// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const nl = {
    login: {
        title: '[[TOK_0]] ComplianceOne',
        subtitle: 'Log in op uw account',
        email: 'E-mail',
        password: 'Wachtwoord',
        sign_in: 'Inloggen',
        signing_in: 'Bezig met inloggen...',
        mfa_code: 'MFA-code',
        mfa_placeholder: 'Voer 6-cijferige code in',
        mfa_instruction: 'Voer de 6-cijferige code in van uw authenticatie-app.',
        verify: 'Verifiëren',
        verifying: 'Bezig met verifiëren...',
        forgot_password: 'Wachtwoord vergeten?',
        account_locked: 'Het account is vergrendeld. Probeer het later opnieuw.',
        account_deactivated: 'Het account is gedeactiveerd. Neem contact op met uw beheerder.',
        invalid_mfa: 'Ongeldige MFA-code. Probeer het opnieuw.',
        invalid_credentials: 'Ongeldig e-mailadres of wachtwoord.',
        login_failed: 'Inloggen mislukt',
        session_expired: 'Uw sessie is verlopen. Herlaad de pagina en probeer het opnieuw.',
    },
    auth: {
        forgot_password: {
            title: 'Wachtwoord vergeten',
            subtitle: 'Voer uw e-mailadres in en wij sturen u een link om uw wachtwoord opnieuw in te stellen.',
            send: 'Herstelkoppeling verzenden',
            sending: 'Verzenden...',
            success: 'Als dat e-mailadres bestaat, is er een link voor het opnieuw instellen van het wachtwoord verzonden.',
            back_to_login: 'Terug naar inloggen',
        },
        reset_password: {
            title: 'Wachtwoord opnieuw instellen',
            subtitle: 'Voer hieronder uw nieuwe wachtwoord in.',
            new_password: 'Nieuw wachtwoord',
            confirm_password: 'Wachtwoord bevestigen',
            reset: 'Wachtwoord opnieuw instellen',
            resetting: 'Opnieuw instellen...',
            success: 'Uw wachtwoord is succesvol opnieuw ingesteld.',
            go_to_login: 'Naar inloggen',
            password_mismatch: 'Wachtwoorden komen niet overeen.',
            invalid_token: 'Ongeldig of ontbrekend hersteltoken. Vraag een nieuwe link voor het opnieuw instellen van het wachtwoord aan.',
            requirements_title: 'Wachtwoordvereisten:',
            password_requirements: 'Het wachtwoord moet aan de volgende vereisten voldoen:',
            rules: {
                min_length: 'Minimaal 12 tekens',
                uppercase: 'Minimaal één hoofdletter',
                lowercase: 'Minimaal één kleine letter',
                digit: 'Minimaal één cijfer',
                special: 'Minimaal één speciaal teken',
            },
        },
        verify_email: {
            title: 'E-mailverificatie',
            verifying: 'Uw e-mailadres wordt geverifieerd...',
            success: 'Uw e-mailadres is succesvol geverifieerd.',
            invalid_token: 'Ongeldig of ontbrekend verificatietoken.',
            failed: 'E-mailverificatie mislukt. Het token is mogelijk ongeldig of verlopen.',
            go_to_login: 'Naar inloggen',
        },
        offline: {
            title: 'U bent offline',
            message: 'Het lijkt erop dat u uw internetverbinding bent verloren. Controleer uw netwerk en probeer het opnieuw.',
        },
    },
    intake: {
        title: 'Verzoek om gegevensrechten',
        subtitle: 'Dien een verzoek om gegevensrechten in bij onze organisatie',
        fields: {
            full_name: 'Volledige naam',
            email: 'E-mailadres',
            phone: 'Telefoonnummer (optioneel)',
            request_type: 'Type verzoek',
            description: 'Beschrijf uw verzoek',
            preferred_language: 'Voorkeurstaal',
            consent: 'Ik geef toestemming voor de verwerking van dit verzoek',
        },
        submit: 'Verzoek indienen',
        validation: {
            name_required: 'Volledige naam is verplicht',
            email_required: 'Een geldig e-mailadres is verplicht',
            type_required: 'Selecteer een type verzoek',
            description_required: 'Beschrijf uw verzoek',
            consent_required: 'U moet toestemming geven voor de verwerking om door te gaan',
        },
        error_title: 'Fout',
        config_load_error: 'Configuratie kon niet worden geladen. Controleer de URL.',
        organization_label: 'Organisatie',
        customer_reference: 'Klantreferentienummer',
        country: 'Land / Rechtsgebied',
        preferred_channel: 'Voorkeurs antwoordkanaal',
        channels: {
            email: 'E-mail',
            postal: 'Post',
            phone: 'Telefoon',
            portal: 'Portaal',
        },
        confirmation: {
            title: 'Verzoek ontvangen',
            message: 'Uw verzoek is succesvol geregistreerd. Uw referentienummer is:',
            next_steps: 'Wij zullen uw verzoek zo spoedig mogelijk verwerken in overeenstemming met de toepasselijke wetgeving. De verwachte verwerkingstijd is 30 werkdagen.',
        },
    },
    request_types: {
        access: 'Inzage (DSAR)',
        deletion: 'Wissing',
        correction: 'Rectificatie / Bijwerking',
        objection: 'Bezwaar',
        portability: 'Gegevensoverdraagbaarheid',
        restriction: 'Beperking van verwerking',
        consent_withdrawal: 'Intrekking van toestemming',
    },
    statuses: {
        new: 'Nieuw',
        in_review: 'In beoordeling',
        waiting_on_requester: 'Wacht op verzoeker',
        waiting_on_internal_data: 'Wacht op interne gegevens',
        approved: 'Goedgekeurd',
        closed: 'Gesloten',
        rejected: 'Afgewezen',
    },
    admin: {
        nav: {
            rights_requests: 'Verzoeken om rechten',
            templates: 'Sjablonen',
            response_templates: 'Antwoordsjablonen',
            data_mapping: 'Gegevensinventarisatie',
            governance: 'Bestuur',
            consent: 'Toestemming',
            assessments: 'Beoordelingen',
            classification: 'Classificatie',
            monitoring: 'Toezicht',
            incidents: 'Incidenten',
            onboarding: 'Aan boord',
            connectors: 'Connectoren',
            vendor_risk: 'Leveranciersrisico',
            deletion_orchestration: 'Verwijderingsorkestratie',
            discovery: 'Gegevensontdekking',
            incident_ops: 'Incidentoperaties',
            program_governance: 'Programmagovernance',
            access_accountability: 'Toegangsverantwoording',
            consent_properties: 'Toestemmingseigenschappen',
            localization: 'Lokalisatie',
            partner_workspace: 'Partnerwerkruimte',
            audit_trail: 'Auditlogboek',
            forseti: 'Forseti',
            settings: 'Instellingen',
            help_center: 'Helpcentrum',
            dashboard: 'Overzicht',
            platform: 'Platformoverzicht',
            integrations: 'Integraties',
            cmp_dsar_sync: 'CMP DSAR-synchronisatie',
            cmp_integration: 'CMP-integratie',
            purpose_mapping: 'Doelkoppeling',
            webhook_config: 'Webhookconfiguratie',
            bulk_sync: 'Bulksynchronisatie',
            privacy_scanner: 'Privacyscanner',
            privacy_monitoring: 'Privacymonitoring',
            real_time_scanner: 'Realtimescanner',
            compliance_forms: 'Nalevingsformulieren',
            forms_dashboard: 'Formulierenoverzicht',
            form_templates: 'Sjablonen',
            form_catalog: 'Formulierencatalogus',
            pack_catalog: 'Pakketcatalogus',
            org_groups: 'Organisatiegroepen',
            consolidation: 'Consolidatie',
            organizations: 'Organisaties',
            org_list: 'Alle Organisaties',
            intake_configs: 'Intake-configuraties',
            task_management: 'Taakbeheer',
            unified_audit: 'Gecombineerde Audit',
            evidence_packs: 'Bewijspakketten',
            audit_periods: 'Auditperioden',
            regulatory_updates: 'Regelgevingsupdates',
            departments: 'Afdelingen',
        },
        sidebar_category_data_privacy_rights: 'Gegevensprivacy & Rechten',
        sidebar_category_vendor_third_party: 'Leveranciers- & Derdenbeheer',
        sidebar_category_risk_assessment: 'Risico & Beoordeling',
        sidebar_category_operations_automation: 'Operaties & Automatisering',
        sidebar_category_task_workflow: 'Taak & Werkstroom',
        sidebar_groups: {
            consent_cmp_webhooks: '[[TOK_0]] en webhooks',
            data_mapping_ropa: 'Verwerkingsregister',
            data_mapping_classification: 'Classificatie',
            data_mapping_governance: 'Bestuur',
            access_live_monitoring: 'Realtime monitoring',
            access_reviews_investigations: 'Reviews & Onderzoeken',
            access_evidence_policies: 'Bewijsstukken & Beleid',
            classification_taxonomies: 'Taxonomieën & Labels',
            classification_workflow: 'Werkstroom',
            classification_insights: 'Inzichten',
            connectors_runtime: 'Looptijd',
            connectors_due_diligence: 'Due diligence',
            connectors_coverage: 'Dekking',
            cp_definitions: 'Definities',
            cp_lifecycle: 'Levenscyclus',
            cp_quality: 'Kwaliteit & Bewijs',
            deletion_execution: 'Uitvoering',
            deletion_vendors: 'Leveranciers',
            deletion_evidence: 'Bewijs & Integratie',
            discovery_rules: 'Regels & Sjablonen',
            discovery_scanning: 'Scannen',
            discovery_review: 'Review-werkstroom',
            discovery_insights: 'Inzichten',
            governance_oversight: 'Toezicht',
            governance_reporting: 'Rapportage',
            governance_vendors: 'Leveranciers & Grensoverschrijdend',
            governance_lifecycle: 'Levenscyclus',
            incident_ops_dashboards: 'Dashboards',
            incident_ops_sla: 'SLA-configuratie',
            incident_ops_playbooks: 'Speelboeken',
            incident_ops_vendor_regulator: 'Leverancier & Toezichthouder',
            incident_ops_evidence: 'Bewijs & Review',
            incidents_workload: 'Werklast',
            incidents_regulatory: 'Regelgeving',
            incidents_reporting: 'Rapportage',
            localization_content: 'Inhoud',
            localization_regulatory: 'Regelgeving',
            localization_observability: 'Waarneembaarheid',
            monitoring_metrics: 'Metrieken',
            monitoring_programs: 'Programma’s',
            monitoring_tasks: 'Taken',
            monitoring_controls: 'Beheersmaatregelen',
            org_entities: 'Entiteiten',
            org_config: 'Configuratie',
            org_frameworks: 'Kaders & Rollup',
            partner_overview: 'Overzicht',
            partner_partners: 'Partners',
            partner_delivery: 'Levering',
            partner_support: 'Ondersteuning',
            platform_identity: 'Identiteit & Rollen',
            platform_access_control: 'Toegangsbeheer',
            platform_auth_session: 'Authenticatie & Sessie',
            platform_access_reviews: 'Toegangsreviews',
            platform_files: 'Bestanden',
            platform_notifications: 'Notificaties',
            platform_module_config: 'Moduleconfiguratie',
            platform_ops: 'Operatie & Logs',
            pg_health: 'Programmastatus',
            pg_maturity: 'Volwassenheid',
            pg_audit: 'Audit & Bewijs',
            pg_obligations: 'Verplichtingen',
            pg_documents: 'Documenten',
            vr_overview: 'Overzicht',
            vr_onboarding: 'Aan boord',
            vr_assessment: 'Beoordeling',
            vr_oversight: 'Toezicht',
        },
        tickets: {
            title: 'Rights Verzoeken',
            create: 'Aanmaken Verzoek',
            filters: 'Filteropties',
            search_placeholder: 'Search tickets...',
            export_csv: 'Exporteer [[TOK_0]]',
            exporting: 'Exporteren...',
            bulk_export_failed: 'Bulkexport mislukt',
            bulk_export: {
                label: 'Exporteren',
                format: {
                    pdf: '[[TOK_0]] Samenvatting',
                    zip: 'ZIP (bewijspakketten per zaak)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Hiermee worden ongeveer [[TOK_1]] casepacks gegenereerd. Dit kan enkele minuten duren. Doorgaan?',
                blocked_over_500: 'Beperk het filter tot 500 of minder cases voordat ZIP wordt geëxporteerd (huidig: [[TOK_1]]).',
                success: 'Bulkexport opgeslagen in de bestandsbrowser ([[TOK_1]] gevallen)',
                failed: 'Bulkexport mislukt',
                continue: 'Ga door',
                cancel: 'Annuleer',
            },
            no_results: 'Geen requests gevonden',
            ticket_id: 'Ticket-ID',
            request_type: 'Verzoek Type',
            requester: 'Aanvrager',
            source: 'Bron',
            all_sources: 'Alle bronnen',
            assigned_to: 'Toegewezen Naar',
            created: 'Aangemaakt',
            load_error: 'Kan niet load cases. Probeer het opnieuw.',
            case_creation_failed: 'Aanmaken zaak mislukt',
            business_unit: 'Bedrijfseenheid',
            reference: 'Referentie',
            sla: {
                title: 'SLA-status',
                on_track: '{days} dagen resterend',
                approaching: 'Deadline nadert',
                overdue: '{days} dagen te laat',
                ack_overdue: '{hours}u voorbij bevestigingsdeadline',
                ack_warning: 'Bevestiging binnenkort vereist',
                closed: 'Gesloten',
                completed_in: 'Afgerond in {days} dagen',
            },
        },
        templates: {
            title: 'Reactie Sjablonen',
            new: 'Nieuw Sjabloon',
            edit: 'Bewerken Sjabloon',
            all_types: 'Alle Types',
            all_locales: 'Alle Locales',
            type_access: 'Toegang/DSAR',
            type_deletion: 'Verwijdering',
            type_correction: 'Correctie',
            type_objection: 'Bezwaar',
            type_portability: 'Overdraagbaarheid',
            type_other: 'Overig',
            type_restriction: 'Beperking',
            type_all: 'All',
            locale_en: 'Engels',
            locale_vi: 'Vietnamees',
            locale_all: 'Beide',
            name: 'Naam',
            request_type: 'Verzoek Type',
            locale: 'Taalinstelling',
            subject: 'Onderwerp',
            body: 'Inhoud',
            name_placeholder: 'Sjabloon naam...',
            subject_placeholder: 'E-mail/brief onderwerp...',
            body_placeholder: 'Sjabloontekst. Gebruik {[TOK_5]]}, {[[TOK_6]]}, {[[TOK_7]]}, {[[TOK_8]]}, {[[TOK_9]]} als tijdelijke aanduidingen.',
            available_placeholders: 'Beschikbaar placeholders:',
            create_template: 'Aanmaken Sjabloon',
            preview: 'Voorbeeld',
            close_preview: 'Sluiten Voorbeeld',
            default_badge: 'Standaard',
            no_templates: 'Geen sjablonen gevonden',
            confirm_delete: 'Verwijderen dit sjabloon?',
            load_error: 'Kan niet load sjablonen. Probeer het opnieuw.',
            create_error: 'Kan niet create sjabloon',
            update_error: 'Kan niet update sjabloon',
            delete_error: 'Kan niet delete sjabloon',
            preview_error: 'Kan niet preview sjabloon',
            response_templates_badge: 'Antwoordsjablonen',
            browse_form_templates: 'Bladeren in Compliance Formuliersjablonen',
            templates_loaded: 'Sjablonen geladen',
            sample_organization: 'Voorbeeldorganisatie',
        },
        detail: {
            requester_info: 'Aanvrager Information',
            status: 'Toestand',
            assignment: 'Toewijzing',
            notes: 'Opmerkingen',
            audit_trail: 'Auditspoor',
            add_note: 'Toevoegen Opmerking',
            case_not_found: 'Case not gevonden',
            load_error: 'Kan niet load case. Probeer het opnieuw.',
            note_error: 'Kan niet add note. Probeer het opnieuw.',
            submitted_from: 'Ingediend vanuit',
            via_cmp: 'via [[TOK_1]] [[TOK_0]]',
            cmp_ticket: 'CMP-ticket:',
            select_template: 'Selecteer een sjabloon',
            direction_inbound: '[[TOK_0]] → GRC',
            direction_outbound: 'GRC → [[TOK_0]]',
            tabs: {
                details: 'Bijzonderheden',
                evidence: 'Bewijs',
                communications: 'Communicaties',
                escalations: 'Escalaties',
                audit_trail: 'Auditspoor',
                fulfillment: 'Uitvoering',
                response: 'Antwoord',
                extension: 'Verlenging',
            },
            requester: {
                name: 'Naam',
                email: 'E-mail',
                phone: 'Telefoon',
                language: 'Taal',
                source: 'Bron',
                customer_ref: 'Klantreferentie',
                country: 'Land',
                preferred_channel: 'Voorkeur Channel',
            },
            sla: {
                title: 'SLA',
                on_track: 'Op schema',
                due_soon: 'Binnenkort verschuldigd',
                overdue: 'Te laat',
                days_remaining: 'd resterend',
                due_date: 'Due Datum',
                breached: 'Geschonden',
                paused: 'Gepauzeerd',
                total_paused_days: 'Totaal Gepauzeerd Dagen',
                days_elapsed: 'Dagen Elapsed',
                progress: 'Voortgang',
            },
            identity: {
                title: 'Identity Verificatie',
                verified: 'Geverifieerd',
                not_verified: 'Niet verified',
                method: 'Methode',
                notes: 'Opmerkingen',
                verified_by: 'Geverifieerd door',
                verified_at: 'Geverifieerd op',
                warning: 'Identiteit nog niet geverifieerd.',
                verify_button: 'Verifiëren Identity',
                select_method: '-- Selecteren --',
                methods: {
                    email_confirmation: 'E-mail Confirmation',
                    id_document: 'Identiteitsdocument',
                    phone_call: 'Telefoon Call',
                    in_person: 'Persoonlijk',
                    other: 'Overig',
                },
            },
            closure: {
                reason: 'Afsluiting Reden',
                summary: 'Afsluiting Samenvatting',
                summary_placeholder: 'Samenvatting van how de request was resolved...',
                reason_required: 'Afsluiting samenvatting en reason are required',
                response_not_sent: 'Er moet een formeel antwoord naar de betrokkene worden gestuurd voordat deze zaak kan worden gesloten',
                reasons: {
                    fulfilled: 'Vervuld',
                    partially_fulfilled: 'Gedeeltelijk vervuld',
                    unfounded: 'Ongegrond',
                    excessive: 'Buitensporig',
                    withdrawn: 'Ingetrokken',
                    duplicate: 'Dupliceren',
                    identity_unverified: 'Identiteit niet geverifieerd',
                },
            },
            export_title: 'Exporteren',
            export_pdf: 'Exporteren PDF',
            export_zip: 'Exporteren ZIP',
            case_file_pdf: 'Exporteer [[TOK_0]] (zaakbestand)',
            evidence_pack_zip: 'ZIP exporteren (bewijspakket)',
            cross_border_warning: 'Grensoverschrijdende overdracht gedetecteerd - grensoverschrijdend dossier vereist',
            breach: {
                flag_btn: 'Markeer als inbreukveroorzakend',
                modal: {
                    title: 'Markeer de zaak als een inbreuk veroorzakend',
                    type_label: 'Type inbreuk',
                    type: {
                        misdirected_response: 'Verkeerd gerichte reactie',
                        unauthorised_disclosure: 'Ongeautoriseerde openbaarmaking',
                        identity_mismatch: 'Identiteitsmismatch',
                        other: 'Anders',
                    },
                    description: 'Beschrijving (optioneel)',
                    description_placeholder: 'Wat is er gebeurd? (max. 1000 tekens)',
                    confirm: 'Markeer en start de 72-uurs indieningsklok',
                    cancel: 'Annuleer',
                    flagging: 'Markeren...',
                },
                banner: {
                    title: 'Schending gemarkeerd: [[TOK_1]]',
                    detected_at: 'Gedetecteerd op [[TOK_1]]',
                    filing_deadline: '72 uur [[TOK_2]] indieningsdeadline: over [[TOK_1]] uur',
                    overdue: '72u [[TOK_0]] indieningsdeadline: TE LAAT',
                },
                toasts: {
                    flagged: 'Zaak gemarkeerd als oorzaak van inbreuk - 72-uursklok gestart',
                    flag_failed: 'Kan de zaak niet markeren als een inbreuk veroorzakend',
                },
            },
            export: {
                generating: 'Bezig met genereren... even geduld a.u.b',
                success: 'Exporteer opgeslagen naar Bestandenbrowser',
                failed: 'Exporteren mislukt - controleer auditlogboek',
            },
            no_notes: 'No opmerkingen yet',
            assign_placeholder: 'Gebruiker ID naar assign...',
            reassign: 'Opnieuw toewijzen',
            evidence: {
                checklist_title: 'Bewijs Checklist',
                complete_pct: '% voltooid',
                no_checklist: 'Geen checklist-items',
                attachments: 'Bijlagen',
                upload_attachment: 'Bijlage uploaden',
                upload_button: 'Uploaden',
                uploading: 'Uploaden...',
                attachment_uploaded: 'Bijlage succesvol geüpload',
                upload_error: 'Upload mislukt',
                category: 'Categorie',
                categories: {
                    identity_proof: 'Identiteitsbewijs',
                    correspondence: 'Correspondentie',
                    internal_data: 'Interne gegevens',
                    legal: 'Juridisch',
                    other: 'Overig',
                },
                no_attachments: 'Geen bijlagen',
                references_title: 'Bewijs References',
                no_references: 'Geen referenties',
                add_reference: 'Toevoegen Referentie',
                ref_type: 'Soort',
                ref_value: 'Waarde',
                ref_desc: 'Beschrijving',
                ref_value_placeholder: 'URL, e-mail ID, of reference...',
                ref_desc_placeholder: 'Beschrijving...',
                ref_types: {
                    url: 'URL',
                    email_id: 'E-mail ID',
                    crm_record: 'CRM-record',
                    ticket_ref: 'Ticket Referentie',
                    other: 'Overig',
                },
            },
            communications: {
                title: 'Communicaties',
                add: 'Toevoegen Message',
                no_records: 'Geen communicatie vastgelegd',
                direction: 'Richting',
                channel: 'Kanaal',
                visibility: 'Zichtbaarheid',
                subject: 'Onderwerp',
                body: 'Inhoud',
                send: 'Verzenden',
                inbound: 'Inkomend',
                outbound: 'Uitgaand',
                internal: 'Intern',
                external: 'Extern',
                tab_all: 'All',
                tab_internal: 'Intern',
                tab_external: 'Extern',
                subject_placeholder: 'Onderwerp (optional)',
                body_placeholder: 'Berichttekst...',
                channels: {
                    email: 'E-mail',
                    portal: 'Portaal',
                    phone: 'Telefoon',
                    postal: 'Post',
                    in_person: 'Persoonlijk',
                },
                apply_template: 'Sjabloon Toepassen',
                select_template: 'Selecteer een sjabloon...',
                no_templates: 'Geen sjablonen beschikbaar',
                template_applied: 'Sjabloon toegepast op antwoord.',
                template_apply_error: 'Kan sjabloon niet toepassen.',
            },
            escalations: {
                title: 'Escalatie Geschiedenis',
                no_events: 'No escalatie gebeurtenissen',
                tier: 'Niveau',
                threshold: 'Drempelwaarde',
                action: 'Actie',
                target: 'Doel',
                triggered_at: 'Geactiveerd At',
            },
            cmp_sync: {
                title: 'AesirX CMP Synchronisatie',
                sync_status: 'Synchronisatie Status',
                last_synced: 'Laatste Synced',
                not_synced: 'Niet Synced',
                resync: 'Nu opnieuw synchroniseren',
                syncing: 'Synchroniseren...',
                sync_history: 'Synchronisatie Geschiedenis (Last 10)',
                direction: 'Richting',
                time: 'Tijd',
                retries: 'Pogingen',
                error_col: 'Fout',
            },
            audit: {
                filter_event_placeholder: 'Filteren op gebeurtenis type...',
                filter_actor_placeholder: 'Filteren op actor...',
            },
            fulfillment: {
                title: 'Afdelingsuitvoering',
                assign_departments: 'Afdelingen toewijzen',
                department: 'Afdeling',
                assignee: 'Toegewezen aan',
                deadline: 'Deadline',
                evidence_count: 'Bewijsmateriaal',
                signoff: 'Aftekening',
                signed_off: 'Afgetekend',
                pending_signoff: 'In afwachting',
                start_button: 'Starten',
                complete_button: 'Markeer als voltooid',
                signoff_button: 'Afmelden',
                no_tasks: 'Nog geen uitvoeringstaken toegewezen.',
                tasks_table: 'Uitvoeringstaken',
                progress_label: 'Uitvoeringsvoortgang',
                overdue: 'te laat',
                assigned_success: 'Afdelingsuitvoeringstaak succesvol toegewezen.',
                assign_error: 'Uitvoeringstaak kon niet worden toegewezen.',
                signoff_success: 'Afdelingsaftekening geregistreerd.',
                signoff_error: 'Aftekening kon niet worden geregistreerd.',
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Bewijs toevoegen',
                evidence_uploaded: 'Bewijs geüpload en gekoppeld',
                evidence_upload_error: 'Upload bewijs mislukt',
                suggest_data_stores: 'Gegevensopslag voorstellen',
                suggest_error: 'Gegevensopslagvoorstellen konden niet worden geladen.',
                suggest_stores_title: 'Voorgestelde gegevensarchieven',
                suggest_stores_none: 'Er zijn geen datastores die overeenkomen met dit geval. Configureer systemen in Data Mapping om suggesties te verbeteren.',
                suggest_stores_add: 'Toevoegen aan casus',
                suggest_stores_added: 'Gegevensopslag toegevoegd aan case',
                no_departments_title: 'Geen afdelingen geconfigureerd',
                no_departments_body: 'Met afdelingen kunt u DSR-uitvoeringstaken routeren naar een functie (Privacy, Legal, HR, IT Ops). Installeer voorbeeldafdelingen of vraag uw beheerder om afdelingen te configureren in de Organisatie-instellingen.',
                no_departments_cta: 'Installeer voorbeeldgegevens',
                department_placeholder: 'Afdelingsnaam...',
                assignee_placeholder: 'Gebruikers-ID om toe te wijzen...',
                assign_button: 'Toewijzen',
                status_pending: 'In behandeling',
                status_in_progress: 'In uitvoering',
                status_completed: 'Voltooid',
                status_verified: 'Geverifieerd',
                confirm_approve: 'Weet u zeker dat u deze verlenging wilt goedkeuren?',
                confirm_deny: 'Weet u zeker dat u deze verlenging wilt weigeren?',
            },
            response: {
                title: 'Antwoordgeneratie',
                select_template: 'Antwoordsjabloon',
                choose_template: 'Selecteer een sjabloon...',
                generate: 'Antwoord genereren',
                preview: 'Antwoordvoorbeeld',
                send: 'Antwoord verzenden',
                delivery_method: {
                    label: 'Bezorgmethode',
                    email: 'E-mail',
                    portal: 'Portaal',
                    postal: 'Postpost',
                    in_person: 'Persoonlijk',
                },
                recipient: {
                    email: 'E-mailadres van ontvanger',
                    portal: 'Portalgebruikers-ID',
                    address: 'Postadres',
                },
                auto_generate_btn: 'Reactie genereren en verzenden',
                auto_generate_success: 'Reactie gegenereerd en afgeleverd',
                auto_generate_missing_recipient: 'Geef een ontvanger op voordat u verzendt.',
                auto_fields: 'Automatisch ingevulde velden',
                case_id: 'Zaak-ID',
                requester_name: 'Naam aanvrager',
                rights_type: 'Rechtstype',
                history: 'Verzonden antwoorden',
                generated_at: 'Gegenereerd',
                confirmation: 'Bevestiging',
                sent_label: 'Verzonden',
                draft_label: 'Concept',
                generated_success: 'Antwoord succesvol gegenereerd.',
                generate_error: 'Antwoord kon niet worden gegenereerd.',
                sent_success: 'Antwoord succesvol verzonden.',
                send_error: 'Antwoord kon niet worden verzonden.',
                load_error: 'Antwoordsjablonen konden niet worden geladen.',
                pdf_title: 'Antwoordbrief aan betrokkene',
                download_pdf: 'PDF downloaden',
                download_all: 'Alles downloaden',
                download_error: 'Antwoord kon niet worden gedownload',
            },
            extension: {
                title: 'Deadlineverlengingen',
                acknowledgment_deadline: 'Bevestigingsdeadline',
                fulfillment_deadline: 'Uitvoeringsdeadline',
                request_extension: 'Verlenging aanvragen',
                reason: 'Reden',
                reason_placeholder: 'Reden voor het aanvragen van extra tijd...',
                additional_days: 'Extra dagen',
                submit_request: 'Verlengingsverzoek indienen',
                history: 'Verlengingsgeschiedenis',
                requested_at: 'Aangevraagd',
                approve: 'Goedkeuren',
                deny: 'Afwijzen',
                request_success: 'Verlengingsverzoek ingediend.',
                request_error: 'Verlengingsverzoek kon niet worden ingediend.',
                approved_success: 'Verlenging goedgekeurd.',
                denied_success: 'Verlenging afgewezen.',
                decision_error: 'Verlengingsbeslissing kon niet worden verwerkt.',
                status_pending: 'In behandeling',
                status_approved: 'Goedgekeurd',
                status_denied: 'Afgewezen',
                confirm_approve: 'Weet u zeker dat u dit verlengingsverzoek wilt goedkeuren?',
                confirm_deny: 'Weet u zeker dat u dit verlengingsverzoek wilt weigeren?',
                decided_by: 'Besloten door',
            },
        },
        audit: {
            export_csv: 'Exporteren CSV',
            exporting: 'Exporteren...',
            search_placeholder: 'Zoeken audit details...',
            filter_by_actor: 'Filteren op actor...',
            all_event_types: 'Alle Gebeurtenis Types',
            seq: '#',
            timestamp: 'Tijdstempel',
            event: 'Gebeurtenis',
            case_col: 'Zaak',
            actor: 'Betrokkene',
            summary: 'Samenvatting',
            no_events: 'Geen audit gebeurtenissen gevonden',
            export_success: 'Audittrail succesvol geëxporteerd.',
            export_error: 'Kan niet export audit CSV',
            load_error: 'Kan niet load audit trail. Probeer het opnieuw.',
            announce_loaded: 'Auditspoor geladen',
            start_date: 'Startdatum',
            end_date: 'Einddatum',
            per_page: '{count} / pagina',
            unknown: 'Onbekend',
            source_filter: {
                label: 'Bron',
                all: 'Allemaal',
                module: 'Module',
                forseti: 'Forseti',
                aria_label: 'Filter auditgebeurtenissen op bron',
            },
            event_types: {
                case_created: 'Case Aangemaakt',
                status_changed: 'Status Gewijzigd',
                case_assigned: 'Case Toegewezen',
                note_added: 'Opmerking Added',
                attachment_added: 'Bijlage Added',
                attachment_deleted: 'Bijlage Verwijderd',
                reference_added: 'Referentie Added',
                checklist_updated: 'Checklist Bijgewerkt',
                identity_verified: 'Identiteit geverifieerd',
                closure_summary_added: 'Afsluiting Samenvatting',
                approval_granted: 'Goedkeuring Granted',
                template_applied: 'Sjabloon Applied',
                export_generated: 'Exporteren Gegenereerd',
                sla_warning: 'SLA Waarschuwing',
                sla_overdue: 'SLA Te laat',
            },
            unified_audit: {
                title: 'Gecombineerd Auditspoor',
                module_filter: 'Module',
                framework_filter: 'Raamwerk',
                select_framework: 'Selecteer een raamwerk...',
                entity_type_filter: 'Entiteitstype',
                action_filter: 'Actie',
                actor_filter: 'Uitvoerder',
                select_actor: 'Selecteer een uitvoerder...',
                search_filter: 'Zoeken',
                search_placeholder: 'Zoek in auditgebeurtenissen...',
                filters_heading: 'Filters',
                date_range: 'Datumbereik',
                no_events_found: 'Geen auditgebeurtenissen gevonden.',
                event_count: 'Aantal gebeurtenissen',
                action: 'Actie',
                actor: 'Uitvoerder',
                date_range_start: 'Begindatum bereik',
                date_range_end: 'Einddatum bereik',
                filtering_events: 'Auditgebeurtenissen filteren',
                framework_codes: 'Raamwerkcodes',
                entity_type_col: 'Entiteitstype',
                aria_table: 'Gecombineerde auditgebeurtenissen',
                page_of: 'Pagina {page} van {total}',
                entity_types: {
                    user: 'Gebruiker',
                    case: 'Geval',
                    incident: 'Voorval',
                    assessment: 'Beoordeling',
                    vendor: 'Verkoper',
                    consent: 'Toestemming',
                    policy: 'Beleid',
                    data_map: 'Gegevenskaart',
                },
                actions: {
                    create: 'Creëer',
                    update: 'Bijwerken',
                    delete: 'Verwijderen',
                    view: 'Bekijk',
                    export: 'Exporteren',
                    status_change: 'Statuswijziging',
                },
            },
            evidence_packs: {
                title: 'Audit Bewijspakketten',
                assemble_pack: 'Bewijspakket samenstellen',
                framework: 'Raamwerk',
                select_framework: 'Selecteer een raamwerk...',
                framework_code_label: 'Raamwerkcode',
                entity_types: 'Entiteitstypen',
                select_entity_types: 'Selecteer entiteitstypen...',
                period: 'Periode',
                period_start: 'Begin periode',
                period_end: 'Einde periode',
                completeness: 'Volledigheid',
                no_packs_found: 'Geen bewijspakketten gevonden.',
                verify: 'Verifiëren',
                export_pack: 'Exporteren',
                exporting: 'Exporteren...',
                pack_assembled: 'Bewijspakket samengesteld',
                pack_exported: 'Bewijspakket geëxporteerd',
                aria_table: 'Audit-bewijspakketten',
                aria_export_pack: 'Pakket exporteren',
                export_format: 'Exportformaat',
                export_in_progress: 'Export bezig...',
                status_draft: 'Concept',
                status_assembled: 'Samengesteld',
                status_verified: 'Geverifieerd',
                status_submitted: 'Ingediend',
                entity_type_labels: {
                    user: 'Gebruiker',
                    case: 'Geval',
                    incident: 'Voorval',
                    assessment: 'Beoordeling',
                    vendor: 'Verkoper',
                    consent: 'Toestemming',
                    policy: 'Beleid',
                    data_map: 'Gegevenskaart',
                },
                template_id: 'Sjabloon-ID',
                csv_headers: {
                    module: 'Module',
                    action: 'Actie',
                    actor_id: 'Acteur',
                    entity_type: 'Entiteitstype',
                    entity_id: 'Entiteits-ID',
                    summary: 'Samenvatting',
                    timestamp: 'Tijdstempel',
                    framework_code: 'Kader',
                },
                export_header_framework: 'Bewijspakket — Raamwerk: {framework}',
                export_header_period: 'Periode: {start} tot {end}',
                export_header_completeness: 'Volledigheid: {score}%',
                export_header_status: 'Status: [[TOK_1]]',
            },
            audit_periods: {
                title: 'Auditperioden',
                create_period: 'Auditperiode aanmaken',
                framework_code_label: 'Raamwerkcode',
                select_framework: 'Selecteer een raamwerk...',
                period_label: 'Periodelabel',
                period_start: 'Begin periode',
                period_end: 'Einde periode',
                start: 'Begin',
                end: 'Einde',
                framework: 'Raamwerk',
                retention_days: 'Bewaardagen',
                no_periods_found: 'Geen auditperioden gevonden.',
                period_created: 'Auditperiode aangemaakt',
                aria_table: 'Auditperiodes',
                suggested_boundaries: 'Voorgestelde grenzen',
                suggested_boundaries_info: 'Voorgestelde periodegrenzen zijn afgeleid van de regelgevende rapportagecyclus van elk raamwerk. Pas aan waar nodig voor uw organisatie.',
                reporting_cycle: 'Rapportagecyclus',
                suggested_start: 'Voorgesteld begin',
                suggested_end: 'Voorgesteld einde',
                suggested_next: 'Voorgestelde volgende periode',
                cycle_monthly: 'Maandelijks',
                cycle_quarterly: 'Driemaandelijks',
                cycle_semi_annual: 'Halfjaarlijks',
                cycle_annual: 'Jaarlijks',
                cycle_custom: 'Aangepast',
                period_deleted: 'Auditperiode verwijderd',
            },
        },
        create_case: {
            customer_ref: 'Customer Referentie',
            country: 'Land / Jurisdictie',
            preferred_channel: 'Voorkeur Channel',
            channels: {
                email: 'E-mail',
                postal: 'Post',
                phone: 'Telefoon',
                portal: 'Portaal',
            },
            source: 'Bron',
            sources: {
                admin_manual: 'Beheerdershandleiding',
                public_form: 'Publieke vorm',
                cmp_gateway: '[[TOK_0]] Gateway',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Telefoon ontvangen',
                postal_received: 'Post ontvangen',
                email_received: 'E-mail ontvangen',
                in_person: 'Persoonlijk',
                legacy_import: 'Verouderde import',
            },
            required_fields: 'Verzoek type, naam, en e-mail are required',
            create_error: 'Kan niet create case',
        },
        settings: {
            title: 'Instellingen',
            request_types: 'Typen verzoeken',
            request_types_desc: 'Configureer welke typen verzoeken zijn ingeschakeld voor het openbare intakeformulier.',
            notifications: 'Meldingen',
            ticket_numbering: 'Ticketnummering',
            ticket_format: 'Huidig formaat',
            ticket_prefix: 'Voorvoegsel',
            ticket_prefix_note: 'niet configureerbaar in Sprint 1.0.0',
            sla_deadlines: 'SLA-termijnen',
            sla_desc: 'Stel de maximale reactietijd (in kalenderdagen) in voor elk type verzoek. Zaken die de drempel naderen, tonen waarschuwingen.',
            days: 'dagen',
            warning_threshold: 'Waarschuwingsdrempel',
            escalation_label: 'Automatische escalatie bij SLA-overschrijding inschakelen',
            save_sla: 'SLA-configuratie opslaan',
            saving: 'Opslaan...',
            saved: 'Succesvol opgeslagen',
            announce_loaded: 'Instellingen geladen',
            email_on_creation: 'E-mailmelding bij aanmaken ticket',
            send_confirmation: 'Bevestigingsmail naar verzoeker sturen',
            users: 'Gebruikers',
            roles: 'Rollen',
            api_keys: '[[TOK_0]] Toetsen',
            mfa: 'MFA',
            sessions: 'Sessies',
            webhooks: 'Webhaken',
            modules: 'Modules',
            deadline_labels: {
                access: 'Inzage (DSAR)',
                deletion: 'Wissing',
                correction: 'Rectificatie',
                portability: 'Overdraagbaarheid',
                objection: 'Bezwaar',
                restriction: 'Beperking',
                consent_withdrawal: 'Intrekking van toestemming',
            },
        },
        section_assignments: {
            title: 'Sectietoewijzingen',
            assign_section: 'Sectie toewijzen',
            section_ref: 'Sectiereferentie',
            section_label: 'Sectielabel',
            department_id: 'Afdeling',
            assignee_id: 'Toegewezene',
            mandatory: 'Verplicht',
            assign: 'Toewijzen',
            no_assignments: 'Geen sectietoewijzingen',
            status: 'Status',
            completion: 'Voltooiing',
            mark_complete: 'Voltooien',
        },
        consolidation: {
            title: 'Consolidatievoortgang',
            add_child: 'Subtaak toevoegen',
            child_task_id: 'Subtaak-id',
            department_id: 'Afdeling',
            link: 'Koppeling',
            overall_completion: 'Totale voltooiing',
            departments_complete: 'Afdelingen voltooid',
            overdue: 'Achterstallig',
            ready: 'Gereed',
            not_ready: 'Niet gereed',
            master_status: 'Algehele status',
            department_breakdown: 'Afdelingsoverzicht',
            department: 'Afdeling',
            status: 'Status',
            completion: 'Voltooiing',
            due_date: 'Vervaldatum',
            overdue_flag: 'Achterstallig',
            child_tasks: 'Subtaken',
            task: 'Taak',
        },
        conflict_detection: {
            title: 'Conflictdetectie',
            unresolved: 'onopgelost',
            no_conflicts: 'Geen conflicten gedetecteerd',
            section: 'Sectie',
            field: 'Veld',
            dept_a: 'Afdeling A',
            value_a: 'Waarde A',
            dept_b: 'Afdeling B',
            value_b: 'Waarde B',
            severity: 'Ernst',
            status: 'Status',
            resolved: 'Opgelost',
            open: 'Openen',
            resolve: 'Oplossen',
        },
        org_maturity: {
            title: 'Organisatorische Volwassenheid',
            departments: 'Afdelingen',
            department_hierarchy: 'Afdelingshiërarchie',
            create_department: 'Afdeling Aanmaken',
            department_name: 'Afdelingsnaam',
            department_code: 'Codeer',
            level: 'Niveau',
            division: 'Divisie',
            department: 'Afdeling',
            team: 'Team',
            parent_department: 'Bovenliggende Afdeling',
            head_user: 'Afdelingshoofd',
            no_departments: 'Geen afdelingen geconfigureerd.',
            user_mappings: 'Gebruikerstoewijzingen',
            map_user: 'Gebruiker Toewijzen',
            user_id: 'Gebruikers-ID',
            role: 'Rol',
            no_users: 'Geen gebruikers toegewezen aan deze afdeling.',
            remove: 'Verwijderen',
            framework_assignments: 'Raamwerktoewijzingen',
            assign_framework: 'Raamwerk Toewijzen',
            entity_id: 'Entiteits-ID',
            entity_type: 'Entiteitstype',
            framework_id: 'Raamwerk-ID',
            framework_code: 'Raamwerkcode',
            no_assignments: 'Geen raamwerktoewijzingen.',
            compliance_rollup: 'Nalevingsoverzicht',
            entity_name: 'Entiteit',
            total_assessments: 'Totaal Beoordelingen',
            completed: 'Voltooid',
            completion_pct: 'Voltooiing %',
            open_gaps: 'Open Tekorten',
            critical_gaps: 'Kritiek',
            compliance_score: 'Scoren',
            no_rollup: 'Geen nalevingsoverzichtgegevens beschikbaar.',
            entity_summary: 'Nalevingsoverzicht Entiteit',
            frameworks_assigned: 'Raamwerken',
            overall_score: 'Totaalscore',
            load_departments_error: 'Laden van afdelingen mislukt',
            load_users_error: 'Laden van gebruikers mislukt',
            department_created: 'Afdeling aangemaakt',
            department_created_announce: 'Afdeling aangemaakt',
            create_department_error: 'Aanmaken van afdeling mislukt',
            user_mapped: 'Gebruiker toegewezen',
            user_mapped_announce: 'Gebruiker toegewezen aan afdeling',
            map_user_error: 'Toewijzen van gebruiker mislukt',
            user_removed: 'Gebruiker verwijderd',
            load_rollup_error: 'Laden van samenvatting mislukt',
            load_assignments_error: 'Laden van toewijzingen mislukt',
            framework_assigned: 'Raamwerk toegewezen',
            framework_assigned_announce: 'Raamwerk toegewezen aan entiteit',
            assign_framework_error: 'Toewijzen van raamwerk mislukt',
            assignment_removed: 'Toewijzing verwijderd',
            enter_entity_id_placeholder: 'Voer entiteit-ID in om toewijzingen te zien',
            entity_type_organization: 'Organisatie',
            entity_type_department: 'Afdeling',
        },
        onboarding_maturity: {
            title: 'Onboarding-volwassenheid',
            quick_starts: 'Snelle start',
            progress: 'Vooruitgang bij onboarding',
            personas: 'Persona-paden',
            persona_onboarding: 'Persona-onboarding',
            quick_start_scenarios: "Snelstartscenario's",
            start: 'Starten',
            restart: 'Opnieuw opstarten',
            estimated_minutes: 'Geschatte minuten',
            steps: 'Stappen',
            scenario: 'Scenario',
            no_scenarios: "Er zijn geen snelstartscenario's beschikbaar.",
            persona_id: 'Persona-ID',
            persona_label: 'Persoon',
            role_description: 'Rolbeschrijving',
            primary_modules: 'Primaire modules',
            recommended_tours: 'Aanbevolen rondleidingen',
            sample_data_modules: 'Voorbeeldgegevensmodules',
            quick_start_scenario: 'Snelstartscenario',
            no_personas: 'Er zijn geen personapaden beschikbaar.',
            framework_setup: 'Regelgevingskaders',
            framework_code: 'Kadercode',
            framework_name: 'Kadernaam',
            related_modules: 'Gerelateerde modules',
            persona_relevance: "Relevante Persona's",
            no_frameworks: 'Er zijn geen opties voor het instellen van het raamwerk beschikbaar.',
            tier_config: 'Configuratie van niveaumodule',
            tier: 'Niveau',
            available_modules: 'Beschikbare modules',
            module_count: 'Moduletelling',
            overall_completion: 'Algemene voltooiing',
            wizard_completed: 'Wizard voltooid',
            tours_completed: 'Rondleidingen voltooid',
            quick_starts_completed: 'Snelle start voltooid',
            selected_frameworks: 'Geselecteerde raamwerken',
            no_progress: 'Er zijn geen voortgangsgegevens over onboarding beschikbaar.',
            detected_persona: 'Gedetecteerde persoon',
            current_tier: 'Huidig niveau',
            completion_pct: 'Voltooiing',
            progress_page: {
                loaded: 'Voortgang geladen',
                no_progress: 'Geen onboarding-voortgangsgegevens beschikbaar.',
                overall: 'Algehele voortgang',
                detected_persona: 'Gedetecteerde persona',
                tier: 'Niveau',
                modules: 'modules',
                wizard: 'Tovenaar',
                completed: 'Voltooid',
                pending: 'In afwachting',
                tours: 'Rondleidingen',
                quick_starts: 'Snelstarts',
                frameworks: 'Geselecteerde raamwerken',
                no_frameworks: 'Geen raamwerken geselecteerd.',
                go_to_wizard: 'Installatiewizard voltooien',
                framework_selection: 'Raamwerkselectie',
                framework_toggle: 'Raamwerken in- of uitschakelen voor uw complianceprogramma.',
                framework_updated: 'Raamwerkselectie bijgewerkt.',
                view_tours: 'Rondleidingen bekijken',
                view_quick_starts: 'Snelstarts bekijken',
            },
            persona_page: {
                description: "Selecteer een persona om aanbevolen modules, rondleidingen en snelstartscenario's te bekijken.",
                no_personas: 'Geen personapaden beschikbaar.',
                modules: 'Modules',
                tours: 'Rondleidingen',
                quick_start: 'Snelstart',
                details: 'Details',
                primary_modules: 'Primaire modules',
                recommended_tours: 'Aanbevolen rondleidingen',
                framework_options: 'Regelgevingskaders',
                no_frameworks: 'Geen raamwerk-instellingsopties beschikbaar.',
                framework_code: 'Raamwerkcode',
                framework_label: 'Etiket',
                region: 'Regio',
                category: 'Categorie',
                enabled: 'Ingeschakeld',
                disabled: 'Uitgeschakeld',
                tier_modules: 'Niveaumoduleconfiguratie',
                tiers_loaded: 'Niveauconfiguraties geladen',
                no_tier_config: 'Geen niveauconfiguratie beschikbaar.',
                view_tours: 'Modulerondleidingen bekijken',
                view_quick_start: 'Snelstart starten',
                toggle_framework: 'Raamwerk schakelen',
                framework_updated: 'Raamwerkselectie bijgewerkt.',
                tier_desc_light: 'Basis privacyfuncties — PDPL-compliancegrondslag',
                tier_desc_standard: 'Volledige compliancesuite — alle modules met werkstromen',
                tier_desc_enterprise: 'Geavanceerd bestuur en automatisering — multi-entiteit, groepsrapportage',
                persona_highlight: 'Uw modules',
                aria_go_to_module: '[[TOK_1]] — ga naar module',
                aria_start_tour: 'Begin [[TOK_1]]',
                aria_quick_start: 'Snelle start: [[TOK_1]]',
                aria_help_article: 'Help-artikel: [[TOK_1]]',
                aria_view_framework: '[[TOK_2]][[TOK_3]] — raamwerkdetails bekijken',
                aria_primary_for_persona: '[[TOK_1]] (primair voor deze persona)',
                primary_for_persona_suffix: ' (primair voor deze persona)',
                aria_view_in_persona_paths: '[[TOK_1]] — bekijken in Persona-paden',
                progress_of_total: '[[TOK_2]] van [[TOK_3]] voltooid',
            },
            quick_starts_page: {
                description: "Oefen veelvoorkomende werkstromen met begeleide snelstartscenario's.",
                no_scenarios: "Geen snelstartscenario's beschikbaar.",
                started: 'Snelstart gestart',
                status_completed: 'Voltooid',
                status_in_progress: 'Bezig',
                status_not_started: 'Niet gestart',
                minutes: 'min',
                steps: 'stappen',
                step: 'Stap',
                restart: 'Herstarten',
                start: 'Starten',
                go_to_module: 'Ga naar module',
                next_step: 'Volgende stap',
                complete: 'Voltooien',
                reset: 'Herstellen',
                step_of: 'van',
                action_navigate: 'Navigeren',
                action_form_fill: 'Formulier invullen',
                action_review: 'Controleren',
                action_confirm: 'Bevestigen',
                step_changed: 'Stap {current} van {total}: {title}',
                completed_message: 'Snelstart succesvol voltooid!',
                reset_message: 'De snelstart is hersteld.',
            },
            persona_p_vn_01_label: 'Onderneming DPO',
            persona_p_vn_01_description: "Data Protection Officer die bedrijfsbrede complianceprogramma's beheert",
            persona_p_vn_02_label: 'Afdelingseigenaar',
            persona_p_vn_02_description: 'Afdelingshoofd verantwoordelijk voor sectierapportage over naleving',
            persona_p_vn_03_label: 'Naleving van e-commerce',
            persona_p_vn_03_description: 'Compliance officer gericht op gegevensbescherming en toestemming voor e-commerce',
            persona_p_vn_04_label: 'Telecom [[TOK_0]]',
            persona_p_vn_04_description: 'Telecomsector DPO beheert abonneegegevens en incidentrapportage',
            persona_p_vn_05_label: 'Leider databeheer',
            persona_p_vn_05_description: 'Verantwoordelijk voor het in kaart brengen, classificeren en beheren van data',
            persona_p_vn_06_label: 'Cyberbeveiliging en juridische activiteiten',
            persona_p_vn_06_description: 'Cybersecurity-functionaris die de incidentrespons en het leveranciersrisico beheert',
            persona_p_vn_07_label: 'AI Bestuursleider',
            persona_p_vn_07_description: 'Leidt toezicht op AI systeembeheer, risicobeoordelingen en classificatie',
            persona_p_vn_08_label: 'Grensoverschrijdende en leveranciersoverheid',
            persona_p_vn_08_description: 'Functionaris die grensoverschrijdende overdrachten en leveranciersbeheer beheert',
            persona_p_vn_09_label: 'Leider voor inbreukreactie',
            persona_p_vn_09_description: 'Leider die de melding van inbreuken en de respons op incidenten coördineert',
            persona_p_vn_10_label: 'Leider Interne Audit',
            persona_p_vn_10_description: 'Hoofdverantwoordelijk voor compliance-audits en programma-governance-evaluatie',
            persona_p_vn_11_label: 'HR- & werknemersgegevens-verantwoordelijke',
            persona_p_vn_11_description: 'HR-manager die toestemmingsregistraties van werknemers en interne DSARs beheert',
            persona_p_vn_12_label: 'Compliance-leider multinationale dochteronderneming',
            persona_p_vn_12_description: 'FG in Vietnamese dochteronderneming van buitenlands bedrijf die lokale compliance-laag nodig heeft',
            persona_p_vn_13_label: 'Compliance-leider onderwijs',
            persona_p_vn_13_description: 'Compliance-leider op buitenlandse school die gegevensbescherming van leerlingen en ouders beheert',
            qs_hr_consent_title: 'Werknemerstoestemmingen registreren',
            qs_hr_consent_description: 'Doorloop van het registreren van werknemerstoestemming en het genereren van een dekkingsrapport.',
            qs_subsidiary_dpia_title: 'DPIA-beoordeling voor dochteronderneming aanmaken',
            qs_subsidiary_dpia_description: 'Doorloop van het aanmaken van een DPIA voor een verwerkingsactiviteit van een dochteronderneming.',
            qs_student_consent_title: 'Verzameling leerlingentoestemming instellen',
            qs_student_consent_description: 'Doorloop van het aanmaken van ouderlijk toestemmingsbeleid voor leerlinggegevens.',
            persona_p_vn_14_label: 'Extern juridisch adviseur',
            persona_p_vn_14_description: 'Senior advocatenkantoorpartner die meerdere klantorganisaties adviseert over PDPL-compliance',
            persona_p_vn_15_label: 'Operationeel manager advocatenkantoor',
            persona_p_vn_15_description: 'Coördinator klantbetrokkenheid die de tracking van deliverables en de coördinatie van deadlines beheert',
            persona_p_vn_16_label: 'Bedrijfseigenaar / CEO',
            persona_p_vn_16_description: 'CEO of GM, die juridisch gezien de gegevensbeheerder is onder PDPL, verantwoordelijk voor investeringen in compliance',
            qs_dpia_filing_title: 'Voltooi uw eerste DPIA-aanvraag',
            qs_dept_compliance_title: 'Dien de nalevingssectie van uw eerste afdeling in',
            qs_ecommerce_consent_title: 'Configureer het verzamelen van toestemming voor e-commerce',
            qs_telecom_data_title: 'Gegevensverwerking van telecomabonnees instellen',
            qs_data_flow_title: 'Breng uw eerste gegevensstroom in kaart',
            qs_incident_response_title: 'Configureer de workflow voor incidentrespons',
            qs_ai_risk_title: 'Voer een AI systeemrisicobeoordeling uit',
            qs_cross_border_title: 'Beoordeel een grensoverschrijdende gegevensoverdracht',
            qs_breach_notification_title: 'Simuleer een workflow voor inbreukmeldingen',
            qs_audit_trail_title: 'Beoordeel een compliance-audittraject',
            qs_legal_advisor_portfolio_title: 'Beoordeel de complianceportfolio voor meerdere klanten',
            qs_legal_advisor_portfolio_description: 'Controleer de nalevingsstatus van meerdere klantorganisaties.',
            qs_law_firm_ops_title: 'Volg de status van de leverbare klant',
            qs_law_firm_ops_description: 'Bewaken van de voortgang van het advies en de betrokkenheid van klanten.',
            qs_ceo_dashboard_title: 'Bekijk het compliance-dashboard van het management',
            qs_ceo_dashboard_description: 'Beoordeel de nalevingsstatus en investeringsstatistieken op hoog niveau.',
        },
        rights_requests: {
            response_templates: {
                title: 'Antwoordsjablonen',
                subtitle: 'Beheer de DSR-antwoordbriefsjablonen die ResponseGenerator gebruikt om antwoorden aan betrokkenen op te stellen.',
                create_btn: 'Nieuwe sjabloon',
                edit_btn: 'Sjabloon bewerken',
                filter_right_type: 'Filter op het juiste type',
                filter_locale: 'Filter op landinstelling',
                filter_status: 'Filter op Status',
                all_right_types: 'Alle juiste typen',
                any_right_type: 'Alle (geldt voor alle typen)',
                all_locales: 'Alle landinstellingen',
                all_statuses: 'Allemaal',
                status_active: 'Actief',
                status_inactive: 'Inactief',
                empty_state: 'Er zijn geen sjablonen die overeenkomen met de huidige filters.',
                columns: {
                    template_id: 'Sjabloon-ID',
                    outcome: 'Resultaat',
                    locale: 'Lokaal',
                    right_type: 'Juiste soort',
                    is_active: 'Status',
                    last_updated: 'Laatst bijgewerkt',
                    actions: 'Acties',
                },
                actions: {
                    edit: 'Bewerken',
                    clone: 'Kloon',
                    deactivate: 'Deactiveren',
                    reactivate: 'Opnieuw activeren',
                    preview: 'Voorbeeld',
                },
                form: {
                    template_id: 'Sjabloon-ID',
                    template_id_help: 'Identificatie in kleine letters, bijv. dsr_access_fulfilled_vi',
                    outcome: 'Resultaat',
                    locale: 'Lokaal',
                    right_type: 'Juiste soort',
                    subject: 'Onderwerp',
                    body: 'Lichaamssjabloon',
                    body_help: 'Gebruik tijdelijke aanduidingen zoals [[TOK_3]], [[TOK_4]], [[TOK_5]]. Minimaal 15 regels voor brieven met meerdere secties.',
                    is_active: 'Actief',
                    official_form_id: 'Officieel formulier-ID (optioneel)',
                },
                outcomes: {
                    fulfilled: 'Vervuld',
                    partially_fulfilled: 'Gedeeltelijk vervuld',
                    denied: 'Geweigerd',
                },
                clone_modal_title: 'Kloon sjabloon',
                clone_target_locale: 'Doelland',
                clone_help: 'Er wordt een nieuwe sjabloon gemaakt in de doellandinstelling, waarbij deze sjabloon als uitgangspunt wordt gebruikt.',
                preview_modal_title: 'Sjabloonvoorbeeld',
                preview_note: 'Voorvertoning gebruikt tijdelijke aanduidingen voor democase DSR-DEMO-0020. Echte bezorging vervangt live casusgegevens.',
                preview_unavailable: 'Voorvoorbeeld is een bestaande case vereist. Voeg deze sjabloon toe aan een case en gebruik de actie Conceptreactie op de casedetailpagina.',
                deactivate_confirm: 'Dit sjabloon deactiveren? Het zal van toepassing blijven op bestaande gevallen waarin ernaar wordt verwezen.',
                toasts: {
                    created: 'Sjabloon gemaakt',
                    updated: 'Sjabloon bijgewerkt',
                    deactivated: 'Sjabloon gedeactiveerd',
                    reactivated: 'Sjabloon opnieuw geactiveerd',
                    cloned: 'Sjabloon gekloond',
                    load_error: 'Kan sjablonen niet laden',
                    save_error: 'Kan sjabloon niet opslaan',
                    clone_error: 'Kan de sjabloon niet klonen',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Afdelingen',
                subtitle: 'Beheer de afdelingen die DSR-zaken, [[TOK_0]]-taken en compliance-workflows doorsturen.',
                create_btn: 'Nieuwe afdeling',
                edit_btn: 'Afdeling bewerken',
                columns: {
                    name: 'Naam',
                    description: 'Beschrijving',
                    active_cases: 'Actieve gevallen',
                    members: 'Leden',
                    status: 'Status',
                    actions: 'Acties',
                },
                status_active: 'Actief',
                status_inactive: 'Inactief',
                form: {
                    name: 'Naam',
                    description: 'Beschrijving',
                },
                actions: {
                    edit: 'Bewerken',
                    deactivate: 'Deactiveren',
                    reactivate: 'Opnieuw activeren',
                    delete: 'Verwijderen',
                    manage_members: 'Leden beheren',
                },
                delete_modal_title: 'Afdeling verwijderen',
                delete_warning: 'Deze afdeling heeft nog actieve zaken. Kies een afdeling waaraan u ze opnieuw wilt toewijzen voordat u ze verwijdert.',
                delete_no_cases: 'Deze afdeling heeft geen actieve cases en kan veilig worden verwijderd.',
                reassign_prompt: 'Wijs actieve cases opnieuw toe aan:',
                reassign_none_available: 'Geen andere actieve afdelingen beschikbaar. Maak eerst een andere afdeling aan.',
                member_section_title: 'Leden',
                add_member: 'Lid toevoegen',
                remove_member: 'Verwijderen',
                member_role: 'Rol',
                no_members: 'Er zijn geen leden toegewezen aan deze afdeling.',
                toasts: {
                    created: 'Afdeling aangemaakt',
                    updated: 'Afdeling bijgewerkt',
                    deactivated: 'Afdeling gedeactiveerd',
                    reactivated: 'Afdeling opnieuw geactiveerd',
                    deleted: 'Afdeling verwijderd',
                    reassigned_count: '[[TOK_1]] zaak(en) opnieuw toegewezen',
                    member_added: 'Lid toegevoegd',
                    member_removed: 'Lid verwijderd',
                    load_error: 'Kan afdelingen niet laden',
                    save_error: 'Kan afdeling niet opslaan',
                    delete_error: 'Kan afdeling niet verwijderen',
                },
            },
            retention_policies: {
                title: 'Bewaarbeleid',
                subtitle: 'Configureer bewaarperioden per doeltype. Identiteitsverificatiedocumenten gebruiken dit om retention_expires_at op toekomstige uploads te stempelen.',
                create_btn: 'Nieuw beleid',
                edit_btn: 'Beleid bewerken',
                columns: {
                    target_type: 'Doeltype',
                    retention_days: 'Retentie (dagen)',
                    owner: 'Beleidseigenaar',
                    effective_from: 'Effectief vanaf',
                    last_reviewed: 'Laatst beoordeeld',
                    status: 'Status',
                    actions: 'Acties',
                },
                status_active: 'Actief',
                status_inactive: 'Inactief',
                form: {
                    target_type: 'Doeltype',
                    target_type_help: 'Op welke gegevenscategorie de bewaarperiode van toepassing is. Momenteel worden alleen DSR-identiteitsverificatiedocumenten ondersteund.',
                    retention_days: 'Bewaarperiode (dagen)',
                    retention_days_help: 'Tussen 1 en 3650 dagen (maximaal 10 jaar).',
                    owner: 'Beleidseigenaar',
                    owner_help: 'Meestal de [[TOK_0]]. Verantwoordelijk voor het bewaarbesluit onder DG-2.',
                    effective_from: 'Effectief vanaf',
                },
                target_types: {
                    dsr_identity_verification_document: 'DSR-identiteitsverificatiedocumenten',
                },
                deactivate_notice: 'Deactiveren heeft geen invloed op reeds gestempelde bijlagen; alleen toekomstige uploads krijgen geen bewaartermijn meer.',
                deactivate_confirm: 'Dit bewaarbeleid deactiveren?',
                toasts: {
                    created: 'Bewaarbeleid gemaakt',
                    updated: 'Bewaarbeleid bijgewerkt',
                    deactivated: 'Bewaarbeleid gedeactiveerd',
                    load_error: 'Kan bewaarbeleid niet laden',
                    save_error: 'Kan het bewaarbeleid niet opslaan',
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'Systemen',
            categories: 'Gegevenscategorieën',
            registry: 'Gegevensregister',
            purposes: 'Verwerkingsdoeleinden',
            retention: 'Bewaring',
            flows: 'Gegevensstromen',
            activities: 'Verwerkingsactiviteiten',
            evidence: 'Bewijs',
            exports: 'Exporten',
            attestation: 'Attestcycli',
            governance: 'Bestuur',
            review: 'Beoordelingstaken',
            inventory: 'Inventaris',
            exceptions: 'Uitzonderingen',
            history: 'Geschiedenis',
            ropa_completeness: 'ROPA-volledigheid',
        },
        ropa_completeness_autofix: {
            ask_button: 'Vraag Forseti',
            drafting: 'Opstellen…',
            accept: 'Accepteer',
            reject: 'Afwijzen',
            accepted: 'Geaccepteerd — solliciteer via de activiteiteneditor.',
            rejected: 'Afgewezen.',
            needs_human_input: 'Forseti heeft meer activiteitscontext nodig (bijvoorbeeld een gedocumenteerd doel) voordat dit veld wordt opgesteld.',
        },
        ropa_completeness: {
            title: 'ROPA-volledigheidsrapport',
            subtitle: 'Hygiëne-audit per veld van uw gegevens over verwerkingsactiviteiten, afgestemd op het regelgevingskader.',
            framework_label: 'Kader',
            kpi_total: 'Activiteiten gescoord',
            kpi_critical: 'Kritisch',
            kpi_high: 'Hoog',
            kpi_conditional: 'Voorwaardelijk',
            field_chart_heading: 'Ontbrekende velden op frequentie',
            drilldown_heading: 'Activiteiten met gaten',
            col_activity: 'Activiteit',
            col_field: 'Veld',
            col_severity: 'Ernst',
            col_condition: 'Conditie',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Kritisch',
            severity_high: 'Hoog',
            severity_conditional: 'Voorwaardelijk',
            severity_informational: 'Informatief',
            include_informational: 'Informatief opnemen (ISO 27701)',
            export_csv: '[[TOK_0]] downloaden',
            exporting: 'Exporteren...',
            loading: 'Laden…',
            empty_state: 'Alle actieve activiteiten hebben volledige ROPA-records voor dit raamwerk.',
            error_fetch: 'Kan het volledigheidsrapport niet laden.',
            error_unsupported_framework: 'Dit raamwerk wordt niet ondersteund.',
            error_framework_not_installed: 'Dit framework is niet geïnstalleerd voor uw organisatie.',
            no_misses_for_field: 'Er zijn geen activiteiten die dit veld missen.',
            framework_PDPL: '[[TOK_0]] (Wet 91/2025 + Decreet 356)',
            framework_GDPR: '[[TOK_0]] Artikel 30',
            framework_DECREE_165: 'Decreet 165 (Vietnamese gegevenswet)',
            framework_ISO_27701: 'ISO 27701 (informatief)',
        },
        registry: {
            page: {
                title: 'Gegevensregister',
                subtitle: 'Persoonlijke gegevenselementen die uw organisatie bewaart, georganiseerd onder Gegevenscategorieën.',
                empty_state: 'Nog geen registeritems. Voeg handmatig een item toe of importeer het uit een wettelijk register.',
                empty_filter_state: 'Er zijn geen artikelen die overeenkomen met uw filters.',
            },
            filter: {
                category: 'Categorie',
                sensitivity: 'Gevoeligheid',
                data_subject: 'Betrokkene',
                status: 'Status',
                data_tier: 'Gegevenslaag',
                cross_border: 'Grensoverschrijdend',
                has_owner: 'Heeft eigenaar',
                has_form_source: 'Geïmporteerd uit formulier',
                search_placeholder: 'Zoeknaam, beschrijving of veld-ID…',
                clear: 'Filters wissen',
                option_all: 'Allemaal',
            },
            col: {
                name: 'Naam',
                category: 'Categorie',
                sensitivity: 'Gevoeligheid',
                data_subjects: 'Betrokkenen',
                systems: 'Systemen',
                activities: 'Activiteiten',
                owner: 'Eigenaar',
                retention: 'Retentie',
                data_tier: 'Gegevenslaag',
                status: 'Status',
                last_reviewed: 'Laatst beoordeeld',
                actions: 'Acties',
            },
            action: {
                add_manual: 'Artikel toevoegen',
                add_from_form: 'Toevoegen vanuit regelgevingsregister',
                import_history: 'Importeer eerdere inzendingen',
                export: 'Exporteren',
                archive: 'Archief',
                restore: 'Herstellen',
                edit: 'Bewerken',
                assign_owner: 'Eigenaar toewijzen',
                attach_evidence: 'Bewijsmateriaal bijvoegen',
                open_lineage: 'Open afstamming',
            },
            modal_editor: {
                section_identity: 'Identiteit',
                section_classification: 'Classificatie',
                section_subjects: 'Onderwerpen & volume',
                section_location: 'Locatie en overdracht',
                section_systems: 'Systemen & Activiteiten',
                section_retention: 'Bewaring en juridisch',
                section_governance: 'Bestuur',
                section_notes: 'Opmerkingen',
                hint_inherited: '(overgenomen van categorie)',
                hint_overridden: '(overschreven)',
                placeholder_field_identifiers: 'bijvoorbeeld klanten.primary_email, hris.employee_id',
                validation_name_required: 'Naam is vereist',
                validation_category_required: 'Categorie is vereist',
                validation_data_subjects_required: 'Er is ten minste één type betrokkene vereist',
                label_data_type: 'Gegevenstype',
                label_field_identifiers: "Veld-ID's (door komma's gescheiden)",
                label_data_subject_types: 'Typen betrokkenen',
                label_volume_band: 'Volumeband',
                label_storage_locations: "Opslaglocaties (door komma's gescheiden)",
                placeholder_storage_locations: 'ISO-3166 codes of vrije tekst (bijv. VN, Hetzner EU)',
                label_cross_border: 'Grensoverschrijdende overdracht',
                label_source_systems: 'Bronsystemen',
                label_processing_activities: 'Verwerkingsactiviteiten',
                label_collection_method: 'Verzamelmethode',
                label_legal_basis: 'Wettelijke basis',
                label_purposes: 'Doeleinden',
                hint_multi_select: 'Houd Cmd/Ctrl ingedrukt om meerdere te selecteren.',
                option_inherit_category: '— (erven van categorie)',
                option_dash: '—',
            },
            modal_import: {
                dry_run_heading: 'Voorbeeld importeren',
                label_to_create: 'Om te creëren',
                label_to_update: 'Om te updaten',
                label_skipped_archived: 'Overgeslagen (gearchiveerd)',
                label_conflicts: 'Conflicten',
                commit: 'Importeren',
                cancel: 'Annuleer',
                conflict_row: '[[TOK_3]] — behoud van je bewerking ([[TOK_4]]); mapper wilde [[TOK_5]].',
            },
            drawer: {
                section_category: 'Categorie',
                section_systems: 'Bronsystemen',
                section_activities: 'Verwerkingsactiviteiten',
                section_flows: 'Gegevensstromen',
                section_retention: 'Effectieve retentie',
                section_governance: 'Bestuur',
                section_evidence: 'Bewijs',
                section_audit: 'Recent audittraject',
                section_source_form: 'Bron formulierinzending',
                badge_inherited: 'Geërfd',
                badge_overridden: 'Overschreven',
            },
            toast: {
                created: 'Registeritem gemaakt.',
                updated: 'Registeritem bijgewerkt.',
                archived: 'Registeritem gearchiveerd.',
                imported: '[[TOK_1]] items geïmporteerd.',
                conflict_warning: '[[TOK_1]] veld(en) hebben uw bewerkingen behouden — zie conflictlijst.',
            },
        },
        systems: {
            title: 'Systeeminventaris',
            new: 'Nieuw systeem',
            edit: 'Systeem bewerken',
            name: 'Naam',
            owner: 'Eigenaar',
            criticality: 'Kriticiteit',
            dpa_status: 'VVO-status',
            location: 'Locatie',
            system_type: 'Systeemtype',
            metadata: 'Metadata (JSON-indeling)',
            department: 'Afdeling',
            hosting_location: 'Hostinglocatie',
            hosting_provider: 'Hostingprovider',
            data_residency_country: 'Land van gegevensopslag',
            hosting: 'Hostingdienst',
            no_systems: 'Geen systemen gevonden',
            confirm_archive: 'Systeem "{name}" archiveren?',
            count: 'systemen',
            count_one: 'systeem',
            type_internal: 'Intern',
            type_external: 'Extern',
            type_cloud_service: 'Clouddienst',
            type_on_premise: 'On-premise',
            type_hybrid: 'Hybride',
            status_active: 'Actief',
            status_decommissioning: 'Wordt ontmanteld',
            status_decommissioned: 'Ontmanteld',
            status_planned: 'Gepland',
            dpa_not_required: 'Niet vereist',
            dpa_required_missing: 'Vereist ontbreekt',
            dpa_in_progress: 'In behandeling',
            dpa_signed: 'Ondertekend',
            all_criticalities: 'Alle kriticiteiten',
        },
        categories: {
            title: 'Gegevenscategorieën',
            new: 'Nieuwe categorie',
            edit: 'Categorie bewerken',
            name: 'Naam',
            sensitivity: 'Gevoeligheid',
            tags: 'Labels',
            used_in: 'Gebruikt in',
            examples: 'Voorbeelden',
            examples_hint: 'Voorbeelden (kommagescheiden)',
            default: 'Standaard',
            all_sensitivities: 'Alle gevoeligheidsniveaus',
            all_statuses: 'Alle statussen',
            no_categories: 'Geen categorieën gevonden',
            confirm_delete: 'Categorie "{name}" verwijderen?',
            count: 'categorieën',
            count_one: 'categorie',
            status_draft: 'Concept',
            status_proposed: 'Voorgesteld',
            status_under_review: 'In beoordeling',
            status_approved: 'Goedgekeurd',
            status_deprecated: 'Verouderd',
            status_updated: 'Categoriestatus bijgewerkt',
            propose: 'Voorstellen',
            approve: 'Goedkeuren',
            deprecate: 'Verouderen',
        },
        purposes: {
            title: 'Verwerkingsdoeleinden',
            new: 'Nieuw doeleinde',
            edit: 'Doeleinde bewerken',
            name: 'Naam',
            legal_basis: 'Rechtsgrond',
            retention_period: 'Bewaartermijn (dagen)',
            justification: 'Rechtvaardiging gerechtvaardigd belang',
            legal_basis_detail: 'Details rechtsgrond',
            all_legal_bases: 'Alle rechtsgronden',
            no_purposes: 'Geen doeleinden gevonden',
            confirm_delete: '"{name}" verwijderen?',
            default: 'Standaard',
            count: '{count} doeleinden',
            count_one: '{count} doeleinde',
            basis_consent: 'Toestemming',
            basis_contract: 'Overeenkomst',
            basis_legal_obligation: 'Wettelijke Verplichting',
            basis_vital_interest: 'Vitaal Belang',
            basis_public_interest: 'Algemeen Belang',
            basis_legitimate_interest: 'Gerechtvaardigd Belang',
        },
        retention: {
            title: 'Bewaarbeleid',
            new: 'Nieuw beleid',
            edit: 'Beleid bewerken',
            name: 'Naam',
            retention_days: 'Bewaardagen',
            disposal_method: 'Verwijderingsmethode',
            data_categories: 'Gegevenscategorieën',
            activities: 'Activiteiten',
            review_frequency: 'Beoordelingsfrequentie',
            review_frequency_days: 'Beoordelingsfrequentie (dagen)',
            no_policies: 'Geen bewaarbeleid gevonden',
            confirm_delete: '"{name}" verwijderen?',
            count: '{count} beleidsregels',
            count_one: '{count} beleidsregel',
            days: 'dagen',
            disposal_deletion: 'Verwijdering',
            disposal_anonymization: 'Anonimisering',
            disposal_archival: 'Archivering',
            review_overdue: 'Beoordeling achterstallig',
            review_status: 'Beoordelingsstatus',
            review_ok: 'Op schema',
            department: 'Afdeling',
            all_departments: 'Alle afdelingen',
        },
        flows: {
            view_tabs_aria: 'Stromenweergave',
            view_list: 'Lijst',
            view_map: 'Kaart',
            title: 'Gegevensstromen',
            new: 'Nieuwe stroom',
            edit: 'Stroom bewerken',
            name: 'Naam',
            from_system: 'Van systeem',
            to_system: 'Naar systeem',
            flow_type: 'Stroomtype',
            cross_border: 'Grensoverschrijdend',
            risk_level: 'Risiconiveau',
            mechanism: 'Mechanisme',
            transfer_mechanism: 'Overdrachtsmechanisme',
            frequency: 'Frequentie',
            source_country: 'Bronland',
            destination_country: 'Bestemmingsland',
            transfer_safeguard: 'Overdrachtswaarborg',
            all_risk_levels: 'Alle risiconiveaus',
            no_flows: 'Geen gegevensstromen gevonden',
            confirm_archive: '"{name}" archiveren?',
            count: '{count} stromen',
            count_one: '{count} stroom',
            status_active: 'Actief',
            status_inactive: 'Inactief',
            status_under_review: 'In beoordeling',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Bestandsoverdracht',
            mechanism_database_replication: 'Databasereplicatie',
            mechanism_manual: 'Handmatig',
            mechanism_email: 'E-mail',
            mechanism_other: 'Overig',
            frequency_real_time: 'Realtime',
            frequency_hourly: 'Elk uur',
            frequency_daily: 'Dagelijks',
            frequency_weekly: 'Wekelijks',
            frequency_monthly: 'Maandelijks',
            frequency_on_demand: 'Op verzoek',
            frequency_one_time: 'Eenmalig',
            safeguard_adequacy_decision: 'Adequaatheidsbesluit',
            safeguard_standard_contractual_clauses: 'Standaardcontractbepalingen',
            safeguard_binding_corporate_rules: 'Bindende bedrijfsvoorschriften',
            safeguard_explicit_consent: 'Uitdrukkelijke toestemming',
            safeguard_legal_obligation: 'Wettelijke verplichting',
            safeguard_none: 'Geen',
            safeguard_other: 'Overig',
        },
        activities: {
            title: 'Verwerkingsactiviteiten',
            new: 'Nieuwe activiteit',
            edit: 'Activiteit bewerken',
            activity_title: 'Titel',
            category: 'Categorie',
            legal_basis: 'Rechtsgrond',
            dpa_required: 'VVO vereist',
            ropa_generated: 'VVR gegenereerd',
            version: 'Versie',
            generate_ropa: 'VVR genereren',
            controller: 'Verwerkingsverantwoordelijke',
            controller_name: 'Naam verwerkingsverantwoordelijke',
            controller_contact: 'Contact verwerkingsverantwoordelijke',
            legal_basis_detail: 'Details rechtsgrond',
            organization_info: 'Organisatie-informatie (Bijlage I)',
            org_address: 'Organisatieadres',
            tax_code: 'Belastingcode',
            contact_person: 'Contactpersoon',
            contact_email: 'Contacte-mail',
            contact_phone: 'Contacttelefoon',
            select_entity: 'Selecteer…',
            no_entities: 'Geen artikelen gevonden',
            dpo_name: 'Naam FG',
            dpo_contact: 'Contact FG',
            processor_name: 'Naam verwerker',
            processor_contact: 'Contact verwerker',
            data_subjects: 'Betrokkenen',
            data_subjects_hint: 'Betrokkenen (kommagescheiden)',
            recipients: 'Ontvangers',
            recipients_hint: 'Ontvangers (kommagescheiden)',
            security_measures: 'Beveiligingsmaatregelen',
            dpia_reference: 'GEB-referentie',
            no_activities: 'Geen verwerkingsactiviteiten gevonden',
            confirm_archive: '"{name}" archiveren?',
            count: '{count} activiteiten',
            count_one: '{count} activiteit',
            ropa_success: 'VVR-registratie gegenereerd. Ga naar Exporteren om het te downloaden.',
            ropa_error: 'VVR kon niet worden gegenereerd',
            required_label: 'Vereist',
            status_draft: 'Concept',
            status_active: 'Actief',
            status_under_review: 'In beoordeling',
            status_archived: 'Gearchiveerd',
            decree_165_heading: 'Decreet 165 datalaag (Vietnamese datawet)',
            decree_165_helper: 'Classificeer de gegevens die deze activiteit verwerkt onder Vietnamdecreet 165. Reguliere gegevens verkrijgen het grensoverschrijdende basisregime; belangrijke en kerngegevens brengen extra verplichtingen met zich mee.',
            data_tier_label: 'Gegevenslaag',
            data_tier_help: 'Decreet 165 classificeert gegevens als regulier, belangrijk of kern – zie het Help-artikel voor richtlijnen.',
            data_tier_column_header: 'Gegevenslaag',
            data_tier_regular: 'Regelmatig',
            data_tier_important: 'Belangrijk',
            data_tier_core: 'Kern',
            transfer_mechanism_label: 'Mechanisme voor grensoverschrijdende overdracht',
            transfer_mechanism_placeholder: 'bijv. Standaardcontractbepalingen, adequaatheidsbesluit',
            security_assessment_reference_label: 'Referentie voor beveiligingsbeoordeling',
            security_assessment_reference_placeholder: 'bijv. [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Bewijskluis',
            new: 'Nieuw bewijs',
            edit: 'Bewijs bewerken',
            name: 'Naam',
            evidence_type: 'Type bewijs',
            linked_entities: 'Gekoppelde entiteiten',
            uploaded: 'Geüpload',
            expiry: 'Vervaldatum',
            file_url: 'Bestands-URL',
            source_mode_label: 'Bewijsbron',
            source_mode_file: 'Bestand uploaden',
            source_mode_url: 'Externe URL koppelen',
            attachment_label: 'Bijlage',
            link_to: 'Bewijs koppelen aan',
            entity_type: 'Entiteitstype',
            entity_id: 'Entiteits-ID',
            no_evidence: 'Geen bewijsitems gevonden',
            manage_links: 'Beheer koppelingen',
            unlink: 'Ontkoppelen',
            confirm_delete: 'Bewijs "{name}" verwijderen?',
            count: '[[TOK_1]] artikelen',
            count_one: '{count} onderdeel',
            type_document: 'Documentbestand',
            type_screenshot: 'Schermafbeelding',
            type_policy: 'Beleid',
            type_contract: 'Overeenkomst',
            type_assessment: 'Beoordeling',
            type_correspondence: 'Correspondentie',
            type_other: 'Overig',
            linked_type_system: 'Systeem',
            linked_type_data_flow: 'Gegevensstroom',
            linked_type_processing_activity: 'Verwerkingsactiviteit',
            linked_type_data_category: 'Gegevenscategorie',
            linked_type_purpose: 'Doel',
            linked_type_retention_policy: 'Bewaarbeleid',
            link_entity: 'Link naar entiteit',
            link_success: 'Entiteit is succesvol gekoppeld',
            confirm_unlink: 'Weet u zeker dat u deze entiteit wilt ontkoppelen?',
            unlink_success: 'Entiteit is ontkoppeld',
            no_linked_entities: 'Geen gekoppelde entiteiten',
            select_entity: 'Selecteer…',
            no_entities: 'Geen artikelen',
        },
        exports: {
            title: 'Gegevensexports',
            recent: 'Recente exports',
            export_type: 'Exporttype',
            format: 'Formaat',
            requested_by: 'Aangevraagd door',
            requested_at: 'Aangevraagd op',
            download: 'Downloaden',
            csv_export: 'CSV-export',
            csv_description: 'Gegevens downloaden in CSV-formaat voor spreadsheetanalyse.',
            pdf_reports: 'PDF-rapporten',
            pdf_description: 'Opgemaakte rapporten genereren voor nalevingsdocumentatie.',
            csv_systems: 'Systeeminventaris',
            csv_categories: 'Gegevenscategorieën',
            csv_flows: 'Gegevensstromen',
            csv_activities: 'Verwerkingsactiviteiten',
            csv_cross_border: 'Grensoverschrijdende stromen',
            csv_retention_policies: 'Bewaarbeleid',
            csv_evidence: 'Bewijsstukken',
            csv_governance_assignments: 'Bestuursopdrachten',
            pdf_ropa: 'VVR-register',
            pdf_systems: 'Systeemrapport',
            pdf_cross_border: 'Grensoverschrijdend rapport',
            pdf_flow_map: 'Stroomkaartgegevens',
            export_failed: 'Export mislukt',
            pdf_generated: 'PDF succesvol gegenereerd.',
            ropa: 'RoPA-register',
            retention_policies: 'Bewaarbeleid',
            governance_assignments: 'Bestuursopdrachten',
            col_entity: 'Entiteit exporteren',
            col_description: 'Beschrijving',
            desc_ropa: 'Volledig ROPA-register van alle verwerkingsactiviteiten met wettelijke basis, [[TOK_0]]-status en controles.',
            desc_systems: 'Systeeminventarisatie met eigenaar, gegevenscategorietags en nalevingsstatus.',
            desc_activities: 'Individuele verwerkingsactiviteiten met verwerkingsverantwoordelijke, wettelijke basis en [[TOK_0]]-classificatie.',
            desc_categories: 'Gegevenscategorieën en gevoeligheidsniveaus die worden gebruikt bij classificatie en audits.',
            desc_purposes: 'Verwerkingsdoeleinden met vermelding van de wettelijke basis volgens Decreet 13/2023 en Telecommunicatiewet 2023.',
            desc_flows: 'Gegevensstromen tussen systemen, inclusief interne en grensoverschrijdende routes.',
            desc_cross_border: 'Alleen grensoverschrijdende stromen, met overdrachtsmechanisme en risicobeoordeling.',
            desc_retention_policies: 'Bewaarbeleid, verwijderingsmethoden en beoordelingsfrequentie.',
            desc_evidence: 'Bewijsstukken verbonden aan verwerkingsactiviteiten: certificaten, DPA-contracten, [[TOK_0]] rapporten.',
            desc_governance_assignments: 'Governance-opdrachten: eigenaren, goedkeurders en ISO 27001-referenties.',
            unified_heading: 'Entiteiten exporteren',
            unified_description: 'Exporteer een gegevenstoewijzingsentiteit in de indeling [[TOK_0]], [[TOK_3]], [[TOK_2]] of [[TOK_1]]. Alle exports worden opgeslagen in de bestandsbrowser.',
            export_button_label: 'Exporteren',
            csv_download_success: 'CSV succesvol gedownload.',
        },
        attestation: {
            title: 'Attestatiecycli',
            create: 'Nieuwe cyclus',
            name: 'Cyclusnaam',
            year: 'Jaar',
            deadline: 'Deadline',
            scope: 'Bereik',
            status: 'Status',
            tasks: 'Afdelingstaken',
            assign_tasks: 'Taken toewijzen',
            department: 'Afdeling',
            assignee: 'Toegewezene',
            progress: 'Voortgang',
            stale_entries: 'Verouderde items',
            detect_stale: 'Verouderde detecteren',
            export_bundle: 'Pakket exporteren',
            no_cycles: 'Nog geen attestatiecycli.',
            create_success: 'Attestatiecyclus aangemaakt.',
            assign_success: 'Taken toegewezen.',
            complete_success: 'Taak voltooid.',
            stale_detected: 'Verouderde items gedetecteerd.',
            stale_systems: 'Verouderde systemen',
            stale_flows: 'Verouderde stromen',
            no_stale: 'Geen verouderde items gedetecteerd.',
            stale_name: 'Naam',
            stale_announcement: '{0} verouderde systemen en {1} verouderde stromen gevonden',
            last_updated: 'Laatst bijgewerkt',
            status_draft: 'Concept',
            status_active: 'Actief',
            status_completed: 'Voltooid',
            task_status_pending: 'In afwachting',
            task_status_in_progress: 'Bezig',
            task_status_completed: 'Voltooid',
            scope_systems: 'Systemen',
            scope_flows: 'Gegevensstromen',
            scope_activities: 'Activiteiten',
            scope_categories: 'Categorieën',
            scope_purposes: 'Doeleinden',
            scope_retention: 'Bewaring',
        },
        governance: {
            title: 'Governance-toewijzingen',
            assign: 'Eigenaarschap toewijzen',
            entity_type: 'Entiteittype',
            entity: 'Entiteit',
            role: 'Rol',
            assigned_by: 'Toegewezen door',
            assigned_at: 'Toegewezen op',
            remove: 'Verwijderen',
            no_assignments: 'Geen governance-toewijzingen.',
            assign_success: 'Eigenaarschap toegewezen.',
            remove_success: 'Toewijzing verwijderd.',
            assignee: 'Toegewezene',
            department: 'Afdeling',
            all_departments: 'Alle afdelingen',
            roles: {
                data_owner: 'Data-eigenaar',
                data_steward: 'Databeheerder',
                data_custodian: 'Databewaarder',
                informed: 'Geïnformeerd',
            },
            entity_types: {
                system: 'Systeem',
                flow: 'Gegevensstroom',
                activity: 'Activiteit',
                category: 'Categorie',
                purpose: 'Doeleinde',
                retention_policy: 'Bewaarbeleid',
            },
        },
        risk_assessment: {
            title: 'Risicobeoordeling',
            create: 'Nieuwe beoordeling',
            safeguard_type: 'Waarborgstype',
            adequacy_status: 'Toereikendheidsstatus',
            risk_factors: 'Risicofactoren',
            mitigations: 'Maatregelen',
            reviewer: 'Beoordelaar',
            decision: 'Beslissing',
            approve: 'Goedkeuren',
            reject: 'Afwijzen',
            no_assessments: 'Geen risicobeoordelingen.',
            create_success: 'Risicobeoordeling aangemaakt.',
            approve_success: 'Beoordeling goedgekeurd.',
            reject_success: 'Beoordeling afgewezen.',
            one_per_line: 'Eén per regel',
            safeguard_adequacy_decision: 'Adequaatheidsbesluit',
            safeguard_standard_contractual_clauses: 'Standaardcontractbepalingen',
            safeguard_binding_corporate_rules: 'Bindende bedrijfsregels',
            safeguard_explicit_consent: 'Uitdrukkelijke toestemming',
            safeguard_legal_obligation: 'Wettelijke verplichting',
            safeguard_none: 'Geen',
            safeguard_other: 'Anders',
            adequacy_adequate: 'Toereikend',
            adequacy_inadequate: 'Ontoereikend',
            adequacy_under_review: 'In beoordeling',
            adequacy_not_assessed: 'Niet beoordeeld',
            decision_approved: 'Goedgekeurd',
            decision_rejected: 'Afgewezen',
        },
        review: {
            title: 'Beoordelingstaken',
            description: 'Beoordelingstaken worden automatisch aangemaakt wanneer een gegevenscategorie wordt voorgesteld. Ga naar Gegevenscategorieën en klik op Voorstellen bij een conceptcategorie om een nieuwe taak te maken.',
            count: 'beoordelingstaken',
            summary: 'Beoordelingsoverzicht',
            pending: 'In afwachting',
            resolved_today: 'Vandaag opgelost',
            escalated: 'Geëscaleerd',
            overdue: 'Achterstallig (>5 dagen)',
            all_statuses: 'Alle statussen',
            status_pending: 'In afwachting',
            status_resolved: 'Opgelost',
            status_escalated: 'Geëscaleerd',
            category_name: 'Categorie',
            system_name: 'Systeem',
            owner: 'Eigenaar',
            resolve: 'Oplossen',
            resolve_task: 'Beoordelingstaak oplossen',
            resolution: 'Oplossing',
            resolution_approve: 'Goedkeuren',
            resolution_modify: 'Wijzigen en goedkeuren',
            resolution_reject: 'Afwijzen',
            resolution_escalate: 'Escaleren',
            notes: 'Oplossingsnotities',
            notes_required: 'Notities vereist (minimaal 10 tekens) voor Wijzigen, Afwijzen of Escaleren',
            resolved_success: 'Beoordelingstaak opgelost',
            bulk_approve: 'Groepsgoedkeuring',
            bulk_reject: 'Groepsafwijzing',
            bulk_success: '{count} taken verwerkt',
            no_tasks: 'Geen beoordelingstaken gevonden',
        },
        inventory: {
            title: 'Classificatie-inventaris',
            count: 'systemen',
            summary: 'Inventarisoverzicht',
            total_systems: 'Totaal systemen',
            total_labels: 'Totaal labels',
            system_name: 'Systeem',
            label_count: 'Etiketten',
            approved_count: 'Goedgekeurd',
            pending_count: 'In afwachting',
            no_items: 'Geen inventarisitems gevonden',
        },
        exceptions: {
            title: 'Classificatie-uitzonderingen',
            count: 'uitzonderingen',
            all_severities: 'Alle ernstniveaus',
            all_statuses: 'Alle statussen',
            system_name: 'Systeem',
            severity_label: 'Ernst',
            status_open: 'Openen',
            status_resolved: 'Opgelost',
            status_accepted_risk: 'Geaccepteerd risico',
            resolve: 'Oplossen',
            resolve_exception: 'Uitzondering oplossen',
            resolution_type: 'Oplossingstype',
            notes: 'Notities',
            justification_required: 'Rechtvaardiging vereist (minimaal 10 tekens) voor geaccepteerd risico',
            resolved_success: 'Uitzondering opgelost',
            no_exceptions: 'Geen uitzonderingen gevonden',
        },
        history: {
            title: 'Classificatiegeschiedenis',
            count: 'gebeurtenissen',
            actor: 'Acteur',
            action: 'Actie',
            entity_type: 'Entiteitstype',
            changes: 'Wijzigingen',
            view_lineage: 'Herkomst bekijken',
            lineage_title: 'Classificatieherkomst',
            no_events: 'Geen geschiedenisgebeurtenissen gevonden',
            no_lineage: 'Geen herkomstgegevens beschikbaar',
            modified: 'Gewijzigd',
            created: 'Aangemaakt',
            removed: 'Verwijderd',
            action_created: 'Gemaakt',
            action_updated: 'Bijgewerkt',
            action_archived: 'Gearchiveerd',
            action_approved: 'Goedgekeurd',
            action_deprecated: 'Verouderd',
            entity_label: 'Etiket',
            entity_taxonomy: 'Taxonomie',
            entity_review_task: 'Beoordelingstaak',
            entity_exception: 'Uitzondering',
            before: 'Voor',
            after: 'Na',
        },
    },
    governance: {
        audit_trail_title: 'Audit-spoor voor governance',
        audit_trail_subtitle: 'Cross-entiteits auditstroom voor governance-acties — goedkeuringen, playbook-uitvoeringen, bewijskoppelingen en meer.',
        audit_trail_item_count: 'auditgebeurtenissen',
        audit_trail_fetch_error: 'Kan auditgebeurtenissen niet ophalen.',
        audit_trail_no_events: 'Geen auditgebeurtenissen gevonden voor de huidige filters.',
        audit_trail_entity_type: 'Entiteitstype',
        audit_trail_entity_id: 'Entiteits-ID',
        audit_trail_action: 'Actie',
        audit_trail_actor: 'Uitvoerder',
        audit_trail_timestamp: 'Tijdstempel',
        audit_trail_date_from: 'Van',
        audit_trail_date_to: 'Tot',
        audit_trail_no_rows_to_export: 'Geen rijen om te exporteren.',
        nav: {
            vendors: 'Leveranciers',
            subprocessors: 'Subverwerkers',
            cross_border: 'Grensoverschrijdend',
            drift: 'Driftmonitor',
            scores: 'Nalevingsscore',
            playbooks: 'Draaiboeken',
            approvals: 'Goedkeuringen',
            audit_trail: 'Auditspoor',
            board_report: 'Bestuursrapport',
            evidence: 'Bewijs',
            onboarding: 'Onboarding-pijplijn',
            dpa_reviews: 'DPA-beoordelingen',
            periodic_reviews: 'Periodieke beoordelingen',
            offboarding: 'Offboarden',
        },
        vendors: {
            title: 'Leveranciersregister',
            new: 'Nieuwe leverancier',
            edit: 'Leverancier bewerken',
            name: 'Naam',
            jurisdiction: 'Jurisdictie',
            dpa_status: 'VVO-status',
            risk_level: 'Risiconiveau',
            onboarding_status: 'Onboardingstatus',
            contact_email: 'Contact e-mail',
            contact_name: 'Contactnaam',
            contact_phone: 'Contacttelefoon',
            website: 'Webpagina',
            services_csv: 'Diensten (kommagescheiden)',
            country: 'Land',
            country_placeholder: 'bijv. NL',
            last_reviewed: 'Laatst beoordeeld',
            offboard: 'Beëindigen',
            offboard_vendor: 'Leverancier beëindigen',
            offboard_reason: 'Reden voor beëindiging',
            no_vendors: 'Geen leveranciers gevonden',
            vendor_count: '{count} leverancier(s)',
            all_dpa_status: 'Alle VVO-statussen',
            all_risk_levels: 'Alle risiconiveaus',
            all_onboarding: 'Alle onboardingstatussen',
            fetch_error: 'Mislukt. Probeer het opnieuw.',
            save_error: 'Leverancier kon niet worden opgeslagen',
            offboard_error: 'Beëindiging mislukt',
        },
        vendor_types: {
            processor: 'Verwerker',
            sub_processor: 'Subverwerker',
            controller: 'Verwerkingsverantwoordelijke',
            joint_controller: 'Gezamenlijke Verwerkingsverantwoordelijke',
        },
        onboarding_statuses: {
            pending_review: 'Beoordeling in Afwachting',
            approved: 'Goedgekeurd',
            active: 'Actief',
            suspended: 'Geschorst',
            offboarded: 'Beëindigd',
        },
        dpa_statuses: {
            not_required: 'Niet Vereist',
            required_missing: 'Vereist Ontbreekt',
            draft: 'Concept',
            under_review: 'In Beoordeling',
            signed: 'Ondertekend',
            expired: 'Verlopen',
        },
        risk_levels: {
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Middel',
            low: 'Laag',
        },
        approval_statuses: {
            pending: 'In Afwachting',
            approved: 'Goedgekeurd',
            rejected: 'Afgewezen',
            expired: 'Verlopen',
        },
        approval_action_types: {
            vendor_onboarding: 'Leveranciersregistratie',
            vendor_offboarding: 'Leveranciersbeëindiging',
            cross_border_acceptance: 'Grensoverschrijdende Goedkeuring',
            playbook_activation: 'Playbook-activering',
            drift_accept_risk: 'Afwijking Risico Geaccepteerd',
            activity_activation: 'Activiteitsactivering',
        },
        drift_check_types: {
            dpa_expiry: 'DPA-vervaldatum',
            dpa_missing: 'DPA Ontbreekt',
            review_overdue: 'Beoordeling Achterstallig',
            cross_border_gap: 'Grensoverschrijdende Lacune',
            sub_processor_chain: 'Subverwerkersketen',
            risk_assessment_overdue: 'Risicobeoordeling Achterstallig',
            retention_policy_missing: 'Bewaarbeleid Ontbreekt',
            evidence_expiring: 'Bewijsmateriaal Verloopt',
        },
        drift_statuses: {
            open: 'Geopend',
            acknowledged: 'Bevestigd',
            in_progress: 'In Behandeling',
            resolved: 'Opgelost',
            accepted_risk: 'Geaccepteerd Risico',
        },
        drift_entity_types: {
            vendor: 'Leverancier',
            system: 'Systeem',
            data_flow: 'Gegevensstroom',
            processing_activity: 'Verwerkingsactiviteit',
            evidence_item: 'Bewijsmateriaal',
        },
        playbook_statuses: {
            draft: 'Concept',
            active: 'Actief',
            archived: 'Gearchiveerd',
        },
        playbook_action_types: {
            delete_data: 'Gegevens Verwijderen',
            verify_deletion: 'Verwijdering Verifiëren',
            notify_vendor: 'Leverancier Informeren',
            confirm_receipt: 'Ontvangst Bevestigen',
            document_evidence: 'Documenteren',
            other: 'Overig',
        },
        playbook_target_types: {
            system: 'Systeem',
            vendor: 'Leverancier',
        },
        dpa_chain_statuses: {
            complete: 'Compleet',
            incomplete: 'Onvolledig',
            unknown: 'Onbekend',
        },
        sub_processor_statuses: {
            active: 'Actief',
            terminated: 'Beëindigd',
        },
        evidence_types: {
            dpa_agreement: 'DPA-overeenkomst',
            risk_assessment: 'Risicobeoordeling',
            audit_report: 'Auditrapport',
            certification: 'Certificering',
            deletion_confirmation: 'Verwijderingsbevestiging',
            training_record: 'Opleidingsregistratie',
            incident_report: 'Incidentrapport',
            document: 'Documentbestand',
            screenshot: 'Schermafbeelding',
            policy: 'Beleid',
            contract: 'Overeenkomst',
            assessment: 'Beoordeling',
            correspondence: 'Correspondentie',
            other: 'Overig',
        },
        linkable_entity_types: {
            vendor: 'Leverancier',
            transfer_mechanism: 'Overdrachtsmechanisme',
            playbook: 'Draaiboek',
            execution: 'Uitvoering',
            system: 'Systeem',
            activity: 'Activiteit',
        },
        subprocessors: {
            title: 'Subverwerkerrelaties',
            new: 'Nieuwe koppeling',
            vendor: 'Leverancier',
            subprocessor: 'Subverwerker',
            relationship_type: 'Type relatie',
            countries: 'Landen',
            countries_csv: 'Landen (kommagescheiden)',
            dpa_chain: 'DPA-keten',
            dpa_chain_status: 'DPA-ketenstatus',
            no_processors: 'Geen verwerkers gevonden.',
            no_subprocessors: 'Geen subverwerkers gevonden.',
            processor_vendor: 'Verwerkerleverancier',
            select_processor: 'Verwerker selecteren',
            select_vendor: 'Leverancier selecteren',
            services: 'Diensten',
            sub_processor_vendor_id: 'Subverwerker-ID',
            terminate: 'Beëindigen',
            confirm_terminate: 'Weet u zeker dat u deze relatie wilt beëindigen?',
            create_error: 'Koppeling kon niet worden aangemaakt.',
            fetch_error: 'Subverwerkers konden niet worden opgehaald.',
            processor: 'Verwerker',
            services_csv: 'Diensten (kommagescheiden)',
            terminate_error: 'Beëindiging mislukt.',
            version_history_heading: 'Wijziging van versiebeheer door subverwerker',
            change_tracking_note: 'Voor alle wijzigingen in de relatie tussen subverwerkers geldt een versiebeheer. Elke wijziging registreert de voor/na-status voor een audittrail.',
            history_retention_note: 'De wijzigingsgeschiedenis wordt bewaard gedurende de volledige bewaartermijn van gegevens. Bekijk wijzigingslogboeken via de detailweergave van de leverancier.',
            vendor_risk_cross_view_heading: 'Subverwerkersregister (Vendor Risk)',
            vendor_risk_cross_view_source: 'Bron: Vendor Risk Register',
            vendor_risk_cross_view_empty: 'Geen vermeldingen in het Vendor Risk-register.',
        },
        cross_border: {
            title: 'Grensoverschrijdend governancerapport',
            flows: 'Grensoverschrijdende stromen',
            transfers: 'Grensoverschrijdende doorgiften',
            detected_gaps: 'Gedetecteerde lacunes',
            safeguards: 'Waarborgen',
            cross_border_vendors: 'Grensoverschrijdende leveranciers',
            destination: 'Bestemming',
            no_cross_border_vendors: 'Geen grensoverschrijdende leveranciers gevonden.',
            no_safeguard: 'Geen waarborg',
            processing_locations: 'Verwerkingslocaties',
            export_error: 'Rapport kon niet worden geëxporteerd.',
            export_pdf: 'PDF exporteren',
            export_success: 'Rapport succesvol geëxporteerd.',
            exporting: 'Bezig met exporteren...',
            fetch_error: 'Grensoverschrijdende gegevens konden niet worden opgehaald.',
            source: 'Bron',
            pdpl_p2_heading: '[[TOK_0]]-P2 Naleving van grensoverschrijdende overdrachten',
            dossier_prep_note: 'Dossiervoorbereiding: verzamel effectbeoordeling, rechtsgrondslag en waarborgdocumentatie vóór indiening.',
            filing_tracking_note: 'Volgen van indieningen: volg de indieningsstatus bij de Autoriteit (PDPC) vanaf de eerste aanvraag tot en met de goedkeuring.',
            supplement_loop_note: 'Aanvullingscyclus: reageer op informatieverzoeken van de autoriteiten en dien indien nodig gewijzigde dossiers opnieuw in.',
            official_forms_note: 'Officiële formulieren: gebruik Mau so 01a (Aanvraag), Mau so 01b (Aanvullende informatie) en Mau so 09 (Transfer Impact Assessment) per [[TOK_0]]-P2-regelgeving.',
            vendor_search_label: 'Leverancier zoeken',
            vendor_search_placeholder: 'Zoek op leveranciersnaam…',
            jurisdiction_filter_label: 'Rechtsgebied',
            filings_section_heading: 'Grensoverschrijdende indieningen',
            filings_empty: 'Nog geen dossiers. Maak er een om een ​​dossier te starten.',
            filings_create_button: 'Nieuwe aangifte',
            filings_table_id: 'Indienings-ID',
            filings_table_jurisdiction: 'Jurisdictie',
            filings_table_type: 'Formuliertype',
            filings_table_status: 'Status',
            filings_table_updated: 'Bijgewerkt',
            filings_table_open: 'Openen',
            filings_detail_title: 'Grensoverschrijdende indiening',
            filings_back_to_list: 'Terug naar grensoverschrijdend',
            filings_status_heading: 'Levenscyclus',
            filings_evidence_heading: 'Bewijs',
            filings_history_heading: 'Audittrail',
            filings_field_filing_id: 'Indienings-ID',
            filings_field_jurisdiction: 'Jurisdictie',
            filings_field_type: 'Formuliertype',
            filings_field_status: 'Status',
            filings_field_reference: 'Referentie autoriteit',
            filings_field_mps_receipt: '[[TOK_0]] ontvangstbewijs',
            filings_field_submitted_at: 'Ingediend op',
            filings_field_acknowledged_at: 'Erkend bij',
            filings_field_archived_at: 'Gearchiveerd op',
            filings_field_version: 'Versie',
            filings_field_notes: 'Opmerkingen',
            filings_action_advance: 'Vooruitgangsstatus',
            filings_action_reject: 'Afwijzen',
            filings_action_archive: 'Archief',
            filings_action_submit: 'Markeer ingediend',
            filings_action_acknowledge: 'Mark erkende het',
            filings_action_resume_draft: 'CV als concept',
            filings_status_draft: 'Diepgang',
            filings_status_assessed: 'Beoordeeld',
            filings_status_pending_review: 'In afwachting van beoordeling',
            filings_status_ready_to_file: 'Klaar om te archiveren',
            filings_status_submitted: 'Ingezonden',
            filings_status_acknowledged: 'Erkend',
            filings_status_rejected: 'Afgewezen',
            filings_status_archived: 'Gearchiveerd',
            filings_type_mau_01a: 'Mẫu 01a — Overdrachtsaanvraag',
            filings_type_mau_03a: 'Mẫu 03a — Aanvullingsdossier',
            filings_type_mau_09: 'Mei 09 — Effectbeoordeling van de overdracht',
            filings_new_dialog_title: 'Nieuwe grensoverschrijdende indiening',
            filings_new_form_jurisdiction: 'Jurisdictie (bijv. VN-[[TOK_0]])',
            filings_new_form_type: 'Formuliertype',
            filings_new_form_notes: 'Opmerkingen (optioneel)',
            filings_new_submit: 'Creëer',
            filings_new_cancel: 'Annuleer',
            filings_reason_label: 'Reden',
            filings_reference_label: 'Referentienummer van de autoriteit',
            filings_mps_receipt_label: '[[TOK_0]] ontvangstreferentie',
            filings_create_error: 'Kan archief niet maken.',
            filings_create_success: 'Archief aangemaakt.',
            filings_update_error: 'Kan de archivering niet bijwerken.',
            filings_update_success: 'Bestand bijgewerkt.',
            filings_fetch_error: 'Kan de dossiers niet ophalen.',
            filings_archive_confirm: 'Deze aangifte archiveren? Dit kan niet ongedaan worden gemaakt.',
            filings_status_rejected_detour: 'De indiening werd na beoordeling afgewezen. Hervat als concept om de stroom opnieuw te starten.',
            recent_exports_heading: 'Recente exporten',
            recent_exports_empty: "Nog geen export. Klik op 'Exporteren [[TOK_0]]' om er een te genereren.",
        },
        drift: {
            title: 'Configuratiedriftmonitor',
            drift_type: 'Type drift',
            severity: 'Ernst',
            detected_at: 'Gedetecteerd op',
            resolve: 'Oplossen',
            all_check_types: 'Alle controletypen',
            all_entity_types: 'Alle entiteitstypen',
            event_count: 'Aantal gebeurtenissen',
            accept_risk: 'Risico accepteren',
            acknowledge: 'Bevestigen',
            assign_error: 'Toewijzing mislukt.',
            assign_event: 'Toewijzen',
            assigned: 'Toegewezen',
            enter_resolution_notes: 'Oplossingsnotities invoeren...',
            enter_user_id: 'Gebruikers-ID invoeren...',
            entity: 'Entiteit',
            fetch_error: 'Driftgebeurtenissen konden niet worden opgehaald.',
            no_events: 'Geen driftgebeurtenissen gevonden.',
            resolution_notes: 'Oplossingsnotities',
            update_status_error: 'Status kon niet worden bijgewerkt.',
        },
        scores: {
            title: 'Nalevingsscoreoverzicht',
            overall: 'Totale nalevingsscore',
            breakdown: 'Score-uitsplitsing per module',
            trend: 'Historische trend',
            module: 'Onderdeel',
            score: 'Scoren',
            grade: 'Beoordeling',
            calculated_at: 'Berekend op',
            generate_board_report: 'Bestuursrapport genereren',
            lang_english: 'Engels',
            lang_vietnamese: 'Vietnamees',
            fetch_error: 'Nalevingsscores konden niet worden opgehaald.',
            generate_report: 'Rapport genereren',
            generating: 'Bezig met genereren...',
            recommendations: 'Aanbevelingen',
            report_error: 'Rapport kon niet worden gegenereerd.',
            factor_owner_assigned: 'Eigenaar toegewezen',
            factor_data_categories_linked: 'Gegevenscategorieën gekoppeld',
            factor_purposes_linked: 'Doeleinden gekoppeld',
            factor_data_flows_documented: 'Gegevensstromen gedocumenteerd',
            factor_processing_activity_linked: 'Verwerkingsactiviteit gekoppeld',
            factor_dpa_status: 'DPA-status',
            factor_retention_policy_linked: 'Bewaarbeleid gekoppeld',
            factor_last_reviewed: 'Laatst beoordeeld binnen drempel',
            factor_risk_assessment_current: 'Risicobeoordeling actueel',
            factor_sub_processors_documented: 'Subverwerkers gedocumenteerd',
            factor_cross_border_safeguards: 'Grensoverschrijdende waarborgen',
            factor_contact_info_complete: 'Contactgegevens volledig',
            factor_onboarding_approved: 'Onboarding goedgekeurd',
            factor_avg_system_score: 'Gemiddelde systeemscore',
            factor_avg_vendor_score: 'Gemiddelde leveranciersscore',
            factor_processing_activity_coverage: 'Dekking van verwerkingsactiviteiten',
            factor_ropa_completeness: 'RoPA-volledigheid',
            factor_open_drift_events: 'Open afwijkingsgebeurtenissen',
        },
        playbooks: {
            title: 'Verwijderingsdraaiboeken',
            new: 'Nieuw draaiboek',
            edit: 'Draaiboek bewerken',
            steps: 'Stappen',
            add_step: 'Stap toevoegen',
            remove_step: 'Stap verwijderen',
            data_categories_csv: 'Gegevenscategorieën (kommagescheiden)',
            estimated_duration: 'Geschatte duur',
            estimated_duration_label: 'Geschatte duur',
            evidence_description: 'Bewijsbeschrijving',
            no_playbooks: 'Geen draaiboeken gevonden.',
            playbook_count: 'Aantal draaiboeken',
            requires_evidence: 'Bewijs vereist',
            step_label: 'Staplabel',
            target_name: 'Doelnaam',
            target_type: 'Doeltype',
            action_type: 'Actietype',
            archive_error: 'Archivering mislukt.',
            confirm_archive: 'Weet u zeker dat u dit draaiboek wilt archiveren?',
            data_categories: 'Gegevenscategorieën',
            days: 'dagen',
            fetch_error: 'Draaiboeken konden niet worden opgehaald.',
            sla_days: 'SLA (dagen)',
            target_id: 'Doel-ID',
            template_class_heading: 'Sjabloonclassificatie',
            official: 'Officieel',
            internal: 'Intern',
            classification: 'Classificatie',
            official_note: 'Officieel: door de regelgeving verplichte sjablonen die zijn afgestemd op [[TOK_1]], [[TOK_0]] of sectorspecifieke vereisten.',
            internal_note: 'Intern: organisatiespecifieke procedures die niet zijn afgeleid van regelgevingssjablonen.',
            active_executions_heading: 'Actieve uitvoeringen',
            no_active_executions: 'Geen actieve uitvoeringen.',
            playbook_label: 'Draaiboek',
            ticket_id_label: 'Kaartje',
            progress_label: 'Voortgang',
            actions_label: 'Acties',
            view_steps_label: 'Stappen bekijken',
            execution_detail_title: 'Uitvoeringsdetail',
            playbook_missing: 'Draaiboek niet gevonden.',
            evidence_required_label: 'Bewijs vereist',
            upload_evidence_label: 'Bewijs uploaden',
            mark_complete_label: 'Markeren als voltooid',
            evidence_required_toast: 'Bewijs vereist voordat deze stap kan worden voltooid.',
            evidence_blocking_message: 'Voeg een bewijsbestand toe om door te gaan.',
            step_completed_toast: 'Stap voltooid.',
            executions_fetch_error: 'Uitvoeringen laden mislukt.',
            step_evidence_default_name: 'Bewijs voor uitvoeringsstap',
            attached_evidence_label: 'Bijgevoegde bewijzen',
        },
        approvals: {
            title: 'Goedkeuringsworkflows',
            new: 'Nieuwe goedkeuring',
            edit: 'Goedkeuring bewerken',
            request_type: 'Type verzoek',
            requester: 'Verzoeker',
            approve: 'Goedkeuren',
            reject: 'Afwijzen',
            justification: 'Rechtvaardiging',
            all_action_types: 'Alle actietypen',
            decided_by: 'Besloten door',
            no_approvals: 'Geen goedkeuringen gevonden.',
            approval_count: 'Aantal goedkeuringen',
            approval_notes_optional: 'Opmerkingen (optioneel)',
            approve_error: 'Goedkeuring mislukt.',
            approve_request: 'Verzoek goedkeuren',
            decision: 'Besluit',
            entity: 'Entiteit',
            fetch_error: 'Goedkeuringen konden niet worden opgehaald.',
            reject_error: 'Afwijzing mislukt.',
            reject_request: 'Verzoek afwijzen',
            rejection_notes_required: 'Reden voor afwijzing vereist',
            rejection_notes_required_msg: 'Geef een reden op voor de afwijzing.',
            requested_at: 'Aangevraagd op',
            multi_step_heading: 'Goedkeuringsworkflow in meerdere stappen',
            legal_review_note: 'Stap 1 — Juridische beoordeling: De juridisch adviseur beoordeelt het verzoek om naleving van de regelgeving.',
            dpo_review_note: 'Stap 2 — [[TOK_0]] Beoordeling: functionaris voor gegevensbescherming valideert de implicaties voor gegevensbescherming.',
            management_review_note: 'Stap 3 — Aftekening door het management: het senior management verleent definitieve autorisatie.',
            supporting_evidence_label: 'Ondersteunend bewijs (optioneel)',
            decision_evidence_name: 'Beslissingsbewijs',
        },
        evidence: {
            title: 'Governancebewijs',
            new: 'Nieuw bewijs',
            link_to: 'Koppelen aan',
            entity_id_placeholder: 'Entiteits-ID',
            file_path_placeholder: '/pad/naar/bestand',
            evidence_label: 'Bewijslabel',
            file_path: 'Bestandspad',
            source_mode_label: 'Bewijsbron',
            source_mode_file: 'Bestand uploaden',
            source_mode_url: 'Externe URL koppelen',
            attachment_label: 'Bijlage',
            item_count: 'Aantal items',
            link_button: 'Bewijs koppelen',
            confirm_delete: 'Weet u zeker dat u dit bewijs wilt verwijderen?',
            enter_entity_id: 'Entiteits-ID invoeren...',
            entity_id: 'Entiteits-ID',
            entity_type: 'Entiteitstype',
            expires: 'Verloopt',
            expires_at: 'Verloopt op',
            fetch_error: 'Bewijs kon niet worden opgehaald.',
            link_error: 'Bewijs kon niet worden gekoppeld.',
            no_evidence: 'Geen bewijs gevonden.',
            tags_csv: 'Tags (kommagescheiden)',
            uploaded: 'Geüpload',
            url: 'URL',
            framework_tag_heading: 'Framework-gelabeld bewijs',
            framework_tag_note: 'Elk bewijsrecord legt de raamwerkcode, actor en tijdstempel vast. Filter op raamwerk om auditrelevante records te isoleren.',
            framework_code: 'Kadercode',
            filter_by_framework: 'Filteren op raamwerkcode...',
            actor: 'Acteur',
        },
        certification: {
            not_applicable: 'Niet van toepassing',
            not_certified: 'Niet gecertificeerd',
            pending: 'In afwachting',
            certified: 'Gecertificeerd',
            revoked: 'Ingetrokken',
        },
        onboarding_pipeline: {
            title: 'Onboarding-pijplijn',
            new_workflow: 'Nieuwe onboarding-workflow',
            vendor_id: 'Leverancier-ID',
            stages: 'Fasen',
            current_stage: 'Huidige fase',
            advance: 'Fase doorvoeren',
            advance_success: 'Fase succesvol doorgevoerd',
            workflow_status: 'Workflowstatus',
            initiated: 'Gestart',
            in_progress: 'In uitvoering',
            completed: 'Voltooid',
            cancelled: 'Geannuleerd',
            no_workflows: 'Geen onboarding-workflows gevonden',
            stages_placeholder: 'Fase 1, Fase 2, Fase 3',
            assigned_to: 'Toegewezen aan',
            notes: 'Notities',
            pdpl_lifecycle_heading: '[[TOK_0]] Levenscyclus van leverancier: introductie',
            due_diligence_note: 'De due diligence-fase is verplicht voordat een verwerker onder [[TOK_0]] wordt toegelaten. Controleer de reikwijdte van de gegevensverwerking, de rechtsgrondslag en de beveiligingsmaatregelen.',
            contract_review_note: 'Contractbeoordeling moet DPA-clausules, gegevensbewaarlimieten en beperkingen voor subverwerkers bevestigen.',
            create_dpa_review_cta: 'DPA-beoordeling aanmaken',
            dpa_review_linked: 'DPA-beoordeling gekoppeld',
        },
        dpa_review: {
            title: 'DPA-beoordelingen',
            new_review: 'Nieuwe DPA-beoordeling',
            review_type: 'Beoordelingstype',
            findings: 'Bevindingen',
            outcome: 'Uitkomst',
            complete_review: 'Beoordeling voltooien',
            complete_success: 'Beoordeling succesvol voltooid',
            link_assessment: 'Beveiligingsbeoordeling koppelen',
            link_success: 'Beoordeling succesvol gekoppeld',
            assessment_id: 'Beoordelings-ID',
            combined_title: 'Gecombineerde beoordeling',
            no_reviews: 'Geen DPA-beoordelingen gevonden',
            telecom_disclosure_heading: 'Beheer van de openbaarmaking van telecom',
            disclosure_trigger_note: 'Door openbaarmaking veroorzaakte beoordelingen leggen gegevensuitwisselingsgebeurtenissen van telecomabonnees vast volgens de VN Telecomwet.',
            telecom_t2_note: 'Goedkeuring van het niveau TELECOM-T2 is vereist voordat abonneegegevens aan de autoriteiten worden bekendgemaakt.',
            quarterly_log_note: 'Gebruik het kwartaallogboek om alle openbaarmakingsgebeurtenissen te documenteren en een continu audittraject bij te houden.',
        },
        periodic_review: {
            title: 'Periodieke beoordelingen',
            new_review: 'Nieuwe periodieke beoordeling',
            review_type: 'Beoordelingstype',
            due_date: 'Vervaldatum',
            next_review: 'Volgende beoordelingsdatum',
            trigger_reassessment: 'Herbeoordeling starten',
            reassessment_reason: 'Reden voor herbeoordeling',
            reassessment_success: 'Herbeoordeling succesvol gestart',
            complete_success: 'Beoordeling succesvol voltooid',
            scheduled: 'Gepland',
            in_progress: 'In uitvoering',
            completed: 'Voltooid',
            overdue: 'Achterstallig',
            material_change: 'Wezenlijke wijziging',
            no_reviews: 'Geen periodieke beoordelingen gevonden',
            mark_complete: 'Markeren als voltooid',
            pdpl_periodic_heading: '[[TOK_0]] Levenscyclus van leverancier: periodieke beoordelingen',
            scheduled_review_note: 'Voor alle actieve verwerkers moeten ten minste jaarlijks periodieke beoordelingen worden gepland. Achterstallige beoordelingen activeren nalevingswaarschuwingen.',
            material_change_note: 'Materiële veranderingen in de gegevensverwerking vereisen een onmiddellijke herbeoordeling, ongeacht het schema.',
            overdue_badge: 'Achterstallig',
            overdue_aria: 'Achterstallige beoordeling',
            only_overdue_filter: 'Alleen achterstallig',
        },
        offboarding: {
            title: 'Leverancier-offboarding',
            initiate: 'Offboarding starten',
            initiate_success: 'Offboarding succesvol gestart',
            reason: 'Reden voor offboarding',
            data_return_required: 'Gegevensretour vereist',
            verify_data: 'Gegevensretour verifiëren',
            verify_success: 'Gegevensretour succesvol geverifieerd',
            sign_off: 'Aftekenen',
            sign_off_success: 'Offboarding succesvol afgetekend',
            status_initiated: 'Gestart',
            status_data_pending: 'Gegevensretour in afwachting',
            status_data_verified: 'Gegevensretour geverifieerd',
            status_completed: 'Voltooid',
            status_cancelled: 'Geannuleerd',
            task_id: 'Taak-ID',
            no_tasks: 'Geen offboarding-taken gevonden',
            evidence_id: 'Bewijs-ID',
            pdpl_offboarding_heading: '[[TOK_0]] Levenscyclus van leverancier: offboarding en verwijdering',
            deletion_capture_note: 'Offboarding moet de bevestiging van de gegevensverwijdering van de leverancier vastleggen. Controleer de gegevensretour voordat u aftekent.',
            evidence_attachment_note: 'Voeg verwijderingsbewijs toe (certificaten, screenshots, leveranciersbevestigingen) om het offboarding-record te voltooien.',
            verify_mode_label: 'Verificatiemethode',
            verify_mode_upload: 'Nieuw bestand uploaden',
            verify_mode_link: 'Bestaand bewijs koppelen',
            verify_mode_none: 'Geen data te retourneren',
            upload_data_return_evidence: 'Upload bewijs van datateruggave',
            no_data_justification_label: 'Rechtvaardiging',
            no_data_justification_placeholder: 'Leg uit waarom geen data hoeft te worden teruggegeven',
            no_data_justification_hint: 'Minimaal 20 tekens',
            upload_required_toast: 'Voeg een bestand toe om door te gaan',
            evidence_link_required_toast: 'Selecteer een bewijs om door te gaan',
            no_data_justification_required_toast: 'Geef een rechtvaardiging van minstens 20 tekens',
            data_return_evidence_name: 'Bewijs van datateruggave',
        },
        dpa_review_types: {
            initial: 'Initieel',
            annual: 'Jaarlijks',
            renewal: 'Verlenging',
            incident_triggered: 'Incidentgerelateerd',
        },
        periodic_review_types: {
            initial: 'Initieel',
            annual: 'Jaarlijks',
            renewal: 'Verlenging',
            incident_triggered: 'Incidentgetriggerd',
            material_change: 'Materiële wijziging',
            disclosure_triggered: 'Openbaarmakingsgetriggerd',
            quarterly_log: 'Kwartaalrapport',
        },
        dpa_review_statuses: {
            pending: 'In afwachting',
            in_progress: 'In behandeling',
            completed: 'Voltooid',
            cancelled: 'Geannuleerd',
        },
        onboarding_stage_names: {
            due_diligence: 'Due diligence',
            contract_review: 'Contractbeoordeling',
            security_assessment: 'Beveiligingsbeoordeling',
            data_mapping: 'Gegevensmapping',
            approval: 'Goedkeuring',
            integration: 'Integratie',
        },
        access_denied_title: 'Toegang geweigerd',
        access_denied: 'U heeft geen toestemming om deze pagina te bekijken. Neem contact op met uw beheerder.',
    },
    consent: {
        nav: {
            policies: 'Beleid',
            purposes: 'Doelcatalogus',
            workflows: 'Werkstromen',
            snapshots: 'CMP-snapshots',
            change_awareness: 'Wijzigingsbewustzijn',
            audit: 'Toestemmingsaudit',
        },
        gap_analysis: {
            nav_label: 'Gap-analyse',
            page_title: 'Analyse van toestemmingskloof',
            page_subtitle: 'Forseti toetst uw actieve toestemmingsdoeleinden aan de vereisten van het geïnstalleerde raamwerk ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) en brengt lacunes aan het licht met citatie + voorgestelde herstelmaatregelen.',
            framework_picker_label: 'Kaders',
            org_flags_label: 'Organisatiecontext',
            flag_withdrawal: 'Heeft een wereldwijd opnamemechanisme gedocumenteerd',
            flag_parental: 'Heeft ouderlijke toestemming voor proefpersonen onder de 16 jaar',
            flag_cross_border: 'Heeft grensoverschrijdende indiening geregistreerd',
            run_label: 'Voer een gap-analyse uit',
            running_label: 'Hardlopen…',
            requires_advisor_label: 'Vereist ai_advisor:chat-toestemming.',
            results_heading: 'Er zijn hiaten aan het licht gekomen ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            empty_label: 'Er zijn geen hiaten gedetecteerd voor de geselecteerde raamwerken.',
            remediation_label: 'Voorgestelde oplossing:',
            dismiss_label: 'Afwijzen als niet van toepassing',
            resolve_label: 'Oplossen',
            dismissed_label: 'Afgewezen omdat het niet van toepassing is',
            resolved_label: 'Opgelost',
        },
        import: {
            title: 'Toestemmingsworkflows importeren',
            nav_title: 'Bulkimport',
            description: 'Upload een CSV-bestand om toestemmingsworkflows in bulk te importeren.',
            select_file: 'CSV-bestand selecteren',
            file_help: 'CSV met kopteksten die overeenkomen met workflowvelden.',
            required_columns_help: 'Vereiste kolommen: Workflowtype, Betrokkene, Kanaal.',
            file_too_large: 'Bestand te groot. Maximale grootte is 2MB.',
            preview: 'Voorbeeld',
            columns_detected: 'Kolommen gedetecteerd: {count}',
            column_mapping: 'Kolomtoewijzing',
            import_button: 'Importeren',
            import_complete: 'Import voltooid',
            import_error: 'Import mislukt',
            result: 'Importresultaat',
            total: 'Totaal',
            imported: 'Geïmporteerd',
            skipped: 'Overgeslagen',
            failed: 'Mislukt',
            errors: 'Fouten',
            error_row: 'Rij',
            error_field: 'Veld',
            error_message: 'Bericht',
            history: 'Importgeschiedenis',
            no_history: 'Geen importgeschiedenis.',
            history_file: 'Bestandsnaam',
            history_date: 'Datum',
            create_profiles_label: 'Betrokkene-profielen aanmaken voor nieuwe subjecten',
            create_profiles_help: 'Imports zonder bijpassend profiel maken er automatisch een aan. Schakel uit om alleen workflows te importeren.',
            profiles_created: 'Profielen aangemaakt',
            profiles_matched: 'Profielen gematcht',
            subject_kind_help: 'Optionele kolommen: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Ongeldig e-mailadres in kolom subject_email.',
            error_subject_unknown_kind: 'Onbekende subject_kind-waarde. Verwacht: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key is vereist wanneer subject_kind=external_ref',
        },
        policies: {
            title: 'Toestemmingsbeleid',
            new: 'Nieuw beleid',
            edit: 'Beleid bewerken',
            name: 'Naam',
            version: 'Versie',
            policy_text: 'Beleidstekst',
            publish: 'Publiceren',
            versions: 'Versies',
            hide_versions: 'Versies verbergen',
            submit_for_review: 'Ter beoordeling indienen',
            suspend: 'Opschorten',
            retire: 'Buiten gebruik stellen',
            jurisdictions: 'Rechtsgebieden',
            jurisdictions_csv: 'Rechtsgebieden (kommagescheiden)',
            approval_mode: 'Goedkeuringsmodus',
            reviewer_ids: "Beoordelaars-ID's (kommagescheiden)",
            tags_csv: 'Tags (kommagescheiden)',
            effective_date: 'Ingangsdatum',
            review_date: 'Beoordelingsdatum',
            consent_model_statement: 'Toestemmingsmodelverklaring',
            consent_model_placeholder: 'Optionele toestemmingsmodelverklaring...',
            default_settings: 'Standaardinstellingen (JSON)',
            changes: 'Wijzigingen',
            fetch_error: 'Kon toestemmingsbeleid niet laden. Probeer het opnieuw.',
            save_error: 'Kon toestemmingsbeleid niet opslaan. Probeer het opnieuw.',
            submit_review_error: 'Kon beleid niet ter beoordeling indienen. Probeer het opnieuw.',
            activate_error: 'Kon beleid niet activeren. Probeer het opnieuw.',
            suspend_error: 'Kon beleid niet opschorten. Probeer het opnieuw.',
            retire_error: 'Kon beleid niet buiten gebruik stellen. Probeer het opnieuw.',
            submit_review_success: 'Beleid ter beoordeling ingediend.',
            activate_success: 'Beleid geactiveerd.',
            suspend_success: 'Beleid opgeschort.',
            retire_success: 'Beleid met pensioen.',
            versions_error: 'Kon beleidsversies niet laden. Probeer het opnieuw.',
            invalid_json: 'Ongeldige JSON in veld Standaardinstellingen. Probeer het opnieuw.',
            page_title: 'Toestemmingsbeleid',
            version_updated: 'Bijgewerkt',
            version_initial: 'Eerste versie',
            json_format: '[[TOK_0]]-indeling',
            sensitive: 'Gevoelig',
            flag_sensitive: 'Vlaggevoelig',
            flag_sensitive_title: 'Markeer beleid als gevoelig',
            require_enhanced_review: 'Uitgebreide beoordeling vereisen',
            enhanced_review_success: 'Verbeterde beoordelingsvereiste ingeschakeld.',
            select_categories: 'Selecteer de toepasselijke [[TOK_0]] categorieën van gevoelige gegevens uit artikel 2:',
            no_policies: 'Geen toestemmingsbeleid gevonden. Maak uw eerste beleid aan om te beginnen.',
            approval_success: 'Beleid goedgekeurd.',
            reviewers_label: 'Beoordelaars',
            enhanced_review_title: 'Uitgebreide beoordeling vereist',
            enhanced_review_badge: 'Uitgebreide beoordeling vereist',
            enhanced_review_status_pending: 'Beoordeling in behandeling',
            enhanced_review_status_approved: 'Beoordeling goedgekeurd',
            enhanced_review_status_rejected: 'Beoordeling afgewezen',
            enhanced_review_reviewed_by: 'Beoordeeld door',
            enhanced_review_notes: 'Beoordelingsnotities',
            enhanced_review_approve: 'Beoordeling goedkeuren',
            enhanced_review_reject: 'Beoordeling afwijzen',
            enhanced_review_notes_required: 'Beoordelingsnotities zijn verplicht',
            enhanced_review_approved: 'Uitgebreide beoordeling goedgekeurd',
            enhanced_review_rejected: 'Uitgebreide beoordeling afgewezen — beleid teruggezet naar concept',
            enhanced_review_reset_to_draft: 'Uitgebreide beoordeling afgewezen — beleid teruggezet naar concept',
            enhanced_review_reject_warning: 'Afwijzing zet dit beleid terug naar de Concept-status. De FG moet het opnieuw indienen voor beoordeling na het oplossen van de problemen.',
            submitted_modal_title: 'Ingediend voor uitgebreide beoordeling',
            submitted_modal_body: 'Dit beleid is ingediend. Een Juridische/Privacy-beoordelaar moet het goedkeuren voordat het geactiveerd kan worden.',
        },
        sensitive_categories: {
            health: 'Gezondheidsgegevens',
            biometric: 'Biometrische gegevens',
            political: 'Politieke opvattingen',
            ethnic: 'Etnische afkomst',
            genetic: 'Genetische gegevens',
            criminal: 'Strafblad',
        },
        purposes: {
            title: 'Doelcatalogus',
            new: 'Nieuw doel',
            edit: 'Doel bewerken',
            name: 'Naam',
            legal_basis: 'Rechtsgrond',
            retention_days: 'Bewaartermijn (dagen)',
            is_active: 'Actief',
            filter_by_category: 'Filteren op categorie',
            policy_ids: "Beleids-ID's (kommagescheiden)",
            ropa_activity_ids: "ROPA-activiteits-ID's (kommagescheiden)",
            policies: 'Beleid',
            deprecate: 'Afkeuren',
            fetch_error: 'Kon toestemmingsdoelen niet laden. Probeer het opnieuw.',
            save_error: 'Kon toestemmingsdoel niet opslaan. Probeer het opnieuw.',
            deprecate_error: 'Kon toestemmingsdoel niet afkeuren. Probeer het opnieuw.',
            page_title: 'Doel Catalogus',
            no_purposes: 'Geen toestemmingsdoelen gevonden. Maak uw eerste doel aan om te beginnen.',
            category_personal_data: 'Persoonlijke gegevens',
            category_sensitive_data: 'Gevoelige gegevens',
            category_health_data: 'Gezondheidsgegevens',
            category_financial_data: 'Financiële gegevens',
            category_biometric_data: 'Biometrische gegevens',
            category_children_data: 'Gegevens van kinderen',
            category_location_data: 'Locatiegegevens',
            category_communications_data: 'Communicatiegegevens',
            category_other: 'Anders',
        },
        workflows: {
            title: 'Toestemmingsworkflows',
            new: 'Nieuwe workflow',
            edit: 'Workflow bewerken',
            workflow_type: 'Type workflow',
            user_id: 'Gebruikers-ID',
            purpose_id: 'Doel-ID',
            purpose_ids_csv: 'Doel ID (comma-separated)',
            reason: 'Reden',
            process: 'Verwerken',
            data_subject_ref: 'Gegevens Onderwerp Referentie',
            data_subject: 'Gegevens Onderwerp',
            channel: 'Kanaal',
            policy_id: 'Beleid ID',
            scope: 'Bereik',
            legal_grounds: 'Juridisch Grounds',
            assessment: 'Beoordeling',
            select_outcome: 'Selecteren Resultaat',
            partially_approved: 'Partially Goedgekeurd',
            denied: 'Geweigerd',
            outcome_upheld: 'Bevestigd',
            outcome_pending: 'In afwachting',
            outcome_denied: 'Geweigerd',
            status_count: 'Statusaantal',
            channel_filter: 'Filteren op kanaal',
            add_action: '+ Actie',
            by_type: 'Per type',
            by_status: 'Per status',
            downstream_actions: 'Downstream Acties',
            downstream_actions_for: 'Downstream Acties voor {subject} ({type})',
            add_downstream_action: 'Toevoegen Downstream Actie',
            assigned_to: 'Toegewezen Naar',
            fetch_error: 'Kan niet fetch toestemming workflows. Probeer het opnieuw.',
            dashboard_error: 'Kan niet fetch workflow dashboard. Probeer het opnieuw.',
            save_error: 'Kan niet save toestemming workflow. Probeer het opnieuw.',
            status_update_error: 'Kan niet update workflow status. Probeer het opnieuw.',
            assessment_error: 'Kan niet update workflow beoordeling. Probeer het opnieuw.',
            add_action_error: 'Kan niet add workflow actie. Probeer het opnieuw.',
            update_action_error: 'Kan niet update workflow actie. Probeer het opnieuw.',
            type_refusal: 'Weigering',
            type_withdrawal: 'Intrekking',
            type_restriction: 'Beperking',
            type_objection: 'Bezwaar',
            status_received: 'Ontvangen',
            status_processing: 'Verwerking',
            status_under_assessment: 'Onder Beoordeling',
            status_implemented: 'Geïmplementeerd',
            evidence_button: 'Bewijs',
            evidence_modal_title: 'Bewijs van de workflow',
            no_evidence: 'Er is geen bewijs gekoppeld aan deze workflow.',
            upload_evidence_label: 'Upload bewijsmateriaal voor de workflow',
            completed_at: 'Voltooid op',
            effective_date: 'Ingangsdatum',
            page_title: 'Toestemmingsworkflows',
            no_workflows: 'Geen toestemmingsworkflows gevonden. Workflows worden aangemaakt wanneer betrokkenen hun rechten uitoefenen.',
            type_grant: 'Verlening',
            propagation_none: 'Geen',
            propagation_pending: 'In afwachting',
            propagation_pending_warning: 'Kan niet voltooien — intrekkingspropagatie is nog in afwachting',
            propagation_completed: 'Voltooid',
            propagation_partial: 'Gedeeltelijk',
            propagation_incomplete_error: 'Kan workflow niet voltooien terwijl intrekkingspropagatie nog in afwachting is',
            propagation_status: 'Propagatiestatus',
        },
        snapshots: {
            title: 'CMP-snapshots',
            new: 'Nieuwe snapshot',
            label: 'Kenmerk',
            snapshot_date: 'Snapshotdatum',
            purposes_count: 'Aantal doelen',
            compare: 'Vergelijken',
            snapshot_data: 'Snapshotgegevens (JSON)',
            select_left: 'Selecteren Left Snapshot',
            select_right: 'Selecteren Right Snapshot',
            comparison_results: 'Vergelijking Resultaten',
            field: 'Veld',
            left: 'Links',
            right: 'Rechts',
            close_comparison: 'Sluiten Vergelijking',
            trigger: 'Activeren',
            trigger_manual: 'Handmatig',
            trigger_policy_approval: 'Beleid Goedkeuring',
            cmp_version: 'CMP Versie',
            policy_version_id: 'Beleid Versie ID',
            banner_config: 'Banner Configuratie (JSON)',
            active_purposes: 'Actief Doelen (JSON)',
            active_legal_bases: 'Actief Juridisch Bases (JSON)',
            domain_scope: 'Domein Bereik',
            domain_scope_csv: 'Domein Bereik (comma-separated)',
            raw_config: 'Raw Configuratie (JSON)',
            checksum: 'Controlesom',
            created: 'Aangemaakt',
            fetch_error: 'Kan niet fetch CMP snapshots. Probeer het opnieuw.',
            save_error: 'Kan niet save CMP snapshot. Probeer het opnieuw.',
            compare_error: 'Kan niet compare snapshots. Probeer het opnieuw.',
            page_title: 'Toestemmingsmomentopnamen',
            json_format: '[[TOK_0]]-indeling',
            json_array_format: '[[TOK_0]] array-indeling',
            manual_snapshot_note: 'Alleen voor beheerders/ontwikkelaars. In normaal gebruik worden snapshots automatisch aangemaakt via de CMP-webhook of bij beleidsgoedkeuring. Plak de JSON geëxporteerd uit uw CMP-leverancier (bijv. OneTrust, Cookiebot).',
            banner_config_hint: 'Plak het bannerconfiguratieobject uit uw CMP-export.',
            active_purposes_hint: 'JSON-array van actieve doeleinden-objecten gekopieerd uit uw CMP-export.',
            active_legal_bases_hint: 'JSON-array van actieve rechtsgrondslagen-objecten gekopieerd uit uw CMP-export.',
            raw_config_hint: 'Volledige ruwe configuratie-JSON van uw CMP. Andere JSON-velden worden hieruit geëxtraheerd. Een SHA-256-controlesom wordt automatisch berekend.',
            changed_field: 'Gewijzigd veld: ',
            no_snapshots: 'Geen CMP-snapshots gevonden. Snapshots worden aangemaakt wanneer beleid wordt goedgekeurd of handmatig wordt geactiveerd.',
            detail_title: 'Snapshot-detail',
            view_snapshot_detail: 'Snapshot-detail bekijken',
            policy_version: 'Beleidsversie',
            removed: 'Voor',
            added: 'Na',
        },
        change_awareness: {
            title: 'Toestemmingswijzigingsbewustzijn',
            change_type: 'Type wijziging',
            entity_type: 'Entiteitstype',
            entity_id: 'Entiteits-ID',
            detected_at: 'Gedetecteerd op',
            acknowledge: 'Bevestigen',
            new_alert: 'Nieuw Waarschuwing',
            new_alert_form: 'Nieuw Wijzigen Awareness Waarschuwing',
            total_open: 'Totaal Open',
            by_severity: 'By Ernst',
            snapshot_id: 'Snapshot-ID',
            update_status: 'Bijwerken Status',
            resolution_notes: 'Oplossing Opmerkingen',
            resolution_required: 'Oplossing Opmerkingen (required)',
            resolution_required_msg: 'Oplossing opmerkingen are required when resolving een item.',
            status_open: 'Geopend',
            status_under_review: 'Onder Beoordelen',
            status_resolved: 'Opgelost',
            status_accepted: 'Geaccepteerd',
            severity_informational: 'Informatief',
            severity_requires_review: 'Requires Beoordelen',
            severity_policy_violation: 'Beleid Violation',
            create_reconciliation: 'Afstemmingstaak maken',
            reconciliation_created: 'Afstemmingstaak is succesvol aangemaakt.',
            reconciliation_error: 'Kan afstemmingstaak niet maken. Probeer het opnieuw.',
            fetch_error: 'Kan niet fetch change awareness items. Probeer het opnieuw.',
            dashboard_error: 'Kan niet fetch change awareness dashboard. Probeer het opnieuw.',
            create_error: 'Kan niet create change awareness item. Probeer het opnieuw.',
            status_update_error: 'Kan niet update change awareness status. Probeer het opnieuw.',
            page_title: 'Verander bewustzijn',
            no_items: 'Geen wijzigingsbewustzijnsitems gevonden. Items worden aangemaakt wanneer wijzigingen in de toestemmingsconfiguratie worden gedetecteerd.',
        },
        audit: {
            title: 'Toestemmingsauditlogboek',
            event_type: 'Type gebeurtenis',
            user_id: 'Gebruikers-ID',
            timestamp: 'Tijdstempel',
            details: 'Bijzonderheden',
            actor: 'Betrokkene',
            filter_by_entity_type: 'Filteren op entity type',
            filter_by_action: 'Filteren op actie',
            fetch_error: 'Kan niet fetch toestemming audit trail. Probeer het opnieuw.',
            page_title: 'Toestemmingscontrole',
            export_csv: 'Exporteer [[TOK_0]]',
            exporting: 'Exporteren…',
            export_success: 'Audittrail succesvol geëxporteerd.',
            export_error: 'Kan toestemmingscontroletraject niet exporteren. Probeer het opnieuw.',
            no_entries: 'Geen auditgegevens gevonden. Auditgebeurtenissen worden automatisch vastgelegd wanneer toestemmingsgegevens wijzigen.',
            entity_policy: 'Beleid',
            entity_purpose: 'Doel',
            entity_workflow: 'Werkstroom',
            entity_consent_record: 'Toestemmingsregistratie',
            entity_change_awareness: 'Wijzigingsbewustzijn',
            entity_cmp_snapshot: 'CMP-momentopname',
            action_created: 'Aangemaakt',
            action_updated: 'Bijgewerkt',
            action_status_changed: 'Status gewijzigd',
            action_drift_detected: 'Afwijking gedetecteerd',
            action_snapshot_created: 'Momentopname aangemaakt',
            action_approval_submitted: 'Goedkeuring ingediend',
            action_archived: 'Gearchiveerd',
            action_purpose_auto_mapped: 'Doel automatisch toegewezen',
            action_purpose_mapping_updated: 'Doeltoewijzing bijgewerkt',
            action_webhook_configured: 'Webhook geconfigureerd',
            entity_propagation: 'Voortplanting',
            entity_reconciliation: 'Verzoening',
            action_propagation_confirmed: 'Voortplanting bevestigd',
            action_propagation_failed: 'Voortplanting mislukt',
            action_consent_captured: 'Toestemming vastgelegd',
            action_reconciliation_created: 'Verzoening gecreëerd',
            action_reconciliation_resolved: 'Verzoening opgelost',
            action_submitted_for_review: 'Ingediend ter beoordeling',
            action_activated: 'Geactiveerd',
            action_suspended: 'Opgeschort',
            action_retired: 'Buiten gebruik gesteld',
            action_enhanced_review_required: 'Uitgebreide beoordeling vereist',
            action_enhanced_review_approved: 'Uitgebreide beoordeling goedgekeurd',
            action_enhanced_review_rejected: 'Uitgebreide beoordeling afgewezen — beleid teruggezet naar concept',
            action_consented: 'Toegestemd',
            action_consented_customize: 'Toestemming op maat',
            action_revoked: 'Ingetrokken',
            action_rejected: 'Afgewezen',
        },
        web_records: {
            title: 'Webtoestemmingsrecords',
            page_title: 'Webtoestemmingsrecords',
            domain: 'Domein',
            visitor_id: 'Bezoekers-ID',
            consent_action: 'Toestemmingsactie',
            received_at: 'Ontvangen bij',
            admin_status: 'Beheerdersstatus',
            revoke: 'Intrekken',
            reject: 'Afwijzen',
            reason: 'Reden',
            reason_placeholder: 'Reden voor deze actie (optioneel)',
            revoke_confirm: 'Deze toestemmingsregistratie intrekken?',
            reject_confirm: 'Deze toestemmingsregistratie afwijzen?',
            override_success: 'Recordstatus is succesvol bijgewerkt.',
            override_error: 'Kan de recordstatus niet bijwerken.',
            no_records: 'Er zijn geen webtoestemmingsrecords gevonden.',
            fetch_error: 'Kan webtoestemmingsrecords niet laden.',
            filter_by_domain: 'Filter op domein',
            filter_by_action: 'Filter op actie',
            active: 'Actief',
        },
        legal_bases: {
            all: 'Alle Juridisch Bases',
            consent: 'Toestemming',
            legitimate_interest: 'Legitimate Belang',
            contract: 'Overeenkomst',
            legal_obligation: 'Juridisch Obligation',
            vital_interest: 'Vitaal Belang',
            public_interest: 'Openbaar Belang',
        },
        common_statuses: {
            suspended: 'Opgeschort',
            retired: 'Uitgefaseerd',
            deprecated: 'Afgeschreven',
        },
        approval_modes: {
            all: 'All',
            any: 'Any',
        },
        cmp_integration: {
            title: 'AesirX CMP Integratie',
            back_to_consent: 'Back naar Toestemming',
            back_to_integration: 'Back naar Integratie',
            webhook_status: 'Webhook-status',
            events_received: 'Gebeurtenissen Ontvangen',
            web_consent_records: 'Web Toestemming Records',
            unmapped_purposes: 'Niet toegewezen Doelen',
            integration_management: 'Integratie Beheer',
            webhook_configuration: 'Webhook Configuratie',
            webhook_config_desc: 'Configureren de CMP webhook endpoint en manage de HMAC secret.',
            purpose_mapping: 'Doel Toewijzing',
            purpose_mapping_desc: 'Toewijzen CMP purpose identifiers naar GRC toestemming catalog purposes.',
            bulk_sync: 'Bulk Synchronisatie',
            bulk_sync_desc: 'Doeltoewijzingen opnieuw toepassen op alle niet-toegewezen toestemmingsrecords.',
            consent_analytics: 'Web Toestemming Analytics (Last 30 Days)',
            consent_grant_rate: 'Toestemming Grant Tarief',
            top_domain: 'Top Domein',
            records: 'records',
            banner_interactions: 'Banner-interacties',
            consent_actions: 'Toestemmingsacties',
            opt_in_trend: 'Toestemming/Afmelding-trend',
            records_by_domain: 'Records per domein',
            date: 'Datum',
            grants: 'Toestemmingen',
            denials: 'Weigeringen',
            not_configured: 'Niet Configured',
            load_error: 'Kan niet load integratie gegevens',
            webhook_not_configured: 'Webhook niet geconfigureerd.',
            webhook_not_configured_msg: 'Gelieve {link} first.',
            configure_webhook_link: 'configureren de webhook',
            setup_wizard: 'Instellen Wizard',
            step_configure_webhook: 'Configureren Webhook',
            step_map_purposes: 'Toewijzen Doelen',
            step_run_sync: 'Uitvoeren Initieel Bulk Synchronisatie',
            step_verify_data: 'Verifiëren Gegevens in Dashboard',
            configure: 'Configureren',
            view_dashboard: 'Bekijken Dashboard',
            syncing: 'Synchroniseren...',
            sync_now: 'Synchronisatie Now',
            sync_completed: 'Synchronisatie completed: {imported} imported, {skipped} skipped, {failed} mislukt.',
            sync_failed: 'Synchronisatie mislukt',
            last_sync_result: 'Laatste Synchronisatie Result',
            imported: 'Geïmporteerd',
            skipped: 'Overgeslagen',
            errors: 'Fouten',
            index: 'Overzicht',
            error: 'Fout',
            sync_history: 'Synchronisatie Geschiedenis',
            no_sync_jobs: 'No synchronisatie jobs recorded yet.',
            load_sync_error: 'Kan niet load synchronisatie gegevens',
            purpose_mapping_title: 'CMP Doel Toewijzing',
            auto_mapping: 'Automatisch toewijzen...',
            auto_map_purposes: 'Auto-Map Doelen',
            unmapped_warning: '[[TOK_1]] niet-toegewezen doel(en) -- deze [[TOK_2]] doeleinden moeten worden toegewezen aan GRC-doeleinden.',
            mapping_saved: 'Toewijzing saved.',
            mapping_deleted: 'Toewijzing deleted.',
            auto_map_complete: 'Auto-map voltooid: {mapped} mapped, {unmatched} unmatched.',
            auto_map_failed: 'Auto-map mislukt',
            save_mapping_error: 'Kan niet save toewijzing',
            delete_mapping_error: 'Kan niet delete toewijzing',
            load_data_error: 'Kan niet load gegevens',
            cmp_purpose: 'CMP Doel',
            grc_purpose: 'GRC Doel',
            select_grc_purpose: '-- Selecteren GRC Doel --',
            auto_mapped: 'Automatisch toegewezen',
            mapped: 'Toegewezen',
            unmapped: 'Niet toegewezen',
            no_mappings: 'Geen doeltoewijzingen gevonden. Toewijzingen worden automatisch aangemaakt wanneer toestemmingsgebeurtenissen worden ontvangen.',
            total_mappings: 'Totaal: {count} mapping(s)',
            webhook_config_title: 'Webhook Configuratie',
            current_configuration: 'Huidig Configuratie',
            setup_webhook: 'Instellen Webhook',
            setup_webhook_desc: 'Configureren de AesirX CMP webhook naar receive toestemming gebeurtenissen.',
            allowed_domains: 'Toegestaan Domeinen (one per line)',
            webhook_secret_warning: 'Webhook Geheim (save dit now -- it will not be shown again):',
            last_event: 'Laatste Gebeurtenis',
            none_received: 'Geen',
            update_domains: 'Bijwerken Domeinen',
            pause_webhook: 'Pauzeren Webhook',
            resume_webhook: 'Hervatten Webhook',
            regenerate_secret: 'Regenerate Geheim',
            configuring: 'Configureren...',
            create_webhook_config: 'Aanmaken Webhook Configuratie',
            webhook_endpoint: 'Webhook Eindpunt',
            webhook_endpoint_desc: 'Configureren your AesirX CMP naar send toestemming gebeurtenissen naar:',
            webhook_signature_note: 'Opnemen de HMAC-SHA256 signature in de {header} header.',
            configured_success: 'Webhook succesvol geconfigureerd.',
            config_updated: 'Configuratie updated.',
            config_error: 'Kan niet configureren webhook',
            update_error: 'Kan niet update configuratie',
            toggle_error: 'Kan niet toggle webhook',
            deactivated: 'Webhook gedeactiveerd.',
            deactivate_error: 'Kan niet deactivate webhook',
            page_title: '[[TOK_0]] Integratie',
            webhook_config_page_title: '[[TOK_0]] Webhook-configuratie',
            bulk_sync_page_title: 'Records opnieuw in kaart brengen',
            purpose_mapping_page_title: 'Doel in kaart brengen',
            data_loaded: '[[TOK_0]] integratiegegevens geladen',
            sync_all: 'Alles synchroniseren',
            sync_selected: 'Geselecteerde synchroniseren',
            sync_status: 'Synchronisatiestatus',
            last_sync: 'Laatste synchronisatie',
            no_records: 'Geen records gevonden.',
            sync_in_progress: 'Synchronisatie bezig...',
            sync_complete: 'Synchronisatie voltooid.',
            sync_error: 'Synchronisatie mislukt. Probeer het opnieuw.',
            map_purpose: 'Doel toewijzen',
            unmap: 'Toewijzing opheffen',
            mapping_status: 'Toewijzingsstatus',
            save_mapping: 'Toewijzing opslaan',
            remap_unmapped_records: 'Breng niet-toegewezen records opnieuw in kaart',
            remap_records: 'Records opnieuw in kaart brengen',
            add_mappings_first: 'Voeg eerst doeltoewijzingen toe (stap 2)',
            remap_result: 'Resultaat opnieuw in kaart brengen',
            remap_result_desc: 'Alle toestemmingsrecords verwerkt met niet-toegewezen of gedeeltelijk toegewezen doeleinden.',
            total_processed: 'Totaal verwerkt',
            newly_mapped: 'Nieuw in kaart gebracht',
            still_unmapped_label: 'Nog steeds niet in kaart gebracht',
            still_unmapped_msg: '[[TOK_2]] record(s) hebben nog steeds niet-toegewezen doeleinden. [[TOK_3]] en klik vervolgens opnieuw op Opnieuw toewijzen.',
            add_more_mappings: 'Voeg meer toewijzingen toe',
            remap_complete: 'Opnieuw toewijzen voltooid: [[TOK_2]] opnieuw in kaart gebracht, [[TOK_3]] nog steeds niet in kaart gebracht.',
            add_mapping: 'Voeg toewijzing toe',
            cmp_purpose_id_label: '[[TOK_0]] Doel-ID *',
            cmp_purpose_id_required: '[[TOK_0]] Doel-ID is vereist',
            cmp_purpose_name_label: '[[TOK_0]] Doelnaam',
            grc_purpose_label: 'GRC-doel',
        },
        propagation: {
            title: 'Intrekkingsverspreiding',
            systems: 'Gekoppelde systemen',
            status: 'Status',
            confirmed: 'Bevestigd',
            pending: 'In afwachting',
            failed: 'Mislukt',
            confirm: 'Intrekking bevestigen',
            fail: 'Markeren als mislukt',
            failure_reason: 'Reden van mislukking',
            can_close: 'Alle systemen bevestigd — workflow kan worden gesloten',
            cannot_close: 'Wachten op systeembevestigingen',
            no_tasks: 'Geen verspreidingstaken.',
            confirm_success: 'Systeemintrekking bevestigd.',
            fail_success: 'Systeem gemarkeerd als mislukt.',
            propagate_success: 'Intrekking verspreid naar gekoppelde systemen.',
            propagate: 'Verspreiden naar systemen',
            add_system: 'Systeem toevoegen',
            remove_system: 'Verwijderen',
            system_id: 'Systeem-ID',
            system_name: 'Systeemnaam',
            owner_id: 'Eigenaar-ID',
            propagate_error: 'Het is niet gelukt om de intrekking door te geven. Probeer het opnieuw.',
            no_systems: 'Voeg ten minste één systeem toe.',
            page_title: 'Intrekking propagatie',
            workflow_id: 'Selecteer Opnameworkflow',
            system_id_hint: 'bijv. crm-001, erp-prod',
            owner_id_hint: 'Systeemeigenaar',
            elapsed: 'Verstreken',
        },
        sensitive: {
            title: 'Beleid voor gevoelige gegevens',
            flag: 'Markeren als gevoelig',
            categories: 'Gevoelige categorieën',
            enhanced_review: 'Uitgebreide beoordeling vereisen',
            enhanced_review_success: 'Uitgebreide beoordeling vereist.',
            flag_success: 'Beleid gemarkeerd als gevoelig.',
            no_sensitive: 'Geen beleid voor gevoelige gegevens.',
        },
        reconciliation: {
            title: 'Afwijkingsafstemming',
            create: 'Nieuwe afstemmingstaak',
            system: 'Systeem',
            owner: 'Eigenaar',
            description: 'Beschrijving',
            resolution: 'Oplossing',
            resolve: 'Oplossen',
            update_grc: 'GRC bijwerken',
            update_cmp: 'CMP bijwerken',
            accept_difference: 'Verschil accepteren',
            escalate: 'Escaleren',
            resolution_notes: 'Oplossingsnotities',
            no_tasks: 'Geen afstemmingstaken.',
            resolve_success: 'Afstemmingstaak opgelost.',
            create_success: 'Afstemmingstaak aangemaakt.',
            open: 'Openen',
            resolved: 'Opgelost',
            escalated: 'Geëscaleerd',
            dashboard_open: 'Open taken',
            dashboard_resolved: 'Opgeloste taken',
            dashboard_escalated: 'Geëscaleerde taken',
            page_title: 'Mismatch-verzoening',
            my_tasks: 'Mijn taken',
            all_tasks: 'Alle taken',
            severity: 'Ernst',
        },
        sync: {
            title: 'CMP-synchronisatie',
            direction: 'Richting',
            cmp_to_grc: '[[TOK_0]] → GRC',
            grc_to_cmp: 'GRC → [[TOK_0]]',
            conflict: 'Conflicten',
            resolve_conflict: 'Conflict oplossen',
            no_events: 'Geen synchronisatiegebeurtenissen.',
            resolve_success: 'Synchronisatieconflict opgelost.',
            create_success: 'Synchronisatiegebeurtenis geregistreerd.',
            page_title: '[[TOK_0]] Synchroniseren',
            detect_drift: 'Conflicten detecteren',
            detecting: 'Detecteren...',
            drift_result: '[[TOK_2]] conflict(en) gedetecteerd uit [[TOK_3]] vergeleken doel(en).',
            no_drift: 'Geen nieuwe conflicten gedetecteerd.',
            drift_error: 'Kan conflictdetectie niet uitvoeren.',
            resolve_modal_title: 'Conflicten oplossen',
            resolve_field: 'Veld',
            resolve_grc_value: 'GRC-waarde',
            resolve_cmp_value: '[[TOK_0]] Waarde',
            accept_cmp: 'Accepteer [[TOK_0]] waarde',
            accept_cmp_desc: 'Update GRC zodat deze overeenkomt met de [[TOK_0]]: de waarde [[TOK_1]] wordt de nieuwe GRC-waarde.',
            keep_grc: 'GRC-waarde behouden',
            keep_grc_desc: 'Sluit dit conflict zonder GRC te wijzigen. Breng de eigenaar van [[TOK_0]] op de hoogte om uit te lijnen.',
            resolve_applied: 'Conflict opgelost. GRC-doel bijgewerkt zodat het overeenkomt met [[TOK_0]].',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Dit gereedheidsrapport is adviserend. Het keurt het dossier niet goed en stelt het niet samen, materialiseert het niet, dient het niet in en verzendt het niet.',
            run_label: 'Voer pre-flight uit',
            running: 'Pre-flight uitvoeren…',
            assemble_label: 'Pakket voor automatische montage',
            assembling: 'Monteren…',
            verdict_label: 'Oordeel vóór de vlucht',
            tokens_label: '≈ [[TOK_1]] tokens',
            remediation_label: 'Sanering',
            no_gaps: 'Er zijn geen gaten vóór de vlucht gedetecteerd. De vijl is klaar om te monteren.',
            override_label: 'Negeer het blokoordeel: de montage krijgt een audit-stempel.',
            accept_label: 'Rapport accepteren',
            reject_label: 'Rapport afwijzen',
            assembled_label: 'Inzendingspakket samengesteld',
            package_id_label: 'Pakket-ID',
            package_filename_label: 'Bestandsnaam',
            package_hash_label: 'Verpak hasj',
            evidence_count_label: '[[TOK_1]] bewijsmateriaal gebundeld',
            error_generic: 'Kon de pre-flight niet uitvoeren of het pakket in elkaar zetten. Probeer het opnieuw of controleer de archiveringsstatus.',
        },
        errors: {
            fetch: 'Kan niet load assessments..',
            save: 'Kan niet save beoordeling..',
            fetch_gap_report_failed: 'Kan niet fetch hiaat report..',
            fetch_transfers_failed: 'Kan niet fetch overdrachten..',
            save_transfer_failed: 'Kan niet save overdracht..',
            submit_review_failed: 'Kan niet submit voor beoordeling..',
            process_decision_failed: 'Kan niet process beslissing..',
            deprecate_failed: 'Kan niet deprecate..',
            evaluate_risk_failed: 'Kan niet evaluate risico..',
            fetch_safeguards_failed: 'Kan niet fetch waarborgen..',
            save_safeguard_failed: 'Kan niet save waarborg..',
            update_safeguard_status_failed: 'Kan niet update waarborg status..',
        },
        nav: {
            dpias: "GEB's",
            transfers: 'Doorgiftebeoordelingen',
            dashboard: 'Overzicht',
            gap_report: 'Lacunerapport',
        },
        risk_level_critical: 'Kritiek risico',
        risk_level_high: 'Hoog risico',
        risk_level_medium: 'Gemiddeld risico',
        risk_level_low: 'Laag risico',
        severity_critical: 'Kritieke ernst',
        severity_high: 'Hoge ernst',
        severity_medium: 'Gemiddelde ernst',
        severity_low: 'Lage ernst',
        overdue: 'Achterstallig',
        framework_filter_label: 'Kader',
        aria_filter_by_framework: 'Filter op raamwerk',
        dashboard: {
            title: 'Beoordelingsoverzicht',
            page_title: 'Beoordelingsdashboard',
            announce_loaded: 'Beoordelingsdashboard geladen',
            announce_chart_view: 'Grafiekweergave tonen',
            announce_table_view: 'Gegevenstabelweergave tonen',
            aria_metrics_table: 'Beoordelingsdashboard-statistieken',
            metric_col: 'Metriek',
            value_col: 'Waarde',
            dpia_prefix: 'DPIA',
            transfer_prefix: 'Overdracht',
            risk_prefix: 'Risico',
            aria_dpias_by_status: 'DPIAs op status',
            aria_transfers_by_status: 'Overdrachten op status',
            aria_top_risks: 'Toprisicos',
            aria_top_risks_table: 'Toprisicos over DPIAs',
            overdue_dpias_attention: '{count} achterstallige DPIA-beoordelingen vereisen aandacht',
            no_overdue_dpias: 'Geen achterstallige DPIA-beoordelingen',
            overdue_transfers_attention: '{count} achterstallige overdrachtsbeoordelingen vereisen aandacht',
            no_overdue_transfers: 'Geen achterstallige overdrachtsbeoordelingen',
            dpias_overview: 'GEB-overzicht',
            transfers_overview: 'Overzicht doorgiftebeoordelingen',
            overdue_items: 'Achterstallige items',
            overdue_dpias: 'Achterstallige GEB-beoordelingen',
            overdue_transfers: 'Achterstallige doorgiftebeoordelingen',
            count: 'Aantal',
            no_data: 'No gegevens available.',
            no_risks: "Geen risico's gevonden.",
            no_dashboard_data: 'No dashboard gegevens available.',
            fetch_error: 'Kan niet fetch dashboard gegevens. Probeer het opnieuw.',
        },
        dpias: {
            page_title: "DPIA's",
            announce_submitted_for_review: 'DPIA ingediend ter beoordeling',
            announce_deprecated: 'DPIA verouderd',
            announce_risks_loaded: '{count} risico(s) geladen',
            announce_mitigations_loaded: '{count} maatregel(en) geladen',
            announce_risk_deleted: 'Risico verwijderd',
            announce_mitigation_status_updated: 'Maatregelstatus bijgewerkt',
            aria_filter: 'DPIAs filteren',
            aria_filter_by_status: 'Filteren op status',
            aria_filter_by_lead: 'Filteren op beoordelingsleider',
            aria_table: 'Gegevensbeschermingseffectbeoordelingen',
            announce_found: '{count} DPIAs gevonden',
            announce_decision: '[[TOK_2]] [[TOK_1]]',
            mitigation_start: 'Starten',
            mitigation_mark_implemented: 'Markeren als geïmplementeerd',
            mitigation_verify: 'Verifiëren',
            title: 'Gegevensbeschermingseffectbeoordelingen',
            new: 'Nieuwe GEB',
            edit: 'GEB bewerken',
            dpia_title: 'Titel',
            activity: 'Activiteit',
            risk_score: 'Risicoscore',
            risks: "Risico's",
            mitigations: 'Maatregelen',
            add_risk: 'Risico toevoegen',
            add_mitigation: 'Maatregel toevoegen',
            necessity: 'Noodzakelijkheid / Evenredigheid',
            likelihood: 'Waarschijnlijkheid',
            impact: 'Impact',
            severity_label: 'Ernst',
            purpose: 'Doel',
            consultation_notes: 'Consultatie Opmerkingen',
            dpo_opinion: 'DPO-advies',
            processing_activity_ids: "Verwerking Activiteit ID's (comma-separated)",
            system_ids: "Systeem ID's (comma-separated)",
            vendor_ids: "Leverancier ID's (comma-separated)",
            data_types: 'Gegevens Types (comma-separated)',
            data_types_short: 'Gegevens Types',
            data_subjects: 'Gegevens Subjects (comma-separated)',
            assessment_lead_id: 'Beoordeling Leider ID',
            assessment_lead: 'Beoordeling Leider',
            dpo_id: 'FG-ID',
            reviewer_ids: "Beoordelaar ID's (comma-separated)",
            approval_mode: 'Goedkeuring Modus',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'DPO-goedkeuring vereist',
            review_date: 'Beoordelen Datum',
            submit_for_review: 'Indienen voor Beoordelen',
            approve_reject: 'Goedkeuren/Afwijzen',
            deprecate: 'Afschrijven',
            deprecated: 'Afgeschreven',
            hide_risks: "Verbergen Risico's",
            hide_mitigations: 'Verbergen Maatregelen',
            comments: 'Opmerkingen',
            submit_decision: 'Indienen Beslissing',
            category_label: 'Categorie',
            category_data_breach: 'Gegevens Inbreuk',
            category_unauthorized_access: 'Ongeautoriseerd Toegang',
            category_function_creep: 'Functie Creep',
            category_re_identification: 'Her-identificatie',
            category_discrimination: 'Discriminatie',
            category_surveillance: 'Bewaking',
            category_other: 'Overig',
            affected_rights: 'Getroffen rechten (kommagescheiden)',
            no_risks: "Geen risico's gevonden.",
            no_mitigations: 'Geen maatregelen gevonden.',
            no_dpias: 'Geen DPIAs gevonden.',
            mitigation_type: 'Soort',
            mitigation_technical: 'Technisch',
            mitigation_organizational: 'Organisatorisch',
            mitigation_contractual: 'Contractueel',
            risk_ids: "Risico ID's (comma-separated)",
            responsible_party: 'Verantwoordelijk Party',
            responsible_party_placeholder: 'Of voer naam handmatig in',
            affected_rights_placeholder: 'Geselecteerde rechten verschijnen hier',
            affected_rights_freetext_placeholder: 'Voer getroffen rechten in (kommagescheiden)',
            responsible: 'Verantwoordelijk',
            target_date: 'Doel Datum',
            created: 'Aangemaakt',
            fetch_error: 'Kan niet fetch DPIAs. Probeer het opnieuw.',
            save_error: 'Kan niet save DPIA. Probeer het opnieuw.',
            submit_review_error: 'Kan niet submit DPIA voor beoordeling. Probeer het opnieuw.',
            decision_error: 'Kan niet process beslissing. Probeer het opnieuw.',
            deprecate_error: 'Kan niet deprecate DPIA. Probeer het opnieuw.',
            fetch_risks_error: "Kan niet fetch risico's. Probeer het opnieuw.",
            save_risk_error: 'Kan niet save risico. Probeer het opnieuw.',
            delete_risk_error: 'Kan niet delete risico. Probeer het opnieuw.',
            fetch_mitigations_error: 'Kan niet fetch maatregelen. Probeer het opnieuw.',
            save_mitigation_error: 'Kan niet save maatregel. Probeer het opnieuw.',
            update_mitigation_status_error: 'Kan de maatregelstatus niet bijwerken. Probeer het opnieuw.',
            link_form_template: 'Link regelgevingsformuliersjabloon',
            link_form_template_placeholder: 'Selecteer een [[TOK_0]] formuliersjabloon (optioneel)',
            link_form_template_none: 'Geen',
            linked_form: 'Gekoppeld formulier',
            linked_form_creating: 'Gekoppeld formulier maken...',
            linked_form_error: 'Kan gekoppeld formulierexemplaar niet maken. De [[TOK_0]] is gemaakt zonder gekoppeld formulier.',
            view_linked_form: 'Bekijk formulier',
            announce_created_with_form: '[[TOK_0]] gemaakt met gekoppelde formulierinstantie',
            creation_mode: '[[TOK_0]] Creatiemodus',
            mode_standard: 'Standaard [[TOK_0]]',
            mode_template: 'Gebruik een sjabloon voor regelgevingsformulieren',
            select_form_template: 'Selecteer Formuliersjabloon',
            create_and_fill_form: 'Formulier maken en invullen',
            template_sections_title: 'Sjabloonsecties',
            field_singular: 'veld',
            field_plural: 'velden',
            no_sections: 'Er zijn geen secties gevonden in deze sjabloon.',
            template_mode_hint: 'Na het aanmaken wordt u doorgestuurd om het volledige regelgevingsformulier in te vullen.',
            linked_dossier_filings: 'Gekoppelde dossierindieingen',
            no_linked_dossier_filings: 'Geen dossierindieingen gekoppeld aan deze DPIA.',
            view_dossier_filing: 'Indiening bekijken',
            hide_dossier_filings: 'Dossierindieingen verbergen',
            supporting_evidence: 'Ondersteunend bewijs',
            hide_supporting_evidence: 'Bewijs verbergen',
            no_supporting_evidence: 'Geen ondersteunend bewijsmateriaal bijgevoegd.',
            upload_supporting_evidence: 'Upload ondersteunend bewijsmateriaal',
            view_form_responses: 'Formulierreacties bekijken',
            regulatory_framework: 'Regelgevend kader',
            all_frameworks: 'Alle kaders',
            no_templates_for_market: 'Geen sjablonen beschikbaar voor de geselecteerde markt. Selecteer een andere markt of maak een sjabloon aan.',
        },
        transfers: {
            page_title: 'Gegevensoverdrachten',
            announce_found: '{count} overdrachtsbeoordelingen gevonden',
            announce_submitted_for_review: 'Overdracht ingediend ter beoordeling',
            announce_deprecated: 'Overdracht verouderd',
            announce_decision: 'Overdracht {decision}',
            announce_risk_eval_completed: 'Risicobeoordeling voltooid',
            announce_safeguard_status_updated: 'Beschermingsstatus bijgewerkt',
            announce_safeguards_loaded: '{count} beschermingsmaatregel(en) geladen',
            aria_filter: 'Overdrachtsbeoordelingen filteren',
            aria_filter_by_status: 'Filteren op status',
            aria_filter_by_mechanism: 'Filteren op overdrachtsmechanisme',
            aria_table: 'Gegevensoverdrachtsbeoordelingen',
            title: 'Grensoverschrijdende doorgiftebeoordelingen',
            new: 'Nieuwe doorgifte',
            edit: 'Doorgifte bewerken',
            name: 'Naam',
            from_country: 'Van land',
            to_country: 'Naar land',
            safeguards: 'Waarborgen',
            risk_level: 'Risiconiveau',
            assessment_notes: 'Beoordelingsnotities',
            mechanism: 'Mechanisme',
            transfer_mechanism: 'Overdracht Mechanisme',
            transfer_mechanism_detail: 'Overdracht Mechanisme Detail',
            all_mechanisms: 'Alle Mechanisms',
            mechanism_adequacy_decision: 'Adequaatheid Beslissing',
            mechanism_sccs: 'Modelcontractbepalingen',
            mechanism_bcrs: 'Bindende bedrijfsregels',
            mechanism_consent: 'Toestemming',
            mechanism_derogation: 'Afwijking',
            mechanism_other: 'Overig',
            data_types: 'Gegevens Types (comma-separated)',
            data_subjects: 'Gegevens Subjects (comma-separated)',
            purpose: 'Doel',
            recipient_name: 'Ontvanger Naam',
            create_success: 'Overdrachtsbeoordeling aangemaakt.',
            update_success: 'Overdrachtsbeoordeling bijgewerkt.',
            recipient_details: 'Ontvangergegevens',
            recipient_details_placeholder: 'Rol, locatie en systemen van de ontvanger en details over verdere doorgifte',
            vendor_id: 'Leverancier ID',
            processing_activity_ids: "Verwerking Activiteit ID's (comma-separated)",
            reviewer_ids: "Beoordelaar ID's (comma-separated)",
            approval_mode: 'Goedkeuring Modus',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'DPO-goedkeuring vereist',
            review_date: 'Beoordelen Datum',
            created: 'Aangemaakt',
            deprecated: 'Afgeschreven',
            submit_for_review: 'Indienen voor Beoordelen',
            approve_reject: 'Goedkeuren/Afwijzen',
            deprecate: 'Afschrijven',
            risk_eval: 'Risico Eval',
            hide_safeguards: 'Verbergen Waarborgen',
            mechanism_proof: 'Mechanisme bewijs',
            hide_mechanism_proof: 'Mechanismebestendig verbergen',
            mechanism_proof_hint: "Upload het ondertekende overdrachtsmechanisme (SCC's, BCR's, adequaatheidsbesluit, enz.) waaruit deze overdrachtsbeoordeling blijkt.",
            no_mechanism_proof: 'Geen mechanismebewijs bevestigd.',
            upload_mechanism_proof: 'Bewijs van uploadmechanisme',
            comments: 'Opmerkingen',
            submit_decision: 'Indienen Beslissing',
            data_sensitivity: 'Gegevens Sensitivity (1-5)',
            country_risk: 'Land Risico (1-5)',
            safeguard_adequacy: 'Waarborg Adequaatheid (1-5)',
            volume_factor: 'Volumefactor (1-5)',
            evaluate: 'Evalueren',
            add_safeguard: 'Toevoegen Waarborg',
            responsible_party: 'Verantwoordelijk Party',
            responsible_party_placeholder: 'Of voer naam handmatig in',
            responsible: 'Verantwoordelijk',
            implementation_date: 'Implementatie Datum',
            implementation: 'Implementatie',
            expiry_date: 'Vervaldatum Datum',
            expiry: 'Vervaldatum',
            expire: 'Verlopen',
            no_safeguards: 'Geen waarborgen gevonden.',
            no_transfers: 'Geen overdracht assessments gevonden.',
            fetch_error: 'Kan niet fetch overdracht assessments. Probeer het opnieuw.',
            save_error: 'Kan niet save overdracht beoordeling. Probeer het opnieuw.',
            submit_review_error: 'Kan niet submit voor beoordeling. Probeer het opnieuw.',
            decision_error: 'Kan niet process beslissing. Probeer het opnieuw.',
            deprecate_error: 'Kan niet deprecate overdracht. Probeer het opnieuw.',
            risk_eval_error: 'Kan niet evaluate risico. Probeer het opnieuw.',
            fetch_safeguards_error: 'Kan niet fetch waarborgen. Probeer het opnieuw.',
            save_safeguard_error: 'Kan niet save waarborg. Probeer het opnieuw.',
            update_safeguard_status_error: 'Kan de waarborgstatus niet bijwerken. Probeer het opnieuw.',
            safeguard_type_encryption_in_transit: 'Versleuteling in Transit',
            safeguard_type_encryption_at_rest: 'Versleuteling bij Rest',
            safeguard_type_access_controls: 'Toegang Controles',
            safeguard_type_contractual_clauses: 'Contractueel Clausules',
            safeguard_type_data_minimization: 'Gegevens Minimization',
            safeguard_type_pseudonymization: 'Pseudonimisering',
            safeguard_type_audit_rights: 'Auditrechten',
            safeguard_type_breach_notification: 'Inbreuk Melding',
            safeguard_type_data_localization: 'Gegevens Lokalisatie',
            safeguard_type_other: 'Overig',
            activate: 'Activeren',
            all_statuses: 'Alle statussen',
            any: 'Any',
            mechanism_detail: 'Mechanisme Detail',
            mechanisms: {
                adequacy_decision: 'Adequaatheid Beslissing',
                sccs: 'Modelcontractbepalingen',
                bcr: 'BCR',
                bcrs: 'Bindende bedrijfsregels',
                derogation: 'Afwijking',
                consent: 'Toestemming',
                other: 'Overig',
            },
            safeguard_types: {
                encryption_in_transit: 'Versleuteling tijdens overdracht',
                encryption_at_rest: 'Versleuteling in rust',
                access_controls: 'Toegangscontroles',
                contractual_clauses: 'Contractuele clausules',
                data_minimization: 'Gegevensminimalisatie',
                pseudonymization: 'Pseudonimisering',
                audit_rights: 'Auditrechten',
                breach_notification: 'Inbreukmelding',
                data_localization: 'Gegevenslokalisatie',
                other: 'Overig',
            },
        },
        gap_report: {
            page_title: 'Beoordelingskloofsrapport',
            announce_loaded: 'Kloofsrapport geladen. {count} kloof(en) geïdentificeerd',
            aria_activities_without_dpia: 'Activiteiten zonder DPIA-beoordeling',
            aria_activities_unclassified: 'Activiteiten met ongeclassificeerde DPIA-vereiste',
            activities_unclassified_section_title: 'Activiteiten met ongeclassificeerde DPIA-vereiste',
            activities_unclassified_description: 'Deze activiteiten zijn niet beoordeeld om te bepalen of een DPIA wettelijk verplicht is. Classificeer elke activiteit om het signaal op te heffen.',
            activities_unclassified_empty: 'Alle actieve activiteiten zijn geclassificeerd.',
            aria_unmitigated_risks: 'Onbehandelde hoge en kritieke risicos',
            aria_transfers_without_safeguards: 'Overdrachten zonder voldoende beschermingsmaatregelen',
            aria_expired_assessments: 'Verlopen beoordelingen die vernieuwing vereisen',
            title: 'Lacunerapport beoordelingen',
            no_dpia: 'Activiteiten zonder GEB',
            no_assessment: 'Doorgiften zonder beoordeling',
            unmitigated: "GEB's met onbehandelde risico's",
            activity_id: 'Activiteit ID',
            dpia_id: 'DPIA-nummer',
            assessment_id: 'Beoordeling ID',
            expired_assessments: 'Verlopen Beoordelingen',
            no_gaps_activities: 'Geen hiaten gevonden Alle activities have DPIAs..',
            no_unmitigated_risks: "Geen unmitigated high/critical risico's gevonden.",
            no_gaps_safeguards: 'Geen hiaten gevonden Alle overdrachten have adequate waarborgen..',
            no_expired: 'Geen expired assessments gevonden.',
            no_report_data: 'No hiaat report gegevens available.',
            fetch_error: 'Kan niet fetch hiaat report. Probeer het opnieuw.',
            no_expired_assessments: 'Geen verlopen beoordelingen.',
            no_gaps_dpia: 'Geen DPIA hiaten gevonden.',
            no_data: 'No gegevens available.',
        },
        dossier_filings: {
            page_title_detail: 'Dossierindiening detail',
            page_title_list: 'Dossierindiening zaken',
            announce_filings_found: '{count} indiening(en) gevonden',
            announce_results: '{count} resultaten',
            aria_filter_by_status: 'Filteren op status',
            title: 'Dossierdossiers',
            nav_label: 'Dossierdossiers',
            create: 'Dossierarchivering maken',
            form_type: 'Formuliertype',
            phu_luc_i_label: 'Mẫu số 02a (Standaard [[TOK_0]], Decreet 356)',
            phu_luc_ii_label: 'Mẫu số 02b (Grensoverschrijdend / Hoog risico [[TOK_0]], Decreet 356)',
            dpia_reference: '[[TOK_0]] Referentie',
            submitted_date: 'Ingediende datum',
            outcome: 'Resultaat',
            parent_filing: 'Ouder',
            no_filings: 'Geen dossierdossiers gevonden.',
            fetch_error: 'Kan dossierdossiers niet ophalen. Probeer het opnieuw.',
            save_error: 'Kan dossierarchivering niet maken. Probeer het opnieuw.',
            created: 'Dossierdossier aangemaakt.',
            loaded: 'Dossierdossier geladen.',
            not_found: 'Dossierdossier niet gevonden.',
            back_to_list: 'Terug naar lijst',
            section_assignments: 'Sectie-opdrachten',
            assign_sections: 'Secties toewijzen',
            section_id: 'Sectie',
            department: 'Afdeling',
            assignee: 'Ontvanger',
            deadline: 'Deadline',
            no_assignments: 'Nog geen sectieopdrachten.',
            sections_assigned_msg: 'Secties toegewezen.',
            assign_error: 'Kan secties niet toewijzen. Probeer het opnieuw.',
            lifecycle: 'Levenscyclus van archivering',
            submission: 'Inzendingsdetails',
            submission_channel: 'Inzendingskanaal',
            mps_portal: '[[TOK_0]] Portaal',
            in_person: 'Persoonlijk',
            postal: 'Post',
            confirmation_number: 'Bevestigingsnummer',
            submit_for_review: 'Indienen ter beoordeling',
            submitted_for_review: 'Voorgelegd voor interne beoordeling.',
            submit_review_error: 'Kan niet ter beoordeling worden ingediend. Probeer het opnieuw.',
            legal_signoff: 'Juridische ondertekening',
            legal_signoff_done: 'Juridische ondertekening voltooid.',
            legal_signoff_error: 'Kan de juridische ondertekening niet voltooien. Probeer het opnieuw.',
            approve: 'Goedkeuren',
            approved_msg: 'Indiening goedgekeurd.',
            approve_error: 'Kan de indiening niet goedkeuren. Probeer het opnieuw.',
            materialisation_status_column: 'Inzending artefact',
            materialisation_na: 'Niet van toepassing',
            materialisation_pending: 'In behandeling',
            materialisation_success: 'Gematerialiseerd',
            materialisation_failed: 'Mislukt',
            materialisation_banner_title: 'Inzendingsartefact kan niet worden gemaakt',
            materialisation_banner_body: 'De indiening werd goedgekeurd, maar het onderliggende dossierrecord kon niet worden aangemaakt. Exporteren van sollicitatiebrieven en inzendingen zijn pas beschikbaar als u het opnieuw probeert.',
            materialisation_retry_button: 'Opnieuw proberen',
            materialisation_retry_count: 'Eerdere pogingen:',
            materialisation_retry_success: 'Het inzendingsartefact is met succes gerealiseerd.',
            materialisation_retry_announce: 'Opnieuw proberen gelukt',
            filter_materialisation_failed: 'Toon alleen materialisatiefouten',
            column_title: 'Titel',
            column_form_type: 'Vorm',
            submit_to_mps: 'Verzenden naar [[TOK_0]]',
            submitted_to_mps_msg: 'Ingediend bij [[TOK_0]].',
            submit_mps_error: 'Kan niet verzenden naar [[TOK_0]]. Probeer het opnieuw.',
            supplement_request: 'Aanvraag voor aanvulling',
            supplement_requests: 'Aanvullingsverzoeken',
            supplement_response: 'Aanvullend antwoord',
            record_supplement: 'Aanvraag supplement vastleggen',
            supplement_recorded: 'Supplementaanvraag geregistreerd.',
            supplement_error: 'Kan aanvullingsverzoek niet opnemen. Probeer het opnieuw.',
            submit_supplement: 'Aanvullend antwoord indienen',
            supplement_submitted_msg: 'Aanvullende reactie ingediend.',
            supplement_submit_error: 'Het is niet gelukt om een aanvullingsreactie in te dienen. Probeer het opnieuw.',
            response_status: 'Reactiestatus',
            response_notes: 'Reactienotities',
            resubmit: 'Opnieuw indienen',
            resubmitted_msg: 'Dossier opnieuw ingediend.',
            resubmit_error: 'Het dossier kan niet opnieuw worden ingediend. Probeer het opnieuw.',
            record_outcome: 'Resultaat opnemen',
            outcome_recorded: 'Resultaat geregistreerd.',
            outcome_error: 'Het is niet gelukt om de uitkomst vast te leggen. Probeer het opnieuw.',
            accepted: 'Geaccepteerd',
            rejected: 'Afgewezen',
            close: 'Sluiten',
            closed_msg: 'Indiening gesloten.',
            close_error: 'Kan de dossieraanvraag niet sluiten. Probeer het opnieuw.',
            change_filing: 'Wijzigingsdossier aanmaken',
            change_filing_created: 'Wijzigingsdossier aangemaakt.',
            change_filing_error: 'Kan wijzigingsaanvraag niet aanmaken. Probeer het opnieuw.',
            change_reason: 'Reden voor verandering',
            filing_lineage: 'Afstammingslijn indienen',
            timers: 'Actieve timers',
            timer_mps_review: '[[TOK_0]] Beoordeling',
            timer_supplement: 'Aanvullingstermijn',
            timer_resubmission: 'Deadline voor herindiening',
            timer_department: 'Deadline van de afdeling',
            days_remaining: 'dagen resterend',
            days_overdue: 'dagen te laat',
            cover_letter: 'Sollicitatiebrief',
            checklist: 'Controlelijst',
            evidence_index: 'Bewijsindex',
            status_draft: 'Concept',
            status_sections_assigned: 'Secties toegewezen',
            status_internal_review: 'Interne beoordeling',
            status_legal_signoff: 'Juridische ondertekening',
            status_approved: 'Goedgekeurd',
            status_submitted_to_mps: 'Ingediend bij [[TOK_0]]',
            status_supplement_requested: 'Aanvulling gevraagd',
            status_supplement_submitted: 'Aanvulling ingediend',
            status_resubmitted: 'Opnieuw ingediend',
            status_accepted: 'Geaccepteerd',
            status_rejected: 'Afgewezen',
            status_closed: 'Gesloten',
            linked_dpia: 'Gekoppelde DPIA',
            linked_dpia_none: 'Geen DPIA gekoppeld aan deze indiening.',
            view_linked_dpia: 'DPIA bekijken',
            linked_dpia_label: 'Deze dossierindiening is gekoppeld aan de volgende DPIA:',
        },
        materialisation_health: {
            nav_label: 'Gezondheid van het artefact bij indiening',
            page_title: 'Inzending Artefactgezondheid',
            page_description: 'Detecteer en verhelp problemen met de materialisatie van dossiers. Lijsten zijn gericht op uw organisatie.',
            failed_title: 'Mislukte materialisaties',
            failed_empty: 'Geen mislukte materialisaties – goed.',
            pending_title: 'Goedgekeurd maar niet gerealiseerd',
            pending_empty: 'Alle goedgekeurde deponeringen hebben een ondersteunend dossier.',
            orphan_title: 'Weesdossiers',
            orphan_description: 'Dossiers die door materialisatie zijn ontstaan en waarnaar in geen enkele dossiers meer wordt verwezen – doorgaans de verliezer van een gelijktijdige race. Op de lijst voor onderzoek; het opruimen is handmatig.',
            orphan_empty: 'Geen weesdossiers gedetecteerd.',
            materialise_button: 'Materialiseer nu',
            column_failure_reason: 'Reden van falen',
            column_failed_at: 'Mislukt bij',
            column_retries: 'Nieuwe pogingen',
            column_approved_at: 'Goedgekeurd op',
            column_dossier_id: 'Dossier-ID',
            column_source_filing_id: 'Bronregistratie',
            column_dossier_type: 'Typ',
            column_created_at: 'Gemaakt op',
        },
    },
    classification: {
        access_denied_title: 'Toegang geweigerd',
        access_denied: 'U beschikt niet over de vereiste machtigingen voor toegang tot de classificatiemodule. Neem contact op met uw beheerder.',
        nav: {
            taxonomies: 'Taxonomieën',
            labeling: 'Kenmerken toewijzen',
            lifecycle: 'Levenscyclus',
            gaps: 'Lacunerapport',
            exports: 'Exporteert',
        },
        exports: {
            title: 'Classificatie-exports',
            csv_section: 'CSV-exports',
            pdf_section: 'PDF-rapporten',
            inventory: 'Inventaris',
            classification_register: 'Classificatieregister',
            raci: 'RACI-matrix',
            exceptions: 'Uitzonderingen',
            evidence_pack: 'Bewijspakket',
            delta_report: 'Deltarapport',
            executive_summary: 'Managementsamenvatting',
            exporting: 'Bezig met exporteren…',
            export_success: 'Export succesvol voltooid.',
            export_error: 'Export mislukt. Probeer het opnieuw.',
            csv_download: 'CSV-download gereed.',
            pdf_download: 'PDF-generatie gestart.',
            no_data: 'Geen gegevens beschikbaar om te exporteren.',
        },
        delta: {
            title: 'Wijzigingsdetails',
            added: 'Toegevoegd',
            removed: 'Verwijderd',
            changed: 'Gewijzigd',
            added_count: 'Toegevoegd ({count})',
            removed_count: 'Verwijderd ({count})',
            changed_count: 'Gewijzigd ({count})',
            object_id: 'Object-ID',
            object_type: 'Objecttype',
            taxonomy: 'Taxonomie',
            level: 'Niveau',
            previous: 'Vorig',
            current: 'Huidig',
            no_records: 'Geen records in deze sectie.',
            empty_section: 'Deze sectie is leeg.',
        },
        schedule: {
            title: 'Ontdekkingscyclus plannen',
            enabled: 'Ingeschakeld',
            interval_days: 'Interval (dagen)',
            interval_label: 'Elke N dagen uitvoeren',
            manual_only: 'Alleen handmatig',
            every_n_days: 'Elke {n} dagen',
            save: 'Planning opslaan',
            cancel: 'Annuleren',
            schedule_updated: 'Planning succesvol bijgewerkt.',
        },
        taxonomies: {
            title: 'Classificatietaxonomieën',
            new: 'Nieuwe taxonomie',
            edit: 'Taxonomie bewerken',
            name: 'Naam',
            levels: 'Classificatieniveaus',
            seed_defaults: 'Initialiseren Standaardwaarden',
            scope: 'Bereik',
            scope_organization: 'Organisatie',
            scope_module_specific: 'Modulespecifiek',
            deprecate: 'Afschrijven',
            hide_levels: 'Verbergen Niveaus',
            versions: 'Versies',
            hide_versions: 'Verbergen Versies',
            add_level: 'Toevoegen Niveau',
            new_level: 'Nieuw Niveau',
            edit_level: 'Bewerken Niveau',
            code: 'Codering',
            label: 'Kenmerk',
            color: 'Kleur',
            ordinal: 'Volgnummer',
            handling_requirements: 'Afhandeling Vereisten',
            version_history: 'Versie Geschiedenis',
            changes: 'Wijzigingen',
            failed_fetch: 'Kan niet fetch taxonomieën. Probeer het opnieuw.',
            failed_save: 'Kan niet save taxonomie. Probeer het opnieuw.',
            failed_activate: 'Kan niet activate taxonomie. Probeer het opnieuw.',
            failed_deprecate: 'Kan niet deprecate taxonomie. Probeer het opnieuw.',
            failed_seed: 'Kan niet seed standaard taxonomieën. Probeer het opnieuw.',
            failed_fetch_levels: 'Kan niet fetch taxonomie niveaus. Probeer het opnieuw.',
            failed_save_level: 'Kan niet save taxonomie niveau. Probeer het opnieuw.',
            failed_delete_level: 'Kan niet delete taxonomie niveau. Probeer het opnieuw.',
            failed_fetch_versions: 'Kan niet fetch taxonomie versies. Probeer het opnieuw.',
            loaded_count: '{count} taxonomieën geladen',
            defaults_seeded: 'Standaard-taxonomieën geïnitialiseerd.',
            no_levels: 'Geen classificatieniveaus gedefinieerd — voeg niveaus toe om uw classificatiehiërarchie op te bouwen.',
            no_versions: 'Nog geen versiegeschiedenis — versies worden aangemaakt wanneer een actieve taxonomie wordt bijgewerkt.',
        },
        labeling: {
            title: 'Gegevenslabeling',
            new: 'Nieuw label',
            edit: 'Label bewerken',
            entity_type: 'Entiteitstype',
            entity_id: 'Entiteits-ID',
            taxonomy: 'Taxonomie',
            classification_level: 'Classificatieniveau',
            applied_by: 'Toegepast door',
            applied_at: 'Toegepast op',
            bulk_apply: 'Bulk toepassen',
            bulk_remove: 'Bulk verwijderen',
            all_taxonomies: 'Alle Taxonomieën',
            system: 'Systeem',
            dataset: 'Gegevensset',
            level_code_placeholder: 'Niveau code...',
            select_taxonomy: 'Selecteren taxonomie...',
            select_level: 'Selecteren niveau...',
            rationale: 'Motivering',
            review_date: 'Beoordelen Datum',
            review: 'Beoordelen',
            selected: 'geselecteerd',
            select_all_labels: 'Selecteer alle labels',
            loaded_count: '{count} labels geladen',
            hide_stale_labels: 'Verbergen Stale Labels',
            show_conflicts: 'Tonen Conflicten',
            hide_conflicts: 'Verbergen Conflicten',
            label_conflicts: 'Label Conflicten',
            conflict_reason: 'Conflict Reden',
            labels: 'Kenmerken',
            failed_fetch: 'Kan niet fetch labels. Probeer het opnieuw.',
            failed_fetch_taxonomies: 'Kan niet fetch taxonomieën. Probeer het opnieuw.',
            failed_fetch_levels: 'Kan niet fetch taxonomie niveaus. Probeer het opnieuw.',
            failed_save: 'Kan niet save label. Probeer het opnieuw.',
            failed_review: 'Kan niet beoordeling label. Probeer het opnieuw.',
            failed_bulk: 'Kan niet bulk label. Probeer het opnieuw.',
            failed_stale: 'Kan niet fetch stale labels. Probeer het opnieuw.',
            failed_conflicts: 'Kan niet fetch label conflicts. Probeer het opnieuw.',
            review_permission_denied: 'U heeft geen toestemming om dit label te beoordelen.',
            review_not_found: 'Label niet gevonden — het is mogelijk verwijderd.',
            approve_selected: 'Geselecteerde goedkeuren',
            reject_selected: 'Geselecteerde afwijzen',
            approved: 'Goedgekeurd',
            rejected: 'Afgewezen',
            labels_count: 'labels',
            failed_count: 'mislukt',
            confirm_approve: 'Goedkeuring bevestigen',
            confirm_reject: 'Afwijzing bevestigen',
            approve_n_labels: '{count} labels goedkeuren?',
            reject_n_labels: '{count} labels afwijzen?',
            submit_for_review: 'Indienen voor beoordeling',
            approve: 'Goedkeuren',
            reject: 'Afwijzen',
            parent_system: 'Bovenliggend systeem',
            parent_system_placeholder: 'Selecteer bovenliggend systeem...',
            parent_system_help: 'Gebruikt voor conflictdetectie.',
            dataset_level: 'Datasetniveau',
            parent_level: 'Bovenliggend niveau',
            bulk_created: '{created} label(s) aangemaakt',
            bulk_skipped: '{skipped} overgeslagen',
            bulk_all_skipped: 'Alle {skipped} overgeslagen',
            ids_hint: 'Voer IDs in gescheiden door kommas',
            delete_confirm: 'Label voor "{id}" verwijderen?',
        },
        lifecycle: {
            title: 'Gegevenslevenscyclusmonitoring',
            new: 'Nieuw item',
            current_stage: 'Huidige fase',
            last_transition: 'Laatste overgang',
            transition: 'Overgang',
            view_history: 'Geschiedenis bekijken',
            stages: {
                creation: 'Aanmaak',
                collection: 'Verzameling',
                processing: 'Verwerking',
                storage: 'Opslag',
                retention: 'Bewaring',
                disposal: 'Verwijdering',
                archived: 'Gearchiveerd',
                active: 'Actief',
                pending_deletion: 'In afwachting Deletion',
                deleted: 'Verwijderd',
                on_hold: 'On Vasthouden',
            },
            all_stages: 'Alle Fases',
            object_id: 'Object-ID',
            object_type: 'Objecttype',
            policy_reference: 'Beleid Referentie',
            retention_period_days: 'Bewaring Periode (days)',
            retention_basis: 'Bewaring Grondslag',
            deletion_method: 'Deletion Methode',
            deletion_secure_erase: 'Beveiligd Erase',
            deletion_anonymization: 'Anonimisering',
            deletion_physical_destruction: 'Fysiek Destruction',
            deletion_other: 'Overig',
            responsible_party: 'Verantwoordelijk Party',
            responsible_user_id: 'Verantwoordelijk Gebruiker ID',
            retention_expiry: 'Bewaring Vervaldatum',
            hold_reason: 'Vasthouden Reden',
            hold: 'Vasthouden',
            release: 'Vrijgeven',
            hide_events: 'Verbergen Gebeurtenissen',
            events_timeline: 'Gebeurtenissen Tijdlijn',
            add_event: 'Toevoegen Gebeurtenis',
            event_type: 'Gebeurtenis Type',
            create_event: 'Aanmaken Gebeurtenis',
            from_stage: 'Van Fase',
            to_stage: 'Naar Fase',
            actor: 'Betrokkene',
            reason_placeholder: 'Reden...',
            go: 'Go',
            show_expired_retentions: 'Tonen Verlopen Retentions',
            hide_expired_retentions: 'Verbergen Verlopen Retentions',
            expired_retentions_alert: 'Verlopen Retentions Waarschuwing',
            failed_fetch: 'Kan niet fetch levenscyclus records. Probeer het opnieuw.',
            failed_save: 'Kan niet save levenscyclus record. Probeer het opnieuw.',
            failed_transition: 'Kan niet transition levenscyclus fase. Probeer het opnieuw.',
            failed_hold: 'Kan niet place vasthouden. Probeer het opnieuw.',
            failed_release: 'Kan niet release vasthouden. Probeer het opnieuw.',
            failed_fetch_events: 'Kan niet fetch levenscyclus gebeurtenissen. Probeer het opnieuw.',
            failed_create_event: 'Kan niet create levenscyclus gebeurtenis. Probeer het opnieuw.',
            failed_expired: 'Kan niet fetch expired retentions. Probeer het opnieuw.',
            hold_reason_prompt: 'Invoeren vasthouden reason:',
            loaded_count: '{count} levenscyclusrecords geladen',
            stage_transition_for: 'Faseovergang voor {id}',
            event_created: 'Aangemaakt',
            event_updated: 'Bijgewerkt',
            event_approved: 'Goedgekeurd',
            event_deprecated: 'Verouderd',
            event_proposed: 'Voorgesteld',
            event_reviewed: 'Beoordeeld',
            event_archived: 'Gearchiveerd',
            event_restored: 'Hersteld',
        },
        gap_report: {
            title: 'Classificatielacunerapport',
            unlabeled: 'Ongelabelde gegevens',
            missing_lifecycle: 'Ontbrekende levenscyclus',
            stale_labels: 'Verouderde labels',
            run_detection: 'Uitvoeren Hiaat Detectie',
            detecting: 'Detecteren...',
            detection_complete: 'Hiaat detection voltooid. {count} gap(s) detected.',
            detection_failed: 'Hiaat detection mislukt.',
            by_severity: 'By Ernst',
            by_gap_type: 'By Hiaat Type',
            all_gap_types: 'Alle Hiaat Types',
            conflicting_labels: 'Conflicterende labels',
            expired_retention: 'Verlopen Bewaring',
            missing_handling: 'Ontbrekend Afhandeling',
            info: 'Info',
            gap_type: 'Hiaat Type',
            object_id: 'Object-ID',
            object_type: 'Objecttype',
            detected_at: 'Gedetecteerd At',
            open: 'Geopend',
            acknowledged: 'Bevestigd',
            remediated: 'Hersteld',
            accepted: 'Geaccepteerd',
            acknowledge: 'Bevestigen',
            remediate: 'Herstellen',
            accept_risk: 'Accepteren Risico',
            accept_risk_prompt: 'Invoeren risico acceptance rechtvaardiging:',
            failed_fetch: 'Kan niet fetch hiaten. Probeer het opnieuw.',
            failed_acknowledge: 'Kan niet acknowledge hiaat. Probeer het opnieuw.',
            failed_remediate: 'Kan niet remediate hiaat. Probeer het opnieuw.',
            failed_accept_risk: 'Kan niet accept hiaat risico. Probeer het opnieuw.',
            failed_detect: 'Kan niet uitvoering hiaat detection. Probeer het opnieuw.',
            loaded_count: '{count} classificatielacunes geladen',
            related_object_id: 'Gerelateerd object-ID',
            related_object_type: 'Gerelateerd objecttype',
            gap_types: {
                unlabeled_asset: 'Ongelabeld object',
                missing_lifecycle: 'Ontbrekende levenscyclus',
                expired_retention: 'Verlopen bewaarperiode',
                extended_pending_deletion: 'Uitgestelde verwijdering',
            },
        },
        label_workflow: {
            title: 'Labelworkflow',
            proposed: 'Voorgesteld',
            under_review: 'In beoordeling',
            approved: 'Goedgekeurd',
            deprecated: 'Verouderd',
            submit_review: 'Indienen ter beoordeling',
            approve: 'Label goedkeuren',
            deprecate: 'Als verouderd markeren',
            bulk_approve: 'Bulk goedkeuren',
            bulk_approve_success: 'Labels goedgekeurd.',
            submit_success: 'Label ingediend ter beoordeling.',
            approve_success: 'Label goedgekeurd.',
            deprecate_success: 'Label als verouderd gemarkeerd.',
        },
        review_tasks: {
            title: 'Beoordelingstaken',
            create: 'Nieuwe beoordelingstaak',
            system: 'Systeem',
            owner: 'Eigenaar',
            description: 'Beschrijving',
            resolution: 'Oplossing',
            resolve: 'Oplossen',
            approve: 'Goedkeuren',
            modify: 'Wijzigen',
            reject: 'Afwijzen',
            escalate: 'Escaleren',
            escalated: 'Geëscaleerde taken',
            no_tasks: 'Geen beoordelingstaken.',
            resolve_success: 'Beoordelingstaak opgelost.',
            status_pending: 'In afwachting',
            status_resolved: 'Opgelost',
            status_escalated: 'Geëscaleerd',
            notes: 'Notities',
            create_success: 'Beoordelingstaak aangemaakt.',
            no_tasks_detail: 'Nog geen beoordelingstaken — maak een taak aan om labelbeoordelingen toe te wijzen aan systeemeigenaren.',
            label_id: 'Label-ID',
            system_id: 'Systeem-ID',
            system_name: 'Systeemnaam',
            owner_id: 'Eigenaar-ID',
            resolution_col: 'Oplossing',
            notes_col: 'Opmerkingen',
        },
        exceptions: {
            title: 'Uitzonderingswachtrij',
            create: 'Nieuwe uitzondering',
            severity: 'Ernst',
            system: 'Systeem',
            owner: 'Eigenaar',
            resolve: 'Oplossen',
            no_exceptions: 'Geen uitzonderingen gevonden.',
            resolve_success: 'Uitzondering opgelost.',
            dashboard_open: 'Open uitzonderingen',
            dashboard_resolved: 'Opgeloste uitzonderingen',
            dashboard_total: 'Totaal',
            dashboard_by_severity: 'Op ernst',
            status_open: 'Openen',
            status_resolved: 'Opgelost',
            status_accepted_risk: 'Geaccepteerd risico',
            create_success: 'Uitzondering aangemaakt.',
            no_exceptions_detail: 'Nog geen uitzonderingen — uitzonderingen worden aangemaakt vanuit ernstige lacunes die speciale afhandeling vereisen.',
            gap_id: 'Lacune-ID',
            system_id: 'Systeem-ID',
            system_name: 'Systeemnaam',
            owner_id: 'Eigenaar-ID',
            resolution_notes: 'Oplosnotities',
            resolution_notes_placeholder: 'Beschrijf hoe deze uitzondering is opgelost...',
        },
        enterprise_map: {
            title: 'Bedrijfsdatakaart',
            inventory: 'Data-inventaris',
            total_systems: 'Totaal systemen',
            total_labels: 'Totaal labels',
            approved_count: 'Goedgekeurde labels',
            proposed_count: 'Voorgestelde labels',
            no_data: 'Geen classificatiegegevens beschikbaar.',
            no_approved_labels: 'Nog geen goedgekeurde labels — labels moeten worden beoordeeld en goedgekeurd voordat ze op de datakaart verschijnen.',
            loaded_count: 'Geladen ondernemingsgegevenskaart',
        },
        discovery: {
            title: 'Ontdekkingscycli',
            create: 'Nieuwe cyclus',
            cycle_name: 'Cyclusnaam',
            run_delta: 'Deltadetectie uitvoeren',
            delta_success: 'Deltadetectie voltooid.',
            create_success: 'Ontdekkingscyclus aangemaakt.',
            no_cycles: 'Geen ontdekkingscycli.',
            status_created: 'Gemaakt',
            status_scanning: 'Scannen',
            status_review: 'Beoordeling',
            status_approved: 'Goedgekeurd',
            status_published: 'Gepubliceerd',
            status_draft: 'Concept',
            running: 'Actief',
            completed: 'Voltooid',
            cancelled: 'Geannuleerd',
            delta_result_summary: '{added} toegevoegd, {removed} verwijderd, {changed} gewijzigde labels gevonden.',
            delta_results: 'Deltaresultaten',
            view_results: 'Resultaten bekijken',
            scope_type: 'Bereiktype',
            scope_type_all: 'Allemaal',
            scope_type_systems: 'Systemen',
            scope_type_datasets: 'Gegevenssets',
            scope_ids: "Bereik-ID's",
            scope_ids_placeholder: "Voer ID's in, gescheiden door komma's",
            cycle_explanation: 'Een ontdekkingscyclus scant uw data-infrastructuur om data-assets te identificeren, classificeren en volgen. Configureer het bereik om specifieke systemen of datasets te targeten.',
            empty_state_title: 'Nog geen ontdekkingscycli',
            empty_state_description: 'Creëer uw eerste ontdekkingscyclus om te beginnen met het scannen en classificeren van uw gegevensassets.',
            empty_state_cta: 'Maak de eerste cyclus',
            validation_name_required: 'Cyclusnaam is vereist',
            validation_scope_type_required: 'Scopetype is vereist',
            validation_scope_ids_required: 'Er is ten minste één bereik-ID vereist',
        },
        regulatory: {
            sensitivity_importance_info: 'De gegevenswet (wet [[TOK_0]], vereiste 18e4bfd1) vereist classificatie op basis van zowel gevoeligheid als belang als afzonderlijke dimensies. Creëer één taxonomie voor elke dimensie om aan deze vereiste te voldoen.',
            handling_rules_info: 'Elk classificatieniveau moet verwerkingsregels definiëren per vereiste. b89981ac ("Definieer afhandelingsregels op classificatieniveau").',
            template_internal_ids_info: "Alle classificatiesjablonen gebruiken interne ID's (bijvoorbeeld vn_data_law_data_classification_record). Er wordt geen sjabloon gepresenteerd als officieel ministerieformulier.",
            ai_risk_tiers_info: '[[TOK_0]] De wet (Wet [[TOK_3]], vereiste 3a87ad63) definieert vier [[TOK_1]] systeemrisiconiveaus: minimaal, beperkt, hoog en onaanvaardbaar. Maak een [[TOK_2]] Risicotaxonomie met deze niveaus.',
            ai_risk_tier_minimal: 'Minimaal',
            ai_risk_tier_limited: 'Beperkt',
            ai_risk_tier_high: 'Hoog',
            ai_risk_tier_unacceptable: 'Onaanvaardbaar',
            ai_register_info: '[[TOK_0]]-classificatierecords moeten linken naar een [[TOK_1]]-invoer in het systeemregister (req. 0f4475d3) waarin wordt vastgelegd: systeemnaam, eigenaar, doel, implementatiecontext, risiconiveau, betrokkenheid van de leverancier.',
            ai_template_internal_info: "[[TOK_0]] classificatiesjablonen gebruiken interne ID's (bijvoorbeeld [[TOK_1]]-RISK-01). Er worden geen officiële [[TOK_2]] tijdelijke ID's ([[TOK_3]]-HC-01 tot en met [[TOK_4]]-HC-08) gebruikt.",
            ai_audit_trail_info: '[[TOK_0]] classificatiewijzigingen produceren een audittrail met versiebeheer per UC-VN-06: actor, tijdstempel, vorige waarde, nieuwe waarde en reden.',
            lifecycle_data_d1_info: 'Levenscyclusovergangen worden in kaart gebracht met de procedure voor gegevenswetgeving DATA-D1: catalogiseren, classificeren, verwerkingsregels definiëren, bewijsmateriaal vastleggen, beoordelingen plannen.',
            lifecycle_deletion_link_info: 'Een geclassificeerd data-item dat het einde van zijn levensduur bereikt, moet een verwijderingsschemarecord activeren via de Deletion Orchestration-module.',
            lifecycle_evidence_info: 'Bij elke wijziging in de levenscyclusstatus (concept, actief, onder beoordeling, gearchiveerd, verwijderd) worden de actor, het tijdstempel en de rechtvaardiging vastgelegd als een audittrailinvoer.',
            escalation_timers_info: 'UC-VN-10 escalatiedeadlines: 5 werkdagen voor beoordeling door de eigenaar, 48 uur voor escalatie van uitzonderingen, 72 uur voor risicovolle/gevoelige items.',
            escalation_owner_review: '5 werkdagen',
            escalation_exception: '48 uur',
            escalation_high_risk: '72 uur',
            gap_risk_areas_info: 'Vereiste gegevenswet f6c3060a ("Datarisicobeoordeling") vereist een analyse van de hiaten op vier risicogebieden: privacy, cyberbeveiliging, toegangscontrole en operationeel risico.',
            gap_risk_area_privacy: 'Privacy',
            gap_risk_area_cybersecurity: 'Cyberveiligheid',
            gap_risk_area_access: 'Toegangscontrole',
            gap_risk_area_operational: 'Operationeel',
            gap_framework_filter_info: 'Filter lacunes op regelgevingskader (VN_DATA_LAW of VN_AI_LAW_2026) om relevante lacunes voor elk regelgevingskader te bekijken.',
            framework_vn_data_law: 'VN Datawet',
            framework_vn_ai_law: 'VN AI-wet 2026',
            enterprise_map_approved_info: 'Deze gegevenskaart toont alleen goedgekeurde classificatierecords per UC-VN-10 workflowstap 10 ("Goedgekeurde labels worden de huidige bedrijfswaarheid"). Concept- en voorgestelde records zijn uitgesloten.',
            exports_bundle_info: 'Exportbundels omvatten: classificatieregister, verwerkingsregels, eigendom/RACI en bewijspakket – overeenkomend met UC-VN-10 exportvereisten en DATA-EVD-01 bewijsbladformaat.',
        },
    },
    monitoring: {
        no_permission_title: 'Onvoldoende machtigingen',
        no_permission_message: 'U heeft geen toestemming om deze monitoringmodule te openen.',
        errors: {
            fetch: 'Kan niet load..',
            save: 'Kan niet save..',
            fetch_programs_failed: "Kan niet fetch programma's..",
            fetch_kpi_failed: 'Kan niet fetch KPI gegevens..',
            create_snapshot_failed: 'Kan niet create snapshot..',
            fetch_periods_failed: 'Kan niet fetch periodes..',
            create_period_failed: 'Kan niet create periode..',
            auto_generate_failed: 'Kan niet auto-generate periodes..',
            start_period_failed: 'Kan niet start periode..',
            close_period_failed: 'Kan niet close periode..',
            save_program_failed: 'Kan niet save programma..',
            activate_program_failed: 'Kan niet activate programma..',
            pause_program_failed: 'Kan niet pause programma..',
            complete_program_failed: 'Kan niet voltooid programma..',
            archive_program_failed: 'Kan niet archive programma..',
            fetch_ric_templates_failed: 'Kan niet fetch RIC sjablonen..',
            fetch_ric_cases_failed: 'Kan niet fetch RIC cases..',
            create_ric_case_failed: 'Kan niet create RIC case..',
            transition_ric_failed: 'Kan niet transition RIC case..',
            add_follow_up_failed: 'Kan niet add follow-up..',
            respond_follow_up_failed: 'Kan niet respond naar follow-up..',
            link_evidence_failed: 'Kan niet link bewijs..',
            fetch_task_templates_failed: 'Kan niet fetch taak sjablonen..',
            save_task_template_failed: 'Kan niet save taak sjabloon..',
            delete_task_template_failed: 'Kan niet delete taak sjabloon..',
            delete_framework_link_failed: 'Kan de raamwerkkoppeling niet verwijderen.',
            seed_defaults_failed: 'Kan niet seed standaardwaarden..',
            fetch_tasks_failed: 'Kan niet fetch taken..',
            create_task_failed: 'Kan niet create taak..',
            instantiate_tasks_failed: 'Kan niet instantiate taken..',
            start_task_failed: 'Kan niet start taak..',
            complete_task_failed: 'Kan niet voltooid taak..',
            defer_task_failed: 'Kan niet defer taak..',
            block_task_failed: 'Kan niet block taak..',
            override_complete_failed: 'Kan niet override voltooid..',
            assign_task_failed: 'Kan niet assign taak..',
            update_checklist_failed: 'Kan niet update checklist..',
        },
        nav: {
            programs: "Programma's",
            periods: 'Perioden',
            task_templates: 'Taaksjablonen',
            tasks: 'Taken',
            kpi: 'KPI-overzicht',
            ric: 'Toezichthouderverzoeken',
            framework_link: 'Kadermonitoring',
            authority_readiness: 'Autoriteitsgereedheid',
            change_review: 'Wijzigingsbeoordeling',
            raci: 'RACI-matrix',
        },
        programs: {
            page_title: "Monitoringprogramma's",
            title: "Monitoringprogramma's",
            new: 'Nieuw programma',
            edit: 'Programma bewerken',
            name: 'Naam',
            scope: 'Reikwijdte',
            frequency: 'Frequentie',
            owner: 'Eigenaar',
            activate: 'Activeren',
            pause: 'Pauzeren',
            resume: 'Hervatten',
            complete: 'Voltooien',
            archive: 'Archiveren',
            custom_frequency_days: 'Aangepast Frequentie (days)',
            select_user: 'Gebruiker selecteren…',
            assign_training: 'Training toewijzen',
            linked_forms: 'Gekoppelde formulieren',
            linked_forms_none: 'Nog geen gekoppelde formulieren',
            loaded_count: "{0} programma's geladen",
            scope_labels: {
                full: 'Volledig',
                partial: 'Gedeeltelijk',
                targeted: 'Gericht',
                consent: 'Toestemming',
                dpia: 'DPIA',
                vendors: 'Leveranciers',
                classification: 'Classificatie',
                rights_requests: 'Rechtenverzoeken',
                data_mapping: 'Datakartering',
                transfers: 'Overdrachten',
                security_monitoring: 'Beveiligingsmonitoring',
                authority_response: 'Autoriteit antwoord',
                evidence_preservation: 'Bewijsbehoud',
                localization_review: 'Lokalisatiebeoordeling',
                ai_system_registration: '[[TOK_0]] Systeemregistratie',
                ai_pre_deployment: '[[TOK_0]] Beoordeling vóór implementatie',
                ai_transparency: '[[TOK_0]] Transparantiecontrole',
                ai_incident_review: '[[TOK_0]] Incidentbeoordeling',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Monitoringperioden',
            title: 'Beoordelingsperioden',
            new: 'Nieuwe periode',
            label: 'Periodelabel',
            start_date: 'Startdatum',
            end_date: 'Einddatum',
            reviewers: 'Beoordelaars',
            auto_generate: 'Perioden automatisch genereren',
            start: 'Starten',
            close: 'Sluiten',
            change_digest: 'Wijzigingsoverzicht',
            no_digest: 'Geen samenvatting beschikbaar.',
            reviewers_count: 'Beoordelaars Aantal',
            select_program: 'Selecteren Programma',
            select_program_prompt: 'Selecteren een programma naar view periodes.',
            hide_digest: 'Verbergen Digest',
            loaded_count: '{0} perioden geladen',
            periods_auto_generated: 'Perioden automatisch gegenereerd',
            label_placeholder: 'bijv. 2026-K1',
        },
        task_templates: {
            page_title: 'Taaksjablonen',
            title: 'Taaksjablonen',
            new: 'Nieuw sjabloon',
            edit: 'Sjabloon bewerken',
            category: 'Categorie',
            priority: 'Prioriteit',
            checklist_items: 'Checklistitems',
            effort: 'Geschatte inspanning (uren)',
            pre_seeded: 'Vooraf ingevuld',
            seed_defaults: 'Standaardwaarden laden',
            add_checklist: 'Checklistitem toevoegen',
            guidance: 'Richtlijnen',
            all_categories: 'Alle Categorieën',
            loaded_count: '{0} taaksjablonen geladen',
            defaults_seeded: 'Standaard taaksjablonen aangemaakt',
            checklist_item_label: 'Checklistitem {0}',
            remove_checklist_item: 'Checklistitem {0} verwijderen',
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Beoordelingstaken',
            title: 'Beoordelingstaken',
            new: 'Nieuwe taak',
            assigned_to: 'Toegewezen aan',
            due_date: 'Uiterste datum',
            checklist: 'Controlelijst',
            start: 'Starten',
            complete: 'Voltooien',
            defer: 'Uitstellen',
            block: 'Blokkeren',
            override_complete: 'Geforceerd voltooien',
            link_evidence: 'Bewijs koppelen',
            direct_upload_label: 'Bewijsbestand uploaden',
            instantiate: 'Instantiëren vanuit sjablonen',
            defer_reason: 'Reden voor uitstel',
            override_justification: 'Rechtvaardiging voor overschrijving',
            filter_assignee: 'Filteren op assignee',
            select_period: 'Selecteren Periode',
            select_program: 'Selecteren Programma',
            select_program_period_prompt: 'Selecteren een programma en periode naar view taken.',
            assign_placeholder: 'Toewijzen naar...',
            loaded_count: '{0} taken geladen',
            tasks_instantiated: 'Taken aangemaakt van sjablonen',
            overdue: 'Achterstallig',
            checklist_for: 'checklist voor',
            manage_checklist: 'Checklist beheren',
            add_checklist_item: 'Item toevoegen',
            checklist_item_label: 'Item',
            checklist_item_description: 'Beschrijving',
            remove_checklist_item: 'Item verwijderen',
            save_checklist: 'Checklist opslaan',
            no_checklist_items: 'Nog geen checklistitems.',
            confirm_delete_attachment: 'Weet u zeker dat u dit bewijsbestand wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
        },
        kpi: {
            page_title: 'KPI-overzicht',
            title: 'KPI-overzicht',
            kpi_name: 'KPI-naam',
            current_value: 'Huidige waarde',
            target: 'Doel',
            trends: 'Ontwikkelingen',
            capture_snapshot: 'Vastleggen Snapshot',
            select_program: 'Selecteren Programma',
            select_program_prompt: 'Selecteren een programma naar view KPIs.',
            snapshot: 'Momentopname',
            kpi_labels: {
                on_track: 'Op schema',
                at_risk: 'At Risico',
                behind: 'Achter',
                rights_request_sla_rate: 'SLA-percentage rechtenverzoeken',
                vendor_review_currency: 'Leveranciersbeoordeling actualiteit',
                dpia_completion_rate: 'DPIA-voltooiingspercentage',
                classification_coverage: 'Classificatiedekking',
                consent_policy_currency: 'Toestemmingsbeleid actualiteit',
                security_event_detection_rate: 'Detectiesnelheid van beveiligingsgebeurtenissen',
                evidence_preservation_compliance_rate: 'Nalevingspercentage van bewijsbehoud',
                authority_response_timeliness: 'Tijdigheid van respons van autoriteiten',
                localization_readiness_score: 'Score voor lokalisatiegereedheid',
                ai_register_completeness: '[[TOK_0]] Volledigheid systeemregister',
                pre_deployment_gate_pass_rate: 'Gate-passpercentage vóór implementatie',
                transparency_disclosure_coverage: 'Dekking van openbaarmaking van transparantie',
                ai_incident_readiness_score: '[[TOK_0]] Incidentgereedheidsscore',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: "KPI's op het gebied van de cyberbeveiligingswetgeving: detectiepercentage van beveiligingsgebeurtenissen, nalevingspercentage van bewijsbehoud, tijdigheid van respons van autoriteiten, score van gereedheid voor lokalisatie.",
            ai_law_kpi_info: "[[TOK_0]] Wet-KPI's: [[TOK_1]] Volledigheid van systeemregister, slagingspercentage vóór implementatie, dekking van openbaarmaking van transparantie, [[TOK_2]] Score voor incidentgereedheid.",
            no_data: 'No gegevens available.',
            snapshot_date: 'Snapshot Datum',
            loaded_count: '{0} KPI-momentopnames geladen',
            snapshot_captured: 'KPI-momentopname vastgelegd',
            showing_chart: 'Grafiekweergave',
            showing_table: 'Datatabelweergave',
            aria_current_values: 'KPI huidige waarden',
            kpi_label: 'KPI',
            actual: 'Werkelijk',
            trend: 'Trend',
            notes: 'Opmerkingen',
            trend_up: 'Stijgend',
            trend_down: 'Dalend',
            trend_stable: 'Stabiel',
        },
        ric: {
            page_title: 'RIC-zaken',
            title: 'Toezichthouderverzoeken',
            new: 'Nieuw RIC-dossier',
            reference: 'Referentie',
            regulator: 'Toezichthouder',
            inquiry_type: 'Type verzoek',
            deadline: 'Antwoordtermijn',
            lead: 'Verantwoordelijke',
            follow_ups: 'Opvolgingen',
            add_follow_up: 'Opvolging toevoegen',
            respond: 'Reageren',
            question: 'Vraag',
            response: 'Antwoord',
            asked_at: 'Gevraagd op',
            no_follow_ups: 'Nog geen opvolgingen.',
            received_date: 'Ontvangen Datum',
            responded_at: 'Beantwoord At',
            hide_follow_ups: 'Verbergen Follow-ups',
            inquiry_types: {
                general: 'Algemeen',
                investigation: 'Onderzoek',
                audit: 'Controle',
                complaint: 'Klacht',
                general_audit: 'Algemene audit',
                rights_requests_review: 'Beoordeling rechtenverzoeken',
                cross_border_transfer_review: 'Beoordeling grensoverschrijdende overdrachten',
                vendor_governance_review: 'Beoordeling leveranciersbeheer',
                consent_management_review: 'Beoordeling toestemmingsbeheer',
                data_mapping_ropa_review: 'Beoordeling datakartering / ROPA',
                incident_readiness_review: 'Beoordeling incidentgereedheid',
                security_access_control_review: 'Beoordeling beveiliging en toegangsbeheer',
                targeted_processing_review: 'Beoordeling gerichte verwerking',
                bank_readiness_pack: 'Bankgereedheidspakket',
            },
            link_evidence: 'Koppelen Bewijs',
            loaded_count: '{0} RIC-zaken geladen',
            to_follow_up: 'naar vervolgvraag',
            overdue: 'Te laat',
            overdue_indicator: 'Reactietermijn overschreden',
            template_info: 'RIC templates are internal platform templates. They are not official government-mandated forms.',
            status_labels: {
                received: 'Ontvangen',
                in_triage: 'In triage',
                evidence_gathering: 'Bewijsverzameling',
                response_drafting: 'Antwoord opstellen',
                internal_review: 'Interne beoordeling',
                submitted: 'Ingediend',
                follow_up: 'Opvolging',
                closed: 'Gesloten',
            },
        },
        framework_link: {
            title: 'Kadergekoppelde monitoring',
            link_program: 'Programma aan kader koppelen',
            framework_code: 'Kadercode',
            select_framework: 'Selecteer een kader...',
            select_program: 'Selecteer een programma...',
            readiness_score: 'Gereedheidsscore',
            no_links: "Geen kadergekoppelde programma's gevonden",
            seed_defaults: 'Standaardsjablonen aanmaken',
            program_id: 'Programma-ID',
            program: 'Programma',
        },
        authority_readiness: {
            title: 'Autoriteitsverzoekgereedheid',
            create_entry: 'Nieuwe gereedheidsvermelding',
            select_framework: 'Selecteer een kader...',
            framework_code: 'Kader',
            readiness_status: 'Gereedheidsstatus',
            readiness_package: 'Gereedheidspakket',
            run_drill: 'Gereedheidsoefening uitvoeren',
            drill_success: 'Gereedheidsoefening geregistreerd',
            last_drill: 'Laatste oefening',
            never_drilled: 'Nooit',
            no_readiness: 'Geen autoriteitsgereedheidsdata gevonden',
            entry_created: 'Gereedheidsvermelding aangemaakt',
            ready: 'Gereed',
            partial: 'Gedeeltelijk',
            not_ready: 'Niet gereed',
            items: 'items',
        },
        change_review: {
            title: 'Regelgevingswijzigingsbeoordeling',
            new_review: 'Nieuwe wijzigingsbeoordeling',
            change_id: 'Wijzigings-ID',
            select_change: 'Selecteer een wijziging...',
            select_framework: 'Selecteer een kader...',
            impact_assessment: 'Impactbeoordeling',
            decision: 'Beslissing',
            no_action: 'Geen actie',
            internal_update: 'Interne update',
            authority_filing: 'Autoriteitsmelding',
            no_reviews: 'Geen wijzigingsbeoordelingen gevonden',
            auto_cycle: 'Automatische beoordelingscyclus',
            cadence: 'Beoordelingsfrequentie',
            framework: 'Raamwerk',
        },
        export_csv: 'Exporteer [[TOK_0]]',
        exporting: 'Exporteren…',
        export_success: '[[TOK_0]] is succesvol geëxporteerd.',
        export_failed: '[[TOK_0]] exporteren mislukt.',
        export_attestation_pack: 'Attestpakket exporteren',
        staleness: {
            badge_label: '[[TOK_1]] verouderde items',
            days_since: '[[TOK_1]] dagen sinds de laatste update',
            detail_title: 'Verouderde artikelen',
            accept_justification: 'Accepteer met rechtvaardiging',
            justification_label: 'Rechtvaardiging',
            no_stale: 'Geen oude items gevonden.',
            threshold_label: 'Verouderingsdrempel (dagen)',
            threshold_min: 'Minimaal 30 dagen',
            threshold_max: 'Maximaal 730 dagen',
            threshold_saved: 'Drempel voor veroudering bijgewerkt.',
        },
        csv_columns: {
            name: 'Naam',
            status: 'Status',
            owner: 'Eigenaar',
            created_at: 'Gemaakt op',
            updated_at: 'Bijgewerkt op',
            scope: 'Reikwijdte',
            frameworks: 'Kaders',
            period_label: 'Periodelabel',
            start_date: 'Startdatum',
            end_date: 'Einddatum',
            task_count: 'Taaktelling',
            completion_rate: 'Voltooiingspercentage',
            title: 'Titel',
            assigned_to: 'Toegewezen aan',
            due_date: 'Vervaldatum',
            priority: 'Prioriteit',
            completed_at: 'Voltooid op',
            kpi_code: '[[TOK_0]] Code',
            kpi_label: '[[TOK_0]] Label',
            target: 'Doel',
            actual: 'Werkelijk',
            trend: 'Trend',
            reference: 'Referentie',
            regulator: 'Regelaar',
            inquiry_type: 'Onderzoekstype',
            lead: 'Lood',
            received_date: 'Datum ontvangen',
            deadline: 'Deadline',
            framework_code: 'Kadercode',
            readiness_status: 'Gereedheidsstatus',
            package_count: 'Aantal pakketten',
            change_id: 'ID wijzigen',
            impact_assessment: 'Effectbeoordeling',
            decision: 'Besluit',
            program: 'Programma',
            readiness_score: 'Gereedheidsscore',
            category: 'Categorie',
            checklist_count: 'Controlelijst tellen',
            effort_hours: 'Inspanning (uren)',
            version: 'Versie',
            department: 'Afdeling',
            function_area: 'Functiegebied',
            role: 'Rol',
            assignee: 'Ontvanger',
            frequency: 'Frequentie',
        },
        raci: {
            page_title: 'Bestuur RACI-matrix',
            title: 'Bestuur RACI-matrix',
            department: 'Afdeling',
            function_area: 'Functiegebied',
            responsible: 'Verantwoordelijk',
            accountable: 'Verantwoordelijk',
            consulted: 'Geraadpleegd',
            informed: 'Geïnformeerd',
            assign_role: 'RACI-rol toewijzen',
            select_program: 'Selecteer Programma',
            select_program_prompt: 'Selecteer een programma om de RACI-matrix te bekijken.',
            no_assignments: 'Geen RACI-toewijzingen gevonden.',
            role_updated: 'RACI-toewijzing bijgewerkt.',
            role_labels: {
                R: 'Verantwoordelijk',
                A: 'Verantwoordelijk',
                C: 'Geraadpleegd',
                I: 'Geïnformeerd',
            },
            loaded_count: '[[TOK_1]] RACI-toewijzingen geladen',
            single_accountability_warning: 'Per functiegebied is slechts één Accountable (A)-rol toegestaan. Als u een nieuwe Accountable-rol toewijst, wordt de bestaande vervangen.',
            cybersec_function_areas: 'Functiegebieden op het gebied van cyberveiligheidsrecht: incidentrespons, behoud van bewijsmateriaal, samenwerking tussen autoriteiten, lokalisatiebeoordeling.',
            ai_law_function_areas: '[[TOK_0]] Juridische functiegebieden: systeemregistratie, beoordeling vóór implementatie, transparantie, incidentafhandeling.',
            suggested_function_areas: 'Voorgestelde functiegebieden',
        },
        prior_cycle: {
            link_label: 'Link naar voorgaande cyclus',
            select_prior: 'Selecteer vorige cyclus…',
            linked: 'Jaar na jaar',
            no_prior: 'Geen eerdere cycli beschikbaar.',
            linked_success: 'Vorige cyclus gekoppeld.',
        },
        digest_table: {
            module: 'Module',
            entity_type: 'Entiteitstype',
            change_type: 'Type wijzigen',
            description: 'Beschrijving',
            changed_at: 'Gewijzigd op',
        },
        view_related_ric: 'Bekijk gerelateerde RIC-cases',
        linked_program: 'Gekoppeld programma',
        nav_raci: 'RACI-matrix',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Concept reactie',
            drafting: 'Opstellen…',
            results_heading: 'Opgestelde antwoorden ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            counsel_label: 'Beoordeling door een raadsman vereist:',
            counsel_default: 'Voor ten minste één antwoord is beoordeling door een raadsman vereist voordat het wordt verzonden.',
            requires_counsel_label: 'Vereist advies van een raadsman.',
            accept_label: 'Concept accepteren',
            reject_label: 'Concept afwijzen',
            error_generic: 'Kan het antwoord niet opstellen. Probeer het opnieuw of verfijn de aanvraagtekst.',
        },
        breach_timeline: {
            compute_label: 'Tijdlijn voor meldingen van inbreuken op computers',
            computing: 'Computergebruik…',
            results_heading: 'Deadline voor melding van inbreuk ([TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            handoff_label: 'Forseti suggereert:',
            empty_label: 'Geen toepasselijke kaders voor de betrokken rechtsgebieden.',
            mandatory_label: 'Verplichte velden:',
            draft_label: 'Kennisgeving concept',
            remaining_label: '[[TOK_1]]u resterend',
            overdue_label: 'ACHTERLIJK door',
            acknowledge_label: 'Erkennen: taken die extern zijn gemaakt',
            acknowledging: 'Erkennen…',
            error_generic: 'Kan de tijdlijn van de inbreuk niet berekenen. Probeer het opnieuw.',
        },
        breach_determination: {
            confirmed_breach: 'Bevestigd Inbreuk',
            suspected_breach: 'Verdacht Inbreuk',
            not_a_breach: 'Niet een Inbreuk',
            pending: 'In afwachting',
        },
        errors: {
            fetch: 'Kan niet load incidenten..',
            save: 'Kan niet save incident..',
            fetch_failed: 'Kan niet fetch incidenten..',
            save_failed: 'Kan niet save incident..',
            transition_failed: 'Kan niet transition incident..',
            close_failed: 'Kan niet close incident..',
            fetch_timeline_failed: 'Kan niet fetch tijdlijn..',
            fetch_decisions_failed: 'Kan niet fetch decisions..',
            triage_failed: 'Kan niet update triage..',
            impact_update_failed: 'Kan niet update impact beoordeling..',
            breach_update_failed: 'Kan niet update breach beoordeling..',
            create_timeline_failed: 'Kan niet create tijdlijn item..',
            create_decision_failed: 'Kan niet create beslissing..',
            notification_update_failed: 'Kan niet update melding..',
            fetch_tasks_failed: 'Kan niet fetch taken..',
            create_task_failed: 'Kan niet create taak..',
            update_task_status_failed: 'Kan de taakstatus niet bijwerken.',
            update_checklist_failed: 'Kan niet update checklist..',
            assign_task_failed: 'Kan niet assign taak..',
            escalate_task_failed: 'Kan niet escalate taak..',
            fetch_templates_failed: 'Kan niet fetch sjablonen..',
            permission_denied: 'U hebt geen toestemming om deze sectie te openen. Neem contact op met uw beheerder.',
        },
        harm_likelihood: {
            unlikely: 'Onwaarschijnlijk',
            possible: 'Mogelijk',
            likely: 'Waarschijnlijk',
            very_likely: 'Zeer Waarschijnlijk',
        },
        reported_via: {
            email: 'E-mail',
            phone: 'Telefoon',
            internal_system: 'Intern Systeem',
            third_party: 'Derde Party',
            automated_detection: 'Geautomatiseerd Detectie',
        },
        task_transition_labels: {
            start: 'Starten',
            complete: 'Voltooien',
            block: 'Blokkeren',
            defer: 'Uitstellen',
        },
        transition_labels: {
            start: 'Starten',
            complete: 'Voltooien',
            block: 'Blokkeren',
            defer: 'Uitstellen',
        },
        nav: {
            all: 'Alle incidenten',
            tasks: 'Responstaken',
            reports: 'Rapporten',
            breach_notifications: 'Inbreukmeldingen',
            supplements: 'Aanvullingen',
            remediation: 'Herstelmaatregelen',
            authority_requests: 'Autoriteitsverzoeken',
            disclosure_register: 'Openbaarmakingsregister',
        },
        list: {
            page_title: 'Incidenten',
            title: 'Incidenten',
            new: 'Nieuw incident',
            edit: 'Incident bewerken',
            incident_title: 'Titel',
            severity: 'Ernst',
            reported_at: 'Gemeld op',
            reported_by: 'Gemeld door',
            assigned_to: 'Toegewezen aan',
            view_detail: 'Detail bekijken',
            reference: 'Referentie',
            lead: 'Leider',
            reported_via: 'Gerapporteerd Via',
            discovery_date: 'Ontdekking Datum',
            hide_details: 'Verbergen Details',
            close_incident: 'Sluiten Incident',
            close_justification_prompt: 'Gelieve provide een rechtvaardiging voor closing dit incident.',
            justification: 'Rechtvaardiging',
            lead_id: 'Leider ID',
            contact: 'Contactpersoon',
            category: 'Categorie',
            not_assessed: 'Niet assessed',
        },
        detail: {
            page_title: 'Incidentdetail',
            title: 'Incidentdetail',
            tabs: {
                overview: 'Overzicht',
                triage: 'Beoordeling',
                impact: 'Impactbeoordeling',
                breach: 'Datalekbeoordeling',
                timeline: 'Tijdlijn',
                decisions: 'Beslissingen',
                evidence: 'Bewijs',
                audit_trail: 'Audittraject',
            },
            evidence_upload_label: 'Bewijsbestand bijvoegen',
            evidence_uploaded: 'Bewijs geüpload',
            evidence_deleted: 'Bewijs verwijderd',
            evidence_delete_error: 'Bewijs verwijderen mislukt',
            evidence_uploaded_at: 'Geüpload',
            evidence_empty: 'Er zijn geen bewijsbestanden aan dit incident gekoppeld.',
            evidence_size: 'Grootte',
            triage_notes: 'Triagenotities',
            initial_classification: 'Initiële classificatie',
            individuals_affected: 'Aantal getroffen personen',
            data_categories: 'Betrokken gegevenscategorieën',
            systems_compromised: 'Gecompromitteerde systemen',
            geographic_scope: 'Geografische reikwijdte',
            breach_determination: 'Datalekbepaling',
            notification_required: 'Melding vereist',
            notification_deadline: 'Meldingstermijn',
            pdpc_reportable: 'Meldingsplichtig bij AP',
            add_timeline: 'Tijdlijnitem toevoegen',
            add_decision: 'Beslissing toevoegen',
            not_found: 'Incident not gevonden.',
            team_members: 'Team Leden',
            checklist: 'Controlelijst',
            completed: 'Voltooid',
            impact_severity_score: 'Calculated Impact Ernst Score',
            records_affected: 'Getroffen records',
            potential_consequences: 'Potentieel Gevolgen',
            harm_likelihood: 'Schade Waarschijnlijkheid',
            legal_basis: 'Juridisch Grondslag',
            jurisdictions: 'Jurisdicties',
            jurisdictions_comma: 'Jurisdicties (comma-separated)',
            jurisdiction: 'Jurisdictie',
            authority_status: 'Autoriteit Status',
            subject_status: 'Onderwerp Status',
            authority_deadline: 'Autoriteit Deadline',
            subject_deadline: 'Onderwerp Deadline',
            mark_authority_done: 'Markeren Autoriteit Done',
            mark_subject_done: 'Markeren Onderwerp Done',
            not_assessed: 'Niet assessed',
            event_type: 'Gebeurtenis Type',
            timestamp: 'Tijdstempel',
            actor: 'Betrokkene',
            no_timeline_events: 'No tijdlijn gebeurtenissen yet.',
            decision_type: 'Beslissing Type',
            decision: 'Beslissing',
            rationale: 'Motivering',
            decision_made: 'Beslissing Made',
            no_decisions: 'Nog geen beslissingen vastgelegd.',
            jurisdictions_comma_separated: 'VN, SG, EU',
            no_audit_events: 'Er zijn nog geen auditgebeurtenissen geregistreerd.',
            export_pdf: 'PDF exporteren',
            pdf_title: 'Incidentoverzicht',
            description: 'Beschrijving',
            linked_records: 'Gekoppelde Records',
        },
        tasks: {
            page_title: 'Incidentresponstaken',
            title: 'Incidentresponstaken',
            new: 'Nieuwe taak',
            edit: 'Taak bewerken',
            task_type: 'Type taak',
            assignee: 'Toegewezene',
            due_date: 'Uiterste datum',
            dependencies: 'Afhankelijkheden',
            mark_complete: 'Markeren als voltooid',
            templates: 'Taaksjablonen',
            select_incident: 'Incident selecteren',
            all_statuses: 'Alle statussen',
            all_categories: 'Alle categorieën',
            new_response_task: 'Nieuwe responstaak',
            category: 'Categorie',
            priority: 'Prioriteit',
            depends_on: "Afhankelijk van (kommagescheiden taak-ID's)",
            checklist_items: 'Checklistitems',
            remove: 'Verwijderen',
            add: 'Toevoegen',
            new_checklist_item: 'Nieuw checklistitem',
            no_templates: 'Geen sjablonen beschikbaar.',
            assign_task: 'Taak toewijzen',
            assign_to: 'Toewijzen aan',
            assign: 'Toewijzen',
            select_incident_prompt: 'Selecteer een incident om de responstaken te bekijken.',
            checklist: 'Controlelijst',
            hide_checklist: 'Checklist verbergen',
            escalate: 'Escaleren',
            escalations: 'Escalaties',
            no_checklist_items: 'Geen checklistitems.',
        },
        reports: {
            page_title: 'Incidentrapporten',
            title: 'Incidentrapporten',
            summary: 'Samenvattingsstatistieken',
            by_severity: 'Op ernst',
            by_status: 'Op status',
            recent: 'Recente incidenten',
            total_incidents: 'Totaal aantal incidenten',
            open: 'Geopend',
            closed: 'Gesloten',
            export_csv: 'CSV exporteren',
            export_pdf: 'PDF exporteren',
            export_success: 'Rapport succesvol geëxporteerd.',
            export_error: 'Rapport exporteren mislukt.',
            reference: 'Referentie',
            view_report: 'Rapport bekijken',
        },
        statuses: {
            reported: 'Gemeld',
            triage: 'Beoordeling',
            contained: 'Ingeperkt',
            investigation: 'Onderzoek',
            remediation: 'Herstel',
            closed: 'Gesloten',
            false_positive: 'Vals positief',
        },
        task_statuses: {
            pending: 'In afwachting',
            in_progress: 'In uitvoering',
            completed: 'Voltooid',
            blocked: 'Geblokkeerd',
            cancelled: 'Geannuleerd',
        },
        severity: {
            low: 'Laag',
            medium: 'Gemiddeld',
            high: 'Hoog',
            critical: 'Kritiek',
        },
        task_types: {
            containment: 'Inperking',
            investigation: 'Onderzoek',
            remediation: 'Herstel',
            communication: 'Communicatie',
            documentation: 'Documentatie',
            notification: 'Melding',
        },
        categories: {
            data_breach: 'Gegevens Inbreuk',
            unauthorized_access: 'Ongeautoriseerd Toegang',
            data_loss: 'Gegevens Loss',
            system_compromise: 'Systeem Compromise',
            malware: 'Schadelijke software',
            phishing: 'Phishing-aanval',
            insider_threat: 'Insider-bedreiging',
            other: 'Overig',
        },
        reported_via_options: {
            email: 'E-mail',
            phone: 'Telefoon',
            internal_system: 'Intern Systeem',
            third_party: 'Derde Party',
            automated_detection: 'Geautomatiseerd Detectie',
        },
        harm_likelihood_options: {
            unlikely: 'Onwaarschijnlijk',
            possible: 'Mogelijk',
            likely: 'Waarschijnlijk',
            very_likely: 'Zeer Waarschijnlijk',
        },
        breach_determination_options: {
            confirmed_breach: 'Bevestigd Inbreuk',
            suspected_breach: 'Verdacht Inbreuk',
            not_a_breach: 'Niet een Inbreuk',
            pending: 'In afwachting',
        },
        timeline_event_types: {
            detection: 'Detectie',
            escalation: 'Escalatie',
            containment: 'Inperking',
            investigation_start: 'Onderzoek Starten',
            evidence_collected: 'Bewijs Collected',
            notification_sent: 'Melding Sent',
            remediation_action: 'Herstel Actie',
            status_change: 'Status Wijzigen',
            communication: 'Communicatie',
            other: 'Overig',
        },
        decision_types: {
            containment: 'Inperking',
            notification: 'Melding',
            remediation: 'Herstel',
            escalation: 'Escalatie',
            closure: 'Afsluiting',
            other: 'Overig',
        },
        task_transitions: {
            start: 'Starten',
            complete: 'Voltooien',
            block: 'Blokkeren',
            cancel: 'Annuleren',
            unblock: 'Deblokkeren',
        },
        announce: {
            loaded: '[[TOK_1]] incidenten geladen',
            reports_loaded: '[[TOK_1]] incidentrapporten geladen',
            tasks_loaded: '[[TOK_1]] taken geladen',
            created: 'Incident succesvol aangemaakt',
            updated: 'Incident succesvol bijgewerkt',
            closed: 'Incident succesvol afgesloten',
            status_changed: 'Incidentstatus gewijzigd',
            triage_completed: 'Triage succesvol afgerond',
            impact_updated: 'Effectbeoordeling bijgewerkt',
            breach_updated: 'Beoordeling van inbreuk bijgewerkt',
            timeline_added: 'Tijdlijngebeurtenis toegevoegd',
            decision_recorded: 'Beslissing vastgelegd',
            notification_updated: 'Meldingsstatus bijgewerkt',
            task_created: 'Taak is succesvol aangemaakt',
            task_status_changed: 'Taakstatus gewijzigd',
            checklist_completed: 'Controlelijstitem voltooid',
            checklist_unchecked: 'Controlelijstitem uitgeschakeld',
            task_assigned: 'Taak toegewezen',
            task_escalated: 'Taak geëscaleerd',
            export_initiated: 'Export gestart',
        },
        breach_notifications: {
            page_title: 'Meldingen van inbreuken',
            title: 'Meldingen van inbreuken',
            new_notification: 'Nieuwe melding',
            no_notifications: 'Geen inbreukmeldingen gevonden',
            status: 'Status',
            submit_to_mps: 'Verzenden naar [[TOK_0]]',
            decision: 'Besluit',
            decision_maker: 'Beslisser',
            notify: 'Informeer',
            do_not_notify: 'Niet op de hoogte stellen',
            rationale: 'Reden',
            filing_deadline: 'Deadline indiening',
            overdue: 'Achterstallig',
            due_soon: 'Bijna verlopen',
            on_track: 'Op schema',
            legal_review: 'Juridische beoordeling',
            incident_id: 'Incident-ID',
            notification_statuses: {
                assessment: 'Beoordeling',
                decision_to_notify: 'Besluit tot kennisgeving',
                notification_drafted: 'Kennisgeving opgesteld',
                legal_review: 'Juridische beoordeling',
                submitted_to_mps: 'Ingediend bij [[TOK_0]]',
                supplement_requested: 'Supplement gevraagd',
                supplement_submitted: 'Aanvulling ingediend',
                acknowledged: 'Erkend',
                closed: 'Gesloten',
            },
        },
        supplements: {
            page_title: 'Aanvullingsverzoeken',
            title: 'Aanvullingsverzoeken',
            new_supplement: 'Nieuw supplement',
            no_supplements: 'Geen aanvullingsverzoeken gevonden',
            request_details: 'Details aanvragen',
            response_package: 'Reactiepakket',
            submit_response: 'Reactie verzenden',
            deadline: 'Deadline',
            notification_id: 'Meldings-ID',
            enter_notification_id: 'Voer een meldings-ID in om supplementen te bekijken.',
            supplement_statuses: {
                requested: 'Gevraagd',
                drafting: 'Opstellen',
                submitted: 'Ingezonden',
                accepted: 'Geaccepteerd',
                rejected: 'Afgewezen',
            },
        },
        remediation: {
            page_title: 'Herstelacties',
            title: 'Herstelacties',
            new_action: 'Nieuwe actie',
            no_actions: 'Geen herstelacties gevonden',
            description: 'Beschrijving',
            owner: 'Eigenaar',
            department: 'Afdeling',
            deadline: 'Deadline',
            statuses: {
                planned: 'Gepland',
                in_progress: 'In uitvoering',
                completed: 'Voltooid',
                verified: 'Geverifieerd',
            },
            verify: 'Verifieer',
            incident_id: 'Incident-ID',
            enter_incident_id: 'Voer een incident-ID in om herstelacties te bekijken.',
            start: 'Begin',
            complete_action: 'Voltooien',
        },
        authority_requests: {
            page_title: 'Autoriteitsverzoeken',
            title: 'Autoriteitsverzoeken',
            new_request: 'Nieuw verzoek',
            no_requests: 'Geen autoriteitsverzoeken gevonden',
            authority_name: 'Naam autoriteit',
            request_details: 'Details aanvragen',
            response_package: 'Reactiepakket',
            submission_channel: 'Inzendingskanaal',
            submit_response: 'Reactie verzenden',
            deadline: 'Deadline',
            confirmation: 'Bevestiging',
            incident_id_optional: 'Incident-ID (optioneel)',
            response_context_label: 'Antwoordcontext (voor materialisatie van indieningsdocument)',
            response_context_none: '(materialisatie overslaan)',
            response_context_supplement: 'Aanvullend antwoord',
            response_context_information: 'Antwoord op informatieverzoek',
            response_context_inspection: 'Antwoord op inspectie',
            materialisation_status_column: 'Indieningsdocument',
            materialisation_pending: 'In behandeling',
            materialisation_success: 'Gematerialiseerd',
            materialisation_failed: 'Mislukt',
            materialisation_retry_button: 'Opnieuw proberen',
            ar_statuses: {
                received: 'Ontvangen',
                verified: 'Geverifieerd',
                assembling: 'Montage',
                submitted: 'Ingediend',
                closed: 'Gesloten',
            },
        },
        disclosure_register: {
            page_title: 'Openbaarmakingsregister',
            title: 'Openbaarmakingsregister',
            new_entry: 'Nieuwe invoer',
            no_entries: 'Geen openbaarmakingsregistergegevens gevonden',
            disclosure_type: 'Openbaarmakingstype',
            disclosure_date: 'Datum van openbaarmaking',
            recipient: 'Ontvanger',
            authority_name: 'Naam autoriteit',
            channel: 'Kanaal',
            content_summary: 'Samenvatting van de inhoud',
            incident_id_optional: 'Incident-ID (optioneel)',
        },
    },
    onboarding: {
        nav: {
            wizard: 'Installatiewizard',
            tours: 'Modulerondleidingen',
            sample_data: 'Voorbeeldgegevens',
        },
        wizard: {
            title: 'Installatiewizard',
            welcome: 'Welkom bij AesirX ComplianceOne',
            welcome_message: 'Laten we uw organisatie instellen. Deze wizard begeleidt u door de initiële configuratie.',
            setup_complete: 'Installatie voltooid',
            skipped_message: 'De installatiewizard is overgeslagen. U kunt deze op elk moment uitvoeren om uw organisatie te configureren.',
            start_setup: 'Installatie starten',
            skip_wizard: 'Wizard overslaan',
            go_to_admin: 'Ga naar Beheerder',
            skip_for_now: 'Voorlopig overslaan',
            next_step: 'Volgende stap',
            previous_step: 'Vorige stap',
            finish_setup: 'Installatie voltooien',
            rerun: 'Installatiewizard opnieuw uitvoeren',
            step_label: 'Stap {number}',
            validation_org_name_required: 'Organisatienaam is verplicht.',
            validation_admin_email_required: 'E-mail van de beheerder is verplicht.',
            validation_admin_email_invalid: 'Voer een geldig e-mailadres in.',
            validation_cmp_endpoint_required: 'CMP-eindpunt is verplicht wanneer CMP is ingeschakeld.',
            steps: {
                license_activation: 'Licentie activatie',
                org_profile: 'Organisatieprofiel',
                module_selection: 'Moduleselectie',
                cmp_integration: 'CMP-integratie',
                notification_preferences: 'Meldingen',
                review: 'Beoordelen & bevestigen',
            },
            step_descriptions: {
                license_activation: 'Voer uw licentiesleutel in om uw pakket te activeren en te bepalen welke modules beschikbaar zijn.',
                org_profile: 'Stel de organisatienaam, jurisdictie, sector, omvang en voorkeurstaal in.',
                module_selection: 'Kies welke compliancemodules geactiveerd moeten worden voor uw organisatie.',
                cmp_integration: 'Configureer de integratie met het Consent Management Platform (optioneel).',
                notification_preferences: 'Configureer hoe u meldingen ontvangt voor compliance-gebeurtenissen.',
                review: 'Controleer uw configuratie en rond de installatie af.',
            },
            license_step: {
                validate_button: 'Valideer licentie',
                skip_warning: 'Moduletoegang is beperkt tot de standaard pakketlaag. U kunt een licentie later activeren in Platform > Licentie-instellingen.',
            },
            module_descriptions: {
                rights_requests: 'Verwerk verzoeken om toegang tot en verwijdering van persoonsgegevens.',
                data_mapping: 'Breng systemen, gegevensstromen en verwerkingsactiviteiten in kaart.',
                governance: 'Beheer leverancierscompliance en verwijderingsprocedures.',
                consent: 'Beheer toestemmingsbeleid en doelcatalogi.',
                consent_properties: 'Beheer toestemming over meerdere digitale eigendommen.',
                assessments: 'Voer impactbeoordelingen en grensoverschrijdende gegevensoverdrachten uit.',
                classification: 'Classificeer en label gegevensactiva met levenscyclustracking.',
                monitoring: 'Geplande compliancebeoordelingen en KPI-tracking.',
                incidents: 'Meld en beheer beveiligings- en privacyincidenten.',
                connectors: 'Maak verbinding met externe systemen voor geautomatiseerde gegevensuitwisseling.',
                vendor_risk: 'Scoor leveranciers, volg contracten en beheer due diligence.',
                deletion_orchestration: 'Coördineer gegevensverwijdering over systemen en leveranciers.',
                discovery: 'Ontdek en classificeer gegevens in uw hele infrastructuur.',
                incident_ops: 'Geavanceerde incidentdraaiboeken, SLA-tracking en escalaties.',
                program_governance: 'Volwassenheidsbeoordelingen, managementrapportage en auditgereedheid.',
                access_accountability: 'Monitor gebruikerstoegang, sessies en rechtvaardigingsworkflows.',
                localization: 'Marktspecifieke compliancepakketten en regelgevingskaders.',
                partner_workspace: 'Partner- en wederverkoperwerkruimte.',
                privacy_scanner: 'Realtime privacymonitoring van digitale eigendommen.',
                onboarding: 'Installatiewizard, rondleidingen en beheer van voorbeeldgegevens.',
                compliance_forms: 'Interactieve compliancesjablonen en documentgeneratie.',
                audit_trail: 'Uitgebreide onveranderlijke auditlogboekregistratie en bewaring.',
                organizations: 'Multi-organisatie- en groepsbeheer.',
                task_management: 'Geïntegreerde taakplanning, workflowengine en agendaweergaven.',
            },
            module_categories: {
                data_privacy_rights: 'Gegevensprivacy en rechten',
                vendor_third_party: 'Beheer van leveranciers en derden',
                risk_assessment: 'Risico en beoordeling',
                operations_automation: 'Operaties & Automatisering',
                platform_admin: 'Platform & Administratie',
            },
            package_tier_label: 'Uw Pakket',
            package_module_unavailable: 'Niet inbegrepen in uw pakket',
            select_all: 'Alles Selecteren',
            deselect_all: 'Alles Deselecteren',
            load_sample_data: 'Voorbeeldgegevens laden na installatie',
            load_sample_data_description: 'Installeer realistische demogegevens (Lotus Financial Services) om het platform te verkennen. Kan later worden verwijderd via Onboarding > Voorbeeldgegevens.',
            language_label: 'Voorkeurstaal',
            language_description: 'Kies de standaardtaal voor uw organisatie.',
            admin_account_title: 'Beheerdersaccount',
            admin_account_created: 'Beheerdersaccount aangemaakt',
            admin_full_name: 'Volledige naam',
            admin_email: 'E-mailadres',
            admin_password: 'Wachtwoord',
            admin_confirm_password: 'Wachtwoord bevestigen',
            admin_show_password: 'Wachtwoord tonen',
            admin_hide_password: 'Wachtwoord verbergen',
            admin_name_placeholder: 'bijv. Jane Smit',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Minimaal 8 tekens',
            admin_password_confirm_placeholder: 'Wachtwoord opnieuw invoeren',
            validation_admin_name_required: 'Beheerdersnaam is verplicht',
            validation_admin_password_required: 'Wachtwoord is verplicht',
            validation_admin_password_min_length: 'Wachtwoord moet minimaal 8 tekens bevatten',
            validation_passwords_mismatch: 'Wachtwoorden komen niet overeen',
            notification_email_enabled: 'E-mailmeldingen Inschakelen',
            notification_email_description: 'Ontvang e-mailmeldingen over taaktoewijzingen, SLA-schendingen en compliance-gebeurtenissen.',
            notification_digest_frequency: 'Samenvattingsfrequentie',
            notification_digest_daily: 'Dagelijks',
            notification_digest_weekly: 'Wekelijks',
            notification_digest_none: 'Geen samenvatting',
            notification_in_app_enabled: 'Platformmeldingen Inschakelen',
            notification_in_app_description: 'Toon meldingsbadge en -lade voor realtimewaarschuwingen.',
            jurisdictions: {
                vietnam: 'Vietnam',
                asean: 'ASEAN',
                eu_eea: 'EU/EER',
                global: 'Wereldwijd',
            },
            languages: {
                en: 'Engels',
                vi: 'Tiếng Việt',
                da: 'Dansk',
                sv: 'Zweeds',
                nb: 'Norsk Bokmal',
                nn: 'Norsk Nynorsk',
                de: 'Duits',
                fi: 'Suomi',
                nl: 'Nederlands',
                fr: 'Frans',
                lb: 'Lëtzebuergesch',
                ga: 'Gaeilge',
                es: 'Spaans',
                ca: 'Català',
                eu: 'Euskara',
                pt: 'Portugees',
            },
            industries: {
                financial_services: 'Financiële dienstverlening',
                healthcare: 'Gezondheidszorg',
                technology: 'Technologie',
                telecommunications: 'Telecommunicatie',
                government: 'Overheid',
                education: 'Onderwijs',
                manufacturing: 'Productie',
                retail: 'Detailhandel',
                other: 'Overig',
            },
            placeholders: {
                org_name: 'bijvoorbeeld Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'gebruiker1@bedrijf.vn, gebruiker2@bedrijf.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Organisatienaam',
                jurisdiction: 'Jurisdictie',
                industry: 'Branche',
                org_size: 'Organisatiegrootte',
                language: 'Voorkeurstaal',
                admin_email: 'E-mail beheerder',
                team_emails: 'E-mailadressen teamleden (kommagescheiden)',
                enable_cmp: 'CMP-integratie inschakelen',
                cmp_endpoint: 'CMP API-eindpunt',
                email_notifications: 'E-mailmeldingen',
                in_app_notifications: 'Platformmeldingen',
                digest_frequency: 'Samenvattingsfrequentie',
            },
        },
        tours: {
            title: 'Modulerondleidingen',
            start: 'Rondleiding starten',
            continue_tour: 'Rondleiding voortzetten',
            replay: 'Rondleiding herhalen',
            exit: 'Rondleiding verlaten',
            skip: 'Rondleiding overslaan',
            next: 'Volgende',
            previous: 'Vorige',
            finish: 'Rondleiding voltooien',
            step_of: 'Stap {current} van {total}',
            info: 'Volg begeleide rondleidingen door elke module om de belangrijkste functies en workflows te leren kennen. Rondleidingen kunnen op elk moment worden herhaald.',
            autoplay: 'Automatisch afspelen',
            interactive: 'Interactief',
            play_all: 'Speel alles',
            search_tours: 'Rondleidingen zoeken...',
            duration: 'Duur',
            steps_label: '[[TOK_1]] stappen',
            mode: 'Modus',
            pause: 'Pauze',
            resume: 'Hervatten',
            speed: 'Snelheid',
            restart: 'Opnieuw opstarten',
            reset: 'Opnieuw instellen',
            reset_success: 'De voortgang van de tour is gereset.',
            category_core_privacy: 'Kernprivacy',
            category_governance: 'Bestuur',
            category_operations: 'Operaties',
            category_platform: 'Platform',
            category_advanced: 'Geavanceerd',
            category_data_privacy_rights: 'Gegevensprivacy en rechten',
            category_vendor_third_party: 'Beheer van leveranciers en derden',
            category_risk_assessment: 'Risico en beoordeling',
            category_operations_automation: 'Operaties & Automatisering',
            category_platform_admin: 'Platform & Administratie',
            steps_count: '[[TOK_1]] stappen',
        },
        sample_data: {
            title: 'Voorbeeldgegevensbeheer',
            select_modules: 'Modules selecteren',
            current_status: 'Huidige status',
            operation_history: 'Bewerkingsgeschiedenis',
            load: 'Voorbeeldgegevens laden',
            clear: 'Voorbeeldgegevens wissen',
            processing: 'Verwerken...',
            loaded: 'Geladen',
            not_loaded: 'Niet geladen',
            records: 'Voorbeeldrecords',
            confirm_clear: 'Weet u zeker dat u alle voorbeeldgegevens voor de geselecteerde modules wilt wissen?',
            confirm_clear_title: 'Voorbeeldgegevens wissen',
            confirm_load_title: 'Voorbeeldgegevens laden',
            confirm_load: 'Weet u zeker dat u voorbeeldgegevens wilt laden voor de geselecteerde modules?',
            action_load: 'Laden',
            action_clear: 'Wissen',
            info: 'Laad realistische demogegevens voor training en demonstraties met het fictieve bedrijf "Lotus Financial Services". Voorbeeldgegevens zijn getagd en kunnen veilig worden verwijderd zonder echte gegevens te beïnvloeden.',
        },
        help: {
            title: 'Helpcentrum',
            search: 'Zoeken',
            search_placeholder: 'Zoek in helpartikelen...',
            clear: 'Wissen',
            all_categories: 'Alle categorieën',
            all_modules: 'Alle Modules',
            back: 'Terug naar helpcentrum',
            callout_important: 'Belangrijk',
            callout_tip: 'Tip',
            no_results: 'Geen artikelen gevonden die overeenkomen met uw zoekopdracht.',
            no_articles: 'Nog geen helpartikelen beschikbaar. Artikelen verschijnen hier zodra inhoud wordt toegevoegd.',
            results_for: '{count} resultaat/resultaten voor "{query}"',
            quick_links: {
                getting_started: 'Aan de slag',
                getting_started_desc: 'Installatie, configuratie en snelstartgids.',
                user_guide: 'Gebruikershandleiding',
                user_guide_desc: 'Module-voor-module gebruiksdocumentatie.',
                admin_guide: 'Beheerdershandleiding',
                admin_guide_desc: 'Configuratie, onderhoud en probleemoplossing.',
                faq: 'Veelgestelde vragen',
                faq_desc: 'Veelgestelde vragen en antwoorden.',
            },
            search_articles_aria: 'Zoek hulpartikelen',
            article_metadata_aria: 'Artikelmetadata',
            articles_list_aria: 'Hulpartikelen',
            category_nav_aria: 'Categorienavigatie',
            quick_links_aria: 'Snellinks naar helpcategorieën',
            returned_to_list: 'Terug naar artikellijst',
            opening_article: 'Artikel openen: {title}',
            read_article_aria: 'Artikel lezen: {title}',
            pagination_nav_aria: 'Paginering van artikelen',
            error_unavailable: 'Het helpcentrum is momenteel niet beschikbaar. Probeer het later opnieuw.',
            retry: 'Opnieuw proberen',
        },
    },
    common: {
        save: 'Opslaan',
        cancel: 'Annuleren',
        system_actor: 'Systeem',
        delete: 'Verwijderen',
        edit: 'Bewerken',
        create: 'Aanmaken',
        update: 'Bijwerken',
        loading: 'Laden...',
        error: 'Er is een fout opgetreden',
        success: 'Gelukt',
        logout: 'Uitloggen',
        actions: 'Acties',
        retrying: 'Opnieuw proberen…',
        permission_denied: 'U heeft geen toegang tot deze pagina.',
        status: 'Toestand',
        description: 'Beschrijving',
        name: 'Naam',
        created_at: 'Aangemaakt op',
        updated_at: 'Bijgewerkt op',
        yes: 'Ja',
        no: 'Nee',
        confirm: 'Bevestigen',
        back: 'Terug',
        next: 'Volgende',
        previous: 'Vorige',
        search: 'Zoeken',
        filter: 'Filteren',
        page_x_of_y: 'Pagina [[TOK_2]] van [[TOK_3]]',
        pagination_label: 'Paginering',
        view_mode_label: 'Weergavemodus',
        export: 'Exporteren',
        exporting: 'Bezig met exporteren…',
        sidebar_navigation: 'Beheer-navigatiebalk',
        items_count: '[[TOK_1]] artikelen',
        items_count_one: '[[TOK_1]] artikel',
        export_success: 'Document succesvol gegenereerd.',
        generate_pdf: 'PDF genereren',
        import: 'Importeren',
        download: 'Downloaden',
        upload: 'Uploaden',
        view: 'Bekijken',
        close: 'Sluiten',
        submit: 'Indienen',
        saved: 'Opgeslagen',
        saving: 'Opslaan...',
        submitting: 'Verzenden...',
        created: 'Aangemaakt',
        all: 'Alle',
        none: 'Geen',
        select: 'Selecteren',
        select_user: 'Gebruiker selecteren...',
        custom_input: 'Handmatig invoeren',
        required: 'Verplicht',
        optional: 'Optioneel',
        notes: 'Notities',
        tags: 'Labels',
        archive: 'Archiveren',
        clone: 'Klonen',
        refresh: 'Vernieuwen',
        retry: 'Opnieuw proberen',
        reset: 'Herstellen',
        add: 'Toevoegen',
        remove: 'Verwijderen',
        removing: 'Verwijderen…',
        attachment: 'Bijlage',
        upload_file: 'Bestand uploaden',
        upload_file_required: 'Bestand uploaden (verplicht)',
        select_entity_type_first: 'Selecteer eerst een entiteitstype',
        failed_to_remove_file: 'Bestand kon niet worden verwijderd.',
        entity_type_label: 'Entiteitstype',
        entity_label: 'Entiteit',
        entity_reference: 'Entiteitsreferentie',
        failed_to_load_entities: 'Entiteiten konden niet worden geladen',
        enable: 'Inschakelen',
        disable: 'Uitschakelen',
        no_data: 'Geen gegevens gevonden',
        confirm_delete: 'Weet u zeker dat u dit item wilt verwijderen?',
        confirm_action: 'Weet u zeker dat u wilt doorgaan?',
        save_success: 'Succesvol opgeslagen',
        save_error: 'Opslaan mislukt',
        delete_success: 'Succesvol verwijderd',
        delete_error: 'Verwijderen mislukt',
        hour: 'uur',
        hours: 'uren',
        load_error: 'Laden van gegevens mislukt',
        operation_error: 'Bewerking mislukt',
        something_went_wrong: 'Er is iets misgegaan',
        go_home: 'Naar overzicht',
        access_denied: 'Toegang geweigerd',
        no_permission: 'U heeft geen toestemming om deze pagina te openen.',
        no_permission_title: 'Onvoldoende rechten',
        no_permission_message: 'U heeft geen toestemming om deze pagina te openen.',
        unknown: 'Onbekend',
        back_to_dashboard: 'Terug naar overzicht',
        id: 'ID',
        type: 'Soort',
        date: 'Datum',
        created_by: 'Aangemaakt door',
        updated_by: 'Bijgewerkt door',
        page_of: 'Pagina {page} van {total}',
        showing_items: '{count} items weergegeven',
        items_per_page: 'Items per pagina',
        no_results: 'Geen records gevonden die aan uw filters voldoen',
        no_items: 'Geen items gevonden',
        sort_by: 'Sorteren op',
        ascending: 'Oplopend',
        descending: 'Aflopend',
        all_statuses: 'Alle statussen',
        all_types: 'Alle typen',
        all_categories: 'Alle categorieën',
        all_severities: 'Alle ernstniveaus',
        date_range: 'Datumbereik',
        from_date: 'Van',
        to_date: 'Tot',
        clear_filters: 'Filters wissen',
        apply_filters: 'Filters toepassen',
        save_changes: 'Wijzigingen opslaan',
        discard_changes: 'Wijzigingen verwerpen',
        confirm_discard: 'U heeft niet-opgeslagen wijzigingen. Wilt u deze verwerpen?',
        copy: 'Kopiëren',
        duplicate: 'Dupliceren',
        move: 'Verplaatsen',
        assign: 'Toewijzen',
        unassign: 'Toewijzing opheffen',
        approve: 'Goedkeuren',
        reject: 'Afwijzen',
        deleting: 'Verwijderen...',
        processing: 'Verwerken...',
        loading_page: 'Pagina laden...',
        operation_success: 'Bewerking succesvol voltooid',
        operation_failed: 'Bewerking mislukt. Probeer het opnieuw.',
        empty_dash: '—',
        network_error: 'Netwerkfout. Controleer uw verbinding.',
        session_expired: 'Sessie verlopen. Log opnieuw in.',
        test: 'Testen',
        pause: 'Pauzeren',
        resume: 'Hervatten',
        activate: 'Activeren',
        last_sync: 'Laatste synchronisatie',
        health: 'Status',
        email: 'E-mail',
        role: 'Rol',
        title: 'Titel',
        owner: 'Eigenaar',
        priority: 'Prioriteit',
        category: 'Categorie',
        details: 'Bijzonderheden',
        overview: 'Overzicht',
        configuration: 'Configuratie',
        history: 'Geschiedenis',
        new_item: 'Nieuw',
        edit_item: 'Bewerken',
        select_option: 'Selecteren...',
        total: 'Totaal',
        active: 'Actief',
        inactive: 'Inactief',
        enabled: 'Ingeschakeld',
        disabled: 'Uitgeschakeld',
        last_login: 'Laatste aanmelding',
        never: 'Nooit',
        password_changed: 'Wachtwoord gewijzigd. U wordt uitgelogd.',
        password_change_failed: 'Wachtwoord wijzigen mislukt',
        passwords_mismatch: 'Wachtwoorden komen niet overeen',
        install: 'Installeren',
        uninstall: 'Deïnstalleren',
        installed: 'Geïnstalleerd',
        available: 'Beschikbaar',
        catalog: 'Catalogus',
        published: 'Gepubliceerd',
        version: 'Versie',
        market: 'Markt',
        language: 'Taal',
        framework: 'Regelgevingskader',
        template: 'Sjabloon',
        connector_type: 'Connectortype',
        polling_interval: 'Polling-interval (minuten)',
        new_instance: 'Nieuwe instantie',
        change_password: 'Wachtwoord wijzigen',
        current_password: 'Huidig wachtwoord',
        new_password: 'Nieuw wachtwoord',
        confirm_password: 'Wachtwoord bevestigen',
        comments: 'Opmerkingen',
        completed: 'Voltooid',
        contact: 'Contactpersoon',
        hide: 'Verbergen',
        hide_details: 'Verbergen Details',
        label: 'Kenmerk',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'Toont',
        page: 'Pagina',
        preview: 'Voorbeeld',
        print: 'Afdrukken',
        show: 'Tonen',
        status_active: 'Actief',
        status_completed: 'Voltooid',
        status_draft: 'Concept',
        status_in_progress: 'In Voortgang',
        status_pending: 'In afwachting',
        view_details: 'Bekijken Details',
        all_priorities: 'Alle Priorities',
        pipeline: 'Werkstroom',
        all_requests: 'Alle Verzoeken',
        schedule: 'Plannen',
        deploy: 'Implementeren',
        rollback: 'Terugdraaien',
        advance_stage: 'Voortgang Fase',
        submit_for_approval: 'Indienen voor Goedkeuring',
        approval_log: 'Goedkeuring Logboek',
        approver: 'Goedkeurder',
        decision: 'Beslissing',
        decided_at: 'Beslist op',
        rollout_stages: 'Uitrol Fases',
        approval_comment: 'Goedkeuring Opmerking',
        optional_comment: 'Optioneel opmerking...',
        impact_summary: 'Impact Samenvatting',
        target_property_ids: "Doel Eigenschap ID's (comma-separated)",
        policy_id: 'Beleid ID',
        target_version: 'Doel Versie',
        target_version_placeholder: 'bv. 2.0.0',
        scheduled_label: 'Gepland',
        scheduled_start: 'Gepland Starten',
        scheduled_end: 'Gepland Einde',
        properties_count: '{count} eigenschappen',
        results: 'Resultaten',
        comparison_results: 'Vergelijking Resultaten',
        past_comparison_reports: 'Vorige Vergelijking Rapporten',
        scanning: 'Scannen...',
        run_inconsistency_scan: 'Uitvoeren Inconsistentie Scannen',
        property_ids_label: "Eigenschap ID's (comma-separated, min 2)",
        comparison_type: 'Vergelijking Type',
        golden_template_id: 'Golden Sjabloon ID (optional)',
        leave_blank_compare: 'Leave blank naar compare eigenschappen against each other',
        add_notes_placeholder: 'Toevoegen your analysis opmerkingen here...',
        covered_of_active: '{covered} van {active} actief eigenschappen covered',
        fetch_error: 'Kan niet fetch gegevens. Probeer het opnieuw.',
        run_comparison_error: 'Kan niet uitvoering comparison. Probeer het opnieuw.',
        save_notes_error: 'Kan niet save opmerkingen. Probeer het opnieuw.',
        scan_complete: 'Inconsistentie scan completed successfully.',
        scan_error: 'Kan niet uitvoering inconsistency scan. Probeer het opnieuw.',
        min_two_properties: "Gelieve provide bij least 2 property ID's voor comparison.",
        comma_separated: 'kommagescheiden',
        language_english: 'Engels',
        language_vietnamese: 'Vietnamees',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Auteur',
        dependencies: 'Afhankelijkheden',
        checksum: 'Controlesom',
        changelog: 'Wijzigingslogboek',
        tier: 'Niveau',
        phone: 'Telefoon',
        launch: 'Starten',
        complete: 'Voltooien',
        back_to_list: 'Back naar Lijst',
        clear_selection: 'Wissen Selectie',
        deactivate: 'Deactiveren',
        scope: 'Bereik',
        deadline: 'Uiterste datum',
        progress: 'Voortgang',
        frequency: 'Frequentie',
        reviewer: 'Beoordelaar',
        user: 'Gebruiker',
        campaign: 'Campagne',
        items: 'Onderdelen',
        next_run: 'Volgende Uitvoeren',
        last_run: 'Laatste Uitvoeren',
        overdue: 'TE LAAT',
        creating: 'Aanmaken...',
        launching: 'Starten...',
        loaded: 'loaded',
        page_size: 'Paginagrootte',
        per_page: '/ pagina',
        urgent: 'Dringend',
        pagination: 'Paginering',
        metric: 'Metrisch',
        value: 'Waarde',
        country: 'Land',
        showing_chart_view: 'Grafiekweergave weergeven',
        showing_table_view: 'Gegevenstabelweergave weergeven',
        policies: 'Beleid',
        select_content_type: 'Selecteer ten minste één inhoudstype.',
        compliant: 'Conform',
        non_compliant_status: 'Niet-conform',
        all_data: 'Alle gegevens',
        sr_urgent: 'Dringend',
        n_per_page: '[[TOK_1]] / pagina',
        select_user_placeholder: '-- Selecteer gebruiker --',
        field_required: 'Dit veld is verplicht',
        results_found: 'resultaten gevonden',
        select_placeholder: '-- Selecteer --',
        unknown_user: 'Onbekende gebruiker',
        export_csv: 'CSV exporteren',
        not_applicable: 'N.v.t.',
        aria_overdue_since: 'Achterstallig sinds {date}',
        placeholders: {
            enter_justification: 'Invoeren rechtvaardiging',
            justification: 'Rechtvaardiging',
            campaign_name_example: 'Q1 2026 Toegang Beoordelen',
            optional_description: 'Optioneel beschrijving',
            enter_user_id: 'Invoeren de user ID van de reviewer',
            enter_user_id_short: 'Invoeren user ID',
            schedule_name_example: 'Kwartaal Toegang Attestering',
            enter_property_id: 'Invoeren property ID',
            enter_policy_id: 'Invoeren beleid ID',
            property_or_group_id: 'Eigenschap of groep ID',
            describe_template_purpose: 'Beschrijven de sjabloon purpose...',
            step_title: 'Stap title...',
            detailed_instructions: 'Gedetailleerde instructies...',
            filter_by_taxonomy_id: 'Filteren op Taxonomie ID...',
            describe_classification_rule: 'Beschrijven de classification regel...',
            describe_dedup_rule: 'Beschrijven de dedup regel...',
            describe_import_template: 'Beschrijven de import sjabloon...',
            reason_for_rejection: 'Reden voor rejection...',
            jurisdiction_codes_example: 'VN, SG, EU',
            filter_by_locale: 'Filteren op locale...',
            filter_by_event_type: 'Filteren op gebeurtenis type',
            filter_by_actor_id: 'Filteren op actor ID',
            filter_by_market_code: 'Filteren op market code...',
            filter_by_framework_id: 'Filteren op raamwerk ID...',
            add_comment: 'Toevoegen een opmerking...',
            provide_rejection_reason: 'Opgeven een reason voor rejecting dit indiening...',
            filter_by_jurisdiction: 'Filteren op jurisdiction code...',
            enter_report_title: 'Invoeren report title',
            enter_name: 'Invoeren naam',
            enter_description: 'Invoeren beschrijving',
            enter_org_id: 'Invoeren Org ID naar add',
            describe_evidence_gap: 'Beschrijven de bewijs hiaat...',
            expected_evidence: 'What bewijs is expected',
            entity_identifier: 'Entiteit identifier',
            remediation_steps: 'Stappen naar remediate dit hiaat',
            user_id_or_name: 'Gebruiker ID of naam',
            reporting_period_id: 'Rapportage periode ID',
            maturity_model_id: 'Volwassenheid model ID',
            describe_maturity_model: 'Beschrijven dit volwassenheid model...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Opgeven een reason voor denying dit request',
            describe_emergency: 'Beschrijven de emergency situation requiring elevated toegang (minimum 20 characters)',
            enter_delegate_id: 'Invoeren user ID van de delegate',
            provide_delegation_reason: 'Opgeven een reason voor dit delegation',
            client_identifier: 'Client-identificator',
            client_secret: 'Client-geheim',
            time_format: 'HH:MM',
            describe_sod_rule: 'Beschrijven de purpose van dit SoD regel...',
            enter_role_id: 'Invoeren role ID',
            explain_exception: 'Explain why dit exception is needed...',
            describe_compensating_controls: 'Beschrijven compensating controles in place...',
            full_name: 'Volledig naam',
            min_chars: 'Min. 12 chars',
            enter_override_justification: 'Invoeren rechtvaardiging voor overriding dit gate evaluatie',
            enter_evidence_id: 'Voer bewijs-ID in om te koppelen:',
            date_format: 'DD/MM/JJJJ',
            describe_pack_contents: 'Beschrijf de pakketinhoud en het doel',
            select_reviewers: 'Selecteer beoordelaars...',
        },
        aria_previous_page: 'Vorige pagina',
        aria_next_page: 'Volgende pagina',
        aria_results_per_page: 'Resultaten per pagina',
        per_page_25: '25 / pagina',
        per_page_50: '50 / pagina',
        per_page_100: '100 / pagina',
        select_language: 'Taal selecteren',
        today: 'Vandaag',
        tomorrow: 'Morgen',
        dashboard_load_error: 'Dashboard kon niet worden geladen. Probeer opnieuw.',
        enum_grade: {
            red: 'Rood',
            amber: 'Oranje',
            yellow: 'Geel',
            green: 'Groen',
        },
        enum_severity: {
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Gemiddeld',
            low: 'Laag',
        },
        enum_priority: {
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Gemiddeld',
            low: 'Laag',
        },
        enum_status: {
            pending: 'In afwachting',
            in_progress: 'Bezig',
            completed: 'Voltooid',
            blocked: 'Geblokkeerd',
            escalated: 'Geëscaleerd',
            cancelled: 'Geannuleerd',
            overdue: 'Achterstallig',
            not_started: 'Niet gestart',
            new: 'Nieuw',
            open: 'Openen',
            closed: 'Gesloten',
            acknowledged: 'Bevestigd',
            resolved: 'Opgelost',
        },
        enum_department: {
            unassigned: 'Niet toegewezen',
        },
        enum_form_category: {
            assessment: 'Beoordeling',
            assessment_report: 'Beoordelingsrapport',
            dpia: '[[TOK_0]]',
            authority_submission: 'Inzending van autoriteit',
            cross_border_transfer: 'Grensoverschrijdende overdracht',
            vendor: 'Verkoper',
            breach: 'Schending',
            consent: 'Toestemming',
            governance: 'Bestuur',
            register: 'Registreren',
            monitoring: 'Toezicht',
            dpa: 'DPA',
            dsr: 'DSR',
            privacy: 'Privacy',
            incident: 'Voorval',
            org: 'Organisatie',
            sector: 'Sector',
            classification: 'Classificatie',
            discovery: 'Ontdekking',
        },
        enum_module: {
            rights_requests: 'Rechtenverzoeken',
            assessments: 'Beoordelingen',
            incidents: 'Incidenten',
            incident_ops: 'Incidentoperaties',
            monitoring: 'Toezicht',
            vendor_risk: 'Leveranciersrisico',
            governance: 'Bestuur',
            deletion_orchestration: 'Verwijdering',
            access_review: 'Toegang tot beoordeling',
            consent: 'Toestemming',
            consent_properties: 'Toestemmingseigenschappen',
            forms: 'Formulieren',
            localization: 'Lokalisatie',
            program_governance: 'Programmabeheer',
            privacy_scanner: 'Privacyscanner',
            classification: 'Classificatie',
            discovery: 'Ontdekking',
            manual: 'Handmatig',
            data_mapping: 'Gegevens in kaart brengen',
        },
        enum_risk_level: {
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Gemiddeld',
            low: 'Laag',
        },
        enum_request_type: {
            all: 'All',
            access: 'Toegang ([[TOK_0]])',
            deletion: 'Verwijdering',
            correction: 'Correctie',
            objection: 'Bezwaar',
            portability: 'Draagbaarheid',
            restriction: 'Beperking',
            consent_withdrawal: 'Intrekking van toestemming',
        },
        enum_locale: {
            en: 'Engels',
            vi: 'Vietnamees',
            all: 'Beide',
        },
        enum_event_type: {
            case_created: 'Case gemaakt',
            status_changed: 'Status gewijzigd',
            case_assigned: 'Casus toegewezen',
            note_added: 'Opmerking toegevoegd',
            attachment_added: 'Bijlage toegevoegd',
            attachment_deleted: 'Bijlage verwijderd',
            reference_added: 'Referentie toegevoegd',
            checklist_updated: 'Controlelijst bijgewerkt',
            identity_verified: 'Identiteit geverifieerd',
            closure_summary_added: 'Samenvatting van de sluiting',
            approval_granted: 'Goedkeuring verleend',
            template_applied: 'Sjabloon toegepast',
            export_generated: 'Gegenereerd exporteren',
            sla_warning: '[[TOK_0]] Waarschuwing',
            sla_overdue: '[[TOK_0]] Te laat',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Verwijderd',
        draft: 'Concept',
        active: 'Actief',
        inactive: 'Inactief',
        pending: 'In afwachting',
        in_progress: 'In uitvoering',
        completed: 'Voltooid',
        archived: 'Gearchiveerd',
        published: 'Gepubliceerd',
        approved: 'Goedgekeurd',
        rejected: 'Afgewezen',
        cancelled: 'Geannuleerd',
        blocked: 'Geblokkeerd',
        deferred: 'Uitgesteld',
        not_started: 'Niet gestart',
        dismissed: 'Afgewezen',
        failed: 'Mislukt',
        in_review: 'In Beoordelen',
        deprecated: 'Afgeschreven',
        scheduled: 'Gepland',
        deploying: 'Implementeren',
        deployed: 'Geïmplementeerd',
        paused: 'Gepauzeerd',
        rolled_back: 'Teruggedraaid',
        received: 'Ontvangen',
        processing: 'Verwerking',
        under_assessment: 'Onder Beoordeling',
        implemented: 'Geïmplementeerd',
        pending_approval: 'In afwachting Goedkeuring',
        pending_deletion: 'In afwachting Deletion',
        on_hold: 'On Vasthouden',
        deleted: 'Verwijderd',
        expired: 'Verlopen',
        outdated: 'Verouderd',
        drifted: 'Afgeweken',
        decommissioned: 'Buiten gebruik',
        match: 'Matchen',
        different: 'Verschillend',
        missing: 'Ontbrekend',
        confirmed: 'Bevestigd',
        revoked: 'Ingetrokken',
        escalated: 'Geëscaleerd',
        system: 'Systeem',
        custom: 'Aangepast',
        warning: 'Waarschuwing',
        blocking: 'Blokkerend',
        analyst: 'Analist',
        viewer: 'Kijker',
        daily: 'Dagelijks',
        weekly: 'Wekelijks',
        policies: 'Beleid',
        denied: 'Geweigerd',
        verified: 'Geverifieerd',
        detected: 'Gedetecteerd',
        ignored: 'Genegeerd',
        open: 'Openen',
        resolved: 'Opgelost',
        suspended: 'Opgeschort',
        retired: 'Gepensioneerd',
        review: 'Beoordeling',
        generated: 'Gegenereerd',
        exported: 'Geëxporteerd',
    },
    severity: {
        low: 'Laag',
        medium: 'Gemiddeld',
        high: 'Hoog',
        critical: 'Kritiek',
    },
    sensitivity: {
        standard: 'Standaard',
        sensitive: 'Gevoelig',
        special_category: 'Bijzondere categorie',
        badge_sensitive: 'Gevoelig',
    },
    change_types: {
        policy_update: 'Beleid Bijwerken',
        new_binding: 'Nieuw Binding',
        remove_binding: 'Verwijderen Binding',
        configuration_change: 'Configuratie Wijzigen',
        banner_update: 'Banner Bijwerken',
    },
    comparison_types: {
        full: 'Volledig',
        banner_only: 'Alleen banner',
        purposes_only: 'Doelen Only',
        legal_bases_only: 'Juridisch Bases Only',
        consent_settings: 'Toestemming Instellingen',
    },
    lifecycle_stages: {
        active: 'Actief',
        archived: 'Gearchiveerd',
        pending_deletion: 'In afwachting Deletion',
        deleted: 'Verwijderd',
        on_hold: 'On Vasthouden',
    },
    object_types: {
        personal_data: 'Persoonlijk Gegevens',
        consent_record: 'Toestemming Record',
        user_account: 'Gebruiker Account',
        audit_log: 'Audit Logboek',
        document: 'Documentbestand',
        backup: 'Back-up',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Adequaatheid Beslissing',
        standard_contractual_clauses: 'Standaard Contractueel Clausules',
        binding_corporate_rules: 'Binding Corporate Regels',
        explicit_consent: 'Expliciet Toestemming',
        public_interest: 'Openbaar Belang',
        legal_claims: 'Juridisch Claims',
        vital_interests: 'Vitaal Interests',
    },
    risk_categories: {
        data_breach: 'Gegevens Inbreuk',
        unauthorized_access: 'Ongeautoriseerd Toegang',
        data_loss: 'Gegevens Loss',
        regulatory_non_compliance: 'Regelgevend Non-Compliance',
        third_party_risk: 'Third-Party Risico',
        operational: 'Operationeel',
        technical: 'Technisch',
        legal: 'Juridisch',
    },
    mitigation_types: {
        technical: 'Technisch',
        organizational: 'Organisatorisch',
        contractual: 'Contractueel',
        procedural: 'Procedureel',
    },
    safeguard_types: {
        encryption_in_transit: 'Versleuteling tijdens het transport',
        encryption_at_rest: 'Versleuteling in rust',
        access_controls: 'Toegangscontroles',
        contractual_clauses: 'Contractuele clausules',
        data_minimization: 'Gegevensminimalisatie',
        pseudonymization: 'Pseudonimisering',
        audit_rights: 'Auditrechten',
        breach_notification: 'Melding van inbreuk',
        data_localization: 'Gegevenslokalisatie',
        other: 'Anders',
    },
    scoring_methods: {
        weighted_average: 'Gewogen Gemiddeld',
        simple_average: 'Eenvoudig Gemiddeld',
        maximum: 'Maximumwaarde',
        manual: 'Handmatig',
    },
    dpa_status: {
        not_required: 'Niet vereist',
        required: 'Vereist',
        in_progress: 'In uitvoering',
        completed: 'Voltooid',
        signed: 'Ondertekend',
    },
    disposal_methods: {
        anonymize: 'Anonimiseren',
        pseudonymize: 'Pseudonimiseren',
        aggregate: 'Aggregeren',
        delete: 'Verwijderen',
    },
    dashboard: {
        title: 'Overzicht',
        no_data: 'Geen overzichtsgegevens beschikbaar.',
        no_data_heading: 'Nog geen live gegevens',
        no_data_detail: 'De overzichtswidgets hieronder tonen de indeling. Gegevens worden ingevuld zodra de backend is verbonden met de database.',
        consent_coverage: 'Toestemmingsdekking',
        ctia_filings: 'CTIA-meldingen',
        next_dpia_review: 'Volgende DPIA-beoordeling',
        next_review_none: 'Geen gepland',
        incident_mps_filings: 'Incident MPS-meldingen',
        compliance_score: 'Nalevingsscore',
        grade: 'Beoordeling',
        no_score: 'Nog geen nalevingsscore berekend.',
        rights_requests: 'Verzoeken om rechten',
        open: 'Geopend',
        sla_breached: 'SLA overschreden',
        sla_approaching: 'SLA nadert',
        closed_month: 'Gesloten (maand)',
        incidents: 'Incidenten & datalekken',
        active: 'Actief',
        breaches: 'Datalekken',
        overdue_tasks: 'Achterstallige taken',
        breach_72h_notice: 'Voor actieve inbreuken geldt een wettelijke kennisgevingstermijn van 72 uur',
        recommendations: 'Aanbevelingen',
        take_action: 'Onderneem actie',
        drift_events: 'Drift & goedkeuringen',
        open_events: 'Openstaande gebeurtenissen',
        pending_approvals: 'Wachtende goedkeuringen',
        monitoring: 'Monitoringtaken',
        programs: "Programma's",
        overdue: 'Achterstallig',
        pending: 'In afwachting',
        ric_cases: 'RIC-dossiers',
        coverage: 'Gegevensdekking',
        systems: 'Systemen',
        activities: 'Activiteiten',
        vendors: 'Leveranciers',
        dpias: "GEB's",
        open_gaps: 'openstaande lacunes',
        view_as_table: 'Weergeven als tabel',
        view_as_chart: 'Weergeven als grafiek',
        table_metric_header: 'Metriek',
        table_value_header: 'Waarde',
        announce_chart_view: 'Grafiekweergave wordt getoond',
        announce_table_view: 'Tabelweergave wordt getoond',
        section_core_metrics: 'Kernmetrieken',
        section_task_management: 'Taakbeheer',
        section_compliance_insights: 'Compliance-inzichten',
        configure_dashboard: 'Dashboard configureren',
        config_col_active: 'Actief',
        config_col_widget: 'Widget',
        collapse_section: 'Inklappen',
        expand_section: 'Uitklappen',
        reset_to_defaults: 'Standaardinstellingen herstellen',
        preferences_saved: 'Dashboard-instellingen opgeslagen',
        preferences_reset: 'Dashboard hersteld naar rolstandaard',
        preferences_load_error: 'Kan dashboard-instellingen niet laden',
        factor_avg_system_score: 'Gemiddelde systeemscore',
        factor_avg_vendor_score: 'Gemiddelde leveranciersscore',
        factor_processing_coverage: 'Dekking van verwerkingsactiviteiten',
        factor_ropa_completeness: 'RoPA-volledigheid',
        factor_drift_penalty: 'Straf voor driftevenementen',
        rec_improve_system_gov: 'Verbeter de documentatie voor systeembeheer',
        rec_improve_vendor_gov: 'Verbeter de documentatie over leveranciersbeheer',
        rec_document_processing: 'Documentverwerkingsactiviteiten voor ongedekte systemen',
        rec_generate_ropa: 'Genereer RoPA-records voor actieve verwerkingsactiviteiten',
        rec_resolve_drift: 'Los open kritieke en zeer ernstige driftgebeurtenissen op',
        score_good: 'Goed',
        score_fair: 'Redelijk',
        score_poor: 'Slecht',
        score_critical: 'Kritiek',
        drag_to_reorder: 'Sleep om te herordenen',
        widget_moved: 'Widget verplaatst',
        press_space_to_grab: 'Druk op spatie om vast te pakken, pijltjestoetsen om te verplaatsen, spatie om los te laten',
        reorder_instructions: 'Gebruik slepen en neerzetten of sneltoetsen om widgets te herordenen',
        task_widgets: {
            tasks_overview: 'Takenoverzicht',
            pending: 'In behandeling',
            in_progress: 'In uitvoering',
            overdue: 'Te laat',
            done_7d: 'Klaar (7d)',
            by_priority: 'Op prioriteit',
            view_all_tasks: 'Bekijk alle taken',
            upcoming_tasks: 'Aankomende taken (volgende 7 dagen)',
            no_upcoming: 'Er zijn geen taken gepland in de komende zeven dagen.',
            view_calendar: 'Bekijk Agenda',
            overdue_alerts: 'Te laat',
            no_overdue: 'Geen achterstallige taken. Alles ligt op schema.',
            assigned_to: 'Toegewezen aan',
            view_all_overdue: 'Bekijk alles Achterstallig',
            notifications: 'Recente meldingen',
            unread: 'unread',
            no_notifications: 'Geen meldingen. Jullie zijn allemaal ingehaald!',
            view_all_notifications: 'Bekijk alle meldingen',
            load_error: 'Gegevens konden niet worden geladen.',
            day_late: 'dag te laat',
            days_late_plural: 'dagen te laat',
            due_today: 'Vandaag verschuldigd',
            just_now: 'zojuist',
            minutes_short: 'm',
            hours_short: 'h',
            days_short: 'd',
            cross_org_stats: 'Statistieken van meerdere organisaties',
            by_organization: 'Per organisatie',
            overdue_across_orgs: 'achterstallige taken binnen organisaties',
            total: 'Totaal',
            tasks: 'tasks',
            organization: 'Organisatie',
            current_org: 'Huidige organisatie',
            all_orgs: 'Alle organisaties',
            all_organizations: 'Alle organisaties',
            filter_by_org: 'Filter op organisatie',
            cross_org: 'Cross-org',
            empty_calendar: 'Geen taken voor deze periode. Maak uw eerste taak of controleer uw filters.',
            empty_my_tasks: 'Er zijn geen taken toegewezen. Geweldig werk!',
            empty_overdue: 'Geen achterstallige taken. Alles ligt op schema.',
            empty_notifications: 'Geen meldingen. Jullie zijn allemaal ingehaald!',
            empty_workflows: 'Geen werkstromen geconfigureerd. Blader door sjablonen om aan de slag te gaan.',
        },
        my_tasks_widget: {
            title: 'Mijn Taken',
            no_tasks: 'Geen taken aan u toegewezen.',
            load_error: 'Taken konden niet worden geladen.',
            overdue: 'achterstallig',
            remaining: 'resterend',
            view_all: 'Alle Taken Bekijken',
        },
        my_section_status_widget: {
            title: 'Mijn Sectiestatus',
            overall_completion: 'Totaal',
            sections_count: 'Secties',
            no_sections: 'Geen secties toegewezen aan uw afdeling.',
            load_error: 'Sectiestatus kon niet worden geladen.',
        },
        revision_requests_widget: {
            title: 'Revisieaanvragen',
            no_revisions: 'Geen revisieaanvragen. Alle secties liggen op schema.',
            load_error: 'Revisieaanvragen konden niet worden geladen.',
        },
        consent_summary: {
            title: 'Toestemming',
            active: 'Actief',
            withdrawn_30d: 'Ingetrokken (30d)',
            expiring_7d: 'Verloopt (7d)',
        },
        transfer_assessments: {
            title: 'Overdracht van beoordelingen',
            open: 'Openen',
            approved: 'Goedgekeurd',
            gaps_flagged: 'Hiaten gemarkeerd',
        },
        breach_notifications: {
            title: 'Meldingen van inbreuken',
            deadline_72h: 'Deadline van 72 uur',
            submitted: 'Ingezonden',
            pending: 'In behandeling',
        },
        authority_requests: {
            title: 'Autoriteitsverzoeken',
            pending: 'In behandeling',
            overdue: 'Te laat',
            responded_30d: 'Gereageerd (30d)',
        },
        data_subjects_widget: {
            title: 'Betrokkenen',
            total: 'Totaal',
            high_risk: 'Hoog risico',
            active_30d: 'Actief (30d)',
        },
        audit_activity_summary: {
            title: 'Auditactiviteit',
            events_today: 'Evenementen vandaag',
            events_7d: 'Evenementen (7d)',
            unique_actors_30d: 'Unieke acteurs (30d)',
        },
        onboarding_progress: {
            title: 'Vooruitgang bij onboarding',
            completion_pct: 'Compleet',
            status_label: 'Status',
            current_step: 'Huidige stap',
            status: {
                in_progress: 'In uitvoering',
                completed: 'Voltooid',
                skipped: 'Overgeslagen',
                not_started: 'Niet gestart',
            },
        },
        sector_overlay_reports_due: {
            title: 'Sector Overlay Reports Due [NL]',
        },
        persona_widgets: {
            framework_filter: 'Filteren op kader',
            all_frameworks: 'Alle kaders',
            filing_lifecycle: 'Indieningslevenscyclus',
            filing_pipeline: 'Indieningspijplijn',
            draft: 'Diepgang',
            internal_review: 'Interne beoordeling',
            approved: 'Goedgekeurd',
            submitted: 'Ingezonden',
            supplement_requested: 'Supplement gevraagd',
            resubmitted: 'Opnieuw ingediend',
            accepted: 'Geaccepteerd',
            rejected: 'Afgewezen',
            closed: 'Gesloten',
            deadline: 'Deadline',
            days_remaining: 'resterende dagen',
            days_overdue: 'dagen te laat',
            no_filings: 'Geen actieve indieingen.',
            department_consolidation: 'Afdelingsconsolidatie',
            departments_completed: 'Afdelingen voltooid',
            departments_pending: 'Afdelingen in afwachting',
            departments_overdue: 'Afdelingen te laat',
            no_consolidation_cases: 'Geen afdelingsoverschrijdende zaken in behandeling.',
            vendor_risk: 'Leveranciers- en derdepartijrisico',
            pending_assessment: 'Wachtende beoordeling',
            overdue_questionnaires: 'Te late vragenlijsten',
            dpa_review_queue: 'DPA-beoordelingswachtrij',
            risk_distribution: 'Risicoverdeling',
            total_vendors: 'Totaal leveranciers',
            by_risk_level: 'Op risiconiveau',
            no_vendor_data: 'Geen leveranciersrisicogegevens beschikbaar.',
            discovery_summary: 'Gegevens ontdekken',
            discovery_classification: 'Gegevensontdekking en -classificatie',
            active_scans: 'Actieve scans',
            labels_pending: 'Etiketten in afwachting van beoordeling',
            exceptions_unresolved: 'Uitzonderingen onopgelost',
            pending_review: 'Wachtende beoordeling',
            exceptions: 'Uitzonderingen',
            approved_labels: 'Goedgekeurde labels',
            total_classified: 'Totaal geclassificeerd',
            no_discovery_data: 'Geen ontdekkingsgegevens beschikbaar.',
            ai_governance: 'AI-systeembestuur',
            systems_inventory: 'Systemen in inventaris',
            systems_in_inventory: 'Systemen in inventaris',
            classification_breakdown: 'Classificatie-uitsplitsing',
            dossier_completion: 'Dossiervoltooing',
            by_classification: 'Op classificatie',
            labeling_status: 'Labelstatus',
            not_started: 'Niet gestart',
            no_ai_data: 'Geen AI-bestuursgegevens beschikbaar.',
            breach_response: 'Inbreuk- en incidentrespons',
            active_breaches: 'Actieve inbreuken',
            notification_status: 'Meldingsstatus',
            remediation_progress: 'Herstelvoortgang',
            supplement_loops: 'Aanvullingslussen',
            no_breach_data: 'Geen actieve inbreukzaken.',
            audit_readiness: 'Audit- en beoordelingsgereedheid',
            assessments: 'Beoordelingen',
            gap_findings: 'Hiaatvindingen',
            evidence_completion: 'Bewijsvoltooing',
            export_ready: 'Klaar voor export',
            not_ready: 'Niet klaar',
            no_audit_data: 'Geen auditgereedheidsgegevens beschikbaar.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Cyberbeveiliging 2018',
            framework_label_vn_ecommerce: 'VN E-commerce 2023',
            framework_label_vn_telecom: 'VN Telecommunicatie 2023',
            framework_label_vn_ai: 'VN AI-wet 2025',
            framework_label_gdpr: 'AVG',
            framework_label_unspecified: 'Niet gespecificeerd',
            my_department: 'Mijn afdeling',
            my_tasks: 'Mijn taken',
            section_status: 'Sectiestatus',
            revision_requests: 'Revisieverzoeken',
            completion: 'Voltooiing',
            reason: 'Reden',
            requested_at: 'Aangevraagd op',
            no_tasks_assigned: 'Geen taken aan u toegewezen.',
            no_sections: 'Geen secties toegewezen aan uw afdeling.',
            no_revisions: 'Geen revisieverzoeken.',
            load_error: 'Kan gegevens niet laden.',
        },
    },
    connectors: {
        nav: {
            instances: 'Instanties',
            credentials: 'Referentiekluis',
            event_bus: 'Gebeurtenisbus',
            definitions: 'Definities',
            brds: 'BRD-vastlegging',
            security_reviews: 'Beveiligingsbeoordelingen',
            poc_scorecards: 'POC-scorekaarten',
            automation_planning: 'Automatiseringsplanning',
            system_inventory: 'Systeeminventaris',
            traceability_matrix: 'Traceerbaarheidsmatrix',
            gap_register: 'Gap-register',
        },
        instances: {
            title: 'Connectorinstanties',
            page_title: 'Connectoren',
            add: 'Instantie toevoegen',
            test: 'Verbinding testen',
            sync_now: 'Nu synchroniseren',
            new_instance: 'Nieuw Connector Instantie',
            no_instances: 'Geen connector instanties gevonden',
            instance_count: '{count} instantie(s)',
            confirm_delete: 'Verwijderen connector instantie "{name}"?',
            all_connector_types: 'Alle Connector Types',
            select_connector: 'Selecteren een connector...',
            fetch_error: 'Kan niet fetch connector instanties. Probeer het opnieuw.',
            fetch_definitions_error: 'Kan niet fetch connector definities. Probeer het opnieuw.',
            create_error: 'Kan niet create connector instantie',
            test_error: 'Kan niet test connector. Probeer het opnieuw.',
            status_error: 'Kan de connectorstatus niet bijwerken. Probeer het opnieuw.',
            delete_error: 'Kan niet delete connector instantie. Probeer het opnieuw.',
        },
        credentials: {
            title: 'Referentiekluis',
            page_title: 'Connectorgegevens',
            add: 'Referentie toevoegen',
            rotate: 'Roteren',
            expired: 'Verlopen',
            expiring: 'Bijna verlopen',
            orphaned: 'Verweesd',
            new_credential: 'Nieuw Referentie',
            no_credentials: 'Geen credentials gevonden',
            no_expiry: 'No Vervaldatum',
            linked_connectors: 'Gekoppeld Connectoren',
            expires_at: 'Verloopt op',
            value_label: 'Waarde * (write-only)',
            confirm_delete_title: 'Bevestig verwijderen',
            confirm_delete_message: 'Deze referentie verwijderen? Gekoppelde connectors verliezen toegang.',
            rotate_title: 'Referentie roteren',
            new_credential_value: 'Nieuwe referentiewaarde',
            fetch_error: 'Kan niet load credentials. Probeer het opnieuw.',
            health_error: 'Kan niet load gezondheid. Probeer het opnieuw.',
            create_error: 'Kan niet create referentie',
            rotate_error: 'Kan niet rotate referentie',
            delete_error: 'Kan niet delete referentie',
        },
        event_bus: {
            title: 'Gebeurtenisbus',
            page_title: 'Evenementenbus',
            events: 'Gebeurtenissen',
            subscriptions: 'Abonnementen',
            dlq: 'Wachtrij voor mislukte berichten',
            publish: 'Gebeurtenis publiceren',
            retry: 'Opnieuw proberen',
            dismiss: 'Afwijzen',
            search_events: 'Zoeken gebeurtenissen...',
            filter_event_type: 'Filteren op gebeurtenis type...',
            event_type: 'Gebeurtenis Type',
            source_module: 'Bron Module',
            timestamp: 'Tijdstempel',
            delivery_status: 'Levering Status',
            correlation_id: 'Correlatie ID',
            tracking_id: 'Tracking-ID',
            delivery_status_hint: 'De bezorgstatus wordt automatisch bijgewerkt naarmate gebeurtenissen worden verwerkt.',
            no_events: 'Geen gebeurtenissen gevonden',
            total_with_count: '{count} totaal',
            prev: 'Vorige',
            new_subscription: '+ Nieuw Abonnement',
            subscriber_type: 'Abonnee Type',
            subscriber_id: 'Abonnee ID',
            event_type_pattern: 'Gebeurtenis Type Patroon',
            event_type_pattern_placeholder: 'bijv. incident.*',
            filter_expression: 'Filteren Expressie',
            filter_expression_placeholder: 'Optioneel filter',
            subscriber_type_hint: 'Kies hoe gebeurtenissen worden bezorgd: webhook stuurt HTTP-verzoeken, e-mail stuurt meldingen, wachtrij routeert naar een berichtenwachtrij.',
            subscriber_id_hint: 'Voer de bestemming voor gebeurtenissen in. Voor webhooks, gebruik een URL. Voor e-mail, gebruik een adres. Voor wachtrijen, gebruik de wachtrijnaam.',
            event_type_pattern_hint: 'Gebeurtenissen matchen op type met jokertekens. Gebruik * om elk segment te matchen (bijv. incident.* matcht incident.created, incident.resolved).',
            filter_expression_hint: 'Optioneel. Filter gebeurtenissen verder op inhoud (bijv. severity=high).',
            subscriber_id_placeholder_webhook: 'bijv. https://uw-app.com/webhook',
            subscriber_id_placeholder_email: 'bijv. alerts@uw-bedrijf.com',
            subscriber_id_placeholder_queue: 'bijv. gebeurtenissen-wachtrij',
            event_pattern: 'Gebeurtenis Patroon',
            filter: 'Filteren',
            enabled: 'Ingeschakeld',
            delivery_stats: 'Levering Stats',
            no_subscriptions: 'Geen abonnementen gevonden',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} delivered / {failed} mislukt',
            confirm_delete_subscription: 'Verwijderen dit abonnement?',
            unresolved: 'Onopgelost',
            resolved: 'Opgelost',
            event_id: 'Gebeurtenis ID',
            subscription_id: 'Abonnement ID',
            error_code: 'Fout Code',
            error_message: 'Fout Message',
            attempts: 'Pogingen',
            last_failed: 'Laatste Failed',
            no_dlq_entries: 'Geen dead letter items gevonden',
            dlq_count: '{count} entry/entries totaal',
            fetch_events_error: 'Kan niet fetch gebeurtenissen. Probeer het opnieuw.',
            fetch_subscriptions_error: 'Kan niet fetch abonnementen. Probeer het opnieuw.',
            fetch_dlq_error: 'Kan niet fetch DLQ items. Probeer het opnieuw.',
            create_subscription_error: 'Kan niet create abonnement',
            toggle_subscription_error: 'Kan niet toggle abonnement',
            delete_subscription_error: 'Kan niet delete abonnement',
            retry_error: 'Opnieuw proberen mislukt',
            dismiss_error: 'Afwijzen mislukt',
            event_published: 'Gebeurtenis gepubliceerd',
            publish_event_error: 'Kan gebeurtenis niet publiceren. Probeer het opnieuw.',
            priority_label: 'Prioriteit',
            priority_low: 'Laag',
            priority_normal: 'Normaal',
            priority_high: 'Hoog',
            payload_helper_text: 'Voer gebeurtenisgegevens in als JSON. Voorbeeld: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Abonnement aangemaakt',
            subscription_toggled: 'Abonnement omgeschakeld',
            subscription_deleted: 'Abonnement verwijderd',
            dlq_retried: 'DLQ-bericht opnieuw geprobeerd',
            dlq_dismissed: 'DLQ-bericht afgewezen',
        },
        definitions: {
            title: 'Connectordefinities',
            page_title: 'Connectordefinities',
            add: 'Definitie toevoegen',
            new_definition: 'Nieuwe connectordefinitie',
            edit_definition: 'Connectordefinitie bewerken',
            no_definitions: 'Geen connectordefinities gevonden',
            definition_count: '[[TOK_1]] definitie(s)',
            all_categories: 'Alle categorieën',
            select_category: 'Selecteer een categorie...',
            capabilities: 'Mogelijkheden',
            capabilities_hint: "Mogelijkheden (door komma's gescheiden)",
            capabilities_placeholder: 'bijv. lezen, schrijven, synchroniseren',
            created: 'Connectordefinitie gemaakt',
            updated: 'Connectordefinitie bijgewerkt',
            fetch_error: 'Kan connectordefinities niet ophalen. Probeer het opnieuw.',
            create_error: 'Kan connectordefinitie niet maken',
            update_error: 'Bijwerken van connectordefinitie mislukt',
        },
        brds: {
            title: 'BRD-vastlegging',
            page_title: 'BRD-vastlegging',
            create_brd: 'BRD aanmaken',
            brd_title: 'BRD-titel',
            description: 'Beschrijving',
            requirements: 'Vereisten',
            status: 'Status',
            stakeholders: 'Belanghebbenden',
            connector_label: 'Connector',
            select_connector: 'Selecteer een connector...',
            approval: 'Goedkeuring',
            no_brds_found: "Geen BRD's gevonden",
            decision_records: 'Besluitregistraties',
            create_decision: 'Besluit aanmaken',
            alternatives_considered: 'Overwogen alternatieven',
            alternative_name: 'Alternatief naam',
            reason_rejected: 'Reden van afwijzing',
            add_alternative: 'Alternatief toevoegen',
            remove_alternative: 'Alternatief {name} verwijderen',
            alternatives: 'Alternatieven',
            rationale: 'Motivering',
            selected_connector: 'Geselecteerde connector',
            comma_separated_names: "Door komma's gescheiden namen",
            brd_created: 'BRD aangemaakt',
            decision_record_created: 'Beslissingsrecord aangemaakt',
            no_decision_records_found: 'Geen beslissingsrecords gevonden',
            aria_brds_table: "BRD's",
            aria_decision_records_table: 'Beslissingsrecords',
            aria_approve: '{name} goedkeuren',
            aria_archive: '{name} archiveren',
            brd_title_help: 'Een korte, voor mensen leesbare naam voor deze BRD — b.v. "Jira-ticketingintegratie", "Okta SSO-uitrol".',
            brd_title_placeholder: 'bijv. Jira-ticketingintegratie',
            description_help: 'Het zakelijke probleem dat deze connector oplost. Welk resultaat verwacht je als het eenmaal live is?',
            description_placeholder: 'bijv. Automatiseer het aanmaken van incidenttickets op basis van monitoringwaarschuwingen, zodat een oproep binnen 60 seconden wordt opgeroepen.',
            connector_help: 'Optioneel. Kies een connector waarvoor deze BRD bedoeld is. Laat leeg als de connector nog niet is gekozen.',
            requirements_help: 'Door komma\'s gescheiden lijst met onmisbare mogelijkheden — b.v. "OAuth2-aanmelding, webhook-levering, auditexport".',
            requirements_placeholder: 'OAuth2-login, webhooklevering, auditexport',
            stakeholders_help: "Door komma's gescheiden namen of e-mailadressen van mensen die zich moeten afmelden.",
            selected_connector_help: 'Kies de connector waarop deze beslissing van toepassing is.',
            rationale_help: 'Waarom voor deze connector is gekozen. Behandel de beslissende factoren zodat een toekomstige lezer de oproep begrijpt.',
            rationale_placeholder: 'bijv. Kies Jira omdat het al onze ticketgeschiedenis bevat en het team erop is getraind.',
            alternatives_considered_help: 'Andere connectoren zijn geëvalueerd en waarom deze niet zijn gekozen. Voegt verdedigbaarheid toe voor audits.',
            alternative_name_placeholder: 'bijv. ServiceNu',
            reason_rejected_placeholder: 'bijv. Kosten 3× hoger, geen voordeel voor onze use case',
        },
        security_reviews: {
            title: 'Beveiligingsbeoordelingen',
            page_title: 'Beveiligingsbeoordelingen',
            create_review: 'Beoordeling aanmaken',
            connector_name: 'Connectornaam',
            connector_label: 'Connector',
            select_connector: 'Selecteer een connector...',
            reviewer: 'Beoordelaar',
            select_reviewer: 'Selecteer een beoordelaar...',
            findings: 'Bevindingen (één per regel)',
            risk_level: 'Risiconiveau',
            risk_level_placeholder: 'bijv. hoog, middel, laag',
            notes: 'Notities',
            review_status: 'Beoordelingsstatus',
            checklist: 'Controlelijst',
            privacy_impact: 'Privacy-impact',
            approval_gate: 'Goedkeuringspoort',
            no_reviews_found: 'Geen beoordelingen gevonden',
            review_created: 'Beveiligingsbeoordeling aangemaakt',
            create_control_mapping: 'Controltoewijzing aanmaken',
            control_mapping_created: 'Controltoewijzing aangemaakt',
            connector_id_label: 'Connector-ID',
            control_id_label: 'Controle-ID',
            control_name_label: 'Controlenaam',
            aria_approve: '{name} goedkeuren',
            aria_reject: '{name} afwijzen',
            scan_imported: 'Scan succesvol geïmporteerd',
            import_scan: 'Scan importeren',
            scan_format: 'Scanformaat',
            scan_data: 'Scangegevens',
            import_results: 'Importresultaten',
            recommendations: 'Aanbevelingen',
            auto_populated_from: 'Automatisch ingevuld uit [[TOK_1]]',
            manual_entry: 'Handmatige invoer',
            automation_type: 'Automatiseringstype',
            select_automation_type: 'Automatiseringstype selecteren...',
            automation_full: 'Volledig - connector automatiseert deze bediening volledig',
            automation_partial: 'Gedeeltelijk – connector levert bewijs; mensen handelen nog steeds',
            automation_monitoring: 'Alleen monitoring: de connector observeert, dwingt niet af',
            control_id_help: 'Gebruik de code uit uw nalevingsschema (bijvoorbeeld ISO-27001-A.12.1, SOC2-CC6.1 of uw interne controle-ID).',
            control_name_help: "Korte, voor mensen leesbare naam (bijvoorbeeld 'Netwerktoegangsbeperking').",
            description_label: 'Beschrijving',
            load_sarif_example: 'SARIF-voorbeeld laden',
            load_json_example: 'Aangepast [[TOK_0]] voorbeeld laden',
            scan_format_help: 'SARIF is de OASIS-standaard die door de meeste scanners wordt uitgezonden (Snyk, CodeQL, Semgrep). Gebruik aangepast [[TOK_0]] voor tools die geen SARIF uitzenden.',
            scan_data_help: 'Plak de volledige scanuitvoer, upload een .sarif/.json-bestand of klik op de knop Voorbeeld laden om de vorm te bekijken.',
            upload_file_label: 'Upload een .sarif- of .json-bestand',
            invalid_scan_json: 'Kan scangegevens niet parseren als [[TOK_0]]. Controleer op syntaxisfouten in de buurt van het gemarkeerde teken.',
            save_as_review: 'Opslaan als beveiligingsbeoordeling',
            discard_preview: 'Voorbeeld negeren',
            preview_hint: "Dit is een voorbeeld; er is nog niets opgeslagen. Klik op 'Opslaan als beveiligingsbeoordeling' om een ​​beoordeling in behandeling te maken, die vooraf is ingevuld met deze waarden.",
            reviewer_required_for_save: 'Kies een reviewer om deze scan op te slaan als een beveiligingsbeoordeling.',
        },
        poc_scorecards: {
            title: 'POC-scorekaarten',
            page_title: 'POC-scorekaarten',
            create_scorecard: 'Scorekaart aanmaken',
            connector_label: 'Connector',
            select_connector: 'Selecteer een connector...',
            vendor_name: 'Leveranciersnaam',
            recommendation: 'Aanbeveling',
            recommendation_placeholder: 'bijv. Doorgaan, Niet doorgaan, Verdere evaluatie nodig',
            criteria: 'Beoordelingscriteria',
            criterion_name: 'Criteriumnaam',
            score: 'Scoren',
            max_score: 'Maximale score',
            notes: 'Notities',
            add_criterion: 'Criterium toevoegen',
            remove_criterion: 'Criterium {name} verwijderen',
            total_score: 'Totaalscore',
            api_quality: 'API-kwaliteit',
            reliability: 'Betrouwbaarheid',
            support_quality: 'Ondersteuningskwaliteit',
            cost_score: 'Kostenscore',
            overall_score: 'Totaalscore',
            evidence: 'Bewijsmateriaal',
            no_scorecards_found: 'Geen scorekaarten gevonden',
            scorecard_created: 'POC-scorekaart aangemaakt',
            connector_help: 'Kies de connector waarvoor deze POC-evaluatie is bedoeld.',
            vendor_name_help: 'De verkoper of het product dat wordt geëvalueerd – b.v. "Okta", "Datadog", "Sneeuwvlok".',
            vendor_name_placeholder: 'bijv. Okta, Datadog, Sneeuwvlok',
            recommendation_help: 'Uw laatste gesprek na de evaluatie. Houd het kort en beslissend.',
            criteria_help: 'Geef de leverancier een score op elk evaluatiecriterium. Voeg één rij toe per criterium ([[TOK_0]] kwaliteit, betrouwbaarheid, ondersteuning, kosten, etc.).',
            criterion_name_help: 'Wat u scoort — b.v. "[[TOK_0]] Kwaliteit", "Betrouwbaarheid", "Ondersteuning", "Kosten".',
            criterion_name_placeholder: 'bijv. [[TOK_0]] Kwaliteit',
            score_help: 'Score toegekend voor dit criterium. Mag de maximale score niet overschrijden.',
            max_score_help: 'Topscore beschikbaar voor dit criterium. Gebruik dezelfde schaal voor alle rijen, zodat de totalen vergelijkbaar zijn.',
            notes_help: 'Optioneel. Voeg bewijsmateriaal, kanttekeningen of links toe – alles wat de partituur verklaart.',
        },
        common_labels: {
            aria_filter_instances: 'Connectorinstanties filteren',
            aria_filter_definitions: 'Connectordefinities filteren',
            aria_filter_credentials: 'Referenties filteren',
            aria_filter_events: 'Gebeurtenissen filteren',
            aria_filter_dlq: 'Dead letter-wachtrij filteren',
            aria_instance_summary: 'Connectorinstantie-samenvatting',
            aria_active_connectors: 'Actieve connectoren',
            aria_error_connectors: 'Connectoren met fouten',
            aria_credential_health: 'Samenvatting referentiestatus',
            aria_items_per_page: 'Items per pagina',
            show_password: 'Wachtwoord tonen',
            hide_password: 'Wachtwoord verbergen',
            payload_json_label: 'Payload ([[TOK_0]])',
            payload_invalid_json: 'Payload moet geldige JSON zijn',
            placeholder_event_type: 'bijv. incident.created',
            placeholder_source_module: 'bijv. monitoring',
            placeholder_version: 'bijv. 1.0',
        },
        statuses: {
            configuring: 'Configureren',
            testing: 'Testen',
            active: 'Actief',
            paused: 'Gepauzeerd',
            error: 'Fout',
            disabled: 'Uitgeschakeld',
            draft: 'Diepgang',
            approved: 'Goedgekeurd',
            archived: 'Gearchiveerd',
            pending: 'In behandeling',
            rejected: 'Afgewezen',
        },
        system_types: {
            application: 'Applicatie',
            database: 'Database',
            middleware: 'Middelware',
            infrastructure: 'Infrastructuur',
            saas: 'SaaS',
            other: 'Overig',
        },
        hosting_types: {
            on_premise: 'Op locatie',
            cloud: 'Wolk',
            hybrid: 'Hybride',
            managed: 'Beheerd',
        },
        system_statuses: {
            active: 'Actief',
            decommissioned: 'Buiten gebruik',
            planned: 'Gepland',
            under_review: 'In beoordeling',
        },
        automation_statuses: {
            planning: 'Plannen',
            in_progress: 'Bezig',
            completed: 'Voltooid',
            on_hold: 'In de wacht',
        },
        gap_types: {
            functional: 'Functioneel',
            technical: 'Technisch',
            security: 'Beveiliging',
            compliance: 'Naleving',
            process: 'Proces',
        },
        severity_labels: {
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Gemiddeld',
            low: 'Laag',
        },
        gap_statuses: {
            open: 'Openen',
            in_progress: 'Bezig',
            mitigated: 'Gemitigeerd',
            closed: 'Gesloten',
            accepted: 'Geaccepteerd',
        },
        verification_statuses: {
            not_started: 'Niet gestart',
            in_progress: 'Bezig',
            verified: 'Geverifieerd',
            failed: 'Mislukt',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Intern',
            email: 'E-mail',
            queue: 'Wachtrij',
        },
        credential_types: {
            password: 'Wachtwoord',
            api_key: 'API-sleutel',
            oauth2_client: 'OAuth2-client',
            certificate: 'Certificaat',
            token: 'Token',
            ssh_key: 'SSH-sleutel',
            imap_credentials: 'IMAP-referenties',
        },
        categories: {
            hr: 'HR',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Wolk',
            security: 'Beveiliging',
            itsm: 'ITSM',
            custom: 'Aangepast',
        },
        delivery_statuses: {
            pending: 'In afwachting',
            delivered: 'Afgeleverd',
            partial: 'Gedeeltelijk',
            failed: 'Mislukt',
        },
        automation_planning: {
            title: 'Automatiseringsplanning',
            page_title: 'Automatiseringsplanning',
            program_name: 'Programmanaam',
            program_status: 'Status',
            description: 'Beschrijving',
            linked_artifacts: 'Gekoppelde artefacten',
            create_program: 'Programma aanmaken',
            edit_program: 'Programma bewerken',
            no_programs_found: "Geen programma's gevonden",
            program_created: 'Programma aangemaakt',
            program_updated: 'Programma bijgewerkt',
            target_date: 'Streefdatum',
            owner: 'Eigenaar',
            select_status: 'Status selecteren...',
            aria_programs_table: "Automatiseringsprogramma's",
            aria_edit: '{name} bewerken',
            export_programs: "Programma's exporteren",
            title_label: 'Programmatitel',
            title_help: 'Een korte, voor mensen leesbare naam voor het automatiseringsprogramma, bijvoorbeeld "Uitrol van incidenten naar Jira in Q3", "[[TOK_0]] automatisering van toegangsverzoeken".',
            title_placeholder: 'bijv. Uitrol van incidenten naar Jira in het derde kwartaal',
            description_help: 'Wat dit programma omvat en de uitkomst die u verwacht als het live is. Optioneel maar aanbevolen.',
            description_placeholder: 'bijv. Stuur monitoringwaarschuwingen door naar Jira, zodat de oproep binnen 60 seconden wordt opgeroepen.',
            owner_label: 'Programma-eigenaar',
            owner_help: 'De persoon die verantwoordelijk is voor dit programma. Ze ontvangen meldingen over de voortgang en poorten.',
            select_owner: 'Selecteer een eigenaar...',
            frameworks_in_scope: 'Kaders in reikwijdte',
            frameworks_in_scope_help: 'Compliance-frameworks die dit programma ondersteunt. Helpt het audittraject te laten zien aan welke regelgeving de automatisering onderworpen is.',
            select_frameworks: 'Kaders selecteren...',
            status_draft: 'Diepgang',
            status_active: 'Actief',
            status_completed: 'Voltooid',
            status_archived: 'Gearchiveerd',
            change_status: 'Wijzig status',
            status_updated: 'Status bijgewerkt',
            aria_change_status: 'Status wijzigen voor [[TOK_1]]',
        },
        system_inventory: {
            title: 'Systeeminventaris',
            page_title: 'Systeeminventaris',
            system_name: 'Systeemnaam',
            system_type: 'Systeemtype',
            hosting: 'Hosten',
            status: 'Status',
            description: 'Beschrijving',
            create_system: 'Systeem aanmaken',
            edit_system: 'Systeem bewerken',
            no_systems_found: 'Geen systemen gevonden',
            system_created: 'Systeem aangemaakt',
            system_updated: 'Systeem bijgewerkt',
            select_type: 'Type selecteren...',
            select_hosting: 'Hosting selecteren...',
            select_status: 'Status selecteren...',
            owner: 'Eigenaar',
            department: 'Afdeling',
            data_categories: 'Gegevenscategorieën',
            data_categories_placeholder: "Door komma's gescheiden, bijv. PII, Financieel, Gezondheid",
            jurisdiction: 'Jurisdictie',
            jurisdiction_placeholder: 'bijv. EU, VS, Wereldwijd',
            interfaces: 'Interfaces',
            interfaces_placeholder: "Door komma's gescheiden, bijv. REST API, SFTP, JDBC",
            owner_placeholder: 'Selecteer een verantwoordelijke eigenaar...',
            department_placeholder: 'Selecteer de verantwoordelijke organisatie-eenheid...',
            system_name_hint: 'Gebruik de bedrijfs-erkende systeem- of applicatienaam.',
            system_type_hint: 'Classificeer het systeem zodat rapportage vergelijkbare activa kan groeperen.',
            hosting_hint: 'Identificeer waar het systeem draait voor verblijfplaats, beveiliging en leveranciersbeoordeling.',
            status_hint: 'Stel de levenscyclusstatus in die wordt gebruikt door beoordelingen, exports en auditbewijsmateriaal.',
            owner_hint: 'Kies de actieve gebruiker die verantwoordelijk is voor systeembeheer en vervolgtaken.',
            department_hint: 'Gebruik de organisatie-eenheid die verantwoordelijk is voor het beheer of de governance van dit systeem.',
            data_categories_hint: "Lijst met gegevenscategorieën die door dit systeem worden verwerkt, gescheiden door komma's.",
            jurisdiction_hint: 'Leg de belangrijkste juridische of hosting-jurisdictie vast voor compliance-mapping.',
            interfaces_hint: 'Lijst met connector- of integratiepaden die worden gebruikt om gegevens uit te wisselen.',
            description_hint: 'Vat samen wat het systeem doet en waarom het belangrijk is voor de datakaart.',
            owner_department_required: 'Eigenaar en Afdeling zijn verplicht.',
            aria_systems_table: 'Systeeminventaris',
            aria_edit: '{name} bewerken',
            export_systems: 'Systemen exporteren',
        },
        traceability_matrix: {
            title: 'Traceerbaarheidsmatrix',
            page_title: 'Traceerbaarheidsmatrix',
            brd_selector: 'BRD selecteren',
            requirement: 'Vereiste',
            linked_artifact: 'Gekoppeld artefact',
            verification_status: 'Verificatiestatus',
            verified_by: 'Geverifieerd door',
            create_entry: 'Item aanmaken',
            edit_entry: 'Item bewerken',
            no_entries_found: 'Geen items gevonden',
            entry_created: 'Item aangemaakt',
            entry_updated: 'Item bijgewerkt',
            select_brd: 'Selecteer een BRD...',
            select_status: 'Status selecteren...',
            aria_matrix_table: 'Traceerbaarheidsmatrix',
            aria_edit: 'Item bewerken voor {name}',
            export_matrix: 'Matrix exporteren',
        },
        gap_register: {
            title: 'Gap-register',
            page_title: 'Gap-register',
            gap_title: 'Gap-titel',
            gap_type: 'Gap-type',
            severity: 'Ernst',
            status: 'Status',
            description: 'Beschrijving',
            remediation_plan: 'Herstelplan',
            assigned_to: 'Toegewezen aan',
            due_date: 'Vervaldatum',
            create_gap: 'Gap aanmaken',
            edit_gap: 'Gap bewerken',
            no_gaps_found: 'Geen gaps gevonden',
            gap_created: 'Gap aangemaakt',
            gap_updated: 'Gap bijgewerkt',
            select_type: 'Type selecteren...',
            select_severity: 'Ernst selecteren...',
            select_status: 'Status selecteren...',
            aria_gaps_table: 'Gap-register',
            aria_edit: '{name} bewerken',
            export_gaps: 'Gaps exporteren',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Raamwerkkoppeling',
            framework_linkage_placeholder: 'bijv. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Raamwerkbereik',
            framework_scope_placeholder: 'bijv. GDPR, PCI-DSS',
            procedure_linkage: 'Procedurekoppeling',
            procedure_linkage_placeholder: 'bijv. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Regelgevende bron',
            regulatory_source_placeholder: 'bijv. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Controlletoewijzing',
            control_mappings_section: 'Controletoewijzingen',
            no_control_mappings: "Nog geen controletoewijzingen. Klik op 'Controletoewijzing maken' om er een toe te voegen.",
            automation_type_col: 'Automatisering',
        },
        gap_register_extra: {
            framework_filter: 'Raamwerk',
            framework_id: 'Raamwerk-ID',
            framework_id_placeholder: 'bijv. GDPR, ISO 27001',
            all_frameworks: 'Alle raamwerken',
        },
        poc_scorecards_extra: {
            criteria_count: 'Criteria',
        },
        export_labels: {
            export_brds: "BRD's exporteren",
            export_decision_records: 'Besluitregisters exporteren',
            export_security_reviews: 'Beveiligingsbeoordelingen exporteren',
            export_poc_scorecards: 'POC-scorekaarten exporteren',
            export_instances: 'Exemplaren exporteren',
            export_definitions: 'Definities exporteren',
            export_credentials: 'Referenties exporteren',
            export_events: 'Gebeurtenissen exporteren',
            exporting: 'Exporteren...',
            export_success: 'Export voltooid',
            export_error: 'Export mislukt',
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Ontwerp redenering',
            drafting: 'Redenering opstellen...',
            results_heading: '[[TOK_2]]-opgestelde redenering ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            narrative_label: 'Rechtvaardiging verhaal',
            controls_heading: 'Compenserende controles',
            no_controls: 'Er worden geen compenserende controles voorgesteld.',
            citations_label: 'Citaties',
            accept_label: 'Accepteer redenering',
            reject_label: 'Concept afwijzen',
            accept_hint: 'Accept legt de redenering vast voor het aanhoudende ontwerp voor de IAT-afstamming. Het verhaal + de bedieningselementen werken het acceptatierecord niet automatisch bij; plakken door de operator is vereist.',
            resolve_summary: 'Resolutie: [[TOK_1]]',
            error_generic: 'Kan geen redenering opstellen. Probeer het opnieuw of controleer de risicoacceptatiestatus.',
        },
        redline_assistant: {
            run_label: 'Redline met bibliotheek',
            running: 'Rode lijn uitvoeren…',
            results_heading: 'Redline-suggesties ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_suggestions: 'Er zijn geen hiaten in de standaardclausules gedetecteerd.',
            jurisdiction_label: 'Jurisdictie',
            col_kind: 'Soort',
            col_severity: 'Ernst',
            col_title: 'Suggestie',
            col_excerpt: 'Bijpassend fragment',
            col_apply: 'Toepassen',
            kind_missing: 'Standaard ontbreekt',
            kind_weaker: 'Zwakker dan standaard',
            kind_jurisdiction: 'Jurisdictie-overlay',
            proposed_label: 'Voorgestelde tekst',
            citations_label: 'Citaties',
            accept_label: 'Accepteer geselecteerd',
            reject_label: 'Rapport afwijzen',
            partial_label: 'Selectie toepassen',
            accept_hint: 'Selectie toepassen registreert de gekozen suggesties voor het ontwerp voor de IAT-afstamming. Er wordt geen automatische bewerking toegepast op de contracttekst; de operator bepaalt de rode lijn.',
            resolve_summary: 'Oplossing: [[TOK_2]] · [[TOK_3]] suggestie(s) toegepast',
            error_generic: 'Kon geen rode lijn produceren. Probeer het opnieuw of controleer de contractstatus.',
            clause_library_link: 'Beheer de clausulebibliotheek',
        },
        clause_library: {
            page_title: 'Clausulebibliotheek',
            add_label: 'Clausule toevoegen',
            edit_label: 'Bewerken',
            delete_label: 'Verwijderen',
            slug_label: 'Slak',
            title_label: 'Titel',
            body_label: 'Lichaam',
            jurisdiction_label: 'Jurisdictie',
            tags_label: "Tags (door komma's gescheiden)",
            must_contain_label: "Markeringen die moeten bevatten (door komma's gescheiden)",
            severity_label: 'Ernst bij vermissing',
            no_clauses: 'Nog geen clausules. Voeg er een toe om de Redline-assistent te plaatsen.',
            save_label: 'Opslaan',
            cancel_label: 'Annuleer',
            load_error: 'Kan de clausulebibliotheek niet laden.',
            save_error: 'Kan clausule niet opslaan.',
            delete_error: 'Kan clausule niet verwijderen.',
            delete_confirm: 'Clausule "[[TOK_1]]" verwijderen? Dit kan niet ongedaan worden gemaakt.',
        },
        obligation_extraction: {
            extract_label: 'Uittreksel verplichtingen',
            extracting: 'Extraheren…',
            results_heading: 'Geëxtraheerde verplichtingen ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_obligations: 'Er zijn geen verplichtingspatronen gedetecteerd in deze contracttekst.',
            col_class: 'Klasse',
            col_summary: 'Samenvatting (bewerkbaar)',
            col_excerpt: 'Clausule-uittreksel',
            col_due_date: 'Vervaldatum (bewerkbaar)',
            col_priority: 'Prioriteit',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Opzegtermijn',
            class_audit: 'Auditrecht',
            class_insurance: 'Verzekering',
            class_sla: 'Reactie [[TOK_0]]',
            class_breach: 'Melding van inbreuk',
            class_renewal: 'Vernieuwingsvenster',
            citations_label: 'Citaties',
            accept_hint: 'Accepteren creëert één taak per verplichting (cap 8) met de prioriteit + vervaldatum weergegeven.',
            accept_label: 'Accepteer verplichtingen',
            reject_label: 'Rapport afwijzen',
            resolve_summary: 'Oplossing: [[TOK_2]] · [[TOK_3]] taak(en) gemaakt',
            error_generic: 'Kon geen verplichtingen afdwingen. Probeer het opnieuw of controleer de contracttekst.',
        },
        subprocessor_impact: {
            assess_label: 'Beoordeel de impact',
            assessing: 'Impact beoordelen…',
            results_heading: 'Impact op subverwerker ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            risk_delta_label: 'Risico-delta',
            notification_heading: 'Klantmelding',
            subject_label: 'Onderwerp',
            deadline_label: 'Deadline voor kennisgeving',
            body_label: 'Kennisgevingsinstantie',
            required_fields_label: 'Verplichte velden in artikel 28, lid 4',
            mitigation_heading: 'Mitigatiestappen',
            citations_label: 'Citaties',
            accept_label: 'Accepteer beoordeling',
            reject_label: 'Beoordeling afwijzen',
            accept_hint: 'Met Accepteren wordt een klantmeldingstaak gemaakt met de deadline van [[TOK_0]] als vervaldatum.',
            resolve_summary: 'Resolutie: [[TOK_2]][[TOK_3]]',
            error_generic: 'Kan deze wijziging in de subverwerker niet beoordelen. Probeer het opnieuw of controleer het wijzigingsrecord.',
        },
        onboarding_evidence: {
            collect_label: 'Voer [[TOK_0]] bewijsverzameling uit',
            collecting: 'Bewijs verzamelen…',
            results_heading: 'Bewijsverzameling ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            findings_heading: 'Bestaand bewijs',
            missing_heading: 'Ontbrekende artefacten',
            no_findings: 'Er is geen bestaand bewijs gevonden.',
            no_missing: 'Er ontbreken geen vereiste artefacten voor deze risicolaag.',
            next_step_label: 'Volgende stap',
            class_dpa: 'Verwerkersovereenkomst',
            class_soc2: 'SOC 2-rapport',
            class_iso27001: 'ISO 27001 certificaat',
            class_insurance: 'Cyberverzekering',
            class_incident_history: 'Voorafgaand incident',
            accept_hint: 'Accepteren creëert taken voor elk ontbrekend artefact (maximaal 5). Bevindingen blijven concept totdat u ze als bewijsmateriaal bijvoegt.',
            accept_label: 'Rapport accepteren',
            reject_label: 'Rapport afwijzen',
            resolve_summary: 'Oplossing: [[TOK_2]] · [[TOK_3]] taak(en) gemaakt',
            error_generic: 'Kan [[TOK_0]] bewijsverzameling niet uitvoeren. Probeer het opnieuw of controleer de status van de onboardingaanvraag.',
        },
        no_permission_title: 'Onvoldoende machtigingen',
        no_permission_message: 'U heeft geen toestemming voor toegang tot leveranciersrisicobeheer.',
        unknown_vendor: 'Onbekende leverancier',
        nav: {
            dashboard: 'Risico-overzicht',
            scoring: 'Risicoscoring',
            questionnaires: 'Vragenlijsten',
            contracts: 'Contracten',
            gates: 'Goedkeuringspoorten',
            reviews: 'Leveranciersbeoordelingen',
            signals: 'Risicosignalen',
            reassessments: 'Herbeoordelingen',
            portfolio: 'Risicoportefeuille',
            acceptances: 'Risicoacceptatie',
            review_routing: 'Beoordelingsroutering',
            onboarding_cases: 'Onboarding-dossiers',
            sub_processor_register: 'Register van subverwerkers',
        },
        dashboard: {
            title: 'Leveranciersrisico-overzicht',
            page_title: "Dashboard voor leveranciersrisico's",
            loading: 'Laden van dashboard gegevens...',
            risk_tier_header: 'Risiconiveau',
            count_header: 'Tel',
            percentage_header: 'Percentage',
            sections_nav: 'Risicosecties voor leveranciers',
            urgent_expiry: 'Spoed: vervalt binnen 14 dagen',
            no_previous_tier: 'Geen vorig niveau',
            view_as_chart: 'Bekijk als grafiek',
            view_as_table: 'Bekijk als tafel',
            showing_chart: 'Grafiekweergave',
            showing_table: 'Datatabelweergave',
            load_error: 'Kan niet load leverancier risico dashboard',
            risk_distribution: 'Risico Distribution Overview',
            recent_tier_changes: 'Recent Niveau Wijzigingen',
            no_tier_changes: 'No recent niveau changes.',
            review_kpis: 'Beoordelen KPIs',
            total_vendors_reviewed: 'Totaal Leveranciers Beoordeeld',
            reviews_by_outcome: 'Beoordelingen op Resultaat',
            contract_coverage: 'Contract Dekking',
            total_vendors: 'Totaal Leveranciers',
            with_active_dpa: 'Met Actief DPA',
            without_dpa: 'Zonder DPA',
            dpa_coverage: 'DPA Dekking',
            active_contracts_by_type: 'Actief Contracten op Type',
            expiring_contracts: 'Verlopend Contracten (Next 90 Days)',
            no_expiring_contracts: 'No contracten expiring within de next 90 dagen.',
            vendor: 'Leverancier',
            previous_tier: 'Vorig Niveau',
            current_tier: 'Huidig Niveau',
            changed_at: 'Gewijzigd At',
            expires_at: 'Verloopt op',
            days_remaining: 'Dagen Resterend',
            days: 'dagen',
            vendors_label: 'leveranciers',
            no_data: 'No gegevens',
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Gemiddeld',
            low: 'Laag',
            expiring_acceptances_heading: 'Verlopende risicoacceptaties',
            expiring_30d_label: 'Verloopt over 30 dagen',
            expiring_60d_label: 'Verloopt over 60 dagen',
            expiring_90d_label: 'Verloopt over 90 dagen',
        },
        scoring: {
            title: 'Risicoscoring',
            page_title: 'Risicoscore van leveranciers',
            filter_scores: 'Risicoscores filteren',
            filter_by_tier: 'Filter op risicolaag',
            scores_pagination: 'Paginering van risicoscores',
            config_dimensions: 'Configuratie van scoringsafmetingen',
            scores_loaded: '[[TOK_1]] risicoscores geladen',
            weight_must_equal_100: 'Het totaalgewicht moet gelijk zijn aan 100 (huidig: [[TOK_1]])',
            out_of_10: 'van de 10, beoordeeld als [[TOK_1]]',
            dimension_name: 'Dimensie [[TOK_1]] naam',
            dimension_weight: '[[TOK_1]] gewicht (percentage)',
            must_equal_100: 'moet gelijk zijn aan 100',
            config_title: 'Scoring Configuratie',
            scores_title: 'Leverancier Risico Scores',
            new_score_title: 'Score een Leverancier',
            new: 'Nieuw Score',
            vendor_id: 'Leverancier ID',
            risk_tier: 'Risico Niveau',
            score: 'Scoren',
            scored_at: 'Gescoord op',
            no_scores: 'Geen risico scores gevonden.',
            all_tiers: 'Alle Niveaus',
            load_config_error: 'Kan niet load risico scoring configuratie',
            update_config: 'Scoringsconfiguratie bijwerken',
            update_config_error: 'Kan niet update risico scoring configuratie',
            load_scores_error: 'Kan niet load leverancier risico scores',
            calculate_error: 'Kan niet calculate leverancier risico score',
            weight: 'gewicht',
            score_range: 'Beoordeling (1-5)',
            method: 'Methode',
        },
        questionnaires: {
            title: 'Vragenlijsten',
            page_title: 'Vragenlijsten van leveranciers',
            filter_questionnaires: 'Vragenlijstfilters',
            questionnaire_views: 'Vragenlijstweergaven',
            templates_list: 'Lijst met vragenlijstsjablonen',
            instances_list: 'Lijst met vragenlijstinstanties',
            filter_by_status: 'Filter op vragenlijststatus',
            templates_per_page: 'Sjablonen per pagina',
            instances_per_page: 'Instanties per pagina',
            select_template: 'Selecteer vragenlijstsjabloon',
            template_category: 'Sjablooncategorie',
            templates_tab: 'Sjablonen',
            instances_tab: 'Instanties',
            new: 'Nieuw Questionnaire',
            new_template: 'Nieuw sjabloon',
            new_instance: 'Nieuwe instantie',
            vendor_id: 'Leverancier ID',
            template_id: 'Sjabloon ID',
            assigned_to: 'Toegewezen Naar',
            due_date: 'Due Datum',
            responses: 'Reacties',
            risk_score: 'Voltooiing',
            no_questionnaires: 'Geen vragenlijsten gevonden.',
            load_templates_error: 'Kan niet load vragenlijst sjablonen',
            load_instances_error: 'Kan niet load vragenlijsten',
            create_template_error: 'Kan niet create vragenlijst sjabloon',
            initiate_error: 'Kan niet initiate vragenlijst',
            submit_error: 'Kan niet submit vragenlijst',
            review_error: 'Kan niet beoordeling vragenlijst',
            resubmit: 'Opnieuw indienen',
            approve_error: 'Kon vragenlijst niet goedkeuren',
            reject_error: 'Kon vragenlijst niet afwijzen',
            resubmit_error: 'Kon vragenlijst niet opnieuw indienen',
            templates_loaded: '[[TOK_1]] vragenlijstsjablonen geladen',
            instances_loaded: '[[TOK_1]] vragenlijstinstanties geladen',
            fill_responses_cta: 'Antwoorden invullen',
            fill_responses_title: 'Vragenlijstantwoorden invullen',
            template_missing: 'Sjabloon niet gevonden.',
            responses_saved: 'Antwoorden opgeslagen.',
            load_template_error: 'Sjabloon laden mislukt.',
            version_history: 'Versiegeschiedenis',
            download_previous_version: 'Vorige versie downloaden',
            trigger: 'Trigger',
            template_label: 'Sjabloon',
            reviewer: 'Recensent',
            reviewer_required: 'Voor [[TOK_1]] vragenlijsten moet een reviewer worden aangesteld (functiescheiding).',
            select_option: 'Selecteer een optie',
            multi_choice_hint: 'Selecteer alles wat van toepassing is',
            category_initial_onboarding: 'Eerste onboarding',
            category_annual_review: 'Jaarlijks overzicht',
            category_incident_triggered: 'Door incidenten veroorzaakt',
            category_contract_renewal: 'Contractverlenging',
            template_editor: {
                page_title: 'Vragenlijstsjabloon bewerken',
                preview_page_title: 'Voorbeeld van een vragenlijstsjabloon',
                edit_structure: 'Structuur bewerken',
                preview: 'Voorbeeld',
                actions: 'Acties',
                back_to_list: 'Terug naar sjablonen',
                load_error: 'Kan sjabloon niet laden',
                save_error: 'Kan de sjabloonstructuur niet opslaan',
                saved: 'Sjabloonstructuur opgeslagen.',
                sections_heading: 'Secties',
                questions_heading: 'Vragen',
                add_section: 'Sectie toevoegen',
                edit_section: 'Sectie bewerken',
                delete_section: 'Sectie verwijderen',
                move_section_up: 'Verplaats sectie naar boven',
                move_section_down: 'Verplaats sectie naar beneden',
                confirm_delete_section: 'Sectie "[[TOK_1]]" verwijderen? Alle vragen zullen worden verwijderd.',
                section_title: 'Sectietitel',
                section_description: 'Sectiebeschrijving',
                section_id: 'Sectie-ID',
                section_id_hint: 'Automatisch gegenereerd, tenzij u er expliciet een instelt.',
                no_sections: 'Nog geen secties. Voeg een sectie toe om te beginnen.',
                no_questions: 'Er zijn nog geen vragen in deze sectie.',
                add_question: 'Vraag toevoegen',
                edit_question: 'Vraag bewerken',
                delete_question: 'Vraag verwijderen',
                move_question_up: 'Verplaats de vraag naar boven',
                move_question_down: 'Verplaats de vraag naar beneden',
                confirm_delete_question: 'Vraag "[TOK_1]]" verwijderen?',
                question_text: 'Vraag tekst',
                question_type: 'Vraagtype',
                question_id: 'Vraag-ID',
                evidence_required: 'Bewijs vereist',
                risk_weight: 'Risicogewicht',
                scoring_map: 'Scorekaart',
                scoring_map_json_hint: '[[TOK_0]] object wijst antwoordwaarden toe aan numerieke scores.',
                scoring_map_invalid_json: 'De scorekaart moet geldig zijn [[TOK_0]].',
                options_heading: 'Antwoordmogelijkheden',
                add_option: 'Optie toevoegen',
                remove_option: 'Optie verwijderen',
                option_label: 'Etiket',
                option_value: 'Waarde',
                option_risk_weight: 'Risicogewicht',
                min_options_error: 'Keuzevragen moeten minimaal 2 opties hebben.',
                option_label_required: 'Elke optie heeft een label nodig.',
                option_value_required: 'Elke optie heeft een waarde nodig.',
                option_value_unique: 'Optiewaarden moeten uniek zijn.',
                branching_rules_heading: 'Vertakkingsregels',
                branching_rules_hint: 'Toon of verberg deze vraag op basis van het antwoord op een eerdere vraag.',
                add_branching_rule: 'Vertakkingsregel toevoegen',
                remove_branching_rule: 'Vertakkingsregel verwijderen',
                branching_condition_question: 'Indien vraag',
                branching_condition_value: 'heeft waarde',
                branching_action: 'dan',
                branching_action_show: 'laat deze vraag zien',
                branching_action_hide: 'verberg deze vraag',
                branching_select_condition_question: 'Selecteer eerdere vraag',
                branching_select_condition_value: 'Selecteer waarde',
                save: 'Structuur bewaren',
                saving: 'Opslaan...',
                cancel: 'Annuleer',
                close: 'Sluiten',
                question_text_required: 'Vraagtekst is vereist.',
                section_title_required: 'Sectietitel is vereist.',
                type_single_choice: 'Enkele keuze',
                type_multi_choice: 'Meerkeuze',
                type_free_text: 'Vrije tekst',
                type_numeric: 'Numeriek',
                type_date: 'Datum',
                type_file_upload: 'Bestand uploaden',
                type_yes_no: 'Ja / Nee',
                preview_heading: 'Sjabloonvoorbeeld',
                preview_subtitle: 'Alleen-lezen voorbeeld van hoe de vragenlijst er voor een leverancier uitziet.',
                preview_no_content: 'Deze sjabloon bevat nog geen secties of vragen.',
                preview_branching_notice: 'Vertakkingsregels worden geëvalueerd tijdens het invullen; preview toont elke vraag.',
            },
            review_modal: {
                title: 'Bekijk de antwoorden op de vragenlijst',
                open_cta: 'Beoordeling',
                loading: 'Vragenlijst laden...',
                template_missing: 'Sjabloon niet gevonden.',
                load_error: 'Kan de vragenlijst niet ter beoordeling laden.',
                annotation_heading: 'Annotaties',
                annotation_placeholder: 'Voeg een recensentannotatie toe voor deze vraag...',
                annotation_status_label: 'Annotatiestatus',
                annotation_status_acceptable: 'Acceptabel',
                annotation_status_concern: 'Bezorgdheid',
                annotation_status_requires_action: 'Vereist actie',
                review_comments_label: 'Algemene beoordelingsopmerkingen',
                review_comments_placeholder: 'Vat uw reviewbevindingen samen...',
                justification_label: 'Rechtvaardiging van het besluit',
                justification_placeholder: 'Leg de reden voor uw beslissing uit...',
                reject_requires_comments: 'Voor het afwijzen van een vragenlijst zijn beoordelingsopmerkingen vereist.',
                decision_heading: 'Besluit',
                decision: {
                    approved: 'Goedkeuren',
                    rejected: 'Afwijzen',
                    additional_info_requested: 'Vraag aanvullende informatie aan',
                },
                submit: 'Beoordeling indienen',
                submitting: 'Beoordeling indienen...',
                cancel: 'Annuleer',
                submit_success: 'Beoordeling ingediend.',
                submit_error: 'Het is niet gelukt om een beoordeling in te dienen.',
                separation_of_duties_error: 'U kunt een vragenlijst die u moet invullen, niet bekijken. Functiescheiding vraagt ​​om een ​​andere beoordelaar.',
                decision_required: 'Selecteer een beoordelingsbesluit.',
                announce_opened: 'Beoordelingsmodaal geopend.',
                announce_submitted: 'Beoordeling ingediend.',
            },
            instance_detail: {
                submitted_at: 'Ingezonden',
                reviewed_at: 'Beoordeeld',
                reviewer: 'Recensent',
                review_decision: 'Besluit',
                review_comments: 'Opmerkingen beoordelen',
                decision_approved: 'Goedgekeurd',
                decision_rejected: 'Afgewezen',
                decision_additional_info_requested: 'Meer info gevraagd',
                decision_pending: 'In afwachting van beoordeling',
                expand_comments: 'Volledige reacties weergeven',
                collapse_comments: 'Volledige opmerkingen verbergen',
                no_reviewer: 'Geen recensent toegewezen',
            },
            export: {
                portfolio_label: 'Portefeuille exporteren',
                instance_label: 'Exporteren',
                portfolio_success: 'Portefeuille-export gereed.',
                instance_success: 'Vragenlijstexport gereed.',
                portfolio_error: 'Kan vragenlijstportfolio niet exporteren.',
                instance_error: 'Kan de vragenlijst niet exporteren.',
            },
            branching: {
                hidden_notice: 'Sommige vragen zijn verborgen door vertakkingsregels.',
                cycle_warning: 'Er is een cyclus gedetecteerd in de vertakkingsregels. Betrokken vragen zijn standaard zichtbaar.',
            },
        },
        contracts: {
            title: 'Contracten',
            page_title: 'Leverancierscontracten',
            new: 'Nieuw Contract',
            vendor_id: 'Leverancier ID',
            filter_contracts: 'Filter contracten',
            filter_by_document_type: 'Filter op documenttype',
            filter_by_status: 'Filter op contractstatus',
            per_page: 'Contracten per pagina',
            expired_notice: 'Dit contract is verlopen',
            document_type: 'Documenttype',
            expiry_date: 'Vervaldatum Datum',
            no_contracts: 'Geen contracten gevonden.',
            all_document_types: 'Alle Document Types',
            load_error: 'Kan niet load contracten',
            create_error: 'Kan niet create contract',
            delete_error: 'Kan niet delete contract',
            update_error: 'Kan de status niet bijwerken',
            confirm_delete: 'Verwijderen contract "{title}"?',
            renewal_date: 'Verlenging Datum',
            effective_date: 'Effectief Datum',
            parties: 'Partijen',
            summary: 'Samenvatting',
            n_contracts: '{count} contracten',
            n_contract: '[[TOK_1]]-contract',
            contracts_loaded: '{count} contracten geladen',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Beveiligingsaddendum',
            doc_type_scc_annex: 'SCC-bijlage',
            doc_type_sub_processor_list: 'Sub-verwerkerlijst',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Overig',
            status_draft: 'Concept',
            status_under_negotiation: 'In onderhandeling',
            status_pending_signature: 'Wacht op ondertekening',
            status_active: 'Actief',
            status_expired: 'Verlopen',
            status_terminated: 'Beëindigd',
            status_superseded: 'Vervangen',
        },
        gates: {
            title: 'Goedkeuringspoorten',
            page_title: 'Poortevaluaties',
            new: 'Nieuw Gate Evaluation',
            vendor_id: 'Leverancier ID',
            gate_name: 'Gate Naam',
            outcome: 'Resultaat',
            evaluator: 'Beoordelaar',
            no_gates: 'Geen gate evaluations gevonden.',
            load_error: 'Kan niet load gate evaluations',
            evaluate_error: 'Kan niet evaluate leverancier gate',
            detail_error: 'Kan niet fetch evaluatie detail',
            override_error: 'Kan niet override gate evaluatie',
            criteria_results: 'Criteria Resultaten',
            evaluate_form: 'Evalueer de leverancierspoort',
            per_page: 'Evaluaties per pagina',
            passed: 'Geslaagd',
            failed: 'Mislukt',
            override: 'Overschrijven',
            override_justification: 'Overschrijven Rechtvaardiging',
            override_placeholder: 'Invoeren rechtvaardiging voor overriding dit gate evaluatie',
            approval_id: 'Goedkeuring ID',
            overall_passed: 'Geslaagd',
            overall_failed: 'Mislukt',
            overall_overridden: 'Overschreven',
            evaluations_loaded: '{count} poortbeoordelingen geladen',
            create_approval_cta: 'Goedkeuring aanmaken',
        },
        reviews: {
            title: 'Leveranciersbeoordelingen',
            page_title: 'Leveranciersrecensies',
            new: 'Nieuw Beoordelen',
            vendor_id: 'Leverancier ID',
            filter_by_outcome: 'Filter op beoordelingsresultaat',
            per_page: 'Recensies per pagina',
            kpi_summary: 'Bekijk de samenvatting van [[TOK_0]].',
            review_outcome_label: 'Beoordeel de uitkomst',
            edit_outcome: 'Beoordelingsresultaat bewerken',
            reviews_loaded: '[[TOK_1]] leveranciersrecensies geladen',
            reviewer: 'Beoordelaar',
            review_type: 'Beoordelen Type',
            outcome: 'Resultaat',
            findings: 'Bevindingen',
            no_reviews: 'Geen leverancier beoordelingen gevonden.',
            load_kpis_error: 'Kan niet fetch leverancier beoordeling KPIs',
            load_error: 'Kan niet fetch leverancier beoordelingen',
            update_error: 'Kan leveranciersrecensie niet bijwerken',
            create_error: 'Kan niet create leverancier beoordeling',
            total_reviewed: 'Totaal Leveranciers Beoordeeld',
            total_reviews: 'Totaal Beoordelingen',
            satisfactory: 'Voldoende',
            concerns_identified: 'Zorgen Identified',
            remediation_required: 'Herstel Vereist',
            escalated: 'Geëscaleerd',
            program_id: 'Programma ID',
            period_id: 'Periode ID',
            task_id: 'Taak ID',
            recommendations: 'Aanbevelingen',
        },
        risk_signals: {
            title: 'Risicosignalen',
            page_title: 'Risicosignalen',
            new_signal: 'Nieuw risicosignaal',
            signal_type: 'Signaaltype',
            severity: 'Ernst',
            description: 'Beschrijving',
            source: 'Bron',
            vendor_id: 'Leverancier-ID',
            certification_expiry: 'Certificaatvervaldatum',
            breach_notification: 'Inbreukmelding',
            financial_instability: 'Financiële instabiliteit',
            compliance_change: 'Nalevingswijziging',
            custom: 'Aangepast',
            active: 'Actief',
            acknowledged: 'Bevestigd',
            resolved: 'Opgelost',
            no_signals: 'Geen risicosignalen gevonden',
            source_external_feed: 'Externe feed',
            source_manual: 'Handmatig',
            source_integration: 'Integratie',
            source_regulatory: 'Regelgevend',
            source_media: 'Media',
            trigger_reassessment_prompt: 'Dit signaal is van hoge ernst. Nu een leveranciersherbeoordeling starten?',
            reassessment_triggered: 'Herbeoordeling gestart.',
            reassessment_trigger_error: 'Kon herbeoordeling niet starten.',
        },
        reassessments: {
            title: 'Herbeoordelingstaken',
            page_title: 'Herbeoordelingstaken',
            trigger: 'Herbeoordeling starten',
            trigger_success: 'Herbeoordeling succesvol gestart',
            reason: 'Reden',
            deadline: 'Deadline',
            assigned_to: 'Toegewezen aan',
            vendor_id: 'Leverancier-ID',
            outcome: 'Resultaat',
            new_risk_level: 'Nieuw risiconiveau',
            complete: 'Herbeoordeling voltooien',
            complete_success: 'Herbeoordeling succesvol voltooid',
            pending: 'In afwachting',
            in_progress: 'Bezig',
            completed: 'Voltooid',
            cancelled: 'Geannuleerd',
            no_tasks: 'Geen herbeoordelingstaken gevonden',
            risk_trend: 'Risicotrend',
            notes: 'Notities',
        },
        portfolio: {
            title: 'Risicoportefeuille',
            page_title: 'Risicoportfolio',
            dashboard: 'Portefeuille-overzicht',
            vendor_id: 'Leverancier-ID',
            total_vendors: 'Totaal aantal leveranciers',
            average_score: 'Gemiddelde risicoscore',
            high_risk_count: 'Hoog-risico leveranciers',
            trend_direction: 'Trendrichting',
            improved: 'Verbeterd',
            stable: 'Stabiel',
            degraded: 'Verslechterd',
            vendor_trend: 'Leverancierstrend',
            outstanding_questionnaires: 'Openstaande vragenlijsten',
            overdue_assessments: 'Achterstallige beoordelingen',
            no_outstanding: 'Geen openstaande vragenlijsten',
            no_overdue: 'Geen achterstallige beoordelingen',
            due_date: 'Vervaldatum',
        },
        risk_acceptance: {
            title: 'Risicoacceptatieregister',
            page_title: 'Risicoacceptatieregister',
            new_acceptance: 'Nieuwe risicoacceptatie',
            vendor_id: 'Leverancier-ID',
            risk_level: 'Risiconiveau',
            conditions: 'Voorwaarden',
            justification: 'Rechtvaardiging',
            expiry_date: 'Vervaldatum',
            create_success: 'Risicoacceptatie succesvol aangemaakt',
            review_condition: 'Voorwaarde beoordelen',
            condition_met: 'Voorwaarde voldaan',
            condition_not_met: 'Voorwaarde niet voldaan',
            review_success: 'Voorwaarde succesvol beoordeeld',
            export_register: 'Register exporteren',
            active: 'Actief',
            expired: 'Verlopen',
            revoked: 'Ingetrokken',
            no_acceptances: 'Geen risicoacceptaties gevonden',
            met_count: '[[TOK_2]]/[[TOK_3]] ontmoet',
        },
        review_routing: {
            title: 'Beoordelingsroutering',
            page_title: 'Bekijk de routering',
            route_to_reviewers: 'Naar beoordelaars sturen',
            route_success: 'Succesvol naar beoordelaars gestuurd',
            vendor_id: 'Leverancier-ID',
            reviewer_id: 'Beoordelaar-ID',
            reviewer_role: 'Beoordelaarsrol',
            questionnaire_id: 'Vragenlijst-ID',
            review_status: 'Beoordelingsstatus',
            reviewers_label: 'Reviewers (user_id, rol per regel)',
            pending: 'In afwachting',
            in_review: 'In beoordeling',
            completed: 'Voltooid',
            no_routing: 'Geen beoordelingsroutering gevonden',
            primary_reviewer: 'Primaire beoordelaar',
            secondary_reviewer: 'Secundaire beoordelaar',
            approver: 'Goedkeurder',
        },
        onboarding: {
            title: 'Leverancier-onboarding-dossiers',
            page_title: 'Leverancier-onboarding-dossiers',
            new_case: 'Nieuw onboarding-dossier',
            case_detail: 'Onboarding-dossier',
            open_mps_dossier_filing: 'MPS-indiening openen',
            dossier_filing_description: 'Maakt een nieuwe MPS-indiening vooraf ingevuld vanuit dit onboardinggeval. De indiening wordt teruggekoppeld aan het geval.',
            dossier_filing_dpia_id: 'DPIA-ID',
            dossier_filing_dpia_id_placeholder: 'bv. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Indieningstitel',
            dossier_filing_form_type: 'Formuliertype',
            dossier_filing_submit: 'Indiening maken',
            dossier_filing_validation_error: 'DPIA-ID en titel zijn vereist.',
            dossier_filing_created: 'MPS-indiening aangemaakt',
            dossier_filing_error: 'MPS-indiening kon niet worden aangemaakt.',
            linked_questionnaire_due_date: 'Vervaldatum',
            linked_questionnaire_assignee: 'Toegewezen aan',
            linked_questionnaire_submitted_at: 'Ingediend op',
            score_last_scored: 'Laatst gescoord',
            score_dimensions: 'Dimensies',
            linked_contract_document_type: 'Documenttype',
            linked_contract_effective_date: 'Ingangsdatum',
            linked_contract_expiry_date: 'Verloopdatum',
            linked_sub_processor_countries: 'Verwerkingslanden',
            linked_sub_processor_last_assessment: 'Laatste beoordeling',
            linked_sub_processor_next_assessment: 'Volgende beoordeling',
            case_id: 'Dossier-ID',
            vendor: 'Leverancier',
            case_type: 'Dossiertype',
            service_description: 'Dienstbeschrijving',
            data_categories: 'Gegevenscategorieën',
            systems_accessed: 'Benaderde systemen',
            jurisdiction: 'Jurisdictie',
            hosting_model: 'Hostingmodel',
            controller_role: 'Verwerkingsverantwoordelijke/Verwerker-rol',
            status_pipeline: 'Statuspijplijn',
            tabs_label: 'Onboarding-dossiersecties',
            per_page: 'Dossiers per pagina',
            filter_cases: 'Onboarding-dossiers filteren',
            cases_count: 'dossiers',
            cases_loaded: 'onboarding-dossiers geladen',
            no_cases: 'Geen onboarding-dossiers gevonden.',
            vendor_lookup_placeholder: 'Voer leverancier-ID in',
            data_categories_placeholder: 'bijv., persoonsgegevens, financieel, gezondheid',
            systems_placeholder: 'bijv., CRM, ERP, HR-systeem',
            status_open: 'Openen',
            status_in_progress: 'In uitvoering',
            status_awaiting_approval: 'Wacht op goedkeuring',
            status_approved: 'Goedgekeurd',
            status_remediation_required: 'Herstel vereist',
            status_closed: 'Gesloten',
            type_new_vendor: 'Nieuwe leverancier',
            type_service_change: 'Dienstwijziging',
            type_renewal: 'Verlenging',
            type_reassessment: 'Herbeoordeling',
            tab_overview: 'Overzicht',
            tab_due_diligence: 'Zorgvuldigheidsonderzoek',
            tab_security_assessment: 'Beveiligingsbeoordeling',
            tab_contractual_controls: 'Contractuele controles',
            tab_sub_processors: 'Subverwerkers',
            tab_approval_gates: 'Goedkeuringspoorten',
            tab_evidence: 'Bewijs',
            tab_placeholder: 'De inhoud van deze sectie wordt ingevuld tijdens het onboarding-proces.',
            completion_not_started: 'Niet gestart',
            completion_in_progress: 'In uitvoering',
            completion_completed: 'Voltooid',
            completion_requiring_attention: 'Aandacht vereist',
            gate_name: 'Poortnaam',
            approver: 'Goedkeurder',
            decision: 'Beslissing',
            comments: 'Opmerkingen',
            decide: 'Beslissing nemen',
            decision_approved: 'Goedgekeurd',
            decision_rejected: 'Afgewezen',
            decision_deferred: 'Uitgesteld',
            no_approvals: 'Geen goedkeuringspoorten geconfigureerd voor dit dossier.',
            approval_success: 'Goedkeuringsbeslissing succesvol vastgelegd',
            approval_error: 'Kon goedkeuringsbeslissing niet vastleggen',
            transition_status: 'Status wijzigen',
            confirm_transition: 'Dossier van "{from}" naar "{to}" wijzigen?',
            transition_success: 'Dossierstatus succesvol gewijzigd',
            transition_error: 'Kon dossierstatus niet wijzigen',
            create_success: 'Onboarding-dossier succesvol aangemaakt',
            create_error: 'Kon onboarding-dossier niet aanmaken',
            load_error: 'Kon onboarding-dossiers niet laden',
            detail_error: 'Kon dossierdetails niet laden',
            export: 'Exporteren',
            export_error: 'Kon onboarding-dossier niet exporteren',
            evidence_tab_description: 'Upload en exporteer bewijzen voor de onboardingzaak.',
            upload_evidence_label: 'Bewijs uploaden',
            attached_evidence_heading: 'Bijgevoegde bewijzen',
            no_evidence_attached: 'Nog geen bewijzen bijgevoegd.',
            export_bundle_button: 'Bewijsbundel exporteren',
            load_attachments_error: 'Bewijzen laden mislukt.',
            linked_questionnaires_heading: 'Gekoppelde vragenlijsten',
            no_linked_questionnaires: 'Geen gekoppelde vragenlijsten.',
            linked_scores_heading: 'Gekoppelde risicoscores',
            no_linked_scores: 'Geen gekoppelde scores.',
            latest_score_label: 'Laatste score',
            linked_contracts_heading: 'Gekoppelde contracten',
            no_linked_contracts: 'Geen gekoppelde contracten.',
            linked_sub_processors_heading: 'Gekoppelde subverwerkers',
            no_linked_sub_processors: 'Geen gekoppelde subverwerkers.',
        },
        sub_processors: {
            title: 'Register van subverwerkers',
            page_title: 'Register van subverwerkers',
            new_record: 'Nieuwe subverwerker',
            edit_record: 'Subverwerker bewerken',
            onboarding_case: 'Onboarding-dossier',
            services: 'Geleverde diensten',
            data_categories: 'Gegevenscategorieën',
            processing_countries: 'Verwerkingslanden',
            dpa_chain_status: 'DPA-ketenstatus',
            certifications: 'Certificeringen',
            last_assessment: 'Laatste beoordeling',
            next_assessment: 'Volgende beoordeling',
            change_history: 'Wijzigingsgeschiedenis',
            history: 'Geschiedenis',
            changed_by: 'Gewijzigd door',
            comma_separated: 'Kommagescheiden waarden',
            filter_records: 'Registraties filteren',
            filter_by_dpa: 'Filteren op DPA-ketenstatus',
            all_dpa_statuses: 'Alle DPA-statussen',
            per_page: 'Registraties per pagina',
            records_count: 'subverwerkers',
            records_loaded: 'registraties geladen',
            no_records: 'Geen subverwerkers gevonden.',
            no_history: 'Geen wijzigingsgeschiedenis beschikbaar.',
            dpa_active: 'Actief',
            dpa_pending: 'In afwachting',
            dpa_expired: 'Verlopen',
            dpa_not_required: 'Niet vereist',
            create_success: 'Subverwerker succesvol aangemaakt',
            create_error: 'Kon subverwerker niet aanmaken',
            update_success: 'Subverwerker succesvol bijgewerkt',
            update_error: 'Kon subverwerker niet bijwerken',
            load_error: 'Kon register niet laden',
            history_error: 'Kon wijzigingsgeschiedenis niet laden',
            export_csv: 'Exporteer CSV',
            export_json: 'Exporteer JSON',
            export_error: 'Kon gegevens niet exporteren',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Orkestratieoverzicht',
            runs: 'Orkestratieruns',
            tasks: 'Uitvoeringstaken',
            templates: 'Checklistsjablonen',
            vendor_requests: 'Leveranciersverzoeken',
            proof_chain: 'Bewijsketen',
            dsr_integration: 'DSR-integratie',
            vendor_verification: 'Leveranciersverificatie',
            completeness: 'Volledigheidsoverzicht',
        },
        dashboard: {
            title: 'Orkestratieoverzicht',
            loading: 'Laden van dashboard gegevens...',
            active_runs: 'Actief Runs',
            completion_rate: 'Voltooiing Tarief',
            avg_completion_time: 'Avg Voltooiing Tijd',
            overdue_tasks: 'Te laat Taken',
            vendor_compliance: 'Leverancier Naleving',
            recent_runs: 'Recente uitvoeringen',
            no_recent_runs: 'Geen recente orkestratie-uitvoeringen.',
            run_id: 'Uitvoeren ID',
            ticket_id: 'Ticket-ID',
            progress: 'Voortgang',
            systems: 'Systemen',
            vendors: 'Leveranciers',
            load_error: 'Kan het orkestratiedashboard niet laden. Probeer het opnieuw.',
            aria_table: 'Recente orkestratie-uitvoeringen',
        },
        runs: {
            title: 'Orkestratieruns',
            new: 'Nieuw Uitvoeren',
            run_id: 'Uitvoeren ID',
            ticket_id: 'Ticket-ID',
            progress: 'Voortgang',
            systems: 'Systemen',
            vendors: 'Leveranciers',
            data_subject_ref: 'Gegevens Onderwerp Ref',
            data_categories: 'Gegevens Categorieën',
            enable_proof_chain: 'Inschakelen Bewijs Keten',
            start: 'Starten',
            started: 'Het rennen is begonnen',
            mark_ready: 'Markeer gereed',
            marked_ready: 'Uitvoering gemarkeerd als gereed',
            complete: 'Compleet',
            complete_exceptions: 'Compleet met uitzonderingen',
            pause: 'Pauze',
            resume: 'Hervatten',
            cancel: 'Annuleer',
            no_runs: 'Geen orchestration runs gevonden.',
            load_error: 'Kan orkestratie-uitvoeringen niet laden. Probeer het opnieuw.',
            create_error: 'Kan orkestratierun niet maken',
            aria_filter_status: 'Filter op uitvoeringsstatus',
            aria_table: 'Orkestratie loopt',
            placeholder_ticket_id: 'bijvoorbeeld TKT-000123',
            placeholder_data_subject_ref: 'bijvoorbeeld DS-REF-001',
            placeholder_data_categories: 'bijvoorbeeld personal_data, financieel, gezondheid',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: 'Uitvoeringstaken',
            task_id: 'Taak ID',
            run_id: 'Uitvoeren ID',
            system_name: 'Systeem Naam',
            assigned_to: 'Toegewezen Naar',
            sla_deadline: 'SLA-deadline',
            progress: 'Voortgang',
            enter_run_id: 'Invoeren Uitvoeren ID naar filter...',
            select_run: 'Selecteer een run om taken te bekijken',
            unassigned: 'Niet toegewezen',
            overdue: 'Te laat',
            assign_task: 'Toewijzen Taak',
            assignee_id: 'Toegewezene ID',
            update_status: 'Bijwerken Status',
            new_status: 'Nieuw Status',
            no_transitions: 'Deze taak heeft een eindstatus en kan niet worden gewijzigd.',
            select_status_placeholder: 'Selecteer een nieuwe status',
            skip_justification: 'Reden voor overslaan',
            failure_reason: 'Reden van mislukking',
            no_tasks: 'Geen execution taken gevonden.',
            new_task: 'Nieuwe taak',
            system_id: 'Systeem-ID',
            data_classification: 'Gegevensclassificatie',
            load_error: 'execution tasks laden mislukt. Probeer het opnieuw.',
            assign_error: 'assign task mislukt',
            status_error: 'Bijwerken van taakstatus mislukt',
            no_tasks_for_run: 'Deze verwijderingsrun heeft nog geen uitvoeringstaken.',
            aria_filter_run_id: 'Filter op run-ID',
            aria_filter_status: 'Filter op taakstatus',
            aria_table: 'Uitvoeringstaken',
            view_steps: 'Stappen bekijken',
            steps_modal_title: 'Uitvoeringsstappen',
            step_title: 'Stap',
            step_status: 'Stapstatus',
            step_notes: 'Notities',
            step_evidence: 'Bewijsbestanden',
            step_evidence_required: 'Bewijs is vereist voor deze stap',
            step_evidence_missing: 'Nog geen bewijs geüpload',
            step_save: 'Stap opslaan',
            step_saved: 'Stap bijgewerkt',
            step_save_error: 'Stap bijwerken mislukt',
            create_success: 'Uitvoeringstaak aangemaakt',
            create_error: 'Uitvoeringstaak aanmaken mislukt',
            step_upload_label: 'Bewijs bijvoegen',
        },
        templates: {
            title: 'Checklistsjablonen',
            new: 'Nieuw Sjabloon',
            template_id: 'Sjabloon ID',
            system_type: 'Systeem Type',
            est_duration: 'Est. Duur',
            steps: 'Stappen',
            action_type: 'Actie Type',
            instructions: 'Instructies',
            mandatory: 'Verplicht',
            add_step: 'Toevoegen Stap',
            step_n: 'Stap',
            no_templates: 'Geen checklist sjablonen gevonden.',
            all_system_types: 'Alle Systeem Types',
            load_error: 'Kan checklistsjablonen niet laden. Probeer het opnieuw.',
            create_error: 'Kan checklistsjabloon niet maken',
            aria_filter_system_type: 'Filter op systeemtype',
            aria_filter_status: 'Filter op sjabloonstatus',
            aria_table: 'Checklist-sjablonen',
            placeholder_name: 'bijvoorbeeld een checklist voor het verwijderen van databases',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Sjabloon succesvol bijgewerkt',
            create_success_msg: 'Sjabloon succesvol aangemaakt',
            update_error: 'Sjabloon bijwerken mislukt',
            activate_success: 'Sjabloon succesvol geactiveerd',
            activate_error: 'Sjabloon activeren mislukt',
            archive_success: 'Sjabloon succesvol gearchiveerd',
            archive_error: 'Sjabloon archiveren mislukt',
            clone_success: 'Sjabloon succesvol gekloond',
            clone_error: 'Sjabloon klonen mislukt',
        },
        vendor_requests: {
            title: 'Leverancier Deletion Verzoeken',
            new: 'Nieuw Verzoek',
            request_id: 'Verzoek ID',
            vendor_name: 'Leverancier Naam',
            vendor_id: 'Leverancier ID',
            data_subject_ref: 'Gegevens Onderwerp Ref',
            data_categories: 'Gegevens Categorieën',
            legal_basis: 'Juridisch Grondslag',
            sla_days: 'SLA Dagen',
            requested_completion: 'Gevraagd Voltooiing',
            communications: 'Communicaties',
            total_requests: 'Totaal Verzoeken',
            no_requests: 'Geen leverancier verwijdering requests gevonden.',
            filter_vendor_id: 'Filteren op Leverancier ID...',
            change_status: 'Status Wijzigen',
            new_status: 'Nieuwe Status',
            actions: 'Acties',
            load_error: 'Kan verwijderingsverzoeken van leverancier niet laden. Probeer het opnieuw.',
            create_error: 'Kan een verwijderingsverzoek van de leverancier niet maken',
            dashboard_error: 'Kan het verwijderingsdashboard van de leverancier niet laden. Probeer het opnieuw.',
            aria_filter_status: 'Filter op aanvraagstatus',
            aria_filter_vendor_id: 'Filter op leveranciers-ID',
            aria_table: 'Verwijderingsverzoeken van leveranciers',
            placeholder_vendor_id: 'bijvoorbeeld VND-001',
            placeholder_vendor_name: 'bijvoorbeeld Acme Analytics',
            placeholder_data_subject_ref: 'bijvoorbeeld DS-REF-001',
            placeholder_data_categories: 'bijvoorbeeld personal_data, analyses',
            placeholder_legal_basis: 'bijv. [[TOK_0]] Artikel 19',
        },
        proof_chain: {
            title: 'Bewijs Keten Kijker',
            enter_run_id: 'Invoeren Uitvoeren ID...',
            load_chain: 'Laden Keten',
            verify_chain: 'Verifiëren Keten',
            verifying: 'Verifiëren...',
            chain_valid: 'Keten is valid',
            chain_invalid: 'Keten is broken',
            chain_length: 'Keten Length',
            broken_at_index: 'Gebroken bij index',
            no_proof_records: 'Geen bewijs records gevonden voor dit uitvoering..',
            proof_id: 'Bewijs ID',
            entity_type: 'Entiteit Type',
            entity_id: 'Entiteit ID',
            event_hash: 'Gebeurtenis Hash',
            previous_hash: 'Vorig Hash',
            attestation: 'Attestering',
            attestation_actor: 'Uitgevoerd door',
            attestation_signed_at: 'Ondertekend op',
            attestation_signature: 'Handtekening',
            attestation_evidence_refs: 'Bewijsreferenties',
            run_field_label: 'Verwijderingsrun',
            select_run: 'Selecteer een verwijderingsrun…',
            aria_select_run: 'Verwijderingsrun voor het opzoeken van de bewijsketen',
            chain_broken_here: 'Keten broken here',
            load_error: 'Kan de proefketting niet laden. Probeer het opnieuw.',
            verify_error: 'Kan de bewijsketen niet verifiëren. Probeer het opnieuw.',
            aria_run_id: 'Voer ID uit voor het opzoeken van de proefketen',
        },
        dsr_integration: {
            change_status: 'Status wijzigen',
            request_type: 'Verzoektype',
            data_subject_hint: 'Identificatie van de betrokkene wiens gegevens worden gewist (bijv. e-mail of klant-ID). Komt meestal overeen met de aanvrager van de geselecteerde DSR-zaak.',
            title: 'DSR-verwijderingsintegratie',
            create_run: 'DSR-verwijderingsrun aanmaken',
            dsr_case_id: 'DSR-zaak-ID',
            data_subject_id: 'Betrokkene-ID',
            systems: 'Doelsystemen',
            route_to_department: 'Doorsturen naar afdeling',
            confirm_deletion: 'Verwijdering bevestigen',
            no_runs: 'Geen DSR-verwijderingsruns gevonden',
            status: 'Verwijderingsstatus',
            deadline: 'Deadline',
        },
        vendor_verification: {
            title: 'Leveranciersverwijderingsverificatie',
            create_followup: 'Opvolging aanmaken',
            deadline: 'Bevestigingsdeadline',
            escalation_contact: 'Escalatiecontact',
            record_confirmation: 'Bevestiging vastleggen',
            overdue: 'Achterstallige verwijderingen',
            escalate: 'Escaleren',
            confirm_escalation: 'Weet u zeker dat u dit verwijderingsverzoek van de leverancier wilt escaleren?',
            no_followups: 'Geen leveranciersopvolgingen gevonden',
            no_overdue: 'Geen achterstallige leveranciersverwijderingen',
            vendor_request: 'Leveranciersverzoek',
            vendor: 'Leverancier',
            unknown_vendor: 'Onbekende leverancier',
            overdue_badge: 'Achterstallig',
            mark_confirmed: 'Markeren als bevestigd',
            mark_confirmed_for: 'Verwijdering als bevestigd markeren voor {vendor}',
            confirm_confirmation: 'Deze leveranciersverwijdering als bevestigd markeren?',
            confirmation_success: 'Leveranciersverwijdering bevestigd',
            confirmation_failed: 'Kon leveranciersverwijdering niet bevestigen',
            select_request: 'Selecteer een leveranciersverzoek…',
            escalation_contact_placeholder: 'bijv. dpo@vendor.example',
            create_success: 'Leveranciersopvolging succesvol aangemaakt',
            create_failed: 'Kon leveranciersopvolging niet aanmaken',
            deadline_hint: 'Deze pagina toont alleen opvolgingen waarvan de termijn al is verstreken.',
            deadline_future_warning: 'Deze termijn ligt in de toekomst, dus de opvolging verschijnt pas in de lijst met achterstallige items zodra de datum is verstreken.',
            escalation_success: 'Leveranciersverwijdering succesvol geëscaleerd',
            escalation_failed: 'Escalatie van leveranciersverwijdering mislukt',
        },
        completeness: {
            title: 'Verwijderingsvolledigheid',
            check_conflicts: 'Bewaringsconflicten controleren',
            no_conflicts: 'Geen bewaringsconflicten gevonden',
            conflict_resolution: 'Conflictoplossing',
            extend_retention: 'Bewaring verlengen',
            proceed_deletion: 'Doorgaan met verwijdering',
            escalate_conflict: 'Escaleren',
            resolve: 'Conflict oplossen',
            data_subject_id: 'ID van de betrokkene',
            placeholder_data_subject_id: 'Voer de ID van de betrokkene in',
            data_subject_hint: 'Identificatie van de persoon van wie u de verwijdering controleert (bijv. e-mail, klant-ID of DSR-referentie). Kies een bekend subject of typ er een.',
            guidance: 'Voer een betrokkene-ID in of selecteer er een, kies optioneel systemen en voer de controle uit om de volledigheid van de verwijdering en bewaarconflicten te zien.',
            completion: 'Verwijdering voltooid',
            pending_items: 'Openstaande items',
            system: 'Systeem',
            policy: 'Beleid',
            retention_end: 'Retentie einde',
            completed_items: 'Voltooide Items',
            last_review_label: 'Laatste recensie',
            days_ago: 'dagen geleden',
            review_overdue: 'Beoordelingscyclus overschreden. Herbeoordeling vereist.',
        },
        run_status_labels: {
            pending: 'In behandeling',
            planning: 'Plannen',
            ready: 'Gereed',
            in_progress: 'In Uitvoering',
            paused: 'Gepauzeerd',
            completed: 'Voltooid',
            completed_with_exceptions: 'Voltooid met Uitzonderingen',
            cancelled: 'Geannuleerd',
        },
        task_status_labels: {
            pending: 'In Afwachting',
            assigned: 'Toegewezen',
            in_progress: 'In Uitvoering',
            awaiting_verification: 'Wacht op Verificatie',
            verified: 'Geverifieerd',
            failed: 'Mislukt',
            skipped: 'Overgeslagen',
        },
        system_type_labels: {
            database: 'Database',
            saas_application: 'SaaS-applicatie',
            file_storage: 'Bestandsopslag',
            email_system: 'E-mailsysteem',
            analytics_platform: 'Analyseplatform',
            backup_system: 'Back-upsysteem',
            vendor_managed: 'Leverancierbeheerd',
            custom: 'Aangepast',
        },
        template_status_labels: {
            draft: 'Concept',
            active: 'Actief',
        },
        action_type_labels: {
            manual_check: 'Handmatige Controle',
            api_call: 'API-aanroep',
            sql_query: 'SQL-query',
            script_execution: 'Scriptuitvoering',
            file_deletion: 'Bestandsverwijdering',
            verification: 'Verificatie',
            notification: 'Melding',
            approval: 'Goedkeuring',
        },
        request_status_labels: {
            draft: 'Concept',
            sent: 'Verzonden',
            acknowledged: 'Bevestigd',
            in_progress: 'In Uitvoering',
            completed: 'Voltooid',
            overdue: 'Achterstallig',
            escalated: 'Geëscaleerd',
            disputed: 'Betwist',
        },
        event_type_labels: {
            initiation: 'Initiatie',
            data_deletion: 'Gegevensverwijdering',
            completion: 'Voltooiing',
            verification: 'Verificatie',
            rollback: 'Terugdraaien',
        },
        count_labels: {
            one_template: '1 sjabloon',
            n_templates: '{n} sjablonen',
            one_run: '1 uitvoering',
            n_runs: '{n} uitvoeringen',
            one_task: '1 taak',
            n_tasks: '{n} taken',
            one_request: '1 verzoek',
            n_requests: '{n} verzoeken',
        },
        aria: {
            completion_rate: 'Voltooiingspercentage: {pct}%',
            vendor_compliance: 'Leveranciersconformiteit: {pct}%',
            run_progress: 'Uitvoeringsvoortgang: {pct}%',
            run_progress_systems: 'Voortgang: {completed} van {total} systemen verwerkt',
            chain_broken: 'Keten gebroken bij dit record',
            chain_valid: 'Keten geldig bij dit record',
            chain_unknown: 'Ketenstatus onbekend',
            escalate_vendor: 'Escaleer {id}',
            resolve_conflict: 'Conflict oplossen voor {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'De volledigheid van de verwijdering moet ten minste elke 365 dagen worden beoordeeld. Records die deze drempel overschrijden, worden gemarkeerd voor verplichte herbeoordeling om naleving van de regelgeving te handhaven.',
            runs_data_d1_lifecycle_info: 'De statussen van de orkestratieuitvoering worden toegewezen aan de levenscyclus DATA-D1: planning = catalogus, klaar = classificeren, in_progress = regels toepassen, voltooid = bewijs gegenereerd, completed_with_exceptions = beoordeling vereist. Elke overgang wordt vastgelegd in de proefketen.',
            vendor_record_linkage_info: 'Elk leveranciersverwijderingsverzoek is gekoppeld aan het bijbehorende leveranciersrecord via vendor_id. Voor de voltooiingsbevestiging is cryptografisch bewijs uit de proefketen vereist voordat het verzoek als voltooid kan worden gemarkeerd.',
            templates_internal_classification_info: 'Alle sjablonen voor verwijderingscontrolelijsten zijn geclassificeerd als interne organisatiedocumenten. Ze zijn niet voorzien van officiële identificatieformulieren en mogen niet worden ingediend als registratiedocumenten.',
            proof_chain_evidence_info: 'In elk bewijsrecord worden de betrokkene/categorie, tijdstempel, actor, rechtsgrondslag en een SHA-256-hash vastgelegd. Samen produceren deze velden cryptografisch verwijderingsbewijs dat voldoet aan de wettelijke auditvereisten.',
            retention_data_law_info: "Bewaarschema's op dit dashboard zijn afgeleid van de Data Law-classificatie die aan elke gegevenscategorie is toegewezen. Wanneer een classificatie verandert, worden gekoppelde bewaarregels automatisch bijgewerkt om afstemming van de regelgeving te garanderen.",
            dsr_erasure_route_info: 'DSR-verwijderingsruns zijn gekoppeld aan de oorspronkelijke Rights Request-zaak. De wettelijke deadline (doorgaans 30 dagen volgens [[TOK_0]] Art. 17) wordt automatisch bijgehouden. Achterstallige zaken worden gemarkeerd voor escalatie.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Ontdekkingsoverzicht',
            scans: 'Ontdekkingsscans',
            staging_area: 'Tussengebied',
            dedup_rules: 'Deduplicatieregels',
            classification_rules: 'Classificatieregels',
            suggestions: 'Suggestiewachtrij',
            analytics: 'Suggestieanalyse',
            import_templates: 'Importsjablonen',
            connectors: 'Connectorbeheer',
            discovery_cycles: 'Ontdekkingscycli',
            owner_review: 'Eigenaarsbeoordeling',
            classification_lineage: 'Classificatiehistorie',
        },
        dashboard: {
            title: 'Ontdekkingsoverzicht',
            loading: 'Laden van dashboard gegevens...',
            total_scans: 'Totaal Scans',
            active_scans: 'Actief Scans',
            completed_30d: 'Voltooid (30d)',
            failed_30d: 'Mislukt (30d)',
            systems_discovered: 'Systemen Ontdekt',
            pending_staged_records: 'In afwachting Staged Records',
            recent_scans: 'Recente scans',
            no_recent_scans: 'Geen recente scans.',
            scan_id: 'Scannen ID',
            discovered: 'Ontdekt',
            view_all_scans: 'Bekijken Alle Scans',
            staging_area: 'Staginggebied',
            suggestion_queue: 'Suggestie Wachtrij',
            records_reviewed: 'Beoordeelde records',
            records_approved: 'Goedgekeurde records',
            exceptions_pending: 'Openstaande uitzonderingen',
            view_as_chart: 'Als diagram weergeven',
            view_as_table: 'Als tabel weergeven',
        },
        scans: {
            title: 'Ontdekkingsscans',
            new: 'Nieuw Scannen',
            scan_id: 'Scannen ID',
            scan_type: 'Scannen Type',
            progress: 'Voortgang',
            discovered: 'Ontdekt',
            no_scans: 'Geen discovery scans gevonden.',
            all_scan_types: 'Alle Scannen Types',
            source_config: 'Bron Configuratie (JSON)',
            invalid_json: 'Ongeldig JSON in source configuratie',
            load_error: 'Kan niet load discovery scans. Probeer het opnieuw.',
            create_error: 'Kan niet create discovery scan',
            change_status: 'Wijzig status',
            new_status: 'Nieuwe status',
            actions: 'Acties',
            type_endpoint: 'Eindpunt',
            type_spreadsheet_import: 'Spreadsheet-import',
            type_cmdb_sync: 'CMDB-synchronisatie',
            type_cloud_sync: 'Cloud-synchronisatie',
            status_pending: 'In afwachting',
            status_running: 'Wordt uitgevoerd',
            status_completed: 'Voltooid',
            status_failed: 'Mislukt',
            status_cancelled: 'Geannuleerd',
            source_config_placeholder: '{"host": "...", "poort": 443}',
        },
        staging_area: {
            title: 'Tussengebied',
            record_id: 'Record-ID',
            source_scan: 'Bron Scannen',
            entity_type: 'Entiteit Type',
            suggested_name: 'Voorgesteld Naam',
            confidence: 'Betrouwbaarheid',
            no_records: 'Geen staged records gevonden.',
            promote: 'Promoveren',
            discard: 'Verwerpen',
            review: 'Beoordelen',
            merge: 'Samenvoegen',
            merge_title: 'Record samenvoegen',
            merge_target_id: 'Samenvoegen Doel ID',
            reject_reason_placeholder: 'Reden voor rejection...',
            promotion_status: 'Promotie Status',
            dedup_status: 'Deduplicatiestatus',
            all_source_types: 'Alle Bron Types',
            all_promotion_statuses: 'Alle Promotie Statuses',
            all_dedup_statuses: 'Alle Dedup Statuses',
            load_error: 'Kan niet load staged records. Probeer het opnieuw.',
            promote_error: 'Kan niet promote record',
            reject_error: 'Kan niet reject record',
            merge_error: 'Kan niet merge record',
            review_error: 'Kan niet mark record voor beoordeling',
            bulk_promote_error: 'Kan niet bulk promote records',
            bulk_reject_error: 'Kan niet bulk reject records',
            service_type_web_server: 'Webserver',
            service_type_database: 'Database',
            service_type_api_gateway: 'API-gateway',
            service_type_storage: 'Opslag',
            service_type_authentication: 'Authenticatie',
            service_type_analytics: 'Analyse',
            service_type_unknown: 'Onbekend',
            source_type_endpoint_scan: 'Eindpuntscan',
            source_type_spreadsheet: 'Spreadsheet',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Cloud-inventaris',
            promotion_status_new: 'Nieuw',
            promotion_status_under_review: 'In beoordeling',
            promotion_status_promoted: 'Gepromoveerd',
            promotion_status_rejected: 'Afgewezen',
            promotion_status_merged: 'Samengevoegd',
            dedup_status_unmatched: 'Geen overeenkomst',
            dedup_status_potential_match: 'Mogelijke overeenkomst',
            dedup_status_exact_match: 'Exacte overeenkomst',
            dedup_status_resolved: 'Opgelost',
            confirm_bulk_reject: 'Weet u zeker dat u de geselecteerde records wilt afwijzen?',
            scan_batch_id: 'Batch-ID',
            promote_to_registry_title: 'Promoten naar gegevensregister',
            promote_modal_instructions: 'Creëert een gegevensregisteritem met collection_method: waargenomen en herkomstkoppeling naar dit ontdekkingsrecord. Het item begint in de conceptstatus ter beoordeling.',
            promote_label_category: 'Categorie',
            promote_label_name_override: 'Naam (optionele overschrijving)',
            placeholder_name_override: 'Standaard ingesteld op de naam/hostnaam van het ontdekkingsrecord',
            promote_label_sensitivity: 'Voorgestelde gevoeligheid',
            inherit_from_category: 'Erven van categorie',
        },
        dedup_rules: {
            title: 'Deduplicatieregels',
            new: 'Nieuw Regel',
            rule_name: 'Regel Naam',
            match_fields: 'Matchen Velden',
            threshold: 'Drempelwaarde',
            no_rules: 'Geen dedup regels gevonden.',
            seed_defaults: 'Initialiseren Standaardwaarden',
            match_type: 'Matchen Type',
            similarity_threshold: 'Gelijkenis Drempelwaarde',
            field_name: 'Veld Naam',
            load_error: 'Kan niet load dedup regels. Probeer het opnieuw.',
            create_error: 'Kan niet create dedup regel',
            toggle_error: 'Kan niet toggle dedup regel',
            seed_error: 'Kan niet seed standaardwaarden',
            priority: 'Prioriteit',
            enabled_status: 'Ingeschakeld',
            disabled_status: 'Uitgeschakeld',
            default_badge: 'Standaard',
            enable: 'Inschakelen',
            disable: 'Uitschakelen',
            match_type_exact: 'Exact',
            match_type_fuzzy: 'Onscherp',
            match_type_regex: 'Regex',
            match_type_ip_range: 'IP-bereik',
        },
        classification_rules: {
            title: 'Classificatieregels',
            new: 'Nieuw Regel',
            rule_name: 'Regel Naam',
            pattern: 'Patroon',
            classification: 'Classificatie',
            no_rules: 'Geen classification regels gevonden.',
            seed_defaults: 'Initialiseren Standaardwaarden',
            run_rules_now: 'Voer nu regels uit',
            run_rules_success: '[[TOK_1]] nieuwe classificatiesuggestie(s) gegenereerd',
            run_rules_no_results: 'Er zijn geen nieuwe suggesties gegenereerd: voor alle overeenkomende regels zijn al suggesties in behandeling',
            run_rules_error: 'Kan classificatieregels niet uitvoeren. Probeer het opnieuw.',
            taxonomy_id: 'Taxonomie ID',
            level_id: 'Niveau ID',
            condition_logic: 'Voorwaarde Logic',
            weight: 'Gewicht',
            conditions: 'Voorwaarden',
            condition_field: 'Veld',
            condition_operator: 'Bewerking',
            condition_value: 'Waarde',
            effectiveness: 'Effectiviteit',
            match_count: 'Overeenkomsten',
            approval_count: 'Goedkeuringen',
            rejection_count: 'Afwijzingen',
            filter_taxonomy: 'Filteren op Taxonomie ID...',
            load_error: 'Kan niet load classification regels. Probeer het opnieuw.',
            create_error: 'Kan niet create classification regel',
            seed_error: 'Kan niet seed standaardwaarden',
            toggle_error: 'Kan niet toggle regel. Probeer het opnieuw.',
            priority: 'Prioriteit',
            enabled_status: 'Ingeschakeld',
            disabled_status: 'Uitgeschakeld',
            enable: 'Inschakelen',
            disable: 'Uitschakelen',
            logic_and: 'EN',
            logic_or: 'OF',
            operator_equals: 'Gelijk aan',
            operator_contains: 'Bevat',
            operator_matches_regex: 'Komt overeen met Regex',
            operator_in_list: 'In lijst',
            operator_not_equals: 'Niet gelijk aan',
            operator_not_contains: 'Bevat niet',
            enabled_label: 'Ingeschakeld',
            disabled_label: 'Uitgeschakeld',
            taxonomy_label: 'Taxonomie',
            operator_label: 'Exploitant',
            value_label: 'Waarde',
        },
        suggestions: {
            title: 'Suggestiewachtrij',
            entity_type: 'Entiteit Type',
            suggested_name: 'Voorgesteld Naam',
            source: 'Bron',
            confidence: 'Betrouwbaarheid',
            accept: 'Accepteren',
            reject: 'Afwijzen',
            no_suggestions: 'No suggesties in queue.',
            modify_approve: 'Wijzigen & Goedkeuren',
            delegate: 'Delegeren',
            delegate_user_id: 'Delegeren Gebruiker ID',
            new_level_id: 'Nieuw Niveau ID',
            reject_reason_placeholder: 'Reden voor rejection...',
            current_level: 'Huidig Niveau',
            suggested_level: 'Voorgesteld Niveau',
            filter_taxonomy: 'Filteren op Taxonomie ID...',
            all_confidence: 'Alle Betrouwbaarheid Bands',
            load_error: 'Kan niet load suggesties. Probeer het opnieuw.',
            approve_error: 'Kan niet approve suggestie',
            reject_error: 'Kan niet reject suggestie',
            modify_error: 'Kan niet modify & approve suggestie',
            delegate_error: 'Kan niet delegate suggestie',
            bulk_approve_error: 'Kan niet bulk approve suggesties',
            bulk_reject_error: 'Kan niet bulk reject suggesties',
            suggestion_type_new_label: 'Nieuw label',
            suggestion_type_validation: 'Validatie',
            suggestion_type_reclassification: 'Herclassificatie',
            status_pending: 'In afwachting',
            status_approved: 'Goedgekeurd',
            status_rejected: 'Afgewezen',
            status_superseded: 'Vervangen',
            confidence_high: 'Hoog',
            confidence_medium: 'Gemiddeld',
            confidence_low: 'Laag',
            confirm_bulk_reject: 'Weet u zeker dat u de geselecteerde suggesties wilt afwijzen?',
        },
        analytics: {
            title: 'Suggestieanalyse',
            total_suggestions: 'Totaal Suggesties',
            accepted: 'Geaccepteerd',
            rejected: 'Afgewezen',
            pending: 'In afwachting',
            acceptance_rate: 'Acceptance Tarief',
            by_entity_type: 'By Entiteit Type',
            by_source: 'By Bron',
            avg_decision_time: 'Avg Beslissing Tijd',
            rule_effectiveness: 'Regel Effectiviteit',
            by_status: 'Per status',
            by_confidence: 'By Betrouwbaarheid Band',
            load_error: 'Kan niet load suggestie analytics. Probeer het opnieuw.',
            confidence_high: 'Hoog',
            confidence_medium: 'Gemiddeld',
            confidence_low: 'Laag',
            by_confidence_band: 'Per betrouwbaarheidsniveau',
            approval_rate: 'Goedkeuringspercentage',
            by_label_state: 'Per labelstatus',
        },
        import_templates: {
            title: 'Importsjablonen',
            new: 'Nieuw Sjabloon',
            template_name: 'Sjabloon Naam',
            file_format: 'Bestand Formaat',
            column_mappings: 'Kolom Toewijzingen',
            no_templates: 'Geen import sjablonen gevonden.',
            source_column: 'Bron Kolom',
            target_field: 'Doel Veld',
            transform: 'Transformeren',
            source_column_label: 'Bronkolom',
            target_field_label: 'Doelveld',
            transform_label: 'Transformeren',
            confirm_delete: 'Are you sure you want naar delete dit import sjabloon?',
            load_error: 'Kan niet load import sjablonen. Probeer het opnieuw.',
            save_error: 'Kan niet save import sjabloon',
            delete_error: 'Kan niet delete import sjabloon',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Connectorbeheer',
            new: 'Nieuw Connector',
            connector_name: 'Connector Naam',
            connector_type: 'Soort',
            last_sync: 'Laatste Synchronisatie',
            no_connectors: 'Geen connectors gevonden.',
            cmdb_syncs: 'CMDB Synchronisaties',
            cloud_syncs: 'Cloud Synchronisaties',
            new_sync: 'Nieuw Synchronisatie',
            no_syncs: 'Geen syncs gevonden.',
            cmdb_error: 'Kan niet load CMDB scans. Probeer het opnieuw.',
            cloud_error: 'Kan niet load cloud scans. Probeer het opnieuw.',
            trigger_error: 'Kan niet trigger synchronisatie',
            trigger_sync_error: 'trigger {type} mislukt',
            cmdb_section_title: 'CMDB-synchronisaties',
            cloud_section_title: 'Cloudsynchronisaties',
            column_connector: 'Connector',
            action_start: 'Starten',
            confirm_cancel_sync: 'Deze synchronisatie annuleren?',
            start_error: 'Synchronisatie starten is mislukt',
            cancel_error: 'Synchronisatie annuleren is mislukt',
            type_endpoint: 'Endpoint-scan',
            type_spreadsheet_import: 'Spreadsheet-import',
            type_cmdb_sync: 'CMDB-synchronisatie',
            type_cloud_sync: 'Cloudsynchronisatie',
        },
        discovery_cycles: {
            title: 'Ontdekkingscycli',
            new_cycle: 'Nieuwe ontdekkingscyclus',
            cycle_name: 'Cyclusnaam',
            scope_type: 'Bereiktype',
            scope_ids: "Bereik-ID's",
            cadence_days: 'Frequentie (dagen)',
            status: 'Status',
            no_cycles: 'Geen ontdekkingscycli gevonden',
            compare: 'Cycli vergelijken',
            delta_report: 'Wijzigingsrapport',
            new_records: 'Nieuwe records',
            changed_records: 'Gewijzigde records',
            removed_records: 'Verwijderde records',
            schedule: 'Scan plannen',
            scope_organization: 'Organisatie',
            scope_department: 'Afdeling',
            scope_system: 'Systeem',
            scope_systems: 'Systemen',
            bulk_actions: 'Bulkacties',
            selected: '{count} geselecteerd',
            bulk_create: 'Bulk aanmaken',
            bulk_assign_scope: 'Bulk bereik toewijzen',
            bulk_advance: 'Bulk status bevorderen',
            confirm_bulk_action: 'Bulkactie bevestigen',
            bulk_confirm_message: 'Weet u zeker dat u deze actie wilt uitvoeren?',
            cycles_affected: '{count} cycli worden beïnvloed',
            select_all: 'Alles selecteren',
            select_cycle: 'Cyclus {name} selecteren',
            from_template: 'vanuit sjabloon',
            bulk_results: 'Bulkresultaten',
            failed_label: 'mislukt',
            template_id: 'Sjabloon-ID',
            count: 'Aantal',
            advance_to: 'Doelstatus',
            bulk_success: 'Bulkbewerking voltooid',
        },
        owner_review: {
            title: 'Eigenaarsbeoordelingstaken',
            assign_owner: 'Toewijzen aan eigenaar',
            owner_id: 'Eigenaar',
            decision: 'Beslissing',
            approve: 'Goedkeuren',
            modify: 'Wijzigen',
            reject: 'Afwijzen',
            escalate: 'Escaleren',
            no_tasks: 'Geen beoordelingstaken gevonden',
            bulk_resolve: 'Massaoplossing',
            exceptions: 'Uitzonderingsposten',
            no_exceptions: 'Geen uitzonderingsposten gevonden',
            record_id_label: 'Record-ID',
            selected: 'geselecteerd',
            notes: 'Notities',
            select_all: 'Alles Selecteren',
            select: 'Selecteren',
            confirm_resolve: 'Bevestigen',
        },
        classification_lineage: {
            title: 'Classificatiehistorie',
            link_suggestion: 'Koppelen aan voorgesteld label',
            suggestion_id: 'Suggestie',
            proposed_label_id: 'Voorgesteld label',
            no_lineage: 'Geen historiegegevens gevonden',
            full_lineage: 'Volledige historie',
            record_id_label: 'Record-ID',
            staged_record_label: 'Geënsceneerde opname',
            enter_staged_record_id: 'Voer de geënsceneerde record-ID in',
            scan_id_label: 'Scan-ID',
            select_record: 'Selecteer een record',
            select_suggestion: 'Selecteer een suggestie',
            select_label: 'Selecteer een label',
        },
        common_labels: {
            n_rules: '[[TOK_1]] regels',
            one_rule: '1 regel',
            n_scans: '[[TOK_1]] scant',
            one_scan: '1 scannen',
            n_syncs: '[[TOK_1]] synchroniseert',
            one_sync: '1 synchronisatie',
            n_records: '[[TOK_1]]-records',
            one_record: '1 plaat',
            n_templates: '[[TOK_1]] sjablonen',
            one_template: '1 sjabloon',
            n_suggestions: '[[TOK_1]] suggesties',
            one_suggestion: '1 suggestie',
            n_selected: '[[TOK_1]] geselecteerd',
            dashboard_loaded: 'Discovery-dashboard geladen',
            n_scans_loaded: '[[TOK_1]] scans geladen',
            n_staged_records_loaded: '[[TOK_1]] geënsceneerde records geladen',
            confirm_delete_import_template: 'Weet u zeker dat u dit importsjabloon wilt verwijderen?',
            invalid_json_source_config: 'Ongeldige [[TOK_0]] in source_config',
            scope_organization: 'Organisatie',
            scope_department: 'Afdeling',
            scope_system: 'Systeem',
            aria_filter_scans: 'Filterscans',
            aria_filter_staged_records: 'Filter geënsceneerde records',
            aria_filter_suggestions: 'Filters',
            aria_filter_by_taxonomy_id: 'Filter op taxonomie-ID',
            aria_filter_by_enabled_status: 'Filter op ingeschakelde status',
            aria_filter_by_source_type: 'Filter op brontype',
            aria_filter_by_promotion_status: 'Filter op promotiestatus',
            aria_filter_by_dedup_status: 'Filter op ontdubbelingsstatus',
            aria_filter_by_scan_type: 'Filter op scantype',
            aria_filter_by_status: 'Filter op status',
            aria_filter_by_confidence: 'Filter op vertrouwensband',
            aria_select_all_records: 'Selecteer alle records',
            aria_select_record: 'Selecteer record [[TOK_1]]',
            aria_select_all_suggestions: 'Selecteer alle suggesties',
            aria_select_suggestion: 'Selecteer suggestie [[TOK_1]]',
            aria_promote_record: 'Record promoten [[TOK_1]]',
            aria_discard_record: 'Record verwijderen [[TOK_1]]',
            aria_merge_record: 'Record samenvoegen [[TOK_1]]',
            aria_review_record: 'Reviewrecord [[TOK_1]]',
            aria_accept_suggestion: 'Suggestie accepteren [[TOK_1]]',
            aria_reject_record: 'Opname weigeren',
            aria_merge_record_dialog: 'Record samenvoegen',
            aria_create_new_scan: 'Nieuwe scan maken',
            aria_sync_progress: 'Synchronisatievoortgang: [[TOK_2]] van [[TOK_3]] items verwerkt',
            aria_scan_progress: 'Scanvoortgang: [[TOK_2]] van [[TOK_3]] items verwerkt',
            aria_confidence: 'Vertrouwen: [[TOK_1]]%',
            aria_effectiveness: 'Effectiviteit: [[TOK_1]]',
            aria_promote_n_records: 'Promoot [[TOK_1]] geselecteerde records',
            aria_discard_n_records: 'Gooi [[TOK_1]] geselecteerde records weg',
            placeholder_pii_detection_rule: 'bijvoorbeeld PII-detectieregel',
            placeholder_tax_id: 'bijvoorbeeld TAX-001',
            placeholder_lvl_id: 'bijvoorbeeld LVL-001',
            placeholder_service_type: 'bijvoorbeeld service_type',
            placeholder_database: 'bijvoorbeeld een database',
            placeholder_hostname_match: 'bijvoorbeeld Exacte match hostnaam',
            placeholder_hostname: 'bijvoorbeeld hostnaam',
            placeholder_hr_systems_csv: 'bijvoorbeeld HR-systemen [[TOK_0]] Importeren',
            placeholder_server_name: 'bijvoorbeeld servernaam',
            placeholder_hostname_field: 'bijvoorbeeld hostnaam',
            placeholder_lowercase: 'bijvoorbeeld kleine letters',
            placeholder_source_config: '{"host": "...", "poort": 443}',
            placeholder_stg_id: 'bijvoorbeeld STG-000123',
            placeholder_lvl_002: 'bijvoorbeeld LVL-002',
            placeholder_usr_id: 'bijvoorbeeld USR-000123',
            decision_for: 'Beslissing voor [[TOK_1]]',
        },
        exports: {
            title: 'Exporteren',
            inventory: 'Data-inventaris',
            classification_register: 'Classificatieregister',
            raci: 'RACI-matrix',
            exceptions: 'Uitzonderingenrapport',
            evidence_pack: 'Bewijspakket',
            delta_report: 'Wijzigingsrapport',
            executive_summary: 'Managementsamenvatting',
            export_button: 'Exporteren',
            downloading: 'Downloaden...',
            download_complete: 'Download voltooid.',
            download_error: 'Export-download mislukt. Probeer het opnieuw.',
        },
        flags: {
            title: 'Downstream-markeringen',
            pending: 'Openstaande markeringen',
            cross_border_review_needed: 'Grensoverschrijdende beoordeling vereist',
            sharing_disclosure_needed: 'Deelingsmelding vereist',
            dpia_review_needed: 'DPIA-beoordeling vereist',
            acknowledge: 'Bevestigen',
            resolve: 'Oplossen',
            no_flags: 'Geen downstream-markeringen.',
        },
        delta: {
            title: 'Wijzigingsoverzicht',
            new_count: '{n} nieuw',
            removed_count: '{n} verwijderd',
            changed_count: '{n} gewijzigd',
            re_review_triggered: 'Herbeoordeling geactiveerd',
            create_re_review: 'Herbeoordeling aanmaken',
            recent_alerts: 'Recente wijzigingswaarschuwingen',
            no_alerts: 'Geen recente wijzigingswaarschuwingen.',
            threshold_exceeded: 'Wijzigingsdrempel overschreden (>10%)',
        },
        regulatory: {
            dashboard_governance_info: "Dit dashboard toont de bestuursstatus op cyclusniveau: gescande systemen, geënsceneerde records, beoordeelde records, goedgekeurde records en in behandeling zijnde uitzonderingen. Dit komt overeen met de succescriteria voor governance-leads: 'live dashboard van wie zijn inventaris, classificatie en deellogboeken heeft bijgewerkt' (P-VN-05).",
            export_artifacts_info: 'Discovery-exports omvatten alle vereiste artefacttypen per UC-VN-10 en DATA-EVD-01: goedgekeurde gegevensinventarisatie, classificatieregister, eigendoms-/RACI-toewijzing, uitzonderingswachtrij, samenvatting, bewijspakket en deltarapport.',
            scan_inventory_pipeline_info: 'Elke voltooide scan produceert records die compatibel zijn met de vn_data_law_data_inventory_register-sjabloon (vereiste 88dd9877). Ontdekte data-assets vullen automatisch het data-inventarisregister in om te voldoen aan de verplichting van de Data Law om een ​​digitale data-inventaris bij te houden.',
            connector_linkage_info: 'Elke connectorconfiguratie moet het volgende bevatten: systeemtype (bijvoorbeeld [[TOK_0]], cloudplatform), gegevensopslagreferentie (database, bestandsopslag, SaaS) en koppeling van bedrijfsprocessen (UC-VN-10 vereiste ondersteunende records). Deze velden zorgen ervoor dat ontdekte assets traceerbaar zijn naar hun bronsysteem en bedrijfscontext.',
            owner_routing_info: 'Controletaken worden doorgestuurd naar de juiste afdeling of applicatie-eigenaar op basis van systeem-/gegevenseigendom (UC-VN-10 stap 5). Routing maakt gebruik van het systeemeigendomsregister en niet van ad-hoctoewijzing.',
            owner_actions_audit_info: 'Eigenaren kunnen elke classificatie goedkeuren, wijzigen, afwijzen of escaleren (UC-VN-10 stap 6). Bij elke actie worden de actor, het tijdstempel en de reden vastgelegd, waardoor er gebeurtenissen uit de governance-audit worden geproduceerd per vereiste f12fc090 (jaarlijkse governance-attest). Het audittraject laat zien wie heeft beoordeeld, wat er is gewijzigd en wanneer.',
            escalation_timers_info: 'Escalatietimers: deadline voor beoordeling door eigenaar is 5 werkdagen; escalatie van uitzonderingen is 48 uur (UC-VN-10 timers). Onopgeloste problemen worden automatisch geëscaleerd wanneer de deadline is verstreken. Timers zijn configureerbaar per organisatiebeleid.',
            original_suggestion_preserved_info: 'De oorspronkelijke suggestie voor machine-/systeemclassificatie blijft behouden naast elke wijziging door de eigenaar (UC-VN-10 bewijsvereiste). De oorspronkelijke suggestie wordt nooit overschreven en blijft zichtbaar voor auditdoeleinden.',
            dedup_lineage_info: 'Ontdubbelingsregels voorkomen dubbele inventarisinvoer wanneer hetzelfde gegevensmiddel wordt ontdekt via meerdere scans of connectoren. De meest recente scanmetagegevens worden bewaard als het primaire record, terwijl de afstammingsreferenties naar alle eerdere ontdekkingen behouden blijven voor de traceerbaarheid van de audit.',
            label_states_info: 'Analytics onderscheidt vier labelstatussen voor governancebeoordeling: door de machine voorgesteld (in behandeling), door de eigenaar goedgekeurd, door de eigenaar gewijzigd en afgewezen. Deze toestanden stellen auditors in staat de nauwkeurigheid van de automatisering en de betrokkenheid van de eigenaar te beoordelen.',
            import_pipeline_info: 'Importsjablonen moeten records produceren die compatibel zijn met de detectiepijplijn. Geïmporteerde records worden in de fasering geplaatst met dezelfde metadatavereisten als gescande records: bronsysteemidentificatie, batch-ID en tijdstempel. Kolomtoewijzingen moeten zich richten op velden die zijn gedefinieerd in vn_data_law_data_inventory_register.',
            lineage_full_path_info: 'De classificatielijn volgt het volledige pad: scannen/importeren -> staging -> eigenaarbeoordeling -> goedgekeurd label -> registerinvoer (UC-VN-10 stappen 1-10). Elke fase toont record-ID, acteur, tijdstempel en statusovergang voor volledige audittraceerbaarheid.',
            staging_workflow_info: 'Geënsceneerde records worden visueel onderscheiden van goedgekeurde voorraadinvoeren door hun promotiestatusbadge (UC-VN-10 stap 3). Elk record behoudt metagegevens over de herkomst: bronsysteem, scanbatch-ID en ontdekkingstijdstempel voor volledige audittraceerbaarheid.',
            suggestion_data_d1_info: 'Suggesties komen overeen met de datawetclassificatieprocedure DATA-D1: (1) catalogiseer gegevensassets, (2) classificeer op gevoeligheidsniveau, (3) definieer verwerkingsregels. Elke suggestie bevat gevoeligheids- en belangrijkheidsdimensies per vereiste 18e4bfd1.',
            downstream_flags_info: 'Items die zijn gemarkeerd voor delen, grensoverschrijdende overdracht of behandeling met een hoog risico activeren gekoppelde stroomafwaartse workflows: beoordeling van grensoverschrijdende overdracht, beoordeling van gedeeld risico en [[TOK_0]] beoordeling (UC-VN-10 stap 8).',
            delta_detection_info: 'Ontdekkingscycli ondersteunen deltadetectie per UC-VN-10 stap 11: elke cyclus laat zien welke records nieuw, gewijzigd of verwijderd zijn sinds de laatste goedgekeurde basislijn. Materiële wijzigingen (>10% delta) activeren automatisch herbeoordelingsworkflows.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Kan niet load..',
            save: 'Kan niet save..',
            fetch_escalation_log_failed: 'Kan niet fetch escalatie logboek..',
            fetch_activations_failed: 'Kan niet fetch activations..',
            deactivate_failed: 'Kan niet deactivate..',
            complete_activation_failed: 'Kan niet voltooid activation..',
            fetch_playbook_templates_failed: 'Kan niet fetch draaiboek sjablonen..',
            create_playbook_template_failed: 'Kan niet create draaiboek sjabloon..',
            clone_template_failed: 'Kan niet clone sjabloon..',
            update_status_failed: 'Kan de status niet bijwerken.',
            deprecate_template_failed: 'Kan niet deprecate sjabloon..',
            seed_defaults_failed: 'Kan niet seed standaardwaarden..',
            fetch_regulator_exports_failed: 'Kan niet fetch regulator exports..',
            create_regulator_export_failed: 'Kan niet create regulator export..',
            update_submission_status_failed: 'Kan niet update indiening status..',
            fetch_response_metrics_failed: 'Kan niet fetch response metrieken..',
            fetch_sla_dashboard_failed: 'Kan niet fetch SLA dashboard..',
            fetch_sla_definitions_failed: 'Kan niet fetch SLA definities..',
            create_sla_definition_failed: 'Kan niet create SLA definitie..',
            seed_sla_defaults_failed: 'Kan niet seed SLA standaardwaarden..',
            fetch_vendor_coordination_failed: 'Kan niet fetch leverancier coördinatie..',
            fetch_vendor_detail_failed: 'Kan niet fetch leverancier detail..',
            create_vendor_coordination_failed: 'Kan niet create leverancier coördinatie..',
            add_communication_failed: 'Kan niet add communication..',
            add_info_request_failed: 'Kan niet add info request..',
            add_action_request_failed: 'Kan niet add actie request..',
        },
        nav: {
            playbooks: 'Draaiboeksjablonen',
            sla_definitions: 'SLA-definities',
            sla_dashboard: 'SLA-overzicht',
            escalation_log: 'Escalatielogboek',
            regulator_exports: 'Toezichthouderexports',
            deadlines: 'Melding Deadlines',
            vendor_coordination: 'Leverancierscoördinatie',
            metrics: 'Responsmetingen',
            playbook_links: 'Draaiboek-koppelingen',
            regulatory_sla: 'Regelgevende SLA',
            coordination_dashboard: 'Coördinatie',
            evidence_chain: 'Bewijsketen',
            post_review: 'Post-incident beoordeling',
        },
        playbooks: {
            page_title: 'Speelboek-sjablonen',
            activations_page_title: 'Playbook-activeringen',
            title: 'Draaiboeksjablonen',
            new: 'Nieuw Sjabloon',
            seed_defaults: 'Initialiseren Standaardwaarden',
            scenario_type: 'Scenariotype',
            severity_applicability: 'Ernst Applicability',
            all_scenario_types: 'Alle Scenario Types',
            new_playbook: 'Nieuw Draaiboek Sjabloon',
            clone: 'Klonen',
            clone_template: 'Klonen Sjabloon',
            template_name: 'Sjabloon naam',
            deprecate: 'Afschrijven',
            confirm_deprecate: 'Afschrijven sjabloon "{name}"?',
            create_template: 'Aanmaken Sjabloon',
            update_status: 'Bijwerken Status',
            no_templates: 'Geen draaiboek sjablonen gevonden',
            deactivation_reason_placeholder: 'Reden voor deactivation...',
            description_placeholder: 'Draaiboek beschrijving...',
            name_placeholder: 'Draaiboek naam...',
        },
        sla_definitions: {
            page_title: 'SLA-definities',
            title: 'SLA-definities',
            new: 'Nieuw SLA Definition',
            sla_name: 'SLA Naam',
            target_hours: 'Doel Hours',
            escalation_after: 'Escalatie After',
            applies_to: 'Applies Naar',
            no_definitions: 'Geen SLA definities gevonden.',
            target_value_placeholder: 'Doel value',
            name_placeholder: 'SLA naam...',
            threshold_hours_label: 'Drempeluren',
            severity_label: 'Ernst',
            all_types: 'Alle typen',
            all_severities: 'Alle ernstniveaus',
            default_label: 'Standaard',
        },
        sla_dashboard: {
            compliant: 'Conform',
            page_title: 'SLA-overzicht',
            title: 'SLA-overzicht',
            loading: 'Laden van SLA gegevens...',
            compliance_rate: 'Naleving Tarief',
            breached: 'Geschonden',
            at_risk: 'At Risico',
            on_track: 'Op schema',
            by_severity: 'By Ernst',
            total_records: 'Totaal records',
            met: 'Voldaan',
            sla_records: 'SLA-records',
            sla_reference: 'SLA-referentie',
            record_id: 'Record-ID',
            metric_type: 'Metrietype',
            severity: 'Ernst',
            elapsed: 'Verstreken',
            clock_start: 'Klokstart',
        },
        escalation_log: {
            page_title: 'Escalatielog',
            title: 'Escalatielogboek',
            incident_id: 'Incident-ID',
            escalated_by: 'Geëscaleerd By',
            escalated_to: 'Geëscaleerd Naar',
            reason: 'Reden',
            escalated_at: 'Geëscaleerd At',
            no_escalations: 'Geen escalations gevonden.',
            filter_incident_id: 'Filteren op Incident ID',
            escalation_id: 'Escalatie-ID',
            level: 'Niveau',
            level_range: 'Niveau (L1–L4)',
            create_escalation: 'Escalatie aanmaken',
            incident_id_placeholder: 'bijv. INC-001',
            target_role_placeholder: 'bijv. dpo, incident_manager',
            select_placeholder: '— selecteren —',
        },
        regulator_exports: {
            page_title: 'Toezichthouderexporten',
            title: 'Toezichthouderexports',
            new: 'Nieuw Exporteren',
            incident_id: 'Incident-ID',
            regulator: 'Toezichthouder',
            export_format: 'Formaat',
            exported_at: 'Geëxporteerd At',
            no_exports: 'Geen regulator exports gevonden.',
            enter_incident_id: 'Invoeren Incident ID',
            export_id: 'Export-ID',
            watermark: 'Watermerk',
            submission_status: 'Indieningsstatus',
            all_jurisdictions: 'Alle jurisdicties',
            no_transitions: 'Geen verdere overgangen beschikbaar vanaf',
            select_new_status: '— nieuwe status selecteren —',
            sections_included: 'Opgenomen secties',
            form_classification: 'Classificatie',
            submission_channel: 'Kanaal',
        },
        deadlines: {
            title: 'Melding Deadlines',
            incident_id: 'Incident-ID',
            deadline: 'Uiterste datum',
            regulator: 'Toezichthouder',
            remaining: 'Resterend',
            no_deadlines: 'Geen melding deadlines gevonden.',
        },
        vendor_coordination: {
            page_title: 'Leverancierscoördinatie',
            title: 'Leverancierscoördinatie',
            new: 'Nieuw Coördinatie',
            incident_id: 'Incident-ID',
            vendor_name: 'Leverancier Naam',
            contact: 'Contactpersoon',
            coordination_status: 'Coördinatie Status',
            no_items: 'Geen leverancier coördinatie items gevonden.',
            assessment_placeholder: 'Initieel beoordeling van leverancier...',
            coordination_id: 'Coördinatie-ID',
            communications: 'Communicatie',
            info_requests: 'Infoverzoeken',
            action_requests: 'Actieverzoeken',
            direction: 'Richting',
            channel_label: 'Kanaal',
            no_transitions: 'Geen verdere overgangen beschikbaar.',
            vendor_ref_number: 'Referentienummer',
            report_date: 'Rapportdatum',
            contact_email: 'E-mail',
            contact_phone: 'Telefoon',
            channel_email: 'E-mail',
            channel_meeting: 'Vergadering',
            channel_phone: 'Telefoon',
            channel_portal: 'Portaal',
            incident_id_placeholder: 'Filteren op Incident ID...',
            priority_critical: 'Kritiek',
            priority_high: 'Hoog',
            priority_low: 'Low',
            priority_medium: 'Gemiddeld',
            vendor_id_placeholder: 'Filteren op Leverancier ID...',
            description_placeholder: 'Beschrijving...',
            filter_vendor_id: 'Filteren op Leverancier ID',
            inbound: 'Inkomend',
            outbound: 'Uitgaand',
            summary_placeholder: 'Samenvatting...',
            priority_label: 'Prioriteit',
            due_date_label: 'Vervaldatum',
            info_request_desc: 'Beschrijving van informatieverzoek',
            action_request_desc: 'Beschrijving actieverzoek',
            content_label: 'Inhoud',
            select_incident: 'Selecteer een incident...',
            select_vendor: 'Leverancier selecteren',
            discovery_date: 'Ontdekking Datum',
        },
        metrics: {
            page_title: 'Responsmetrieken',
            title: 'Responsmetingen',
            loading: 'Laden van metrieken gegevens...',
            avg_response_time: 'Avg Reactie Tijd',
            avg_resolution_time: 'Avg Oplossing Tijd',
            total_incidents: 'Totaal Incidenten',
            by_severity: 'By Ernst',
            by_status: 'Per status',
            trend: 'Ontwikkeling',
            start_sla_clock: 'SLA-klok starten',
            sla_records: '[[TOK_0]] Records',
            no_sla_records: 'Nog geen SLA-records.',
            record_id: 'Record-ID',
            severity: 'Ernst',
            progress: 'Voortgang',
            incident_id_required: 'Incident-ID is vereist',
            sla_definition_required: 'SLA-definitie is vereist',
            metric_type_required: 'Metrietype is vereist',
            threshold_required: 'Drempeluren zijn vereist',
            sla_clock_started: 'SLA-klok gestart',
            sla_definition: 'SLA-definitie',
            no_definitions: 'Geen SLA-definities gevonden.',
            select_definition: 'SLA-definitie selecteren...',
            select_metric_type: 'Metrietype selecteren...',
            select_severity: 'Ernstniveau selecteren...',
            threshold_hours: 'Drempel (uren)',
            warning_threshold_pct: 'Waarschuwingsdrempel (%)',
            start_clock: 'Klok starten',
            starting: 'Starten...',
            metric_label: 'Metriek',
            value_label: 'Waarde',
            incident_id: 'Incident-ID',
            threshold_placeholder: 'bijv. 24',
            metric_types: {
                triage_time: 'Triagetijd',
                containment_time: 'Inperkingstijd',
                notification_time: 'Meldingstijd',
                resolution_time: 'Oplossingstijd',
            },
            severities: {
                critical: 'Kritiek',
                high: 'Hoog',
                medium: 'Gemiddeld',
                low: 'Low',
            },
        },
        playbook_links: {
            page_title: 'Playbooklinks',
            title: 'Draaiboek-meldingskoppelingen',
            new_link: 'Draaiboek aan melding koppelen',
            activation_id: 'Activerings-ID',
            notification_id: 'Meldings-ID',
            select_activation: 'Selecteer een activering...',
            select_notification: 'Selecteer een melding...',
            no_links: 'Geen draaiboek-koppelingen gevonden',
            seed_pdpl: 'PDPL-draaiboeken initialiseren',
            created: 'Playbook-koppeling aangemaakt',
            seeded: 'PDPL-playbooks geïnitialiseerd',
            create_failed: 'Aanmaken van playbook-koppeling mislukt',
            seed_failed: 'Initialiseren van PDPL-playbooks mislukt',
        },
        regulatory_sla: {
            page_title: 'Regelgevende SLA-toewijzingen',
            title: 'Regelgevende SLA-toewijzingen',
            new_mapping: 'Nieuwe SLA-toewijzing',
            sla_definition: 'SLA-definitie',
            select_sla_definition: 'Selecteer een SLA-definitie...',
            framework_code: 'Raamwerkcode',
            deadline_type: 'Deadlinetype',
            deadline_hours: 'Deadline in uren',
            auto_escalate: 'Auto-escalatie',
            seed_pdpl: 'PDPL-standaardwaarden initialiseren',
            no_mappings: 'Geen regelgevende SLA-toewijzingen gevonden',
            dashboard: 'Regelgevend SLA-overzicht',
            deadline_types: {
                initial_notification: 'Eerste kennisgeving',
                supplement_response: 'Aanvulling reactie',
                authority_response: 'Autoriteit antwoord',
                remediation_report: 'Saneringsrapport',
            },
            statutory_reference: 'Statutaire referentie',
        },
        coordination_dashboard: {
            page_title: 'Coördinatieoverzicht',
            title: 'Coördinatieoverzicht',
            incident_id: 'Incident-ID',
            select_incident: 'Selecteer een incident...',
            team_role: 'Teamrol',
            members: 'Leden',
            tasks: 'Taken',
            sla_status: 'SLA-status',
            no_teams: 'Geen coördinatieteams gevonden',
            new_team: 'Nieuw coördinatieteam',
            enter_incident_id: 'Voer een incident-ID in om coördinatieteams te bekijken.',
            member_ids_placeholder: 'gebruiker1, gebruiker2',
            edit_team: 'Team bewerken',
            task_count: 'Taaktelling',
            tasks_completed: 'Voltooid',
            team_roles: {
                security: 'Beveiliging',
                legal: 'Juridisch',
                it: 'IT',
                management: 'Beheer',
                department_owner: 'Afdelingseigenaar',
                external: 'Extern',
            },
        },
        evidence_chain: {
            page_title: 'Bewijsketen',
            title: 'Bewijsketen',
            new_entry: 'Nieuwe bewijsinvoer',
            select_incident: 'Selecteer een incident...',
            actor: 'Betrokkene',
            select_actor: 'Selecteer een betrokkene...',
            evidence_id: 'Bewijs-ID',
            action: 'Actie',
            recipient: 'Ontvanger',
            no_entries: 'Geen bewijsketeninvoeren gevonden',
            enter_incident_id: 'Voer een incident-ID in om de bewijsketen te bekijken.',
            evidence_id_placeholder: 'bijv. EVD-2026-0001',
            evidence_id_help: 'Een unieke verwijzing naar het bewijsstuk – een logbestand, een schijfkopie of een schermafbeelding. Er is een suggestie vooraf ingevuld; pas deze aan uw bewijscatalogus aan.',
            select_incident_first: 'Selecteer hierboven een incident voordat u een bewijsvermelding toevoegt.',
            for_incident: 'Voor incident',
            actions: {
                collected: 'Verzameld',
                shared: 'Gedeeld',
                exported: 'Geëxporteerd',
                archived: 'Gearchiveerd',
            },
        },
        post_review: {
            page_title: 'Na-incidentbeoordeling',
            title: 'Post-incident beoordeling',
            new_review: 'Nieuwe beoordeling',
            select_incident: 'Selecteer een incident...',
            lessons_learned: 'Geleerde lessen',
            recommendations: 'Aanbevelingen',
            improvement_actions: 'Verbeteracties',
            submit_for_review: 'Indienen ter beoordeling',
            aria_submit_review: 'Beoordeling {name} indienen ter beoordeling',
            aria_sign_off: 'Beoordeling {name} goedkeuren',
            sign_off: 'Goedkeuring',
            no_reviews: 'Geen post-incident beoordelingen gevonden',
            enter_incident_id: 'Voer een incident-ID in om de na-incidentbeoordeling te bekijken.',
            one_per_line: 'Eén per regel',
            statuses: {
                draft: 'Concept',
                in_review: 'In beoordeling',
                signed_off: 'Goedgekeurd',
                closed: 'Gesloten',
            },
        },
        activations: {
            title: 'Playbook-activeringen',
            activation_id: 'Activerings-ID',
            phases: 'Fasen',
            activated_at: 'Geactiveerd bij',
            activated_by: 'Geactiveerd door',
            deactivate: 'Deactiveren',
            complete: 'Voltooien',
            deactivation_reason: 'Reden van deactivering',
            evidence_button: 'Bewijs',
            evidence_modal_title: 'Activeringsbewijs',
            no_evidence: 'Er is geen bewijs gekoppeld aan deze activering.',
            upload_evidence_label: 'Activeringsbewijs uploaden',
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Leid mij door gaten',
            running: 'Lopende gaten…',
            results_heading: 'Routekaart voor verbetering ([[TOK_2]] kloof[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_gaps: 'Geen hiaten gedetecteerd: alle domeinen op of boven het doel.',
            col_priority: 'Prioriteit',
            col_domain: 'Domein',
            col_levels: 'Huidig → Doel',
            col_severity: 'Ernst',
            col_actions: 'Saneringsacties',
            citations_label: 'Citaties',
            accept_label: 'Accepteer routekaart',
            reject_label: 'Concept afwijzen',
            export_label: 'Exporteer [[TOK_0]]',
            exported_label: 'Routekaart geëxporteerd',
            accept_hint: 'Accepteren legt de routekaart vast op het blijvende concept. Gebruik Export [[TOK_0]] om het resultaat te genereren; de operator plakt improvement_actions terug in de beoordeling.',
            resolve_summary: 'Resolutie: [[TOK_1]]',
            error_generic: 'Kan de gap-walkthrough niet uitvoeren. Probeer het opnieuw of controleer de beoordelingsstatus.',
        },
        policy_gap: {
            run_label: 'Beleidslacunes opsporen',
            running: 'Gaten detecteren…',
            results_heading: 'Beleidslacunes ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_gaps: 'Er zijn geen dekkingslacunes gedetecteerd.',
            col_severity: 'Ernst',
            col_kind: 'Soort',
            col_clause: 'Clausule / vereiste',
            kind_missing: 'Ontbrekende clausule',
            kind_weak: 'Zwakke dekking',
            kind_stale: 'Verouderd (recensie te laat)',
            remediation_label: 'Voorgestelde sanering',
            citations_label: 'Citaties',
            accept_label: 'Accepteer het hiaatrapport',
            reject_label: 'Rapport afwijzen',
            export_label: 'Exporteer [[TOK_0]]',
            accept_hint: 'Accepteren registreert het hiaatrapport over het aanhoudende concept. Gebruik Export [[TOK_0]] om een ​​beleidsauditrapport te genereren; de operator zorgt voor de daadwerkelijke beleidsbewerking.',
            resolve_summary: 'Resolutie: [[TOK_1]]',
            error_generic: 'Kon geen beleidslacunes ontdekken. Probeer het opnieuw of controleer de documentstatus.',
        },
        remediation_plan_generator: {
            run_label: 'Genereer een plan uit hiaten',
            running: 'Plan genereren…',
            results_heading: 'Saneringsplan ([[TOK_2]] fase[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            phase_label: 'Fase [[TOK_1]]',
            window_label: 'Venster',
            owner_label: 'Eigenaar rol',
            evidence_label: 'Bewijssoorten vereist',
            tasks_label: 'Taken',
            no_phases: 'Er zijn geen fasen geproduceerd. De input gap-set is mogelijk leeg.',
            citations_label: 'Citaties',
            accept_label: 'Plan accepteren',
            reject_label: 'Plan afwijzen',
            export_label: 'Exporteer [[TOK_0]]',
            accept_hint: 'Accepteren creëert fasetaken gekoppeld aan het planrecord. Gebruik Export [[TOK_0]] voor het volledige resultaat. Tijdelijke aanduidingen voor de rol van de eigenaar vereisen opvolging door de operator.',
            resolve_summary: 'Oplossing: [[TOK_2]] · [[TOK_3]] taak(en) gemaakt',
            error_generic: 'Kan herstelplan niet genereren. Probeer het opnieuw of controleer de invoer van de gap-set.',
            source_picker_label: 'Bron',
            source_all: 'Allemaal',
            source_consent: 'Analyse van toestemmingskloof',
            source_policy: 'Detectie van beleidslacunes',
            source_vendor: 'Onboarding van leveranciers',
            load_upstream_label: 'Laden van stroomopwaarts',
            loading_upstream: 'Laden…',
            upstream_count: '[[TOK_1]] opening(en) geladen',
        },
        nav: {
            maturity_models: 'Volwassenheidsmodellen',
            maturity_assessments: 'Volwassenheidsbeoordelingen',
            trend_dashboard: 'Trendoverzicht',
            reporting_periods: 'Rapportageperioden',
            executive_summaries: 'Bestuurlijke samenvattingen',
            audit_readiness: 'Controlebereidheid',
            evidence_gaps: 'Bewijslacunes',
            program_health: 'Programmastatus',
            obligation_mappings: 'Verplichtingskoppelingen',
            governance_documents: 'Bestuursdocumenten',
            remediation_plans: 'Herstelplannen',
            governance_model: 'Governancemodel',
            document_drafting: 'Documentontwerp',
            document_issuance: 'Documentuitgifte',
            acknowledgment_tracking: 'Bevestigingsopvolging',
            change_log: 'Wijzigingslogboek',
            review_cadence: 'Beoordelingscadans',
        },
        maturity_models: {
            title: 'Volwassenheidsmodellen',
            new: 'Nieuw Model',
            seed_defaults: 'Initialiseren Standaardwaarden',
            domains: 'Domeinen',
            activate: 'Activeren',
            no_models: 'Geen volwassenheid models gevonden',
            new_maturity_model: 'Nieuw Volwassenheid Model',
            create_model: 'Aanmaken Model',
            load_error: 'Kan volwassenheidsmodellen niet laden. Probeer opnieuw.',
            create_error: 'Kan volwassenheidsmodel niet aanmaken',
            status_error: 'Kan modelstatus niet bijwerken',
            seed_error: 'Kan standaardwaarden niet genereren',
            aria_seed_defaults: 'Genereer standaard volwassenheidsmodellen',
            aria_create_new: 'Nieuw volwassenheidsmodel aanmaken',
            loading_sr: 'Volwassenheidsmodellen laden',
            model_name_placeholder: 'bijv., Privacy-volwassenheidsmodel',
            status_changed: 'Modelstatus gewijzigd naar {status}',
        },
        maturity_assessments: {
            title: 'Volwassenheidsbeoordelingen',
            new: 'Nieuw Beoordeling',
            model: 'Modeltype',
            assessor: 'Beoordelaar',
            overall_score: 'Algeheel Score',
            overall_score_help: 'Een gewogen volwassenheidsbeoordeling van 0–5, die automatisch wordt berekend wanneer een beoordeling wordt afgerond. Verhoog deze door elk domein tijdens de evaluatie hoger te scoren en de beoordeling vervolgens via Indienen ter beoordeling → Afronden te doorlopen.',
            assessed_at: 'Beoordeeld op',
            no_assessments: 'Geen volwassenheid assessments gevonden.',
            load_error: 'Kan volwassenheidsbeoordelingen niet laden. Probeer opnieuw.',
            create_error: 'Kan beoordeling niet aanmaken',
            start_error: 'Kan beoordeling niet starten',
            archive_error: 'Kan beoordeling niet archiveren',
            eval_error: 'Kan beoordeling niet laden voor evaluatie',
            eval_min_score: 'Beoordeel ten minste één domein',
            eval_save_error: 'Kan domeinbeoordelingen niet opslaan',
            review_error: 'Kan niet indienen ter beoordeling',
            finalize_error: 'Kan beoordeling niet afronden',
            start: 'Starten',
            start_confirm_title: 'Beoordeling starten',
            start_confirm_message: 'Weet u zeker dat u deze beoordeling wilt starten?',
            archive_confirm_title: 'Beoordeling archiveren',
            archive_confirm_message: 'Weet u zeker dat u deze beoordeling wilt archiveren?',
            evaluate_domains: 'Evalueren',
            evaluate_domains_title: 'Domeinen evalueren',
            submit_for_review: 'Indienen ter beoordeling',
            finalize: 'Afronden',
            archive: 'Archiveren',
            all_reviewers: 'Alle beoordelaars moeten goedkeuren',
            any_reviewer: 'Elke beoordelaar kan goedkeuren',
            select_level: 'Selecteer volwassenheidsniveau...',
            findings_placeholder: 'Bevindingen, notities, bewijsreferenties...',
            no_domains: 'Geen domeinen gevonden voor dit model.',
        },
        trend_dashboard: {
            title: 'Trendoverzicht',
            loading: 'Laden van trend gegevens...',
            score_trend: 'Scoretrend',
            domain_comparison: 'Domein Vergelijking',
            period: 'Periode',
            load_error: 'Kan trendsamenvatting niet laden. Probeer opnieuw.',
            metrics_load_error: 'Kan trendmetingen niet laden. Probeer opnieuw.',
            module: 'Module',
            metric: 'Metriek',
            value: 'Waarde',
            trend: 'Trend',
            aria_filters: 'Filters voor trendmetingen',
            showing_chart: 'Grafiekweergave',
            showing_table: 'Datatabelweergave',
        },
        reporting_periods: {
            title: 'Rapportageperioden',
            new: 'Nieuw Periode',
            period_name: 'Periode Naam',
            start_date: 'Starten Datum',
            end_date: 'Einde Datum',
            no_periods: 'Geen reporting periodes gevonden.',
            load_error: 'Kan rapportageperiodes niet laden. Probeer opnieuw.',
            create_error: 'Kan rapportageperiode niet aanmaken',
            auto_generate_error: 'Kan rapportageperiodes niet automatisch genereren',
            status_error: 'Kan periodestatus niet bijwerken',
            start_collecting: 'Start verzameling',
            mark_as_draft: 'Markeren als concept',
            submit_for_review: 'Indienen ter beoordeling',
            publish: 'Publiceren',
            auto_generate: 'Rapportageperiodes automatisch genereren',
            period_label_placeholder: 'bijv., K1 2026',
            status_updated: 'Periodestatus bijgewerkt',
        },
        executive_summaries: {
            title: 'Bestuurlijke samenvattingen',
            new: 'Nieuw Samenvatting',
            period: 'Periode',
            generated_at: 'Gegenereerd At',
            generated_by: 'Gegenereerd By',
            no_summaries: 'Geen executive summaries gevonden.',
            generate: 'Genereren',
            load_error: 'Kan directiesamenvattingen niet laden. Probeer opnieuw.',
            generate_error: 'Kan directiesamenvatting niet genereren',
            save_error: 'Kan directiesamenvatting niet opslaan',
        },
        audit_readiness: {
            title: 'Controlebereidheid',
            loading: 'Laden van audit readiness gegevens...',
            overall_readiness: 'Algeheel Readiness',
            by_domain: 'By Domein',
            evidence_coverage: 'Bewijs Dekking',
            gaps: 'Hiaten',
            load_error: 'Kan laatste gereedheid niet laden. Probeer opnieuw.',
            history_error: 'Kan gereedheidshistorie niet laden. Probeer opnieuw.',
            calculate_error: 'Kan auditgereedheid niet berekenen',
            aria_recalculate: 'Herbereken auditgereedheidsscore',
            aria_current_readiness: 'Huidige auditgereedheid',
            aria_history: 'Geschiedenis van gereedheidsscores',
            recalculated: 'Auditgereedheid herberekend',
            loading_sr: 'Auditgereedheidsgegevens laden',
        },
        evidence_gaps: {
            title: 'Bewijslacunes',
            domain: 'Domein',
            control: 'Controle',
            gap_type: 'Hiaat Type',
            severity: 'Ernst',
            no_gaps: 'Geen bewijs hiaten gevonden.',
            load_error: 'Kan bewijslacunes niet laden. Probeer opnieuw.',
            stats_error: 'Kan lacunestatistieken niet laden. Probeer opnieuw.',
            create_error: 'Kan bewijslacune niet aanmaken',
            update_error: 'Kan bewijslacune niet bijwerken',
            status_error: 'Kan status niet bijwerken',
            aria_create_new: 'Nieuwe bewijslacune aanmaken',
            aria_statistics: 'Bewijslacunestatistieken',
            loading_sr: 'Bewijslacunes laden',
            status_updated: 'Lacunestatus bijgewerkt',
            entity_type_placeholder: 'bijv., leverancier, systeem',
            all_modules: 'Alle domeinen',
            all_severities: 'Alle ernstniveaus',
        },
        program_health: {
            title: 'Programmastatus',
            loading: 'Laden van programma gezondheid gegevens...',
            overall_health: 'Algeheel Gezondheid',
            by_module: 'Per module',
            risk_areas: 'Risico Areas',
            recommendations: 'Aanbevelingen',
            load_error: 'Kan programgezondheidsgegevens niet laden. Probeer opnieuw.',
            aria_key_metrics: 'Kerncijfers programgezondheid',
            aria_module_scorecard: 'Moduleresultaatkaart uitsplitsing',
            loading_sr: 'Programgezondheidsgegevens laden',
            trending_up: 'Stijgende trend',
            trending_down: 'Dalende trend',
            trending_stable: 'Stabiel',
            data_loaded: 'Programgezondheidsgegevens geladen',
        },
        obligation_mappings: {
            title: 'Verplichtingskoppelingen',
            create_mapping: 'Verplichtingskoppeling aanmaken',
            framework: 'Raamwerk',
            select_framework: 'Selecteer een kader...',
            obligation: 'Verplichting',
            obligation_ref: 'Verplichtingsreferentie',
            obligation_description: 'Verplichtingsbeschrijving',
            role: 'Rol',
            assigned_role: 'Toegewezen rol',
            assigned_department: 'Toegewezen afdeling',
            select_department: 'Selecteer een afdeling...',
            control_ids: "Controle-ID's",
            raci_assignments: 'RACI-toewijzingen',
            create_raci: 'RACI-toewijzing aanmaken',
            activity: 'Activiteit',
            activity_name: 'Activiteitsnaam',
            activity_description: 'Activiteitsbeschrijving',
            responsible: 'Verantwoordelijk',
            select_users: 'Selecteer gebruikers...',
            accountable: 'Eindverantwoordelijk',
            select_user: 'Selecteer een gebruiker...',
            consulted: 'Geraadpleegd',
            informed: 'Geïnformeerd',
            review_frequency: 'Beoordelingsfrequentie',
            frequency_monthly: 'Maandelijks',
            frequency_quarterly: 'Elk kwartaal',
            frequency_semi_annual: 'Halfjaarlijks',
            frequency_annual: 'Jaarlijks',
            no_mappings_found: 'Geen verplichtingskoppelingen gevonden.',
            no_raci_found: 'Geen RACI-toewijzingen gevonden.',
            mapping_created: 'Verplichtingstoewijzing aangemaakt',
            mapping_updated: 'Verplichtingskoppeling bijgewerkt',
            mapping_deleted: 'Verplichtingskoppeling verwijderd',
            raci_created: 'RACI-toewijzing aangemaakt',
            raci_updated: 'RACI-toewijzing bijgewerkt',
            raci_deleted: 'RACI-toewijzing verwijderd',
            aria_edit_mapping: 'Koppeling {name} bewerken',
            aria_delete_mapping: 'Koppeling {name} verwijderen',
            aria_edit_raci: 'RACI {name} bewerken',
            aria_delete_raci: 'RACI {name} verwijderen',
            confirm_delete_mapping: 'Deze verplichtingskoppeling verwijderen?',
            confirm_delete_raci: 'Deze RACI-toewijzing verwijderen?',
            table_view: 'Tabelweergave',
            matrix_view: 'Matrixweergave',
            print_export: 'Afdrukken / Exporteren',
            filter_framework: 'Filteren op framework',
            no_matrix_data: 'Geen RACI-toewijzingen om weer te geven in matrixweergave.',
            aria_print_export: 'RACI-matrix afdrukken of exporteren',
        },
        governance_documents: {
            title: 'Bestuursdocumenten',
            create_document: 'Bestuursdocument aanmaken',
            document_title: 'Documenttitel',
            document_type: 'Documenttype',
            content_url: 'Inhouds-URL',
            content_url_placeholder: 'https://...',
            framework_codes: 'Kadercodes',
            select_frameworks: 'Selecteer kaders...',
            effective_date: 'Ingangsdatum',
            review_date: 'Beoordelingsdatum',
            status: 'Status',
            version: 'Versie',
            acknowledgments: 'Bevestigingen',
            acknowledge: 'Bevestigen',
            acknowledged_by: 'Bevestigd door',
            department: 'Afdeling',
            no_documents_found: 'Geen bestuursdocumenten gevonden.',
            draft: 'Concept',
            review: 'Beoordeling',
            approved: 'Goedgekeurd',
            issued: 'Uitgegeven',
            superseded: 'Vervangen',
            document_created: 'Document aangemaakt',
            document_acknowledged: 'Document bevestigd',
            policy: 'Beleid',
            procedure: 'Werkwijze',
            standard: 'Standaard',
            guideline: 'Richtlijn',
        },
        governance_model: {
            title: 'Governancemodel',
            create_model: 'Governancemodel',
            edit_model: 'Governancemodel',
            model_name: 'Model',
            description: 'Beschrijving',
            governance_type: 'Type',
            type_centralized: 'Gecentraliseerd',
            type_federated: 'Federaal',
            type_hybrid: 'Hybride',
            framework_codes: 'Framework',
            select_frameworks: '...',
            review_frequency: 'Frequency',
            freq_monthly: 'Maandelijks',
            freq_quarterly: 'Driemaandelijks',
            freq_semi_annual: 'Halfjaarlijks',
            freq_annual: 'Jaarlijks',
            committees: 'Commissies',
            committee_name: 'Name',
            committee_members: 'Members',
            committee_mandate: 'Mandaat',
            add_committee: '+',
            no_committees: '—',
            delegation_rules: 'Delegation',
            from_role: 'From',
            to_role: 'To',
            scope: 'Reikwijdte',
            add_delegation_rule: '+',
            control_owner_summary: 'RACI',
            no_raci_data: '—',
            activity: 'Activiteit',
            responsible: 'R',
            accountable: 'A',
            consulted: 'C',
            informed: 'I',
            no_models_found: '—',
            model_created: 'OK',
            model_updated: 'OK',
            model_deleted: 'OK',
            confirm_delete: '?',
            expand: '+',
            collapse: '-',
            aria_expand: '{name}',
            aria_edit: '{name}',
            aria_delete: '{name}',
            aria_export_csv: '{name} CSV',
            aria_export_json: '{name} JSON',
            framework_read_permission_warning: 'U heeft de toestemming regulatory_framework:read nodig om frameworks te selecteren. Vraag een beheerder om deze toe te staan.',
            select_members: 'Selecteer commissieleden',
            select_from_role: 'Selecteer delegerende rol',
            select_to_role: 'Selecteer ontvangende rol',
            mandate_markdown_hint: 'Ondersteunde prijsverlagingen: **vet**, lijsten, links.',
            scope_tab_obligation: 'Verplichting',
            scope_tab_framework: 'Kader',
            scope_tab_free_text: 'Vrije tekst',
            select_obligation: 'Selecteer een verplichting',
            select_framework: 'Selecteer een raamwerk',
            aria_remove_committee: 'Commissie {n} verwijderen',
            aria_remove_delegation_rule: 'Delegatieregel {n} verwijderen',
            no_frameworks_available: 'Geen kaders beschikbaar. Voeg eerst regelgevingskaders toe.',
        },
        document_drafting: {
            title: 'Documentontwerp',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Status',
            drafter: 'Tekenaar',
            deadline: 'Deadline',
            assign_drafter: 'Assign',
            select_drafter: '...',
            assign: 'Toewijzen',
            submit_for_review: 'Submit',
            legal_review: 'Review',
            reviewer: 'Recensent',
            select_reviewer: '...',
            comments: 'Opmerkingen',
            review_action: 'Action',
            approve: 'Goedkeuren',
            request_changes: 'Wijzigingen aanvragen',
            submit_review: 'Submit',
            executive_approval: 'Approval',
            no_drafts_found: '—',
            drafter_assigned: 'OK',
            status_updated: 'OK',
            review_approved: 'OK',
            changes_requested: 'OK',
            document_approved: 'OK',
            aria_assign: '{name}',
            aria_submit_review: '{name}',
            aria_review: '{name}',
            aria_approve: '{name}',
        },
        document_issuance: {
            title: 'Documentuitgifte',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Status',
            version: 'Versie',
            effective_date: 'Date',
            distribution_scope: 'Distribution',
            distribution_placeholder: '...',
            issuance_number: 'Number',
            issuance_number_placeholder: 'ISS-2026-001',
            supersedes: 'Supersedes',
            none: '—',
            issue_document: 'Issue',
            ready_for_issuance: 'Ready',
            issued_documents: 'Issued',
            no_issued_documents: '—',
            view_lineage: 'Lineage',
            supersession_lineage: 'Supersession',
            document_issued: 'OK',
            document_superseded: 'OK',
            aria_issue: '{name}',
            aria_view_lineage: '{name}',
        },
        acknowledgment_tracking: {
            title: 'Bevestigingsopvolging',
            document_title: 'Documenteren',
            acknowledged_count: 'Erkend',
            pending_count: 'In behandeling',
            percentage: '%',
            details: 'Details',
            send_reminder: 'Remind',
            acknowledgment_details: 'Details',
            user: 'Gebruiker',
            department: 'Afdeling',
            acknowledged_at: 'Date',
            status: 'Status',
            acknowledged: 'OK',
            no_issued_documents: '—',
            no_acknowledgments: '—',
            reminder_sent: 'OK',
            aria_expand: '{name}',
            aria_send_reminder: '{name}',
        },
        change_log: {
            title: 'Wijzigingslogboek',
            date: 'Datum',
            document: 'Documenteren',
            change_type: 'Type',
            actor: 'Acteur',
            summary: 'Samenvatting',
            export_csv: 'Exporteer [[TOK_0]]',
            filters: 'Filters',
            filter_document: 'Document',
            all_documents: 'All',
            filter_change_type: 'Type',
            all_types: 'All',
            date_from: 'From',
            date_to: 'To',
            version_history: 'History',
            version_archive: 'Archive',
            no_entries: '—',
            no_history: '—',
            exported: 'OK',
            aria_export: 'CSV',
            aria_view_history: '{name}',
        },
        review_cadence: {
            title: 'Beoordelingscadans',
            configure_cadence: 'Beoordelingscadans',
            edit_cadence: 'Beoordelingscadans',
            document: 'Documenteren',
            select_document: '...',
            review_frequency: 'Frequency',
            freq_30: '30',
            freq_60: '60',
            freq_90: '90',
            freq_180: '180',
            freq_365: '365',
            last_reviewed: 'Last',
            next_review: 'Next',
            status: 'Status',
            overdue: 'Te laat',
            on_track: 'OK',
            days: 'days',
            horizon: 'Horizon',
            overdue_warning: 'Overdue',
            overdue_count: '{count}',
            no_cadences: '—',
            cadence_created: 'OK',
            cadence_updated: 'OK',
            aria_edit: '{name}',
        },
        remediation_plans: {
            title: 'Herstelplannen',
            create_plan: 'Herstelplan aanmaken',
            gap_id: 'Lacunereferentie',
            select_gap: 'Selecteer een lacune...',
            plan_title: 'Titel',
            description: 'Beschrijving',
            priority: 'Prioriteit',
            priority_critical: 'Kritiek',
            priority_high: 'Hoog',
            priority_medium: 'Gemiddeld',
            priority_low: 'Laag',
            assigned_to: 'Toegewezen aan',
            select_user: 'Selecteer een gebruiker...',
            target_date: 'Streefdatum',
            framework_code: 'Raamwerk',
            select_framework: 'Selecteer een kader...',
            gap_finding: 'Lacunevaststelling',
            action_items: 'Actiepunten',
            owner: 'Eigenaar',
            deadline: 'Deadline',
            planned: 'Gepland',
            in_progress: 'Bezig',
            completed: 'Voltooid',
            verified: 'Geverifieerd',
            no_plans_found: 'Geen herstelplannen gevonden.',
            evidence: 'Bewijs',
            plan_created: 'Herstelplan aangemaakt',
            action_items_hint: 'Actiepunten (één per regel)',
        },
        statuses: {
            identified: 'Geïdentificeerd',
            assigned: 'Toegewezen',
            in_remediation: 'Bij sanering',
            resolved: 'Opgelost',
            accepted_risk: 'Geaccepteerd risico',
            planned: 'Gepland',
            in_progress: 'In uitvoering',
            under_review: 'Onder beoordeling',
            finalized: 'Afgerond',
            archived: 'Gearchiveerd',
            draft: 'Diepgang',
            active: 'Actief',
            upcoming: 'Aankomend',
            collecting: 'Verzamelen',
            published: 'Gepubliceerd',
            review: 'Beoordeling',
            approved: 'Goedgekeurd',
            issued: 'Uitgegeven',
            superseded: 'Vervangen',
            completed: 'Voltooid',
            verified: 'Geverifieerd',
        },
        severities: {
            critical: 'Kritisch',
            high: 'Hoog',
            medium: 'Middelmatig',
            low: 'Low',
        },
        priorities: {
            critical: 'Kritisch',
            high: 'Hoog',
            medium: 'Middelmatig',
            low: 'Low',
        },
        gap_types: {
            missing: 'Ontbreekt',
            expired: 'Verlopen',
            insufficient: 'Onvoldoende',
        },
        document_types: {
            policy: 'Beleid',
            procedure: 'Werkwijze',
            standard: 'Standaard',
            guideline: 'Richtlijn',
            template: 'Sjabloon (intern)',
        },
        maturity_levels: {
            level_1: 'Niveau 1 — Initieel',
            level_2: 'Niveau 2 — Ontwikkelen',
            level_3: 'Niveau 3 — Gedefinieerd',
            level_4: 'Niveau 4 — Beheerd',
            level_5: 'Niveau 5 — Optimaliseren',
        },
        grades: {
            excellent: 'Uitstekend',
            good: 'Goed',
            fair: 'Eerlijk',
            poor: 'Arm',
            critical: 'Kritisch',
            needs_improvement: 'Verbetering nodig',
            not_assessed: 'Niet beoordeeld',
        },
        modules: {
            data_mapping: 'Gegevens in kaart brengen',
            consent: 'Toestemming',
            governance: 'Bestuur',
            incidents: 'Incidenten',
            monitoring: 'Toezicht',
            classification: 'Classificatie',
            vendor_risk: 'Leveranciersrisico',
            discovery: 'Ontdekking',
            deletion: 'Verwijdering',
        },
        cadences: {
            monthly: 'Maandelijks',
            quarterly: 'Driemaandelijks',
            semi_annual: 'Halfjaarlijks',
            annual: 'Jaarlijks',
        },
        section_labels: {
            opening: 'Openen',
            key_metrics: 'Belangrijke statistieken',
            highlights: 'Hoogtepunten',
            concerns: 'Zorgen',
            recommendations: 'Aanbevelingen',
            outlook: 'Vooruitzichten',
        },
        out_of_100: '/ 100',
        count_gaps: '[[TOK_1]] kloof',
        count_gaps_plural: '[[TOK_1]] hiaten',
        count_summaries: '[[TOK_1]] samenvatting',
        count_summaries_plural: '[[TOK_1]] samenvattingen',
        count_assessments: '[[TOK_1]] beoordeling',
        count_assessments_plural: '[[TOK_1]] beoordelingen',
        count_models: '[[TOK_1]]-model',
        count_models_plural: '[[TOK_1]] modellen',
        count_periods: '[[TOK_1]] periode',
        count_periods_plural: '[[TOK_1]] perioden',
        count_metrics: '[[TOK_1]] statistiek',
        count_metrics_plural: '[[TOK_1]] statistieken',
        unknown_user: 'Onbekende gebruiker',
        unknown_gap: 'Onbekende kloof',
        no_permission_title: 'Onvoldoende machtigingen',
        no_permission_message: 'U heeft geen toestemming om deze pagina te bezoeken.',
        ac_vn_frameworks_title: 'VN-frameworkdekking',
        ac_vn_frameworks_body: 'Maturiteitsbeoordelingen hebben betrekking op alle zes de Vietnamese regelgevingskaders: [[TOK_0]], datarecht, telecomrecht, cyberveiligheidsrecht, [[TOK_1]] recht en e-commercerecht – elk met raamwerkspecifieke beoordelingscriteria.',
        ac_controller_processor_title: 'Verwerkingsverantwoordelijke versus verwerker',
        ac_controller_processor_body: 'Bij verplichtingstoewijzingen wordt onderscheid gemaakt tussen de verantwoordelijkheden van de gegevensbeheerder en de gegevensverwerker. Wijs rollen toe met behulp van de RACI-matrix om ervoor te zorgen dat elke verplichting een duidelijke eigenaar heeft, ongeacht of de organisatie optreedt als verwerkingsverantwoordelijke of als verwerker.',
        ac_versioned_evidence_title: 'Versieversie van bewijspad',
        ac_versioned_evidence_body: 'Elke statusovergang (concept, beoordeling, goedgekeurd, afgegeven) creëert een record met tijdstempel en versiebeheer dat als controleerbaar bewijsmateriaal dient. Het wijzigingslogboek legt de volledige geschiedenis van de levenscyclus van het document vast.',
        ac_remediation_gap_link_title: 'Gekoppeld aan beoordelingslacunes',
        ac_remediation_gap_link_body: 'Elk saneringsplan is rechtstreeks gekoppeld aan een geïdentificeerde beoordelingskloof. Wijs een eigenaar aan en stel een streefdeadline in om de voortgang van de oplossing van het hiaat tot het sluiten te volgen.',
        ac_annual_attestation_title: 'Jaarlijkse attestatiecyclus',
        ac_annual_attestation_body: "Rapportageperioden komen overeen met de jaarlijkse attestvereiste van de Vietnamese gegevenswet. Gebruik de cadans 'Jaarlijks' (cyclus van 365 dagen) om automatisch op attesten afgestemde perioden te genereren.",
        ac_evidence_per_obligation_title: 'Bewijs per kaderverplichting',
        ac_evidence_per_obligation_body: 'Bewijslacunes identificeren ontbrekend, verlopen of onvoldoende bewijs voor elke kaderverplichting. Filter op domein om te zien welke wettelijke vereisten geen ondersteunend bewijsmateriaal bevatten.',
        ac_cross_framework_title: 'Cross-framework volledigheid',
        ac_cross_framework_body: 'Auditgereedheid biedt een compleetheidsoverzicht dat meerdere kaders omvat. Componentscores weerspiegelen de dekking binnen alle in kaart gebrachte raamwerken, waarbij gebieden worden benadrukt die aandacht behoeven vóór een audit.',
        ac_cadence_default_title: 'Standaard beoordelingscadans',
        ac_cadence_default_body: 'De standaard beoordelingsfrequentie is 180 dagen. Achterstallige beoordelingen worden automatisch gemarkeerd. Pas indien nodig de frequentie per document aan – de opties variëren van 30 tot 365 dagen.',
        ac_templates_internal_title: 'Sjabloonclassificatie',
        ac_templates_internal_body: "Sjablonen worden geclassificeerd als interne documenten. Gebruik het documenttype 'Sjabloon' om herbruikbare governance-artefacten te markeren met een uitsluitend intern distributiebereik.",
    },
    mcp_pending: {
        title: 'MCP — Wachtende schrijfopdrachten',
        subtitle: 'Externe Claude-clients stellen hier schrijfopdrachten voor. Keur elke vermelding goed of af — Forseti voert pas uit na goedkeuring door een beheerder.',
        no_pending: 'Geen wachtende schrijfopdrachten.',
        col_tool: 'Gereedschap',
        col_preview: 'Voorbeeld',
        col_key: '[[TOK_0]]-toets',
        col_requested: 'Aangevraagd',
        col_expires: 'Verloopt',
        col_status: 'Status',
        status_pending: 'In afwachting',
        status_approved: 'Goedgekeurd',
        status_declined: 'Afgewezen',
        status_expired: 'Verlopen',
        status_executed: 'Uitgevoerd',
        approve_label: 'Goedkeuren',
        decline_label: 'Afwijzen',
        refresh_label: 'Vernieuwen',
        error_generic: 'Wachtende schrijfopdrachten konden niet worden geladen.',
        confirm_approve: 'Bij goedkeuring wordt de tool uitgevoerd op uw organisatie met de rechten van de houder van de API key. Doorgaan?',
        confirm_decline: 'Deze wachtende schrijfopdracht afwijzen? Dit kan niet ongedaan worden gemaakt.',
        advisory_banner: 'Wachtende schrijfopdrachten verlopen 24 uur na aanmaak. De uurlijkse GC-sweep wijst verlopen vermeldingen automatisch af.',
    },
    audit_walkthrough: {
        title: 'Forseti — Generator voor auditrondgang',
        subtitle: 'Genereer een gestructureerde rondgang voor een auditkickoff: openingsvraag per beheersmaatregel, verwacht bewijs, vervolgvragen, mogelijke hiaten.',
        audit_picker_label: 'Controle',
        audit_picker_hint: 'Kies een geplande audit om een rondgang te genereren.',
        run_label: 'Rondgang genereren',
        running: 'Bezig met genereren…',
        results_heading: 'Rondgang — {count} beheersmaatregel(en)',
        tokens_label: '≈ [[TOK_1]] tokens',
        no_controls: 'Geen beheersmaatregelen binnen scope. Voeg beheersmaatregelen toe aan de auditregistratie.',
        col_control: 'Beheersmaatregel',
        col_question: 'Openingsvraag',
        col_evidence: 'Bewijs',
        col_gaps: 'Mogelijke hiaten',
        expected_evidence_label: 'Verwacht bewijs',
        followup_probes_label: 'Vervolgvragen',
        accept_label: 'Rondgang aanvaarden',
        reject_label: 'Afwijzen',
        export_label: 'Exporteren als DOCX',
        resolve_summary: 'Resolutie: {status}',
        error_generic: 'De rondgang kon niet worden gegenereerd. Probeer opnieuw of controleer de auditstatus.',
    },
    privilege_creep: {
        title: 'Forseti — Detectie van rechtenophoping',
        subtitle: 'Periodieke scan van rolverdelingen. Bevindingen zijn adviserend — Forseti trekt nooit automatisch rechten in.',
        run_label: 'Nu scannen',
        running: 'Bezig met scannen…',
        findings_heading: '{count} bevinding(en)',
        no_findings: 'Geen rechtenophoping gemarkeerd.',
        col_user: 'Gebruiker',
        col_job_function: 'Functie',
        col_severity: 'Ernst',
        col_unexpected: 'Onverwachte rechten',
        col_remediation: 'Voorgestelde remediatie',
        col_status: 'Status',
        severity_critical: 'Kritiek',
        severity_high: 'Hoog',
        severity_medium: 'Gemiddeld',
        severity_low: 'Laag',
        status_open: 'Openen',
        status_dismissed: 'Genegeerd',
        status_remediated: 'Verholpen',
        dismiss_label: 'Negeren',
        remediate_label: 'Markeren als verholpen',
        note_label: 'Notitie (optioneel)',
        error_generic: 'Kon rechtenophoping niet scannen. Probeer het later opnieuw.',
        advisory_banner: 'Deze bevindingen zijn adviserend. Forseti trekt nooit automatisch rechten in — overleg met de roleigenaar voordat u handelt.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Automatische toewijzing van nalevingsregels',
            subtitle: 'Forseti voert een geïnstalleerd regelgevingspakket uit en stelt nieuwe of vernieuwde nalevingsregels voor, gebaseerd op de bronartikelen.',
            pack_picker_label: 'Regelgevend pakket',
            pack_picker_hint: 'Selecteer een geïnstalleerd pakket om in kaart te brengen.',
            run_label: 'Kaart uit verpakking',
            running: 'In kaart brengen…',
            results_heading: '[[TOK_1]] suggestie(s)',
            tokens_label: '≈ [[TOK_1]] tokens uit uw maandelijkse bucket',
            no_suggestions: 'Geen suggesties: pakketinhoud valt mogelijk al volledig onder de bestaande regels.',
            kind_new: 'Nieuwe regel',
            kind_refresh: 'Bestaande vernieuwen',
            kind_no_change: 'Geen verandering vereist',
            col_kind: 'Soort',
            col_title: 'Voorgestelde titel',
            col_existing: 'Bestaande regel',
            col_source: 'Bron',
            proposed_body_label: 'Voorgesteld lichaam',
            source_quote_label: 'Bron citaat',
            accept_selected: 'Accepteer geselecteerd',
            reject_all: 'Alles afwijzen',
            accept_all: 'Accepteer alles',
            resolve_summary: 'Oplossing: [[TOK_2]] · [[TOK_3]] regel(s) gemaakt',
            error_generic: 'Kan regeltoewijzing niet uitvoeren. Probeer het opnieuw of controleer de pakketcode.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Sessieoverzicht',
            access_log: 'Toegangslogboek',
            justification_review: 'Motivatiebeoordeling',
            investigations: 'Onderzoeken',
            pattern_analysis: 'Patroonanalyse',
            anchoring_status: 'Verankeringsstatus',
            configuration: 'Configuratie',
            access_policies: 'Toegangsbeleid',
            review_campaigns: 'Beoordelingscampagnes',
            evidence_packages: 'Bewijspakketten',
        },
        session_dashboard: {
            title: 'Sessieoverzicht',
            loading: 'Laden van dashboard gegevens...',
            total_sessions: 'Totaal Sessies',
            active_sessions: 'Actief Sessies',
            avg_duration: 'Avg Duur',
            concurrent_peak: 'Gelijktijdig Peak',
            auth_method_breakdown: 'Auth Methode Breakdown',
            geo_country_breakdown: 'Geo Land Breakdown',
            recent_session_events: 'Recent Sessie Gebeurtenissen',
            user_id: 'Gebruiker ID',
            session_id: 'Sessie ID',
            ip_address: 'IP Adres',
            auth_method: 'Auth Methode',
            started_at: 'Gestart At',
            event_type: 'Gebeurtenis Type',
            all_event_types: 'Alle Gebeurtenis Types',
            filter_by_user: 'Filteren op Gebruiker ID...',
            no_active_sessions: 'No actief sessies',
            no_session_events: 'Geen sessie gebeurtenissen gevonden',
            revoke: 'Intrekken',
            revoke_session: 'Intrekken Sessie',
            revoke_reason: 'Reden',
            revoke_placeholder: 'Opgeven een reason voor revoking dit sessie...',
            session_label: 'Sessie:',
            load_failed: 'Kan niet load sessie dashboard. Probeer het opnieuw.',
            events_load_failed: 'Kan niet load sessie gebeurtenissen. Probeer het opnieuw.',
            revoke_failed: 'Kan niet revoke sessie',
            session_events_loaded: '{n} session events geladen',
            event_types: {
                session_created: 'Sessie gemaakt',
                session_refreshed: 'Sessie vernieuwd',
                session_expired: 'Sessie verlopen',
                session_revoked: 'Sessie ingetrokken',
                session_terminated: 'Sessie beëindigd',
                login_success: 'Inloggen succesvol',
                login_failure: 'Inloggen mislukt',
                logout: 'Uitloggen',
                token_refresh: 'Token vernieuwen',
                mfa_challenge: 'MFA-uitdaging',
            },
        },
        access_log: {
            title: 'Toegangslogboek',
            user_id: 'Gebruiker ID',
            resource: 'Bron',
            action: 'Actie',
            ip_address: 'IP Adres',
            timestamp: 'Tijdstempel',
            no_logs: 'Geen toegang logboek items gevonden.',
            filter_by_user: 'Filteren op Gebruiker ID...',
            load_failed: 'Kan niet load toegang logboek. Probeer het opnieuw.',
            export_success: 'Exporteren initiated successfully',
            export_failed: 'Kan niet export toegang logboek',
            record_count: 'vermelding',
            record_count_plural: 'vermeldingen',
            unclassified: 'Niet geclassificeerd',
            classification_missing: 'Classificatie ontbreekt',
            response_code: 'Responscode',
            classification_levels: {
                public: 'Openbaar',
                internal: 'Intern',
                confidential: 'Vertrouwelijk',
                restricted: 'Beperkt',
                unclassified: 'Niet geclassificeerd',
            },
        },
        justification_review: {
            title: 'Motivatiebeoordeling',
            user_id: 'Gebruiker ID',
            resource: 'Bron',
            justification: 'Rechtvaardiging',
            submitted_at: 'Ingediend At',
            reviewer: 'Beoordelaar',
            no_reviews: 'Geen rechtvaardiging beoordelingen gevonden.',
            load_failed: 'Kan niet load rechtvaardigingen. Probeer het opnieuw.',
            review_failed: 'Kan niet beoordeling rechtvaardiging',
            decline_failed: 'Kan niet decline toegang',
            justification_count: 'rechtvaardiging',
            justification_count_plural: 'rechtvaardigingen',
            reviewed: 'Beoordeeld',
            concerning: 'Zorgwekkend',
            escalated: 'Geëscaleerd',
            link_investigation_placeholder: 'Koppelen naar een onderzoek (optional)',
            review_queue: 'Beoordelen Wachtrij',
            access_id_label: 'Toegangs-ID',
            access_id_placeholder: 'Toegangslogboek-invoer-ID',
            select_user_placeholder: 'Selecteer gebruiker (optioneel)',
            resource_type_label: 'Brontype',
            resource_type_placeholder: 'bijv. document, database',
            resource_id_label: 'Bron-ID',
            resource_id_placeholder: 'Bronidentifier',
            reason_placeholder: 'Reden voor toegang tot deze bron...',
            create_failed: 'create justification mislukt',
            unclassified: 'Niet geclassificeerd',
            review_statuses: {
                pending: 'In behandeling',
                reviewed: 'Beoordeeld',
                concerning: 'Wat betreft',
                escalated: 'Geëscaleerd',
            },
            reason_codes: {
                business_need: 'Zakelijke behoefte',
                legal_obligation: 'Wettelijke verplichting',
                data_subject_request: 'Verzoek van betrokkene',
                audit_requirement: 'Auditvereiste',
                incident_response: 'Reactie op incidenten',
                research: 'Onderzoek',
                administrative: 'Administratief',
                other: 'Anders',
            },
        },
        investigations: {
            title: 'Onderzoek Workspace',
            new: 'Nieuw Onderzoek',
            subject: 'Onderwerp',
            investigator: 'Onderzoeker',
            opened_at: 'Geopend At',
            findings: 'Bevindingen',
            no_investigations: 'Geen onderzoeken gevonden.',
            load_failed: 'Kan niet load onderzoeken. Probeer het opnieuw.',
            create_failed: 'Kan niet create onderzoek',
            timeline_add_failed: 'Kan niet add tijdlijn item',
            link_access_failed: "Kan niet link toegang ID's",
            link_justification_failed: "Kan niet link rechtvaardiging ID's",
            close_failed: 'Kan niet close onderzoek',
            export_success: 'Exporteren initiated successfully',
            export_failed: 'Kan niet export onderzoek',
            refresh_failed: 'Kan niet refresh onderzoek detail. Probeer het opnieuw.',
            update_failed: 'Bijwerken van onderzoek mislukt',
            investigation_count: 'onderzoek',
            investigation_count_plural: 'onderzoeken',
            title_placeholder: 'Onderzoek title',
            description_placeholder: 'Detailed beschrijving van de onderzoek...',
            assignee_placeholder: 'Gebruiker ID van assignee (optional)',
            timeline_action_placeholder: 'e.g., Beoordeeld toegang logs',
            timeline_note_placeholder: 'Optioneel note',
            access_ids_placeholder: 'toegang-id-1, toegang-id-2',
            justification_ids_placeholder: 'rechtvaardiging-id-1, rechtvaardiging-id-2',
            findings_placeholder: 'Samenvatten de onderzoek bevindingen...',
            by_actor: 'by',
            close_investigation: 'Sluiten Onderzoek',
            add_timeline_failed: 'Kan niet add tijdlijn item..',
            fetch_failed: 'Kan niet fetch onderzoeken..',
            change_status: 'Onderzoeksstatus wijzigen',
            details: 'Onderzoeksdetails',
            link_evidence: 'Bewijs koppelen',
            link_justifications: 'Rechtvaardigingen koppelen',
            access_ids_label: 'Toegangs-IDs',
            justification_ids_label: 'Rechtvaardigings-IDs',
            access_ids_link_placeholder: 'toegang-id-1, toegang-id-2',
            justification_ids_link_placeholder: 'rechtvaardiging-id-1, rechtvaardiging-id-2',
            investigations_loaded: '{n} investigations geladen',
            status_changed_to: 'Status gewijzigd naar {status}',
            add_timeline_entry: 'Tijdlijn-invoer toevoegen',
            add_access_ids: 'Toegangs-IDs toevoegen',
            add_justification_ids: 'Rechtvaardigings-IDs toevoegen',
            investigation_types: {
                anomaly_review: 'Anomalie beoordeling',
                complaint_driven: 'Klacht gedreven',
                scheduled_review: 'Geplande beoordeling',
                whistleblower_report: 'Klokkenluidersrapport',
            },
            severity_labels: {
                low: 'Laag',
                medium: 'Middelmatig',
                high: 'Hoog',
                critical: 'Kritisch',
            },
            status_labels: {
                open: 'Openen',
                in_progress: 'In uitvoering',
                pending_review: 'In afwachting van beoordeling',
                closed_substantiated: 'Gesloten (onderbouwd)',
                closed_unsubstantiated: 'Gesloten (niet onderbouwd)',
                closed_inconclusive: 'Gesloten (niet doorslaggevend)',
            },
            disposition_labels: {
                substantiated: 'Onderbouwd',
                unsubstantiated: 'Niet onderbouwd',
                inconclusive: 'Niet doorslaggevend',
            },
        },
        pattern_analysis: {
            title: 'Patroonanalyse',
            loading: 'Laden van patroon gegevens...',
            anomalies_detected: 'Anomalieën Gedetecteerd',
            patterns: 'Patronen',
            by_user: 'By Gebruiker',
            by_resource: 'By Bron',
            time_range: 'Tijd Range',
            load_failed: 'Kan niet analyze patterns. Probeer het opnieuw.',
            top_resources: 'Top-10',
            access_by_hour: 'Toegang op Hour van Dag',
            access_by_day: 'Toegang op Dag van Week',
            fetch_failed: 'Kan niet fetch patroon analysis..',
            analysis_loaded: 'Patroonanalyse geladen voor {user}, {n} sessies gevonden',
            date_format_placeholder: 'DD/MM/JJJJ',
            access_by_hour_heading: 'Toegang per uur',
            access_by_day_heading: 'Toegang per weekdag',
            by_classification: 'Per classificatieniveau',
            top_accessed_resources: 'Meest bezochte bronnen',
            user_access_summary: 'Gebruikerstoegangsoverzicht',
            days: {
                sunday: 'Zondag',
                monday: 'Maandag',
                tuesday: 'Dinsdag',
                wednesday: 'Woensdag',
                thursday: 'Donderdag',
                friday: 'Vrijdag',
                saturday: 'Zaterdag',
            },
            linked_access_logs: 'Gekoppelde toegangslogboeken',
            linked_access_logs_desc: 'Toegang tot logboekvermeldingen die zijn gekoppeld aan de gedetecteerde patronen voor deze gebruiker.',
        },
        anchoring_status: {
            title: 'Verankeringsstatus',
            loading: 'Laden van anchoring gegevens...',
            anchored: 'Verankerd',
            pending: 'In afwachting',
            failed: 'Mislukt',
            last_anchor: 'Laatste Anker',
            no_records: 'Geen anchoring records gevonden.',
            status_load_failed: 'Kan niet load anchoring status. Probeer het opnieuw.',
            proofs_load_failed: 'Kan niet load toegang bewijzen. Probeer het opnieuw.',
            verify_failed: 'Kan niet verify bewijs keten. Probeer het opnieuw.',
            anchor_failed: 'Kan niet anker toegang bewijs',
            batch_anchor_failed: 'Kan niet batch anker toegang bewijzen',
            proof_count: 'bewijs',
            proof_count_plural: 'bewijzen',
            anchor_single: 'Anker Single',
            anchor_batch: 'Anker Batch',
            access_id_placeholder: 'Invoeren toegang ID naar anker',
            batch_ids_placeholder: 'toegang-id-1, toegang-id-2, toegang-id-3',
            verify_chain: 'Verifiëren Keten',
            chain_breaks: 'Keten Breaks',
            total_checked: 'Totaal Checked',
            anchor_placeholder: 'Invoeren toegang ID naar anker',
            fetch_failed: 'Kan niet fetch anchoring status..',
            fetch_proofs_failed: 'Kan niet fetch bewijzen..',
            access_id: 'Toegangs-ID',
            chain_sequence: 'Ketenreeks',
            proof_hash_label: 'Bewijs-hash',
            batch_id: 'Batch-ID',
            proofs_loaded: '{n} access proofs geladen',
            anchor_statuses: {
                pending: 'In behandeling',
                submitted: 'Ingezonden',
                confirmed: 'Bevestigd',
                failed: 'Mislukt',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Ketting',
                blockchain_anchor: 'Blockchain-anker',
                zkp_stub: 'ZKP-stomp',
            },
        },
        configuration: {
            title: 'Configuratie',
            session_settings: 'Sessie Instellingen',
            log_retention: 'Logboek Bewaring (days)',
            anomaly_threshold: 'Anomalie Drempelwaarde',
            anchoring_enabled: 'Verankering Ingeschakeld',
            save_config: 'Opslaan Configuratie',
            load_failed: 'Kan niet load configuratie. Probeer het opnieuw.',
            save_success: 'Configuratie saved successfully',
            save_failed: 'Kan niet save configuratie. Probeer het opnieuw.',
            justification_rules: 'Rechtvaardiging Regels',
            reason_codes: 'Reden Codes',
            anchoring_settings: 'Verankering Instellingen',
            anchoring_method: 'Verankering Methode',
            anchoring_frequency: 'Verankering Frequentie',
            batch_interval: 'Batch-interval (minuten)',
            eligibility_criteria: 'Geschiktheid Criteria',
            add_criterion_placeholder: 'Toevoegen eligibility criterion...',
            retention_settings: 'Bewaring Instellingen',
            standard_retention: 'Standaard Bewaring (days)',
            sensitive_retention: 'Gevoelig Bewaring (days)',
            working_hours: 'Werk Hours',
            work_start: 'Starten Tijd',
            work_end: 'Einde Tijd',
            timezone: 'Tijdzone',
            timezone_placeholder: 'bijv. Asia/Ho_Chi_Minh',
            working_days: 'Werk Dagen',
            concurrent_sessions: 'Gelijktijdig Sessie Limits',
            concurrent_threshold: 'Gelijktijdig Sessie Drempelwaarde',
            classification_level: 'Classificatie Niveau',
            prompt_mode: 'Prompt Modus',
            grace_period: 'Respijt Periode (s)',
            code_placeholder: 'codering',
            is_custom: 'Aangepast',
            label_placeholder: 'Kenmerk',
            description_placeholder: 'Beschrijving',
            custom: 'Aangepast',
            fetch_failed: 'Kan niet fetch configuratie..',
            classification_levels: {
                public: 'Openbaar',
                internal: 'Intern',
                confidential: 'Vertrouwelijk',
                restricted: 'Beperkt',
                unclassified: 'Niet geclassificeerd',
            },
            prompt_modes: {
                reason_only: 'Alleen reden',
                reason_text: 'Reden + Tekst',
                reason_text_supervisor: 'Reden + Tekst + Begeleider',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Ketting',
                blockchain_anchor: 'Blockchain-anker',
                zkp_stub: 'ZKP-stomp',
            },
            anchoring_frequencies: {
                realtime: 'Realtime',
                batched: 'In batches',
                on_demand: 'Op aanvraag',
            },
        },
        access_policies: {
            title: 'Toegangsbeleid',
            create_policy: 'Toegangsbeleid aanmaken',
            policy_name: 'Beleidsnaam',
            framework_code: 'Raamwerk',
            select_framework: 'Selecteer een raamwerk...',
            review_frequency: 'Beoordelingsfrequentie',
            scope: 'Bereik',
            no_policies_found: 'Geen toegangsbeleid gevonden.',
            policy_created: 'Toegangsbeleid aangemaakt',
            frequency_labels: {
                monthly: 'Maandelijks',
                quarterly: 'Kwartaal',
                semi_annual: 'Halfjaarlijks',
                annual: 'Jaarlijks',
            },
        },
        review_campaigns: {
            title: 'Toegangsbeoordelingscampagnes',
            create_campaign: 'Beoordelingscampagne aanmaken',
            reviewer: 'Beoordelaar',
            due_date: 'Vervaldatum',
            certify: 'Certificeren',
            no_campaigns_found: 'Geen toegangsbeoordelingscampagnes gevonden.',
            status_open: 'Openen',
            status_in_review: 'In beoordeling',
            status_completed: 'Voltooid',
            campaign_created: 'Beoordelingscampagne aangemaakt',
            review_certified: 'Toegangsbeoordeling gecertificeerd',
            certify_campaign: 'Campagne {id} certificeren',
            policy_id: 'Beleids-ID',
            select_policy: 'Selecteer een beleid...',
            reviewer_ids_label: 'Beoordelaars',
            select_reviewers: 'Selecteer beoordelaars...',
            status_labels: {
                open: 'Openen',
                in_review: 'In beoordeling',
                completed: 'Voltooid',
            },
            evidence_package_id: 'Bewijspakket-ID',
        },
        evidence_packages: {
            title: 'Bewijspakketten',
            generate_package: 'Bewijspakket genereren',
            export_type: 'Exporttype',
            package_type: 'Pakkettype',
            framework_scope: 'Raamwerkbereik',
            period: 'Periode',
            generated_by: 'Gegenereerd door',
            generated_at: 'Gegenereerd op',
            no_packages_found: 'Geen bewijspakketten gevonden.',
            package_generated: 'Bewijspakket gegenereerd',
            export_type_full: 'Volledige export',
            export_type_summary: 'Samenvatting',
            export_type_certification_only: 'Alleen certificering',
            package_type_access_review: 'Toegangsbeoordeling',
            package_type_investigation: 'Onderzoek',
            package_type_certification: 'Certificering',
            package_type_authority_request: 'Autoriteitsverzoek',
            period_start: 'Begin periode',
            period_end: 'Einde periode',
            select_frameworks: 'Selecteer kaders...',
            completeness_col: 'Volledigheid',
            status_col: 'Status',
            generated_by_col: 'Gegenereerd door',
        },
        evidence_package_detail: {
            title: 'Bewijspakketdetails',
            not_found: 'Bewijspakket niet gevonden.',
            package_metadata: 'Pakketmetadata',
            status: 'Status',
            item_count: 'Aantal items',
            disposition: 'Dispositie',
            closed_at: 'Gesloten op',
            completeness_dashboard: 'Volledigheidsoverzicht',
            no_completeness_data: 'Geen volledigheidsgegevens beschikbaar.',
            controls_covered: 'controles gedekt',
            missing: 'Ontbrekend',
            sign_off_tracker: 'Goedkeuringstracker',
            stage_framework_owner: 'Kadereigenaar',
            stage_legal_compliance: 'Juridisch en Compliance',
            stage_internal_audit: 'Interne audit',
            approved: 'Goedgekeurd',
            returned: 'Geretourneerd',
            pending: 'In afwachting',
            approve: 'Goedkeuren',
            return_btn: 'Retourneren',
            sign_off_submitted: 'Goedkeuring ingediend',
            artifacts: 'Artefacten',
            no_artifacts: 'Geen artefacten gevonden.',
            template_id: 'Sjabloon-ID',
            description: 'Beschrijving',
            classification: 'Classificatie',
            evidence_type: 'Bewijstype',
            framework_section: 'Kadersectie',
            history: 'Goedkeuringsgeschiedenis',
            expand: 'Uitvouwen',
            collapse: 'Invouwen',
            action: 'Actie',
            actor: 'Acteur',
            timestamp: 'Tijdstempel',
            comment: 'Opmerking',
            close_case: 'Zaak sluiten',
            confirm_close: 'Sluiting bevestigen',
            closure_notes: 'Sluitingsnotities',
            disposition_compliant: 'Conform',
            disposition_non_compliant: 'Niet-conform',
            disposition_partial: 'Gedeeltelijk',
            case_closed: 'Bewijspakket gesloten',
            export_package: 'Pakket exporteren',
            export_complete: 'Bewijspakket geëxporteerd',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Overzicht',
            properties: 'Eigenschappen',
            groups: 'Groepen',
            bindings: 'Bindingen',
            change_requests: 'Wijzigingsverzoeken',
            comparison: 'Vergelijking',
            inconsistencies: 'Inconsistenties',
            snapshot_schedules: "Momentopnameschema's",
            golden_templates: 'Gouden sjablonen',
            evidence_packs: 'Bewijspakketten',
            audit: 'Controle',
        },
        select_property: 'Eigenschap selecteren…',
        select_policy: 'Beleid selecteren…',
        select_properties: 'Eigenschappen selecteren…',
        select_target_properties: 'Doeleigenschappen selecteren…',
        select_owner: 'Eigenaar selecteren…',
        select_technical_contact: 'Technisch contact selecteren…',
        property_statuses: {
            active: 'Actief',
            inactive: 'Inactief',
            pending: 'In afwachting',
            decommissioned: 'Buiten gebruik',
        },
        dashboard: {
            title: 'Overkoepelend eigendomsoverzicht',
            loading: 'Laden van dashboard gegevens...',
            total_properties: 'Totaal Eigenschappen',
            active_properties: 'Actief Eigenschappen',
            snapshot_coverage: 'Snapshot-dekking',
            properties_covered: 'eigenschappen gedekt',
            total_bindings: 'Totaal bindingen',
            deployed_bindings: 'Geïmplementeerd',
            pending_bindings: 'Wacht op implementatie',
            deployment_progress: 'Implementatievoortgang',
            on_target: 'Op doel',
            below_target: 'Onder doel',
            target_label: 'Doel',
            total_groups: 'Totaal Groepen',
            pending_changes: 'In afwachting Wijzigingen',
            inconsistencies: 'Inconsistenties',
            recent_activity: 'Recent Activiteit',
            no_recent_activity: 'Geen recente activiteit.',
            fetch_error: 'Kan niet load dashboard. Probeer het opnieuw.',
        },
        properties: {
            title: 'Eigendomsregister',
            new: 'Nieuw Eigenschap',
            edit: 'Bewerken Eigenschap',
            property_name: 'Naam',
            property_type: 'Typ',
            identifier: 'Identificator',
            environment: 'Omgeving',
            owner_id: 'Eigenaar ID',
            technical_contact_id: 'Technisch Contact ID',
            decommission: 'Buiten gebruik stellen',
            confirm_decommission: 'Are you sure you want naar decommission dit property?',
            no_properties: 'Geen eigenschappen gevonden.',
            all_environments: 'Alle Environments',
            all_types: 'Alle Types',
            cmp_instance_id: '[[TOK_0]] Instantie-ID',
            deployment_date: 'Implementatiedatum',
            identifier_placeholder: 'bijvoorbeeld www.example.com of com.example.app',
            owner_name: 'Eigenaar',
            technical_contact_name: 'Technisch contact',
            sensitive_data_categories: 'Gevoelige gegevenscategorieën',
            sensitive_data_categories_placeholder: 'Selecteer gevoelige gegevenscategorieën',
            requires_enhanced_review: 'Vereist uitgebreide beoordeling',
            sensitive_review_status: 'Gevoelige gegevensbeoordeling',
            sensitive_review_pending: 'In afwachting van beoordeling',
            sensitive_review_approved: 'Goedgekeurd',
            sensitive_review_rejected: 'Afgewezen',
            sensitive_review_submit: 'Beoordeling indienen',
            sensitive_review_approve: 'Goedkeuren',
            sensitive_review_reject: 'Afwijzen',
            sensitive_review_notes: 'Beoordelingsnotities',
            sensitive_review_notes_placeholder: 'Beoordelingsopmerkingen invoeren...',
            record_withdrawal: 'Intrekking registreren',
            withdrawal_subject_id: 'Onderwerp-ID',
            withdrawal_consent_id: 'Toestemmings-ID',
            withdrawal_reason: 'Reden',
            withdrawal_downstream_systems: 'Stroomafwaartse systemen',
            withdrawal_downstream_placeholder: 'systeem-1, systeem-2',
            withdrawal_success: 'De intrekking is met succes doorgevoerd.',
            withdrawal_error: 'Het is niet gelukt om de intrekking door te geven.',
            withdrawal_data_subject_id: 'ID van de betrokkene',
            withdrawal_data_subject_id_placeholder: 'bv. usr_abc123',
            withdrawal_consent_record_id: 'Toestemmingsrecord-ID',
            withdrawal_consent_record_id_placeholder: 'bv. consent_xyz789',
            withdrawal_purposes: 'Ingetrokken doeleinden',
            withdrawal_purposes_placeholder: 'Selecteer doeleinden om toestemming in te trekken voor...',
            withdrawal_withdrawn_at: 'Intrekkingsdatum',
            withdrawal_tasks_created: 'Taken gemaakt',
            withdrawal_affected_bindings: 'Betrokken bindingen',
            withdrawal_affected_activities: 'Betrokken verwerkingsactiviteiten',
            withdrawal_history: 'Intrekkingsgeschiedenis',
        },
        groups: {
            title: 'Eigendomsgroepen',
            new: 'Nieuw Groep',
            group_name: 'Groep Naam',
            member_count: 'Leden',
            no_groups: 'Geen property groups gevonden.',
            policies: 'Beleid',
            confirm_delete: 'Weet je zeker dat je deze groep wilt verwijderen?',
        },
        bindings: {
            title: 'Bindingsmatrix',
            property: 'Eigenschap',
            purpose: 'Doel',
            legal_basis: 'Juridisch Grondslag',
            bound: 'Gebonden',
            no_bindings: 'Geen bindings gevonden.',
            bind_policy: 'Bind beleid',
            bulk_bind: 'Bulkbinding',
            bind_policy_to_property: 'Beleid aan eigendom binden',
            bulk_bind_policy: 'Beleid voor bulkbinding',
            unbound: 'Ongebonden',
            policy_id: 'Beleids-ID',
            version_placeholder: 'bijvoorbeeld 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Bindend',
            property_name: 'Eigenschapsnaam',
            policy_name: 'Beleidsnaam',
            bindings_list: 'Bindinglijst',
            binding_actions: {
                start_deploy: 'Start implementatie',
                mark_deployed: 'Markeer als geïmplementeerd',
                rollback: 'Terugdraaien',
            },
        },
        change_requests: {
            title: 'Wijzigingsverzoekproces',
            new: 'Nieuw Wijzigen Verzoek',
            requester: 'Aanvrager',
            change_type: 'Wijzigen Type',
            property: 'Eigenschap',
            submitted_at: 'Ingediend At',
            no_requests: 'Geen change requests gevonden.',
            fetch_pipeline_error: 'Kan niet fetch pipeline. Probeer het opnieuw.',
            fetch_list_error: 'Kan niet fetch change requests. Probeer het opnieuw.',
            create_error: 'Kan niet create change request. Probeer het opnieuw.',
            action_error: 'Kan niet perform actie. Probeer het opnieuw.',
            approver_name: 'Goedkeurder',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Alle',
            view_my_properties: 'Mijn Eigenschappen',
            stage_requests: '{stage}-verzoeken',
        },
        comparison: {
            title: 'Vergelijkingswerkruimte',
            select_properties: 'Selecteren Eigenschappen naar Vergelijken',
            compare: 'Vergelijken',
            no_comparison: 'Selecteren bij least two eigenschappen naar compare.',
            fetch_error: 'Kan niet fetch comparison reports. Probeer het opnieuw.',
            run_error: 'Kan niet uitvoering comparison. Probeer het opnieuw.',
            save_notes_error: 'Kan niet save opmerkingen. Probeer het opnieuw.',
            scan_complete: 'Inconsistentie scan completed successfully.',
            scan_error: 'Kan niet uitvoering inconsistency scan. Probeer het opnieuw.',
            min_two_properties: "Gelieve provide bij least 2 property ID's voor comparison.",
            view_inconsistencies: 'Inconsistenties bekijken',
            click_to_select: 'Klik om twee of meer eigenschappen te selecteren',
            no_properties_available: 'Geen eigenschappen beschikbaar',
            no_matching_properties: 'Geen overeenkomende eigenschappen',
            select_at_least_two_props: 'Selecteer minimaal twee eigenschappen uit het bovenstaande keuzemenu.',
            no_differences_found: 'Geen verschillen gevonden tussen de geselecteerde eigenschappen.',
            found_inconsistencies: '{count} inconsistenties gevonden in {properties} eigenschappen en {bindings} bindingen.',
        },
        inconsistencies: {
            title: 'Inconsistentielijst',
            property: 'Eigenschap',
            field: 'Veld',
            expected: 'Verwacht',
            actual: 'Werkelijk',
            severity: 'Ernst',
            no_inconsistencies: 'Geen inconsistencies gevonden.',
            trend: 'Inconsistentietrend',
            trend_chart_label: 'Inconsistentietrenddiagram met tellingen in de loop van de tijd',
            acknowledge: 'Bevestigen',
            resolve: 'Oplossen',
            suppress: 'Onderdrukken',
            cr_id_placeholder: 'CR-nummer',
            view_all: 'Alle',
            view_my_properties: 'Mijn Eigenschappen',
            view_dpo_review: '[[TOK_0]] Recensiewachtrij',
            change_request_id_required: 'De wijzigingsaanvraag-ID is vereist om deze inconsistentie op te lossen.',
        },
        snapshot_schedules: {
            title: "Momentopnameschema's",
            new: 'Nieuw Plannen',
            schedule_name: 'Plannen Naam',
            frequency: 'Frequentie',
            next_run: 'Volgende Uitvoeren',
            last_run: 'Laatste Uitvoeren',
            no_schedules: 'Geen snapshot planningen gevonden.',
            target_type: 'Doeltype',
            target_id: 'Doel-ID',
            custom_frequency_days: 'Aangepaste frequentie (dagen)',
            time_of_day: 'Tijd van de dag',
            time: 'Tijd',
            retention_days: 'Retentie (dagen)',
            execute_now: 'Voer nu uit',
            placeholder_days: 'bijvoorbeeld 10',
            target_name: 'Doelnaam',
        },
        golden_templates: {
            title: 'Gouden sjablonen',
            new: 'Nieuw Sjabloon',
            template_name: 'Sjabloon Naam',
            property_type: 'Eigenschap Type',
            no_templates: 'Geen golden sjablonen gevonden.',
            applicable_group_ids: "Toepasselijke groeps-ID's (door komma's gescheiden)",
            applicable_groups: 'Toepasselijke groepen',
            purposes: 'Doeleinden',
            legal_bases: 'Juridische grondslagen',
            banner_config: 'Bannerconfiguratie',
            consent_settings: 'Toestemmingsinstellingen',
            group_ids_placeholder: 'groep-id-1, groep-id-2',
            apply_to_property: 'Toepassen op Eigenschap',
            apply_to_group: 'Toepassen op Groep',
            apply_success: 'Sjabloon succesvol toegepast.',
            applications: 'Toepassingsgeschiedenis',
            no_applications: 'Nog geen sjabloontoepassingen.',
            no_configuration_details: 'Sjabloon heeft geen configuratiedetails. Bewerk het sjabloon om doeleinden, rechtsgrondslagen, bannerinstellingen of toestemmingsinstellingen toe te voegen.',
        },
        rollouts: {
            title: 'Sjabloonuitrol',
            rollout_status: 'Uitrolstatus',
            confirmed: 'Bevestigd',
            pending: 'In afwachting',
            failed: 'Mislukt',
            confirm: 'Eigenschap bevestigen',
            confirm_success: 'Eigenschap bevestigd in uitrol.',
            can_close: 'Alle eigenschappen bevestigd — uitrol voltooid',
            cannot_close: 'Wachten op eigendomsbevestigingen',
            no_rollouts: 'Geen uitrollingen gevonden.',
            in_progress: 'Bezig',
            completed: 'Voltooid',
            cancelled: 'Geannuleerd',
            reject: 'Eigenschap Afwijzen',
            reject_success: 'Eigenschap afgewezen uit uitrol.',
            confirm_all: 'Alles Bevestigen',
            reject_all: 'Alles Afwijzen',
            confirm_label: 'Bevestig uitrol voor',
            reject_label: 'Wijs uitrol af voor',
            confirm_all_label: 'Alle Wachtende Uitrollingen Bevestigen',
            reject_all_label: 'Alle Wachtende Uitrollingen Afwijzen',
            no_properties_in_rollout: 'Deze uitrol heeft geen eigenschappen.',
        },
        analytics: {
            title: 'Eigenschapsanalyse',
            opt_in_rate: 'Opt-in-percentage',
            opt_out_rate: 'Opt-out-percentage',
            withdrawal_rate: 'Intrekkingspercentage',
            total_consents: 'Totaal toestemmingen',
            total_withdrawals: 'Totaal intrekkingen',
            compliance_score: 'Nalevingsscore',
            non_compliant: 'Niet-conforme eigenschappen',
            no_non_compliant: 'Alle eigenschappen zijn conform.',
            threshold: 'Nalevingsdrempel',
            property_id: 'Property-ID',
            compliant: 'Conform',
            non_compliant_status: 'Niet-conform',
            compliance_help_summary: 'Hoe wordt de nalevingsscore berekend en hoe kan ik dit oplossen?',
            compliance_help_intro: 'Een eigenschap wordt als niet-conform gemarkeerd als de score lager is dan 80%. De score wordt als volgt berekend:',
            compliance_help_with_template_label: 'Als een gouden sjabloon wordt toegepast:',
            compliance_help_with_template_text: '% configuratiesleutels (doeleinden, legal_bases, banner_config, consent_settings) die exact overeenkomen met de sjabloon.',
            compliance_help_no_template_label: 'Als er geen Gouden Sjabloon wordt toegepast:',
            compliance_help_no_template_text: '% bindingen (toestemmingstypen toegewezen aan de property) met deployment_status = geïmplementeerd. Een eigenschap zonder bindingen is standaard 100%.',
            compliance_help_fix_intro: 'Om een eigenschap uit deze lijst te verwijderen, voert u een van de volgende handelingen uit:',
            compliance_help_fix_deploy_label: 'Implementeer de bindingen',
            compliance_help_fix_deploy_text: 'open de pagina Bindingsmatrix en stel de implementatiestatus van elke binding in op geïmplementeerd.',
            compliance_help_fix_template_label: 'Pas een gouden sjabloon toe',
            compliance_help_fix_template_text: 'gebruik Toepassen op groep op de sjabloon en bevestig vervolgens de implementatie voor deze property. Zorg ervoor dat de configuratie van de eigenschap overeenkomt met de sjabloon.',
            compliance_help_fix_decommission_label: 'Ontmantel het pand',
            compliance_help_fix_decommission_text: 'gebruik de knop Ontmanteling in het modale objectdetail als deze niet langer in gebruik is.',
            compliance_help_fix_no_bindings_label: 'Verwijder alle bindingen',
            compliance_help_fix_no_bindings_text: 'als een eigenschap geen sjabloon en geen bindingen heeft, scoort deze standaard 100%.',
        },
        evidence_packs: {
            title: 'Bewijspakketten',
            new: 'Nieuw Pakket',
            pack_name: 'Pakket Naam',
            properties: 'Eigenschappen',
            generated_at: 'Gegenereerd At',
            no_packs: 'Geen bewijs packs gevonden.',
            generate: 'Genereren',
            content_type_consent_records: 'Toestemming Records',
            content_type_policy_versions: 'Beleid Versies',
            content_type_binding_history: 'Binding Geschiedenis',
            content_type_change_requests: 'Wijzigen Verzoeken',
            content_type_inconsistency_reports: 'Inconsistentie Rapporten',
            content_type_snapshot_data: 'Snapshot Gegevens',
            content_type_audit_trail: 'Auditspoor',
        },
        audit: {
            title: 'Toestemmingseigendomscontrole',
            event_type: 'Gebeurtenis Type',
            entity_type: 'Entiteit Type',
            entity_id: 'Entiteit ID',
            actor: 'Betrokkene',
            timestamp: 'Tijdstempel',
            no_events: 'Geen audit gebeurtenissen gevonden.',
            entity_type_property: 'Eigenschap',
            entity_type_group: 'Groep',
            entity_type_binding: 'Bindend',
            entity_type_change_request: 'Wijzigingsverzoek',
            entity_type_golden_template: 'Gouden sjabloon',
            entity_type_snapshot_schedule: 'Momentopnameschema',
            entity_type_inconsistency: 'Inconsistentie',
            entity_type_evidence_pack: 'Bewijspakket',
            action_created: 'Aangemaakt',
            action_updated: 'Bijgewerkt',
            action_deleted: 'Verwijderd',
            action_decommissioned: 'Buiten gebruik',
            action_status_changed: 'Status gewijzigd',
            action_submitted: 'Ingediend',
            action_approved: 'Goedgekeurd',
            action_rejected: 'Afgewezen',
            action_deployed: 'Geïmplementeerd',
            action_rolled_back: 'Teruggedraaid',
            action_paused: 'Gepauzeerd',
            action_resumed: 'Hervat',
            action_cancelled: 'Geannuleerd',
            action_acknowledged: 'Bevestigd',
            action_resolved: 'Opgelost',
            action_suppressed: 'Onderdrukt',
            action_executed: 'Uitgevoerd',
        },
        property_types: {
            website: 'Website',
            mobile_app: 'Mobiele app',
            ott: 'OTT',
            iot_device: 'IoT-apparaat',
            kiosk: 'Kiosk',
            api_service: 'API-dienst',
            sdk: 'SDK',
        },
        environments: {
            production: 'Productie',
            staging: 'Staging',
            development: 'Ontwikkeling',
            testing: 'Testen',
        },
        group_types: {
            brand: 'Merk',
            region: 'Regio',
            product_line: 'Productlijn',
            business_unit: 'Bedrijfseenheid',
            custom: 'Aangepast',
        },
        target_types: {
            property: 'Eigenschap',
            group: 'Groep',
            all: 'Alle',
        },
        frequencies: {
            hourly: 'Elk uur',
            daily: 'Dagelijks',
            weekly: 'Wekelijks',
            monthly: 'Maandelijks',
            custom: 'Aangepast',
        },
        binding_statuses: {
            current: 'Huidig',
            outdated: 'Verouderd',
            pending: 'In afwachting',
            deploying: 'Implementeren',
            rolled_back: 'Teruggedraaid',
        },
        sensitive_categories: {
            health: 'Gezondheidsgegevens',
            biometric: 'Biometrische gegevens',
            genetic: 'Genetische gegevens',
            racial_ethnic: 'Raciale/etnische afkomst',
            political_opinions: 'Politieke meningen',
            religious_beliefs: 'Religieuze overtuigingen',
            trade_union: 'Lidmaatschap van een vakbond',
            sexual_orientation: 'Seksuele geaardheid',
            criminal_records: 'Strafregisters',
            financial: 'Financiële gegevens',
            children: 'Gegevens van kinderen',
            geolocation: 'Nauwkeurige geolocatie',
        },
        export_csv: 'CSV exporteren',
        exporting: 'Exporteren...',
        page_x_of_y: 'Pagina {page} van {total}',
        regulatory: {
            capture_method_guidance: '[[TOK_0]] vereist een toestemmingsbewijs dat overeenkomt met het verzamelkanaal. Propertytypen worden toegewezen aan methoden voor het vastleggen van toestemming: website/OTT = op banners gebaseerde toestemming, mobiele app/SDK = toestemmingsstroom in de app, kiosk = fysiek/op het scherm vastleggen van toestemming, [[TOK_1]] service = programmatische toestemming, IoT-apparaat = toestemmingsmechanisme op apparaatniveau.',
            dashboard_metrics_info: 'Dit dashboard biedt de [[TOK_0]] één weergave van de toestemmingsstatus voor alle digitale eigendommen. Belangrijke statistieken zijn onder meer: ​​het dekkingspercentage van de bindingen (geïmplementeerd vs. totale bindingen), naleving van de template via de inconsistentieswidget, openstaande wijzigingsverzoeken die moeten worden beoordeeld, en een uitsplitsing van de eigendomsstatus met eigendommen met actieve, inactieve of buiten gebruik gestelde statussen. Eigendommen met gevoelige gegevenscategorieën worden gevolgd via het eigendomsregister.',
            change_request_impact_info: 'Wijzigingsverzoeken die van invloed zijn op toestemmingseigenschappen moeten de gevolgen van de regelgeving documenteren: welke [[TOK_0]] vereisten worden beïnvloed, of de wijziging van invloed is op de verwerking van gevoelige gegevens (art. 2.4) en of voor de wijziging hernieuwde toestemming van de betrokkenen vereist is. In het impactoverzicht in elk wijzigingsverzoek worden de [[TOK_1]] referenties van de regelgeving voor controle-informatie gedetailleerd beschreven.',
            outdated_binding_warning: "Bindingen met de status 'verouderd' geven aan dat een eigenschap een beleidsversie uitvoert die niet actueel is. Deze eigenschappen weerspiegelen mogelijk niet de nieuwste [[TOK_0]]-vereisten of updates van het organisatiebeleid. Controleer en update verouderde bindingen onmiddellijk om de naleving van [TOK_1]] voor alle toestemmingseigenschappen te behouden.",
            template_pdpl_alignment: 'Volgens [[TOK_0]] Art. 11: gouden sjablonen moeten doeleinden koppelen aan rechtsgrondslagen. Bannerconfiguraties moeten opt-in (niet opt-out) afdwingen volgens Art. 11.3 uitdrukkelijke toestemming. Sjablonen moeten een opnamemechanisme specificeren volgens Art. 12. Voor gevoelige gegevens (art. 2.4) moeten sjablonen expliciete schriftelijke of gelijkwaardige toestemming afdwingen; doorklikacceptatie is onvoldoende.',
        },
    },
    localization: {
        nav: {
            dashboard: 'Overzicht',
            market_packs: 'Marktpakketten',
            language_packs: 'Taalpakketten',
            frameworks: 'Regelgevingskaders',
            mappings: 'Moduletoewijzingen',
            submissions: 'Pakketinzendingen',
            translations: 'Vertalingsvoorbeeld',
            audit: 'Controlespoor',
        },
        dashboard: {
            title: 'Lokalisatieoverzicht',
            loading: 'Laden van dashboard gegevens...',
            active_market_packs: 'Actief Markt Pakketten',
            published_packs_available: 'Gepubliceerd market packs available',
            language_packs: 'Taal Pakketten',
            total_language_packs: 'Totaal language packs registered',
            active_regulatory_frameworks: 'Actief Regelgevend Raamwerken',
            frameworks_active: 'Raamwerken met actief status',
            pending_pack_submissions: 'In afwachting Pakket Indieingen',
            submissions_awaiting_review: 'Indieingen awaiting beoordeling',
            recent_audit_events: 'Recent Audit Gebeurtenissen',
            no_recent_audit: 'No recent audit gebeurtenissen.',
            event_type: 'Gebeurtenis Type',
            entity_type: 'Entiteit Type',
            entity_id: 'Entiteit ID',
            actor: 'Betrokkene',
            timestamp: 'Tijdstempel',
        },
        market_packs: {
            title: 'Marktpakketcatalogus',
            new: 'Nieuw Markt Pakket',
            pack_name: 'Pakket Naam',
            market: 'Markt',
            locale: 'Taalinstelling',
            no_packs: 'Geen market packs gevonden.',
        },
        language_packs: {
            title: 'Taalpakketten',
            new: 'Nieuw Taal Pakket',
            language: 'Taal',
            locale_code: 'Taalinstelling Code',
            completeness: 'Volledigheid',
            completeness_detail: 'Volledigheidsdetail',
            overall_completeness: 'Algemene volledigheid',
            total_keys: 'Totaal aantal sleutels',
            translated_keys: 'Vertaalde sleutels',
            missing_keys: 'Ontbrekende sleutels',
            namespace_breakdown: 'Uitsplitsing van de naamruimte',
            namespace: 'Naamruimte',
            translated: 'Vertaald',
            no_packs: 'Geen language packs gevonden.',
            install_language_pack: 'Taalpakket installeren',
            available_packs: 'Beschikbare taalpakketten',
            install: 'Installeren',
            all_installed: 'Alle taalpakketten zijn al geïnstalleerd.',
            install_success: 'Taalpakket succesvol geïnstalleerd.',
            market: 'Markt',
            featured: 'Uitgelicht',
        },
        frameworks: {
            title: 'Regelgevingskaders',
            new: 'Nieuw Raamwerk',
            framework_name: 'Raamwerk Naam',
            jurisdiction: 'Jurisdictie',
            effective_date: 'Effectief Datum',
            no_frameworks: 'Geen regulatory frameworks gevonden.',
            view_requirements: 'Bekijk vereisten',
            hide_requirements: 'Verberg vereisten',
            show_legacy: 'Toon verouderde kaders',
            effective_until: 'Geldig tot',
            effective_on: 'Geldig vanaf',
            replaced_by: 'Vervangen door',
            replaces_label: 'Vervangt',
            status_legacy: 'Verouderd',
            status_upcoming: 'Aanstaand',
            watchlist: 'Volglijst',
            watchlist_empty: 'Geen concept- of aanstaande kaders',
            watchlist_empty_desc: 'Frameworks met de status "concept" of "aankomend" zullen hier verschijnen voor monitoring.',
            expected_effective: 'Verwacht effectief',
            effective_date_tbd: 'Ingangsdatum: nader vast te stellen',
            activate: 'Activeer',
            ai_law_title: 'Vietnam [[TOK_0]] Wet',
            ai_risk_classification: '[[TOK_0]] Risicoclassificatie',
            ai_system_dossier: '[[TOK_0]] Systeemdossier',
            ai_labeling_checklist: '[[TOK_0]] Etikettering en openbaarmaking',
            ai_incident_report: '[[TOK_0]] Incidentrapport',
            ai_impact_assessment: '[[TOK_0]] Effectbeoordeling',
            ai_sandbox_application: 'Sandbox-applicatie',
            ai_sandbox_monitoring: 'Sandbox-monitoring',
            ai_sandbox_completion: 'Sandbox-voltooiing',
            ai_submission_tracker: 'Inzendingstracker',
            ai_evidence_capture: 'Bewijs vastleggen',
            risk_level_minimal: 'Minimaal risico',
            risk_level_limited: 'Beperkt risico',
            risk_level_high: 'Hoog risico',
            risk_level_unacceptable: 'Onaanvaardbaar risico',
            submission_status_draft: 'Diepgang',
            submission_status_submitted: 'Ingezonden',
            submission_status_returned: 'Teruggestuurd voor wijziging',
            submission_status_accepted: 'Geaccepteerd',
            submission_status_rejected: 'Afgewezen',
            submission_status_closed: 'Gesloten',
            ecommerce_law_title: 'Vietnamees e-commercerecht',
            ecommerce_platform_classification: 'Platformclassificatie',
            ecommerce_seller_register: 'Verkopersregister',
            ecommerce_complaint_register: 'Klachtenregister',
            ecommerce_takedown_register: 'Verwijderingsregister',
            ecommerce_submission_tracking: 'Inzendingen volgen',
            ecommerce_dossier_checklist: 'Dossierchecklist',
            ecommerce_cross_border: 'Grensoverschrijdende naleving',
            ecommerce_trustmark: 'Trustmark-programma',
            ecommerce_notification: 'Kennisgeving',
            ecommerce_registration: 'Registratie',
            ecommerce_termination: 'Beëindiging',
            ecommerce_reporting_readiness: 'Rapportagegereedheid',
            ecommerce_evidence_capture: 'Bewijs vastleggen',
            submission_status_approved: 'Goedgekeurd',
            cybersec_law_2025_title: 'Vietnamese cyberveiligheidswet (2025)',
            cybersec_system_classification: 'Systeemclassificatie',
            cybersec_risk_assessment: 'Risicobeoordeling',
            cybersec_incident_report: 'Incidentrapport',
            cybersec_authority_cooperation: 'Samenwerking tussen autoriteiten',
            cybersec_data_localization: 'Gegevenslokalisatie',
            cybersec_vendor_security: 'Beveiliging van leveranciers',
            cybersec_submission_tracker: 'Inzendingstracker',
            cybersec_evidence_capture: 'Bewijs vastleggen',
            cybersec_dossier_checklist: 'Dossierchecklist',
            cybersec_classification_general: 'Algemeen',
            cybersec_classification_important: 'Belangrijk',
            cybersec_classification_critical: 'Kritisch',
            data_law_title: 'Gegevenswet Vietnam',
            data_inventory: 'Gegevensinventarisatie',
            data_classification: 'Gegevensclassificatie',
            data_sharing: 'Gegevens delen',
            data_governance: 'Gegevensbeheer',
            data_submission_tracker: 'Inzendingstracker',
            data_evidence_capture: 'Bewijs vastleggen',
            data_dossier_checklist: 'Dossierchecklist',
            telecom_law_title: 'Telecomwet van Vietnam',
            telecom_authority_request: 'Autoriteitsverzoek',
            telecom_disclosure: 'Openbaarmaking',
            telecom_confidentiality: 'Vertrouwelijkheid',
            telecom_submission_tracker: 'Inzendingstracker',
            telecom_evidence_capture: 'Bewijs vastleggen',
            telecom_dossier_checklist: 'Dossierchecklist',
            pdpl_law_title: 'Vietnamese wet op de bescherming van persoonsgegevens',
            pdpl_breach_notification: 'Melding van inbreuk',
            pdpl_dpo_notification: '[[TOK_0]] Afspraakmelding',
            pdpl_data_subject_notification: 'Kennisgeving van de betrokkene',
            pdpl_submission_tracker: 'Inzendingstracker',
            pdpl_evidence_capture: 'Bewijs vastleggen',
            pdpl_dossier_checklist: 'Dossierchecklist',
            pdpl_authority_filing: 'Autoriteit indienen',
            pdpl_mops_filing: 'MoPS-archivering',
        },
        mappings: {
            title: 'Moduletoewijzingen',
            new: 'Nieuw Toewijzing',
            module: 'Onderdeel',
            market_pack: 'Markt Pakket',
            mapping_status: 'Toewijzing Status',
            no_mappings: 'Geen module toewijzingen gevonden.',
            incomplete_entries_warning: '{count} toewijzing(en) verborgen vanwege ontbrekend framework-ID, vereiste-ID of module.',
        },
        submissions: {
            title: 'Pakketinzendingen',
            new: 'Nieuw Indiening',
            submitter: 'Indiener',
            pack: 'Pakket',
            submitted_at: 'Ingediend At',
            no_submissions: 'Geen pakket indieingen gevonden.',
            installed_sector_overlays_title: 'Sector Overlays ({count}) [NL]',
            installed_sector_overlays_aria: 'Installed Sector Overlays [NL]',
            installed_col_name: 'Name [NL]',
            installed_col_code: 'Code [NL]',
            installed_col_sector: 'Sector [NL]',
            installed_col_mode: 'Mode [NL]',
            installed_col_status: 'Status [NL]',
            installed_refresh: 'Refresh [NL]',
        },
        translations: {
            title: 'Vertalingsvoorbeeld',
            select_locale: 'Selecteren Taalinstelling',
            select_module: 'Selecteren Module',
            key: 'Key',
            value: 'Waarde',
            no_translations: 'Geen translations gevonden.',
        },
        audit: {
            title: 'Lokalisatie Audit Trail',
            event_type: 'Gebeurtenis Type',
            entity_type: 'Entiteit Type',
            entity_id: 'Entiteit ID',
            entity_name: 'Entiteitsnaam',
            actor: 'Betrokkene',
            timestamp: 'Tijdstempel',
            payload: 'Laadvermogen',
            collapse_payload: 'Payloaddetails inklappen',
            expand_payload: 'Payloaddetails uitklappen',
            collapse: 'Inklappen',
            expand: 'Uitklappen',
            all_entity_types: 'Alle entiteitstypen',
            no_events: 'Geen audit gebeurtenissen gevonden.',
        },
        market_packs_detail: {
            installed_at: 'Geïnstalleerd op',
            pack_details_label: 'Pakketdetails',
            market_code: 'Marktcode',
            supported_locales: 'Ondersteunde talen',
            min_platform_version: 'Minimale platformversie',
            pack_information: 'Pakketinformatie',
            pack_contents: 'Inhoud verpakking',
            included_frameworks: 'Inbegrepen raamwerken',
            pack_artifacts: 'Pakketartefacten',
            no_artifacts: 'Geen artefacten gevonden voor dit pakket',
            pack_not_found: 'Pakket niet gevonden',
        },
        mappings_form: {
            framework_id: 'Raamwerk-ID',
            requirement_id: 'Vereiste-ID',
            module_label: 'Module',
            mapping_type: 'Toewijzingstype',
            configuration_json: 'Configuratie (JSON)',
            conflict_resolution: 'Conflictoplossing',
            is_override: 'Is overschrijving',
            all_modules: 'Alle modules',
            all_mapping_types: 'Alle toewijzingstypen',
        },
        submissions_detail: {
            submission_id: 'Inzendings-ID',
            validation: 'Validatie',
            reviewers: 'Beoordelaars',
            start_review: 'Beoordeling starten',
            hide_comments: 'Opmerkingen verbergen',
            review_comments: 'Beoordelingscommentaren',
            loading_comments: 'Opmerkingen laden...',
            no_comments: 'Nog geen opmerkingen.',
            add_comment: 'Opmerking toevoegen',
            reject_submission: 'Inzending afwijzen',
            reason_for_rejection: 'Reden voor afwijzing',
            reviewer_ids: "Beoordelaars-IDs (door komma's gescheiden)",
            submit_new_pack: 'Nieuw pakket indienen',
            pack_type: 'Pakkettype',
            market_code: 'Marktcode',
            target_locales: 'Doeltalen',
            pack_file: 'Pakketbestand',
            pack_format_info: 'Pakketindeling: marktpakketten moeten landspecifieke [[TOK_0]]-bestanden met naamruimte/sleutelvertalingen bevatten. Taalpakketten moeten vertalingen bieden voor de opgegeven doellandinstellingen. Zie documentatie voor gedetailleerd schema.',
            accepted_formats: 'Geaccepteerde formaten: .json of .zip. [[TOK_0]]-bestanden moeten een plat object of een object met een naamruimte van vertaalsleutel-waardeparen bevatten. ZIP-bestanden moeten een of meer [[TOK_1]] locale-bestanden bevatten.',
            comma_separated_locales: "Door komma's gescheiden taalcodes voor dit taalpakket",
            confirm_approval: 'Goedkeuring bevestigen',
            approve_message: 'Deze pakketinzending goedkeuren?',
            submission_label: 'Inzending',
            all_pack_types: 'Alle pakkettypen',
            passed: 'geslaagd',
            failed_label: 'mislukt',
            market_code_required: 'Marktcode is vereist',
            version_required: 'Versie is vereist',
            pack_type_regulatory: 'Regelgevend',
            framework_code: 'Raamwerkcode',
            jurisdiction_code: 'Jurisdictiecode',
            pack_source: 'Bron',
            pack_source_manual: 'Handmatig',
            pack_version: 'Pakketversie',
            install_regulatory_pack: 'Regelgevend pakket installeren',
            regulatory_pack_desc: 'Upload een regelgevend raamwerkpakket (.zip)',
            framework_required: 'Kaderregelgevingcode is vereist',
            jurisdiction_required: 'Jurisdictiecode is vereist',
        },
        catalog_detail: {
            packs_installed_of: 'van {total} pakketten geïnstalleerd',
            install_all: 'Alles installeren',
            installing: 'Installeren...',
            removing: 'Verwijderen...',
            requires: 'Vereist',
            tab_catalog: 'Catalogus',
            tab_installed: 'Geïnstalleerd',
            details: 'Details',
        },
        translations_detail: {
            source_locale: 'Brontaal',
            target_locale: 'Doeltaal',
            locales_must_differ: 'Bron- en doeltaal moeten verschillend zijn.',
            all_keys_translated: 'Alle sleutels vertaald',
            keys_missing: '[[TOK_1]] sleutel(s) ontbreken',
            show_missing_only: 'Alleen ontbrekende tonen',
            namespace: 'Naamruimte',
            source: 'Bron',
            target: 'Doel',
        },
        frameworks_detail: {
            tab_frameworks: 'Raamwerken',
            tab_watchlist: 'Volglijst',
            authority: 'Autoriteit',
            requirements_count: 'Vereisten',
            all_types: 'Alle typen',
            collapse_all: 'Alles inklappen',
            expand_all: 'Alles uitklappen',
            filtered_to: 'Gefilterd op',
            clear_filter: 'Filter wissen',
            no_requirements: 'Geen vereisten gevonden voor dit raamwerk.',
            requirements_label: 'Vereisten',
            status_updated: 'Status succesvol bijgewerkt',
            overview_tab: 'Overzicht',
            forms_tab: 'Formulieren',
            procedures_tab: 'Procedures',
            fines_risks_tab: "Boetes en risico's",
            deadlines_tab: 'Deadlines',
            guidance_tab: 'Begeleiding',
            guidance_empty: 'Er is geen begeleidingsinhoud voor dit raamwerk.',
            guidance_loading: 'Begeleiding laden…',
            guidance_section: 'Begeleidingssectie',
            guidance_view: 'Begeleiding bekijken',
            guidance_map_to_workflow: 'Toewijzen aan workflow',
            guidance_link_evidence: 'Bewijs koppelen',
            guidance_filter_type: 'Typ',
            guidance_filter_category: 'Categorie',
            guidance_filter_module: 'Module',
            guidance_filter_status: 'Status',
            guidance_filter_search: 'Zoekbegeleiding',
            guidance_filter_all: 'Allemaal',
            guidance_table_reference: 'Referentie',
            guidance_table_name: 'Begeleidingsnaam',
            guidance_table_type: 'Typ',
            guidance_table_category: 'Categorie',
            guidance_table_effective_date: 'Ingangsdatum',
            guidance_table_modules: 'Gerelateerde modules',
            guidance_table_actions: 'Acties',
            guidance_reference_only_banner: 'Alleen referentie: geldt voor de sector {[[TOK_1]]}, maar niet voor uw organisatie.',
            guidance_related_link: 'Gerelateerde richtlijnen',
            deadlines_empty: 'Geen regelgevende deadlines gevonden voor dit raamwerk.',
            deadlines_sla_type: 'SLA-type',
            deadlines_value: 'Deadline',
            deadlines_unit: 'Eenheid',
            deadlines_extension: 'Verlenging',
            deadlines_reference: 'Juridische referentie',
            framework_stack: 'Raamwerkstructuur',
            layer_parent_law: 'Hoofdwet',
            layer_implementing_decree: 'Uitvoeringsbesluit',
            layer_enforcement_decree: 'Handhavingsbesluit',
            layer_admin_procedures: 'Administratieve procedures',
            status_active: 'Actief',
            status_draft: 'Concept',
            draft_enforcement_badge: 'Concept — nog niet uitgevaardigd',
            effective_date: 'Inwerkingtreding',
            forms_table_id: 'Formulier-ID',
            forms_table_name: 'Formuliernaam',
            forms_table_source: 'Bron',
            forms_table_category: 'Categorie',
            forms_table_type: 'Typ',
            fill_form: 'Formulier invullen',
            view_reference: 'Bekijk referentie',
            forms_official: 'Officieel',
            forms_internal: 'Intern',
            forms_empty: 'Geen formulieren gevonden voor dit raamwerk.',
            forms_loading: 'Formulieren laden...',
            filter_by_source_layer: 'Filter op bronlaag',
            all_layers: 'Alle lagen',
            procedures_id: 'Procedure-ID',
            procedures_name: 'Werkwijze',
            procedures_trigger: 'Trigger',
            procedures_steps: 'Stappen',
            procedures_outputs: 'Resultaten',
            procedures_related_forms: 'Gerelateerde formulieren',
            procedures_submission_channels: 'Inzendingskanalen',
            procedures_empty: 'Geen procedures gevonden voor dit raamwerk.',
            fines_area: 'Overtredingsgebied',
            fines_articles: 'Conceptartikelen',
            fines_individual: 'Boete (individu)',
            fines_organization: 'Boete (organisatie)',
            fines_revenue: 'Omzetescalatie',
            fines_deadlines: 'Deadlines',
            fines_remediation: 'Herstelmaatregelen',
            fines_related: 'Gerelateerde procedures',
            fines_empty: 'Geen handhavingsgegevens beschikbaar voor dit raamwerk.',
            fines_enforcement_pending: 'Handhavingskader nog niet gepubliceerd. Sanctiegegevens worden toegevoegd wanneer het uitvoeringsinstrument is afgekondigd.',
            view_details: 'Details bekijken',
            back_to_list: 'Terug naar de lijst',
            description: 'Beschrijving',
            jurisdiction: 'Jurisdictie',
            lineage: 'Afstamming',
            replaces: 'Vervangt',
            replaced_by: 'Vervangen door',
            requirements: 'Vereisten',
            tab_navigation: 'Raamwerkdetail-tabbladen',
            forms_table_actions: 'Acties',
            create_form: 'Formulier aanmaken',
            mark_promulgated: 'Markeren als afgekondigd',
            status_promulgated: 'Afgekondigd',
            promulgated_success: 'Laagstatus bijgewerkt naar afgekondigd',
            transition_review: 'Overgangsbeoordeling',
            transition_review_desc: 'Dit kader heeft een openstaande overgangsbeoordeling voor de invoering van de opvolgende wet.',
            transition_review_by: 'Beoordelingsdatum',
            transition_review_status: 'Beoordelingsstatus',
            transition_review_notes: 'Opmerkingen',
            transition_review_pending: 'In afwachting',
            transition_review_in_progress: 'In uitvoering',
            transition_review_completed: 'Afgerond',
            transition_review_successor: 'Opvolgend kader',
            transition_review_lead_time: 'Voorbereidingstijd',
            transition_review_lead_time_days: '{days} dagen voor inwerkingtreding',
            transition_review_forms_heading: 'Formulierovergangsbeoordeling',
            transition_review_forms_desc: 'Beoordeel elk operationeel sjabloon op relevantie onder het opvolgende kader.',
            transition_review_outcome: 'Resultaat',
            transition_review_outcome_carry_forward: 'Behouden',
            transition_review_outcome_carry_forward_revised: 'Behouden (herzien)',
            transition_review_outcome_retire: 'Intrekken',
            transition_review_outcome_split: 'Splitsen',
            transition_review_outcome_awaiting_decree: 'Wachtend op besluit',
            transition_review_no_forms: 'Geen formulierovergangsbeoordeling geconfigureerd.',
            transition_review_update_success: 'Overgangsbeoordeling succesvol bijgewerkt',
            transition_review_operational_note: 'Dit zijn procesondersteunende operationele sjablonen, geen wettelijke formuliertellingen. De juridische toewijzing blijft bij het oude kader totdat de opvolgende wet in werking treedt.',
            rights_tab: 'Rechten',
            rights_empty: 'Geen rechten van betrokkenen gedefinieerd voor dit kader.',
            rights_code: 'Codeer',
            rights_name: 'Recht',
            rights_legal_basis: 'Rechtsgrondslag',
            rights_elaborating_articles: 'Uitwerkingsartikelen',
            rights_description: 'Beschrijving',
            requirements_reference: 'Referentie',
            requirements_mandatory: 'Verplicht',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'Bron',
            category_legal_basis: 'Wettelijke basis',
            category_data_subject_rights: 'Rechten van betrokkenen',
            category_notification: 'Kennisgeving',
            category_assessment: 'Beoordeling',
            category_governance: 'Bestuur',
            category_record_keeping: 'Registratie bijhouden',
            category_cross_border: 'Grensoverschrijdend',
            category_technical_measures: 'Technische maatregelen',
            category_incident_reporting: 'Incidentrapportage',
            category_risk_management: 'Risicobeheer',
            category_supply_chain: 'Toeleveringsketen',
            category_certification: 'Certificering',
            child_frameworks: '[[TOK_1]] onderliggend raamwerk',
            child_frameworks_plural: '[[TOK_1]] onderliggende raamwerken',
            replaces_prefix: 'Vervangt:',
            replaced_by_prefix: 'Vervangen door:',
            responsible_prefix: 'Verantwoordelijk:',
            watchlist_empty_hint: 'Frameworks met de status "concept" of "aankomend" zullen hier verschijnen voor monitoring.',
            framework_count: '[[TOK_1]]-framework',
            framework_count_plural: '[[TOK_1]] raamwerken',
            hiding_legacy: '([[TOK_1]] verouderd verbergen)',
            label_VN_PDPL: '[[TOK_0]] (Decreet 13/2023)',
            label_VN_PDPD_DECREE_13: 'Wbp-decreet 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Wet 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Decreet [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: '[[TOK_0]] Handhavingsontwerp 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Gegevenswet',
            label_VN_DATA_LAW_DECREE_165_2025: 'Besluit gegevenswet 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Data-uitwisselingen concept 2026',
            label_VN_TELECOM_LAW_2023: 'Telecommunicatiewet 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Telecomdecreet 163/2024',
            label_VN_CYBERSEC_LAW: 'Cyberveiligheidswet (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Cybersec-decreet 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Cyberveiligheidswet 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'Wet op de elektronische handel 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] Wet 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Bedrijf',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Autoriteit',
            sla_type_rights_request_ack: 'Rechten vragen om erkenning',
            'sla_type_Access control review': 'Toegangscontrole beoordeling',
            'sla_type_Annual governance attestation': 'Jaarlijks bestuursattest',
            'sla_type_Audit review cycle': 'Auditbeoordelingscyclus',
            'sla_type_Authority request response': 'Antwoord van autoriteitsverzoek',
            'sla_type_Change notification processing': 'Meldingsverwerking wijzigen',
            'sla_type_Complaint acknowledgment': 'Klachtbevestiging',
            'sla_type_Complaint resolution': 'Klachtenafhandeling',
            'sla_type_Confidentiality policy review': 'Herziening van het vertrouwelijkheidsbeleid',
            'sla_type_Cybersecurity incident full report': 'Volledig rapport over cyberbeveiligingsincidenten',
            'sla_type_Cybersecurity incident initial report': 'Eerste rapport cyberveiligheidsincidenten',
            'sla_type_Data inventory review': 'Beoordeling van gegevensinventarisatie',
            'sla_type_Disclosure log review cycle': 'Beoordelingscyclus van openbaarmakingslogboek',
            'sla_type_Incident classification decision': 'Beslissing over classificatie van incidenten',
            'sla_type_Information system classification review': 'Beoordeling van de classificatie van informatiesystemen',
            'sla_type_Notification processing (sales website/app)': 'Meldingsverwerking (verkoopwebsite/app)',
            'sla_type_Pen test cycle': 'Pentestcyclus',
            'sla_type_Registration processing (service platform)': 'Registratieverwerking (serviceplatform)',
            'sla_type_Risk assessment cycle': 'Risicobeoordelingscyclus',
            'sla_type_Takedown decision (after review)': 'Takedownbesluit (na beoordeling)',
            'sla_type_Termination notice (public)': 'Beëindigingsmededeling (openbaar)',
            sla_type_ai_impact_assessment_completion: '[[TOK_0]] effectbeoordeling voltooid',
            sla_type_ai_sandbox_application_review: '[[TOK_0]] beoordeling van sandbox-applicaties',
            sla_type_ai_serious_incident_report: '[[TOK_0]] rapport over ernstige incidenten',
            sla_type_ai_system_registration: '[[TOK_0]] systeemregistratie',
            sla_type_authority_request_response: 'Antwoord van autoriteitsverzoek',
            sla_type_certificate_issuance_review: 'Beoordeling van certificaatuitgifte',
            sla_type_complaint_handling_approach_notice: 'Kennisgeving klachtafhandeling',
            sla_type_complaint_incomplete_info_request: 'Klacht onvolledig infoverzoek',
            sla_type_data_governance_attestation: 'Attest voor gegevensbeheer',
            sla_type_dsr_acknowledgment: 'DSR-erkenning',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Kl.2) — Intrekken / beperken / bezwaar maken',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Kl.2) — Derde partij',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Kl.3) — Toegang / corrigeren / verstrekken',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Kl.3) — Derde partij',
            sla_type_dsr_cl4_deletion: 'DSR (Kl.4) — Schrapping',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Kl.4) — Schrapping, derde partij',
            sla_type_dsr_cl5_protective_measures: 'DSR (Kl.5) — Beschermende maatregelen',
            sla_type_telecom_authority_request_response: 'Telecomautoriteit verzoek om reactie',
            sla_type_rights_request_completion: 'Voltooiing van het rechtenverzoek',
            sla_type_incident_authority_notification: 'Melding incidentautoriteit',
            sla_type_incident_subject_notification: 'Melding van incidentonderwerp',
            sla_type_dpia_completion: '[[TOK_0]] voltooiing',
            sla_type_data_retention_review: 'Beoordeling van gegevensbewaring',
            sla_type_authority_filing_review: 'Beoordeling van de indiening door de autoriteit',
            sla_type_authority_supplement_response: 'Reactie van autoriteitssupplement',
            sla_type_authority_resubmission: 'Herindiening van de autoriteit',
            sla_type_authority_filing_supplement_response: 'Antwoord van de autoriteit die een supplement indient',
            sla_type_authority_filing_resubmission: 'Herindiening van de autoriteit',
            unit_working_days: 'werkdagen',
            unit_calendar_days: 'kalenderdagen',
            unit_hours: 'uur',
            form_category_dpa: 'DPA',
            form_category_dsr: 'DSR',
            form_category_consent: 'Toestemming',
            form_category_privacy: 'Privacy',
            form_category_breach: 'Schending',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: 'Registreren',
            form_category_monitoring: 'Toezicht',
            form_category_vendor: 'Verkoper',
            form_category_org: 'Organisatorisch',
            form_category_sector: 'Sector',
            form_category_data_mapping: 'Gegevens in kaart brengen',
            form_category_governance: 'Bestuur',
            form_category_incident: 'Voorval',
            form_category_authority_submission: 'Inzending van autoriteit',
            form_category_notice: 'Let op',
            form_category_assessment_report: 'Beoordelingsrapport',
            form_category_request: 'Verzoek',
            form_category_dossier: 'Dossier',
            form_category_filing: 'Indienen',
            module_consent: 'Toestemming',
            module_rights_request: 'Rechtenverzoek',
            module_classification: 'Classificatie',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Bestuur',
            module_monitoring: 'Toezicht',
            module_register: 'Registreren',
            module_risk: 'Risico',
            module_data_mapping: 'Gegevens in kaart brengen',
            module_incident: 'Voorval',
            module_assessment: 'Beoordeling',
            module_vendor: 'Verkoper',
            module_policy: 'Beleid',
            module_audit: 'Controle',
            module_training: 'Opleiding',
            module_discovery: 'Ontdekking',
            enum_guidance_type_calculation_guidance: 'Berekeningsbegeleiding',
            enum_guidance_type_implementation_guidance: 'Implementatiebegeleiding',
            enum_guidance_type_interpretive_note: 'Interpretatieve opmerking',
            enum_guidance_type_legal_guidance: 'Juridische begeleiding',
            enum_guidance_type_procedural_guidance: 'Procedurele begeleiding',
            enum_guidance_type_sector_guidance: 'Sectorbegeleiding',
            enum_guidance_type_technical_methodology: 'Technische Methodologie',
            enum_guidance_category_annual_reporting: 'Jaarlijkse rapportage',
            enum_guidance_category_authority_cooperation: 'Samenwerking tussen autoriteiten',
            enum_guidance_category_authority_coordination: 'Coördinatie van autoriteiten',
            enum_guidance_category_business_continuity: 'Bedrijfscontinuïteit',
            enum_guidance_category_capital_adequacy: 'Kapitaaltoereikendheid',
            enum_guidance_category_complaint_handling: 'Klachtenafhandeling',
            enum_guidance_category_consent: 'Toestemming',
            enum_guidance_category_consent_management: 'Toestemmingsbeheer',
            enum_guidance_category_consumer_protection: 'Consumentenbescherming',
            enum_guidance_category_control_environment: 'Controleomgeving',
            enum_guidance_category_cross_border: 'Grensoverschrijdend',
            enum_guidance_category_cross_border_transfers: 'Grensoverschrijdende overdrachten',
            enum_guidance_category_data_classification: 'Gegevensclassificatie',
            enum_guidance_category_data_localization: 'Gegevenslokalisatie',
            enum_guidance_category_data_protection_impact_assessment: 'Gegevensbeschermingseffectbeoordeling',
            enum_guidance_category_direct_marketing: 'Directe marketing',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Bestuur',
            enum_guidance_category_ict_risk_management: 'ICT-risicobeheer',
            enum_guidance_category_incident_management: 'Incidentbeheer',
            enum_guidance_category_internal_audit: 'Interne audit',
            enum_guidance_category_isms_documentation: 'ISMS-documentatie',
            enum_guidance_category_lawful_basis: 'Wettelijke basis',
            enum_guidance_category_licensing: 'Licentie',
            enum_guidance_category_local_presence: 'Lokale aanwezigheid',
            enum_guidance_category_logging_and_retention: 'Registratie en retentie',
            enum_guidance_category_logical_and_physical_access: 'Logische en fysieke toegang',
            enum_guidance_category_operational_resilience_testing: 'Operationele veerkracht testen',
            enum_guidance_category_outsourcing: 'Uitbesteding',
            enum_guidance_category_platform_registration: 'Platformregistratie',
            enum_guidance_category_quality_of_service: 'Kwaliteit van de dienstverlening',
            enum_guidance_category_risk_classification: 'Risicoclassificatie',
            enum_guidance_category_risk_management: 'Risicobeheer',
            enum_guidance_category_scope_definition: 'Definitie van reikwijdte',
            enum_guidance_category_sectoral_localisation: 'Sectorale lokalisatie',
            enum_guidance_category_subscriber_protection: 'Abonneebescherming',
            enum_guidance_category_supply_chain: 'Toeleveringsketen',
            enum_guidance_category_system_classification: 'Systeemclassificatie',
            enum_guidance_category_system_operations: 'Systeembewerkingen',
            enum_guidance_category_telecommunications_data: 'Telecommunicatiegegevens',
            enum_guidance_category_third_party_risk: 'Risico van derden',
            enum_guidance_category_transitional_provisions: 'Overgangsbepalingen',
            enum_guidance_category_vulnerability_management: 'Kwetsbaarheidsbeheer',
            enum_guidance_status_active: 'Actief',
            enum_guidance_status_draft: 'Diepgang',
            enum_module_access_management: 'Toegangsbeheer',
            enum_module_ai_governance: '[[TOK_0]] Bestuur',
            enum_module_asset_management: 'Vermogensbeheer',
            enum_module_audit_trail: 'Audittraject',
            enum_module_breach_notification: 'Melding van inbreuk',
            enum_module_capital_adequacy: 'Kapitaaltoereikendheid',
            enum_module_classification: 'Classificatie',
            enum_module_consent: 'Toestemming',
            enum_module_consent_management: 'Toestemmingsbeheer',
            enum_module_cross_border_transfers: 'Grensoverschrijdende overdrachten',
            enum_module_data_localization: 'Gegevenslokalisatie',
            enum_module_data_mapping: 'Gegevens in kaart brengen',
            enum_module_data_protection: 'Gegevensbescherming',
            enum_module_data_subject_rights: 'Rechten van betrokkenen',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Encryptie',
            enum_module_governance: 'Bestuur',
            enum_module_incident: 'Voorval',
            enum_module_incident_management: 'Incidentbeheer',
            enum_module_internal_audit: 'Interne audit',
            enum_module_isms_documentation: 'ISMS-documentatie',
            enum_module_isms_governance: 'ISMS-bestuur',
            enum_module_logging_and_monitoring: 'Loggen en monitoren',
            enum_module_monitoring: 'Toezicht',
            enum_module_policy_management: 'Beleidsbeheer',
            enum_module_risk: 'Risico',
            enum_module_risk_management: 'Risicobeheer',
            enum_module_training: 'Opleiding',
            enum_module_vendor: 'Verkoper',
            enum_module_vendor_management: 'Leveranciersbeheer',
            enum_module_vendor_risk: 'Leveranciersrisico',
            enum_module_vulnerability_management: 'Kwetsbaarheidsbeheer',
            category_access: 'Toegang',
            category_availability: 'Beschikbaarheid',
            category_change_management: 'Verandermanagement',
            category_classification: 'Classificatie',
            category_communication_and_information: 'Communicatie & Informatie',
            category_compliance: 'Naleving',
            category_confidentiality: 'Vertrouwelijkheid',
            category_control_activities: 'Controleactiviteiten',
            category_control_environment: 'Controleomgeving',
            category_incident: 'Voorval',
            category_internal_audit: 'Interne audit',
            category_internal_control: 'Interne controle',
            category_logical_and_physical_access: 'Logische en fysieke toegang',
            category_mis_data: 'Managementinformatiesysteemgegevens',
            category_monitoring: 'Toezicht',
            category_monitoring_activities: 'Controleactiviteiten',
            category_outsourcing: 'Uitbesteding',
            category_privacy: 'Privacy',
            category_processing_integrity: 'Verwerkingsintegriteit',
            category_reporting: 'Rapportage',
            category_risk_assessment: 'Risicobeoordeling',
            category_risk_mitigation: 'Risicobeperking',
            category_sector_applicability: 'Sectorale toepasbaarheid',
            category_system_operations: 'Systeembewerkingen',
            category_training: 'Opleiding',
            category_vendor: 'Verkoper',
            guidance_related_forms_advisory: 'Sommige formulieren hebben bijbehorende richtlijnen — bekijk in de',
            guidance_related_procedures_advisory: 'Sommige procedures hebben bijbehorende richtlijnen — bekijk in de',
            guidance_related_requirements_advisory: 'Voor sommige vereisten gelden bijbehorende richtlijnen — bekijk in de',
        },
        channels: {
            title: 'Inzendingskanalen en deadlines',
            channels: 'Inzendingskanalen',
            add_channel: 'Kanaal toevoegen',
            channel_type: 'Typ',
            name: 'Naam',
            instructions: 'Instructies',
            active: 'Actief',
            no_channels: 'Geen inzendingskanalen geconfigureerd',
            portal: 'Portaal',
            in_person: 'Persoonlijk',
            postal: 'Post',
            email: 'E-mail',
            add: 'Toevoegen',
            deadlines: 'Regelgevende deadlines',
            add_deadline: 'Deadline toevoegen',
            label: 'Etiket',
            days: 'Dagen',
            day_type: 'Dagtype',
            calendar_days: 'Kalenderdagen',
            working_days: 'Werkdagen',
            no_deadlines: 'Geen deadlines geconfigureerd',
            description: 'Beschrijving',
            failed_load: 'load channel data mislukt',
            channel_added: 'Kanaal toegevoegd',
            channel_added_announce: 'Inzendingskanaal toegevoegd',
            failed_add_channel: 'add channel mislukt',
            deadline_added: 'Deadline toegevoegd',
            deadline_added_announce: 'Regelgevende deadline toegevoegd',
            failed_add_deadline: 'add deadline mislukt',
        },
        module_links: {
            title: 'Raamwerkkoppeling',
            modules: 'Gekoppelde modules',
            add_module: 'Module toevoegen',
            module_code: 'Modulecode',
            required: 'Vereist',
            link: 'Koppelen',
            no_modules: 'Geen modules gekoppeld',
            notes: 'Notities',
            personas: "Gekoppelde persona's",
            add_persona: 'Persona toevoegen',
            persona_id: 'Persona-ID',
            role_description: 'Rolbeschrijving',
            no_personas: "Geen persona's gekoppeld",
            failed_load: 'load framework links mislukt',
            module_linked: 'Module gekoppeld',
            module_linked_announce: 'Module succesvol gekoppeld',
            failed_link_module: 'link module mislukt',
            persona_linked: 'Persona gekoppeld',
            persona_linked_announce: 'Persona succesvol gekoppeld',
            failed_link_persona: 'link persona mislukt',
        },
        regulatory_updates: {
            statuses: {
                pending: 'In behandeling',
                assessed: 'Beoordeeld',
                applied: 'Toegepast',
                dismissed: 'Afgewezen',
            },
            title: 'Regelgevende updates en raamwerk-dashboard',
            page_description: 'Coverage at a glance for every installed regulatory framework, plus the in-product change log of regulatory updates: amendments, effective dates, and impact assessments. [NL]',
            coverage_dashboard: 'Dashboard raamwerkdekking',
            no_frameworks: 'Geen raamwerken gevonden',
            framework: 'Raamwerk',
            modules: 'Modules',
            templates: 'Sjablonen',
            forms: 'Formulieren',
            channels: 'Kanalen',
            deadlines: 'Deadlines',
            pending: 'Wachtende updates',
            updates: 'Regelgevende updates',
            create_update: 'Update aanmaken',
            framework_id: 'Raamwerk-ID',
            update_title: 'Titel',
            description: 'Beschrijving',
            effective_date: 'Ingangsdatum',
            amendment_ref: 'Amendementreferentie',
            create: 'Aanmaken',
            no_updates: 'Geen regelgevende updates',
            status: 'Status',
            impact: 'Impact',
            change_summary: 'Wijzigingsoverzicht',
            assess: 'Beoordelen',
            failed_load: 'load data mislukt',
            update_created: 'Update aangemaakt',
            update_created_announce: 'Regelgevende update aangemaakt',
            failed_create: 'create update mislukt',
            update_assessed: 'Update beoordeeld',
            failed_assess: 'assess update mislukt',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Banking [NL]',
                insurance: 'Insurance [NL]',
                healthcare: 'Healthcare [NL]',
                ict_critical: 'Critical ICT [NL]',
                telecom: 'Telecommunications [NL]',
                energy: 'Energy [NL]',
                transport: 'Transport [NL]',
                digital_services: 'Digital services [NL]',
                digital_technology_industry: 'Digitale technologie-industrie',
                public_administration: 'Public administration [NL]',
                payments: 'Payments [NL]',
                other: 'Other [NL]',
            },
            sector_label: 'Sector [NL]',
            direct_scope_label: 'Direct legal scope [NL]',
            chip_direct: 'Directly applicable [NL]',
            chip_reference: 'Reference only [NL]',
            banner_direct_copy: 'Directly applicable to your organization. Sector reports and deadlines are active. [NL]',
            banner_reference_copy: 'Reference only — your organization is not classified in this sector. [NL]',
            edit_mode_button: 'Edit mode [NL]',
            edit_form_title: 'Change install mode [NL]',
            mode_direct_label: 'Direct — legally applicable [NL]',
            mode_direct_help: 'Schedules sector deadlines and dashboard widgets. [NL]',
            mode_reference_label: 'Reference only [NL]',
            mode_reference_help: 'Browseable but no deadlines or widgets. [NL]',
            reason_note_label: 'Reason (optional) [NL]',
            reason_note_placeholder: 'e.g. Bank subsidiary acquired [NL]',
            cancel: 'Cancel [NL]',
            confirm: 'Confirm [NL]',
            confirming: 'Saving… [NL]',
            save: 'Save [NL]',
            saving: 'Saving… [NL]',
            toast_mode_changed: 'Sector overlay mode updated. [NL]',
            toast_installed: 'Sector overlay installed. [NL]',
            toast_sectors_saved: 'Sector self-identification saved. [NL]',
            install_modal_title: 'Install sector overlay [NL]',
            install_modal_intro: 'Sector overlays are opt-in regulatory packs scoped to a single industry. [NL]',
            install_modal_footer: 'You can change install mode later from the framework detail page. [NL]',
            install_button: 'Install [NL]',
            installed_label: 'Installed [NL]',
            uninstall_button: 'Verwijderen',
            uninstall_confirm: 'Bevestig het verwijderen',
            uninstall_cancel: 'Annuleer',
            suggested_label: 'Suggested [NL]',
            catalog_page_title: 'Sector overlays [NL]',
            catalog_page_intro: 'Optional regulatory packs scoped to a single industry sector. [NL]',
            catalog_empty_title: 'No sector overlays available [NL]',
            catalog_empty_description: 'Sector overlay packs published in your platform will appear here. [NL]',
            authority_label: 'Authority [NL]',
            org_sectors_title: 'Industry sectors [NL]',
            org_sectors_intro: 'Select the industry sectors your organization operates in. [NL]',
            widget_title: 'Sector overlay reports due [NL]',
            widget_aria_label: 'Sector overlay reports due [NL]',
            widget_empty: 'No upcoming sector overlay deadlines. [NL]',
            audit_event_mode_changed: 'Sector overlay install mode changed [NL]',
            audit_event_installed: 'Sector overlay installed [NL]',
            view_details_button: 'View details → [NL]',
            banner_aria_label: 'Sector overlay status [NL]',
            toast_load_failed: 'Failed to load sector overlays [NL]',
            toast_install_failed: 'Failed to install sector overlay [NL]',
            toast_uninstall_confirm_required: 'Type "{packCode}" to confirm uninstall. [NL]',
            toast_uninstalled: 'Uninstalled {packCode}. [NL]',
            toast_uninstall_failed: 'Failed to uninstall sector overlay [NL]',
            uninstall_warning_destructive_label: 'Destructive action. [NL]',
            uninstall_warning_body: 'Uninstalling will delete the framework record and any persisted regulatory deadlines tied to {frameworkCode} from this organisation. [NL]',
            uninstall_warning_type_to_confirm: 'Type {packCode} to confirm. [NL]',
            uninstall_in_progress: 'Uninstalling… [NL]',
            widget_view_all: 'View all sector overlays → [NL]',
            widget_due_in_days: 'Due in {days}d [NL]',
            widget_overdue_days: 'Overdue by {days}d [NL]',
            widget_due_today: 'Due today [NL]',
            widget_due_unknown: '— [NL]',
        },
        phased_obligations: {
            panel_title: 'Phased obligations [NL]',
            panel_aria_label: 'Phased obligations [NL]',
            panel_intro: 'Some clauses in this framework activate later than the framework itself. [NL]',
            phased_effective_date_label: 'Phased effective: [NL]',
            status_pending: 'Pending [NL]',
            status_active: 'Active [NL]',
            status_early: 'Active (early-implemented) [NL]',
            notice_window_label: 'Authority notice window: [NL]',
            days_label: 'days [NL]',
            recipient_label: 'Recipient: [NL]',
            early_implement_button: 'Mark early-implemented [NL]',
            early_implement_modal_title: 'Mark phased obligation as early-implemented [NL]',
            early_implement_modal_intro: 'Recording an early implementation activates the obligation now and schedules the regulator notice timer. [NL]',
            effective_at_label: 'Effective from [NL]',
            reason_label: 'Reason (optional) [NL]',
            reason_placeholder: 'e.g. Board approved early adoption 2026-09-01 [NL]',
            confirm: 'Confirm [NL]',
            toast_early_implemented: 'Early implementation recorded. [NL]',
            audit_event_early_implemented: 'Phased obligation marked early-implemented [NL]',
            widget_rolling_window_label: 'Phased activations within 90 days [NL]',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Overzicht',
            partner_orgs: 'Partnerorganisaties',
            service_tiers: 'Serviceniveaus',
            deliverable_templates: 'Opleverpuntsjablonen',
            deliverables: 'Opleverpunten',
            brand_profiles: 'Merkprofielen',
            support_tickets: 'Ondersteuningstickets',
            workflow_templates: 'Werkstroomsjablonen',
            workflows: 'Werkstromen',
            escalation: 'Escalatie',
            reports: 'Rapporten',
            audit: 'Controlespoor',
        },
        dashboard: {
            title: 'Partneroverzicht',
            loading: 'Laden van dashboard gegevens...',
            total_managed_tenants: 'Totaal Beheerd Tenants',
            avg_health_score: 'Avg Gezondheid Score',
            open_tickets: 'Open tickets',
            upcoming_deliverables: 'Aanstaand Deliverables',
            escalated_tickets: 'Geëscaleerd Tickets',
            managed_tenants: 'Beheerd Tenants',
            partner_tier: 'Partner Niveau',
            managed_tenants_count: 'Beheerd Tenants Aantal',
            onboarding_date: 'Onboarding Datum',
            view_details: 'Bekijken Details',
            no_partner_orgs: 'Geen partner organisaties gevonden.',
        },
        partner_orgs: {
            title: 'Partnerorganisaties',
            new: 'Nieuw Partner Org',
            contact_name: 'Contact Naam',
            contact_email: 'Contact E-mail',
            partner_tier: 'Partner Niveau',
            managed_orgs: 'Beheerd Orgs',
            onboarding_date: 'Onboarding Datum',
            no_orgs: 'Geen partner organisaties gevonden.',
            contact_phone: 'Contact Telefoon',
            metadata_json: 'Metadata (JSON-indeling)',
            change_status: 'Wijzigen Status',
            new_status: 'Nieuw Status',
            invalid_json_metadata: 'Ongeldig JSON in metadata field',
            suspended: 'Opgeschort',
            offboarded: 'Uitgeschreven',
            all_tiers: 'Alle Niveaus',
            silver: 'Zilver',
            gold: 'Goud',
            platinum: 'Platina',
            status_offboarded: 'Uitgeschreven',
            status_suspended: 'Opgeschort',
            tier_gold: 'Goud',
            tier_platinum: 'Platina',
            tier_silver: 'Zilver',
        },
        service_tiers: {
            title: 'Serviceniveaus',
            new: 'Nieuw Niveau',
            tier_name: 'Niveau Naam',
            monthly_fee: 'Maandelijks Fee',
            features: 'Functies',
            no_tiers: 'Geen service niveaus gevonden.',
            tier_code: 'Niveau Code',
            user_seats: 'Gebruiker Licenties',
            user_seat_limit: 'Gebruiker Licentie Limiet',
            storage_gb: 'Opslag (GB)',
            storage_limit_gb: 'Opslag Limiet (GB)',
            response_time_hrs: 'Reactie Tijd (hrs)',
            resolution_time_hrs: 'Oplossing Tijd (hrs)',
            review_frequency: 'Beoordelen Frequentie',
            sla_response_time: 'SLA Reactie Tijd (hours)',
            sla_resolution_time: 'SLA Oplossing Tijd (hours)',
            module_profile_json: 'Module Profiel (JSON)',
            comparing: 'Vergelijken...',
            compare: 'Vergelijken',
            comparison: 'Service Niveau Vergelijking',
            attribute: 'Attribuut',
            deprecate: 'Afschrijven',
            deprecated: 'Afgeschreven',
            invalid_json_module: 'Ongeldig JSON in module profile field',
            select_compare: 'Selecteren bij least 2 niveaus naar compare',
            comparison_title: 'Service Niveau Vergelijking',
            status_deprecated: 'Afgeschreven',
            activate: 'Activeren',
            invalid_json_module_profile: 'Ongeldig JSON in module profile',
            resolution_time: 'Oplossing Tijd',
            response_time: 'Reactie Tijd',
            select_at_least_two: 'Selecteren bij least 2 niveaus',
        },
        deliverable_templates: {
            title: 'Opleverpuntsjablonen',
            new: 'Nieuw Sjabloon',
            template_name: 'Sjabloon Naam',
            deliverable_type: 'Type deliverable',
            no_templates: 'Geen deliverable sjablonen gevonden.',
            frequency: 'Frequentie',
            est_effort_hrs: 'Est. Inspanning (hrs)',
            estimated_effort: 'Geschat Inspanning (hours)',
            associated_module: 'Gekoppelde module',
            linked_tiers_count: 'Gekoppeld Niveaus Aantal',
            evidence_requirements: 'Bewijs Vereisten (comma-separated)',
            tier_ids: "Niveau ID's (comma-separated)",
            frequency_one_time: 'Eén Tijd',
            frequency_monthly: 'Maandelijks',
            frequency_quarterly: 'Kwartaal',
            frequency_annually: 'Jaarlijks',
            type_report: 'Rapport',
            type_review: 'Beoordelen',
            type_assessment: 'Beoordeling',
            type_meeting: 'Vergadering',
            type_configuration: 'Configuratie',
            freq_one_time: 'Eén Tijd',
            freq_monthly: 'Maandelijks',
            freq_quarterly: 'Kwartaal',
            freq_annually: 'Jaarlijks',
            status_deprecated: 'Afgeschreven',
        },
        deliverables: {
            title: 'Opleverpunten',
            new: 'Nieuw Deliverable',
            partner: 'Zakenpartner',
            deliverable_type: 'Type deliverable',
            due_date: 'Due Datum',
            no_deliverables: 'Geen deliverables gevonden.',
            assigned_to: 'Toegewezen Naar',
            completion_date: 'Voltooiing Datum',
            update_status: 'Bijwerken Status',
            hide_details: 'Verbergen Details',
            view_details: 'Bekijken Details',
            evidence_ids: "Bewijs ID's",
            client_approval: 'Client Goedkeuring',
            bulk_update: 'Bulk Bijwerken',
            bulk_update_status: 'Bulk Bijwerken Status',
            generate_schedule: 'Genereren Plannen',
            generate_deliverable_schedule: 'Genereren Deliverable Plannen',
            organization_id: 'Organisatie ID',
            service_tier_id: 'Service Niveau ID',
            filter_assigned_to: 'Filteren op Toegewezen Naar',
            select_status: 'Selecteren status...',
            new_status: 'Nieuw Status',
            upcoming: 'Aanstaand',
            overdue: 'Te laat',
            status_deferred: 'Uitgesteld',
            status_overdue: 'Te laat',
            status_upcoming: 'Aanstaand',
        },
        brand_profiles: {
            title: 'Merkprofielen',
            new: 'Nieuw Merk Profiel',
            partner: 'Zakenpartner',
            brand_name: 'Merk Naam',
            primary_color: 'Primair Kleur',
            logo_url: 'Logo-adres',
            no_profiles: 'Geen brand profiles gevonden.',
            secondary_color: 'Secundair Kleur',
            header_text: 'Koptekst Text',
            footer_text: 'Voettekst Text',
            contact_email: 'Contact E-mail',
            contact_phone: 'Contact Telefoon',
            contact_website: 'Contactwebsite',
            contact_address: 'Contact Adres',
            is_default: 'Is Standaard',
            set_default: 'Set Standaard',
            preview: 'Voorbeeld',
            report_header_preview: 'Rapport Koptekst Voorbeeld',
            report_footer_preview: 'Rapport Voettekst Voorbeeld',
            preview_description: 'This is een preview van de report header met de geselecteerd brand colors.',
            contact_website_short: 'Webpagina',
            logo_preview: 'Logo-voorbeeld',
        },
        support_tickets: {
            title: 'Ondersteuningstickets',
            new: 'Nieuw Ticket',
            partner: 'Zakenpartner',
            subject: 'Onderwerp',
            assigned_to: 'Toegewezen Naar',
            no_tickets: 'Geen support tickets gevonden.',
            category: 'Categorie',
            priority: 'Prioriteit',
            escalation_tier: 'Escalatie Niveau',
            sla_status: 'SLA-status',
            update_status: 'Bijwerken Status',
            escalate: 'Escaleren',
            add_note: 'Toevoegen Opmerking',
            escalate_ticket: 'Escaleren Ticket',
            escalate_to_tier: 'Escaleren Naar Niveau',
            notes_timeline: 'Opmerkingen Tijdlijn',
            no_notes: 'No opmerkingen yet.',
            attachments: 'Bijlagen',
            no_attachments: 'Geen bijlagen.',
            client_org_id: 'Klantorganisatie-ID',
            content: 'Inhoud',
            note_type: 'Soort',
            view_detail: 'Bekijken Detail',
            hide: 'Verbergen',
            new_status: 'Nieuw Status',
            all_categories: 'Alle Categorieën',
            all_priorities: 'Alle Priorities',
            all_tiers: 'Alle Niveaus',
            ticket_not_found: 'Ticket not gevonden',
            ticket_id: 'Ticket-ID',
            client_org: 'Klantorganisatie',
            deescalate: 'De-escaleren',
            deescalate_ticket: 'Ticket de-escaleren',
            deescalate_to_tier: 'De-escalate Naar Niveau',
            add_attachment: 'Toevoegen Bijlage',
            file: 'Bestand',
            linked_entity: 'Gekoppeld Entiteit',
            sla_target: 'Doel',
            breached: 'Geschonden',
            remaining_hours: 'resterend',
            na: 'N/A',
            tickets_found: 'tickets gevonden',
            reason: 'Reden',
            target: 'Doel',
            upload: 'Uploaden',
        },
        workflow_templates: {
            title: 'Werkstroomsjablonen',
            new: 'Nieuw Sjabloon',
            template_name: 'Sjabloon Naam',
            steps: 'Stappen',
            no_templates: 'Geen workflow sjablonen gevonden.',
            category: 'Categorie',
            view_steps: 'Bekijken Stappen',
            hide_steps: 'Verbergen Stappen',
            step: 'Stap',
            step_title: 'Titel',
            step_description: 'Beschrijving',
            assignee_role: 'Toegewezene Rol',
            sla_hours: 'SLA-uren',
            evidence_required: 'Bewijs Vereist',
            guidance_notes: 'Richtlijn Opmerkingen',
            add_step: 'Toevoegen Stap',
            no_steps: 'Geen stappen gedefinieerd.',
            no_steps_defined: 'Geen stappen gedefinieerd.',
            templates_found: 'sjablonen gevonden',
            all_categories: 'Alle Categorieën',
        },
        workflows: {
            title: 'Workflow Instanties',
            new: 'Nieuw Workflow',
            template: 'Sjabloon',
            partner: 'Zakenpartner',
            current_step: 'Huidig Stap',
            progress: 'Voortgang',
            no_workflows: 'Geen workflow instanties gevonden.',
            instances_found: 'instanties gevonden',
        },
        escalation: {
            title: 'Escalatie Dashboard',
            ticket: 'Melding',
            partner: 'Zakenpartner',
            escalated_at: 'Geëscaleerd At',
            reason: 'Reden',
            no_escalations: 'Geen escalations gevonden.',
            time_in_tier: 'Tijd in Niveau',
            auto_evaluate: 'Auto Evalueren',
            priority_critical: 'Kritiek',
            priority_high: 'Hoog',
            priority_medium: 'Gemiddeld',
            priority_low: 'Low',
            deescalated_from_dashboard: 'De-escalated van dashboard',
            sla_breached: 'SLA Geschonden',
            sla_remaining: 'SLA Resterend',
        },
        reports: {
            title: 'Rapporten',
            partner: 'Zakenpartner',
            report_type: 'Rapport Type',
            generated_at: 'Gegenereerd At',
            no_reports: 'Geen reports gevonden.',
            generate: 'Genereren Rapport',
        },
        audit: {
            title: 'Partner-auditspoor',
            event_type: 'Gebeurtenis Type',
            entity_type: 'Entiteit Type',
            entity_id: 'Entiteit ID',
            actor: 'Betrokkene',
            timestamp: 'Tijdstempel',
            no_events: 'Geen audit gebeurtenissen gevonden.',
            events_found: 'gebeurtenissen gevonden',
            event_type_created: 'Gemaakt',
            event_type_updated: 'Bijgewerkt',
            event_type_deleted: 'Verwijderd',
            event_type_status_change: 'Statuswijziging',
            event_type_escalation: 'Escalatie',
            event_type_assignment: 'Opdracht',
            entity_type_partner_org: 'Partnerorg',
            entity_type_service_tier: 'Servicelaag',
            entity_type_deliverable_template: 'Leverbaar sjabloon',
            entity_type_deliverable_instance: 'Leverbaar exemplaar',
            entity_type_brand_profile: 'Merkprofiel',
            entity_type_support_ticket: 'Ondersteuningsticket',
            entity_type_workflow_template: 'Workflow-sjabloon',
            entity_type_workflow_instance: 'Werkstroominstantie',
            entity_type_generated_report: 'Gegenereerd rapport',
            entity_type_escalation_rule: 'Escalatieregel',
        },
        no_permission_title: 'Onvoldoende machtigingen',
        no_permission_message: 'U heeft geen toestemming voor toegang tot de partnerwerkruimte.',
        status_active: 'Actief',
        status_suspended: 'Opgeschort',
        status_offboarded: 'Buiten boord',
        status_completed: 'Voltooid',
        status_cancelled: 'Geannuleerd',
        status_deprecated: 'Afgekeurd',
        status_new: 'Nieuw',
        status_triaged: 'Triaged',
        status_in_progress: 'In uitvoering',
        status_waiting_on_client: 'Wachten op cliënt',
        status_waiting_on_vendor: 'Wachten op verkoper',
        status_escalated: 'Geëscaleerd',
        status_resolved: 'Opgelost',
        status_closed: 'Gesloten',
        status_pending: 'In behandeling',
        status_skipped: 'Overgeslagen',
        category_onboarding: 'Aan boord',
        category_incident_escalation: 'Incidentescalatie',
        category_config_change: 'Configuratiewijziging',
        category_periodic_review: 'Periodieke beoordeling',
        category_offboarding: 'Offboarden',
        category_custom: 'Aangepast',
        category_configuration: 'Configuratie',
        category_incident: 'Voorval',
        category_compliance_question: 'Nalevingsvraag',
        category_feature_request: 'Functieverzoek',
        category_bug_report: 'Bugrapport',
        priority_critical: 'Kritisch',
        priority_high: 'Hoog',
        priority_medium: 'Middelmatig',
        priority_low: 'Laag',
        tier_silver: 'Zilver',
        tier_gold: 'Goud',
        tier_platinum: 'Platina',
        report_type_compliance_summary: 'Nalevingsoverzicht',
        report_type_risk_overview: 'Risicooverzicht',
        report_type_incident_report: 'Incidentrapport',
        report_type_consent_status: 'Toestemmingsstatus',
        report_type_program_maturity: 'Programma volwassenheid',
        report_type_executive_pack: 'Executive-pakket',
        note_type_internal: 'Intern',
        note_type_client_visible: 'Klant zichtbaar',
        status_updated: 'Status succesvol bijgewerkt',
        deliverable_status_updated: 'De status van het leverbare product is succesvol bijgewerkt',
        ticket_status_updated: 'Ticketstatus is succesvol bijgewerkt',
        ticket_escalated: 'Ticket is succesvol geëscaleerd',
        note_added: 'Opmerking succesvol toegevoegd',
        attachment_uploaded: 'Bijlage succesvol geüpload',
        ticket_deescalated: 'Ticket is gede-escaleerd',
        auto_evaluation_completed: 'Automatische evaluatie voltooid',
        template_created: 'Workflowsjabloon is succesvol aangemaakt',
        template_updated: 'Workflowsjabloon succesvol bijgewerkt',
        brand_set_default: 'Merkprofiel is succesvol als standaard ingesteld',
        brand_created: 'Merkprofiel is succesvol aangemaakt',
        brand_updated: 'Merkprofiel succesvol bijgewerkt',
        tier_created: 'Servicelaag is succesvol gemaakt',
        tier_updated: 'Servicelaag is succesvol bijgewerkt',
        tier_deprecated: 'Servicelaag is beëindigd',
        tier_activated: 'Servicelaag is succesvol geactiveerd',
        period: 'Periode',
        format: 'Formaat',
        period_start: 'Periode begin',
        period_end: 'Einde periode',
        reports_count: '[[TOK_1]] rapporten',
        reports_count_one: '[[TOK_1]] rapport',
        metric: 'Metrisch',
        value: 'Waarde',
        showing_chart_view: 'Grafiekweergave weergeven',
        showing_table_view: 'Gegevenstabelweergave weergeven',
        evidence_ids_placeholder: 'bijv. ev-001, ev-002',
        confirm_cancel_workflow: 'Weet u zeker dat u deze workflow wilt annuleren? Deze actie kan niet ongedaan worden gemaakt.',
        export_csv: 'Exporteer [[TOK_0]]',
        compliance_qualifications_title: 'Kwalificaties van complianceservices',
        compliance_qualifications_desc: 'Het partnerniveau (zilver/goud/platina) bepaalt de reikwijdte van de complianceservice. Gold- en Platinum-partners zijn gekwalificeerd voor opdrachten in de gereguleerde sector. Gebruik het veld Metagegevens om certificeringen (ISO 27001, SOC 2), specialisaties en jurisdictiekwalificaties voor elke partner vast te leggen.',
        regulatory_output_title: 'Regelgevende outputafstemming',
        regulatory_output_desc: 'Elk sjabloontype is toegewezen aan een regelgevende outputcategorie: rapporten produceren nalevingsdocumentatie, beoordelingen valideren de effectiviteit van controles, beoordelingen omvatten risico-evaluaties ([[TOK_0]], kloofanalyse), vergaderingen documenteren governancesessies. Bewijsvereisten definiëren de artefacten waarnaar elk product moet verwijzen om gereed te zijn voor een audit.',
        sla_compliance_title: '[[TOK_0]] Bijhouden voor nalevingslevering',
        sla_compliance_desc: "SLA's voor respons- en oplossingstijd zijn contractueel bindend voor de levering van compliancediensten. Beoordelingsfrequentie bepaalt hoe vaak de nalevingsresultaten van partners worden geëvalueerd. [[TOK_0]] inbreuken op compliance-kritieke tickets leiden tot automatische escalatie en worden geregistreerd in de Partner Audit Trail voor regelgevend bewijs.",
        regulatory_engagement_title: 'Regelgevende betrokkenheidspatronen',
        regulatory_engagement_desc: 'Workflowcategorieën worden toegewezen aan typen toezichtsbetrokkenheid: Onboarding omvat de initiële compliance-instellingen en analyse van hiaten, Periodieke beoordeling behandelt terugkerende compliance-beoordelingen, Incidentescalatie beheert de reactie op inbreuken op de regelgeving, Offboarding zorgt ervoor dat aan de verplichtingen voor het bewaren van gegevens wordt voldaan. Voor elke stap kan het verzamelen van bewijsmateriaal nodig zijn om de audittrail volledig te maken.',
        compliance_escalation_title: 'Compliance-kritische escalatieprocedures',
        compliance_escalation_desc: "L1 behandelt standaard operationele problemen. T2 heeft betrekking op tekortkomingen die gevolgen hebben voor de naleving (gemiste deadlines voor regelgeving, lacunes in de controle). L3 is gereserveerd voor scenario's voor inbreuken op de regelgeving die onmiddellijke aandacht van het management vereisen. [[TOK_0]] inbreuk op L2/L3-tickets genereert automatisch audit trail-invoer. Alle escalatie- en de-escalatieacties worden permanent geregistreerd.",
        audit_regulatory_title: 'Regelgevingsbewijstraject',
        audit_regulatory_desc: 'Dit audittraject biedt fraudebestendige gegevens voor naleving van de regelgeving. Elke partneractie (maken, bijwerken, verwijderen, escalatie, statuswijziging) wordt geregistreerd met de identiteit van de acteur, tijdstempel en volledige payload-verschillen. Gebruik Entiteitstype-filters om bewijsmateriaal te isoleren op nalevingsdomein. Exporteer gefilterde resultaten om auditklare documentatie te produceren voor wettelijke inspecties.',
        evidence_trail_title: 'Moduleoverschrijdend bewijspad',
        evidence_trail_desc: "Elke workflowstap kan bewijs-ID's verzamelen die zijn gekoppeld aan deliverables, auditgebeurtenissen en compliance-artefacten in verschillende modules. Door een stap verder te gaan met bewijs-ID's ontstaat er een verifieerbare keten die de workflows van partners verbindt met wettelijke documentatie. Voltooide workflows met volledige bewijsketens dienen als bewijs van nalevingsbetrokkenheid.",
        evidence_ids_label: "Bewijs-ID's",
    },
    org_groups: {
        title: 'Organisatiegroepen',
        new: 'Aanmaken Groep',
        group_name: 'Groep Naam',
        member_count: 'Lid Aantal',
        root_org: 'Hoofd Org',
        no_groups: 'Geen org groups gevonden.',
        add_organization: 'Organisatie Toevoegen',
        select_organization: 'Selecteer een organisatie...',
        no_available_orgs: 'Geen beschikbare organisaties om toe te voegen.',
        no_members: 'Geen lidorganisaties in deze groep.',
        member_added: 'Organisatie toegevoegd aan groep.',
        member_removed: 'Organisatie verwijderd uit groep.',
        already_in_group: 'Deze organisatie behoort al tot een groep.',
        org_not_found: 'Organisatie niet gevonden.',
        add_member_error: 'Kan organisatie niet toevoegen aan groep.',
        remove_member_error: 'Kan organisatie niet verwijderen uit groep.',
        confirm_remove_member: 'Weet u zeker dat u "{name}" uit deze groep wilt verwijderen?',
        load_error: 'Kan org. groepsdetails niet laden.',
        page_title_list: 'Organisatiegroepen',
        page_title_detail: 'Details van organisatiegroep',
        page_title_create: 'Organisatiegroep maken',
        page_title_settings: 'Organisatiegroepinstellingen',
        page_title_users: 'Groepsgebruikers',
        page_title_reports: 'Groepsrapporten',
        page_title_dashboard: 'Groepsdashboard',
        page_title_audit: 'Groepsaudit',
        page_title_org_audit: 'Organisatiegroepaudit',
        page_title_shared_vendors: 'Gedeelde leveranciers',
        page_title_shared_frameworks: 'Gedeelde raamwerken',
        page_title_shared_forms: 'Gedeelde formuliersjablonen',
        page_title_merged_vendors: 'Samengevoegde leveranciers',
        page_title_settings_inheritance: 'Instellingen Overerving',
        announce_loaded_groups: '[[TOK_1]] organisatiegroepen geladen',
        announce_loaded_group: 'Geladen groep [[TOK_1]]',
        announce_loaded_users: 'Groepsgebruikers van [[TOK_1]] geladen',
        announce_loaded_reports: '[[TOK_1]] rapporten geladen',
        announce_loaded_vendors: '[[TOK_1]] gedeelde leveranciers geladen',
        announce_loaded_frameworks: '[[TOK_1]] gedeelde raamwerken geladen',
        announce_loaded_templates: '[[TOK_1]] gedeelde formuliersjablonen geladen',
        announce_loaded_audit: '[[TOK_1]] auditgebeurtenissen geladen',
        announce_loaded_merged: '[[TOK_2]] gedeelde en [[TOK_3]] lokale leveranciers geladen',
        announce_dashboard_loaded: 'Dashboard geladen.',
        announce_dashboard_refreshed: 'Dashboard vernieuwd.',
        announce_dashboard_refresh_failed: 'Kan het dashboard niet vernieuwen.',
        announce_refreshing: 'Dashboard vernieuwen...',
        announce_settings_loaded: 'Overname van instellingen geladen.',
        announce_settings_saved: 'Instellingen succesvol opgeslagen.',
        announce_saving_settings: 'Instellingen opslaan...',
        announce_error_saving: 'Fout bij opslaan van instellingen.',
        announce_group_dissolved: 'Groep opgelost.',
        announce_creating_group: 'Organisatiegroep maken...',
        announce_group_created: 'Organisatiegroep is succesvol aangemaakt.',
        announce_error_creating: 'Fout bij maken van organisatiegroep.',
        announce_vendor_published: 'Leverancier succesvol gepubliceerd.',
        announce_vendor_retired: 'Verkoper is met pensioen.',
        announce_framework_published: 'Framework met succes gepubliceerd.',
        announce_framework_retired: 'Kader met pensioen.',
        announce_template_published: 'Formuliersjabloon succesvol gepubliceerd.',
        announce_template_retired: 'Formuliersjabloon buiten gebruik gesteld.',
        announce_role_assigned: 'Rol toegewezen.',
        announce_error_assign_role: 'Fout bij het toewijzen van rol.',
        announce_role_revoked: 'Rol is succesvol ingetrokken.',
        announce_report_generating: 'Rapport genereren...',
        announce_report_requested: 'Rapportgeneratie gevraagd.',
        announce_error_report: 'Fout bij het opvragen van rapport.',
        announce_report_deleted: 'Rapport verwijderd.',
        announce_search_applied: 'Zoek toegepast.',
        announce_search_cleared: 'Zoeken gewist.',
        announce_tab_selected: 'Tabblad [[TOK_1]] geselecteerd',
        announce_error_add_member: 'Fout bij toevoegen van lid aan groep.',
        announce_category_reverted: '[[TOK_1]] is teruggekeerd naar overgenomen van ouder.',
        announce_category_overridden: '[[TOK_1]] ingesteld op lokale overschrijving.',
        announce_override_saved: '[[TOK_1]] overschrijven opgeslagen.',
        announce_export_started: 'Controle exporteren als [[TOK_1]]...',
        announce_export_completed: 'Exporteren als [[TOK_1]] voltooid.',
        announce_export_failed: 'Exporteren is mislukt.',
        announce_filter_org: 'Gefilterd op organisatie [[TOK_1]]',
        announce_filter_org_cleared: 'Organisatiefilter gewist',
        announce_filter_event: 'Gefilterd op gebeurtenistype [[TOK_1]]',
        announce_filter_cleared: 'Filter gewist',
        announce_download: '[[TOK_2]] downloaden als [[TOK_3]]',
        error_load_groups: 'Kan organisatiegroepen niet laden. Probeer het opnieuw.',
        error_load_users: 'Kan groepsgebruikers niet laden.',
        error_load_reports: 'Kan groepsrapporten niet laden.',
        error_load_dashboard: 'Kan groepsdashboard niet laden.',
        error_load_settings: 'Kan groepsinstellingen niet laden.',
        error_load_vendors: 'Kan samengevoegde leveranciers niet laden.',
        error_save_settings: 'Kan instellingen niet opslaan.',
        error_dissolve_group: 'Kan groep niet ontbinden.',
        error_assign_role: 'Kan rol niet toewijzen.',
        error_create_group: 'Kan organisatiegroep niet maken. Probeer het opnieuw.',
        error_request_report: 'Kan rapport niet opvragen.',
        error_group_name_required: 'Groepsnaam is vereist.',
        success_settings_saved: 'Instellingen succesvol opgeslagen.',
        confirm_retire_vendor: 'Weet u zeker dat u leverancier "[TOK_1]]" wilt beëindigen?',
        confirm_retire_framework: 'Weet u zeker dat u raamwerk "[TOK_1]]" wilt beëindigen?',
        confirm_retire_template: "Weet u zeker dat u formuliersjabloon '[[TOK_1]]' wilt intrekken?",
        confirm_dissolve_group: "Weet u zeker dat u '[TOK_1]]' wilt ontbinden? Deze actie kan niet ongedaan worden gemaakt.",
        confirm_revoke_role: "Weet u zeker dat u de rol '[TOK_2]]' wilt intrekken van '[[TOK_3]]'?",
        confirm_delete_report: "Weet u zeker dat u het rapport '[TOK_1]]' wilt verwijderen?",
        dissolve_group: 'Groep oplossen',
        dissolve_warning: 'Hierdoor wordt de organisatiegroep definitief ontbonden. Alle aangesloten organisaties worden verwijderd.',
        count_groups: '[[TOK_1]] groep',
        count_groups_plural: '[[TOK_1]] groepen',
        count_users: '[[TOK_1]] gebruiker',
        count_users_plural: '[[TOK_1]] gebruikers met groepsrollen',
        count_events: '[[TOK_1]] evenement',
        count_events_plural: '[[TOK_1]] evenementen',
        count_reports: '[[TOK_1]] rapport',
        count_reports_plural: '[[TOK_1]] rapporten',
        count_vendors: '[[TOK_1]] leverancier gedeeld door de groep',
        count_vendors_plural: '[[TOK_1]] leveranciers gedeeld door de groep',
        count_frameworks: '[[TOK_1]] raamwerk gedeeld door de hele groep',
        count_frameworks_plural: '[[TOK_1]] raamwerken gedeeld door de groep',
        count_templates: '[[TOK_1]] sjabloon gedeeld door de groep',
        count_templates_plural: '[[TOK_1]] sjablonen gedeeld door de groep',
        count_shared_vendors: '[[TOK_1]] gedeelde leveranciers',
        count_local_vendors: '[[TOK_1]] lokale leveranciers',
        merged_combined_view: 'Gecombineerde weergave van [[TOK_2]] gedeelde en [[TOK_3]] lokale leveranciers',
        dashboard: {
            title: 'Groepsoverzicht',
            loading: 'Laden van dashboard gegevens...',
            total_groups: 'Totaal Groepen',
            total_members: 'Totaal Leden',
            active_groups: 'Actief Groepen',
            overall_compliance_score: 'Algemene nalevingsscore',
            group_risk_level: 'Groepsrisiconiveau',
            sla_compliance: '[[TOK_0]] Naleving',
            compliance_posture: 'Nalevingshouding',
            risk_heatmap: 'Risico-hittekaart',
            sla_performance: '[[TOK_0]] Prestaties',
            recent_incidents: 'Recente incidenten',
            recent_activity: 'Recente activiteit',
            refresh_label: 'Vernieuw dashboardgegevens',
            score_good: 'Goed',
            score_needs_attention: 'Heeft aandacht nodig',
            score_critical: 'Kritisch',
            trend_up: 'Trend omhoog',
            trend_down: 'Trend naar beneden',
            trend_stable: 'Stabiel',
            risk_low: 'Low',
            risk_medium: 'Middelmatig',
            risk_high: 'Hoog',
            risk_critical: 'Kritisch',
            risk_unknown: 'Onbekend',
            col_organization: 'Organisatie',
            col_score: 'Scoren',
            col_trend: 'Trend',
            col_open_issues: 'Openstaande problemen',
            col_critical_issues: 'Kritieke problemen',
            col_health: 'Gezondheid',
            col_vendor_risk: 'Leveranciersrisico',
            col_data_risk: 'Gegevensrisico',
            col_compliance_risk: 'Nalevingsrisico',
            col_total_cases: 'Totaal aantal gevallen',
            col_on_time: 'Op tijd',
            col_breached: 'geschonden',
            col_sla_percent: '[[TOK_0]] %',
            col_avg_days: 'Gem. dagen',
            sr_vendor_risk: 'Leveranciersrisicoscore: [[TOK_1]]',
            sr_data_risk: 'Gegevensrisicoscore: [[TOK_1]]',
            sr_compliance_risk: 'Compliancerisicoscore: [[TOK_1]]',
            sr_sla_breaches: 'Waarschuwing: [[TOK_1]] [[TOK_2]] inbreuken',
            sr_severity: 'Ernst: [[TOK_1]]',
        },
        detail: {
            title: 'Groepsdetails',
            members: 'Leden',
            settings: 'Instellingen',
            audit: 'Controle',
            sr_loading: 'Organisatiegroepdetails laden',
            sr_loading_hierarchy: 'Hiërarchie laden',
            member_org: 'leden organisatie',
            root_org_label: 'wortelorganisatie',
        },
        users: {
            title: 'Groepsgebruikers',
            add_user: 'Toevoegen Gebruiker',
            no_users: 'No users in dit groep.',
            role_group_admin: 'Groepsbeheerder',
            role_group_reader: 'Groepslezer',
            sr_loading: 'Groepsgebruikers laden',
        },
        reports: {
            title: 'Groepsrapporten',
            no_reports: 'Geen reports gevonden.',
            generate_report: 'Nieuw rapport genereren',
            report_type_compliance: 'Nalevingsoverzicht',
            report_type_risk: 'Risicooverzicht',
            report_type_sla: '[[TOK_0]] Prestaties',
            report_type_incident: 'Incidentrapport',
            report_type_executive: 'Uitvoerende briefing',
            report_type_board: 'Bestuursrapport',
            status_queued: 'In de wachtrij',
            status_generating: 'Genereren',
            status_completed: 'Voltooid',
            status_failed: 'Mislukt',
            period_start: 'Periode begin',
            period_end: 'Einde periode',
            sr_loading: 'Groepsrapporten laden',
        },
        shared_vendors: {
            title: 'Gedeelde leveranciers',
            no_vendors: 'Geen shared leveranciers gevonden.',
            merged_vendors: 'Samengevoegd Leveranciers',
            publish_form_label: 'Publiceer gedeelde leverancier',
            sr_loading: 'Gedeelde leveranciers laden',
            sr_loading_merged: 'Samengevoegde leveranciers laden',
            local_vendors: 'Lokale verkopers',
            source_shared: 'Gedeeld vanuit groep',
            source_local: 'Lokale verkoper',
            category_technology: 'Technologie',
            category_consulting: 'Advies',
            category_outsourcing: 'Uitbesteding',
            category_cloud: 'Wolk',
            category_data_processing: 'Gegevensverwerking',
            category_other: 'Anders',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Middelmatig',
            risk_tier_high: 'Hoog',
            risk_tier_critical: 'Kritisch',
            compliance_compliant: 'Conform',
            compliance_non_compliant: 'Niet-conform',
            compliance_pending: 'In behandeling',
            compliance_under_review: 'Onder beoordeling',
            status_active: 'Actief',
            status_retired: 'Gepensioneerd',
        },
        shared_frameworks: {
            title: 'Gedeelde kaders',
            no_frameworks: 'Geen shared frameworks gevonden.',
            publish_form_label: 'Publiceer een gedeeld raamwerk',
            sr_loading: 'Gedeelde raamwerken laden',
            status_active: 'Actief',
            status_retired: 'Gepensioneerd',
        },
        shared_forms: {
            title: 'Gedeelde formuliersjablonen',
            no_forms: 'Geen shared formulier sjablonen gevonden.',
            publish_form_label: 'Gedeelde formuliersjabloon publiceren',
            sr_loading: 'Gedeelde formuliersjablonen laden',
            status_active: 'Actief',
            status_retired: 'Gepensioneerd',
        },
        audit: {
            title: 'Groepscontrole',
            consolidated_title: 'Geconsolideerd Audit Trail',
            consolidated_subtitle: 'Cross-organization audit gebeurtenissen voor dit groep',
            audit_log_title: 'Groep Audit Logboek',
            event_type: 'Gebeurtenis Type',
            actor: 'Betrokkene',
            timestamp: 'Tijdstempel',
            source_org: 'Bron Org',
            org: 'Org',
            summary: 'Samenvatting',
            details: 'Bijzonderheden',
            no_events: 'Geen audit gebeurtenissen gevonden.',
            all_events: 'Alle Gebeurtenissen',
            all_orgs: 'Alle Orgs',
            organization: 'Organisatie',
            from: 'Van',
            to: 'To',
            search_events: 'Zoeken gebeurtenissen...',
            clear: 'Wissen',
            events_24h: 'Gebeurtenissen (24h)',
            events_7d: 'Gebeurtenissen (7d)',
            active_orgs: 'Actief Orgs',
            exporting: 'Exporteren...',
            export_csv: 'Exporteren CSV',
            export_json: 'Exporteren JSON',
            back_to_group: 'Back naar Groep',
            back_to_detail: 'Back naar Detail',
            sr_loading: 'Auditgebeurtenissen laden',
            sr_loading_summary: 'Auditsamenvatting laden',
        },
        settings: {
            title: 'Groep Instellingen',
            inheritance: 'Instellingen Inheritance',
            inheritance_subtitle: 'Configureer welke instellingencategorieën van de groep overnemen en welke lokale overschrijvingen gebruiken',
            sla_settings: 'SLA Instellingen',
            calendar_settings: 'Kalender Instellingen',
            notification_settings: 'Melding Instellingen',
            intake_settings: 'Intake Instellingen',
            cmp_integration: 'CMP Integratie',
            overridden: 'Overschreven',
            inheriting: 'Overerving',
            hide_defaults: 'Verbergen Standaardwaarden',
            show_group_defaults: 'Tonen Groep Standaardwaarden',
            group_defaults: 'Groep Standaardwaarden',
            inherit_from_group: 'Overnemen van Groep',
            use_local_override: 'Use Local Overschrijven',
            local_override_json: 'Local Overschrijven (JSON)',
            save_override: 'Opslaan Overschrijven',
            saving: 'Opslaan...',
            sr_loading: 'Overname van instellingen laden',
            sr_loading_settings: 'Groepsinstellingen laden',
            sr_enabled: 'Ingeschakeld',
            sr_disabled: 'Uitgeschakeld',
            sr_override_active: 'Lokale overschrijving actief',
            sr_inherited: 'Geërfd van ouder',
            danger_zone: 'Gevarenzone',
            sharing_options: 'Opties voor delen',
            advanced_options: 'Geavanceerde opties',
        },
        status_active: 'Actief',
        status_dissolved: 'Opgelost',
        status_pending: 'In behandeling',
        status_suspended: 'Opgeschort',
    },
    integrations: {
        nav: {
            webhooks: 'Webhook-koppelingen',
            domains: 'Domeinen',
            export_schedules: "Exportschema's",
            email_log: 'E-maillogboek',
        },
    },
    platform: {
        nav: {
            users: 'Gebruikers',
            roles: 'Rollen',
            profile: 'Mijn profiel',
        },
        security: {
            mfa: 'MFA-instellingen',
            sso: 'SSO-configuratie',
            api_keys: 'API-sleutels',
            service_accounts: 'Serviceaccounts',
            ip_allowlist: 'IP-acceptatielijst',
            delegations: 'Delegaties',
            break_glass: 'Noodtoegang',
            session_settings: 'Sessie-instellingen',
            active_sessions: 'Actieve sessies',
            access_reviews: 'Toegangsbeoordelingen',
            my_reviews: 'Mijn beoordelingen',
            role_analytics: 'Rolanalyses',
            attestation_schedules: "Attestatieschema's",
            sod_rules: 'SoD-regels',
            sod_violations: 'SoD-schendingen',
        },
        module_config: {
            title: 'Moduleconfiguratie',
            subtitle: 'Schakel functiemodules in of uit voor uw organisatie. Uitgeschakelde modules worden verborgen in de navigatie.',
            enabled: 'Ingeschakeld',
            disabled: 'Uitgeschakeld',
            save: 'Configuratie opslaan',
            saving: 'Opslaan...',
            saved: 'Configuratie succesvol opgeslagen',
            nav_label: 'Moduleconfiguratie',
            settings: 'Instellingen',
            webhooks: 'Webhook-koppelingen',
            domains: 'Domeinen',
            export_schedules: "Exportschema's",
            email_log: 'E-maillogboek',
        },
        files_nav: {
            section: 'Bestanden',
            configuration: 'Configuratie',
            browser: 'Bestandsbrowser',
            dashboard: 'Bestandendashboard',
        },
        immutable_audit_trails: {
            nav_group_label: 'Controle en bewijs',
            nav_settings: 'Instellingen',
            nav_status: 'Bewijsstatus',
            nav_integrity_center: 'Integriteit Centrum',
            nav_usage: 'Gebruik en tegoeden',
            settings_title: 'Onveranderlijke audittrails: instellingen',
            settings_subtitle: 'Instellingen per organisatie voor de add-on Onveranderlijke audittrails.',
            settings_banner: 'De invoegtoepassing Onveranderlijke audittrails is niet ingeschakeld voor uw organisatie. Schakel dit hier in om te beginnen met het verankeren van bewijs voor Tier-A- en Tier-B-auditgebeurtenissen.',
            status_title: 'Onveranderlijke audittrails — Bewijsstatus',
            status_subtitle: 'Proefrelaties per gebeurtenis tussen modules.',
            status_banner: 'De invoegtoepassing Onveranderlijke audittrails is niet ingeschakeld voor uw organisatie. Ga naar Instellingen om dit in te schakelen.',
            integrity_center_title: 'Onveranderlijke audittrails — Integrity Center',
            integrity_center_subtitle: 'Verifieer bewijzen en exporteer integriteitspakketten.',
            integrity_center_banner: 'De invoegtoepassing Onveranderlijke audittrails is niet ingeschakeld voor uw organisatie. Ga naar Instellingen om dit in te schakelen voordat u de verificatie uitvoert of Integriteitspakketten exporteert.',
            usage_title: 'Onveranderlijke audittrails: gebruik en credits',
            usage_subtitle: 'Kredietsaldo, pakketaankopen en gebruiksgeschiedenis.',
            usage_banner: 'Schakel onveranderlijke audittrails in Instellingen in om proefcredits te gaan gebruiken.',
            module_tips_placeholder: 'Tips en richtlijnen voor dit oppervlak zijn beschikbaar in het Helpcentrum.',
            column_label: 'Bewijs',
            no_proof_aria: 'Geen bewijs geregistreerd',
            proof_status_receipt_label: 'bewijsstuk {id}',
            in_progress_hint: 'In uitvoering: wordt automatisch bijgewerkt',
            status_pills: {
                pending: 'In behandeling',
                submitted: 'Ingezonden',
                anchored: 'Verankerd',
                confirmed: 'Bevestigd',
                retrying: 'Opnieuw proberen',
                paused_cap: 'Gepauzeerd (limiet)',
                failed: 'Mislukt',
                failed_auth: 'Verificatie mislukt',
            },
            status_tooltips: {
                pending: 'In behandeling — in de wachtrij voor de proefservice. Gaat binnenkort naar Ingediend; geen actie nodig.',
                submitted: 'Ingediend: uw evenement is naar de proefservice gestuurd. Voor batchmodus wacht het om te worden verzegeld en aan de ketting te worden verankerd. Wordt automatisch bijgewerkt; geen actie nodig.',
                anchored: 'Verankerd – de batch is on-chain geschreven en wacht op definitieve bevestiging. Wordt automatisch bijgewerkt; geen actie nodig.',
                confirmed: 'Bevestigd – het bewijs is verankerd in de keten en verifieerbaar.',
                retrying: 'Opnieuw proberen: er is een tijdelijke fout opgetreden. De afstemmingsfunctie probeert het automatisch opnieuw; geen actie nodig.',
                paused_cap: 'Onderbroken: uw maandelijkse proefkredietlimiet is bereikt. Wissel meer tegoeden in of wacht tot de volgende factureringsmaand.',
                failed: 'Mislukt: het verankeren is niet gelukt. De reconciler zal het automatisch opnieuw proberen; neem contact op met de ondersteuning als het probleem zich blijft voordoen.',
                failed_auth: 'Verificatie mislukt: de proefservice heeft onze inloggegevens afgewezen. Controleer de pagina Onveranderlijke audittrails-instellingen.',
            },
            mode_pills: {
                direct: 'Direct',
                batch: 'Partij',
            },
            drawer: {
                title: 'Bewijsdetails',
                close: 'Sluiten',
                section_proof: 'Bewijs',
                section_batch: 'Batch-lidmaatschap',
                status: 'Status',
                proof_reference: 'Bewijsreferentie',
                receipt_id: 'Ontvangst-ID',
                taxonomy_class: 'Taxonomie klasse',
                units_consumed: 'Eenheden verbruikt',
                created_at: 'Gemaakt',
                verification_ref: 'Ketenverificatiereferentie',
                chain: 'Keten',
                tx_hash: 'Tx-hash',
                block_ref: 'Blokref',
                batch_reference: 'Batchreferentie',
                leaf_index: 'Bladindex',
                local_event_hash: 'Hash van lokale evenementen',
                show_inclusion: 'Toon opnamepad',
                hide_inclusion: 'Insluitingspad verbergen',
                privacy_note: 'Payload is gehasht; Er zijn geen persoonlijke gegevens achtergelaten bij ComplianceOne voor dit evenement.',
                verify_now: 'Verifieer nu',
                verify_pending: 'Verificatie wordt uitgevoerd...',
                verify_verified: 'Geverifieerd – lokale + ketencontroles geslaagd.',
                verify_issue_prefix: 'Verificatieprobleem: ',
                verify_failed: 'Verificatiegesprek mislukt.',
                verify_result_prefix: 'Verificatie oordeel: ',
                verify_pending_note: 'Verificatie in behandeling: dit bewijs wacht nog op verankering aan de ketting. Probeer het opnieuw nadat de batch is verzegeld.',
                awaiting_anchor_note: 'Dit bewijs maakt deel uit van een open batch. Verificatie wordt beschikbaar zodra de batch is verzegeld en in de keten is verankerd, doorgaans binnen het geconfigureerde batchvenster van de organisatie. De statusbadge wordt automatisch bijgewerkt.',
                terminal_error_note: 'Dit bewijs slaagde er niet in om te verankeren. De proof-status reconciler zal het automatisch opnieuw proberen; handmatige verificatie hoeft nog niets te controleren.',
            },
            integrity_center: {
                section_run: 'Voer verificatie uit',
                section_progress: 'Voer de voortgang uit',
                section_issues: 'Problemen',
                period_start: 'Begin van de periode',
                period_end: 'Einde periode',
                module_filter: "Modules (door komma's gescheiden, optioneel)",
                modules_placeholder: 'rights_requests, incidenten',
                run_button: 'Voer verificatie uit',
                export_button: 'Integriteitspakket exporteren',
                export_success: 'Integriteitspakket geëxporteerd.',
                export_failed: 'Exporteren is mislukt.',
                empty_disabled: 'Schakel onveranderlijke audittrails in Instellingen in om verificatiepassen uit te voeren.',
                error_period_required: 'Kies een begin- en einddatum.',
                error_start_run: 'Kan het rennen niet starten.',
                processed: 'Verwerkt: [[TOK_2]] van [[TOK_3]]',
                col_verdict: 'Vonnis',
                col_count: 'Tel',
                col_proof_link: 'Bewijslink',
                col_module: 'Module',
                col_event_type: 'Type evenement',
                col_expected: 'Verwachte hasj',
                col_recomputed: 'Opnieuw berekende hasj',
                col_raised_at: 'Opgegroeid bij',
                any_verdict: 'Welk oordeel dan ook',
                no_issues: 'Geen problemen gevonden.',
            },
            settings_page: {
                load_error: 'Kan instellingen niet laden.',
                save: 'Opslaan',
                save_success: 'Instellingen opgeslagen.',
                save_error: 'Opslaan mislukt.',
                discard: 'Wijzigingen negeren',
                read_only_banner: 'U heeft alleen-lezen toegang. Neem contact op met een platformbeheerder om wijzigingen aan te brengen.',
                section_status: 'Status en activering',
                enabled_label: 'Add-on ingeschakeld',
                enabled_help: 'Indien ingeschakeld, wordt elke Tier-A- en Tier-B-auditgebeurtenis gehasht en verankerd.',
                section_scope: 'Reikwijdte',
                scope_self: 'Alleen zichzelf',
                scope_self_and_children: 'Zelf- en kindorganisaties',
                scope_children_only: 'Alleen kinderen (ouder bewijst zijn eigen evenementen niet)',
                section_mode: 'Standaard proefmodus',
                mode_direct: 'Direct (één anker per evenement)',
                mode_batch: 'Batch (Merkle-rootanker per groep)',
                mode_hybrid: 'Hybride (registerstandaard per klasse)',
                batch_window_label: 'Batchvenster (minuten, 1–60)',
                section_taxonomy: 'Taxonomie van beschermde gebeurtenissen',
                taxonomy_help: 'Overschrijvingen per gebeurtenisklasse. Niveau A → directe modus, Niveau B → batchmodus, Uit → niet gecontroleerd.',
                taxonomy_search: 'Zoekoverschrijvingen',
                taxonomy_reset: 'Resetten naar standaardwaarden',
                taxonomy_event_class: 'Evenement klasse',
                taxonomy_override: 'Overschrijven',
                taxonomy_actions: 'Acties',
                taxonomy_clear: 'Duidelijk',
                taxonomy_no_overrides: 'Geen overschrijvingen — met behulp van registerstandaardwaarden.',
                taxonomy_add_class: 'event_class.code',
                taxonomy_add: 'Overschrijving toevoegen',
                section_privacy: 'Privacycontroles',
                privacy_log_actor_ip: 'Acteur-IP loggen',
                privacy_log_user_agent: 'Gebruikersagent registreren',
                privacy_privileged_access_proofing: 'Bewijs van leesbewerkingen met geprivilegieerde toegang (niveau A)',
                privacy_note: 'Wijzigingen zijn alleen prospectief van toepassing.',
                section_caps: 'Caps en limieten',
                cap_label: 'Maandlimiet (eenheden; blanco = onbeperkt)',
                warn_label: 'Waarschuwdrempel (eenheden; moet kleiner zijn dan de limiet)',
                auto_pause_label: 'Pauzeer nieuwe proefdrukken automatisch zodra de limiet is bereikt',
                section_export: 'Toegang exporteren',
                export_help: "Rol-ID's mogen integriteitspakketten exporteren. Door komma's gescheiden; blanco = gebruik de standaardmachtiging IMMUTABLE_AUDIT_TRAILS_EXPORT.",
                section_group: 'Groepsdeelname',
                group_view_intro: 'U bent geconfigureerd als groepsouder. Elke onderliggende organisatie beheert zijn eigen in-/uitschakeling; hun beslissingen tellen mee voor uw facturering volgens de groepsfactureringsregels.',
                group_view_rule_enabled: 'Een kind met ingeschakeld=false wordt weergegeven als "Niet deelnemend". Je ziet de afwezigheid; het kind bestuurt de schakelaar.',
                group_view_rule_billing: 'Het kinderverbruik wordt opgeteld tot uw maandelijkse limiet. Bekijk de pagina Gebruik om de gecombineerde brandsnelheid te controleren.',
                group_view_rule_edit: 'U kunt de instellingen van een kind niet vanaf deze pagina bewerken. Open de onderliggende organisatie rechtstreeks om deze te bewerken.',
                group_view_open_groups: 'Organisatiegroepen openen',
                section_credentials: 'Referenties',
                credential_id: 'Referentie-ID',
                credential_rotated_at: 'Laatst gedraaid',
                rotate_button: 'Referentie roteren',
                rotate_success: 'Referentie geroteerd. Oude inloggegevens geldig voor nog [[TOK_1]] minuten.',
                rotate_failed: 'Rotatie van inloggegevens is mislukt.',
                rotate_modal_title: '[[TOK_0]]-referentie roteren?',
                rotate_modal_body: 'Rotatie geeft een nieuwe identificatie af. De oude inloggegevens blijven geaccepteerd door [[TOK_0]] voor een uitstelperiode van 60 minuten, zodat werknemers aan boord hun huidige taken kunnen afmaken. Na 60 minuten wordt de oude identificatie ingetrokken.',
                rotate_modal_confirm: 'Draai nu',
                tier_a_off_modal_title: 'Controle uitschakelen voor een gebeurtenisklasse?',
                tier_a_off_modal_body: "Door een gebeurtenisklasse op 'Uit' in te stellen, kan de proeftap deze gebeurtenissen niet meer verankeren. Architectuur §6 legt de implicaties van de regelgeving uit: Tier-A-gebeurtenissen zijn relevant voor de toezichthouder; Als u ze uitschakelt, kan dit de verdedigbaarheid van uw audittraject aantasten.",
                tier_a_off_modal_confirm: 'Ik begrijp het, pas overschrijving toe',
                error_warn_lt_cap: 'De waarschuwingsdrempel moet lager zijn dan de maandelijkse limiet.',
                error_window_range: 'Batchvenster moet tussen 1 en 60 minuten liggen.',
                error_run_in_progress: 'Er wordt een verificatierun uitgevoerd; kan de add-on momenteel niet uitschakelen.',
            },
            status_page: {
                filter_status: 'Status',
                filter_mode: 'Bewijsmodus',
                filter_module: 'Module',
                filter_source_collection: 'Bron collectie',
                filter_from_date: 'Van',
                filter_to_date: 'Aan',
                filter_search: 'Zoeken',
                any_status: 'Elke status',
                any_mode: 'Elke modus',
                col_module: 'Module',
                col_event_type: 'Type evenement',
                col_proof_status: 'Status',
                col_proof_mode: 'Modus',
                col_created_at: 'Gemaakt',
                col_units: 'Eenheden',
                empty_disabled: 'De invoegtoepassing Onveranderlijke audittrails is niet ingeschakeld voor uw organisatie. Ga naar Instellingen om dit in te schakelen.',
                empty_enabled_no_rows: 'Er zijn geen bewijslinks die overeenkomen met de huidige filters.',
                export_csv: 'Exporteer [[TOK_0]]',
                export_xlsx: 'Exporteer [[TOK_0]]',
                export_success: 'Exporteren voltooid',
                export_failed: 'Exporteren is mislukt',
            },
            usage_page: {
                section_alerts: 'Meldingen',
                alert_dismiss: 'Negeren',
                alert_dismiss_aria: 'Waarschuwing sluiten [[TOK_1]]',
                alert_dismissed: 'Waarschuwing afgewezen',
                alert_dismiss_failed: 'Het negeren van de waarschuwing is mislukt',
                section_balance: 'Creditsaldo',
                balance_label: 'Beschikbare kredieten',
                balance_hint: 'Resterende eenheden (1 eenheid = 1 beschermde gebeurtenisbestendig).',
                section_current_month: 'Huidige maand',
                consumed_label: 'Verbruikt',
                granted_label: 'Toegegeven',
                refunded_label: 'Terugbetaald',
                net_label: 'Netto',
                section_history: 'Gebruiksgeschiedenis',
                history_kind: 'Soort',
                history_units: 'Eenheden',
                history_balance_after: 'Saldo achteraf',
                history_notes: 'Opmerkingen',
                history_at: 'Wanneer',
                cap_warning_banner: 'U heeft uw waarschuwingsdrempel voor deze factureringsmaand overschreden. Overweeg om extra credits in te wisselen.',
                cap_paused_banner: 'Maandlimiet bereikt. Het indienen van proefdrukken wordt opgeschort tot volgende maand of totdat de limiet wordt verhoogd.',
                section_redeem: 'Kredietpakket inwisselen',
                redeem_purchase_id: 'Factuurnummer',
                redeem_package: 'Pakket',
                redeem_button: 'Inwisselen',
                redeem_pending: 'Inwisselen…',
                redeem_success: 'Tegoeden ingewisseld',
                redeem_failed: 'Inwisselen mislukt',
                redeem_option_template: '[[TOK_4]] — [[TOK_5]] [[TOK_6]] — [[TOK_7]]',
                redeem_option_units: 'eenheden',
                alert_dismissing: 'Afwijzen…',
                alert_kind: {
                    cap_reached: 'Maandlimiet bereikt',
                    low_balance: 'Laag saldo',
                    auth_failure: 'Authenticatie mislukt',
                    merkle_mismatch: 'Merkle-mismatch',
                    batch_terminal_failure: 'Batchterminalfout',
                    direct_terminal_failure: 'Terminalfout voor directe indiening',
                },
                usage_kind: {
                    consume: 'Consumeer',
                    refund: 'Terugbetaling',
                    grant: 'Verleen',
                    adjustment: 'Aanpassing',
                    reservation: 'Reservering',
                },
                package_starter: 'Voorgerecht',
                package_growth: 'Groei',
                package_enterprise: 'Onderneming',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Meer tegoeden kopen',
                    purchase_title: 'Meer tegoeden kopen',
                    purchase_subtitle: 'Kies een pakket. U wordt naar de beveiligde Stripe-afrekenpagina geleid en uw factuur komt per e-mail.',
                    checkout_button: 'Doorgaan naar afrekenen',
                    checkout_pending: 'Afrekenen openen…',
                    cancel_button: 'Annuleren',
                    purchase_error: 'Kan het afrekenen niet starten. Probeer het straks opnieuw.',
                    redeem_subtitle: 'Al betaald? Selecteer het pakket dat u hebt gekocht en voer de factuur-ID uit uw e-mail in om de tegoeden toe te voegen.',
                    error_not_found: 'Er is geen factuur gevonden met dat nummer. Controleer het factuurnummer en probeer het opnieuw.',
                    error_not_paid: 'Deze factuur is nog niet als betaald gemarkeerd.',
                    error_org_mismatch: 'Deze factuur is niet aan uw organisatie uitgereikt.',
                    error_package_mismatch: 'Deze factuur komt niet overeen met het geselecteerde pakket.',
                    error_billing_unavailable: 'Kan de factureringsservice niet bereiken. Probeer het straks opnieuw.',
                },
            },
        },
        files_config: {
            title: 'Bestandenconfiguratie',
            subtitle: 'Configureer bestandsuploadlimieten, bewaarbeleid en overschrijvingen per eigenaartype voor het platformkoppelingsoppervlak.',
            section_global: 'Globale standaardinstellingen',
            section_global_help: 'Deze limieten zijn van toepassing op elk bestand dat wordt geüpload door gebruikers in uw organisatie, tenzij een overschrijving per eigenaartype hieronder deze limieten wijzigt.',
            section_overrides: 'Overschrijvingen per eigenaartype',
            section_overrides_help: 'Overschrijf de algemene limieten voor een specifiek eigenaarstype. Waarden per eigenaartype winnen altijd de globale instelling.',
            max_file_size_label: 'Maximale bestandsgrootte',
            max_file_size_hint: 'Per individuele upload (MiB)',
            max_total_attachments_label: 'Maximaal totaal aantal bijlagen',
            max_total_attachments_hint: 'Door de hele organisatie heen',
            max_total_size_label: 'Maximale totale opslag',
            max_total_size_hint: 'Over de gehele organisatie (MiB)',
            allowed_mime_types_label: 'Toegestane bestandstypen',
            allowed_mime_types_placeholder: 'Selecteer MIME-typen',
            retention_days_label: 'Bewaartermijn (dagen)',
            retention_days_hint: 'Hoe lang bestanden moeten worden bewaard voordat ze in aanmerking komen voor verwijdering. Laat dit veld leeg als er geen bewaarbeleid is.',
            legal_hold_label: 'Juridische wacht',
            legal_hold_hint: 'Indien ingeschakeld, vereist het definitief verwijderen van een bestand van dit eigenaarstype de toestemming om de wettelijke bewaarplicht te overschrijven en de expliciete aanmelding van de operator.',
            save: 'Wijzigingen opslaan',
            saving: 'Opslaan…',
            reset: 'Opnieuw instellen',
            save_success: 'Instellingen opgeslagen',
            save_version_conflict: 'Een andere operator heeft deze instellingen bijgewerkt terwijl u aan het bewerken was. Herlaad om de nieuwste waarden te zien.',
            empty_state_title: 'Standaardplatforminstellingen gebruiken',
            empty_state_body: 'Uw organisatie gebruikt momenteel het standaard bestandsbeleid van het platform. Bewerk een willekeurige waarde hieronder om een ​​overschrijving op organisatieniveau te maken.',
            read_only_banner: 'U heeft alleen-lezen toegang tot de bestandsconfiguratie. Neem contact op met een platformbeheerder om wijzigingen aan te brengen.',
            owner_type_default_badge: 'Standaard',
            owner_type_overridden_badge: 'Overschreven',
            owner_type_label: 'Type eigenaar',
            owner_type_collapse: 'Samenvouwen',
            owner_type_expand: 'Uitbreiden',
            override_save: 'Overschrijven opslaan',
            override_remove: 'Overschrijving verwijderen',
            mime_labels: {
                'application/pdf': '[[TOK_0]]-document',
                'image/png': 'PNG-afbeelding',
                'image/jpeg': 'JPEG-afbeelding',
                'image/jpg': 'JPG-afbeelding',
                'application/msword': 'Word-document (verouderd)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word-document',
                'application/vnd.ms-excel': 'Excel-spreadsheet (verouderd)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel-spreadsheet',
                'text/csv': '[[TOK_0]] bestand',
                'text/plain': 'Platte tekst',
                'message/rfc822': 'E-mailbericht',
            },
        },
        files_browser: {
            title: 'Bestandsbrowser',
            subtitle: 'Zoek, filter en beheer elke bijlage die binnen de organisatie wordt geüpload.',
            filter_owner_type: 'Type eigenaar',
            filter_uploader: 'Geüpload door',
            filter_from: 'Daarna geüpload',
            filter_to: 'Eerder geüpload',
            filter_size_min: 'Minimale grootte (MiB)',
            filter_size_max: 'Maximale grootte (MiB)',
            filter_mime: 'Bestandstype',
            filter_deleted_state: 'Verwijderingsstatus',
            filter_deleted_any: 'Alle bestanden',
            filter_deleted_only: 'Alleen verwijderd',
            filter_deleted_exclude: 'Uitsluiten verwijderd',
            filter_orphaned: 'Alleen wees',
            filter_search_placeholder: 'Bestandsnaam zoeken…',
            filter_apply: 'Pas filters toe',
            filter_clear: 'Filters wissen',
            col_filename: 'Bestandsnaam',
            col_owner_type: 'Type eigenaar',
            col_owner_entity: 'Eigenaar',
            col_uploader: 'Geüpload door',
            col_uploaded_at: 'Geüpload',
            col_size: 'Grootte',
            col_mime: 'Typ',
            col_state: 'Staat',
            col_actions: 'Acties',
            state_active: 'Actief',
            state_deleted: 'Verwijderd',
            state_orphaned: 'Wees',
            action_view_detail: 'Bekijk details',
            action_download: 'Downloaden',
            action_ai_edits: '[[TOK_0]] Bewerkingen',
            action_soft_delete: 'Zacht verwijderen',
            action_restore: 'Herstellen',
            action_hard_delete: 'Moeilijk verwijderen',
            bulk_soft_delete: 'Zacht verwijderen geselecteerd',
            bulk_export_csv: 'Exporteer [[TOK_0]]',
            bulk_select_all: 'Selecteer alles',
            reason_label: 'Reden',
            reason_min_10_chars: 'Reden is vereist (minstens 10 tekens)',
            reason_min_20_chars: 'Reden is vereist (minimaal 20 tekens)',
            legal_hold_override_label: 'Wettelijke bewaarplicht negeren',
            legal_hold_override_warning: 'Dit bestand valt onder wettelijke bewaring. Als u de melding definitief verwijdert, wordt deze met uw reden en overschrijvingsmarkering in de audittrail opgenomen.',
            empty_state_title: 'Er zijn geen bestanden die overeenkomen met uw filters',
            empty_state_body: 'Pas uw filters aan om resultaten te zien, of wis ze om alle bestanden te bekijken.',
            pagination_prev: 'Vorige',
            pagination_next: 'Volgende',
            pagination_page: 'Pagina [[TOK_2]] van [[TOK_3]]',
            pagination_size_label: 'Per pagina',
            pagination_total: 'Totaal: [[TOK_1]]',
            toast_soft_deleted: 'Bestand zacht verwijderd',
            toast_restored: 'Bestand hersteld',
            toast_hard_deleted: 'Bestand permanent verwijderd',
            toast_bulk_deleted: '[[TOK_1]] bestand(en) verwijderd',
            toast_error: 'Operatie mislukt',
            confirm_soft_delete_title: 'Zacht verwijderbestand',
            confirm_restore_title: 'Bestand herstellen',
            confirm_hard_delete_title: 'Bestand definitief verwijderen',
            confirm_bulk_soft_delete_title: 'Zachte verwijdering van geselecteerde bestanden',
            confirm_submit: 'Bevestig',
            confirm_cancel: 'Annuleer',
        },
        files_detail: {
            modal_title: 'Bestandsdetails',
            close: 'Sluiten',
            meta_filename: 'Bestandsnaam',
            meta_size: 'Grootte',
            meta_mime: 'Typ',
            meta_owner_type: 'Type eigenaar',
            meta_owner_entity: 'Eigenaar entiteit',
            meta_uploader: 'Geüpload door',
            meta_uploaded_at: 'Geüpload',
            meta_storage_path: 'Opslagpad',
            meta_deleted_state: 'Verwijderingsstatus',
            audit_section_title: 'Audittrail',
            audit_load_more: 'Laad meer evenementen',
            audit_empty: 'Er zijn geen auditgebeurtenissen geregistreerd voor dit bestand.',
            audit_config_changed: 'Configuratie gewijzigd',
            audit_soft_deleted: 'Zacht verwijderd',
            audit_restored: 'Hersteld',
            audit_hard_deleted: 'Permanent verwijderd',
            audit_downloaded: 'Gedownload',
            audit_quota_breached: 'Poging tot quotaschending',
            action_download: 'Downloaden',
            action_soft_delete: 'Zacht verwijderen',
            action_restore: 'Herstellen',
            action_hard_delete: 'Moeilijk verwijderen',
            effective_settings_title: 'Effectief beleid',
            effective_max_file_size: 'Maximale bestandsgrootte',
            effective_retention_days: 'Retentie',
            effective_legal_hold: 'Juridische wacht',
            effective_legal_hold_yes: 'Actief',
            effective_legal_hold_no: 'Geen',
        },
        files_dashboard: {
            title: 'Bestandendashboard',
            subtitle: 'Opslaggebruik, groei en zwevende bestanden in de hele organisatie.',
            kpi_total_files: 'Totaal bestanden',
            kpi_total_size: 'Totale opslag',
            kpi_near_quota: 'Quotumgebruik',
            kpi_orphaned: 'Verweesde bestanden',
            chart_by_owner_type: 'Bestanden op type eigenaar',
            chart_growth_30d: '30 dagen groei',
            toggle_count: 'Op telling',
            toggle_size: 'Op maat',
            orphaned_panel_title: 'Weesbestanden (top 20)',
            orphaned_view_all: 'Bekijk alle weesbestanden',
            orphaned_empty: 'Geen weesbestanden gevonden.',
            growth_empty: 'Geen uploadactiviteit in de afgelopen 30 dagen.',
            retention_n_days: '[[TOK_1]] dag(en)',
            retention_none: 'Geen beleid',
        },
    },
    category_labels: {
        'user-guide': 'Gebruikershandleiding',
        'admin-guide': 'Beheerdersgids',
        'getting-started': 'Aan de slag',
        faq: 'Veelgestelde vragen',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Toetsen',
        webhook: 'Webhook',
        webhooks: 'Webhaken',
        admin: 'Beheerder',
        aesirx: 'AesirX',
        purposes: 'Doeleinden',
        preferences: 'Voorkeuren',
        onboarding: 'Aan boord',
        'first-steps': 'Eerste stappen',
        login: 'Inloggen',
        navigation: 'Navigatie',
        users: 'Gebruikers',
        user: 'Gebruiker',
        roles: 'Rollen',
        role: 'Rol',
        'access-control': 'Toegangscontrole',
        'access-management': 'Toegangsbeheer',
        permissions: 'Machtigingen',
        permission: 'Toestemming',
        consent: 'Toestemming',
        'consent-management': 'Toestemmingsbeheer',
        privacy: 'Privacy',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Controle',
        auditing: 'Controle',
        breach: 'Schending',
        incident: 'Voorval',
        incidents: 'Incidenten',
        notification: 'Kennisgeving',
        notifications: 'Meldingen',
        reporting: 'Rapportage',
        risk: 'Risico',
        vendor: 'Verkoper',
        vendors: 'Verkopers',
        'vendor-risk': 'Leveranciersrisico',
        assessment: 'Beoordeling',
        assessments: 'Beoordelingen',
        dpia: 'DPIA',
        'cross-border': 'Grensoverschrijdend',
        transfer: 'Overdracht',
        transfers: 'Overdrachten',
        deletion: 'Verwijdering',
        retention: 'Retentie',
        'data-mapping': 'Gegevens in kaart brengen',
        discovery: 'Ontdekking',
        classification: 'Classificatie',
        workflow: 'Werkstroom',
        workflows: 'Werkstromen',
        template: 'Sjabloon',
        templates: 'Sjablonen',
        catalog: 'Catalogus',
        monitoring: 'Toezicht',
        tasks: 'Taken',
        task: 'Taak',
        'task-management': 'Taakbeheer',
        organizations: 'Organisaties',
        org: 'Organisatie',
        governance: 'Bestuur',
        compliance: 'Naleving',
        forms: 'Formulieren',
        form: 'Vorm',
        connectors: 'Connectoren',
        connector: 'Connector',
        integration: 'Integratie',
        integrations: 'Integraties',
        security: 'Beveiliging',
        encryption: 'Encryptie',
        backup: 'Back-up',
        recovery: 'Herstel',
        maintenance: 'Onderhoud',
        settings: 'Instellingen',
        configuration: 'Configuratie',
        sla: 'SLA',
        escalation: 'Escalatie',
        remediation: 'Sanering',
        evidence: 'Bewijs',
        'case-management': 'Casebeheer',
        profile: 'Profiel',
        delegation: 'delegatie',
        'service-accounts': 'Serviceaccounts',
        license: 'Licentie',
        'license-management': 'Licentiebeheer',
        plan: 'Plannen',
        plans: 'Plannen',
        dashboard: 'Dashboard',
        'web-consent': 'Webtoestemming',
        'partner-marketplace': 'Partnermarktplaats',
        partner: 'Partner',
        partners: 'Partners',
        deliverables: 'Leveringen',
        'service-tiers': 'Serviceniveaus',
        'support-tickets': 'Ondersteuningstickets',
        'audit-trail': 'Audittraject',
        'first-time-setup': 'Eerste installatie',
        setup: 'Installatie',
        quickstart: 'Snel beginnen',
        tour: 'Rondleiding',
        tours: 'Rondleidingen',
        'sample-data': 'Voorbeeldgegevens',
        'data-subject': 'Betrokkene',
        'data-subjects': 'Betrokkenen',
        pseudonymous: 'Pseudoniem',
        identified: 'Geïdentificeerd',
        'help-center': 'Helpcentrum',
        article: 'Artikel',
        articles: 'Artikelen',
        search: 'Zoeken',
        'platform-settings': 'Platforminstellingen',
        'platform-config': 'Platformconfiguratie',
        'module-config': 'Moduleconfiguratie',
        'module-configuration': 'Moduleconfiguratie',
        'rights-requests': 'Rechtenverzoeken',
        'access-accountability': 'Toegang tot verantwoording',
        'data-discovery': 'Gegevens ontdekken',
        'incident-ops': 'Incidentoperaties',
        'deletion-orchestration': 'Verwijderingsorkestratie',
        'compliance-forms': 'Nalevingsformulieren',
        'program-governance': 'Programmabeheer',
        localization: 'Lokalisatie',
        'privacy-scanner': 'Privacyscanner',
        'consent-properties': 'Toestemmingseigenschappen',
        acceptances: 'Acceptaties',
        access: 'Toegang',
        'access-review': 'Toegang tot beoordeling',
        'access-reviews': 'Toegang tot beoordelingen',
        accountability: 'Verantwoording',
        acknowledgment: 'Erkenning',
        'action-plans': 'Actieplannen',
        activation: 'Activering',
        activations: 'Activeringen',
        'active-response': 'Actieve reactie',
        activity: 'Activiteit',
        adequacy: 'Geschiktheid',
        'admin-guide': 'Beheerdersgids',
        aggregation: 'Aggregatie',
        agreements: 'Overeenkomsten',
        ai: 'AI',
        alerts: 'Waarschuwingen',
        analytics: 'Analyse',
        anchoring: 'Verankering',
        approval: 'Goedkeuring',
        approvals: 'Goedkeuringen',
        apps: 'Apps',
        assets: 'Activa',
        assignments: 'Opdrachten',
        attestation: 'Attest',
        'audit-log': 'Auditlogboek',
        'audit-pack': 'Auditpakket',
        authentication: 'Authenticatie',
        authority: 'Autoriteit',
        'auto-play': 'Automatisch afspelen',
        automated: 'Geautomatiseerd',
        automation: 'Automatisering',
        baseline: 'Basislijn',
        batches: 'Batches',
        bidirectional: 'Bidirectioneel',
        bilingual: 'Tweetalig',
        bindings: 'Bindingen',
        blockchain: 'Blockchain',
        board: 'Bord',
        brand: 'Merk',
        brds: "BRD's",
        'break-glass': 'Breekglas',
        builder: 'Bouwer',
        bulk: 'Bulk',
        'bulk-sync': 'Bulksynchronisatie',
        bundles: 'Bundels',
        calendar: 'Kalender',
        campaigns: 'Campagnes',
        cases: 'Gevallen',
        categories: 'Categorieën',
        category: 'Categorie',
        certification: 'Certificering',
        chain: 'Keten',
        change: 'Verandering',
        'change-awareness': 'Verander bewustzijn',
        'change-log': 'Wijzigingslogboek',
        'change-management': 'Verandermanagement',
        'change-requests': 'Wijzigingsverzoeken',
        'cmp-validation': '[[TOK_0]] Validatie',
        collection: 'Collectie',
        comparison: 'Vergelijking',
        completeness: 'Volledigheid',
        completion: 'Voltooiing',
        'compliance-posture': 'Nalevingshouding',
        'compliance-proof': 'Nalevingsbewijs',
        'compliance-reviews': 'Nalevingsbeoordelingen',
        config: 'Configuratie',
        confirmation: 'Bevestiging',
        conflicts: 'Conflicten',
        consolidation: 'Consolidatie',
        continuous: 'Continu',
        contracts: 'Contracten',
        controls: 'Controles',
        cookies: 'Koekjes',
        cooperation: 'Samenwerking',
        coordination: 'Coördinatie',
        'corporate-governance': 'Corporate governance',
        'corrective-actions': 'Corrigerende acties',
        coverage: 'Dekking',
        'credential-vault': 'Referentiekluis',
        credentials: 'Referenties',
        cycles: 'Cycli',
        dashboards: 'Dashboards',
        'data-assets': 'Gegevensactiva',
        'data-flows': 'Gegevensstromen',
        'data-sensitivity': 'Gegevensgevoeligheid',
        'data-steward': 'Gegevensbeheerder',
        deadlines: 'Deadlines',
        'decree-356': 'Decreet 356',
        dedup: 'Ontdubbelen',
        definitions: 'Definities',
        deliverable: 'Leverbaar',
        departments: 'Afdelingen',
        'dependency-order': 'Afhankelijkheidsorde',
        deployment: 'Implementatie',
        detection: 'Detectie',
        diff: 'Verschil',
        'digital-properties': 'Digitale eigendommen',
        dimensions: 'Afmetingen',
        disable: 'Uitschakelen',
        'disaster-recovery': 'Herstel na een ramp',
        disclosure: 'Openbaarmaking',
        documentation: 'Documentatie',
        documents: 'Documenten',
        domains: 'Domeinen',
        dossier: 'Dossier',
        dpa: 'DPA',
        drift: 'Afdrijven',
        'drift-detection': 'Driftdetectie',
        'due-diligence': 'Due diligence',
        email: 'Email',
        emergency: 'Noodsituatie',
        enable: 'Inschakelen',
        'enterprise-map': 'Enterprise-kaart',
        erasure: 'Wissen',
        evaluation: 'Evaluatie',
        'event-bus': 'Evenementenbus',
        exceptions: 'Uitzonderingen',
        execution: 'Uitvoering',
        executive: 'Uitvoerend',
        exercises: 'Oefeningen',
        export: 'Exporteren',
        exports: 'Exporteert',
        filing: 'Indienen',
        filter: 'Filteren',
        filtering: 'Filteren',
        findings: 'Bevindingen',
        flows: 'Stromen',
        'follow-up': 'Vervolg',
        forensic: 'Forensisch',
        forensics: 'Forensisch onderzoek',
        'form-filler': 'Formuliervuller',
        framework: 'Kader',
        frameworks: 'Kaders',
        'gap-analysis': 'Gap-analyse',
        'gap-report': 'Gap-rapport',
        gaps: 'Hiaten',
        gates: 'Poorten',
        'getting-started': 'Aan de slag',
        'golden-templates': 'Gouden sjablonen',
        grc: 'GRC',
        'group-management': 'Groepsbeheer',
        groups: 'Groepen',
        'guided-tours': 'Rondleidingen',
        guides: 'Gidsen',
        handling: 'Behandeling',
        'hands-on': 'Hands-on',
        health: 'Gezondheid',
        help: 'Hulp',
        hierarchy: 'Hiërarchie',
        history: 'Geschiedenis',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Identiteitsprovider',
        implementation: 'Implementatie',
        import: 'Importeren',
        improvement: 'Verbetering',
        'incident-response': 'Reactie op incidenten',
        inconsistencies: 'Inconsistenties',
        instances: 'Instanties',
        intake: 'Inname',
        'intake-key': 'Innamesleutel',
        interactive: 'Interactief',
        international: 'Internationaal',
        inventory: 'Inventaris',
        investigation: 'Onderzoek',
        investigations: 'Onderzoeken',
        'ip-allowlist': 'Toegestane IP-lijst',
        issues: 'Problemen',
        justification: 'Rechtvaardiging',
        justifications: 'Rechtvaardigingen',
        kanban: 'Kanban',
        keyboard: 'Toetsenbord',
        keys: 'Sleutels',
        'knowledge-base': 'Kennisbank',
        koncernstyring: 'Corporate governance',
        kpi: 'KPI',
        labeling: 'Etikettering',
        language: 'Taal',
        'language-packs': 'Taalpakketten',
        languages: 'Talen',
        lawfulness: 'Rechtmatigheid',
        layout: 'Indeling',
        'legal-basis': 'Wettelijke basis',
        'lessons-learned': 'Geleerde lessen',
        levels: 'Niveaus',
        library: 'Bibliotheek',
        lifecycle: 'Levenscyclus',
        lineage: 'Afstamming',
        links: 'Koppelingen',
        listings: 'Advertenties',
        live: 'Leef',
        locale: 'Lokaal',
        log: 'Log',
        logging: 'Loggen',
        'managed-service': 'Beheerde dienst',
        mapping: 'In kaart brengen',
        mappings: 'Toewijzingen',
        'market-packs': 'Marktpakketten',
        marketplace: 'Marktplaats',
        maturity: 'Volwassenheid',
        metrics: 'Statistieken',
        models: 'Modellen',
        module: 'Module',
        modules: 'Modules',
        mps: 'MPS',
        'multi-factor': 'Multi-factor',
        'multi-market': 'Multi-markt',
        'multi-org': 'Multi-Org',
        'multi-property': 'Meerdere eigendommen',
        'my-tasks': 'Mijn taken',
        obligations: 'Verplichtingen',
        offboarding: 'Offboarden',
        oidc: 'OIDC',
        orchestration: 'Orkestratie',
        'org-groups': 'Organisatiegroepen',
        organization: 'Organisatie',
        overdue: 'Te laat',
        overview: 'Overzicht',
        'owner-review': 'Eigenaar beoordeling',
        package: 'Pakket',
        packages: 'Pakketten',
        packs: 'Pakken',
        pagination: 'Paginering',
        'parent-child': 'Ouder-kind',
        patterns: 'Patronen',
        performance: 'Prestaties',
        periodic: 'Periodiek',
        periods: 'Perioden',
        personal: 'Persoonlijk',
        'personal-data': 'Persoonlijke gegevens',
        personas: "Persona's",
        planning: 'Plannen',
        platform: 'Platform',
        playbooks: 'Speelboeken',
        poc: 'PoC',
        'point-in-time': 'Punt-in-tijd',
        policies: 'Beleid',
        portfolio: 'Portefeuille',
        'post-incident': 'Post-incident',
        'power-user': 'Hoofdgebruiker',
        practice: 'Oefen',
        pricing: 'Prijzen',
        'privacy-impact': 'Privacy-impact',
        procedures: 'Procedures',
        processes: 'Processen',
        processing: 'Verwerking',
        'processing-activities': 'Verwerkingsactiviteiten',
        procurement: 'Inkoop',
        productivity: 'Productiviteit',
        profiles: 'Profielen',
        programs: "Programma's",
        progress: 'Vooruitgang',
        proof: 'Bewijs',
        propagation: 'Voortplanting',
        properties: 'Eigenschappen',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Publieke vorm',
        quality: 'Kwaliteit',
        questionnaires: 'Vragenlijsten',
        'quick-links': 'Snelle koppelingen',
        'quick-start': 'Snel beginnen',
        'quick-starts': 'Snelle start',
        raci: 'RACI',
        readiness: 'Bereidheid',
        'real-time': 'Realtime',
        reassessments: 'Herbeoordelingen',
        reconciliation: 'Verzoening',
        record: 'Opnemen',
        records: 'Opnames',
        recurring: 'Terugkerend',
        register: 'Registreren',
        registry: 'Register',
        regulations: 'Regelgeving',
        regulator: 'Regelaar',
        regulatory: 'Regelgevend',
        'regulatory-frameworks': 'Regelgevende kaders',
        remap: 'Opnieuw toewijzen',
        reminders: 'Herinneringen',
        reports: 'Rapporten',
        requests: 'Verzoeken',
        requirements: 'Vereisten',
        response: 'Reactie',
        'response-plans': 'Reactieplannen',
        'response-team': 'Reactieteam',
        'response-templates': 'Antwoordsjablonen',
        'response-time': 'Reactietijd',
        responses: 'Reacties',
        responsibility: 'Verantwoordelijkheid',
        results: 'Resultaten',
        review: 'Beoordeling',
        reviews: 'Recensies',
        'right-to-delete': 'Recht om te verwijderen',
        rights: 'Rechten',
        'risk-tiers': 'Risiconiveaus',
        rollouts: 'Uitrol',
        rollup: 'Samenvouwen',
        ropa: 'ROPA',
        routing: 'Routering',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Regels',
        runs: 'Loopt',
        saml: 'SAML',
        scan: 'Scannen',
        scanning: 'Scannen',
        scc: 'SCC',
        schedule: 'Schema',
        scheduled: 'Gepland',
        schedules: "Schema's",
        scheduling: 'Planning',
        scores: 'Scores',
        scoring: 'Scoren',
        scripts: 'Scripts',
        'security-reviews': 'Beveiligingsrecensies',
        'sensitive-data': 'Gevoelige gegevens',
        sensitivity: 'Gevoeligheid',
        'separation-of-duties': 'Scheiding van taken',
        service: 'Dienst',
        sessions: 'Sessies',
        'setup-wizard': 'Installatiewizard',
        severity: 'Ernst',
        'shared-governance': 'Gedeeld bestuur',
        'shared-settings': 'Gedeelde instellingen',
        shortcuts: 'Snelkoppelingen',
        sidebar: 'Zijbalk',
        signals: 'Signalen',
        'single-sign-on': 'Eenmalige aanmelding',
        snapshots: 'Momentopnamen',
        sod: 'SoD',
        sorting: 'Sorteren',
        sources: 'Bronnen',
        staging: 'Staging',
        standards: 'Normen',
        status: 'Status',
        structure: 'Structuur',
        'sub-processor': 'Subverwerker',
        'sub-processors': 'Subverwerkers',
        submissions: 'Inzendingen',
        subprocessors: 'Subverwerkers',
        subscription: 'Abonnement',
        suggestions: 'Suggesties',
        summaries: 'Samenvattingen',
        supplements: 'Supplementen',
        support: 'Ondersteuning',
        sync: 'Synchroniseren',
        system: 'Systeem',
        systems: 'Systemen',
        tables: 'Tafels',
        tagging: 'Labelen',
        'tamper-proof': 'Fraudebestendig',
        taxonomies: 'Taxonomieën',
        taxonomy: 'Taxonomie',
        tenants: 'Huurders',
        termination: 'Beëindiging',
        'third-party': 'Derde partij',
        'ticket-sync': 'Ticketsynchronisatie',
        tickets: 'Kaartjes',
        tiers: 'Niveaus',
        tokens: 'Tokens',
        totp: 'TOTP',
        traceability: 'Traceerbaarheid',
        tracking: 'Volgen',
        trail: 'Parcours',
        training: 'Opleiding',
        translation: 'Vertaling',
        translations: 'Vertalingen',
        transparency: 'Transparantie',
        trends: 'Trends',
        unified: 'Verenigd',
        updates: 'Updates',
        validation: 'Validatie',
        vault: 'Kluis',
        'vendor-requests': 'Leveranciersverzoeken',
        verification: 'Verificatie',
        versioning: 'Versiebeheer',
        versions: 'Versies',
        vietnam: 'Vietnam',
        violations: 'Overtredingen',
        visualization: 'Visualisatie',
        waivers: 'Ontheffingen',
        'web-records': 'Webrecords',
        website: 'Website',
        websites: 'Websites',
        weights: 'Gewichten',
        'white-label': 'White-label',
        withdrawal: 'Intrekking',
    },
    module_labels: {
        rights_requests: 'Verzoeken om rechten',
        data_mapping: 'Gegevensinventarisatie',
        governance: 'Leveranciersgovernance',
        consent: 'Toestemmingsgovernance',
        consent_properties: 'Toestemmingseigenschappen',
        assessments: 'GEB & beoordelingen',
        classification: 'Gegevensclassificatie',
        monitoring: "Monitoringprogramma's",
        program: 'Monitoringprogramma',
        incidents: 'Incidentrespons',
        connectors: 'Connectoren',
        vendor_risk: 'Leveranciersrisico',
        deletion_orchestration: 'Verwijderingsorkestratie',
        discovery: 'Gegevensontdekking',
        incident_ops: 'Incidentoperaties',
        program_governance: 'Programmabestuur',
        access_accountability: 'Toegangsverantwoording',
        localization: 'Lokalisatie',
        partner_workspace: 'Partnerwerkruimte',
        privacy_scanner: 'Privacyscanner',
        onboarding: 'Aan boord',
        compliance_forms: 'Nalevingsformulieren',
        audit_trail: 'Audittrail',
        data_subjects: 'Betrokkenen',
        organizations: 'Organisaties',
        task_management: 'Taakbeheer',
        deletion_orch: 'Verwijderingsorkestratie',
        forms: 'Nalevingsformulieren',
        partner_marketplace: 'Partnermarktplaats',
        dashboard: 'Dashboard',
        platform_settings: 'Platforminstellingen',
        help_center: 'Helpcentrum',
    },
    module_descriptions: {
        rights_requests: 'Beheer verzoeken van betrokkenen om hun rechten uit te oefenen, waaronder inzage, verwijdering en overdraagbaarheid. Volg de levenscyclus van verzoeken, wijs behandelaars toe en haal wettelijke termijnen.',
        data_mapping: 'Breng gegevensstromen in kaart binnen uw organisatie. Volg verwerkingsactiviteiten, gegevenscategorieën, doeleinden, bewaartermijnen en systeemintegraties.',
        governance: 'Beheer leverancierscompliance en governance. Volg leveranciersbeoordelingen, contracten, SLA-prestaties en wettelijke verplichtingen.',
        consent: 'Beheer het verzamelen, opslaan en intrekken van toestemming. Volg toestemmingsregistraties, doeleinden en integratie met toestemmingsbeheerplatformen.',
        consent_properties: 'Configureer toestemmingseigenschappen, groepen en gouden sjablonen. Definieer herbruikbare toestemmingsconfiguraties voor consistente uitrol.',
        assessments: "Voer gegevensbeschermingseffectbeoordelingen (GEB) en privacyrisico-beoordelingen uit. Evalueer verwerkingsactiviteiten op nalevingsrisico's.",
        classification: 'Classificeer gegevensactiva op gevoeligheidsniveau. Pas taxonomielabels toe, volg levenscyclusrecords en identificeer classificatielacunes.',
        monitoring: "Stel monitoringprogramma's in om nalevingsmetrieken, belangrijke risico-indicatoren en de effectiviteit van controles in de loop der tijd te volgen.",
        incidents: 'Meld en beheer privacyincidenten en datalekken. Volg onderzoeks-, meldings- en herstelworkflows.',
        connectors: 'Configureer gegevensbronconnectoren en integraties. Verbind externe systemen voor geautomatiseerde gegevensontdekking en monitoring.',
        vendor_risk: "Beoordeel en bewaak risico's van externe leveranciers. Scoor leveranciers, volg risicobeperking en beheer configuraties voor leveranciersrisico.",
        deletion_orchestration: 'Orkestreer gegevensverwijdering over systemen heen. Volg verwijderingsverzoeken, verifieer bewijsketens en waarborg volledige gegevensverwijdering.',
        discovery: 'Ontdek persoonsgegevens in verbonden systemen. Scan gegevensbronnen om een uitgebreide gegevensinventaris op te bouwen.',
        incident_ops: 'Operationeel incidentbeheer met draaiboeken, escalatieworkflows en SLA-tracking voor incidentoplossing.',
        program_governance: 'Volg de algehele volwassenheid van het privacyprogramma, nalevingsscores, bewijslacunes en directierapportage binnen uw organisatie.',
        access_accountability: 'Onderzoek en controleer gebruikerstoegangspatronen. Volg toegangsconfiguraties, monitor verdachte activiteit en handhaaf verantwoordingsplicht.',
        localization: 'Installeer en beheer marktlokalisatiepakketten. Voeg regelgevende kaders, taalpakketten en regiospecifieke nalevingsinhoud toe.',
        partner_workspace: 'Werk samen met externe partners. Deel nalevingsgegevens, volg partnerverplichtingen en beheer partnerrelaties.',
        privacy_scanner: 'Scan websites op privacynalevingsproblemen. Monitor cookiegebruik, trackingscripts en de aanwezigheid van privacybeleid in realtime.',
        onboarding: 'Begeleid nieuwe organisaties bij het instellen van het platform. Stapsgewijze onboarding-wizard voor initiële configuratie en gegevensimport.',
        compliance_forms: 'Maak en beheer nalevingsformulieren vanuit een sjablonencatalogus. Vul regelgevende formulieren in, volg inzendingen en genereer rapporten.',
        audit_trail: 'Bekijk een volledig auditspoor van alle systeemacties. Volg wie wat deed, wanneer en waar in alle modules.',
        organizations: 'Beheer organisaties en multi-tenantinstellingen. Configureer organisatieprofielen, hiërarchieën en relaties tussen organisaties.',
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Anomalieën uitleggen',
            explaining: 'Uitleggen…',
            results_heading: 'Verklaringen voor afwijkingen ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            items_label: '[[TOK_1]] artikelen',
            remediation_label: 'Saneringsstappen',
            items_detail_label: 'Betrokken artikelen',
            accept_label: 'Accepteer uitleg',
            reject_label: 'Verklaring afwijzen',
            error_generic: 'Kon de afwijkingen niet verklaren. Probeer het opnieuw of controleer of de scan succesvol is voltooid.',
        },
        cookie_insight: {
            insight_label: 'Cookie & tracker [[TOK_0]] inzicht',
            producing: 'Inzicht genereren…',
            results_heading: 'Cookie- en trackerinzicht ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            items_label: '[[TOK_1]] artikelen',
            classification_label: 'Classificatie',
            severity_label: 'Ernst',
            banner_copy_label: 'Voorgestelde bannerkopie',
            retention_label: 'Bewaaradvies',
            citations_label: 'Citaties',
            kind_cookie: 'Koekje',
            kind_tracker: 'Volger',
            class_necessary: 'Noodzakelijk',
            class_analytics: 'Analyse',
            class_marketing: 'Marketing',
            class_social: 'Sociaal',
            accept_label: 'Accepteer inzicht',
            reject_label: 'Inzicht afwijzen',
            no_items: 'Er zijn bij deze scan geen cookies of trackers gedetecteerd.',
            error_generic: 'Kan het cookie-inzicht niet produceren. Probeer het opnieuw of controleer of de scan succesvol is voltooid.',
        },
        monitoring: {
            title: 'Privacymonitoring',
            new_scan: 'Nieuw Scannen',
            scan_url: 'URL naar Scannen',
            scan_frequency: 'Scannen Frequentie',
            last_scan: 'Laatste Scannen',
            score: 'Privacyscore',
            issues: 'Gevonden problemen',
            history: 'Scannen Geschiedenis',
            settings: 'Monitoring Instellingen',
        },
        real_time: {
            title: 'Realtimescanner',
            scan_now: 'Scannen Now',
            scanning: 'Scannen...',
            results: 'Scannen Resultaten',
            no_results: 'Nog geen scanresultaten.',
            cookies: 'Browsercookies',
            trackers: 'Volgsystemen',
            consent_banners: 'Toestemming Banners',
            third_party: 'Scripts van derden',
            archive: 'Resultaten Archiveren',
            settings: 'Scanner Instellingen',
        },
        dashboard: {
            page_title: 'Dashboard voor privacybewaking',
            privacy_monitoring: 'Privacybewaking',
            plan_label: '[[TOK_1]]-abonnement',
            expires_label: 'verloopt op [[TOK_1]]',
            settings: 'Instellingen',
            refresh: 'Vernieuwen',
            refreshing_dashboard: 'Vernieuwend monitoringdashboard',
            refresh_aria: 'Vernieuw het monitoringdashboard',
            not_configured_title: 'Privacybewaking niet geconfigureerd',
            not_configured_desc: 'Sluit uw [[TOK_0]] Privacy Monitoring-service aan om de naleving van de website te volgen.',
            configure_monitoring: 'Configureer monitoring',
            license_expired_title: 'Licentie verlopen',
            license_expired_desc: 'Uw [[TOK_0]] Privacy Monitoring-licentie is verlopen. Verleng deze om serviceonderbreking te voorkomen.',
            compliance_score: 'Nalevingsscore',
            cookies_detected: 'Cookies gedetecteerd',
            trackers_label: 'Volgers',
            open_issues: 'Openstaande problemen',
            score_good: 'Goed',
            score_needs_improvement: 'Verbetering nodig',
            score_critical: 'Kritisch',
            action_required: 'Actie vereist',
            cookies_sr: 'cookies gedetecteerd',
            trackers_sr: 'spoorzoekers gevonden',
            open_issues_sr: 'openstaande kwesties',
            action_required_sr: 'actie vereist',
            metric_label: 'Metrisch',
            value_label: 'Waarde',
            status_label: 'Status',
            aria_metrics: 'Statistieken voor privacymonitoring',
            plan_limit_warning: 'Scannen [[TOK_4]]: [[TOK_2]]/[[TOK_3]] — je hebt je abonnementslimiet bereikt.',
            manage_domains: 'Beheer domeinen of upgrade uw abonnement.',
            monitored_domains: 'Bewaakte domeinen',
            domain_added: 'Domein [[TOK_1]] toegevoegd',
            domain_removed: 'Domein [[TOK_1]] verwijderd',
            failed_add_domain: 'Kan domein niet toevoegen',
            failed_remove_domain: 'Kan domein niet verwijderen',
            failed_load: 'Kan het monitoringdashboard niet laden',
            new_domain_aria: 'Nieuw domein [[TOK_0]]',
            add_domain: 'Domein toevoegen',
            adding_domain: 'Toevoegen…',
            no_domains: 'Er zijn nog geen bewaakte domeinen geconfigureerd.',
            aria_domains_table: 'Gecontroleerde domeinen',
            col_domain: 'Domein',
            col_compliance_score: 'Nalevingsscore',
            col_status: 'Status',
            col_cookies: 'Koekjes',
            col_trackers: 'Volgers',
            col_issues: 'Problemen',
            col_last_scan: 'Laatste scan',
            col_action: 'Actie',
            compliance_status_sr: 'nalevingsstatus',
            showing_chart: 'Grafiekweergave weergeven',
            showing_table: 'Gegevenstabelweergave weergeven',
            loading_sr: 'Monitoringdashboard laden',
            col_framework_tags: 'Kadertags',
            col_last_monitored: 'Laatst gecontroleerd',
            framework_tags_sr: 'toepasselijke regelgevingskaders',
            last_monitored_sr: 'tijdstempel voor continue monitoring',
            audit_trail_heading: 'Audittraject',
            audit_trail_info: 'Elke monitoringscan wordt voorzien van een tijdstempel en geregistreerd. Wijzigingen in de compliance op domeinniveau zorgen voor een onveranderlijk auditrecord dat kan worden geëxporteerd voor controle door de toezichthouder.',
            cybersecurity_law_info_heading: 'Detectie van cyberbeveiligingswetten',
            cybersecurity_law_info: 'Gecontroleerde domeinen worden automatisch gecontroleerd op de vereisten van de cyberbeveiligingswetgeving (bijvoorbeeld de Vietnamese cyberbeveiligingswet, [[TOK_0]] richtlijn). Kadertags geven aan welke regelgeving van toepassing is. Kwesties worden gecategoriseerd per regelgevingskader voor gericht herstel.',
        },
        scan: {
            page_title: 'Realtime scannen',
            title: 'Realtime privacyscanner',
            settings: 'Instellingen',
            results_archive: 'Resultatenarchief',
            launch_scan: 'Start Scannen',
            target_url: 'Doel [[TOK_0]]',
            protocol_aria: 'Protocol',
            url_required: '[[TOK_0]] is vereist',
            url_whitespace: 'Verwijder de witruimte uit de [[TOK_0]]',
            url_invalid: 'Voer een geldig domein in (bijvoorbeeld voorbeeld.com)',
            add_subpages: "Subpagina's toevoegen",
            add_subpages_aria: "Subpagina's toevoegen, [[TOK_1]] toegevoegd",
            start_scan: 'Start scannen',
            launching: 'Lancering…',
            scan_launched: 'Scannen is succesvol gestart',
            scan_failed: 'Kan de scan niet starten',
            scan_progress: 'Scanvoortgang',
            scanning_in_progress: 'Bezig met scannen…',
            scan_id: 'Scan-ID',
            status_label: 'Status',
            status_unknown: 'unknown',
            progress_label: 'Vooruitgang',
            pages_label: "Pagina's",
            refresh_status: 'Vernieuwingsstatus',
            new_scan: 'Nieuwe scan',
            scan_completed: 'Scan voltooid, resultaten beschikbaar',
            failed_check_status: 'Kan de scanstatus niet controleren',
            scan_results: 'Scanresultaten',
            main_page: 'Hoofdpagina',
            page_n: 'Pagina [[TOK_1]]',
            result_pages_nav: "Resultatenpagina's",
            page_url: 'Pagina [[TOK_0]]',
            risk_score: 'Risicoscore',
            risk_score_sr: 'risicoscore',
            cookies_label: 'Koekjes',
            cookies_sr: 'cookies gedetecteerd',
            scripts_label: 'Scripts',
            scripts_sr: 'scripts gedetecteerd',
            issues_label: 'Problemen',
            issues_sr: 'problemen gevonden',
            issues_found: 'Problemen gevonden',
            aria_issues_table: 'Problemen gevonden tijdens de scan',
            col_severity: 'Ernst',
            col_category: 'Categorie',
            col_title: 'Titel',
            col_remediation: 'Sanering',
            severity_sr: 'severity',
            scan_result_metrics: 'Resultaatstatistieken scannen',
            view_full_detail: 'Bekijk alle details',
            col_consent_category: 'Toestemmingscategorie',
            consent_category_sr: 'categorisering van toestemming',
            compliance_evidence_heading: 'Bewijs van naleving',
            compliance_evidence_info: 'Scanbevindingen worden automatisch gekoppeld aan compliancegevallen. Elk probleem kan worden herleid tot een toestemmingscategorie (essentieel, functioneel, analytisch, marketing) en levert auditklaar bewijsmateriaal op voor controle door de toezichthouder.',
            rule_config_heading: 'Regelconfiguratie',
            rule_config_info: 'Scanregels zijn configureerbaar per regelgevingskader. Cookiecontroles, scriptdetectie en leveranciersanalyse kunnen via Instellingen worden in- of uitgeschakeld. Aangepaste regels kunnen worden gedefinieerd om te voldoen aan de nalevingsvereisten van uw organisatie.',
            case_linkage_heading: 'Koppeling van compliancezaken',
            case_linkage_info: 'Problemen die tijdens realtime scans worden aangetroffen, kunnen worden gekoppeld aan nalevingsgevallen voor tracking en herstel. Navigeer naar de pagina Scanresultatendetail om case-associaties te bekijken.',
            subpages_modal_title: "Subpagina's toevoegen",
            subpages_modal_desc: "Voeg maximaal vijf subpagina-URL's toe om naast het hoofddomein te scannen.",
            subpage_n: 'Subpagina [[TOK_1]]',
        },
        result_detail: {
            page_title: 'Details van scanresultaten',
            title: 'Scanresultaat',
            back_to_archive: 'Terug naar archief',
            failed_load: 'Kan het scanresultaat niet laden',
            loading_sr: 'Scanresultaat laden…',
            scan_id: 'Scan-ID',
            target_url: 'Doel [[TOK_0]]',
            status_label: 'Status',
            status_sr: 'status',
            started: 'Gestart',
            completed: 'Voltooid',
            pages_scanned: "Pagina's gescand",
            https_label: 'HTTPS',
            highest_risk_score: 'Hoogste risicoscore',
            most_cookies: 'De meeste koekjes',
            most_vendors: 'De meeste externe leveranciers',
            most_issues: 'De meeste problemen',
            across_pages: "over pagina's heen",
            highest_values_aria: "Hoogste waarden op alle pagina's",
            scanned_pages_nav: "Gescande pagina's",
            main_page: 'Hoofdpagina',
            page_n: 'Pagina [[TOK_1]]',
            page_url: 'Pagina [[TOK_0]]',
            risk_score: 'Risicoscore',
            overall_risk_sr: 'algemene risicoscore',
            cookies_label: 'Koekjes',
            cookies_sr: 'cookies gedetecteerd',
            vendors_label: 'Externe leveranciers',
            vendors_sr: 'externe leveranciers gedetecteerd',
            issues_label: 'Problemen',
            issues_sr: 'problemen gevonden',
            risk_breakdown_aria: 'Uitsplitsing van de risicoscore',
            issues_found: 'Problemen gevonden',
            aria_issues_table: 'Problemen gevonden tijdens de scan',
            col_severity: 'Ernst',
            col_category: 'Categorie',
            col_title: 'Titel',
            col_remediation: 'Sanering',
            severity_sr: 'severity',
            cookies_heading: 'Cookies ([[TOK_1]])',
            aria_cookies_table: 'Cookies gedetecteerd',
            col_name: 'Naam',
            col_domain: 'Domein',
            col_path: 'Pad',
            col_secure: 'Veilig',
            col_httponly: 'Alleen HTTPP',
            col_samesite: 'Dezelfde site',
            vendors_heading: 'Externe leveranciers ([[TOK_1]])',
            aria_vendors_table: 'Externe leveranciers gedetecteerd',
            col_hostname: 'Hostnaam',
            scripts_heading: 'Scripts/bakens ([[TOK_1]])',
            aria_scripts_table: 'Scripts en bakens gedetecteerd',
            col_url: 'URL',
            col_type: 'Typ',
            links_heading: 'Koppelingen',
            first_party: 'Eerste partij',
            third_party: 'Derden',
            col_risk_category: 'Risicocategorie',
            col_regulatory_framework: 'Regelgevingskader',
            col_actionable_detail: 'Bruikbare details',
            risk_category_sr: 'risicocategorie op het gebied van de regelgeving',
            risk_category_mapping_heading: 'Risicocategorie in kaart brengen',
            risk_category_mapping_info: 'Elke scanbevinding wordt toegewezen aan een risicocategorie van de regelgeving (gegevensverzameling, grensoverschrijdende overdracht, toestemmingsbeheer, gegevensbewaring, beveiligingscontroles). Deze mapping maakt gericht herstel mogelijk, geprioriteerd op basis van de impact van de regelgeving.',
            compliance_case_heading: 'Vereniging voor nalevingszaken',
            compliance_case_info: 'Scanresultaten worden gekoppeld aan compliance-cases voor end-to-end tracking. Problemen kunnen rechtstreeks vanuit de scanresultaten worden geëscaleerd naar de workflow voor nalevingszaken.',
        },
        results_archive: {
            page_title: 'Archief scanresultaten',
            title: 'Archief scanresultaten',
            back_to_scanner: 'Terug naar Scanner',
            failed_load: 'Kan scanresultaten niet laden',
            results_loaded: 'Scanresultaten geladen, [[TOK_1]] records',
            total_label: 'Totaal: [[TOK_1]]',
            aria_table: 'Archief met scanresultaten',
            col_scan_date: 'Scandatum',
            col_target_url: 'Doel [[TOK_0]]',
            col_duration: 'Duur',
            col_issues_found: 'Problemen gevonden',
            col_risk_score: 'Risicoscore',
            col_status: 'Status',
            col_actions: 'Acties',
            scan_status_sr: 'scanstatus',
            view_result: 'Bekijk',
            no_results: 'Geen scanresultaten gevonden.',
            loading_sr: 'Scanresultaten laden',
            pagination_aria: 'Paginering van scanresultaten',
            col_risk_category: 'Risicocategorie',
            risk_category_sr: 'risicocategorie op het gebied van de regelgeving',
            archive_retention_heading: 'Archiefbehoud',
            archive_retention_info: 'Scanresultaten worden bewaard gedurende de periode die is gespecificeerd in het gegevensbewaarbeleid van uw organisatie. Gearchiveerde resultaten omvatten de volledige scancontext (framework-tags, risicocategorieën, herstelbegeleiding) en kunnen worden geëxporteerd als [[TOK_0]] voor regelgevend bewijs.',
            export_context_info: 'Geëxporteerde [[TOK_0]]-bestanden bevatten de regelgevingscontext: risicocategorie, toepasselijke raamwerken en bruikbare hersteldetails voor elke bevinding.',
        },
        scanner_settings: {
            page_title: 'Scannerinstellingen',
            title: 'Scannerinstellingen',
            back_to_scanner: 'Terug naar Scanner',
            failed_load: 'Kan de scannerconfiguratie niet laden',
            endpoint_url: 'Eindpunt [[TOK_0]]',
            save_success: 'Scannerconfiguratie succesvol opgeslagen.',
            save_failed: 'Kan de scannerconfiguratie niet opslaan',
            test_connection: 'Verbinding testen',
            testing: 'Testen...',
            save_configuration: 'Configuratie opslaan',
            saving: 'Opslaan...',
            loading_sr: 'Scannerinstellingen laden',
        },
        monitoring_settings: {
            page_title: 'Instellingen voor privacybewaking',
            title: 'Controle-instellingen',
            back_to_dashboard: 'Terug naar Dashboard',
            failed_load: 'Kan de monitoringconfiguratie niet laden',
            credentials_heading: '[[TOK_0]] Inloggegevens',
            connected_as: 'Verbonden als [[TOK_1]]',
            credentials_desc: 'Voer uw [[TOK_0]]-accountgegevens in om verbinding te maken met Privacy Monitoring. Zoek uw lidmaatschaps-ID op de profielpagina van uw [[TOK_1]]-account.',
            client_id: 'Klant-ID',
            client_secret: 'Klantgeheim',
            username: '[[TOK_0]] Gebruikersnaam (e-mail)',
            password: '[[TOK_0]] Wachtwoord',
            placeholder_keep: '(laat leeg om bestaand te blijven)',
            credential_form_aria: '[[TOK_0]] inlogformulier',
            test_connection: 'Verbinding testen',
            testing: 'Testen…',
            test_aria: 'Test [[TOK_0]]-verbinding',
            testing_aria: 'Verbinding testen',
            save_configuration: 'Configuratie opslaan',
            saving: 'Opslaan…',
            save_aria: 'Bewaar inloggegevens',
            saving_aria: 'Inloggegevens opslaan',
            credentials_saved: '[[TOK_0]] inloggegevens zijn succesvol opgeslagen.',
            credentials_saving: '[[TOK_0]] inloggegevens opgeslagen. Configuratie opnieuw laden…',
            credentials_save_failed: 'Kan de inloggegevens niet opslaan',
            client_id_required: 'Klant-ID en gebruikersnaam zijn vereist.',
            all_fields_required: 'Alle inloggegevensvelden zijn verplicht.',
            email_heading: 'E-mailmeldingen',
            receive_emails: 'Ontvang e-mails met scanrapporten',
            email_toggle_aria: 'Schakel e-mails met scanrapporten in of uit',
            only_on_change: 'Alleen e-mailen als de risicostatus verandert',
            only_on_change_aria: 'Schakel alleen e-mail in bij wijziging van de risicostatus',
            emails_enabled: 'E-mails met scanrapporten ingeschakeld',
            emails_disabled: 'E-mails met scanrapporten uitgeschakeld',
            only_change_on: 'Alleen e-mailen over risicowijzigingen',
            only_change_off: 'E-mailen bij elke scan',
            email_failed: 'Kan de e-mailinstelling niet updaten',
            email_settings_aria: 'Instellingen voor e-mailmeldingen',
            loading_sr: 'Bewakingsinstellingen laden',
        },
        entity_types: {
            user: 'Gebruiker',
            case: 'Geval',
            incident: 'Voorval',
            assessment: 'Beoordeling',
            vendor: 'Verkoper',
            consent: 'Toestemming',
            policy: 'Beleid',
            data_map: 'Gegevenskaart',
        },
        actions: {
            create: 'Creëer',
            update: 'Bijwerken',
            delete: 'Verwijderen',
            view: 'Bekijk',
            export: 'Exporteren',
            status_change: 'Statuswijziging',
        },
    },
    forms: {
        dashboard: {
            title: 'Formulieroverzicht',
            total_templates: 'Totaal Sjablonen',
            installed: 'Geïnstalleerd',
            available: 'Beschikbaar',
            by_market: 'By Markt',
            back_dashboard: 'Back naar Dashboard',
            browse_templates: 'Bladeren Sjablonen',
            catalog_coverage: 'Catalogus Dekking',
            quick_start: 'Snel Starten',
            recent_instances: 'Recent Instanties',
            total_instances: 'Totaal Instanties',
            fetch_failed: 'Kan niet fetch dashboard gegevens..',
            no_instances: 'Geen instanties gevonden.',
            form_metrics: 'Overzicht formuliermetrieken',
            templates_total: 'sjablonen totaal',
            instances_total: 'instanties totaal',
            installed_of_available: '[[TOK_2]] van [[TOK_3]] geïnstalleerd',
            templates_in_category: 'sjablonen in {category}',
        },
        templates: {
            title: 'Formuliersjablonen',
            new: 'Nieuw Sjabloon',
            edit: 'Bewerken Sjabloon',
            name: 'Sjabloon Naam',
            form_type: 'Formulier Type',
            market: 'Markt',
            language: 'Taal',
            schema: 'Formulier Schema',
            preview: 'Voorbeeld',
            duplicate: 'Duplicate Sjabloon',
            grid_view: 'Raster Bekijken',
            list_view: 'Lijst Bekijken',
            fetch_failed: 'Kan niet fetch sjablonen..',
            filter_templates: 'Sjablonen filteren',
            version_history: 'Versiegeschiedenis',
            no_version_history: 'Geen versiegeschiedenis — dit is de initiële versie.',
            form_id: 'Formulier-ID',
            source_instrument: 'Broninstrument',
            issuer: 'Uitgever',
            all_frameworks: 'Alle raamwerken',
            view_mode: 'Weergavemodus',
        },
        catalog: {
            title: 'Formuliercatalogus',
            install: 'Installeren',
            uninstall: 'Verwijderen',
            install_all: 'Installeren Alle',
            installed_tab: 'Geïnstalleerd',
            catalog_tab: 'Catalogus',
            search_placeholder: 'Zoeken sjablonen...',
            no_templates: 'Geen sjablonen gevonden.',
            template_count: '{count} sjablonen',
            all_markets: 'Alle Markets',
            sections: 'Secties',
            all_categories: 'Alle Categorieën',
            category: 'Categorie',
            category_install_failed: 'Kan niet install category sjablonen..',
            category_install_success: 'Categorie sjablonen installed.',
            fetch_failed: 'Kan niet fetch sjablonen..',
            fetch_installed_failed: 'Kan niet fetch installed sjablonen..',
            fields: 'Velden',
            install_failed: 'Kan niet install sjabloon..',
            install_success: 'Sjabloon installed successfully.',
            installing: 'Installeren...',
            removing: 'Verwijderen...',
            uninstall_confirm: 'Are you sure you want naar uninstall dit sjabloon?',
            uninstall_failed: 'Kan niet uninstall sjabloon..',
            uninstall_success: 'Sjabloon uninstalled successfully.',
            installation_summary: 'Installatieoverzicht',
            filter_catalog: 'Catalogus filteren',
            all_frameworks: 'Alle raamwerken',
            templates_installed_count: '[[TOK_1]] sjabloon(s) succesvol geïnstalleerd',
            all_already_installed: 'Alle sjablonen in deze categorie zijn al geïnstalleerd',
            form_id: 'Formulier-ID',
            issuer: 'Uitgever',
            catalog_tabs: 'Formuliercatalogus-tabs',
        },
        filler: {
            back_templates: 'Back naar Sjablonen',
            no_sections: 'Geen secties gevonden.',
            draft_created: 'Concept created.',
            draft_saved: 'Concept saved.',
            fetch_template_failed: 'Kan niet fetch sjabloon..',
            save_draft: 'Opslaan Concept',
            save_draft_failed: 'Kan niet save concept..',
            saving: 'Opslaan...',
            select_option: 'Selecteren een optie',
            submit: 'Indienen',
            submit_failed: 'Kan niet submit..',
            submitting: 'Indienen...',
            title: 'Formulier Wizard',
            form_id_label: 'Formulier-ID',
            schema_label: 'Schema',
            framework_label: 'Raamwerk',
            issuer_label: 'Uitgever',
            source_label: 'Bron',
            market_label: 'Markt',
            section_of: 'Sectie {current} van {total}',
            form_navigation: 'Formuliernavigatie',
            form_progress: 'Formuliervoortgang: Sectie {current} van {total}',
            removed_item: 'Item {index} verwijderd uit {field}',
            added_item: 'Nieuw item toegevoegd aan {field}',
            go_to_previous: 'Ga naar vorige sectie, sectie {current} van {total}',
            go_to_next: 'Ga naar volgende sectie, sectie {current} van {total}',
            risk_matrix_placeholder: '1–5',
        },
        filing: {
            title: 'Indieningsstatus',
            advance: 'Indieningsstatus bijwerken...',
            not_started: 'Niet gestart',
            drafting: 'Opstellen',
            internal_review: 'Interne beoordeling',
            approved_for_submission: 'Goedgekeurd voor indiening',
            submitted_to_authority: 'Ingediend bij autoriteit',
            supplement_requested: 'Aanvulling gevraagd',
            supplement_in_progress: 'Aanvulling in behandeling',
            resubmitted: 'Opnieuw ingediend',
            accepted: 'Geaccepteerd',
            rejected: 'Afgewezen',
            closed: 'Gesloten',
        },
        instances: {
            approved_by: 'Goedgekeurd By',
            form_answers: 'Formulier Antwoorden',
            no_answers: 'Geen answers gevonden.',
            view_outputs: 'Bekijken Uitvoeren',
            approve: 'Goedkeuren',
            approve_failed: 'Kan niet approve..',
            approving: 'Goedkeuren...',
            detail_title: 'Instantie Detail',
            fetch_failed: 'Kan niet fetch instanties..',
            generate_failed: 'Kan niet generate uitvoer..',
            generate_output: 'Genereren Uitvoer',
            generating: 'Genereren...',
            submitted_at: 'Ingediend At',
            instance_metadata: 'Formulierinstantie-metadata',
            filing_status_steps: 'Archiveringsstatus-stappen',
            current_status: 'huidige status',
            filing_status_update_failed: 'Bijwerken van indieningstatus mislukt',
        },
        outputs: {
            back_instance: 'Back naar Instantie',
            no_outputs_msg: 'No uitvoeren have been generated yet.',
            no_outputs_title: 'No Uitvoeren',
            output_name: 'Uitvoer Naam',
            download: 'Downloaden',
            download_failed: 'Kan niet download..',
            fetch_failed: 'Kan niet fetch uitvoeren..',
            format: 'Formaat',
            generated_at: 'Gegenereerd At',
            generated_by: 'Gegenereerd By',
            size: 'Grootte',
            title: 'Formulier Uitvoeren',
            print: 'Afdrukken',
            print_outputs: 'Formulieruitvoer afdrukken',
            printing: 'Formulieruitvoer afdrukken',
            pdf_preview: 'PDF-voorbeeld',
            downloading: '{name} downloaden',
            preview_in_new_window: 'Voorbeeld {name} ({format}) in nieuw venster',
        },
        cybersec_domains: {
            scope: 'Reikwijdte en toepasselijkheid',
            risk: 'Risicobeoordeling en controlekartografie',
            policy: 'Organisatorisch beveiligingsbeleid',
            localization: 'Datalokalisatie en lokale aanwezigheid',
            vendor: 'Derden en toeleveringsketen',
            authority: 'Afhandeling van verzoeken van autoriteiten',
            incident: 'Incidentrespons en bewijsvoering',
            training: 'Opleiding en gereedheid',
        },
        market_finalization_domains: {
            data_law: 'Datawet — Governance en Operationele Controles',
            pdpl_2025: 'PDPL 2025 — Privacy-governance en Rechten van Betrokkenen',
            decree_356: 'Besluit 356/2025 — Leveranciers- en Grensoverschrijdende Controles',
            telecom: 'Telecommunicatiewet — Vertrouwelijkheid en Autoriteitsverzoeken',
        },
        nav: {
            filing_case_links: 'Indieningszaakkoppelingen',
            section_routing: 'Sectieroutering',
            submission_packages: 'Inzendingspakketten',
        },
        filing_case_links: {
            title: 'Indieningszaakkoppelingen',
            link_form: 'Formulier koppelen aan indieningszaak',
            filing_case_type: 'Indieningszaaktype',
            form_instance: 'Formulierinstantie',
            select_form_instance: 'Selecteer een formulierinstantie...',
            select_filing_case: 'Selecteer een indieningszaak...',
            no_links_found: 'Geen indieningszaakkoppelingen gevonden.',
            linked: 'Gekoppeld',
            filing_case_id: 'Archiveringscase-ID',
            link_created: 'Archiveringscase-koppeling aangemaakt',
            link_deleted: 'Indieningszaakkoppeling verwijderd',
            aria_delete_link: 'Koppeling {name} verwijderen',
            case_type_dpia_dossier: 'DPIA-dossier',
            case_type_cross_border_filing: 'Grensoverschrijdende indiening',
            case_type_breach_notification: 'Melding van inbreuk',
            no_instances_guidance: 'Nog geen formulierinstanties. Maak er een aan vanuit Formuliersjablonen.',
            no_filings_guidance: 'Nog geen indieningszaken. Maak er een aan vanuit Beoordelingen.',
        },
        section_routing: {
            title: 'Sectieroutering',
            assign_section: 'Sectie toewijzen',
            department: 'Afdeling',
            select_department: 'Selecteer een afdeling...',
            assignee: 'Toegewezen aan',
            select_assignee: 'Selecteer een toegewezene...',
            section: 'Sectie',
            select_section: 'Selecteer een sectie...',
            select_form_instance: 'Selecteer een formulierinstantie...',
            no_assignments_found: 'Geen sectietoewijzingen gevonden.',
            select_instance_prompt: 'Selecteer een formulierinstantie om sectietoewijzingen te bekijken.',
            complete_section: 'Sectie voltooien',
            status_pending: 'In afwachting',
            status_in_progress: 'Bezig',
            status_completed: 'Voltooid',
            status_reviewed: 'Beoordeeld',
            form_instance_id: 'Formulierinstantie-ID',
            assignment_created: 'Sectietoewijzing aangemaakt',
            assignment_deleted: 'Sectietoewijzing verwijderd',
            status_updated: 'Sectiestatus bijgewerkt',
            aria_delete_assignment: 'Toewijzing {name} verwijderen',
            deadline: 'Deadline',
            deadline_help: 'Optioneel. Toewijzingen na deze datum worden als achterstallig weergegeven.',
            overdue: 'Achterstallig',
            days_remaining: 'dagen resterend',
            approval_requested: 'Ingediend ter beoordeling',
            form_approved: 'Formulier goedgekeurd',
            form_rejected: 'Formulier afgewezen',
            no_departments_guidance: 'Geen afdelingen geconfigureerd. Stel in via Organisatie-instellingen.',
            no_sections_guidance: 'Geen secties gedefinieerd in het sjabloon. Zorg ervoor dat het formuliersjabloon secties bevat.',
            select_instance_first: 'Selecteer eerst een formulierinstantie om beschikbare secties te laden.',
        },
        submission_packages: {
            title: 'Inzendingspakketten',
            assemble_package: 'Inzendingspakket samenstellen',
            dossier: 'Dossier',
            select_dossier: 'Selecteer een dossier...',
            package_label: 'Pakketlabel',
            cover_letter: 'Begeleidende brief',
            checklist: 'Controlelijst',
            evidence_index: 'Bewijsindex',
            completeness: 'Volledigheid',
            incomplete_warning: 'Kan niet samenstellen: formulier heeft onvolledige secties.',
            no_packages_found: 'Geen inzendingspakketten gevonden.',
            version: 'Versie',
            package_assembled: 'Inzendingspakket samengesteld',
            package_deleted: 'Inzendingspakket verwijderd',
            aria_delete_package: 'Pakket {name} verwijderen',
            status_draft: 'Concept',
            status_complete: 'Voltooid',
            status_submitted: 'Ingediend',
            status_accepted: 'Geaccepteerd',
            status_rejected: 'Afgewezen',
            package_updated: 'Inzendingspakket bijgewerkt',
            document_generated: 'Document gegenereerd',
            documents: 'Documenten',
            generate: 'Genereren',
            preview: 'Voorbeeld',
            download: 'Downloaden',
            download_all: 'Alles downloaden',
            no_dossiers_guidance: 'Nog geen dossiers. Maak er een aan vanuit Beoordelingen.',
            package_plan_help: 'Opnemen in pakketplan (automatische documentgeneratie beschikbaar):',
            cover_letter_help: 'Officiële begeleidende brief gericht aan de ontvangende autoriteit',
            checklist_help: 'Nalevingschecklist die verifieert dat aan alle indieningsvereisten is voldaan',
            evidence_index_help: 'Index van ondersteunende bewijsdocumenten waarnaar in de indiening wordt verwezen',
            completeness_skipped: 'Volledigheidscontrole overgeslagen — geen formulierinstantie gekoppeld aan dit dossier.',
            completeness_unavailable: 'Volledigheidscontrole niet beschikbaar — doorgaan met pakketsamenstelling.',
            duplicate_package_error: 'Er bestaat al een indieningspakket voor dit dossier.',
            doc_cover_letter: 'Begeleidende brief',
            doc_checklist: 'Controlelijst',
            doc_evidence_index: 'Bewijsstukkenindex',
            export_csv: 'CSV exporteren',
            export_success: 'Koppelingen naar indieningszaken succesvol geëxporteerd',
            no_assignments_guidance: 'Nog geen sectietoewijzingen. Wijs secties toe aan afdelingen en teamleden om de routering te starten.',
        },
        template_picker: {
            title: 'Een sjabloon selecteren',
            hint: 'Kies een regelgevend formuliersjabloon of begin met een leeg formulier.',
            market_filter: 'Filteren op markt',
            framework_filter: 'Filteren op kader',
            all_markets: 'Alle markten',
            all_frameworks: 'Alle kaders',
            search_placeholder: 'Sjablonen zoeken...',
            blank_form: 'Leeg / generiek formulier',
            blank_form_desc: 'Aanmaken zonder sjabloon — velden handmatig invullen.',
            no_templates: 'Geen sjablonen gevonden voor dit filter.',
            select: 'Selecteren',
            link_error: 'Sjabloonkoppeling mislukt — u kunt een sjabloon later koppelen vanuit de Bewerkenweergave.',
            internal_badge: 'Intern sjabloon',
            legacy_badge: 'Verouderd',
            draft_badge: 'Concept',
            upcoming_badge: 'Aankomend',
            hidden_badge: 'Verborgen',
            show_hidden_toggle: 'Verborgen / verouderde sjablonen tonen',
            show_hidden_toggle_hint: 'Beheerdersweergave: bevat sjablonen met de markering internal_only, hidden, legacy of draft.',
        },
        cover_letter_modal: {
            title: 'Begeleidende brief: voorbeeld en bewerken',
            iframe_title: 'Voorbeeld van begeleidende brief',
            stage_label: 'Fase',
            stage_initial: 'Eerste indiening',
            stage_supplement: 'Aanvullend antwoord',
            stage_resubmission: 'Herindiening',
            subject_label: 'Onderwerp',
            body_label: 'Hoofdalinea',
            notes_label: 'Aanvullende opmerkingen',
            refresh_preview: 'Voorbeeld vernieuwen',
            confirm: 'Bevestigen en opslaan',
            regenerate: 'Opnieuw genereren',
            snapshot_saved: 'Begeleidende brief opgeslagen',
        },
        related_panel: {
            title: 'Gerelateerde regelgevingsformulieren',
            open_form: 'Formulier invullen',
            no_forms: 'Geen gerelateerde formulieren gevonden.',
            hint_vn: 'VN-specifieke regelgevingsformulieren beschikbaar — selecteer een formulier om de nalevingsassistent te openen.',
            internal_badge: 'Intern',
            official_badge: 'Officieel',
            loading: 'Gerelateerde formulieren laden...',
            error: 'Kan gerelateerde formulieren niet laden.',
            form_id: 'Formulier-ID',
            form_name: 'Formuliernaam',
            framework: 'Regelgevend kader',
        },
        view_form: 'Formulier bekijken',
        edit_form: 'Formulier bewerken',
        save_draft: 'Concept opslaan',
        module_settings: 'Module-instellingen',
        validation_errors: 'Corrigeer de validatiefouten',
        custom_name_help: 'Optioneel — standaard de sjabloonnaam als dit leeg is',
        select_placeholder: 'Selecteer...',
        previous_section: 'Vorige',
        next_section: 'Volgende',
        loading: 'Bezig met laden...',
        array_add: 'Toevoegen',
        array_remove: 'Verwijderen',
        array_item_label: '[[TOK_2]] artikel [[TOK_3]]',
        array_add_item: 'Item toevoegen aan {label}',
        array_remove_item: 'Item {index} verwijderen uit {label}',
        legacy_banner: 'Deze record is gemaakt vóór de geünificeerde formulieren. Sommige gegevens kunnen verschillen tussen de entiteit en de formulierinstantie.',
        field_required: '{label} is verplicht',
        section_announcement: 'Sectie [[TOK_3]] van [[TOK_4]]: [[TOK_5]]',
        sections_nav_label: 'Formulier secties',
        no_sections: 'Er zijn geen sjabloonsecties beschikbaar.',
        section_label_tpl: 'Sectie [[TOK_2]]: [[TOK_3]]',
        module_settings_auto_applied: 'Modulespecifieke instellingen worden automatisch toegepast.',
        operation_failed: 'Operatie mislukt',
        failed_to_load_form: 'Formulier kon niet worden geladen',
        failed_to_save_form: 'Formulier kon niet worden opgeslagen',
        failed_to_submit_form: 'Formulier kon niet worden verzonden',
        failed_to_load_template: 'Sjabloon kon niet worden geladen',
        failed_to_save_draft: 'Concept kon niet worden opgeslagen',
        failed_to_create: 'Aanmaken is mislukt',
    },
    pack_catalog: {
        title: 'Pakket Catalogus',
        install: 'Installeren Pakket',
        uninstall: 'Verwijderen Pakket',
        install_batch: 'Installeren Cluster',
        installed_tab: 'Geïnstalleerd',
        catalog_tab: 'Catalogus',
        pack_details: 'Pakket Details',
        frameworks: 'Raamwerken',
        requirements: 'Vereisten',
        artifacts: 'Artefacten',
        language_pack: 'Taal Pakket',
        dependencies: 'Afhankelijkheden',
        no_packs: 'Geen packs gevonden.',
    },
    platform_pages: {
        users: {
            title: 'Gebruikers',
            new: 'Nieuw Gebruiker',
            invite: 'Invite Gebruiker',
            edit: 'Bewerken Gebruiker',
            name: 'Naam',
            email: 'E-mail',
            role: 'Rol',
            status: 'Toestand',
            identity_type: 'Identiteitstype',
            last_login: 'Laatste Login',
            deactivate: 'Deactiveren',
            reactivate: 'Heractiveren',
            unlock: 'Ontgrendelen',
            reset_password: 'Wachtwoord resetten',
            remove: 'Verwijderen',
            remove_confirm: '"{name}" verwijderen? Deze actie is permanent en de gebruiker verliest alle toegang. Het record wordt bewaard voor auditdoeleinden.',
        },
        roles: {
            title: 'Rollen',
            new: 'Nieuw Rol',
            edit: 'Bewerken Rol',
            name: 'Rol Naam',
            description: 'Beschrijving',
            permissions: 'Rechten',
            users_count: 'Gebruikers',
            detail: 'Rol Detail',
            all_tiers: 'Alle niveaus',
            role_name_placeholder: 'bv. regionaal compliance-manager',
        },
        profile: {
            title: 'My Profiel',
            name: 'Naam',
            display_name: 'Weergavenaam',
            email: 'E-mail',
            phone: 'Telefoon',
            department: 'Afdeling',
            job_title: 'Functietitel',
            language: 'Taal',
            role: 'Rol',
            persona: 'Gedetecteerde persona',
            last_login: 'Laatste Login',
            save: 'Wijzigingen opslaan',
            save_success: 'Profiel succesvol bijgewerkt',
            module_tips_section: 'Moduletips',
            tips_toggle: 'Toon regelgevingstips in modules',
            dismissed_tips: 'Genegeerde tips',
            reset_dismissed: 'Alle genegeerde tips resetten',
            notification_prefs: 'Meldingsvoorkeuren',
            notification_prefs_link: 'Meldingsvoorkeuren beheren →',
            change_password: 'Wijzigen Password',
            current_password: 'Huidig Password',
            new_password: 'Nieuw Password',
            confirm_password: 'Bevestigen Password',
            accessibility: 'Toegankelijkheid',
            high_contrast: 'Hoog contrast modus',
            high_contrast_desc: 'Verhoog het contrast voor betere leesbaarheid. Voldoet aan WCAG 2.1 AAA.',
            passwords_no_match: 'Wachtwoorden komen niet overeen',
            password_changed_logout: 'Wachtwoord gewijzigd. U wordt uitgelogd.',
            failed_update: 'Profiel bijwerken mislukt',
            failed_change_password: 'Wachtwoord wijzigen mislukt',
            none: 'Geen',
            never: 'Nooit',
            password_requirements: 'Min. 12 tekens, hoofdletter, kleine letter, cijfer, speciaal teken',
        },
        security: {
            mfa_title: 'MFA Instellingen',
            mfa_enable: 'Inschakelen MFA',
            mfa_disable: 'MFA uitschakelen',
            mfa_setup: 'Scannen dit QR code met your authenticator app',
            sso_title: 'SSO Configuratie',
            sso_provider: 'Aanbieder',
            sso_client_id: 'Client-ID',
            sso_redirect: 'Omleidings-URI',
            api_keys_title: 'API-sleutels',
            api_keys_new: 'Nieuw API Sleutel',
            api_keys_name: 'Sleutel Naam',
            api_keys_last_used: 'Laatste Used',
            api_keys_expires: 'Verloopt',
            api_keys_revoke: 'Intrekken',
            service_accounts_title: 'Serviceaccounts',
            ip_allowlist_title: 'IP-toelatingslijst',
            ip_add: 'Toevoegen IP Adres',
            ip_address: 'IP Adres',
            ip_description: 'Beschrijving',
            delegations_title: 'Delegaties',
            delegations_new: 'Nieuw Delegation',
            delegations_from: 'Van Gebruiker',
            delegations_to: 'Naar Gebruiker',
            delegations_expires: 'Verloopt',
            break_glass_title: 'Break-Glass Toegang',
            break_glass_request: 'Verzoek Toegang',
            break_glass_reason: 'Reden voor Toegang',
            break_glass_duration: 'Duur',
            session_settings_title: 'Sessie Instellingen',
            session_timeout: 'Sessie Time-out (minutes)',
            session_max_concurrent: 'Max Gelijktijdig Sessies',
            active_sessions_title: 'Actief Sessies',
            active_sessions_device: 'Apparaat',
            active_sessions_ip: 'IP Adres',
            active_sessions_started: 'Gestart',
            active_sessions_revoke: 'Intrekken Sessie',
            active_sessions_confirm_terminate: 'Weet u zeker dat u deze sessie wilt beëindigen?',
            active_sessions_confirm_terminate_current: 'Dit is uw huidige sessie. Als u de overeenkomst beëindigt, wordt u onmiddellijk afgemeld. Doorgaan?',
            active_sessions_confirm_terminate_all: 'Weet u zeker dat u alle andere sessies wilt beëindigen? Alleen uw huidige sessie blijft actief.',
            active_sessions_terminated: 'Sessie succesvol beëindigd.',
            active_sessions_all_terminated: 'Alle andere sessies zijn beëindigd.',
            active_sessions_terminate_all: 'Beëindig alle andere sessies',
            active_sessions_last_activity: 'Laatste activiteit',
            active_sessions_current: 'Huidige sessie',
            active_sessions_revoke_selected: 'Geselecteerde intrekken',
            active_sessions_confirm_terminate_selected: 'Weet u zeker dat u de geselecteerde sessies wilt beëindigen?',
            active_sessions_selected_terminated: 'Geselecteerde sessies succesvol beëindigd.',
            ip_allowlist_desc: 'Beheer toegestane IP-adressen voor toegang tot [[TOK_0]].',
            ip_no_entries: 'Geen IP-adressen geconfigureerd.',
            session_settings_desc: 'Configureer sessietime-out en gelijktijdige sessielimieten.',
            session_settings_save_policy: 'Sessiebeleid opslaan',
            session_settings_saved: 'Sessie-instellingen zijn succesvol bijgewerkt.',
            session_settings_idle_timeout: 'Time-out bij inactiviteit (minuten)',
            session_settings_absolute_timeout: 'Absolute time-out (minuten)',
            session_settings_help_idle: 'De sessie vervalt na deze periode van inactiviteit.',
            session_settings_help_absolute: 'De sessie vervalt na deze totale duur, ongeacht de activiteit.',
            session_settings_help_max: 'Maximaal aantal gelijktijdige sessies per gebruiker.',
            sso_note: 'Wijzigingen in de SSO-configuratie vereisen mogelijk dat gebruikers zich opnieuw moeten verifiëren.',
            service_accounts_warning: 'Deze [[TOK_0]]-sleutel wordt slechts één keer weergegeven. Kopieer het nu en bewaar het veilig.',
            service_accounts_new: 'Nieuw serviceaccount',
            service_accounts_name: 'Accountnaam',
            service_accounts_role: 'Rol',
            service_accounts_created: 'Gemaakt',
            service_accounts_desc: 'Beheer machine-to-machine serviceaccounts voor [[TOK_0]]-integraties.',
            break_glass_warning: 'De toegang tot breekglas wordt gecontroleerd en geregistreerd. Alleen gebruiken voor echte noodgevallen.',
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] minimum aantal tekens',
            break_glass_permission_count: '[[TOK_1]] toestemming(en) geselecteerd',
            break_glass_submitted: 'Breekglasaanvraag ingediend. In afwachting van goedkeuring.',
            break_glass_approved: 'Aanvraag breekglas goedgekeurd.',
            break_glass_denied: 'Verzoek om glasbreuk afgewezen.',
            break_glass_confirm_activate: 'Dit breekglasverzoek goedkeuren? Hierdoor wordt onmiddellijk toegang voor noodgevallen verleend.',
            break_glass_confirm_title: 'Bevestig activering',
            break_glass_pending: 'In behandeling zijnde verzoeken',
            break_glass_active_sessions: 'Actieve break-glass-sessies',
            break_glass_time_remaining: 'Resterende tijd',
            break_glass_expired: 'Verlopen',
            break_glass_approved_denied_by: 'Goedgekeurd/geweigerd door',
            delegations_desc: 'Beheer tijdelijke machtigingsdelegaties tussen gebruikers.',
            delegations_my: 'Mijn delegaties',
            delegations_to_me: 'Aan mij gedelegeerd',
            delegations_scope_all: 'Alle machtigingen',
            delegations_scope_specific: 'Specifieke machtigingen',
            delegations_created: 'Delegatie is succesvol aangemaakt.',
            delegations_revoked: 'Delegatie ingetrokken.',
            delegations_confirm_revoke: 'Weet u zeker dat u deze delegatie wilt intrekken?',
            delegations_confirm_revoke_title: 'Bevestig intrekken',
            delegations_permission_count: '[[TOK_1]] toestemming(en)',
            api_keys_status: 'Status',
            api_keys_prefix: 'Sleutelvoorvoegsel',
            api_keys_permissions_count: 'Machtigingen',
            api_keys_ip_count: 'IP-beperkingen',
            api_keys_created: 'Gemaakt',
            api_keys_confirm_revoke_title: 'Bevestig intrekken',
            api_keys_confirm_revoke_message: 'Weet u zeker dat u de [[TOK_2]]-sleutel "[[TOK_1]]" wilt intrekken? Deze actie kan niet ongedaan worden gemaakt.',
            api_keys_confirm_rotate_title: 'Bevestig rotatie',
            api_keys_confirm_rotate_message: 'Weet je zeker dat je de [[TOK_2]]-sleutel "[[TOK_1]]" wilt draaien? De huidige sleutel stopt onmiddellijk met werken.',
            api_keys_created_success: '[[TOK_0]] sleutel is succesvol aangemaakt.',
            api_keys_revoked_success: '[[TOK_2]] sleutel "[[TOK_1]]" is ingetrokken.',
            api_keys_rotated_success: '[[TOK_2]] sleutel "[[TOK_1]]" is gedraaid. Kopieer de nieuwe sleutel hieronder.',
            api_keys_load_error: 'Kan de sleutels van [[TOK_0]] niet laden.',
            api_keys_create_error: 'Kan de sleutel [[TOK_0]] niet maken.',
            api_keys_revoke_error: 'Kan de sleutel [[TOK_0]] niet intrekken.',
            api_keys_rotate_error: 'Kan de [[TOK_0]]-sleutel niet roteren.',
            break_glass_duration_15: '15 minuten',
            break_glass_duration_30: '30 minuten',
            break_glass_duration_60: '60 minuten (1u)',
            break_glass_duration_120: '120 minuten (2u)',
            break_glass_duration_240: '240 minuten (4 uur)',
            sod_rules_title: 'Regels voor functiescheiding',
            sod_violations_report: 'Overtredingenrapport',
            sod_create_rule: 'Regel maken',
            sod_col_name: 'Naam',
            sod_col_description: 'Beschrijving',
            sod_col_conflict_count: 'Conflicttelling',
            sod_col_severity: 'Ernst',
            sod_col_status: 'Status',
            sod_col_actions: 'Acties',
            sod_no_rules: 'Geen SoD-regels gevonden',
            sod_severity_warning: 'Waarschuwing',
            sod_severity_blocking: 'Blokkeren',
            sod_active: 'Actief',
            sod_inactive: 'Inactief',
            sod_edit: 'Bewerken',
            sod_exceptions: 'Uitzonderingen',
            sod_deactivate: 'Deactiveren',
            sod_confirm_deactivate_title: 'Bevestig de deactivering',
            sod_confirm_deactivate_message: 'Regel "[[TOK_1]]] deactiveren? Het zal niet langer overtredingen signaleren.',
            sod_deactivate_error: 'Kan de regel niet deactiveren',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: 'Toegang Beoordelingen',
            campaigns: 'Beoordelen Campagnes',
            new_campaign: 'Nieuw Campagne',
            campaign_name: 'Campagne Naam',
            scope: 'Bereik',
            reviewers: 'Beoordelaars',
            due_date: 'Due Datum',
            progress: 'Voortgang',
            my_reviews: 'My Beoordelingen',
            approve: 'Goedkeuren',
            revoke: 'Intrekken',
            analytics: 'Rol Analytics',
            analytics_title: 'Rol Analytics',
            permission_usage: 'Toestemming Usage',
            role_coverage: 'Rol Dekking',
            campaign_detail: 'Campagnedetails',
            campaign_description: 'Beschrijving',
            campaign_status: 'Status',
            campaign_deadline: 'Deadline',
            campaign_scope_type: 'Bereiktype',
            campaign_completion: 'Voltooiing',
            campaign_total_items: 'Totaal aantal artikelen',
            campaign_pending_items: 'In behandeling',
            campaign_confirmed_items: 'Bevestigd',
            campaign_revoked_items: 'Ingetrokken',
            campaign_escalated_items: 'Geëscaleerd',
            campaign_launch: 'Campagne lanceren',
            campaign_cancel: 'Campagne annuleren',
            campaign_confirm_launch: 'Weet u zeker dat u deze campagne wilt lanceren?',
            campaign_confirm_cancel: 'Weet u zeker dat u deze campagne wilt annuleren?',
            campaign_launched: 'Campagne succesvol gelanceerd.',
            campaign_cancelled: 'Campagne geannuleerd.',
            review_items: 'Artikelen beoordelen',
            review_item_user: 'Gebruiker',
            review_item_role: 'Rol',
            review_item_reviewer: 'Recensent',
            review_item_decision: 'Besluit',
            review_item_justify: 'Rechtvaardiging',
            review_item_confirm: 'Bevestig',
            review_item_revoke: 'Intrekken',
            review_item_escalate: 'Escaleren',
            all_decisions: 'Alle beslissingen',
            bulk_action: 'Bulkactie',
            bulk_confirm: 'Bulkbevestiging',
            bulk_revoke: 'Bulkintrekking',
            selected_count: '[[TOK_1]] geselecteerd',
            justify_required: 'Er is een rechtvaardiging vereist',
            scope_all_users: 'Alle gebruikers',
            scope_role_owner: 'Rol Eigenaar',
            scope_department: 'Afdeling',
            back_to_campaigns: 'Terug naar Campagnes',
            recommendations: 'Aanbevelingen',
            refreshing: 'Verfrissend...',
            decide: 'Beslis',
            decision_by: 'Beslissing door',
            loading_items: 'Artikelen laden...',
            loading_review_items: 'Review-items laden...',
            campaign_not_found: 'Campagne niet gevonden',
            loading_campaign: 'Campagnedetails laden...',
            campaign_completed: 'Campagne succesvol afgerond.',
            confirm_cancel_title: 'Bevestig Annuleren',
            justify_bulk_confirm: 'Rechtvaardiging voor bulkbevestiging:',
            justify_bulk_revoke: 'Reden voor bulkintrekking:',
            items_selected: '[[TOK_1]] artikel(en) geselecteerd',
            justify_bulk_required: 'Voor bulkacties is een rechtvaardiging vereist',
            create_campaign_title: 'Maak een toegangsbeoordelingscampagne',
            name_required: 'Naam is vereist',
            scope_type_required: 'Scopetype is vereist',
            reviewer_strategy_required: 'Reviewerstrategie is vereist',
            deadline_required: 'Deadline is vereist',
            reviewer_id_required: 'Reviewer-ID is vereist voor een specifieke gebruikersstrategie',
            invalid_json: 'Ongeldige [[TOK_0]]',
            scope_filter_label: 'Bereikfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Recensent Strategie',
            reviewer_id_label: 'Recensent-ID',
            deadline_label: 'Deadline',
            create_campaign_btn: 'Campagne maken',
            scope_type_label: 'Bereiktype',
            scope_by_role: 'Per rol',
            scope_by_department: 'Per afdeling',
            scope_custom: 'Aangepast',
            reviewer_manager: 'Beheerder',
            reviewer_specific_user: 'Specifieke gebruiker',
            enter_json_filter: 'Voer het [[TOK_0]]-filter in',
            hint_label: 'Tip:',
            role_usage: 'Rolgebruik',
            over_privileged_users: 'Overbevoorrechte gebruikers',
            role_name_col: 'Rolnaam',
            assigned_users: 'Toegewezen gebruikers',
            active_users_30d: 'Actieve gebruikers (30d)',
            total_perms: 'Totaal permanenten',
            used_perms: 'Gebruikte permanenten',
            unused_perms: 'Ongebruikte permanenten',
            no_data_available: 'Geen gegevens beschikbaar',
            roles_col: 'Rollen',
            total_col: 'Totaal',
            used_col: 'Gebruikt',
            unused_pct: 'Ongebruikt %',
            current_count: 'Huidige telling',
            recommended_count: 'Aanbevolen aantal',
            rationale: 'Reden',
            loading_analytics: 'Analyses laden...',
            loading_role_analytics: 'Rolanalysegegevens laden...',
            computed_at: 'Berekend op:',
            form_errors: 'Formulier bevat [[TOK_1]] fout(en). Corrigeer ze alstublieft.',
            scope_filter_invalid_json: 'Bereikfilter bevat ongeldige [[TOK_0]]',
            scope_hint_all_users: 'Geen filter nodig: alle gebruikers worden opgenomen.',
            review_type_label: 'Beoordelingstype',
            review_type_required: 'Beoordelingstype is verplicht',
            reviewer_ids_label: "Beoordelaar-ID's",
            reviewer_ids_hint: "Voer gebruikers-ID's in, gescheiden door komma's",
            reviewer_ids_required: 'Minimaal één beoordelaar-ID is vereist',
            start_date_label: 'Startdatum',
            start_date_required: 'Startdatum is verplicht',
            end_date_label: 'Einddatum',
            end_date_required: 'Einddatum is verplicht',
            review_type_user_access: 'Gebruikerstoegang',
            review_type_role_permissions: 'Rolmachtigingen',
            review_type_service_accounts: 'Serviceaccounts',
            review_type_privileged_access: 'Bevoorrechte toegang',
            review_type_application_access: 'Applicatietoegang',
            auto_revoke_label: 'Automatisch intrekken bij weigering',
            campaigns_title: 'Toegang tot beoordelingscampagnes',
            create_campaign_label: '+ Campagne maken',
            no_campaigns_found: 'Geen campagnes gevonden',
            loading_campaigns: 'Campagnes laden...',
            no_reviews_assigned: 'Er zijn geen beoordelingen aan u toegewezen',
            loading_reviews: 'Beoordelingen laden...',
            review_decision_title: 'Herzie besluit',
            justification_label: 'Rechtvaardiging',
            announce_loaded_review_items: '[[TOK_1]] recensie-items geladen',
            announce_loaded_campaigns: '[[TOK_1]] campagnes geladen',
            announce_decision_submitted: "Beslissing '[[TOK_1]]' ingediend voor beoordelingsitem",
            announce_decision_submitted_for: 'Beslissing "[[TOK_2]]" ingediend voor [[TOK_3]]',
            announce_bulk_decision: 'Bulk [[TOK_2]] toegepast op [[TOK_3]] artikelen',
        },
        attestation: {
            title: 'Attestering Schedules',
            new: 'Nieuw Plannen',
            edit: 'Bewerken Plannen',
            create_title: 'Attesteringsschema aanmaken',
            edit_title: 'Attesteringsschema bewerken',
            schedule_history: 'Schemageschiedenis',
            next_run_date: 'Volgende uitvoeringsdatum',
            schedule_name: 'Plannen Naam',
            frequency: 'Frequentie',
            next_run: 'Volgende Uitvoeren',
            last_run: 'Laatste Uitvoeren',
            history: 'Attestering Geschiedenis',
            description: 'Beschrijving',
            scope: 'Reikwijdte',
            status: 'Status',
            created_at: 'Gemaakt',
            updated_at: 'Bijgewerkt',
            trigger_now: 'Activeer nu',
            back_to_schedules: "Terug naar Schema's",
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Schema is succesvol geactiveerd.',
            deleted: 'Schema verwijderd.',
            saved: 'Schema is succesvol opgeslagen.',
            campaigns_generated: 'Campagnes gegenereerd',
            run_date: 'Uitvoeringsdatum',
            run_status: 'Status uitvoeren',
            create_schedule: 'Schema maken',
            view_history: 'Geschiedenis bekijken',
            deactivate: 'Deactiveren',
            overdue: 'OVERDUE',
            overdue_sr: 'Het schema is te laat',
            confirm_trigger_title: 'Bevestig actie',
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Bevestig de deactivering',
            confirm_deactivate_message: 'Weet u zeker dat u dit schema wilt deactiveren?',
            triggered_success: 'Schema is succesvol geactiveerd.',
            deactivated_success: 'Schema gedeactiveerd.',
            name_label: 'Naam *',
            frequency_label: 'Frequentie *',
            scope_type_label: 'Scopetype *',
            scope_filter_label: 'Bereikfilter ([[TOK_0]])',
            reviewer_strategy_label: 'Reviewer Strategie *',
            reviewer_id_label: 'Recensent-ID *',
            frequency_quarterly: 'Driemaandelijks',
            frequency_semi_annual: 'Halfjaarlijks',
            frequency_annual: 'Jaarlijks',
            scope_all_users: 'Alle gebruikers',
            scope_by_role: 'Per rol',
            scope_by_department: 'Per afdeling',
            scope_framework: 'Kader',
            scope_custom: 'Aangepast',
            reviewer_manager: 'Beheerder',
            reviewer_role_owner: 'Rol Eigenaar',
            reviewer_specific_user: 'Specifieke gebruiker',
            computed_next_run_date: 'Berekende volgende rundatum',
            current_scheduled_date: 'Huidige geplande datum',
            recomputed_frequency_changed: '(opnieuw berekend - frequentie gewijzigd)',
            estimated_days_hint: 'Geschat op basis van [[TOK_1]] dagen vanaf vandaag',
            validation_name_required: 'Naam is vereist',
            validation_frequency_required: 'Frequentie is vereist',
            validation_scope_type_required: 'Scopetype is vereist',
            validation_reviewer_strategy_required: 'Reviewerstrategie is vereist',
            validation_reviewer_id_required: 'Reviewer-ID is vereist voor een specifieke gebruikersstrategie',
            validation_invalid_json: 'Ongeldige [[TOK_0]]',
            validation_scope_filter_invalid_json: 'Bereikfilter bevat ongeldige [[TOK_0]]',
            form_errors: 'Formulier bevat [[TOK_1]] fout(en). Corrigeer ze alstublieft.',
            create_schedule_btn: 'Schema maken',
            schedule_history_title: 'Schemageschiedenis',
            campaign_name_col: 'Campagnenaam',
            items_col: 'Artikelen',
            no_campaigns_yet: 'Er zijn nog geen campagnes gegenereerd',
            loading_history: 'Geschiedenis laden...',
            loading_schedule: 'Schema laden...',
            total_campaigns: 'Totaal aantal campagnes: [[TOK_1]]',
            results_per_page: 'Resultaten per pagina',
            page_size_option: '[[TOK_1]] / pagina',
        },
        sod: {
            title: 'Scheiding van Duties Regels',
            new: 'Nieuw Regel',
            edit: 'Bewerken Regel',
            create_title: 'SoD-regel aanmaken',
            edit_title: 'SoD-regel bewerken',
            rule_name: 'Regel Naam',
            conflicting_permissions: 'Conflicterende rechten',
            permission_a: 'Toestemming A',
            permission_b: 'Toestemming B',
            violations: 'SoD-schendingen',
            violation_user: 'Gebruiker',
            violation_rule: 'Regel Violated',
            violation_date: 'Gedetecteerd At',
            exceptions: 'SoD Uitzonderingen',
            exception_reason: 'Uitzondering Reden',
            exception_approver: 'Goedgekeurd By',
            exception_status: 'Uitzonderingsstatus',
            has_exception: 'Heeft uitzondering',
            no_exception: 'Geen uitzondering',
            grant_exception: 'Uitzondering verlenen',
            granting: 'Verlenen...',
            grant_new_exception: 'Nieuwe uitzondering toestaan',
            exceptions_for: 'Uitzonderingen voor: [[TOK_1]]',
            back_to_rules: 'Terug naar Regels',
            no_violations: 'Geen overtredingen gevonden',
            no_exceptions_found: 'Er zijn geen uitzonderingen gevonden op deze regel',
            all_exception_statuses: 'Alle uitzonderingsstatussen',
            user_id_label: 'Gebruikers-ID',
            justification_label: 'Rechtvaardiging',
            compensating_controls_label: 'Compenserende controles',
            expires_at_label: 'Verloopt op',
            granting_exception_for: 'Een uitzondering toestaan voor regel: [[TOK_1]]',
            severity: 'Ernst',
            severity_warning: 'Waarschuwing',
            severity_blocking: 'Blokkeren',
            violation_count: '[[TOK_1]] overtreding(en)',
            exception_count: '[[TOK_1]] uitzondering(en)',
            rule_description: 'Beschrijving',
            confirm_delete: 'Weet u zeker dat u deze regel wilt verwijderen?',
            deleted: 'Regel verwijderd.',
            framework_code: 'Regelgevend kader',
            name_label: 'Naam *',
            severity_label: 'Ernst *',
            conflict_pairs_legend: 'Conflicterende toestemmingsparen',
            conflict_pairs_hint: 'Elk paar definieert twee machtigingen die niet door dezelfde gebruiker mogen worden beheerd.',
            placeholder_permission_a: '-- Toestemming A --',
            placeholder_permission_b: '-- Toestemming B --',
            permission_a_for_pair: 'Toestemming A voor paar [[TOK_1]]',
            permission_b_for_pair: 'Toestemming B voor paar [[TOK_1]]',
            conflict_pair_label: 'Conflictpaar [[TOK_1]]',
            remove_conflict_pair: 'Conflictpaar verwijderen [[TOK_1]]',
            add_pair: '+ Voeg paar toe',
            placeholder_name: 'bijv. Betalingsgoedkeuring gescheiden',
            create_rule: 'Regel maken',
            loading_rule: 'SoD-regel laden...',
            failed_load_rule: 'Kan regel niet laden.',
            failed_create_rule: 'Kan SoD-regel niet maken.',
            failed_update_rule: 'Kan de SoD-regel niet updaten.',
            validation_name_required: 'Naam is vereist.',
            validation_pair_required: 'Er is ten minste één conflictmachtigingspaar vereist.',
            validation_pair_both_required: 'Koppel [[TOK_1]]: beide machtigingen moeten worden geselecteerd.',
            validation_pair_must_differ: 'Paar [[TOK_1]]: Toestemming A en Toestemming B moeten verschillend zijn.',
            added_conflict_pair: 'Conflictpaar toegevoegd [[TOK_1]]',
            removed_conflict_pair: 'Conflictpaar [[TOK_1]] verwijderd',
            announce_loaded_violations: 'Er zijn [[TOK_1]] overtredingen geladen',
            announce_loaded_exceptions: '[[TOK_1]] uitzonderingen geladen',
            announce_loaded_rules: '[[TOK_1]] SoD-regels geladen',
            announce_loading_exceptions: 'Uitzonderingen laden…',
            regulatory_info: {
                sod_context: 'SoD-regels handhaven de regelgevende rolscheiding die door de PDPL wordt vereist. Overtredingen gekoppeld aan een framework_code kunnen worden opgenomen in kaderspecifieke bewijspakketten (UC-VN-09).',
                violation_export_context: 'SoD-overtredingsexporten bevatten framework_code, conflicterende rollen, ernst, maker en detectiedatum voor bewijspakketten (P-VN-10).',
                exception_context: 'SoD-uitzonderingen produceren audit-bewijs: goedkeurder, rechtvaardiging, compenserende controles en vervaldatum. Verlopen uitzonderingen blijven zichtbaar (UC-VN-09 Stap 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'CMP Integratie',
            status: 'Verbindingsstatus',
            endpoint: 'CMP Eindpunt',
            last_sync: 'Laatste Synchronisatie',
            configure: 'Configureren',
        },
        purpose_mapping: {
            title: 'Doel Toewijzing',
            cmp_purpose: 'CMP Doel',
            grc_purpose: 'GRC Doel',
            mapping_status: 'Toewijzing Status',
            auto_map: 'Auto Toewijzen',
            new_mapping: 'Nieuw Toewijzing',
        },
        webhook: {
            title: 'Webhook Configuratie',
            webhook_url: 'Webhook-URL',
            secret: 'Webhook Geheim',
            events: 'Gebeurtenis Types',
            test_webhook: 'Webhook testen',
        },
        bulk_sync: {
            title: 'Bulk Synchronisatie',
            sync_now: 'Synchronisatie Now',
            last_run: 'Laatste Uitvoeren',
            records_synced: 'Gesynchroniseerde records',
            sync_history: 'Synchronisatie Geschiedenis',
            syncing: 'Synchroniseren...',
        },
        sync_settings: {
            sync_failures: 'Synchronisatie Failures',
            sync_secret_warning: 'Synchronisatie Geheim (save dit now — it will not be shown again):',
            push_description: 'Configureren de GRC Suite naar push case status updates naar AesirX CMP.',
            technical_description: 'Deze configuratie bepaalt hoe de GRC Suite updates van de casestatus pusht naar [[TOK_1]] [[TOK_0]].',
            direction_label: 'Richting',
            direction_value: 'GRC Suite → AesirX CMP (uitgaand)',
            auth_label: 'Authenticatie',
            auth_value: 'HMAC-SHA256-handtekening in X-GRC-Signature-header',
            retry_label: 'Opnieuw proberen Beleid',
            retry_value: '3 retries met exponential backoff (30s, 2min, 10min)',
            inbound_label: 'Inkomend Configuratie',
            inbound_value: 'Inkomend webhook (CMP → GRC) is configured in',
            cmp_webhook_settings: 'CMP Webhook Instellingen',
            page_title: 'CMP Synchronisatie-instellingen',
            outbound_sync_configured: 'Uitgaande synchronisatie geconfigureerd.',
            configure_sync_failed: 'Synchronisatie configureren mislukt',
            configuration_updated: 'Configuratie bijgewerkt.',
            update_configuration_failed: 'Configuratie bijwerken mislukt',
            connection_test_failed: 'Verbindingstest mislukt',
            test_result_message: 'Test verzonden naar {endpoint}. Status: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Nieuw → Onder Beoordelen (assigned)',
                under_review_to_identity_verification: 'Onder Beoordelen → Identity Verificatie',
                under_review_to_in_progress: 'Onder Beoordelen → In Voortgang',
                in_progress_to_completed: 'In Voortgang → Voltooid',
                in_progress_to_denied: 'In Voortgang → Denied',
                any_to_closed: 'Any → Gesloten',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhaken',
            new: 'Nieuw Webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Gebeurtenissen',
            secret: 'Geheim',
            active: 'Actief',
            test: 'Proef',
            create_failed: 'Kan niet create webhook..',
            create_success: 'Webhook succesvol aangemaakt.',
            deactivate_failed: 'Kan niet deactivate webhook..',
            deactivate_success: 'Webhook gedeactiveerd.',
            fetch_failed: 'Kan niet fetch webhooks..',
            send_test_failed: 'Kan niet send test..',
            test_failed: 'Webhook test mislukt.',
            test_success: 'Webhooktest geslaagd.',
            edit_title: 'Webhook bewerken',
            announce_loaded: 'Webhooks geladen',
            update_success: 'Webhook succesvol bijgewerkt.',
            update_failed: 'Kan webhook niet bijwerken.',
            activate_success: 'Webhook geactiveerd.',
            activate_failed: 'Kan webhook niet activeren.',
        },
        domains: {
            title: 'Domeinen',
            new: 'Nieuw Domein',
            domain_name: 'Domein Naam',
            verified: 'Geverifieerd',
            verify: 'Verifiëren',
            add_failed: 'Kan niet add domein..',
            add_success: 'Domein added successfully.',
            domain_placeholder: 'bijv. grc.example.com',
            fetch_failed: 'Kan niet fetch domeinen..',
            remove_failed: 'Kan niet remove domein..',
            remove_success: 'Domein removed successfully.',
            txt_record: 'TXT-record',
            verify_dns_failed: 'DNS verification mislukt.',
            verify_failed: 'Kan niet verify domein..',
            verify_success: 'Domein verified successfully.',
        },
        export_schedules: {
            title: "Exportschema's",
            new: 'Nieuw Plannen',
            schedule_name: 'Naam',
            frequency: 'Frequentie',
            format: 'Formaat',
            last_run: 'Laatste Uitvoeren',
            next_run: 'Volgende Uitvoeren',
            create_failed: 'Kan niet create planning..',
            create_success: 'Plannen created successfully.',
            day_of_month: 'Dag van Maand',
            day_of_week: 'Dag van Week',
            deactivate_failed: 'Kan niet deactivate planning..',
            deactivate_success: 'Plannen deactivated.',
            fetch_failed: 'Kan niet fetch planningen..',
            freq_daily: 'Dagelijks',
            freq_monthly: 'Maandelijks',
            freq_weekly: 'Wekelijks',
            recipients: 'Ontvangers',
            time_utc: 'Tijd (UTC)',
            trigger_failed: 'Kan niet trigger export..',
            trigger_success: 'Exporteren triggered successfully.',
            type_audit_trail: 'Auditspoor',
            type_compliance_report: 'Naleving Rapport',
            type_custom: 'Aangepast',
            type_incident_report: 'Incident Rapport',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: 'E-maillogboek',
            recipient: 'Ontvanger',
            subject: 'Onderwerp',
            sent_at: 'Verzonden op',
            status: 'Toestand',
            resend: 'Opnieuw verzenden',
            fetch_failed: 'Kan niet fetch e-mail logs..',
        },
    },
    organizations: {
        title: 'Organisaties',
        create: 'Aanmaken Organisatie',
        edit: 'Bewerken Organisatie',
        name: 'Naam',
        slug: 'URL-naam',
        timezone: 'Tijdzone',
        locale: 'Standaard Taalinstelling',
        parent: 'Bovenliggend Organisatie',
        group: 'Groep',
        org_group: 'Organisatiegroep',
        no_group: '(Geen – niet in een groep)',
        created: 'Aangemaakt',
        no_parent: '(Geen – zelfstandig)',
        no_orgs: 'Geen organisaties gevonden',
        load_error: 'Kan niet load organisaties',
        save_error: 'Kan niet save organisatie',
        created_msg: 'Organisatie created',
        updated: 'Organisatie updated',
        deactivate: 'Deactiveren',
        deactivated: 'Organisatie deactivated',
        confirm_deactivate: 'Are you sure you want naar deactivate dit organisatie?',
        loaded_results: 'Organizations geladen, {count} resultaten',
        form_loaded: 'Organization-formulier geladen',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        locale_en_us: 'Engels (en-VS)',
    },
    intake_configs: {
        title: 'Openbaar Intake Configs',
        create: 'Aanmaken Configuratie',
        edit: 'Bewerken Intake Configuratie',
        label_col: 'Kenmerk',
        key: 'Intake Sleutel',
        key_hint: 'Openbaar URL will be: /rights-request?key=',
        mapped_org: 'Doel Organisatie',
        status: 'Toestand',
        enabled: 'Ingeschakeld',
        disabled: 'Uitgeschakeld',
        request_types: 'Ingeschakeld Verzoek Types',
        language: 'Standaard Taal',
        public_url: 'Openbaar URL',
        no_configs: 'Geen intake configs gevonden Aanmaken one naar enable public rights request forms..',
        load_error: 'Kan niet load intake configs',
        save_error: 'Kan niet save',
        delete_error: 'Kan niet delete',
        created_msg: 'Configuratie created',
        updated: 'Configuratie updated',
        deleted: 'Intake configuratie deleted',
        confirm_delete: 'Verwijderen dit intake configuratie?',
        select_types: 'Selecteren bij least one request type',
        select_org: 'Selecteren een target organisatie',
        routing_mode: 'Routeringsmodus',
        single_org: 'Enkele Organisatie',
        org_group_mode: 'Organisatiegroep',
        org_group: 'Organisatiegroep',
        select_group: 'Selecteer een organisatiegroep...',
        group_root_hint: 'Wordt automatisch ingesteld op de hoofdorganisatie van de groep wanneer de groep wordt geselecteerd.',
        loaded_results: 'Intake configurations geladen, {count} resultaten',
        form_loaded: 'Intake configuration-formulier geladen',
    },
    frequency: {
        weekly: 'Wekelijks',
        monthly: 'Maandelijks',
        quarterly: 'Kwartaal',
        semi_annually: 'Halfjaarlijks',
        annually: 'Jaarlijks',
        custom: 'Aangepast',
    },
    task_management: {
        nav: {
            calendar: 'Kalender',
            all_tasks: 'Alle taken',
            my_tasks: 'Mijn taken',
            overdue: 'Te laat',
            board: 'Bord',
            workflows: 'Werkstromen',
        },
        list: {
            title: 'Alle taken',
            my_title: 'Mijn taken',
            overdue_title: 'Te late taken',
            new_task: 'Taak aanmaken',
            no_tasks: 'Geen taken gevonden.',
            empty_state: 'Geen taken gevonden. Taken worden gegenereerd vanuit moduleworkflows zoals beoordelingen, incidenten en beoordelingscampagnes.',
            total: 'Totaal taken',
            search_placeholder: 'Taken zoeken...',
            bulk_actions: 'Bulkacties',
            change_status: 'Status wijzigen',
            change_priority: 'Prioriteit wijzigen',
            assign: 'Toewijzen',
            sr_my_tasks_count: '{count} taken aan u toegewezen',
            sr_days_overdue: '{count} dagen te laat',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Taakdetail',
            description: 'Beschrijving',
            workflow_progress: 'Workflowvoortgang',
            checklist: 'Controlelijst',
            dependencies: 'Afhankelijkheden',
            comments: 'Opmerkingen',
            activity_timeline: 'Activiteitstijdlijn',
            assignees: 'Toegewezenen',
            add_assignee: 'Toegewezene toevoegen',
            remove_assignee: 'Toegewezene verwijderen',
            due_date: 'Vervaldatum',
            start_date: 'Startdatum',
            sla_status: 'SLA-status',
            sla_on_track: 'Op schema',
            sla_at_risk: 'In gevaar',
            sla_breached: 'Geschonden',
            tags: 'Labels',
            source_entity: 'Bronentiteit',
            view_source: 'Bron weergeven',
            add_dependency: 'Afhankelijkheid toevoegen',
            remove_dependency: 'Afhankelijkheid verwijderen',
            write_comment: 'Schrijf een opmerking...',
            post_comment: 'Plaatsen',
            edit_comment: 'Bewerken',
            delete_comment: 'Verwijderen',
            add_checklist_item: 'Item toevoegen',
            no_dependencies: 'Geen afhankelijkheden',
            no_comments: 'Nog geen opmerkingen',
            blocks: 'Blokkeert',
            blocked_by: 'Geblokkeerd door',
            related: 'Gerelateerd',
            working_days_remain: 'werkdagen resterend',
            created_by: 'Aangemaakt door',
            completed_at: 'Voltooid op',
            no_assignees: 'Geen toegewezenen',
            add_assignee_placeholder: 'Voer gebruikers-ID in...',
            edited: 'bewerkt',
            timeline: 'Activiteitstijdlijn',
            no_timeline: 'Nog geen activiteit',
            no_workflow: 'Geen workflow toegewezen',
            add_dependency_placeholder: 'Voer taak-ID in...',
            sr_status_updated: 'Status bijgewerkt naar [[TOK_1]]',
            sr_priority_updated: 'Prioriteit bijgewerkt naar [[TOK_1]]',
            convert_to_workflow: 'Uitvoeren als workflow',
            convert_modal_title: 'Converteer taak naar werkstroomuitvoering',
            convert_workflow_label: 'Werkstroom',
            convert_workflow_placeholder: 'Kies een werkstroom...',
            convert_attachments_label: 'Bijlagen',
            convert_attachments_empty: 'Geen bijlagen bij deze taak.',
            convert_persona_label: 'Persona-overschrijving (optioneel)',
            convert_submit: 'Start de werkstroomuitvoering',
            convert_starting: 'Werkstroomuitvoering starten...',
            convert_started: 'Workflowrun gestart - openingsrun...',
            convert_disabled_in_flight: 'Er wordt al een werkstroom uitgevoerd voor deze taak.',
            linked_workflow_chip: 'Van [[TOK_1]]',
            linked_chat_chip: 'Van [[TOK_0]] Chat',
            linked_more: '+[[TOK_1]] meer',
        },
        calendar: {
            title: 'Taakkalender',
            page_title: 'Kalender',
            create_task: 'Taak aanmaken',
            month: 'Maand',
            week: 'Week',
            day: 'Dag',
            today: 'Vandaag',
            more_tasks: '+[[TOK_1]] meer',
            no_tasks_day: 'Geen taken deze dag',
            all_day: 'Hele dag',
            quick_create_tooltip: 'Taak aanmaken voor deze dag',
            view_changed: 'Kalenderweergave gewijzigd naar {view}',
            tasks_in_view: '{count} taken in weergave',
            task_in_view: '[[TOK_1]] taak in beeld',
        },
        filters: {
            assignee: 'Toegewezene',
            me: 'Mij',
            role: 'Rol',
            status: 'Status',
            priority: 'Prioriteit',
            task_type: 'Taaktype',
            source_module: 'Bronmodule',
            organization: 'Organisatie',
            sla_breached_only: 'Alleen SLA-geschonden tonen',
            clear_filters: 'Filters wissen',
            apply_filters: 'Toepassen',
            source_label: 'Bron',
            source_manual: 'Handmatig',
            source_module_kind: 'Module-gegenereerd',
            source_chat: 'Van [[TOK_0]] Chat',
            source_workflow_run: 'Van [[TOK_0]] Workflowuitvoering',
        },
        status: {
            pending: 'In afwachting',
            in_progress: 'In behandeling',
            blocked: 'Geblokkeerd',
            completed: 'Voltooid',
            overdue: 'Te laat',
            escalated: 'Geëscaleerd',
            cancelled: 'Geannuleerd',
        },
        priority: {
            critical: 'Kritiek',
            high: 'Hoog',
            medium: 'Gemiddeld',
            low: 'Laag',
        },
        task_types: {
            manual_task: 'Handmatige taak',
            dsr_case: 'DSR-zaak',
            dsr_review: 'DSR-beoordeling',
            dsr_escalation: 'DSR-escalatie',
            dpia_review: 'DPIA-beoordeling',
            dpia_approval: 'DPIA-goedkeuring',
            transfer_review: 'Overdrachtsbeoordeling',
            incident_task: 'Incidenttaak',
            incident_notification: 'Incidentmelding',
            playbook_step: 'Playbook-stap',
            regulator_deadline: 'Regelgevingsdeadline',
            monitoring_task: 'Monitoringtaak',
            kpi_alert: 'KPI-waarschuwing',
            vendor_review: 'Leveranciersbeoordeling',
            vendor_questionnaire: 'Leveranciersvragenlijst',
            governance_review: 'Bestuursbeoordeling',
            drift_alert: 'Afwijkingswaarschuwing',
            governance_approval: 'Bestuursgoedkeuring',
            deletion_task: 'Verwijderingstaak',
            deletion_verification: 'Verwijderingsverificatie',
            access_review: 'Toegangsbeoordeling',
            sod_alert: 'SoD-waarschuwing',
            consent_workflow: 'Toestemmingsworkflow',
            consent_alert: 'Toestemmingswaarschuwing',
            property_review: 'Eigenschapsbeoordeling',
            inconsistency_alert: 'Inconsistentiewaarschuwing',
            form_review: 'Formulierbeoordeling',
            dossier_deadline: 'Dossierdeadline',
            submission_task: 'Indieningstaak',
            translation_review: 'Vertalingsbeoordeling',
            governance_task: 'Bestuurstaak',
            reporting_deadline: 'Rapportagedeadline',
            scanner_alert: 'Scannerwaarschuwing',
            classification_review: 'Classificatiebeoordeling',
            lifecycle_task: 'Levenscyclustaak',
            discovery_review: 'Ontdekkingsbeoordeling',
        },
        task_type_groups: {
            manual: 'Handmatig',
            dsr: 'DSR / Rechtenverzoeken',
            assessments: 'Beoordelingen',
            incidents: 'Incidenten',
            incident_ops: 'Incidentoperaties',
            monitoring: 'Toezicht',
            vendor_risk: 'Leveranciersrisico',
            governance: 'Bestuur',
            deletion: 'Verwijdering',
            access_review: 'Toegangsbeoordeling',
            consent: 'Toestemming',
            consent_properties: 'Toestemmingseigenschappen',
            forms: 'Formulieren',
            localization: 'Lokalisatie',
            program_governance: 'Programmabestuur',
            privacy_scanner: 'Privacyscanner',
            classification: 'Classificatie',
            discovery: 'Ontdekking',
        },
        create: {
            title: 'Taak aanmaken',
            task_title: 'Titel',
            task_description: 'Beschrijving',
            task_type: 'Taaktype',
            task_type_label: 'Taaktype',
            task_type_placeholder: 'Selecteer een taaktype',
            priority: 'Prioriteit',
            assignees: 'Toegewezenen',
            assignee_search_placeholder: 'Gebruikers zoeken...',
            due_date: 'Vervaldatum',
            start_date: 'Startdatum',
            checklist: 'Controlelijst',
            tags: 'Labels',
            add_checklist_item: 'Checklistitem toevoegen',
            validation: {
                title_required: 'Titel is verplicht',
                title_max_length: 'Titel mag maximaal 500 tekens bevatten',
                description_max_length: 'Beschrijving mag maximaal 5000 tekens bevatten',
                due_date_before_start: 'Vervaldatum moet na startdatum liggen',
                max_reminders: 'Maximaal 5 herinneringen per taak',
            },
            reminders: {
                title: 'Herinneringen',
                add: 'Herinnering toevoegen',
                at_due_date: 'Op vervaldatum',
                minutes_before: '[[TOK_1]] minuten eerder',
                hours_before: '[[TOK_1]] uur eerder',
                days_before: '[[TOK_1]] dagen ervoor',
                weeks_before: '[[TOK_1]] weken eerder',
                custom: 'Aangepast',
                channel_platform: 'Platform',
                channel_email: 'E-mail',
                channel_both: 'Beide',
            },
            workflow: {
                label: 'Werkstroom',
                none: 'Geen (handmatig statusbeheer)',
                steps_count: '[[TOK_1]] stappen',
                preview_label: 'Workflowstappen',
            },
        },
        errors: {
            fetch_failed: 'Taken konden niet worden geladen.',
            save_failed: 'Taak kon niet worden opgeslagen.',
            delete_failed: 'Taak kon niet worden verwijderd.',
            status_change_failed: 'Taakstatus kon niet worden gewijzigd.',
            assign_failed: 'Taak kon niet worden toegewezen.',
            comment_failed: 'Opmerking kon niet worden opgeslagen.',
            checklist_failed: 'Bijwerken van checklist mislukt.',
            dependency_failed: 'Bijwerken van afhankelijkheid mislukt.',
            workflow_failed: 'Workflow kon niet worden opgeslagen.',
            workflow_activate_failed: 'Workflow kon niet worden geactiveerd.',
            workflow_delete_failed: 'Workflow kon niet worden verwijderd.',
            template_install_failed: 'Sjabloon kon niet worden geïnstalleerd.',
            search_failed: 'Zoeken mislukt.',
            convert_failed: 'Kan de werkstroomuitvoering niet starten.',
            convert_quota_exhausted: 'Tokenemmer laag. Vul bij voordat u opnieuw begint.',
        },
        dependency_types: {
            blocks: 'Blokkeert',
            blocked_by: 'Geblokkeerd door',
            related: 'Gerelateerd',
        },
        workflow: {
            current_step: 'Huidige stap',
            transition: 'Overgang',
            history: 'Stapgeschiedenis',
            no_workflow: 'Geen workflow toegewezen',
            detail_title: 'Workflowdetails',
            list_title: 'Workflowdefinities',
            create_workflow: 'Workflow aanmaken',
            browse_templates: 'Sjablonen bekijken',
            template_catalog_title: 'Workflowsjablooncatalogus',
            name: 'Naam',
            description: 'Beschrijving',
            task_types: 'Taaktypen',
            steps: 'Stappen',
            version: 'Versie',
            created: 'Aangemaakt',
            actions: 'Acties',
            status_draft: 'Concept',
            status_active: 'Actief',
            status_archived: 'Gearchiveerd',
            activate: 'Activeren',
            archive: 'Archiveren',
            save: 'Opslaan',
            edit: 'Bewerken',
            delete: 'Verwijderen',
            clone: 'Klonen',
            install: 'Installeren',
            installed: 'Geïnstalleerd',
            system: 'Systeem',
            general_settings: 'Algemene instellingen',
            default_assignment: 'Standaardtoewijzing',
            default_sla: 'Standaard SLA',
            workflow_steps: 'Workflowstappen',
            add_step: 'Stap toevoegen',
            step_name: 'Stapnaam',
            step_status: 'Statuswaarde',
            assignment_strategy: 'Toewijzingsstrategie',
            assignment_role: 'Toewijzingsrol',
            sla_hours: 'SLA-uren',
            sla_calendar_type: 'Kalendertype',
            working_days: 'Werkdagen',
            calendar_days: 'Kalenderdagen',
            is_terminal: 'Eindstap',
            required_fields: 'Verplichte velden',
            checklist_template: 'Checklistsjabloon',
            transitions: 'Overgangen',
            add_transition: 'Overgang toevoegen',
            from_step: 'Van',
            to_step: 'Naar',
            permission: 'Toestemming',
            sla_action: 'SLA-actie',
            notify: 'Melden',
            escalation_rules: 'Escalatieregels',
            add_rule: 'Regel toevoegen',
            trigger: 'Trigger',
            threshold: 'Drempelwaarde',
            action: 'Actie',
            target_role: 'Doelrol',
            trigger_sla_threshold: 'SLA-drempel',
            trigger_sla_breach: 'SLA-schending',
            trigger_blocked_duration: 'Geblokkeerde duur',
            trigger_manual: 'Handmatig',
            action_notify: 'Melden',
            action_escalate: 'Escalatieniveau',
            action_reassign: 'Opnieuw toewijzen',
            sla_start: 'Begin',
            sla_pause: 'Pauzeren',
            sla_resume: 'Hervatten',
            sla_stop: 'Stoppen',
            strategy_manual: 'Handmatig',
            strategy_role_based: 'Rolgebaseerd',
            strategy_round_robin: 'Ronde Robin',
            strategy_least_loaded: 'Minst belast',
            strategy_creator: 'Aanmaker',
            confirm_delete: 'Weet u zeker dat u deze workflow wilt verwijderen?',
            confirm_archive: 'Weet u zeker dat u deze workflow wilt archiveren?',
            cannot_delete_active: 'Actieve workflows kunnen niet worden verwijderd. Archiveer eerst.',
            validation_errors: 'Workflowvalidatiefouten',
            step_count: '[[TOK_1]] stappen',
            no_workflows: 'Geen workflows gevonden.',
            no_templates: 'Geen sjablonen beschikbaar.',
            sr_templates_count: '[[TOK_1]] sjablonen beschikbaar',
            template_installed: 'Sjabloon succesvol geïnstalleerd.',
            activate_success: 'Workflow succesvol geactiveerd.',
            archive_success: 'Workflow succesvol gearchiveerd.',
            save_success: 'Workflow succesvol opgeslagen.',
            delete_success: 'Workflow succesvol verwijderd.',
        },
        columns: {
            priority: 'Prioriteit',
            title: 'Titel',
            status: 'Status',
            type: 'Typ',
            assignees: 'Toegewezene(n)',
            due_date: 'Vervaldatum',
            source: 'Bron',
            actions: 'Acties',
        },
        groups: {
            overdue: 'Te laat',
            due_today: 'Vandaag verschuldigd',
            due_this_week: 'Deze week verschuldigd',
            due_later: 'Later verschuldigd',
            no_due_date: 'Geen vervaldatum',
        },
        board: {
            title: 'Taakbord',
            drag_hint: 'Sleep taken tussen kolommen om de status te wijzigen',
            empty_column: 'Geen taken',
            keyboard_hint: 'Toetsenbord: pijltoetsen om te navigeren, spatie om een taak op te pakken, links/rechts om kolom te selecteren, Enter om neer te zetten, Escape om te annuleren.',
            sr_moving: '{title} verplaatsen. Boven {column}. Druk Enter om neer te zetten, Escape om te annuleren.',
            sr_tasks_shown: '{count} taken weergegeven',
            sr_picked_up: '{title} opgepakt',
            sr_returned: '[[TOK_2]] is teruggekeerd naar [[TOK_3]]',
            sr_dropped: '{title} neergezet in {column}, positie {position} van {total}',
            sr_move_cancelled: 'Verplaatsing geannuleerd',
            sr_over_column: 'Boven {column}',
            sr_moved_to: '{title} verplaatst naar {column}',
            invalid_transition: 'Kan taak niet verplaatsen van {from} naar {to}.',
            terminal_status: 'Deze taak heeft een eindstatus en kan niet worden verplaatst.',
            invalid_drop_target: 'Ongeldig doel',
        },
        team: {
            title: 'Teamwerkbelasting',
            assignee: 'Toegewezene',
            active: 'Actief',
            overdue: 'Te laat',
            blocked: 'Geblokkeerd',
            completed_7d: 'Voltooid (7d)',
            load: 'Belasting',
            load_high: 'Hoog',
            load_medium: 'Gemiddeld',
            load_normal: 'Normaal',
        },
        graph: {
            title: 'Afhankelijkheidsgrafiek',
            list_view: 'Lijstweergave',
            graph_view: 'Grafiekweergave',
            zoom_in: 'Inzoomen',
            zoom_out: 'Uitzoomen',
            reset_zoom: 'Opnieuw instellen',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Geen afhankelijkheden om te visualiseren.',
        },
        add_dependency_modal: {
            title: 'Afhankelijkheid toevoegen',
            search_placeholder: 'Zoek taken op titel of ID...',
            no_results: 'Geen taken gevonden.',
            this_blocks: 'Deze taakblokken zijn geselecteerd',
            this_blocked_by: 'Deze taak is geblokkeerd door geselecteerd',
            related: 'Gerelateerd',
            max_dependencies: 'Maximaal 10 afhankelijkheden per taak.',
            circular_error: 'Kan niet toevoegen: zou een circulaire afhankelijkheid creëren.',
        },
        conflict_detection: {
            title: 'Conflictdetectie',
            unresolved: 'onopgelost',
            no_conflicts: 'Geen conflicten gedetecteerd',
            section: 'Sectie',
            field: 'Veld',
            dept_a: 'Afdeling A',
            value_a: 'Waarde A',
            dept_b: 'Afdeling B',
            value_b: 'Waarde B',
            severity: 'Ernst',
            status: 'Status',
            resolved: 'Opgelost',
            open: 'Openen',
            resolve: 'Oplossen',
            load_failed: 'load conflicts mislukt',
            resolve_success: 'Conflict succesvol opgelost',
            resolve_failed: 'resolve conflict mislukt',
            severity_critical: 'Kritisch',
            severity_warning: 'Waarschuwing',
            severity_info: 'Info',
        },
        consolidation: {
            title: 'Consolidatievoortgang',
            add_child: 'Subtaak toevoegen',
            child_task_id: 'Subtaak-ID',
            department_id: 'Afdelings-ID',
            link: 'Koppelen',
            overall_completion: 'Algehele voltooiing',
            departments_complete: 'Afdelingen voltooid',
            overdue: 'Te laat',
            ready: 'Gereed',
            not_ready: 'Niet gereed',
            master_status: 'Hoofdstatus',
            department_breakdown: 'Afdelingsoverzicht',
            department: 'Afdeling',
            status: 'Status',
            completion: 'Voltooiing',
            due_date: 'Vervaldatum',
            overdue_flag: 'Te laat',
            child_tasks: 'Subtaken',
            task: 'Taak',
            load_failed: 'load consolidation data mislukt',
            child_linked: 'Subtaak succesvol gekoppeld',
            link_failed: 'link child task mislukt',
            confirm_unlink: 'Weet u zeker dat u deze subtaak wilt ontkoppelen?',
            child_unlinked: 'Subtaak ontkoppeld',
            unlink_failed: 'Ontkoppelen van subtaak mislukt',
            unlink: 'Ontkoppelen',
            status_completed: 'Voltooid',
            status_in_progress: 'In uitvoering',
            status_pending: 'In afwachting',
            select_child_task: 'Selecteer subtaak',
            select_department: 'Selecteer afdeling',
        },
        section_assignments: {
            title: 'Sectietoewijzingen',
            assign_section: 'Sectie toewijzen',
            section_ref: 'Sectiereferentie',
            section_label: 'Sectielabel',
            department_id: 'Afdelings-ID',
            department: 'Afdeling',
            assignee_id: 'Toegewezen-ID',
            assignee: 'Toegewezen persoon',
            mandatory: 'Verplicht',
            assign: 'Toewijzen',
            no_assignments: 'Geen sectietoewijzingen',
            status: 'Status',
            completion: 'Voltooiing',
            mark_complete: 'Voltooien',
            load_failed: 'load section assignments mislukt',
            assign_success: 'Sectie succesvol toegewezen',
            assign_failed: 'assign section mislukt',
            status_updated: 'Status bijgewerkt',
            status_update_failed: 'Bijwerken van status mislukt',
            section_ref_placeholder: 'bijv. 3.2',
            status_completed: 'Voltooid',
            status_in_progress: 'In uitvoering',
            status_pending: 'In afwachting',
            select_department: 'Selecteer afdeling',
            select_assignee: 'Selecteer persoon',
        },
        overdue_columns: {
            days_overdue: 'Dagen te laat',
        },
        regulatory_info: {
            deadline_context: 'Bij het aanmaken van DPIA-taken moeten vervaldatums overeenkomen met PDPL-indieningsdeadlines: afdelingsinvoer = 10 werkdagen. Cyberbeveiligings- en telecomdeadlines zijn ook van toepassing.',
            overdue_deadline_context: 'Regelgevende deadlines uit pakketgegevens: PDPL afdelingsinvoer = 10 werkdagen, aanvullend antwoord = 15 werkdagen, herindiening = 10 werkdagen. SLA-geschonden taken worden visueel onderscheiden.',
            section_assignment_context: 'DPIA multi-afdelingsworkflow (PDPL-P1): DPO wijst dossiersecties toe aan afdelingen. Afdelingsinvoerdeadline: 10 werkdagen.',
            template_catalog_context: 'Systeemsjablonen dekken kaderspecifieke processen: PDPL DPIA, Datawet-attestering, cyberbeveiligingsincidentrespons, telecom-autoriteitsverzoeken en AI-registratie. Systeemsjablonen zijn niet bewerkbaar.',
            workflow_instantiation_context: 'Geinstalleerde sjablonen kunnen worden geinstantieerd naar live workflows. Taken worden automatisch aangemaakt met berekende vervaldatums.',
        },
    },
    notifications: {
        bell: {
            title: 'Meldingen',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Meldingen',
            mark_all_read: 'Markeer alles als gelezen',
            no_notifications: 'Geen meldingen',
            filter: {
                all: 'All',
                unread: 'Ongelezen',
                tasks: 'Taken',
                approvals: 'Goedkeuringen',
                alerts: 'Waarschuwingen',
            },
        },
        preferences: {
            title: 'Meldingsvoorkeuren',
            description: 'Configureer hoe u meldingen ontvangt',
            category: {
                label: 'Categorie',
                task_assigned: 'Taak toegewezen',
                task_sla_approaching: '[[TOK_0]] Ik nader',
                task_overdue: 'Taak achterstallig',
                task_completed: 'Taak voltooid',
                task_escalated: 'Taak geëscaleerd',
                workflow_transition: 'Workflow-transitie',
                approval_requested: 'Goedkeuring aangevraagd',
                comment_added: 'Commentaar toegevoegd',
                weekly_digest: 'Wekelijkse samenvatting',
                sla_breach_report: '[[TOK_0]] Schendingsrapport',
                system_alert: 'Systeemwaarschuwing',
            },
            channel: {
                platform: 'Platform',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Rustige uren',
                start: 'Starten',
                end: 'End',
                timezone: 'Tijdzone',
            },
            digest: {
                title: 'Digest-frequentie',
                daily: 'Dagelijks',
                weekly: 'Wekelijks',
                none: 'Geen',
            },
            watched: {
                title: 'Gekeken entiteiten',
                empty: 'Geen bekeken entiteiten',
            },
            save: 'Bewaar voorkeuren',
            saving: 'Opslaan...',
            saved_success: 'Voorkeuren zijn succesvol opgeslagen',
            load_error: 'Kan opgeslagen voorkeuren niet laden. Standaardwaarden weergeven: wijzigingen worden opgeslagen wanneer u op Opslaan klikt.',
            enabled: 'Ingeschakeld',
            disabled: 'Uitgeschakeld',
            unwatch: 'Uitkijken',
        },
        admin_queue: {
            title: 'Beheerderswachtrij voor meldingen',
            description: 'E-mailbezorgingsstatus bewaken en mislukte berichten opnieuw proberen',
            load_error: 'Kan e-mailwachtrijgegevens niet laden',
            retry_error: 'Kan e-mail niet opnieuw proberen',
            filter_status: 'Filteren op status',
            all_statuses: 'Alle',
            refresh: 'Vernieuwen',
            status_queued: 'In wachtrij',
            status_sent: 'Verzonden',
            status_failed: 'Mislukt',
            status_bounced: 'Geweigerd',
            col_recipient: 'Ontvanger',
            col_category: 'Categorie',
            col_template: 'Sjabloon',
            col_status: 'Status',
            col_retries: 'Pogingen',
            col_created: 'Aangemaakt',
            col_sent: 'Verzonden op',
            col_actions: 'Acties',
            no_items: 'Geen items in de e-mailwachtrij gevonden',
            retry: 'Opnieuw proberen',
            retrying: 'Opnieuw aan het proberen...',
            prev: 'Vorige',
            next: 'Volgende',
            access_denied_title: 'Beheerderstoegang vereist',
            access_denied: 'Deze pagina is alleen beschikbaar voor beheerders. Neem contact op met uw beheerder als u toegang nodig heeft.',
            announce_queue_loaded: 'E-mailwachtrij geladen, [[TOK_1]] items',
            announce_processed: 'Verwerkte [[TOK_1]] e-mail(s)',
            process_now: 'Verwerk nu',
            processing_ellipsis: 'Verwerken…',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'UI-assistentie',
            activate: 'Activeer',
            deactivate: 'Deactiveren',
            connected: 'Verbonden',
            disconnected: 'Verbinding verbroken',
            disconnected_hint: "Verbinding verbroken: voer 'npm run relay' uit om verbinding te maken met Claude CLI",
            open_panel: 'Open het UI Assist-paneel',
            history: 'Geschiedenis',
            settings: 'Instellingen',
        },
        prompt: {
            placeholder: 'Beschrijf de verandering die u wilt doorvoeren...',
            send: 'Verzenden',
            cancel: 'Annuleer',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Verwerken…',
            complete: 'Compleet',
            error: 'Fout',
            abort: 'Afbreken',
            abort_confirm: 'Weet u zeker dat u wilt afbreken?',
            aborted_hint: 'Sessie werd onderbroken — u kunt vanaf hier verdergaan.',
            undo: 'Ongedaan maken',
            redo: 'Opnieuw uitvoeren',
            retry: 'Opnieuw proberen',
            dismiss: 'Negeren',
        },
        label: {
            component: 'Onderdeel',
            element: 'Element',
            file: 'Bestand',
        },
        response: {
            you: 'You',
            claude: 'Claude',
            empty: 'Nog geen berichten. Selecteer elementen en stuur een prompt om aan de slag te gaan.',
        },
        panel: {
            tab_conversation: 'Chatten',
            tab_tasks: 'Taken',
            tab_sprint: 'Sprinten',
            tab_sessions: 'Sessies',
            tab_lobby: 'Lobby',
            follow_up: 'Vervolg',
            followup_placeholder: 'Stel een vervolgvraag…',
            interrupt_placeholder: 'Typ om te onderbreken en om te leiden…',
            send_interrupt: 'Verzenden & Onderbreken',
            will_interrupt: 'Breekt het huidige antwoord af en verzendt dit in plaats daarvan',
            expand: 'Uitvouwen naar volledig scherm',
            collapse: 'Samenvouwen naar zijpaneel',
            no_sessions: 'Geen eerdere sessies. Selecteer elementen en stuur een bericht om te beginnen.',
            session_active: 'Actief',
            session_ended: 'Beëindigd',
            session_messages: '{count} berichten',
            switch_session: 'Overschakelen naar deze sessie',
            load_session: 'Sessiegeschiedenis laden',
            session_restored: 'Sessie hersteld uit de geschiedenis',
            archive_session: 'Archiefsessie',
            archive_confirm: 'Deze sessie archiveren? Het sessiebestand wordt verwijderd.',
            new_session: 'Nieuwe sessie',
            new_session_desc: 'Gebruik Activeren om een UI-element te selecteren en een nieuwe sessie te starten',
            start_new_session: 'Nieuwe sessie starten',
            no_active_session_chat: 'Start een nieuwe sessie of gebruik Activeren om een UI-element op de pagina te selecteren om te beginnen.',
            no_active_session_tasks: 'Start een nieuwe sessie of selecteer een bestaande sessie om taken aan te maken.',
            no_active_session_sprint: 'Start een nieuwe sessie of selecteer een bestaande sessie om een sprint te plannen.',
            previous_sessions: 'Vorige sessies',
        },
        tasks: {
            none_found: 'Geen taken gevonden in het antwoord. Vraag Claude om taken voor te stellen.',
            selected: 'selected',
            create_selected: 'Taken maken',
            execute_tasks: 'Taken uitvoeren',
            creating: 'Creëren…',
            created: 'taken gecreëerd',
            create_error: 'Kan taak niet maken',
            plan_sprint: 'Sprint plannen',
            priority_critical_desc: 'Blokkerend — direct oplossen',
            priority_high_desc: 'Belangrijk — deze sprint oplossen',
            priority_medium_desc: 'Normaal — plannen voor komende sprint',
            priority_low_desc: 'Nice to have — backlog-kandidaat',
            add_custom: 'Taak toevoegen',
            add_title_placeholder: 'Taaktitel…',
            add_desc_placeholder: 'Beschrijving (optioneel)',
            add_save: 'Toevoegen',
            add_cancel: 'Annuleren',
        },
        sprint: {
            title: 'Sprintplanner',
            assigned: 'assigned',
            new_placeholder: 'Sprintnaam (bijv. Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Achterstand',
            move_to: 'Ga naar…',
            empty: 'Maak een sprintgroep en wijs er taken aan toe.',
            create_all: 'Maak alle taken',
            remove: 'Verwijderen',
            drop_here: 'Wijs taken toe vanuit de onderstaande backlog',
            add_task: 'Taak toevoegen vanuit achterstand…',
        },
        feature_disabled: 'UI Assist is niet ingeschakeld',
        permission_denied: 'U heeft geen toestemming om UI Assist te gebruiken',
    },
    license: {
        title: 'Licentie & pakket',
        current_license: 'Huidige licentie',
        license_key: 'Licentiesleutel',
        activate: 'Activeer licentie',
        deactivate: 'Licentie deactiveren',
        validate_now: 'Valideer nu',
        status: 'Licentiestatus',
        active: 'Actief',
        expired: 'Verlopen',
        suspended: 'Opgeschort',
        invalid: 'Ongeldig',
        pending: 'In behandeling',
        no_license: 'Geen licentie',
        expires_at: 'Verloopt',
        last_validated: 'Laatst gevalideerd',
        domain: 'Gelicentieerd domein',
        activation_success: 'Licentie succesvol geactiveerd.',
        activation_failed: 'Licentieactivering mislukt.',
        domain_mismatch: 'Licentiedomein komt niet overeen met het huidige domein.',
        deactivation_success: 'Licentie gedeactiveerd.',
        validation_success: 'Licentie succesvol gevalideerd.',
        validation_failed: 'Licentievalidatie mislukt.',
        enter_key: 'Voer uw licentiesleutel in',
        confirm_deactivate: 'Weet u zeker dat u deze licentie wilt deactiveren? Modulebeperkingen zijn van toepassing op basis van het standaardniveau.',
    },
    package_mgmt: {
        title: 'Pakket',
        module_column: 'Module',
        current_tier: 'Huidig pakket',
        light: 'Licht',
        standard: 'Standaard',
        enterprise_unlimited: 'Onderneming onbeperkt',
        change_package: 'Pakket wijzigen',
        upgrade: 'Upgraden',
        downgrade: 'Downgraden',
        target_tier: 'Doelpakket',
        new_license_key: 'Licentiesleutel voor doelpakket',
        confirm_change: 'Bevestig pakketwijziging',
        change_success: 'Pakket succesvol gewijzigd.',
        change_failed: 'Pakketwijziging mislukt.',
        modules_included: 'Modules inbegrepen',
        modules_restricted: 'Niet beschikbaar in huidig pakket',
        upgrade_to_enable: 'Upgrade om deze module in te schakelen.',
        module_availability: 'Beschikbaarheid van modules',
        comparison: 'Pakketvergelijking',
        power_users: 'Hoofdgebruikers',
        unlimited: 'Onbeperkt',
        impact_warning: 'Als u downgradet, worden de volgende modules uitgeschakeld:',
        invalid_license: 'De verstrekte licentiesleutel is niet geldig voor dit pakket.',
        tier_mismatch: 'De licentiesleutel is voor een andere pakketlaag.',
    },
    board_report: {
        title: 'Bestuurlijk Compliancerapport',
        subtitle: 'Samenvatting van compliance over alle modules',
        date_from: 'Datum vanaf',
        date_to: 'Datum tot',
        language: 'Rapporttaal',
        generate: 'Rapport genereren',
        generating: 'Rapport wordt gegenereerd...',
        download_pdf: 'PDF downloaden',
        close: 'Rapport sluiten',
        open_board_report: 'Bestuursrapport genereren',
        close_board_report: 'Bestuursrapport sluiten',
        report_period: 'Rapportperiode',
        generated_at: 'Gegenereerd op',
        generated_by: 'Gegenereerd door',
        organization: 'Organisatie',
        section_rights_requests: 'Rechtenverzoeken',
        section_vendors: 'Leveranciers',
        section_dpias: "DPIA's",
        section_consent: 'Toestemmingsbeleid',
        section_data_mapping: 'Datakoppeling',
        section_incidents: 'Incidenten',
        section_classification: 'Dataclassificatie',
        section_governance: 'Bestuur',
        open: 'Openen',
        closed: 'Gesloten',
        sla_compliance: 'SLA-naleving',
        total: 'Totaal',
        expired_dpa: 'Verlopen DPA',
        high_risk: 'Hoog risico',
        completed: 'Voltooid',
        overdue: 'Achterstallig',
        policies_active: 'Actief beleid',
        coverage: 'Dekking',
        systems: 'Systemen',
        completeness: 'Volledigheid',
        avg_resolution_days: 'Gem. oplostijd (dagen)',
        labeled: 'Gelabeld',
        unlabeled_systems: 'Ongelabelde systemen',
        compliance_score: 'Compliancescore',
        drift_events_open: 'Open afwijkingen',
        no_data: 'Geen gegevens beschikbaar voor de geselecteerde periode.',
        error_date_range: 'Selecteer zowel een begin- als einddatum.',
        table_category: 'Categorie',
        table_metric: 'Metriek',
        table_value: 'Waarde',
        showing_chart_view: 'Grafiekweergave wordt getoond',
        showing_table_view: 'Datatabelweergave wordt getoond',
        error_generate: 'Bestuursrapport kon niet worden gegenereerd.',
        playbook_evidence_title: 'Bewijs van playbook-uitvoering',
        playbook_evidence_description: 'Uitvoeringsactiviteit per playbook en bijgevoegde bewijsbestanden voor de rapportperiode.',
        playbook_name: 'Speelboek',
        playbook_execution_count: 'Uitvoeringen',
        playbook_steps_total: 'Stappen',
        playbook_steps_required: 'Bewijs vereist',
        playbook_steps_attached: 'Bewijs bijgevoegd',
        playbook_coverage_pct: 'Dekking',
        playbook_evidence_files: 'Bewijsbestanden',
        playbook_no_evidence: 'Geen playbook-uitvoeringen in deze periode.',
        playbook_download_file: 'Bestand downloaden',
    },
    framework_module_links: {
        title: 'Raamwerkkoppeling',
        modules: 'Gekoppelde modules',
        add_module: 'Module toevoegen',
        module_code: 'Modulecode',
        required: 'Verplicht',
        notes: 'Notities',
        link: 'Koppelen',
        no_modules: 'Geen modules gekoppeld',
        personas: "Gekoppelde persona's",
        add_persona: 'Persona toevoegen',
        persona_id: 'Persona-id',
        role_description: 'Rolbeschrijving',
        no_personas: "Geen persona's gekoppeld",
    },
    framework_channels: {
        title: 'Indieningskanalen & Deadlines',
        channels: 'Indieningskanalen',
        add_channel: 'Kanaal toevoegen',
        channel_type: 'Typ',
        name: 'Naam',
        instructions: 'Instructies',
        active: 'Actief',
        no_channels: 'Geen indieningskanalen geconfigureerd',
        portal: 'Portaal',
        in_person: 'Persoonlijk',
        postal: 'Post',
        email: 'E-mail',
        add: 'Toevoegen',
        deadlines: 'Regelgevingsdeadlines',
        add_deadline: 'Deadline toevoegen',
        label: 'Etiket',
        days: 'Dagen',
        day_type: 'Dagtype',
        calendar_days: 'Kalenderdagen',
        working_days: 'Werkdagen',
        description: 'Beschrijving',
        no_deadlines: 'Geen deadlines geconfigureerd',
    },
    regulatory_updates: {
        title: 'Regelgevingsupdates & Raamwerk-dashboard',
        coverage_dashboard: 'Raamwerkdekking-dashboard',
        no_frameworks: 'Geen raamwerken gevonden',
        framework: 'Raamwerk',
        status: 'Status',
        modules: 'Modules',
        templates: 'Sjablonen',
        forms: 'Formulieren',
        channels: 'Kanalen',
        deadlines: 'Deadlines',
        pending: 'Lopende updates',
        updates: 'Regelgevingsupdates',
        create_update: 'Update aanmaken',
        framework_id: 'Raamwerk-id',
        update_title: 'Titel',
        description: 'Beschrijving',
        effective_date: 'Inwerkingtreedingsdatum',
        create: 'Aanmaken',
        no_updates: 'Geen regelgevingsupdates',
        impact: 'Impact',
        assess: 'Beoordelen',
    },
    module_tips: {
        show_guide: 'Gids tonen',
        hide_guide: 'Gids verbergen',
        title: 'Modulegids',
        title_prefix: 'Moduletip:',
        loading_aria: 'Moduletip laden',
        related_frameworks: 'Gerelateerde kaders',
        quick_start_label: 'Snelstart',
        related_forms_note: 'Gerelateerde nalevingsformulieren zijn hieronder beschikbaar — zoek naar het Mẫu số-kenmerk om officiële Vietnamese regelgevingsformulieren te identificeren.',
        read_full_guide: 'Lees de volledige gids',
        view_full_requirements: 'Alle vereisten bekijken',
        relevant_for: 'Relevant voor',
        key_procedure: 'Kernprocedure',
        deletion_orchestration: 'Coördinatie van gegevensverwijderingsverzoeken over systemen en leveranciers met verificatieworkflows en audittrails.',
        rights_requests: 'Beheer verzoeken van betrokkenen waaronder inzage, verwijdering, correctie en overdraagbaarheid. Vereist onder PDPL wet 91/2025 en GDPR.',
        consent: 'Beheer toestemmingsbeleid en werkstromen. Vereist voor PDPL, e-commercewet en GDPR-naleving.',
        consent_properties: 'Configureer toestemmingsverzamelpunten en CMP-integratie-eigenschappen voor web- en apptoestemming.',
        data_mapping: 'Breng gegevensstromen in uw organisatie in kaart — verwerkingsactiviteiten, systemen en grensoverschrijdende overdrachten.',
        data_mapping_registry: 'Houd een inventaris per veld bij van elk element van persoonlijke gegevens dat uw organisatie bewaart. Koppel elk element aan een gegevenscategorie, overschrijf de gevoeligheid of bewaring wanneer dat nodig is, en importeer uit inzendingen uit het regelgevende register ([[TOK_0]] persoonlijke gegevensinventaris) zonder bewerkingen van de operator te verliezen.',
        data_mapping_ropa_completeness: 'Hygiëne-audit per veld van elke Verwerkingsactiviteit aan de hand van de vereiste ROPA-velden van het raamwerk ([[TOK_1]], [[TOK_0]], Decreet 165). Identificeer kritieke/hoge/voorwaardelijke fouten voordat u ze indient bij de regelgeving en ga direct naar de activiteiteneditor om ze allemaal op te lossen.',
        assessments: 'Maak en beheer gegevensbeschermingseffectbeoordelingen (DPIA) en AI-systeemrisicobeoordelingen. Vereist onder PDPL wet 91/2025 artikel 24.',
        classification: 'Classificeer en label gegevensmiddelen op gevoeligheid, categorie en regelgevingsvereisten.',
        incidents: 'Registreer en beheer beveiligingsincidenten en datalekken. Vereist voor lekmelding onder PDPL en cyberbeveiligingswet.',
        incident_ops: 'Coördineer incidentresponsoperaties met playbook-activeringen, escalatiepaden en realtime coördinatiedashboards.',
        monitoring: "Monitor nalevings-KPI's, programmastatus en taakafronding over de hele organisatie.",
        vendor_risk: 'Beoordeel en beheer leveranciersrisico via vragenlijsten, risicoportefeuilles en nalevingsscoring.',
        governance: 'Beheer leveranciersbestuur, playbooks en nalevingsvereisten van derden.',
        program_governance: 'Configureer volwassenheidsbeoordelingen voor programmabestuur, dashboardstatistieken en nalevingsscorekaders.',
        discovery: 'Ontdek en inventariseer gegevensmiddelen in uw organisatie met geautomatiseerde scanning en classificatieworkflows.',
        discovery_cycles: 'Plan en voer terugkerende ontdekkingscycli uit die systemen opnieuw scannen, deltawijzigingen tonen en bevindingen routeren via beoordeling, goedkeuring en publicatie.',
        connectors: 'Configureer integraties en gegevenconnectoren voor geautomatiseerde nalevingsgegevensverzameling.',
        task_management: 'Beheer nalevingstaken, toewijzingen en deadlines over teams en modules.',
        audit_trail: 'Bekijk en doorzoek het uniforme auditspoor voor alle nalevingsactiviteiten en bewijsverzameling.',
        evidence_packs: 'Verzamel, verifieer en dien auditbewijspakketten in voor naleving van de regelgeving. Bewijspakketten verzamelen auditgebeurtenissen per raamwerk, entiteitstype en tijdsperiode in exporteerbare bundels voor interne beoordeling of indiening bij de toezichthouder.',
        audit_periods: 'Definieer en beheer auditrapportageperioden per regelgevingskader. Auditperioden bepalen de tijdsgrenzen en het bewaarbeleid voor de verzameling van bewijsmateriaal en de rapportagecycli voor naleving.',
        qs_evidence_pack: 'Stel uw eerste bewijspakket samen',
        qs_audit_period: 'Maak een auditrapportageperiode aan',
        compliance_forms: 'Blader door de nalevingsformulierencatalogus en maak formulieren aan voor regelgevingsindienemn.',
        partner_workspace: 'Beheer van partner- en wederverkoperwerkruimten met afgebakende toegang, compliance-beoordelingsworkflows en samenwerkingstools.',
        localization: 'Beheer regelgevingskaders, taalpakketten en lokalisatie-instellingen.',
        onboarding: 'Volg onboardingvoortgang, voltooi snelstarts en volg personagebaseerde nalevingstrajecten.',
        organizations: 'Beheer organisatiestructuur, afdelingen en multi-org-configuraties.',
        privacy_scanner: 'Monitor de privacynaleving van websites met geautomatiseerde scanning en probleemdetectie.',
        access_accountability: 'Configureer toegangsbeoordelingscampagnes en verantwoordingsbeleid voor gegevenstoegangsbeheer.',
        dashboard: 'Bekijk het compliance-dashboardoverzicht met realtime statussamenvattingen, raamwerkdekking en belangrijke compliance-statistieken.',
        platform: 'Beheer platformbeveiligingsinstellingen, waaronder [[TOK_0]]-sleutels, noodtoegang tot breekglas en SSO-configuratie.',
        framework_vn_pdpl: 'VN Wet bescherming persoonsgegevens (PDPL)',
        framework_vn_cybersecurity: 'VN Cyberbeveiligingswet',
        framework_vn_ecommerce: 'VN E-commercewet',
        framework_vn_ai_law: 'VN AI-wet',
        framework_vn_telecom: 'VN Telecommunicatiewet',
        framework_vn_banking_circular_83: 'VN-bankcirculaire [[TOK_0]] — Intern controlesysteem',
        framework_gdpr: 'EU GDPR',
        cross_framework: 'Kaderoverschrijdend — ondersteunt alle regelgevingsnalevingsactiviteiten',
        qs_dpia_filing: 'Voltooi uw eerste DPIA-indiening',
        qs_dept_compliance: 'Dien uw eerste afdelingsnalevingssectie in',
        qs_ecommerce_consent: 'Configureer toestemmingsverzameling voor e-commerce',
        qs_telecom_data: 'Stel verwerking van telecommunicatieabonneegegevens in',
        qs_data_flow: 'Breng uw eerste gegevensstroom in kaart',
        qs_incident_response: 'Configureer incidentresponsworkflow',
        qs_ai_risk: 'Voer een AI-systeemrisicobeoordeling uit',
        qs_cross_border: 'Beoordeel een grensoverschrijdende gegevensoverdracht',
        qs_breach_notification: 'Simuleer een datalekmeldings-workflow',
        qs_audit_trail: 'Controleer een nalevingsauditspoor',
        procedure_data_deletion_fulfillment: 'Uitvoering van gegevensverwijdering',
        procedure_cross_system_deletion: 'Systeemoverschrijdende verwijdering',
        procedure_dsar_intake: 'Ontvangst van verzoeken van betrokkenen',
        procedure_cmp_property_config: 'CMP-eigenschappenconfiguratie',
        procedure_consent_collection: 'Beleid voor het verzamelen van toestemming',
        procedure_ropa_filing: 'Indienen van register van verwerkingsactiviteiten',
        procedure_cross_border_assessment: 'Beoordeling van grensoverschrijdende gegevensoverdracht',
        procedure_data_classification: 'Gegevensclassificatie',
        procedure_breach_notification: 'Melding van gegevensinbreuk',
        procedure_incident_timeline: 'Tijdlijnregistratie van incidenten',
        procedure_playbook_escalation: 'Escalatie via draaiboek',
        procedure_compliance_kpi_monitoring: 'Monitoring van nalevings-KPI',
        procedure_vendor_risk_assessment: 'Risicobeoordeling van leveranciers',
        procedure_transfer_mechanism_review: 'Beoordeling van overdrachtsm mechanisme',
        procedure_program_maturity: 'Beoordeling van programmarijpheid',
        procedure_data_discovery: 'Ontdekking van gegevensactiva',
        procedure_connector_setup: 'Installatie en configuratie van connectoren',
        procedure_task_assignment: 'Taaktoewijzing en delegatie',
        procedure_audit_evidence: 'Verzameling van auditbewijzen',
        procedure_form_submission: 'Indienen van nalevingsformulieren',
        procedure_partner_onboarding: 'Workflow voor partneronboarding',
        procedure_partner_access: 'Partnertoegang en machtigingen',
        procedure_framework_pack_install: 'Installatie van raamwerkpakket',
        procedure_language_pack_deploy: 'Uitrol van taalpakket',
        procedure_org_onboarding: 'Instelling van organisatie-onboarding',
        procedure_multi_org_config: 'Multi-organisatieconfiguratie',
        procedure_privacy_scan: 'Privacynalevingsscan',
        procedure_access_review: 'Campagne voor toegangsbeoordeling',
        procedure_dpia_filing: 'DPIA-indieningsprocedure',
        security: 'Platformbeveiligingsconfiguratie: [[TOK_0]] sleutelbeheer, sessiebeleid, MFA-handhaving, SSO-integratie, IP-toelatingslijsten en noodtoegangscontroles voor noodgevallen.',
        settings: "Platformbrede configuratie: meldingsvoorkeuren, domeinbeheer, exportschema's en moduleconfiguratie voor uw organisatie.",
        users: 'Gebruikersaccountbeheer: maak en beheer gebruikersaccounts, wijs rollen toe, configureer afdelingslidmaatschap en volg inlogactiviteiten.',
        roles: 'Rollen- en machtigingsbeheer: definieer aangepaste rollen, configureer gedetailleerde machtigingen per module en dwing beleid voor scheiding van taken af.',
        profile: 'Uw persoonlijke profielinstellingen: weergavenaam, contactgegevens, taalvoorkeur, modulegidsvoorkeuren, toegankelijkheidsopties en wachtwoordbeheer.',
        consent_properties_bindings: 'Beheer toestemmingsbeleidsbindingen voor digitale eigendommen. Houd bij welke beleidsversie voor elke property wordt geïmplementeerd, identificeer verouderde bindingen en coördineer de implementatie van beleid.',
        consent_properties_templates: 'Gouden sjabloonbeheer: definieer standaard toestemmingsconfiguraties, vergelijk eigendommen met sjablonen en implementeer sjabloonwijzigingen in alle eigendomsgroepen.',
        consent_properties_compliance: 'Toezicht op naleving van toestemming: detecteer configuratie-inconsistenties tussen eigenschappen en gouden sjablonen, beheer wijzigingsverzoeken via goedkeuringsworkflows en genereer bewijspakketten voor auditgereedheid.',
        consent_properties_operations: "Operationeel beheer voor toestemmingseigenschappen: configureer geautomatiseerde momentopnameschema's, organiseer eigenschappen in groepen en bekijk het audittraject van de toestemmingseigenschap.",
        consent_properties_audit: 'Toestemming voor audit en analyse van eigendommen: bekijk de geschiedenis van configuratiewijzigingen, analyseer trends op het gebied van de naleving van eigendommen en genereer nalevingsrapporten voor beoordeling door de toezichthouders.',
        classification_taxonomies: 'Definieer en beheer dataclassificatietaxonomieën met gevoeligheids- en belangrijkheidsdimensies. Configureer classificatieniveaus, verwerkingsvereisten en [[TOK_0]] risiconiveaus.',
        classification_labeling: 'Pas classificatielabels toe op gegevensassets. Dien labels ter beoordeling in, beheer bulkclassificatie en volg de labelstatus in uw gegevensinventaris.',
        classification_lifecycle: 'Volg de levenscyclus van geclassificeerde gegevensassets in fasen: concept, actief gebruik, wordt beoordeeld, gearchiveerd en in afwachting van verwijdering. Houd bewaarperioden in de gaten en activeer verwijderingsworkflows.',
        classification_gaps: 'Detecteer en beheer classificatielacunes in uw gegevensinventaris. Voer hiaatdetectie uit om niet-gelabelde assets en ontbrekende levenscyclustoewijzingen te identificeren, en volg vervolgens het herstel.',
        classification_reviews: 'Beheer classificatiebeoordelingstaken met escalatietimers. Beoordeel voorgestelde labels, handel uitzonderingen af ​​en zorg voor tijdige classificatiebeslissingen.',
        incidents_breach: 'Beheer meldingen van datalekken en autoriteitsrapportage. Maak meldingspakketten, houd wettelijke deadlines bij en documenteer de volledige tijdlijn voor de respons op inbreuken.',
        incidents_authority: 'Behandel formele autoriteitsverzoeken van regelgevende instanties. Houd binnenkomende vragen bij, stel bewijspakketten samen, beheer verificatiechecklists en voldoe aan reactiedeadlines.',
        incidents_disclosure: 'Onderhoud het gecentraliseerde openbaarmakingsregister voor alle communicatie met regelgevende instanties. Leg data van openbaarmaking, kanalen, ontvangers en inhoudssamenvattingen vast om aan de audittrail te voldoen.',
        incidents_reports: 'Genereer en beheer incidentrapporten voor interne beoordeling en indiening bij de regelgeving. Maak gedetailleerde incidentsamenvattingen, volg de rapportstatus en exporteer documentatie voor autoriteitsregistraties.',
        incidents_tasks: 'Coördineer incidentresponstaken tussen teams. Maak taakchecklists, wijs eigenaren toe, houd prioriteiten en afhankelijkheden bij, escaleer geblokkeerde items en controleer de voortgang van de voltooiing.',
        incidents_supplements: 'Beheer aanvullende documentatie die door regelgevende instanties wordt opgevraagd na de eerste melding van een inbreuk. Volg aanvullingsverzoeken, bereid antwoordpakketten voor en bewaak de indieningsdeadlines.',
        incidents_remediation: 'Volg corrigerende acties die zijn toegewezen aan afdelingen en gebruikers om de hoofdoorzaak en impact van incidenten aan te pakken. Bewaak de implementatiedeadlines, verifieer de voltooiing en documenteer herstelbewijs.',
        incident_ops_playbooks: 'Creëer en beheer draaiboeken voor incidentrespons. Definieer escalatiepaden, wijs responsteams toe en activeer draaiboeken tijdens live incidenten.',
        incident_ops_sla: "Houd SLA's voor incidentrespons en wettelijke deadlines bij. Houd toezicht op de naleving van de wettelijke meldingstijdlijnen en meet de responsprestatiestatistieken.",
        incident_ops_evidence: 'Onderhoud bewijsketens voor incidenten en voer beoordelingen na incidenten uit. Genereer voor de toezichthouders geschikte exportpakketten met volledige incidentdocumentatie.',
        data_mapping_systems: 'Registreer en beheer systemen die persoonsgegevens verwerken. Documenteer systeemeigendom, gegevenscategorieën, verwerkingsdoeleinden en nalevingsscores.',
        data_mapping_flows: 'Breng gegevensstromen tussen systemen in kaart, inclusief grensoverschrijdende overdrachten. Documenteer de verplaatsingspaden van gegevens, de overdrachtsmechanismen en de jurisdicties van de ontvangers.',
        data_mapping_activities: 'Documentverwerkingsactiviteiten en het genereren van records van verwerkingsactiviteiten (RoPA). Koppel activiteiten aan rechtsgrondslagen, doeleinden en gegevenscategorieën.',
        data_mapping_governance: 'Beheer opdrachten voor gegevensbeheer, attestcycli en risicobeoordelingen. Houd het eigendom van het beheer bij en bekijk de planningen voor uw gegevensinventaris.',
        data_mapping_reference: 'Beheer referentiegegevens voor datatoewijzing: gegevenscategorieën, verwerkingsdoeleinden, bewaarbeleid en exportconfiguraties.',
        data_mapping_categories: 'Beheer de gegevenscategoriecatalogus: namen, gevoeligheidsniveaus, voorbeelden en tags. Basis voor elke classificatie- en karteringsactiviteit.',
        data_mapping_purposes: 'Catalogusverwerkingsdoeleinden met hun wettelijke basis. Gebruikt door ROPA-, [[TOK_0]]- en rechtmatigheidsaudits.',
        data_mapping_retention: 'Configureer retentiebeleid, verwijderingsmethoden en bekijk de cadans. Voldoet aan de vereisten van Decreet 13/2023 en Decreet 356/2025.',
        data_mapping_exports: 'Exporteer ROPA, systemen, doeleinden en categorieën naar [[TOK_0]], [[TOK_3]], [[TOK_2]] of [[TOK_1]]. Alle exporten komen terecht in de bestandsbrowser van het platform.',
        data_mapping_attestation: 'Plan en bewaak gegevensattestcycli. Volg de voltooiing van attesten in uw gegevensinventaris.',
        data_mapping_review: 'Wachtrij voor classificatiebeoordeling: beoordelingstaken, kwaliteitssignalen en goedkeuringsstatus.',
        data_mapping_risk: 'Risicobeoordeling voor verwerkingsactiviteiten: scorekaders, mitigatieplannen en tracking van de effectiviteit.',
        data_mapping_evidence: 'Bewijs gekoppeld aan verwerkingsactiviteiten: beveiligingscertificaten, DPA-contracten, [[TOK_0]]-rapporten.',
        data_mapping_inventory: 'Overzicht van classificatie-inventaris: tags, gevoeligheidsniveaus en organisatiebrede distributie.',
        data_mapping_exceptions: 'Uitzonderingsregister voor classificaties: grondgedachte, goedkeurder, geldigheidsperiode en herstelpad.',
        data_mapping_history: 'Classificatieveranderingsgeschiedenis: wie veranderde wat, wanneer en waarom.',
        access_accountability_logs: 'Realtime stroom van geprivilegieerde toegangsgebeurtenissen. Koppel met de beleidspagina om te definiëren wie elke datazone kan bereiken; gecombineerd met onderzoeken om afwijkingen op te volgen.',
        access_accountability_policies: 'Beleidsontwerp voor toegangszones: geef aan welke rollen en gebruikers elke datazone mogen bereiken, met tijdsgebonden uitzonderingen. Stuurt de handhavingscontroles aan die in de logboeken voorkomen.',
        access_accountability_anchoring: 'Fraudebestendige verankering van het toegangslogboek aan een hash-keten. Vereist voor de integriteit van het audittraject van de VN Cybersecurity Law.',
        access_accountability_investigations: 'Casewerkruimte voor het onderzoeken van verdachte toegangsgebeurtenissen. Tijdlijn, gekoppelde logboeken, bewijspakketten en workflow voor het sluiten van zaken in één weergave.',
        assessment_triggers: 'Regels die automatisch een [[TOK_0]]- of dossierdossier openen wanneer upstream-wijzigingen (nieuwe verwerkingsactiviteit, nieuwe leverancier, nieuwe grensoverschrijdende stroom) aan de triggervoorwaarde voldoen.',
        connectors_gap_register: 'Catalogus van niet-geïmplementeerde of gedeeltelijke connectoren. Sorteer items, wijs eigenaren toe, volg het dichten van gaten via de routekaart.',
        connectors_system_inventory: 'Inventarisatie van elk systeem bereikbaar via een connector. Eén bron van waarheid voor de datakaart.',
        connectors_traceability: 'End-to-end afstamming van een data-element tussen systemen die zijn verbonden via connectoren. Essentieel voor ROPA-nauwkeurigheid en vervulling van onderwerpverzoeken.',
        consent_properties_change_requests: 'Pijplijn met voorgestelde wijzigingen in een toestemmingseigenschap (toegevoegd doel, nieuwe taal, bijgewerkte beleidslink). Governance-evaluatie vóór de uitrol van de productie.',
        consent_properties_comparison: 'Zij-aan-zij vergelijking van de vorm van de toestemmingseigenschap tussen domeinen of implementaties. Er wapperen vlaggen die de afdwingbaarheid zouden verzwakken.',
        governance_playbooks: 'Playbook-sjablonen die herhaalbare governance-workflows aansturen (onboarding van leveranciers, DPA-beoordeling, overdrachtsbeoordeling).',
        incident_ops_coordination: 'Teamoverschrijdend coördinatiedashboard voor een actief incident. Eén plek om te zien wie erop zit, wat ze doen en wat wordt geblokkeerd.',
        incident_ops_escalation: 'Escalatielogboek voor actieve incidenten. Overgangen over de ernst, kennisgevingen aan belanghebbenden en instructies van het management worden hier allemaal vastgelegd.',
        incident_ops_post_review: 'Beoordeling na incidenten: analyse van de hoofdoorzaak, tijdlijn, herstelacties en geleerde lessen. Feeds voor trainingen en draaiboekupdates.',
        incident_ops_regulator_exports: 'Genereer indieningspakketten voor toezichthouders voor meldingsplichtige incidenten. Mẫu số 08 (inbreuk) + ondersteunende bewijsbundel.',
        incident_ops_vendor_coordination: "Coördineer de respons met de leverancier wiens systeem is geschonden. Contractverplichtingen, respons-SLA's en gedeelde bewijsketen.",
        monitoring_authority_readiness: 'Controlelijst voor gereedheid en bewijspakket voor komende bezoeken van toezichthouders. Geconsolideerd overzicht van openstaande hiaten en voltooide controles.',
        monitoring_change_review: 'Periodieke beoordeling van controlewijzigingen binnen het monitoringprogramma. Detecteert afwijkingen voordat het een compliance-kloof wordt.',
        monitoring_framework_link: 'Koppel monitoringcontroles aan specifieke regelgevingskaderartikelen. Genereert de bewijskaart die toezichthouders verwachten.',
        monitoring_ric: 'Regelgevende onderzoeken en correspondentiezaken. Volg vragen en antwoorden van de toezichthouder in de loop van de tijd.',
        forms: 'Catalogus met wettelijke formulieren, formulierinvullers, formulierexemplaren en links naar dossierdossiers. Ruggengraat voor Mẫu số 02a/02b en gerelateerde inzendingen.',
        monitoring_tasks: 'Wachtrij voor monitoringtaken: geplande controleverificaties, attesten en vernieuwingen van bewijsmateriaal.',
        partner_workspace_reports: 'Rapporten gedeeld via het partnernetwerk: nalevingsstatus, maandelijkse samenvattingen, statistieken voor meerdere organisaties.',
        partner_workspace_tickets: 'Ondersteuningstickets die tussen partners zijn aangemaakt over gedeelde workflows en escalaties.',
        program_governance_audit_readiness: 'Scoren van auditgereedheid met inzoomen op ontbrekend bewijsmateriaal, hiatenregister en eigenaren van herstelmaatregelen.',
        program_governance_drafting: 'Werkruimte voor het opstellen van documenten met versiebeheer, beoordelingsroutering en goedkeuringsworkflow.',
        program_governance_evidence_gaps: 'Register met bewijslacunes: welke controles ontbreken actueel bewijs en wanneer vernieuwing nodig is.',
        program_governance_executive_summaries: "Sjablonen voor samenvattingen met automatisch ingevulde KPI's voor briefings van het bestuur en het management.",
        program_governance_health: 'Algemeen programmagezondheidsdashboard: volwassenheid, dekking en trendindicatoren.',
        program_governance_issuance: 'Workflow voor documentuitgifte: goedkeuring, publicatie, kennisgeving aan belanghebbenden.',
        program_governance_model: 'Bestuursmodel: rollen, verantwoordelijkheden, commissies en beslissingsrechten.',
        program_governance_remediation: 'Saneringsplannen gekoppeld aan geïdentificeerde hiaten. Eigenaar, deadline, status en verificatiebewijs.',
        program_governance_review_cadence: 'Geplande beoordelingsfrequentie voor governance-artefacten: beleid, procedures, controles, bewijsmateriaal.',
        program_governance_trends: 'Trenddashboard: volwassenheid in de loop van de tijd, versheid van bewijsmateriaal, snelheid waarmee gaten worden gedicht.',
        task_management_conflicts: 'Detecteer conflicterende taaktoewijzingen (dubbel geboekte eigenaren, overlappende deadlines) en los deze op door deze opnieuw toe te wijzen.',
        task_management_consolidation: 'Consolideer taken die automatisch door meerdere modules zijn gegenereerd in één enkele workflow voor de verantwoordelijke.',
        localization_dashboard: 'Overzicht van de lokalisatiemodule: status van de raamwerkcatalogus, pakketstatus, vertalingsdekking en verwachte updates van regelgeving in één dashboard.',
        localization_frameworks: 'Catalogus van regelgevingskader: [[TOK_1]], Decreet 13/2023, Decreet 356/2025, Cyberbeveiligingswet, en [[TOK_0]]. Elk raamwerk koppelt artikelen aan platformbedieningen.',
        localization_framework_channels: 'Kanalen voor indiening door toezichthouders gekoppeld aan elk raamwerk ([[TOK_1]] portal, [[TOK_0]] eindpunt, e-mail van autoriteit). Bestuurt de routering van Mẫu số-archieven.',
        localization_framework_detail: "Detailweergave in één raamwerk: artikelen, procedures, persona's, gekoppelde formulieren en implementatiediepte op het hele platform.",
        localization_framework_module_links: 'Framework → moduledekkingskaart. Welke regelgevingsartikelen worden afgedwongen door welke platformmodule.',
        localization_language_packs: 'Catalogus van taalpakketten in 16 talen: installatiestatus, volledigheid van de vertaling en geschiedenis van het indienen van pakketten.',
        localization_audit: 'Audittrail voor lokalisatiewijzigingen: raamwerkbewerkingen, pakketupdates, indieningsgebeurtenissen.',
        localization_market_packs: 'Marktpakketcatalogusbundelingskader + taal + formulieren per markt (VN, EU-lidstaten, etc.).',
        localization_module_mappings: 'Module mapping register: welk raamwerkartikel van toepassing is op welke module op featureniveau.',
        localization_pack_detail: 'Detailweergave van één pakket: versie, inbegrepen frameworks, vertaalstatus, installatiegeschiedenis.',
        localization_pack_submissions: 'Pijplijn voor het indienen van pakketten: partnerinzendingen, beoordelingsstatussen, publicatiegoedkeuringen.',
        localization_regulatory_updates: 'Regulatory update feed: nieuwe decreten, wijzigingen en richtlijnen die van invloed zijn op de kadercatalogus.',
        localization_sector_overlays: 'Sector-overlay-catalogus: optionele sectorspecifieke regelgevingspakketten (bijv. bankwezen, gezondheidszorg). Installeer in de directe modus voor organisaties binnen het bereik of in de referentiemodus voor sectoroverschrijdende zichtbaarheid.',
        localization_help_content_packs: 'Help-Content Pack-manager: installeer, versie en vertaal de in-app help-artikelen, modulehandleidingen en snelstartgidsen die in de beheerdersinterface verschijnen.',
        localization_translation_preview: 'Live voorbeeld van UI-tekenreeksen op verschillende locaties. Zij-aan-zij vergelijking voor vertaling QA.',
        organizations_groups_create: 'Maak een nieuwe organisatiegroep (koncern): kies de hoofdorganisatie, selecteer leden, definieer de overnamemodus per categorie.',
        organizations_groups_detail: 'Details van één organisatiegroep: leden, overnamematrix, gedeelde bronnen en auditsamenvatting.',
        organizations_groups_settings: 'Organisatiegroepinstellingen: [[TOK_0]], agenda, meldingen, intake, [[TOK_1]] integratie. Wisselschakelaar voor overnemen/overschrijven per categorie.',
        organizations_groups_audit: 'Auditlogboek per groep: lidmaatschapswijzigingen, overervingsschakelaars, toevoegen/verwijderen van gedeelde bronnen.',
        organizations_groups_consolidated_audit: 'Geconsolideerde auditweergave voor alle aangesloten organisaties van een groep. Filter op entiteit, acteur, tijdvenster.',
        organizations_groups_dashboard: 'Cross-member dashboard: nalevingsstatus, openstaande items, [[TOK_0]] inbreuken verzameld voor de hele groep.',
        organizations_groups_reports: 'Rapporten op groepsniveau: samenvatting, overzicht van toezichthouders, vergelijking tussen leden [[TOK_0]].',
        organizations_groups_users: 'Gebruikers zichtbaar in de hele groep: roltoewijzingen voor meerdere organisaties, gedeelde beheerders, imitatieketen.',
        organizations_groups_merged_vendors: 'Gededupliceerde leveranciersweergave voor alle aangesloten organisaties: één enkele leverancier verschijnt één keer, zelfs als deze afzonderlijk is aangemeld.',
        organizations_groups_shared_templates: 'Formuliersjablonen gepubliceerd op groepsniveau. Leden kiezen ervoor om een ​​sjabloon te erven; opt-out is per organisatie.',
        organizations_groups_shared_frameworks: 'Regelgevingskaders gedeeld door de hele groep. Centrale update stroomt naar elk lid met mode=inherit.',
        organizations_groups_shared_vendors: 'Leveranciersregister op groepsniveau. Contract, DPA-status en risicoscore zichtbaar voor elk lid.',
        onboarding_help_center: 'Helpcentrum: blader door alle 309+ artikelen per module, categorie en persona. Zoeken in volledige tekst in EN + VI-inhoud.',
        onboarding_progress: 'Onboarding-voortgangstracker: welke stappen voor livegang zijn voltooid, welke in behandeling zijn, wie de eigenaar is van de blokkers.',
        onboarding_personas: 'Persona-gestuurde onboardingtrajecten voor de 10 VN-rollen (P-VN-01 tot en met P-VN-10). Elke reis is een samengestelde lijst met eerste acties.',
        onboarding_quick_starts: "Snelstartscenario's: voer een volledige compliance-workflow end-to-end uit in de sandbox. Ideaal voor trainingen.",
        onboarding_sample_data: "Voorbeeldgegevensgenerator: laad realistische demorijen in elke module. Handig voor verkoopdemo's en trainingen.",
        onboarding_tours: 'Interactieve rondleidingen. Start een modulespecifieke walkthrough die elke pagina vertelt terwijl u navigeert.',
        security_sessions: 'Liveweergave van geverifieerde sessies: apparaat, IP, laatste activiteit, gebruikte MFA-factor. Beëindig met één klik.',
        security_api_keys: 'Serviceaccount [[TOK_0]]-sleutels: bereik, rotatie, laatst gebruikt en audittraject per sleutel.',
        security_break_glass: 'Noodtoegang tot breekglas: tijdgebonden super-admin-subsidie met verplicht audittraject en beoordeling na het evenement.',
        security_delegations: 'Tijdelijke roldelegatie: afwezigheidsdekking, goedkeuringsketens, automatisch verlopen.',
        security_ip_allowlist: 'Configuratie van IP-toelatingslijst: beperk beheerdersaanmelding tot specifieke bedrijfsnetwerken of VPN-bereiken.',
        security_mfa: 'Multi-factor authenticatiebeleid: handhaving per rol, factor-toelatingslijst (TOTP/SMS/WebAuthn), resetstroom.',
        security_service_accounts: 'Serviceaccounts voor systeem-naar-systeem-integratie. Afzonderlijk van menselijke gebruikers afgebakend, gecontroleerd en geroteerd.',
        security_session_settings: 'Sessiebeleid: time-out bij inactiviteit, maximale sessieduur, limiet voor gelijktijdige sessies, triggers voor herauthenticatie.',
        security_sso: 'Configuratie voor eenmalige aanmelding: SAML/OIDC-providers, attribuuttoewijzing, regels voor automatische inrichting.',
        rights_requests_create: 'Maak een nieuwe aanvraag voor de rechten van de betrokkene aan. Legt de identiteit van de aanvrager, het verzoektype, het kanaal en het begin van de [[TOK_0]] klok vast.',
        rights_requests_list: 'Alle rechtenaanvraaggevallen met [[TOK_0]] aftelling, rechthebbende, status en filterchips voor kanaal + verzoektype.',
        rights_requests_detail: 'Werkruimte voor één case: correspondentie, uitvoeringsacties, bewijsmateriaal, opstellen van antwoorden, [[TOK_0]] overgangen.',
        rights_requests_cmp_sync: '[[TOK_0]] instellingen voor integratiesynchronisatie: webhook-eindpunt, regels voor automatisch aanmaken van cases, beleid voor opnieuw proberen.',
        rights_requests_extensions: '[[TOK_0]] uitbreidingsverzoeken: rechtvaardiging, routering van goedkeurder en invoer van audittrail bij toekenning/weigering.',
        rights_requests_fulfillment: 'Werkruimte voor afhandeling van aanvragen: gegevenspakketten verzamelen, redacties toepassen, verpakken voor bezorging.',
        rights_requests_responses: 'Antwoorden opstellen met sjablooninvoeging, samenvoegvelden en naast elkaar geplaatste EN/VI-preview.',
        rights_requests_response_templates: 'Catalogus antwoordsjablonen: goedgekeurde sjablonen per verzoektype + rechtsgebied, met versiegeschiedenis.',
        compliance_forms_consolidation_create: 'Creëer een nieuwe consolidatiezaak: groepeer gerelateerde formulierinzendingen onder één enkel indieningspakket, bestemd voor één toezichthouder.',
        compliance_forms_consolidation_detail: 'Werkruimte voor één enkele consolidatiezaak: sectie-invoer, goedkeuringen van de reviewer, export van het volledige dossier naar de toezichthouder.',
        compliance_forms_consolidation_cases: 'Alle consolidatiezaken met archiveringsstatus, opdrachten van revisoren en bijhouden van deadlines.',
        compliance_forms_consolidation_review: 'Werkruimte voor consolidatiegevallen beoordelen: sectie-invoer goedkeuren, revisies aanvragen, afmelden vóór export.',
        compliance_forms_dossier_export: 'Exporteer het geconsolideerde dossier als een voor de toezichthouders geschikte [[TOK_0]]-bundel met begeleidende brief, bijlagen en handtekeningen.',
        compliance_forms_section_input: 'Werkruimte voor afdelingseigenaren voor het voltooien van één sectie van een consolidatieaanvraag.',
        compliance_forms_filing_case_links: 'Koppelingen tussen formulierinstanties en dossierzaken. Zorgt ervoor dat elke indiening wordt ondersteund door de juiste formuliergegevens.',
        compliance_forms_section_routing: 'Regels voor sectieroutering: welke afdeling is eigenaar van welke sectie van elke formuliersjabloon.',
        assessments_dashboard: 'Beoordelingsdashboard: [[TOK_0]] aantal, overdrachtsbeoordelingen, hiaatoverzicht, komende beoordelingsdeadlines.',
        assessments_dossier_filing_detail: 'Enkelvoudige dossierindiening: formuliertype (Mẫu số 02a/02b), sectietoewijzingen, sectiestatus, indieningsdetails, [[TOK_0]] timers.',
        assessments_dossier_filing_list: 'Alle dossierarchieven met formuliertype, status en voortgang van de sectietoewijzing. Filter op status en kader.',
        assessments_dpia_list: '[[TOK_0]] registreren: alle lopende, goedgekeurde en gearchiveerde gegevensbeschermingseffectbeoordelingen.',
        assessments_gap_report: "Gap-rapport: [[TOK_0]] dekking, niet-geclassificeerde [[TOK_1]] vereiste, onbeperkte risico's, ontbrekende deponeringen. Primair auditgereedheidsoppervlak.",
        assessments_transfer_list: 'Overdrachtsbeoordelingen voor grensoverschrijdende gegevensstromen. Elke beoordeling documenteert het mechanisme, de waarborgen en de risicobeoordeling.',
        deletion_orchestration_templates: 'Controlelijstsjablonen voor verwijderingsruns. Elke sjabloon is een gescripte reeks taken die zijn gekoppeld aan specifieke systemen en bewaarregels.',
        deletion_orchestration_dsr_integration: 'DSR-naar-verwijderingsintegratie: activeer automatisch een verwijderingsrun vanaf een goedgekeurd verwijderingsverzoek.',
        deletion_orchestration_tasks: 'Uitvoeringstaken voor actieve verwijderingsruns. Elke taak houdt het systeem, de actie, de eigenaar en het verificatiebewijs bij.',
        deletion_orchestration_dashboard: 'Dashboard voor verwijderingsorkestratie: actieve runs, voltooiingspercentage, lopende verificaties, versheid van de proefketen.',
        deletion_orchestration_proof_chain: 'Fraudebestendige keten voor elke verwijderingsactie. Vereist voor naleving van [[TOK_0]] wat betreft verwijdering.',
        organizations_compliance_rollup: 'Nalevingsoverzicht voor alle entiteiten: [[TOK_0]] per entiteit, dekking op raamwerkniveau, uitstaande verplichtingen.',
        organizations_departments_admin: 'Beheerwerkruimte voor afdelingen: aanmaken, eigenaren opnieuw toewijzen, teamlidmaatschap beheren, routeringsregels instellen.',
        organizations_departments: 'Afdelingen geven een overzicht van entiteiten. Stimuleer sectierouting, goedkeuringsstromen en bewijstoewijzing.',
        organizations_entity_frameworks: 'Wijs regelgevingskaders toe aan elke entiteit. Drives welke Mẫu số-formulieren van toepassing zijn en welke audits verplicht zijn.',
        organizations_entity_form: 'Maak of bewerk één organisatie-entiteit: wettelijke naam, bedrijfsregistratie, adres, vertegenwoordiger.',
        organizations_list: 'Alle organisatie-entiteiten binnen de tenant. Primaire lijstweergave met statusfilters en snelle toegangsacties.',
        organizations_retention_policies_admin: 'Beheer van bewaarbeleid gericht op de organisatie: standaardregels, overschrijvingen per entiteit.',
        task_management_calendar: 'Kalenderweergave van taken en deadlines. Kleurgecodeerd per module en [[TOK_0]]-status.',
        task_management_my_tasks: 'Persoonlijke takenwachtrij: toegewezen aan mij, binnenkort gepland, te laat. Primaire dagelijkse werkruimte.',
        task_management_overdue: 'Achterstallige taken in de hele organisatie. Filtert op eigenaar, module en bucket met achterstallige dagen.',
        task_management_section_assignments: 'Overzicht sectieopdracht: welke afdeling is eigenaar van welke sectie van elke actieve formulierindiening.',
        task_management_board: 'Kanban-bordweergave van taken. Sleep tussen kolommen (To-Do / In uitvoering / Review / Klaar) om de status bij te werken.',
        task_management_detail: 'Werkruimte voor één taak: beschrijving, opmerkingen, bijlagen, subtaken, audittrail, statusovergangen.',
        task_management_list: 'Platte lijst van alle taken met filters: eigenaar, module, status, prioriteit, vervaldatumbereik.',
        consent_cmp_sync: '[[TOK_0]] synchronisatiewerkruimte: activeer synchronisaties, bekijk de synchronisatiegeschiedenis, inspecteer fouten. Houdt de status [[TOK_1]] in lijn met het platform.',
        consent_cmp_bulk_sync: "Bulk [[TOK_0]] synchronisatie: synchroniseer alle toestemmingsrecords voor alle property's opnieuw. Wordt gebruikt voor tenantmigraties en grote [[TOK_1]] wijzigingen.",
        consent_cmp_integration: '[[TOK_0]] integratie-instellingen: eindpunt, authenticatie, synchronisatiebeleid en verbindingsstatus.',
        consent_cmp_purpose_mapping: 'Wijs [[TOK_0]] doeleinden toe aan platformdoeleinden. Zorgt ervoor dat toestemmingssignalen correct tussen de twee systemen stromen.',
        consent_cmp_webhook: '[[TOK_0]] webhook-configuratie: routering van inkomende gebeurtenissen, ondertekeningsgeheimen, beleid voor opnieuw proberen.',
        partner_workspace_brand_profiles: 'Partnermerkprofielen: logo, slogan, contact, serviceaanbod. Stuurt de vermelding op de partnermarktplaats aan.',
        partner_workspace_deliverable_templates: 'Leverbare sjablooncatalogus: gestandaardiseerde servicepakketten die partners kunnen aanbieden ([[TOK_0]] beoordeling, leveranciersaudit, training).',
        partner_workspace_deliverables: 'Actieve deliverables voor partnerbetrokkenheid. Houd de reikwijdte, vervaldata en acceptatiecriteria bij.',
        partner_workspace_service_tiers: 'Definities van servicelagen: Brons/Zilver/Goud met bereik, [[TOK_0]] en prijsklassen.',
        partner_workspace_workflow_instances: 'Actieve workflow-instanties bij partners: onboarding, beoordeling, escalatie, offboarding-runs.',
        partner_workspace_workflow_templates: "Catalogus van workflowsjablonen voor partnerbetrokkenheid. Elke sjabloon definieert stappen, eigenaren, SLA's en outputs.",
        access_accountability_justification_reviews: 'Controleer de toegangsredenen die door gebruikers zijn ingediend. Beleid per zone goedkeuren, aanvechten of escaleren.',
        access_accountability_review_campaigns: 'Geplande campagnes voor toegangsbeoordeling: herhaling, bereik, toewijzing van reviewers, bijhouden van voltooiing.',
        access_reviews_list: 'Alle toegangsbeoordelingscampagnes met filters: cyclus, status, recensent, doelsysteem.',
        access_reviews_campaign_detail: 'Werkruimte voor één campagne: bereik, reviewers, itemwachtrij, certificeringsstatus, audittrail.',
        access_reviews_my_reviews: 'Aan mij toegewezen beoordelingen: hangende beslissingen met context, certificeren of intrekken per item.',
        attestation_schedules_list: "Register van attestschema's: herhaling, bereik, volgende vervaldatum, voltooiingspercentage per schema.",
        attestation_schedules_create: 'Maak een nieuw attestschema: kies frequentie, bereik, attesters en bewijsvereisten.',
        attestation_schedules_edit: 'Bewerk een bestaand attestschema. Wijzigingen zijn van toepassing op de volgende cyclus; eerdere cycli blijven ongewijzigd.',
        attestation_schedules_history: 'Historische voltooiingstijdlijn van een attestschema. Bewijsartefacten gekoppeld per cyclus.',
        governance_board_report: "Nalevingsrapport klaar voor de raad van bestuur: samenvatting, scoretrends, openstaande risico's, herstelstatus.",
        governance_compliance_score: 'Compliantiescoreberekening over verschillende raamwerken heen. Inzoomen op de bijdrage per controle.',
        governance_drift_monitor: 'Detecteer controledrift: wijzigingen in instellingen, toestemmingsverleningen, beleidsuitzonderingen die de houding verzwakken.',
        governance_audit: 'Governance-specifiek auditlogboek: workflowgebeurtenissen, goedkeuringsbeslissingen, driftsignalen.',
        governance_evidence: 'Bewijscatalogus voor governancecontroles. Ondersteunende documenten, screenshots, attestbewijzen.',
        partner_workspace_escalation: 'Escalatiedashboard voor meerdere partners: open escalaties, ernst, [[TOK_0]]-klokken en eigenaren van volgende acties.',
        partner_workspace_audit: 'Auditlogboek voor partnerwerkruimte: wijzigingen in de betrokkenheid, leverbare updates, escalatietransities.',
        partner_workspace_partner_detail: 'Profiel van één partnerorganisatie: betrokkenheidsgeschiedenis, actieve resultaten, contacten, prestatiescore.',
        partner_workspace_partner_list: 'Partnerorganisatieregister: actieve, onboarding- en offboarded-partners met serviceniveau + prestatiebadges.',
        platform_license: 'Licentie-instellingen: niveau, aantal licenties, verlengingsstatus, functieschakelaars op basis van de geïnstalleerde licentie.',
        platform_notifications_admin_queue: 'Wachtrij voor beheerdersmeldingen: waarschuwingen tijdens de vlucht, mislukte bezorging, status van nieuwe pogingen via e-mail/sms/in-app-kanalen.',
        platform_notifications_prefs: 'Voorkeuren voor meldingen per gebruiker: kanaalaanmelding, overzichtsschema, gedempte onderwerpen.',
        settings_overview: 'Overzicht van tenantinstellingen: snelle links naar domeinen, e-mail, exports, webhooks en andere platformbrede configuraties.',
        settings_domains: 'Toegestane domeinen voor aanmelding en SSO. Beperkt het aanmaken van accounts tot geverifieerde bedrijfsdomeinen.',
        settings_email: 'Configuratie van uitgaande e-mail: SMTP-provider, identiteit van de afzender, DKIM/SPF-status, test-e-mailtool.',
        settings_export_schedules: 'Geplande exports: terugkerende [[TOK_0]]/[[TOK_2]]/[[TOK_1]] generatie geleverd aan de bestandsbrowser volgens een cron-schema.',
        settings_webhooks: 'Uitgaande webhookeindpunten: externe systemen abonneren op platformgebeurtenissen. Ondertekenen, opnieuw proberen, audit van elke levering.',
        sod_rules_create: 'Maak een functiescheidingsregel: kies conflicterende rolparen, bereik en handhavingsmodus (blokkeren/waarschuwen).',
        sod_rules_edit: 'Bewerk een bestaande SoD-regel. Wijzigingen zijn onmiddellijk van kracht; bestaande overtredingen worden bij de volgende toegang opnieuw geëvalueerd.',
        sod_rules_list: 'Alle SoD-regels voor de tenant: handhavingsmodus, rolparen, aantal uitzonderingen, aantal overtredingen.',
        connectors_definitions: 'Register van connectortype: definitie van elke integratie (eindpuntvorm, authenticatie, ondersteunde bewerkingen).',
        connectors_list: 'Alle connectorinstanties zijn aangesloten op de tenant. Status, laatste synchronisatie, foutenlogboek, actie voor synchronisatie op aanvraag.',
        connectors_credentials: 'Kluis voor connectorreferenties: [[TOK_1]] tokens, [[TOK_0]] sleutels, wachtwoorden voor serviceaccounts. Rotatieschema + audit.',
        connectors_event_bus: 'Connector-gebeurtenisbus: inkomende gebeurtenissen van integraties, routeringsregels, wachtrij voor het opnieuw afspelen van dode letters.',
        consent_change_awareness: 'Detecteer betekenisvolle wijzigingen in de toestemming: doel toegevoegd, beleid bijgewerkt, bereik verbreed. Stimuleer campagnes voor hernieuwde toestemming.',
        consent_audit: 'Toestemmingsaudittraject: elke toekenning, update en intrekking in alle workflows. Primair oppervlak voor doorloop van de regelaar.',
        consent_reconciliation: 'Stem de toestemmingsstatus af op [[TOK_0]], platform- en downstream-systemen. Markeert discrepanties.',
        consent_withdrawal_propagation: 'Intrekkingsvoortplantingspijplijn: wanneer een persoon zijn toestemming intrekt, zorg ervoor dat deze naar elk gekoppeld systeem stroomt.',
        consent_policies: 'Catalogus van toestemmingsbeleid: versies van het privacybeleid, taalvarianten, activeringsvensters.',
        consent_purpose_catalog: 'Doelcatalogus gebruikt door toestemmingsworkflows. Aan elk doeleinde is een wettelijke basis en een bewaarregel verbonden.',
        consent_snapshots: 'Toestemmingsmomentopnamen: momentopname van alle actieve toestemmingen. Vereist voor audits en wettelijke bewaarplichten.',
        consent_workflows: 'Toestemmingsworkflowcatalogus. Elke workflow definieert triggers, verzamelstromen en downstream-acties.',
        discovery_classification_lineage: 'Classificatielijn: traceer hoe een data-element werd geclassificeerd via scans en handmatige beoordeling.',
        discovery_classification_rules: 'Register voor classificatieregels: regex, woordenschat, ML-patronen die worden gebruikt om ontdekte velden automatisch te classificeren.',
        discovery_dedup_rules: 'Ontdubbelingsregels voor ontdekte records. Voorkomt dat hetzelfde veld meerdere keren verschijnt.',
        discovery_import_templates: 'Importeer sjablonen om bestaande gegevenscatalogi in de Discovery-module te brengen via [[TOK_0]] of externe tools.',
        discovery_owner_review: 'Wachtrij voor eigenaarbeoordeling: voorgestelde classificaties die wachten op goedkeuring of afwijzing van de gegevenseigenaar.',
        discovery_staging: 'Verzamelplaats voor nieuw ontdekte velden. Triage vóór promotie naar de Data Mapping-catalogus.',
        discovery_suggestion_analytics: 'Analyses voor de suggestie-engine: nauwkeurigheid, dekking, meest overschreven classificaties.',
        discovery_suggestion_queue: 'Bekijk de wachtrij met voorgestelde classificaties voordat ze worden toegepast. Per item accepteren, wijzigen of afwijzen.',
        compliance_forms_filler: 'Interactieve formulierinvuller: doorloop een regelgevingsformulier met validatie, automatisch opslaan en ondersteuning voor co-auteur.',
        compliance_forms_instance_detail: 'Eén formulierexemplaar: huidige staat, geschiedenis, gekoppelde dossieraanvraag, exporten.',
        compliance_forms_outputs: 'Gegenereerde uitvoer per formulierinstantie: [[TOK_2]], [[TOK_1]], [[TOK_0]] pakketten met begeleidende brief en handtekeningen.',
        compliance_forms_submission_packages: 'Catalogus van indieningspakketten: bundels die klaar zijn voor de toezichthouder, met manifest, handtekeningen en ontvangstbewijs.',
        incident_ops_regulatory_sla: 'Regelgevende [[TOK_2]] configuratie voor incidentmeldingen (VN Cybersecurity Law 72-uurs venster, [[TOK_1]] 72-uur, [[TOK_0]] 72-uur).',
        incident_ops_response_metrics: 'Statistieken over incidentrespons: MTTD, MTTR, [[TOK_0]] nalevingspercentage, aantal escalaties.',
        incident_ops_sla_dashboard: "[[TOK_0]] dashboard: actieve incidenten tegen hun [[TOK_1]] klok, waarschuwingen voor risico's, inbreukgeschiedenis.",
        incident_ops_sla_definitions: '[[TOK_0]] definities: ernstniveaus, respons- en oplossingsvensters per laag, raamwerkcitaties.',
        monitoring_governance_raci: 'RACI-matrix voor governancecontroles: verantwoordelijk, aansprakelijk, geraadpleegd, geïnformeerd per controle over het hele programma.',
        monitoring_periods: 'Monitoringperioden: jaarlijkse/driemaandelijkse/maandelijkse beoordelingscycli afgestemd op de wettelijke indieningstermijnen.',
        monitoring_programs_list: "Monitoringprogrammacatalogus: op het raamwerk afgestemde programma's met reikwijdte, eigenaar, cadans.",
        monitoring_task_templates: 'Taaksjablonen voor het monitoren van cycli. Elke sjabloon definieert de reikwijdte, de rol van de verantwoordelijke en de bewijsvereisten.',
        access_accountability_evidence_detail: 'Details van het enkelvoudige bewijspakket: controleketen, handtekeningen, exportopties voor indiening door de toezichthouder.',
        access_accountability_evidence_packages: 'Bewijspakketcatalogus voor toegangsverantwoording: ondertekende, manipulatiebestendige bundels klaar voor audit.',
        access_reviews_role_analytics: 'Rolanalyse: dichtheid van rolgebruik, toename van rechten, trends in certificeringsbeslissingen.',
        access_accountability_pattern_analysis: 'Patroonanalyse van toegangslogboeken: ongebruikelijke toegangstijden, geografische uitschieters, signalen van escalatie van bevoegdheden.',
        access_accountability_session_dashboard: 'Sessiedashboard: live geverifieerde sessies, sessie-heatmap per uur/dag, waarschuwingen voor inactieve sessies.',
        classification_exports: 'Classificatie-export: exporteer de classificatie-inventaris als [[TOK_0]]/[[TOK_1]] voor externe audittools.',
        classification_discovery_cycles: 'Classificatie-ontdekkingscycli: geplande scans die nieuw toegevoegde of gewijzigde gegevenselementen aan het licht brengen.',
        classification_enterprise_data_map: 'Bedrijfsgegevenskaart: geaggregeerde classificatieweergave voor systemen, afdelingen en gevoeligheidsniveaus.',
        connectors_automation_planning: 'Automatiseringsplanning: definieer trigger → connector → actieketens voor gebeurtenisgestuurde databewerkingen.',
        connectors_brd_capture: 'Bedrijfsvereisten Documentregistratie voor nieuwe connectoruitbreidingen.',
        connectors_poc_scorecards: 'Proof-of-concept-scorekaarten voor het evalueren van nieuwe connectorintegraties aan de hand van acceptatiecriteria.',
        discovery_connector_management: 'Beheer van Discovery-connectoren: welke scanners zijn geïnstalleerd, wat hun status is en op welke systemen ze zich richten.',
        discovery_scans_list: 'Alle ontdekkingsscans met status, dekking en ontdekkingen. Bekijk de bevindingen per scan.',
        governance_approvals: 'Wachtrij voor governance-goedkeuringen: hangende beslissingen over onboarding van leveranciers, DPA-beoordelingen, overdrachtsbeoordelingen.',
        governance_offboarding: 'Workflow voor het offboarden van leveranciers: contractbeëindiging, gegevensretour/verwijdering, intrekking van toegang, eindaudit.',
        governance_periodic_review: "Periodieke leveranciersbeoordeling: geplande herbeoordeling van risico's, DPA-valuta, lijst met subverwerkers.",
        incident_ops_playbook_activations: 'Actieve playbook-instanties: welk playbook draait op welk incident, voortgang, openstaande taken.',
        incident_ops_playbook_links: 'Playbook → incidentkoppelingsregister. Ook links naar notificatiesjablonen voor toezichthouders per draaiboek.',
        incident_ops_playbook_templates: 'Playbook-sjablooncatalogus: herbruikbare incident-responsscripts per incidenttype en ernst.',
        organizations_groups_settings_inheritance: 'Overervingsmatrix voor instellingen voor groepsleden. Overnemen/overschrijven per categorie met audittrail.',
        organizations_intake_config_form: 'Maak of bewerk een intakeconfiguratie: openbaar [[TOK_0]] pad, tarieflimieten, captcha, routering van meldingen.',
        organizations_intake_configs_list: 'Intake-configuratiecatalogus: openbare toegangspunten voor rechtenaanvragen per markt/merk.',
        privacy_scanner_monitoring_dashboard: 'Dashboard voor monitoring van privacyscanner: eigendomsdekking, scancadans, gemarkeerde signalen per eigendom.',
        privacy_scanner_monitoring_settings: 'Controle-instellingen: scanfrequentie, drempelregels, waarschuwingsrouting, bewaren van scanresultaten.',
        privacy_scanner_settings: 'Scannerinstellingen: ingeschakelde scancategorieën, handtekeningupdates, [[TOK_0]] inloggegevens voor het scannereindpunt.',
        privacy_scanner_real_time_scan: 'Realtime scan: activeer een ad-hocscan en zie hoe de resultaten binnenstromen. Ideaal voor snelle verificatie.',
        privacy_scanner_scan_result_detail: 'Detailweergave van één enkel scanresultaat: cookies, bakens, gevonden trackers, classificatie, herstelacties.',
        privacy_scanner_results_archive: 'Archief van historische scanresultaten. Filter op eigenschap, datumbereik, signaaltype.',
        task_management_workflow_detail: "Eén workflow-exemplaar: alle stappen, eigenaren, SLA's, vertakkingslogica, voltooiingsbewijs.",
        task_management_workflow_list: 'Alle workflow-exemplaren in modules: status, eigenaar, deadline, oorsprongsmodule.',
        task_management_workflow_templates: 'Catalogus van workflowsjablonen: herbruikbare meerstapsworkflows die vanuit elke bronmodule kunnen worden geïnstantieerd.',
        audit_trail_classic: 'Klassieke audittrailweergave (verouderd). Wordt verouderd ten gunste van de uniforme auditmodule.',
        audit_trail_unified: 'Uniform audittraject voor elke module. Primair auditoppervlak.',
        iat_settings: 'Configureer de add-on Onveranderlijke Audit Trails: inschakelen, bereik, standaard proefmodus, taxonomie-overschrijvingen, limieten en [[TOK_0]] inloggegevensrotatie. Lees eerst de canonieke modulegids; de diepe metgezel is "Inschakelen en configureren".',
        iat_status: 'Blader door elke proof_link met status-, modus-, module- en datumfilters. Klik op een badge om de proefla te openen. Diepe metgezel: "Bewijsstatus begrijpen".',
        iat_integrity_center: 'Verificatie van driftdetectie gaat over een datumbereik; exporteer het Integriteitspakket voor elk auditbereik. Diepe metgezel: "Het Integriteitscentrum gebruiken".',
        iat_usage: 'Volg het huidige saldo, het maandelijkse verbruik, de limietstatus en wissel kredietpakketten in. Diepe metgezel: "Credits en Caps".',
        classification_exceptions: 'Wachtrij voor classificatie-uitzonderingen: records gemarkeerd als randgevallen, in afwachting van handmatige beoordeling.',
        classification_review_tasks: 'Wachtrij voor classificatiebeoordelingstaken: automatisch voorgestelde classificaties die wachten op bevestiging van de eigenaar.',
        consent_properties_audit_log: 'Audittrail voor wijzigingen in toestemmingseigenschappen: wie heeft wat bijgewerkt, wanneer, oude/nieuwe waarden.',
        consent_properties_analytics: 'Analyse van toestemmingseigendommen: percentage vastgelegde toestemming, opnamepercentage, trends in de doelmix.',
        consent_properties_evidence_packs: 'Bewijspakketten voor toestemmingseigenschappen: bundels die klaar zijn voor toezichthouders en bewijzen dat toestemming wordt nageleefd.',
        consent_properties_inconsistencies: 'Inconsistenties in toestemmingseigendommen: eigenschappen waarbij het platform en [[TOK_0]] het niet eens zijn over de status.',
        consent_properties_golden_templates: 'Gouden toestemmingsbannersjablonen: goedgekeurde, beoordeelde, bestuursklare bannervormen die voor alle accommodaties worden ingezet.',
        consent_properties_template_rollouts: 'Uitrolpijplijn voor sjablonen: fase, pilot, productiegolven voor het pushen van gouden sjablonen naar eigendommen.',
        consent_properties_property_groups: 'Eigenschapsgroepen: clustergerelateerde eigenschappen voor governance- en rapportagecombinaties.',
        consent_properties_snapshot_schedules: "Momentopnameschema's: automatiseer periodieke registraties van toestemmingsstatussen voor audit- en juridische bewaardoeleinden.",
        deletion_orchestration_completeness: 'Volledigheidstracker: verifieert elk systeem in de bevestigde verwijdering van het retentiebereik.',
        deletion_orchestration_runs_list: 'Alle verwijderingsruns: status, duur, gedekte systemen, voltooiingspercentage.',
        deletion_orchestration_vendor_requests: 'Uitgaande verwijderingsverzoeken aan leveranciers: tracking, [[TOK_0]], verificatieartefacten.',
        deletion_orchestration_vendor_verification: 'Workflow voor leveranciersverificatie: bevestig dat de systemen van de leverancier het wissen hebben voltooid volgens ons verzoek.',
        compliance_forms_catalog: 'Catalogus van conformiteitsformulieren: elk regelgevingsformulier (Mẫu số, [[TOK_0]] Art 30, ISO 27701) beschikbaar voor indiening.',
        compliance_forms_template_browser: 'Sjabloonbrowser: ontdek goedgekeurde formuliersjablonen in verschillende frameworks.',
        governance_cross_border: 'Register voor grensoverschrijdende overdrachten op bestuursniveau: mechanismen, waarborgen, landenrisicobeoordeling.',
        governance_subprocessors: 'Register van subverwerkers: wie onze leveranciers gebruiken, DPA-cascade, melding van wijzigingen.',
        incidents_detail: 'Werkruimte voor één incident: tijdlijn, eigenaar, ernst, herstel, status van melding van toezichthouders.',
        incidents_list: 'Incidentenregister: alle actieve + historische incidenten met filters voor ernst, kanaal, raamwerk.',
        partner_workspace_partner_dashboard: "Partnerdashboard: KPI's op het hoogste niveau voor alle partnerbetrokkenheid, escalatieaantallen, gezondheidstrends.",
        partner_workspace_support_tickets: 'Ticketcatalogus voor partnerondersteuning. Gedeeld tussen partner- en tenantteams met [[TOK_0]]-tracking.',
        program_governance_acknowledgment_tracking: 'Documentbevestiging volgen: wie elk beleid of elke procedure heeft gelezen en erkend.',
        program_governance_change_log: 'Documentwijzigingslogboek: elke bewerking van een governancedocument met diff- en goedkeuringsketen.',
        roles_detail: 'Detail van één rol: machtigingen gebonden aan deze rol, toegewezen gebruikers, audit van lidmaatschapswijzigingen.',
        roles_list: 'Rollencatalogus: elke ingebouwde en aangepaste rol met ledenaantal en machtigingsbereik.',
        consent_properties_cross_property_dashboard: 'Dashboard voor meerdere eigendommen: toestemmingsstatus voor elk eigendom. Aggregaten vangpercentage, opnamepercentage, driftindicatoren.',
        consent_properties_property_registry: 'Eigendomsregister: elke woning die de huurder beheert met de status van de toestemmingsbanner, gekoppeld aan [[TOK_0]], beleidsversie.',
        forseti_projects_overview: 'Forseti-werkruimten: een project groepeert documenten, gesprekken, workflowruns en beoordelingen in tabelvorm in één container, zodat de [[TOK_0]]-adviseur de context gedurende de hele opdracht behoudt.',
        forseti_workflows_list: 'Er zijn [[TOK_0]]-promptsjablonen opgeslagen die op verzoek taken produceren en bewijsmateriaal opstellen. Gebruik ingebouwde pakketworkflows of schrijf uw eigen workflows; runs worden in rekening gebracht op uw maandelijkse tokenbucket.',
        forseti_tabular_reviews_list: 'Herhaalbare, kolom-voor-kolom beoordeling van een documentcorpus. Definieer de vragen één keer, voer dezelfde beoordeling uit over veel bijlagen en krijg een antwoordraster naast elkaar met citaten.',
        forseti_document_review_index: "Triage inbox voor documenten met door [[TOK_0]] voorgestelde bewerkingen of versies afkomstig van Forseti. Documenten komen in de wachtrij terecht via chats, workflowruns of de CTA 'Een document ter beoordeling verzenden' op deze pagina.",
        forseti_audit_lineage: 'Traceer elk [[TOK_0]]-gegenereerd artefact dat aan een record is gekoppeld: chats, tooloproepen, taken, bewijsconcepten en documentversies. Vereist voor de verdedigbaarheid van bewijsmateriaal en audits na de actie.',
        forseti_draft_evidence: '[[TOK_0]] heeft bewijsmateriaal opgesteld in afwachting van menselijke beoordeling. Elk concept moet worden goedgekeurd door een geautoriseerde beoordelaar voordat het formeel bewijs wordt. Forseti archiveert nooit automatisch.',
        forseti_usage: 'Tokenverbruik en bucketstatus voor deze organisatie. Houdt maandelijks factureerbare eenheden, resterende bucket en recente activiteit bij per gebruiker/functie/tool.',
        forseti_overview: 'Toegangspunt tot de juridisch adviseur van Forseti [[TOK_0]]: kies een persona, blader door recente chats en start een nieuw gesprek. Persona-selectie stelt hier de standaardstem in voor nieuwe chats.',
        forseti_chat_detail: 'Eén Forseti-gesprek: bekijk de berichtgeschiedenis, wissel van personage tijdens de chat, stuur nieuwe berichten en exporteer het transcript als [[TOK_0]] voor bewijsdoeleinden.',
        forseti_cross_framework_conflicts: 'Samengestelde catalogus van conflicten tussen de regelgevingspakketten die uw organisatie heeft geïnstalleerd. Filter op raamwerk/onderwerp/ernst/bevestigingsstatus, klik op een rij om raamwerkposities naast elkaar te bekijken en te bevestigen/toewijzen/oplossen. Forseti brengt de conflicten aan het licht; mensen beslissen.',
        users_detail: 'Profiel voor één gebruiker: identiteit, rol, MFA, sessiegeschiedenis, audittrail.',
        users_list: 'Gebruikerslijst: alle actieve, uitgenodigde en gedeactiveerde gebruikers met snelfilters en bulkacties.',
        governance_vendors: 'Beheer de levenscyclus van leveranciersbeheer: onboarding-pijplijn, periodieke beoordelingen, goedkeuringen en offboarding. Volg de nalevingsstatus van leveranciers en de naleving van het draaiboek.',
        governance_compliance: 'Houd toezicht op de compliance van de organisatie met scores, detectie van afwijkingen en bestuursrapportage. Volg nalevingstrends en genereer rapporten die geschikt zijn voor managers.',
        governance_transfers: 'Beheer grensoverschrijdende gegevensoverdrachten, DPA-beoordelingen en beheer van subverwerkers. Mechanismen voor documentoverdracht en zorgen voor naleving van de regelgeving voor internationale gegevensstromen.',
        vendor_risk_assessment: 'Beoordeel en scoor het leveranciersrisico voor uw hele portfolio. Houd risicosignalen in de gaten, volg herbeoordelingen en onderhoud een alomvattend overzicht van de risicoportfolio.',
        vendor_risk_contracts: 'Beheer leverancierscontracten, due diligence-vragenlijsten en poortevaluaties. Houd contractvoorwaarden, verlengingsdata en nalevingsvereisten bij.',
        vendor_risk_onboarding: 'Beheer de onboarding-levenscyclus van de leverancier: intakebeoordeling, beoordelingsroutering, goedkeuringsworkflows en beslissingen over risicoacceptatie.',
        vendor_risk_dashboard: "Centraal overzicht van uw leveranciersrisicopositie: portefeuilleverdeling per niveau, recente niveauwijzigingen, contracten die binnen 90 dagen aflopen, beoordeling van KPI's en de status van risicoacceptatie. Begin hier om alles in één oogopslag te lezen voordat u dieper ingaat op scorepunten, signalen of poorten.",
        vendor_risk_scoring: 'Configureer scoredimensies en evalueer leveranciers op basis van gewogen risicocriteria. Houd samengestelde scores, toegewezen niveaus en scoregeschiedenis in de loop van de tijd bij.',
        vendor_risk_signals: 'Houd ongunstige gebeurtenissen bij die een herbeoordeling van de leverancier kunnen rechtvaardigen: het verlopen van de certificering, meldingen van inbreuken, financiële instabiliteit en wijzigingen in de naleving. Signalen sturen stroomafwaartse herbeoordelingstaken aan.',
        vendor_risk_reviews: "Voer periodieke leveranciersbeoordelingen uit met momentopnamen van de contractstatus, bevindingen en aanbevelingen. Volg de beoordelingsresultaten (bevredigend, geconstateerde problemen, herstel vereist, geëscaleerd) voor alle programma's en perioden.",
        vendor_risk_reassessments: "Activeer en beheer herbeoordelingstaken wanneer signalen of periodieke schema's wijzen op een gewijzigde risicohouding. Registreer de resultaten en bijgewerkte risiconiveaus; voltooide herbeoordelingen vloeien terug naar de score.",
        vendor_risk_acceptance: 'Accepteer formeel het resterende leveranciersrisico met expliciete voorwaarden, vervaldata en rechtvaardiging. Houd het risicoacceptatieregister bij: het controleerbare overzicht van actieve, verlopen en ingetrokken acceptatiebeslissingen.',
        vendor_risk_onboarding_cases: 'Beheer de levenscyclus van de onboarding van leveranciers: nieuwe onboarding, beoordelingen van materiële wijzigingen en periodieke beoordelingen. Werk door gefaseerde tabbladen met voltooiingsindicatoren en activeer goedkeuringspoorten wanneer u klaar bent.',
        vendor_risk_review_routing: 'Stuur beoordelingstaken van leveranciers naar specifieke revisoren per gebruiker en rol. Wijs vragenlijsten toe, houd de opdrachten van reviewers bij en leg de routeringsresultaten vast met een volledig audittraject.',
        vendor_risk_gates: 'Evalueer goedkeuringspoorten voor inkoop voordat leveranciers live gaan. Configureer poortcriteria (certificeringen, DPA ondertekend, vragenlijst ingevuld, risico binnen de drempel), leg de overschrijvingsredenen vast en koppel bewijsmateriaal.',
        vendor_risk_questionnaires: 'Creëer sjablonen voor due diligence-vragenlijsten en wijs deze toe aan leveranciers. Houd de voltooiing van reacties bij, bekijk annotaties en bevindingen die bijdragen aan risicoscores en goedkeuringspoorten.',
        monitoring_programs: "Creëer en beheer compliance-monitoringprogramma's die zijn gekoppeld aan regelgevingskaders. Wijs taken toe via RACI-governance en volg de programma-uitvoering.",
        monitoring_kpi: "Volg nalevings-KPI's, scores voor autoriteitsgereedheid en de beoordelingsstatus van wijzigingen. Dashboardweergave van het monitoren van programmaprestaties in alle actieve frameworks.",
        discovery_scans: 'Voer datadetectiescans uit op verbonden systemen. Beheer detectiecycli met deltadetectie, configureer connectoren en houd scanresultaten bij.',
        discovery_classification: 'Beoordeel ontdekkingssuggesties, beheer de verzamelplaats voor nieuw ontdekte gegevens en voer een beoordeling door de eigenaar uit met classificatie-aanbevelingen.',
        discovery_management: 'Configureer deduplicatieregels, beheer importsjablonen en traceer de classificatielijn vanaf ontdekking tot goedgekeurde classificatielabels.',
        connectors_integration: 'Configureer systeemconnectoren, beheer inloggegevens en bewaak de gebeurtenisbus voor realtime gegevenssynchronisatie tussen geïntegreerde systemen.',
        connectors_automation: 'Plan automatiseringsstrategieën, leg bedrijfsvereisten vast en evalueer proof-of-concept-scorekaarten voor systeemintegratieprojecten.',
        connectors_governance: 'Beheer de systeeminventaris, voer beveiligingsbeoordelingen uit, onderhoud traceerbaarheidsmatrixen en houd registers van integratielacunes bij.',
        task_management_tasks: 'Bekijk en beheer nalevingstaken: takenlijst, persoonlijke takenwachtrij, achterstallige taken, taakbord en kalenderweergaven voor het volgen van werk in alle modules.',
        task_management_workflows: 'Ontwerp en beheer compliance-workflows: maak workflow-sjablonen, configureer sectietoewijzingen en bewaak de uitvoering van de workflow.',
        compliance_forms_templates: 'Blader door en beheer sjablonen voor nalevingsformulieren. Krijg toegang tot de sjablonencatalogus, maak aangepaste sjablonen en configureer formulierindelingen voor indieningen bij de regelgeving.',
        compliance_forms_submissions: 'Nalevingsformulieren invullen en indienen. Houd formulierexemplaren bij, bekijk de resultaten en beheer indieningspakketten voor wettelijke indiening.',
        compliance_forms_filing: 'Beheer de koppelingen naar dossiers, sectieroutering en consolidatie tussen meerdere afdelingen voor het voorbereiden en indienen van regelgevingsdossiers.',
        organizations_entities: 'Beheer organisatie-entiteiten, wijs regelgevingskaders per entiteit toe en configureer afdelingshiërarchieën voor naleving door meerdere entiteiten.',
        organizations_groups: 'Beheer organisatiegroepen voor ondernemingen met meerdere entiteiten. Deel leveranciers, raamwerken en formuliersjablonen met groepsleden met geconsolideerde rapportage.',
        organizations_intake: 'Configureer de intake-instellingen en beheer de overname van instellingen binnen de hiërarchieën van de organisatie.',
        access_accountability_sessions: 'Bewaak gebruikerssessies, bekijk toegangslogboeken en analyseer toegangspatronen. Volg sessie-activiteit met verankeringsstatus voor bewijs van verantwoordelijkheid.',
        access_accountability_reviews: 'Voer toegangsbeoordelingscampagnes uit, beheer rechtvaardigingsbeoordelingen en houd de voortgang van de beoordelaars bij. Coördineer periodieke toegangscertificering binnen de hele organisatie.',
        access_accountability_sod: 'Definieer regels voor de scheiding van taken, detecteer overtredingen en beheer uitzonderingen. Dwing controles op belangenverstrengeling af voor alle rollen en machtigingen.',
        access_accountability_evidence: 'Genereer bewijspakketten voor toegangsbeoordelingen, voer onderzoeken uit en analyseer rolgebruikspatronen voor rapportage over toegangsverantwoordelijkheid.',
        program_governance_maturity: 'Beoordeel en volg de volwassenheid van het complianceprogramma binnen de verschillende frameworks. Definieer volwassenheidsmodellen, voer beoordelingen uit en volg verbeteringstrends in de loop van de tijd.',
        program_governance_obligations: 'Breng wettelijke verplichtingen in kaart voor organisatie-eenheden met RACI-governance. Definieer het governancemodel en volg herstelplannen voor geïdentificeerde hiaten.',
        program_governance_documents: 'Beheer het register van governancedocumenten: stel de erkenning van compliancebeleid en operationele documenten op, bekijk, publiceer en volg de erkenning ervan.',
        program_governance_reporting: "Genereer samenvattingen, auditgereedheidsrapporten en analyses van bewijslacunes. Houd rapportageperioden bij en bewaak de statusstatistieken van programma's.",
        deletion_orchestration_runs: 'Voer verwijderingsorkestratieruns uit en bewaak deze. Volg uitvoeringstaken, verifieer de volledigheid en beheer het verwijderingsdashboard.',
        deletion_orchestration_vendors: 'Coördineer verwijderingsverzoeken van leveranciers, controleer of de leverancier voldoet aan de verwijderingsverplichtingen en onderhoud bewijsketendocumentatie.',
        consent_management: 'Beheer toestemmingsbeleid, doelcatalogi en toestemmingsworkflows. Configureer regels voor het verzamelen van toestemming en houd momentopnamen van toestemming in de loop van de tijd bij.',
        consent_cmp: "Integreer met Consent Management Platforms (CMP's): configureer webhooks, wijs [[TOK_0]] doeleinden toe aan GRC-catalogusdoeleinden en synchroniseer toestemmingsrecords.",
        consent_compliance: 'Bewaak de naleving van de toestemming: detecteer configuratiewijzigingen, corrigeer discrepanties, volg de verspreiding van intrekkingen en bekijk het toestemmingsaudittraject.',
        partner_workspace_partners: 'Beheer partnerorganisaties, voer partneraudits uit en handel escalaties af. Volg de onboardingstatus van partners en nalevingsvereisten.',
        partner_workspace_operations: 'Beheer partnerresultaten, workflowsjablonen, serviceniveaus en merkprofielen. Configureer operationele workflows voor samenwerking met partners.',
        privacy_scanner_scanning: 'Voer realtime privacyscans uit op websites en applicaties. Bekijk scanresultaten, volg bewijsmateriaal vóór toestemming en beheer het scanarchief.',
        privacy_scanner_monitoring: "Configureer dashboards en instellingen voor het bewaken van de privacyscanner. Stel geautomatiseerde scanschema's in en beheer de scannerconfiguratie.",
        consent_import: 'Toestemmingsrecords bulksgewijs importeren uit [[TOK_0]] bestanden. Ideaal voor het op grote schaal registreren van papieren toestemming (arbeidsovereenkomsten, toestemmingsformulieren van ouders/school). Ondersteunt workflowtypen voor toekenning, intrekking, beperking en bezwaar.',
        cases_import: "Bulkimport van aanvragen voor de rechten van betrokkenen uit [[TOK_0]] bestanden. Ondersteunt bronnen voor intake via meerdere kanalen, waaronder telefoon-, post-, e-mail- en persoonlijke inzendingen voor organisaties die grote hoeveelheden DSAR's ontvangen.",
        data_subjects: 'Bekijk uniforme profielen van betrokkenen waarin alle gevallen van rechtenverzoeken en toestemmingsrecords voor elk individu zijn verzameld. Volg de volledige privacylevenscyclus per persoon: toestemmingsgeschiedenis, DSR-gevallen en interactietijdlijn.',
        files_config: 'Stel het platformbrede beleid voor het uploaden van bestanden in: groottelimieten, type-toelatingslijst, standaardbewaarinstellingen en regels voor wettelijke bewaring. Met overschrijvingen per eigenaartype kunt u het beleid voor gevoelige modules (bijvoorbeeld bewijs van rechtenaanvragen) aanscherpen, terwijl de rest van de organisatie op de standaardinstelling blijft. Wanbetalingen bij het bewaren ondersteunen de verwachtingen op het gebied van gegevensminimalisatie op grond van [[TOK_0]] Wet 91/2025, artikel 3; juridische bewaring schort de verwijdering op tijdens lopende onderzoeken of geschillen.',
        files_browser: 'Blader, doorzoek en beheer elke bijlage die binnen de organisatie wordt geüpload. Filter op eigenaarsmodule, uploader, datum en MIME-type; open de bijlagedetaillade om de auditgeschiedenis, de gekoppelde entiteit en de bewaarstatus te bekijken. Een operationele weergave (niet raamwerkspecifiek) die door beheerders en auditors wordt gebruikt om bestanden te vinden en te beoordelen.',
        files_dashboard: 'Operationeel overzicht van het bestandsoppervlak: totale opslag, groei in de loop van de tijd, verweesde bijlagen (geen bovenliggende entiteit) en naleving van het bewaarbeleid per type eigenaar. Gebruik het om beleidsafwijkingen op te sporen (bijvoorbeeld een module die bestanden bewaart voorbij de algemene retentieperiode) en om opslag te budgetteren. Operationele tooling – niet gebonden aan een specifiek regelgevingskader.',
    },
    framework_rights: {
        be_informed: 'Recht op informatie',
        consent: 'Recht op toestemming',
        refuse_consent: 'Recht om toestemming te weigeren',
        withdraw_consent: 'Recht om toestemming in te trekken',
        access: 'Recht van inzage',
        rectification: 'Recht op rectificatie',
        data_provision: 'Recht op gegevensverstrekking',
        deletion: 'Recht op verwijdering',
        restriction_of_processing: 'Recht op beperking van verwerking',
        object_to_processing: 'Recht van bezwaar tegen verwerking',
        complaint: 'Recht om een klacht in te dienen',
        denunciation: 'Recht op aangifte',
        lawsuit: 'Recht om een rechtszaak aan te spannen',
        claim_damages: 'Recht op schadevergoeding',
        request_protection_measures: 'Recht om beschermingsmaatregelen te verzoeken',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Richtlijn 2002/58/EG (ePrivacy-richtlijn)',
            description: 'Moederrichtlijn voor nationale ePrivacy-omzettingen. Omvat cookies, privacy van elektronische communicatie, direct marketing. Elke lidstaat moet deze omzetten in nationaal recht.',
        },
        EU_GDPR: {
            display_name: 'Algemene Verordening Gegevensbescherming (EU) 2016/679',
            description: 'De Algemene Verordening Gegevensbescherming ([[TOK_0]]) is een EU-verordening inzake gegevensbescherming en privacy. Het is rechtstreeks van toepassing in alle EU/EER-lidstaten.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Richtlijn (EU) 2022/2555 ([[TOK_0]])',
            description: 'Moederrichtlijn voor nationale [[TOK_0]]-omzettingen. Omvat cyberbeveiligingsrisicobeheer, incidentrapportage en beveiliging van de toeleveringsketen voor essentiële en belangrijke entiteiten.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Vietnam [[TOK_0]] wet ([[TOK_1]]) — van kracht vanaf 1 maart 2026',
            description: 'Vietnam [[TOK_0]] Wet (Luật Trí tuệ nhân tạo [[TOK_2]]) die de ontwikkeling, inzet en gebruik van kunstmatige-intelligentiesystemen regelt. Stelt verplichtingen op het gebied van risicoclassificatie, transparantie en etikettering, vereisten voor het melden van incidenten, verplichtingen voor effectbeoordeling en een gecontroleerd testmechanisme (sandbox) vast voor [[TOK_1]]-activiteiten in Vietnam.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Vietnam Cybersecurity-wet (tijdperk 24/2018)',
            description: 'De Vietnamese wet inzake cyberbeveiliging (wet nr. [[TOK_0]]) waarin eisen worden vastgelegd voor cyberbeveiliging, gegevenslokalisatie en incidentrapportage. Actief totdat deze wordt vervangen door wet [[TOK_1]], van kracht op 01-07-2026.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Decreet 53 — Implementatie van de cyberbeveiligingswet',
            description: 'Decreet [[TOK_0]] ter implementatie van de cyberbeveiligingswet, met betrekking tot bepaling binnen de reikwijdte, triggers voor gegevenslokalisatie, vereisten voor lokale aanwezigheid en workflows voor samenwerking tussen autoriteiten.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Wet op cyberbeveiliging ([[TOK_0]])',
            description: 'De geconsolideerde wet van Vietnam inzake cyberbeveiliging (Wet [[TOK_0]]), ter vervanging van Wet [[TOK_1]], van kracht per 1 juli 2026. Consolideert de reikwijdte van Decreet [[TOK_2]]Đ-CP (zie VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Gegevenswet Vietnam',
            description: 'De Vietnamese datawet (wet [[TOK_0]]) die uitgebreide vereisten voor databeheer vastlegt, waaronder data-inventarisatie, classificatie, gedeeld beheer en grensoverschrijdend beheer van gegevensoverdracht. Overlapt met VN_PDPL_LAW_2025 (persoonlijke gegevensaspecten) en VN_CYBERSEC_LAW_2025 (gegevenslokalisatie/classificatie).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Decreet [[TOK_0]]Đ-CP (implementatie gegevenswet)',
            description: 'Decreet [[TOK_0]]Đ-CP ter implementatie van de Vietnamese gegevenswet (wet [[TOK_1]]). Biedt officiële formulieren voor de effectbeoordeling van grensoverschrijdende gegevensoverdracht, jaarlijkse risicobeoordelingsrapportage en toegang tot nationale databases. Definieert 11 officiële Mẫu số-vormen.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Ontwerpbesluit data-uitwisselingen 2026',
            description: 'Ontwerpdecreet betreffende de werking van platforms voor gegevensuitwisseling (Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu). Regelt platformclassificatie, geschiktheid van deelnemers, controles op dataproducten en -services, sandbox-testen, transactieworkflow, elektronische contracten, certificaten van eigendomsrechten op gegevens en afhandeling van klachten/geschillen. Momenteel in openbare consultatie; nog niet afgekondigd. Citeert de wet inzake gegevens [[TOK_0]], de wet inzake de bescherming van persoonsgegevens [[TOK_1]], de wet inzake cyberbeveiliging [[TOK_2]] en de wet inzake elektronische transacties [[TOK_3]].',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Wet op de elektronische handel ([[TOK_0]])',
            description: 'De Vietnamese wet inzake elektronische handel (Luật Thương mại điện tử [[TOK_0]]) tot vaststelling van een uniform nationaal regime voor elektronische handel, dat betrekking heeft op binnenlandse en grensoverschrijdende platformoperaties, platformbeheer en -verantwoording, consumentenbescherming, controles op verkopers en partners, klachtenafhandeling, inhoudsmoderatie en verwijderingshandhaving, en gereedheid voor administratieve procedures voor het staatsbeheersysteem voor e-commerce.',
        },
        VN_PDPL: {
            display_name: 'Vietnam [[TOK_0]] (tijdperk Decreet 13/2023)',
            description: 'Het Vietnamese besluit inzake de bescherming van persoonsgegevens (Decreet [[TOK_0]]) waarin uitgebreide vereisten voor gegevensbescherming zijn vastgelegd. Verouderd raamwerk — vervangen door wet [[TOK_1]] en decreet [[TOK_2]] met ingang van 01-01-2026.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Decreet 13 — [[TOK_0]] Operationele basislijn',
            description: 'Decreet [[TOK_1]], het operationele instrument voor [[TOK_0]] taken, waaronder het indienen van dossiers, bestuursartefacten, grensoverschrijdende mechanismen en administratieve MoPS-procedures. Vervangen door decreet [[TOK_2]] van kracht op 01-01-2026.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Wet bescherming persoonsgegevens ([TOK_0]])',
            description: "De Vietnamese wet op de bescherming van persoonsgegevens (wet [[TOK_2]]) die een alomvattend raamwerk voor de bescherming van persoonsgegevens tot stand brengt, van kracht vanaf 1 januari 2026. Heeft betrekking op nalevingsthema's A tot en met J: grondslagen voor rechtmatige verwerking, toestemming voor gevoelige gegevens, rechten van betrokkenen (toegang/rectificatie/verwijdering/beperking/bezwaar/portabiliteit), melding van inbreuken aan autoriteiten en betrokkenen, [[TOK_0]] voor verwerking met een hoog risico, beheer van grensoverschrijdende overdrachten, [[TOK_1]] aanduiding, gegevens van verwerkingsactiviteiten, contractuele verplichtingen van de verwerker. Verplichte indiening door de autoriteit via MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Kruisverwijzingen: VN_PDPL_DECREE_356_2025 (uitvoeringsbesluit), VN_CYBERSEC_LAW_2025 (overlappingen op het gebied van cyberbeveiliging), VN_DATA_LAW (data governance).",
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Decreet [[TOK_1]] ([[TOK_0]] Uitvoering)',
            description: 'Decreet [[TOK_0]] ter uitvoering van de Wet bescherming persoonsgegevens, ter vervanging van Decreet [[TOK_1]]. Omvat dossierarchivering, governance-artefacten, grensoverschrijdende mechanismen en certificering van dienstverleners. Bijlageformulier inventaris: Phụ lục I–VIII (effectbeoordeling, grensoverschrijdende overdracht, certificering). Administratieve MoPS-procedures via VN_PDPL_ADMIN_PROCEDURES_778_2026 (Besluit 778/QĐ-BCA-A05). Certificeringsworkflow: aanvraag → uitgifte → wijzigingsverzoek → heruitgave → intrekking. Kruisverwijzingen: VN_PDPL_LAW_2025 (moederwet), VN_CYBERSEC_LAW_2025 (gegevenslokalisatie), VN_DATA_LAW (overlappingen op het gebied van gegevensbeheer).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] A05 Administratieve procedures (Besluit 778/QĐ-BCA-A05)',
            description: 'Besluit 778/QĐ-BCA-A05 (februari 2026) — Administratieve procedures voor de bescherming van persoonsgegevens onder A05 ([[TOK_0]]). Definieert de procedures voor het indienen, verwerken en uitgeven van resultaten, inclusief DLCN-HC-formulieren en Mẫu số wettelijke formulieren.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Ontwerp Handhavingsbesluit 2026',
            description: 'Ontwerphandhavings- en sanctiebesluit voor overtredingen van de Wet bescherming persoonsgegevens (Wet [[TOK_0]]). Definieert de strafmaat, verzwarende/verzachtende factoren en handhavingsprocedures. Momenteel in conceptstatus in afwachting van afkondiging.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Vietnam Telecommunicatiewet 2023',
            description: 'Vietnam Telecommunicatiewet 2023 (Luật Viễn tông), een sectoroverlay voor telco-/ISP-/platformbedrijven met verplichtingen op het gebied van vertrouwelijkheid, openbaarmaking en afhandeling van autoriteitsverzoeken. Kruisverwijzingen: VN_CYBERSEC_LAW_2025 (beveiliging van informatiesystemen), VN_PDPL_LAW_2025 (verwerking van gebruikersgegevens), VN_DATA_LAW (gegevensbeheer).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Decreet [[TOK_0]]Đ-CP (implementatie telecomwet)',
            description: 'Decreet [[TOK_0]]Đ-CP ter uitvoering van de telecommunicatiewet (wet [[TOK_1]]). Biedt officiële formulieren voor kennisgevingen aan telecomdiensten, licenties, registratie en ontwikkelingsplannen voor datacenters. Definieert 7 officiële Mẫu số-vormen.',
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Indiening van een ontwikkelingsplan voor het datacenter',
            description: 'Ontwikkelingsplannen voor datacenters moeten worden ingediend bij de bevoegde autoriteit overeenkomstig decreet [[TOK_0]]Đ-CP.',
        },
        d163_r3: {
            title: 'Registratie van telecomdiensten',
            description: 'Registratie van telecommunicatiediensten moet met behulp van het voorgeschreven formulier bij de bevoegde autoriteit worden ingediend.',
        },
        d163_r2: {
            title: 'Aanvraag telecomvergunning',
            description: 'Aanvragen voor telecommunicatievergunningen moeten worden ingediend met behulp van het voorgeschreven formulier in overeenstemming met besluit [[TOK_0]]Đ-CP.',
        },
        d163_r1: {
            title: 'Melding telecomdienstverlening',
            description: 'Telecomdienstverleners moeten vóór aanvang van de dienstverlening de bevoegde autoriteit van de dienstverlening op de hoogte stellen via het voorgeschreven formulier.',
        },
        vn_dp_draft_f: {
            title: 'Klachten, geschillen en risicobeheer',
            description: "Platformexploitanten moeten zorgen voor klachteninname, een workflow voor geschillenbehandeling met behoud van bewijsmateriaal, controles op risico-identificatie en vroegtijdige waarschuwing, en periodieke evaluatie van de risico's op het gebied van privacy, cyberbeveiliging en toegangsbeheer.",
        },
        vn_dp_draft_e: {
            title: 'Transactieworkflow en certificaat van eigendomsrechten op gegevens',
            description: 'Transacties vereisen accountregistratie, goedkeuring van de aanbieding, elektronische contractering, betalingsbevestiging, leveringsbewijs en uitgifte van een certificaat van eigendomsrechten op gegevens, indien van toepassing. Transactiegeschiedenis en traceerbaarheid moeten worden bewaard in een transactieregister.',
        },
        vn_dp_draft_d: {
            title: 'Sandbox- en testomgevingscontroles',
            description: 'Testomgevingen moeten worden geïsoleerd, met beperkte toegang, met beveiligingsmonitoring en worden beoordeeld voordat er enige output uit wordt gehaald. Er mogen geen brongegevens uit de testomgeving worden gehaald en het afsluiten/opschonen van testsessies moet worden vastgelegd.',
        },
        vn_dp_draft_c: {
            title: 'Bedieningselementen voor gegevensproducten en -services',
            description: 'Advertenties moeten worden ondersteund door bewijs van wettige bron en eigendom/gebruiksrecht, technische validatiegegevens, openbaarmakingen over de kwaliteit en gegevens over de beoordeling en goedkeuring van vermeldingen op het platform. Verboden gegevens moeten worden gefilterd voordat ze worden vermeld.',
        },
        vn_dp_draft_b: {
            title: 'Geschiktheid van deelnemers en onboarding',
            description: 'Platformexploitanten moeten de juridische status, juridische capaciteit en voorwaardelijke zakelijke vereisten voor verkopers en kopers verifiëren, transactie- en betaalrekeningen registreren en een deelnemersregister bijhouden.',
        },
        vn_dp_draft_a: {
            title: 'Classificatie en bedrijfsmodel van dataplatforms',
            description: 'Platformexploitanten moeten een classificatie van platformtype vaststellen (nationaal dataplatform versus andere dataplatforms), de geschiktheid en verantwoordelijkheden van operators definiëren, en prijzen, vergoedingen, werkingsregels en technisch bestuur documenteren.',
        },
        d165_r5: {
            title: 'Toegang tot nationale database-informatie',
            description: 'Voor verzoeken om informatie uit de nationale digitale databank te halen/gebruiken worden voorgeschreven formulieren gebruikt (Mẫu số 07a/07b).',
        },
        d165_r4: {
            title: 'Jaarlijkse risicobeoordelingsrapportage',
            description: 'Jaarlijkse risicobeoordelingsrapporten moeten worden ingediend met behulp van voorgeschreven formulieren (Mẫu số 05a/05b, 06).',
        },
        d165_r3: {
            title: 'Kennisgeving van beëindiging van de grensoverschrijdende overdracht',
            description: 'Beëindiging van grensoverschrijdende overdracht moet worden gemeld met behulp van voorgeschreven formulieren (Mẫu số 04a/04b).',
        },
        d165_r2: {
            title: 'Kennisgeving van beoordelingsresultaten',
            description: 'De autoriteit geeft mededelingen over beoordelingsresultaten uit volgens het voorgeschreven formulier (Mẫu số 03).',
        },
        d165_r1: {
            title: 'Indiening van effectbeoordeling van grensoverschrijdende gegevensoverdracht',
            description: 'Organisaties moeten grensoverschrijdende gegevensoverdracht/effectbeoordelingsdossiers indienen met behulp van voorgeschreven formulieren (Mẫu số 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Toestemming voor cookies en soortgelijke technologieën',
            description: 'Het opslaan van of toegang krijgen tot informatie op eindapparatuur is alleen toegestaan met voorafgaande geïnformeerde toestemming, behalve voor technisch noodzakelijke opslag.',
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Vertrouwelijkheid van communicatie',
            description: 'De lidstaten waarborgen de vertrouwelijkheid van communicatie en daarmee samenhangende verkeersgegevens door middel van een openbaar communicatienetwerk en openbaar beschikbare elektronische-communicatiediensten.',
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Toestemming voor direct marketing (opt-in)',
            description: 'Voor het gebruik van elektronische communicatiesystemen voor direct marketing is voorafgaande toestemming van de abonnee vereist.',
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Zachte opt-in voor bestaande klanten',
            description: 'Directe marketing naar bestaande klanten voor vergelijkbare producten/diensten is zonder toestemming toegestaan als er een opt-outmogelijkheid bestaat.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Inbreukmelding voor telecomaanbieders',
            description: 'Aanbieders van openbare elektronische-communicatiediensten stellen de bevoegde nationale autoriteit in kennis van inbreuken op persoonsgegevens.',
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: 'Recht om bezwaar te maken tegen direct marketing',
            description: 'Abonnees krijgen de mogelijkheid om op elk moment en kosteloos bezwaar te maken tegen het ontvangen van directmarketingberichten.',
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Bewaren en wissen van verkeersgegevens',
            description: 'Verkeersgegevens met betrekking tot abonnees en gebruikers moeten worden gewist of geanonimiseerd wanneer ze niet langer nodig zijn voor verzending, met uitzondering van facturering of interconnectiebetalingen.',
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Voorwaarden voor verwerking van locatiegegevens',
            description: 'Andere locatiegegevens dan verkeersgegevens mogen alleen worden verwerkt als ze geanonimiseerd zijn of met toestemming van de gebruiker, voor zover en voor de duur die nodig is.',
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Rechtmatigheid van de verwerking – toestemming',
            description: 'De verwerking is alleen rechtmatig als de betrokkene toestemming heeft gegeven voor de verwerking van zijn persoonsgegevens voor een of meer specifieke doeleinden.',
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Rechtmatigheid van de verwerking – contract',
            description: 'De verwerking is noodzakelijk voor de uitvoering van een overeenkomst waarbij de betrokkene partij is.',
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Rechtmatigheid van de verwerking – wettelijke verplichting',
            description: 'De verwerking is noodzakelijk om te voldoen aan een wettelijke verplichting die op de verwerkingsverantwoordelijke rust.',
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Rechtmatigheid van de verwerking — vitale belangen',
            description: 'De verwerking is noodzakelijk om de vitale belangen van de betrokkene of een andere natuurlijke persoon te beschermen.',
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Rechtmatigheid van de verwerking – algemeen belang',
            description: 'De verwerking is noodzakelijk voor de uitvoering van een taak die wordt uitgevoerd in het algemeen belang of in de uitoefening van openbaar gezag.',
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Rechtmatigheid van de verwerking – legitieme belangen',
            description: 'De verwerking is noodzakelijk voor de legitieme belangen van de verwerkingsverantwoordelijke of een derde partij.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Verwerking van bijzondere categorieën (gevoelige gegevens)',
            description: 'De verwerking van bijzondere categorieën van persoonsgegevens (raciale afkomst, politieke opvattingen, gezondheid, enz.) is verboden, tenzij specifieke voorwaarden in Art. 9(2) is voldaan.',
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Voorwaarden voor toestemming',
            description: 'Verwerkingsverantwoordelijke moet aantonen dat er toestemming is gegeven. Toestemming moet vrijelijk, specifiek, geïnformeerd en ondubbelzinnig worden gegeven. Het intrekken moet net zo eenvoudig zijn als het geven van toestemming.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: 'Toestemming van het kind — digitale diensten',
            description: 'Voor de verwerking van persoonsgegevens van een kind jonger dan 16 jaar (of een door de lidstaat vastgestelde lagere leeftijd, niet jonger dan 13 jaar) is toestemming van de ouders vereist voor diensten van de informatiemaatschappij.',
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Transparante informatie en communicatie',
            description: 'De verwerkingsverantwoordelijke verstrekt informatie met betrekking tot de verwerking in een beknopte, transparante, begrijpelijke en gemakkelijk toegankelijke vorm.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Informatie voor directe verzameling',
            description: 'Wanneer persoonsgegevens van de betrokkene worden verzameld, verstrekt de verwerkingsverantwoordelijke specifieke informatie op het moment van verzameling.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Informatie voor indirecte verzameling',
            description: 'Wanneer er geen persoonsgegevens van de betrokkene zijn verkregen, verstrekt de verwerkingsverantwoordelijke binnen een redelijke termijn gespecificeerde informatie.',
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: 'Recht op toegang',
            description: 'De betrokkene heeft het recht om bevestiging van de verwerking van en toegang tot de persoonsgegevens en aanvullende informatie te verkrijgen.',
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Recht op rectificatie',
            description: 'De betrokkene heeft het recht om zonder onnodige vertraging rectificatie van onjuiste persoonsgegevens te verkrijgen.',
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: 'Recht op verwijdering (recht om vergeten te worden)',
            description: 'De betrokkene heeft het recht om zonder onnodige vertraging de verwijdering van persoonsgegevens te verkrijgen indien specifieke redenen van toepassing zijn.',
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Recht op beperking van de verwerking',
            description: 'De betrokkene heeft het recht om beperking van de verwerking te verkrijgen wanneer specifieke voorwaarden van toepassing zijn.',
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Meldingsplicht — rectificatie/verwijdering/beperking',
            description: 'De verwerkingsverantwoordelijke zal elke rectificatie, verwijdering of beperking meedelen aan elke ontvanger aan wie gegevens zijn bekendgemaakt.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Recht op gegevensportabiliteit',
            description: 'De betrokkene heeft het recht om zijn persoonsgegevens te ontvangen in een gestructureerd, algemeen gebruikt, machinaal leesbaar formaat.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: 'Recht om bezwaar te maken',
            description: 'De betrokkene heeft het recht om bezwaar te maken tegen verwerking op basis van openbaar belang of legitieme belangen, inclusief profilering.',
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Geautomatiseerde individuele besluitvorming, inclusief profilering',
            description: 'De betrokkene heeft het recht om niet te worden onderworpen aan een uitsluitend op geautomatiseerde verwerking gebaseerde beslissing waaraan juridische of soortgelijke significante gevolgen zijn verbonden.',
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: 'Melding van inbreuk aan toezichthoudende autoriteit (72 uur)',
            description: 'In geval van een inbreuk in verband met persoonsgegevens stelt de verwerkingsverantwoordelijke de toezichthoudende autoriteit binnen 72 uur nadat hij hiervan op de hoogte is gesteld, op de hoogte, tenzij het onwaarschijnlijk is dat dit tot een risico zal leiden.',
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Melding van inbreuk aan betrokkenen (hoog risico)',
            description: 'Wanneer een inbreuk waarschijnlijk een hoog risico voor de rechten en vrijheden met zich meebrengt, deelt de verwerkingsverantwoordelijke de inbreuk zonder onnodige vertraging mee aan de betrokkene.',
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Reactie op verzoeken van betrokkenen (30 dagen)',
            description: 'De verwerkingsverantwoordelijke reageert zonder onnodige vertraging op verzoeken van betrokkenen en binnen één maand na ontvangst, verlengbaar met nog eens twee maanden voor complexe verzoeken.',
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: 'Impactbeoordeling van gegevensbescherming',
            description: 'Wanneer de verwerking waarschijnlijk een hoog risico voor de rechten en vrijheden met zich meebrengt, voert de verwerkingsverantwoordelijke voorafgaand aan de verwerking een [[TOK_0]] uit.',
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: 'Voorafgaand overleg met toezichthoudende autoriteit',
            description: 'De verwerkingsverantwoordelijke moet de toezichthoudende autoriteit raadplegen wanneer een [[TOK_0]] aangeeft dat de verwerking zonder risicobeperkende maatregelen tot een hoog risico zou leiden.',
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] verplichte verwerkingslijst',
            description: '[[TOK_0]] is vereist voor systematische evaluatie/profilering, grootschalige verwerking van speciale categorieën en systematische monitoring van openbare ruimtes.',
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Registratie van verwerkingsactiviteiten (verwerkingsverantwoordelijke)',
            description: 'Elke verwerkingsverantwoordelijke houdt een register bij van de verwerkingsactiviteiten die onder zijn verantwoordelijkheid vallen, inclusief doeleinden, categorieën, ontvangers, overdrachten en bewaring.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Registratie van verwerkingsactiviteiten (verwerker)',
            description: 'Elke verwerker houdt een register bij van alle categorieën verwerkingsactiviteiten die namens een verwerkingsverantwoordelijke worden uitgevoerd.',
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Beveiliging van de verwerking',
            description: 'Verwerkingsverantwoordelijke en verwerker implementeren passende technische en organisatorische maatregelen om de veiligheid te waarborgen die is afgestemd op het risico.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Gegevensbescherming door ontwerp en standaard',
            description: 'Verwerkingsverantwoordelijke treft passende maatregelen om ervoor te zorgen dat alleen persoonsgegevens worden verwerkt die noodzakelijk zijn voor elk specifiek doel (gegevensminimalisatie).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Aanwijzing functionaris voor gegevensbescherming',
            description: 'De verwerkingsverantwoordelijke en de verwerker wijzen een [[TOK_0]] aan wanneer de verwerking wordt uitgevoerd door een overheidsinstantie, regelmatige en systematische monitoring inhoudt, of grootschalige verwerking van bijzondere categorieën.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Algemeen principe voor overdrachten',
            description: 'Elke overdracht van persoonsgegevens naar een derde land vindt alleen plaats als aan de voorwaarden van Hoofdstuk V is voldaan.',
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Overdrachten op basis van een adequaatheidsbesluit',
            description: 'Er kan sprake zijn van overdracht wanneer de Commissie heeft besloten dat het derde land een passend beschermingsniveau waarborgt.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Overdrachten onderworpen aan passende waarborgen',
            description: "Bij ontstentenis van een adequaatheidsbesluit kunnen overdrachten plaatsvinden indien passende waarborgen worden geboden, waaronder SCC's of BCR's.",
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Standaardcontractbepalingen',
            description: 'Modelcontractbepalingen die door de Commissie of door een toezichthoudende autoriteit zijn aangenomen, bieden passende waarborgen voor internationale overdrachten.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Bindende bedrijfsregels',
            description: 'Bindende bedrijfsregels die zijn goedgekeurd door een bevoegde toezichthoudende autoriteit bieden passende waarborgen voor internationale overdrachten binnen de groep.',
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Afwijkingen voor specifieke situaties',
            description: 'Bij gebrek aan adequaatheid of waarborgen kunnen overdrachten plaatsvinden op basis van expliciete toestemming, contractnoodzaak, openbaar belang, juridische claims, vitale belangen of openbaar register.',
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Verantwoordelijkheid en opleiding van het bestuursorgaan',
            description: 'Beheersorganen van essentiële en belangrijke entiteiten moeten maatregelen op het gebied van cyberbeveiligingsrisicobeheer goedkeuren en regelmatig training volgen.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Maatregelen voor risicobeheer op het gebied van cyberveiligheid',
            description: 'Essentiële en belangrijke entiteiten nemen passende en evenredige technische, operationele en organisatorische maatregelen om de cyberveiligheidsrisico’s te beheersen.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Beleid en procedures voor incidentafhandeling',
            description: 'Entiteiten moeten beleid ten aanzien van de afhandeling van incidenten implementeren, inclusief detectie-, analyse-, inperkings- en responsprocedures.',
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Bedrijfscontinuïteit en crisismanagement',
            description: 'Entiteiten implementeren maatregelen voor bedrijfscontinuïteit, waaronder back-upbeheer, noodherstel en crisisbeheer.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: 'Beveiliging van de toeleveringsketen',
            description: 'Entiteiten moeten veiligheidsgerelateerde aspecten van relaties met directe leveranciers en dienstverleners aanpakken, inclusief risicobeoordelingen van de toeleveringsketen.',
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: 'Beveiliging in netwerk- en informatiesystemen',
            description: 'Entiteiten implementeren beveiliging bij de aanschaf, ontwikkeling en het onderhoud van netwerk- en informatiesystemen, inclusief het omgaan met kwetsbaarheden.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Behandeling en openbaarmaking van kwetsbaarheden',
            description: 'Entiteiten implementeren beleid en procedures voor de gecoördineerde openbaarmaking en afhandeling van kwetsbaarheden.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Effectiviteit van cyberbeveiligingsrisicobeoordeling',
            description: 'Entiteiten implementeren beleid en procedures om de effectiviteit van maatregelen voor cyberbeveiligingsrisicobeheer te beoordelen.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Cryptografie- en encryptiebeleid',
            description: 'Entiteiten implementeren beleid en procedures met betrekking tot het gebruik van cryptografie en, indien van toepassing, encryptie.',
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: 'HR-beveiliging, toegangscontrole, asset management',
            description: 'Entiteiten moeten personeelsbeveiliging, toegangscontrolebeleid en activabeheer implementeren.',
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Authenticatie met meerdere factoren',
            description: 'Entiteiten maken gebruik van oplossingen voor meervoudige authenticatie of continue authenticatie, beveiligde spraak-/video-/tekstcommunicatie en beveiligde noodcommunicatiesystemen.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Vroegtijdige waarschuwing voor CSIRT (24 uur)',
            description: 'Entiteiten moeten binnen 24 uur nadat zij zich bewust zijn geworden van een significant incident een vroegtijdige waarschuwing indienen bij het bevoegde CSIRT.',
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: 'Melding van incidenten aan CSIRT (72 uur)',
            description: 'Entiteiten dienen binnen 72 uur nadat zij kennis hebben gekregen van een significant incident een incidentmelding in bij het bevoegde CSIRT.',
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Eindrapport aan het CSIRT (1 maand)',
            description: 'Entiteiten dienen uiterlijk één maand na de melding van het incident een eindrapport in bij het bevoegde CSIRT.',
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: 'Toepasselijkheidsbepaling voor [[TOK_0]] activiteiten',
            description: 'Bepaal of de organisatie [[TOK_0]] activiteiten uitvoert die vallen onder de Vietnamese [[TOK_1]] wet en documenteer de toepasselijkheidsbeslissing.',
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: "[[TOK_0]] classificatie van systeemrisico's op risiconiveau",
            description: 'Classificeer elk [[TOK_0]]-systeem op risiconiveau (minimaal, beperkt, hoog, onaanvaardbaar) met behulp van de begeleide classificatiemethodologie.',
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Onderhoud van systeemregisterinvoer',
            description: 'Houd een register bij van [[TOK_0]] systemen met systeemnaam, eigenaar, doel, implementatiecontext, risiconiveau en betrokkenheid van de leverancier.',
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Systeemdossier met artefactchecklist en bewijsmateriaal',
            description: 'Bouw en onderhoud een systeemdossier met de vereiste artefactchecklist, bewijsbibliotheek en versiegeschiedenis.',
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: 'Transparantieverplichtingen voor [[TOK_0]] systeembeheerders',
            description: 'Implementeer transparantiemaatregelen voor [[TOK_0]]-systemen, waaronder gebruikersmeldingen, openbaarmaking van de betrokkenheid van [[TOK_1]] en systeemdocumentatie.',
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: '[[TOK_0]] uitvoerlabels, watermerken en ondertekening van metagegevens',
            description: 'Implementeer labeling en watermerken voor door [TOK_0]] gegenereerde inhoud, inclusief ondertekening van metagegevens, indien van toepassing.',
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: 'Openbaarmakingsvereisten voor door [[TOK_0]] gegenereerde inhoud',
            description: 'Laat gebruikers weten wanneer inhoud [[TOK_0]] is gegenereerd en zorg voor mechanismen waarmee gebruikers de betrokkenheid van [[TOK_1]] kunnen identificeren.',
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Uitlegbaarheid en gebruikersgerichte transparantieverplichtingen',
            description: 'Zorg voor verklaarbare resultaten voor [[TOK_0]]-besluiten die gevolgen hebben voor individuen en onderhoud gebruikersgerichte transparantiedocumentatie.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Verplichtingen voor menselijk toezicht op risicovolle [[TOK_0]]-systemen',
            description: 'Zorg ervoor dat er mechanismen voor menselijk toezicht aanwezig zijn voor risicovolle [[TOK_0]]-systemen, inclusief escalatie- en override-mogelijkheden.',
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] monitoring en detectie van incidenten',
            description: 'Implementeer monitoringmogelijkheden om [[TOK_0]] systeemincidenten, storingen en nadelige gevolgen te detecteren.',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: 'Ernstig [[TOK_0]] incident gemeld aan de autoriteit',
            description: 'Meld ernstige [[TOK_0]] incidenten binnen de voorgeschreven termijn (72 uur) aan de bevoegde autoriteit.',
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: '[[TOK_0]] naleving van de tijdlijn voor incidentmeldingen',
            description: 'Houd u aan de meldingstijdlijnen voor [[TOK_0]]-incidenten, inclusief initiële meldingen, updates en afsluitingsrapporten.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: '[[TOK_0]] effectbeoordeling voor systemen met een hoog risico',
            description: "Voer effectbeoordelingen uit voor risicovolle [[TOK_0]]-systemen met betrekking tot risico's, mitigaties, menselijk toezicht en monitoringplannen.",
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Gecontroleerd testen / bepaling van geschiktheid voor de sandbox',
            description: 'Bepaal of u in aanmerking komt voor deelname aan gecontroleerde tests (sandbox) en documenteer de geschiktheidsbeoordeling.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Indiening van sandbox-applicaties en volgen van goedkeuring',
            description: 'Dien sandbox-aanvragen in bij de bevoegde autoriteit en volg de goedkeuringsstatus gedurende de gehele indieningscyclus.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Controlepunten voor sandboxbewaking en voltooiing/afsluiting',
            description: 'Voer periodieke monitoringcontrolepunten uit tijdens sandbox-deelname en bereid voltooiings-/afsluitrapporten voor.',
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Etikettering van vrijstelling/uitzonderingsdocumentatie met onderbouwing',
            description: 'Documenteer eventuele vrijstellingen of uitzonderingen op het gebied van etikettering met onderbouwing en ondersteunend bewijsmateriaal.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Gegevenslokalisatie voor Vietnamese gebruikers',
            description: 'Gegevens van Vietnamese gebruikers over diensten die in Vietnam worden geleverd, moeten op het grondgebied van Vietnam worden opgeslagen.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: 'Rapportage van cyberveiligheidsincidenten',
            description: 'Cybersecurity-incidenten moeten tijdig aan de bevoegde autoriteiten worden gemeld.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: 'Classificatie van informatiesystemen',
            description: 'Informatiesystemen moeten worden geclassificeerd naar belangrijkheidsniveau en er moeten passende beveiligingsmaatregelen worden toegepast.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Risicobeoordeling op het gebied van cyberbeveiliging',
            description: 'Er moeten regelmatig cyberveiligheidsrisicobeoordelingen worden uitgevoerd voor informatiesystemen.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: 'In-scope bepaling (beslisboom)',
            description: 'Organisaties moeten aan de hand van de voorgeschreven beslisboom bepalen of zij onder de reikwijdte van Besluit 53 vallen.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Beoordeling en gereedheid van gegevenslokalisatie',
            description: 'Organisaties moeten de vereisten voor datalokalisatie beoordelen en gereedheid tonen.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Controlelijst voor gereedheid voor opslag en bewaring',
            description: 'Er moet een checklist voor de gereedheid voor opslag en retentie worden ingevuld om te voldoen aan de eisen voor gegevenslokalisatie.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Beoordeling van lokale aanwezigheidsvereisten',
            description: 'Organisaties moeten beoordelen of lokale aanwezigheidsvereisten van toepassing zijn en dienovereenkomstig plannen maken.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Autoriteit verzoek om ontvangst en verificatie',
            description: 'Autoriteitsverzoeken moeten worden ontvangen, geverifieerd en verwerkt volgens voorgeschreven procedures.',
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Autoriteit vraagt om reactie binnen de deadline',
            description: 'Antwoorden op verzoeken van autoriteiten moeten binnen de voorgeschreven termijn worden verstrekt.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: 'Logboek voor afhandeling van autoriteitsverzoeken',
            description: 'Er moet een logboek worden bijgehouden van alle activiteiten voor het afhandelen van autoriteitsverzoeken.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Toepasbaarheid en bepaling binnen de reikwijdte (geconsolideerd)',
            description: 'Organisaties moeten bepalen of ze binnen het toepassingsgebied vallen onder de geconsolideerde cyberbeveiligingswet, die zowel het oude toepassingsgebied van Wet 24/2018 als Decreet 53/2022 bestrijkt.',
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: 'Classificatie van informatiesystemen op belangrijkheidsniveau',
            description: 'Informatiesystemen moeten worden geclassificeerd op belangrijkheidsniveau (algemeen, belangrijk, kritisch) met bijbehorende beveiligingsverplichtingen.',
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Bestuursstructuur voor cyberbeveiliging en verantwoordelijk personeel',
            description: 'Organisaties moeten bestuursstructuren voor cyberbeveiliging opzetten en verantwoordelijk personeel aanwijzen.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Periodieke cyberveiligheidsrisicobeoordeling',
            description: 'Voor alle geheime informatiesystemen moeten regelmatig cyberveiligheidsrisicobeoordelingen worden uitgevoerd.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: 'Beveiligingsmaatregelen per informatiesysteemclassificatie',
            description: 'Er moeten technische beveiligingsmaatregelen worden toegepast die geschikt zijn voor elk classificatieniveau van een informatiesysteem.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: 'Toegangscontrole en identiteitsbeheer',
            description: 'Voor informatiesystemen moeten maatregelen voor toegangscontrole en identiteitsbeheer worden geïmplementeerd.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: 'Registratie, monitoring en audittrail',
            description: 'Informatiesystemen moeten de mogelijkheden voor logboekregistratie, monitoring en audittrails behouden.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Kwetsbaarheidsbeheer en patching',
            description: 'Kwetsbaarheidsbeheer en patchingprocessen moeten worden opgezet en onderhouden.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Gegevenslokalisatie voor Vietnamese gebruikersgegevens',
            description: 'Gegevens van Vietnamese gebruikers over diensten die in Vietnam worden geleverd, moeten op het grondgebied van Vietnam worden opgeslagen.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Lokale aanwezigheidsvereisten voor buitenlandse dienstverleners',
            description: 'Buitenlandse dienstverleners die in Vietnam actief zijn, moeten zoals voorgeschreven lokaal aanwezig zijn.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Lokale opslagarchitectuur en grensoverschrijdende stroomdocumentatie',
            description: 'De lokale opslagarchitectuur moet worden gedocumenteerd en grensoverschrijdende datastromen moeten in kaart worden gebracht en gecontroleerd.',
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Detectie en respons op cyberbeveiligingsincidenten',
            description: 'Organisaties moeten over de mogelijkheden beschikken om cyberveiligheidsincidenten te detecteren en erop te reageren.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: 'Verplichte melding van incidenten aan de bevoegde autoriteit',
            description: 'In aanmerking komende cyberbeveiligingsincidenten moeten binnen de voorgeschreven termijnen worden gerapporteerd aan [[TOK_1]]/[[TOK_0]].',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Naleving van de tijdlijn voor incidentmeldingen',
            description: 'Incidentmeldingen moeten voldoen aan de voorgeschreven tijdlijnvereisten (eerste melding binnen 24 uur, volledige melding binnen 72 uur).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Behandeling en samenwerking van autoriteitsverzoeken',
            description: 'Autoriteitsverzoeken moeten snel worden afgehandeld en er moet medewerking worden verleend volgens voorgeschreven procedures.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: 'Autoriteitsverzoekzaakregister en openbaarmakingslogboek',
            description: 'Alle autoriteitsverzoeken en openbaarmakingen moeten worden vastgelegd in een casusregister met volledig audittraject.',
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Beveiligingsbeoordeling van leveranciers en derden',
            description: 'Externe leveranciers met toegang tot informatiesystemen moeten een beveiligingsbeoordeling ondergaan.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Controles op toegang tot leveranciersgegevens en melding van incidenten',
            description: 'De toegang tot leveranciersgegevens moet worden gedocumenteerd en contractuele verplichtingen voor het melden van incidenten moeten worden vastgelegd.',
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Beveiligingsbewustzijnstrainingen en -oefeningen',
            description: 'Er moeten regelmatig cybersecurity-bewustzijnstrainingen en tabletop-oefeningen worden gehouden.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: 'Periodieke pentest en beveiligingsaudit',
            description: 'Er moeten periodieke penetratietests en beveiligingsaudits worden uitgevoerd op geheime informatiesystemen.',
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: 'Onderhouden van digitale data-inventaris',
            description: 'Organisaties moeten een uitgebreide digitale data-inventaris bijhouden waarin alle data-assets worden gecatalogiseerd.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Gegevensclassificatie op basis van gevoeligheid en belang',
            description: 'Gegevens moeten worden geclassificeerd op basis van gevoeligheids- en belangrijkheidsniveaus zoals gedefinieerd in de Gegevenswet.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Definieer verwerkingsregels per classificatieniveau',
            description: 'Voor elk gegevensclassificatieniveau moeten verwerkingsregels worden vastgesteld.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Volg het delen en openbaar maken van gegevens met goedkeuringen',
            description: 'Alle activiteiten voor het delen en openbaar maken van gegevens moeten worden gevolgd met de juiste goedkeuringen.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Beheer van grensoverschrijdende gegevensoverdracht',
            description: 'Grensoverschrijdende gegevensoverdrachten moeten voldoen aan de governancevereisten op grond van de Gegevenswet.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Handhaaf het governancebeleid en de verantwoordelijkheden',
            description: 'Organisaties moeten een data governance-beleid handhaven en governanceverantwoordelijkheden toewijzen.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: 'Jaarlijks bestuursattest',
            description: 'Er moet jaarlijks een bestuursattest worden ingevuld om de voortdurende naleving te bevestigen.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Gegevensrisicobeoordeling',
            description: "Er moet een datarisicobeoordeling worden uitgevoerd om de risico's op het gebied van databeheer te identificeren en te beperken.",
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Verantwoordelijkheid van platformexploitanten en governanceverplichtingen',
            description: 'Zet verantwoordingsstructuren voor platformexploitanten op, inclusief governancebeleid, monitoringverantwoordelijkheden en handhavingsverplichtingen.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Platformregels publicatie en transparantie van informatie',
            description: 'Publiceer platformregels, handelsvoorwaarden en operationele openbaarmakingen op een transparante en toegankelijke manier.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'Melding van website/app voor e-commerceverkoop aan MOIT',
            description: 'Melding indienen bij MOIT voor e-commerce verkoopwebsites en -applicaties via Online.gov.vn of aangewezen kanalen.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'E-commerce serviceplatform/marktplaatsregistratie bij MOIT',
            description: 'Registreer e-commerce serviceplatforms en marktplaatsen bij MOIT, inclusief het indienen van dossiers en het volgen van goedkeuringen.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Onderhoud verkopersregister (binnen- en buitenland)',
            description: 'Houd een register bij van alle verkopers op het platform, inclusief binnenlandse en buitenlandse verkopers, met onboarding, verificatie en tracking van de levenscyclus.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Livestream-verkopersregister en nalevingscontroles',
            description: 'Houd een register bij van livestreamverkopers met identiteitsverificatie, het volgen van activiteiten en nalevingscontroles.',
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Affiliate- en marketingpartnerregister',
            description: 'Houd een register bij van aangesloten marketeers en verwijzingspartners met de contractstatus, inhoudsrichtlijnen en nalevingsbevestigingen.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Productvermelding en handhaving van verboden/voorwaardelijke goederen',
            description: 'Implementeer controles op productvermeldingen, inclusief screening, monitoring en handhavingsacties van verboden en voorwaardelijke goederen.',
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: 'Consumentenklachten registreren met intake, acties en audittrail',
            description: 'Houd een klachtenregister bij met intakegegevens, onderzoeksacties, oplossingsresultaten en een volledig audittraject.',
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Klachtenbehandelingsprocedure en oplossingstermijnen',
            description: 'Stel klachtenbehandelingsprocedures op met gedefinieerde tijdlijnen voor erkenning, onderzoek en oplossing.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Contentmoderatie, monitoring en verwijderingshandhaving',
            description: 'Implementeer procedures voor inhoudsmoderatie, monitoring en verwijdering van illegale, verboden of in strijd zijnde inhoud.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: 'Verwijderings- en handhavingsacties worden geregistreerd met behoud van bewijsmateriaal',
            description: 'Houd een register bij van verwijderings- en handhavingsacties met beslissingsregistraties, bewaring van bewijsmateriaal en verkopersmeldingen.',
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Platformbeleid en openbaarmakingsregister (versies, publicatiedata, acceptatie)',
            description: 'Houd een register bij van platformbeleid en openbaarmakingen met versiegeschiedenis, publicatiedata en acceptatiebewijs.',
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: 'Consumenteninformatieplichten - nauwkeurige productinformatie en anti-misleiding',
            description: 'Zorg voor nauwkeurige, duidelijke product- en service-informatie en implementeer maatregelen om misleidende praktijken op het platform te voorkomen.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Bedrijfsvoorwaarden en registratie/melding van buitenlandse platformen',
            description: 'Voldoe aan de bedrijfsvoorwaarden voor buitenlandse platforms die Vietnamese gebruikers bedienen, inclusief registratie- of meldingsvereisten.',
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Lokale vertegenwoordiging of autorisatie voor buitenlandse platforms',
            description: 'Wijs een lokale vertegenwoordiger of geautoriseerde entiteit in Vietnam aan voor buitenlandse platforms, zoals vereist door de wet.',
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Grensoverschrijdende coördinatie van verkoper- en klachtenafhandeling',
            description: 'Coördineren van de grensoverschrijdende afhandeling van verkopers en het oplossen van klachten, inclusief escalatie en bewijsbeheer.',
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Staat voor interactie met e-commercebeheersystemen en rapportagegereedheid',
            description: 'Bereid je voor op interactie met het e-commercebeheersysteem van de staat, inclusief het in kaart brengen van gegevensvelden en rapportagemogelijkheden.',
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Kennisgeving van materiële wijzigingen na goedkeuring',
            description: 'Meldingen indienen voor materiële wijzigingen in platformdetails, beleid of activiteiten na initiële goedkeuring.',
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Beëindigings- en deactiveringsmelding',
            description: 'Meldingen van beëindiging of deactivering indienen bij het stopzetten van e-commerceactiviteiten, inclusief openbare kennisgeving en afhandeling van consumentenbescherming.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Geschiktheid en onderhoud van het Trustmark- en geloofwaardigheidsbeoordelingsprogramma',
            description: "Beoordeel of u in aanmerking komt voor trustmark- en geloofwaardigheidsbeoordelingsprogramma's en bewaar nalevingsbewijs voor voortdurende deelname.",
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Toestemming voor verwerking van persoonsgegevens',
            description: 'Voor de verwerking van persoonsgegevens is toestemming van de betrokkene vereist, tenzij er een uitzondering van toepassing is.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Toestemming voor verwerking van gevoelige gegevens',
            description: 'Voor de verwerking van gevoelige persoonsgegevens is uitdrukkelijke toestemming met afzonderlijke, duidelijke kennisgeving aan de betrokkene vereist.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: 'Recht op toegang',
            description: 'Betrokkenen hebben recht op toegang tot hun persoonsgegevens die in het bezit zijn van de verantwoordelijke voor de verwerking.',
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Recht op rectificatie',
            description: 'Betrokkenen hebben het recht om rectificatie van onjuiste persoonsgegevens te verzoeken.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: 'Recht op verwijdering',
            description: 'Betrokkenen hebben het recht om verwijdering van hun persoonsgegevens te verzoeken.',
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Recht om de verwerking te beperken',
            description: 'Betrokkenen hebben het recht om beperking van de verwerking van hun persoonsgegevens te verzoeken.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: 'Recht om bezwaar te maken',
            description: 'Betrokkenen hebben het recht om bezwaar te maken tegen de verwerking van hun persoonsgegevens.',
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Recht om toestemming in te trekken',
            description: 'Betrokkenen hebben het recht om eerder gegeven toestemming op elk moment in te trekken.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: 'Melding van inbreuk aan autoriteit (72 uur)',
            description: 'De verwerkingsverantwoordelijke moet het ministerie van Openbare Veiligheid binnen 72 uur na ontdekking van een inbreuk in verband met persoonsgegevens op de hoogte stellen.',
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Melding van inbreuk aan betrokkenen',
            description: 'De verwerkingsverantwoordelijke moet de getroffen betrokkenen zonder onnodige vertraging op de hoogte stellen van een inbreuk in verband met persoonsgegevens.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] voor verwerking met een hoog risico',
            description: 'Er moet een gegevensbeschermingseffectbeoordeling worden uitgevoerd voor verwerkingsactiviteiten die waarschijnlijk een hoog risico met zich meebrengen.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Beoordeling grensoverschrijdende overdracht',
            description: 'Er moet een effectbeoordeling worden uitgevoerd voordat persoonlijke gegevens buiten Vietnam worden overgedragen.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Registratie van verwerkingsactiviteiten',
            description: 'Gegevensbeheerders moeten een Register van Verwerkingsactiviteiten (RoPA) bijhouden waarin alle verwerkingsactiviteiten worden gedocumenteerd.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Registratie van gegevensverwerkingsovereenkomsten',
            description: 'Er moeten registers worden bijgehouden van gegevensverwerkingsovereenkomsten met verwerkers en subverwerkers.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Waarborgen voor grensoverschrijdende overdrachten',
            description: 'Voor de overdracht van persoonsgegevens buiten Vietnam zijn passende waarborgen en gedocumenteerde beoordelingen vereist.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Bevestiging binnen 2 werkdagen',
            description: 'Verzoeken van betrokkenen moeten binnen 2 werkdagen na ontvangst worden bevestigd.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Oplevering binnen 15 werkdagen',
            description: 'Verzoeken van betrokkenen moeten binnen 15 werkdagen worden afgehandeld, met een mogelijke verlenging van 5 werkdagen.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'MoPS-impactbeoordelingsdossier indienen',
            description: 'Organisaties die risicovolle verwerkingen uitvoeren, moeten een effectbeoordelingsdossier indienen bij het Ministerie van Openbare Veiligheid volgens de voorgeschreven administratieve procedure.',
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'Indiening van MoPS-dossiers voor grensoverschrijdende overdracht',
            description: 'Organisaties die persoonsgegevens buiten Vietnam overdragen, moeten een dossier voor de effectbeoordeling van grensoverschrijdende overdrachten indienen bij het ministerie van Openbare Veiligheid.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Certificering van verwerkingsdienstverlener',
            description: 'Organisaties die de verwerking van persoonsgegevens als dienst aanbieden, moeten een certificaat voor de verwerking van diensten verkrijgen van het Ministerie van Openbare Veiligheid.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: 'Verwerking van het impactbeoordelingsdossier wanneer de triggers zijn bereikt',
            description: 'Er moet een verwerkingseffectbeoordelingsdossier worden ingediend wanneer aan de voorgeschreven triggers wordt voldaan.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Impactdossier grensoverschrijdende overdracht',
            description: 'Voor internationale gegevensoverdrachten moet een impactdossier voor grensoverschrijdende overdrachten worden opgesteld en ingediend.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Aanwijzing functionaris voor gegevensbescherming',
            description: 'Er moet een functionaris voor gegevensbescherming worden aangewezen zoals vereist door Decreet 13.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Governance-artefacten (beleid, rollen, procedures)',
            description: 'Governance-artefacten, waaronder beleid, rollen en procedures, moeten worden gehandhaafd.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Volledigheid van het bewijspakket en een onveranderlijk audittraject',
            description: 'Bewijspakketten moeten compleet zijn en er moet een onveranderlijk audittraject worden bijgehouden.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Ondersteuning van de workflow voor het indienen van dossiers',
            description: 'Workflows voor het indienen van zaken moeten worden ondersteund voor effectbeoordelingen en grensoverschrijdende dossiers.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Contractuele vereisten van verwerker',
            description: 'Er moeten contractuele vereisten voor gegevensverwerkers worden vastgesteld en gecontroleerd.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: 'Jaarlijkse nalevingsbeoordeling',
            description: 'Er moet jaarlijks een nalevingsbeoordeling worden uitgevoerd om de voortdurende naleving te verifiëren.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Autoriteit die indieningsgegevens indient',
            description: 'Er moeten gegevens worden bijgehouden van alle indieningen bij de autoriteit.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Wettelijke grondslagen voor de verwerking van persoonsgegevens',
            description: 'De verwerking van persoonsgegevens moet gebaseerd zijn op wettelijke grondslagen zoals gedefinieerd door de [[TOK_0]].',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Toestemmingsvereisten voor gevoelige gegevens',
            description: 'Voor de verwerking van gevoelige persoonsgegevens is uitdrukkelijke toestemming met specifieke vereisten vereist.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Rechten van betrokkenen (toegang, rectificatie, verwijdering, beperking, bezwaar, portabiliteit)',
            description: 'Betrokkenen hebben uitgebreide rechten, waaronder toegang, rectificatie, verwijdering, beperking, bezwaar en portabiliteit.',
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: 'Melding van inbreuk aan de autoriteit',
            description: 'Gegevensbeheerders moeten de bevoegde autoriteit binnen de voorgeschreven termijn op de hoogte stellen van inbreuken op persoonsgegevens.',
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Melding van inbreuk aan betrokkenen',
            description: 'Gegevensbeheerders moeten de getroffen betrokkenen op de hoogte stellen van inbreuken op persoonsgegevens.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: 'Impactbeoordeling van gegevensbescherming',
            description: 'Voor verwerkingsactiviteiten met een hoog risico moet een gegevensbeschermingseffectbeoordeling worden uitgevoerd.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Grensoverschrijdende overdrachtsgovernance',
            description: 'Grensoverschrijdende overdrachten van persoonsgegevens moeten voldoen aan de governancevereisten.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Aanwijzing functionaris voor gegevensbescherming',
            description: 'Organisaties moeten indien nodig een functionaris voor gegevensbescherming aanwijzen.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Registratie van verwerkingsactiviteiten',
            description: 'Organisaties moeten een register bijhouden van alle verwerkingsactiviteiten.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Contractuele verplichtingen van verwerker',
            description: 'Er moeten contractuele verplichtingen worden vastgelegd met gegevensverwerkers.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Indiening van effectbeoordelingsdossiers',
            description: 'Effectbeoordelingsdossiers moeten zoals voorgeschreven bij de bevoegde autoriteit worden ingediend.',
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Impactdossier grensoverschrijdende overdracht',
            description: 'Voor internationale gegevensoverdrachten moet een impactdossier voor grensoverschrijdende overdrachten worden opgesteld en ingediend.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] afspraak en melding',
            description: 'Er moet een functionaris voor gegevensbescherming worden aangesteld en de autoriteit moet op de hoogte worden gesteld.',
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Bestuursbeleid en -procedures',
            description: 'Het beleid en de procedures op het gebied van governance moeten worden vastgesteld en onderhouden.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Bewijspakket en onveranderlijk audittraject',
            description: 'Bewijspakketten moeten compleet zijn en er moet een onveranderlijk audittraject worden bijgehouden.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Levenscyclus van dossierdossiers',
            description: 'De levenscycli van dossiers moeten worden beheerd via voorgeschreven fasen.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Contractuele vereisten van verwerker',
            description: 'Er moeten contractuele vereisten voor gegevensverwerkers worden vastgesteld en gecontroleerd.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Certificering van dienstverlener voor verwerking',
            description: 'Organisaties die gegevensverwerkingsdiensten leveren, moeten een certificering verkrijgen.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Autoriteit die indieningsgegevens indient',
            description: 'Er moeten gegevens worden bijgehouden van alle indieningen bij de autoriteit.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: 'Jaarlijkse nalevingsbeoordeling',
            description: 'Er moet jaarlijks een nalevingsbeoordeling worden uitgevoerd om de voortdurende naleving te verifiëren.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Technische maatregelen voor gegevensbeveiliging',
            description: 'Technische maatregelen voor gegevensbeveiliging moeten worden geïmplementeerd en onderhouden.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Decreet 356 officiële Mẫu số-formuliervereisten',
            description: 'De 13 officiële Mẫu số administratieve procedureformulieren (Mẫu số 01a–10), voorgeschreven door Decreet [[TOK_0]]Đ-CP, moeten worden gebruikt voor de overeenkomstige aangiften bij het Ministerie van Openbare Veiligheid. De Phụ lục I-VIII-items zijn interne gegevensstructuurtoewijzingen, geen officiële regelgevingsformulieren.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] dossierindiening bij A05',
            description: 'Organisaties moeten [[TOK_0]] dossiers indienen bij A05/[[TOK_1]] voor verwerkingsactiviteiten waarbij gevoelige persoonsgegevens betrokken zijn of grootschalige verwerking.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Indiening van dossiers voor grensoverschrijdende overdracht',
            description: 'Organisaties moeten dossiers voor grensoverschrijdende gegevensoverdracht indienen ter beoordeling en goedkeuring volgens A05/[[TOK_0]].',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Verwerken servicecertificaataanvraag',
            description: 'Aanbieders van gegevensverwerkingsdiensten moeten certificaten aanvragen bij A05/[[TOK_0]].',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Melding verwerking persoonsgegevens',
            description: 'Verwerkingsverantwoordelijken moeten A05/[[TOK_0]] op de hoogte stellen van de verwerkingsactiviteiten van persoonsgegevens door middel van voorgeschreven formulieren (Mẫu số 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: 'Jaarlijkse situatierapportage',
            description: 'Verwerkingsverantwoordelijken moeten jaarlijkse situatierapporten over de verwerking van persoonsgegevens indienen (Mẫu số 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Standaard vertrouwelijkheid van gebruikersinformatie',
            description: 'Gebruikersinformatie moet standaard als vertrouwelijk worden behandeld.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Minimale organisatorische en technische beveiligingsmaatregelen',
            description: 'Er moeten minimale organisatorische en technische beveiligingsmaatregelen worden geïmplementeerd.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Alleen bekendmaking op juiste basis',
            description: 'Openbaarmaking van gebruikersinformatie is alleen toegestaan als er een goede wettelijke basis is.',
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Verplichte openbaarmaking en controleerbaarheid',
            description: 'Alle openbaarmakingen moeten worden geregistreerd en controleerbaar zijn.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: 'Interne goedkeuringsworkflow voor openbaarmakingen',
            description: 'Voor alle openbaarmakingen moet een interne goedkeuringsworkflow worden opgezet.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Afhandeling van respons op autoriteitsverzoeken',
            description: 'Autoriteitsverzoeken moeten worden behandeld en beantwoord volgens voorgeschreven procedures.',
        },
    },
    framework_rights_descriptions: {
        be_informed: 'De betrokkene heeft het recht om geïnformeerd te worden over de verwerking van persoonsgegevens.',
        consent: 'De betrokkene heeft het recht om toestemming te geven voor de verwerking van zijn persoonsgegevens.',
        refuse_consent: 'De betrokkene heeft het recht om geen toestemming te geven voor de verwerking van zijn persoonsgegevens.',
        withdraw_consent: 'De betrokkene heeft het recht om de intrekking van eerder gegeven toestemming te verzoeken.',
        access: 'De betrokkene heeft recht op inzage en toegang tot de persoonsgegevens die de verwerkingsverantwoordelijke bewaart.',
        rectification: 'De betrokkene heeft het recht om onjuiste persoonsgegevens te corrigeren of te vragen.',
        data_provision: 'De betrokkene heeft het recht om te verzoeken dat zijn persoonsgegevens worden verstrekt (yêu cầu cung cấp dữ liệu cá nhân).',
        deletion: 'De betrokkene heeft het recht om verwijdering of vernietiging van persoonlijke gegevens te verzoeken, behoudens uitzonderingen in de wet.',
        restriction_of_processing: 'De betrokkene heeft het recht om beperking van de verwerking van zijn persoonsgegevens te verzoeken.',
        object_to_processing: 'De betrokkene heeft het recht om een verzoek te sturen waarin hij bezwaar maakt tegen de verwerking van zijn persoonsgegevens.',
        complaint: 'De betrokkene heeft het recht om een klacht (khiếu nại) in te dienen over de verwerking van persoonsgegevens.',
        denunciation: 'De betrokkene heeft het recht om aangifte te doen (tố cáo) met betrekking tot schendingen van de bescherming van persoonsgegevens.',
        lawsuit: 'De betrokkene heeft het recht om juridische stappen (khởi kiện) te ondernemen wegens schending van zijn gegevensbeschermingsrechten.',
        claim_damages: 'De betrokkene heeft het recht om schadevergoeding te eisen voor schade veroorzaakt door schendingen van de bescherming van persoonsgegevens.',
        request_protection_measures: 'De betrokkene heeft het recht om bevoegde autoriteiten of relevante organisaties/individuen te verzoeken maatregelen te nemen om hun persoonsgegevens te beschermen.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Risicobeheer en -monitoring (ontwerp)',
            steps: {
                '1': 'Identificeer risicocategorieën',
                '2': 'Zorg voor controles op het gebied van vroegtijdige waarschuwing',
                '3': "Beoordeel de risico's voor verzamelen, opslaan, verwerken, delen en transacties",
                '4': "Leg de risico's op het gebied van privacy, cyberbeveiliging en toegangsbeheer vast",
                '5': 'Activeer herstelacties',
                '6': 'Behoud de recensiegeschiedenis',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Klachten en geschillen (concept)',
            steps: {
                '1': 'Ontvang klachten-/geschilintake',
                '2': 'Controleer de volledigheid van de vereiste informatie; bij onvolledigheid binnen 24 uur een aanvulling aanvragen',
                '3': 'Breng de partijen binnen drie werkdagen na ontvangst van een volledig verzoek op de hoogte van de aanpak en de verwachte tijdlijn',
                '4': 'Vraag om antwoorden en ondersteunende documenten',
                '5': 'Beoordeel betwistingsfeiten en platformverantwoordelijkheid',
                '6': 'Resultaat van de recordresolutie',
                '7': 'Bewaar bewijsmateriaal en sluit de zaak',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Levering en certificaat van eigendomsrechten op gegevens (concept)',
            steps: {
                '1': 'Product/dienst leveren volgens contractmethode',
                '2': 'Registreer de bezorggebeurtenis en -tijd',
                '3': 'Genereer een certificaat van eigendomsrechten op gegevens',
                '4': 'Registreer de voltooiing van de transactie',
                '5': 'Schakel later opzoeken/verificatie in waar nodig',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Transactie-initiatie en contractering (concept)',
            steps: {
                '1': 'Bekijk de vermelding en het evaluatieresultaat',
                '2': 'Start een workflow voor aankoop, onderhandeling of veiling',
                '3': 'Genereer elektronisch contract',
                '4': 'Verzeker de acceptatie van beide partijen',
                '5': 'Registreer de voltooiing van de betaling',
                '6': 'Levering autoriseren',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Toegang tot sandbox/testomgeving (concept)',
            steps: {
                '1': 'Sandbox-verzoek indienen',
                '2': 'Definieer het bereik, de toegestane gegevens, de tijdsperiode en de verwerkingsrechten',
                '3': 'Voorzien van geïsoleerde technische omgeving',
                '4': 'Bewaak de beveiliging en toegang tijdens het testen',
                '5': 'Controleer de uitvoer vóór extractie',
                '6': 'Laat extractie alleen goedkeuren als dit is toegestaan',
                '7': 'Sluit de testsessie af en ruim de omgeving op',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Gegevensproduct-/dienstlijst (concept)',
            steps: {
                '1': 'Maak een vermeldingstoepassing',
                '2': 'Leg bron- en eigendoms-/gebruiksrechtbewijs vast',
                '3': 'Leg technische kenmerken, formaat, [[TOK_0]] details en beperkingen vast',
                '4': 'Documenteer kwaliteitsinformatie',
                '5': 'Dien het vermeldingsdossier in voor platformbeoordeling',
                '6': 'Platform voert volledigheids-, wettigheids- en technische controles uit',
                '7': 'Lijst goedkeuren of afwijzen',
                '8': 'Indien goedgekeurd, publiceert u de vermelding met het bijgevoegde evaluatieresultaat',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Onboarding van deelnemers (concept)',
            steps: {
                '1': 'Bepaal het type deelnemer: verkoper of koper',
                '2': 'Controleer de juridische status en handelingsbekwaamheid',
                '3': 'Controleer aanvullende voorwaarden als er voorwaardelijke bedrijfslijnen van toepassing zijn',
                '4': 'Transactieaccount registreren',
                '5': 'Betaalrekening koppelen',
                '6': 'Platformdeelname goedkeuren',
                '7': 'Bewaar deelnemersrecord en audittrail',
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Systeemregistratie/melding',
            steps: {
                '1': 'Toepasbaarheidscontrole en [[TOK_0]] systeemclassificatie',
                '2': 'Registratie-/meldingsdossier opbouwen',
                '3': 'Interne goedkeuring',
                '4': 'Inzenden via kanaal',
                '5': 'Amendementlus — indien geretourneerd, bijwerken en opnieuw indienen',
                '6': 'Bevestiging sluiten en opslaan',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Workflow voor risicoclassificatie',
            steps: {
                '1': 'Maak een [[TOK_0]] Systeemregisterinvoer',
                '2': 'Voer de classificatiewizard uit',
                '3': 'Bewijsmateriaal bijvoegen',
                '4': 'Classificatie goedkeuren',
                '5': 'Koppel uitgangen aan systeemdossier',
            },
        },
        AI_A3: {
            name: 'Naleving van etikettering en openbaarmaking',
            steps: {
                '1': 'Identificeer etiketteringsverplichtingen per systeem en gebruiksscenario',
                '2': 'Implementeer etiketteringsaankondigingen',
                '3': 'Leg bewijs vast: screenshots, UI-kopie, technische metadata',
                '4': 'Behandel vrijstellingen en leg de rechtvaardiging vast',
                '5': 'Goedkeuren en versie',
            },
        },
        AI_A4: {
            name: 'Rapportage van ernstige incidenten',
            steps: {
                '1': 'Maak een [[TOK_0]] incidentrecord',
                '2': 'Classificeer de ernst',
                '3': 'Voer insluitingsacties uit en verzamel bewijsmateriaal',
                '4': 'Genereer een sjabloonexport voor een rapport over ernstige incidenten',
                '5': 'Via kanaal indienen bij de autoriteit',
                '6': 'Volg de reacties en afsluitingen van autoriteiten',
            },
        },
        AI_A5: {
            name: '[[TOK_0]] Effectbeoordeling',
            steps: {
                '1': 'Beoordelingsrecord maken',
                '2': 'Vul de vereiste secties in',
                '3': 'Voeg bewijsmateriaal toe: gegevensstromen, modeldocumentatie, controles',
                '4': 'Interne goedkeuring',
                '5': 'Rapport exporteren en opslaan in dossier',
            },
        },
        AI_A6: {
            name: 'Gecontroleerd testen / Sandbox-deelname',
            steps: {
                '1': 'Volledige geschiktheids- en gereedheidsrecord',
                '2': 'Aanvraag voorbereiden en exporteren',
                '3': 'Inzenden via kanaal',
                '4': 'Goedkeuring bijhouden',
                '5': 'Voer monitoringcontrolepunten en logboeken uit',
                '6': 'Compleet opleveringsrapport en afsluitingspakket',
            },
        },
        CYBERSEC_C1: {
            name: 'Kritieke veiligheidsbeoordeling van informatiesystemen',
            steps: {
                '1': 'Classificeer informatiesystemen volgens de nationale cyberbeveiligingsvereisten',
                '2': 'Voer beveiligingsbeoordelingen en risico-evaluatie uit voor geclassificeerde systemen',
                '3': 'Implementeer de vereiste beveiligingsmaatregelen en basiscontroles',
                '4': 'Documenteer het bewijs van naleving en plan periodieke beoordelingen',
            },
        },
        CYBERSEC_C2: {
            name: 'Melding van cyberbeveiligingsincidenten',
            steps: {
                '1': 'Detecteer, classificeer en beoordeel het cyberbeveiligingsincident',
                '2': 'Voer onmiddellijke responsacties uit en bewaar bewijsmateriaal',
                '3': 'Rapporteer aan de autoriteit en neem deel aan de nationale coördinatie van incidentenrespons',
                '4': 'Voer een beoordeling na het incident uit en documenteer de geleerde lessen',
            },
        },
        CYBERSEC_C3: {
            name: 'Verificatie van naleving van gegevenslokalisatie',
            steps: {
                '1': 'Beoordeel of triggers voor gegevenslokalisatie van toepassing zijn op basis van het servicetype en de gegevenscategorieën',
                '2': 'Controleer of de lokale opslagarchitectuur en grensoverschrijdende stroomcontroles aanwezig zijn',
                '3': 'Beoordeel lokale aanwezigheidsvereisten (filiaal/vertegenwoordigingskantoor) indien van toepassing',
                '4': 'Documenteer nalevingsbewijs en bewaar dit voor beoordeling door de autoriteit',
            },
        },
        CYBERSEC_C4: {
            name: 'Antwoord van autoriteitssamenwerkingsverzoek',
            steps: {
                '1': 'Ontvang en verifieer de legitimiteit en reikwijdte van het autorisatieverzoek',
                '2': 'Verzamel de gevraagde informatie en bereid deze voor of voer de vereiste acties uit',
                '3': 'Dien uw reactie binnen de vereiste tijdlijn in bij de autoriteit',
                '4': 'Registreer de openbaarmaking en sluit de zaak',
            },
        },
        CYBERSEC_C5: {
            name: 'Kwalificatieverificatie van cyberbeveiligingspersoneel',
            steps: {
                '1': 'Beoordeel de beveiligingssituatie van leveranciers met behulp van het beoordelingskader voor cyberbeveiliging',
                '2': 'Controleer het bereik van de toegang tot de leveranciersgegevens en registreer u in het toegangslogboek van de leverancier',
                '3': 'Bekijk de clausule over de melding van leveranciersincidenten en de contractuele cyberbeveiligingsvereisten',
                '4': 'Plan periodieke beveiligingsbeoordelingen van leveranciers en controleer de naleving',
            },
        },
        DATA_D1: {
            name: 'Gegevensinventarisatie en classificatie instellen',
            steps: {
                '1': 'Catalogiseer alle gegevensassets met typen en bronnen in het gegevensinventarisregister',
                '2': 'Classificeer elk activum op gevoeligheidsniveau',
                '3': 'Definieer afhandelingsregels per classificatieniveau',
                '4': 'Leg bewijs vast: screenshots, architectuurdiagrammen, toegangscontroles',
                '5': 'Plan periodieke beoordelingen',
            },
        },
        DATA_D2: {
            name: 'Beheer van het delen van gegevens',
            steps: {
                '1': 'Evalueer nieuwe regelingen voor delen via risicobeoordeling voor het delen van gegevens',
                '2': 'Voltooi de interne goedkeuringsworkflow',
                '3': 'Registreer de deelgebeurtenis in het logboek voor het delen/openbaar maken van gegevens',
                '4': 'Verzamel bewijsmateriaal: goedkeuringsgegevens, contractuele documenten',
                '5': 'Periodieke evaluatie van de deelregelingen',
            },
        },
        DATA_D3: {
            name: 'Beoordeling van grensoverschrijdende gegevensoverdracht',
            steps: {
                '1': 'Identificeer grensoverschrijdende overdrachten in de gegevensinventaris',
                '2': 'Voer een overdrachtsrisicobeoordeling uit',
                '3': 'Pas waarborgen en beheersmaatregelen toe',
                '4': 'Document in het grensoverschrijdende deel van de bestuursattest',
                '5': 'Exporteer beoordelingspakket voor audit',
            },
        },
        DATA_D4: {
            name: 'Jaarlijkse bestuursattest',
            steps: {
                '1': 'Beoordeel de governance RACI-matrix',
                '2': 'Beleidsstatus verifiëren (beheer, classificatie, delen, bewaren)',
                '3': 'Compleet attestpakket',
                '4': 'Zorg voor interne goedkeuring',
                '5': 'Attestatie exporteren en archiveren',
            },
        },
        DATA_D5: {
            name: 'Afhandeling van gegevensincidenten',
            steps: {
                '1': 'Classificeer het incident met behulp van het beslissingsrecord',
                '2': 'Voer incidentrespons uit per draaiboek',
                '3': 'Bewijsmateriaal vastleggen: logboeken, schermafbeeldingen, communicatie',
                '4': 'Voer een beoordeling na een incident uit',
                '5': 'Als kennisgeving aan de autoriteit vereist is: maak een indieningsaanvraag aan en dien deze in bij [[TOK_0]]',
                '6': 'Sluiten en archiveren',
            },
        },
        ECOM_P1: {
            name: 'Melding (verkoopwebsite/app)',
            steps: {
                '1': 'Classificatie bepalen: verkoopsite/app versus marktplaats/serviceplatform',
                '2': 'Creëer een intern dossierrecord met bedrijfsidentiteit, website-/app-informatie en vereiste openbaarmakingen',
                '3': "Genereer een bewijspakket: screenshots van openbaarmakingen, beleids-URL's, versiegeschiedenis",
                '4': 'Indienen via Online.gov.vn – upload documenten, noteer tijdstempel en bevestiging',
                '5': 'Volg de verwerking: leg de redenen vast als u het terugstuurt voor wijziging en verzend het opnieuw',
                '6': 'Sluiten: bevestiging opslaan, bewijsmateriaal koppelen en audittraject',
            },
        },
        ECOM_P2: {
            name: 'Registratie (serviceplatforms / marktplaatsen)',
            steps: {
                '1': 'Bepaal het platformmodel en de verplichtingen – marktplaats versus gemengde versus sociale handel',
                '2': 'Registratiedossier opbouwen – aanvraagformulier, dienstverleningsschema, algemene voorwaarden, platformregels',
                '3': 'Interne goedkeuringen — wijs de juridische/compliance-eigenaar toe, keur deze goed voor indiening',
                '4': 'Indienen via Online.gov.vn – dossier uploaden, tijdstempel vastleggen',
                '5': 'Verwerkingslus — indien geretourneerd voor wijziging, bijwerken en opnieuw indienen',
                '6': 'Goedkeuring en operationalisering – opslagbevestiging, bijhouden van doorlopende nalevingsregisters',
            },
        },
        ECOM_P3: {
            name: 'Update/wijzigingsmelding',
            steps: {
                '1': 'Identificeer de veranderingstrigger: materiële verandering in dossieritems',
                '2': 'Genereer een wijzigingspakket: wijzigingssamenvatting, bijgewerkte documenten, bewijsupdates',
                '3': 'Verzend de update en registreer de indieningsstatus',
                '4': 'Volg de verwerking en sluit af',
            },
        },
        ECOM_P4: {
            name: 'Beëindiging / deactivering',
            steps: {
                '1': 'Bereid het beëindigingspakket voor - stopdatum, reden, afhandelingsplan voor consumentenbescherming, bewijs van openbare kennisgeving',
                '2': 'Beëindiging indienen – noteer tijdstempel en bevestiging',
                '3': 'Sluiten: bewaar de definitieve status en bewijsmateriaal',
            },
        },
        ECOM_P5: {
            name: 'Trustmark / Geloofwaardigheidsbeoordelingsprogramma',
            steps: {
                '1': 'Beoordeling van geschiktheid en gereedheid',
                '2': 'Bereid het dossier voor met behulp van het officiële formulier',
                '3': 'Verzenden en volgen',
                '4': 'Zorg voor doorlopend nalevingsbewijs',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Indiening indienen bij [[TOK_1]]',
            steps: {
                '1': 'Voltooi [[TOK_0]] met behulp van het formuliertraject van Decreet 356 (Mẫu số 02a/02b)',
                '2': 'Verzamel omslagdocumenten en ondersteunend bewijsmateriaal',
                '3': 'Dien één origineel dossier in bij het Ministerie van Openbare Veiligheid ([[TOK_0]])',
                '4': 'Houd toezicht op aanvullende verzoeken van [[TOK_0]] en reageer binnen de deadline',
                '5': 'Bewaar het dossier en het bewijs van indiening voor het audittraject',
            },
        },
        PDPL_P2: {
            name: 'Aanvraag grensoverschrijdende overdracht',
            steps: {
                '1': 'Vul het dossier voor grensoverschrijdende overdracht in met behulp van Decreet 356-formulieren (Mẫu số 01a/01b, Mẫu số 09)',
                '2': 'Dien één origineel dossier in bij [[TOK_0]] binnen 60 dagen na aanvang van de verwerking',
                '3': 'Informeer [[TOK_0]] na succesvolle overdracht met de contactgegevens van de ontvangende partij',
                '4': 'Reageer binnen de deadline op aanvullings-/correctie-/inspectieverzoeken van [[TOK_0]].',
            },
        },
        PDPL_P3: {
            name: 'Certificaataanvraag voor gegevensverwerkingsservice',
            steps: {
                '1': 'Bereid een certificeringsaanvraagdossier voor volgens de vereisten van Decreet 356',
                '2': 'Dien uw aanvraag in bij [[TOK_0]] met de vereiste ondersteunende documenten',
                '3': 'Reageer op [[TOK_0]] beoordelingsreacties en aanvullingsverzoeken',
                '4': 'Certificaat- en verlengingsschema bijhouden',
            },
        },
        PDPL_P4: {
            name: 'Verwerking van rechten van betrokkenen',
            steps: {
                '1': 'Aanvraag ontvangen en loggen; verifieer de identiteit van de betrokkene binnen 2 werkdagen',
                '2': 'Beoordeel het type verzoek en bepaal de toepasselijke deadline (10/15/20 dagen per type)',
                '3': 'Voer fulfilmentacties uit in relevante systemen en afdelingen',
                '4': 'Bereid een antwoord voor en stuur het naar de betrokkene, met resultaat en onderbouwing',
                '5': 'Sluit de zaak en bewaar bewijsmateriaal voor audit; documenteer eventuele weigeringsredenen',
            },
        },
        PDPL_P5: {
            name: 'Kennisgeving van inbreuk aan [[TOK_0]]',
            steps: {
                '1': 'De inbreuk detecteren en beoordelen; notificatieplicht binnen 2 werkdagen vaststellen',
                '2': 'Bereid een meldingspakket voor volgens de [[TOK_0]] vereisten',
                '3': 'Dien binnen twee werkdagen na ontdekking een melding in bij [[TOK_0]]',
                '4': 'Reageren op [[TOK_0]] vervolgverzoeken; supplementen en coördinatiebewijs indienen',
            },
        },
        TELECOM_T1: {
            name: 'Afhandeling van autoriteitsverzoeken',
            steps: {
                '1': 'Ontvang en registreer het machtigingsverzoek via het intakerecord',
                '2': 'Controleer de identiteit van de autoriteit, de rechtsgrondslag en de reikwijdte van het verzoek',
                '3': 'Voer een interne juridische beoordeling uit en verkrijg goedkeuring van het management',
                '4': 'Bereid een responspakket voor met verzameld bewijsmateriaal',
                '5': 'Antwoordbrief opstellen en goedkeuren',
                '6': 'Creëer een indieningsaanvraag en dien uw reactie in via het kanaal',
                '7': 'Openbaarmaking van logboeken en erkenning van de autoriteit',
                '8': 'Sluit de zaak en bewaar bewijsmateriaal voor het audittraject',
            },
        },
        TELECOM_T2: {
            name: 'Beheer van openbaarmaking',
            steps: {
                '1': 'Ontvang een openbaarmakingsverzoek (toestemming van de gebruiker, wettelijke verplichting of autoriteitsverzoek)',
                '2': 'Voltooi de goedkeuringsworkflow voor openbaarmaking',
                '3': 'Voer de openbaarmaking uit en noteer het in het logregister',
                '4': 'Verzamel bewijsmateriaal: goedkeuringsgegevens, communicatiegegevens',
                '5': 'Periodieke beoordeling van het openbaarmakingslogboek',
            },
        },
        TELECOM_T3: {
            name: 'Vertrouwelijkheidsbeleid en toegangscontrole instellen',
            steps: {
                '1': 'Opstellen en goedkeuren van het vertrouwelijkheidsbeleid',
                '2': 'Opstellen en goedkeuren van toegangscontrole- en logbeleid',
                '3': 'Documentverwerkingsactiviteiten in het gebruikersinformatieverwerkingsregister',
                '4': 'Verzamel bewijsmateriaal: beleidsdocumenten, implementatiebewijs',
                '5': 'Plan periodieke beoordelingen',
            },
        },
        TELECOM_T4: {
            name: 'Beoordeling van telecomincidenten',
            steps: {
                '1': 'Classificeer en beoordeel het incident',
                '2': 'Bepaal de meldingsvereisten',
                '3': 'Als kennisgeving aan de autoriteit vereist is: maak een indieningsdossier aan',
                '4': 'Bewijsmateriaal vastleggen en bewaren',
                '5': 'Resolutie en afsluiting',
            },
        },
        TELECOM_T5: {
            name: 'Beheer van bewaren en verwijderen',
            steps: {
                '1': 'Definieer het bewaar- en verwijderingsschema per gegevenscategorie',
                '2': 'Implementeer verwijderingsprocedures',
                '3': 'Leg bewijsmateriaal vast – verwijder records',
                '4': 'Periodieke beoordeling van planningen',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Incidentafhandeling en rapportage van fouten',
            'CYBERSEC-FINE-B': 'Systeembeveiligingsmonitoring en basiscontrolefouten',
            'CYBERSEC-FINE-C': 'Samenwerkingsverzoeken van autoriteiten mislukten',
            'CYBERSEC-FINE-D': 'Gegevenslokalisatie en schendingen van lokale aanwezigheid',
            'CYBERSEC-FINE-E': 'Malwarepreventie en systeembeveiligingsfouten',
            'CYBERSEC-FINE-F': 'Reactiefouten van platform/serviceprovider',
            'CYBERSEC-FINE-G': 'Beveiligingsfouten van leveranciers/derden',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Registratie / Melding / Administratieve gereedheid',
            'ECOM-FINE-B': 'Klachten en consumentenbescherming',
            'ECOM-FINE-C': 'Toezicht en verwijderingshandhaving',
            'ECOM-FINE-D': 'Grensoverschrijdende operaties',
            'ECOM-FINE-E': 'Platformregels en transparantie',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Nalatigheid bij het uitvoeren van [[TOK_0]]',
            'PDPL-FINE-B': 'Ongeautoriseerde grensoverschrijdende overdracht',
            'PDPL-FINE-C': 'Verwerking zonder wettelijke basis',
            'PDPL-FINE-D': 'Niet reageren op DSR',
            'PDPL-FINE-E': 'Het niet melden van een datalek',
            'PDPL-FINE-F': 'Niet-conforme Verwerkersovereenkomst',
            'PDPL-FINE-G': 'Schendingen van gevoelige gegevensverwerking',
            'PDPL-FINE-H': 'Schendingen van gegevensverwerking door kinderen',
            'PDPL-FINE-I': 'Schendingen van geautomatiseerde besluitvorming',
            'PDPL-FINE-J': 'Niet-naleving van autoriteitsbevelen',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Mislukkingen bij het afhandelen van autoriteitsverzoeken',
            'TELECOM-FINE-B': 'Vertrouwelijkheid en ongeoorloofde openbaarmaking',
            'TELECOM-FINE-C': 'Toegangscontrole en logboekfouten',
            'TELECOM-FINE-D': 'Overtredingen bij het bewaren en verwijderen',
            'TELECOM-FINE-E': 'Mislukte beoordeling van telecomincidenten',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Onmiddellijk bij detectie',
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Zoals gespecificeerd in het machtigingsverzoek',
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Tot 80 miljoen VND',
                fine_org: 'Tot 160 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'ECOM-FINE-D': {
                fine_individual: 'Tot 80 miljoen VND',
                fine_org: 'Tot 160 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'ECOM-FINE-C': {
                fine_individual: 'Tot 80 miljoen VND',
                fine_org: 'Tot 160 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'ECOM-FINE-B': {
                fine_individual: 'Tot 80 miljoen VND',
                fine_org: 'Tot 160 miljoen VND',
                deadlines: 'Zoals gespecificeerd per klachtafhandelingsverplichtingen',
            },
            'ECOM-FINE-A': {
                fine_individual: 'Tot 80 miljoen VND',
                fine_org: 'Tot 160 miljoen VND',
                deadlines: 'Voordat u met e-commerceactiviteiten begint',
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'CYBERSEC-FINE-F': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Zoals gespecificeerd in het machtigingsverzoek',
            },
            'CYBERSEC-FINE-E': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Doorlopende verplichting',
            },
            'CYBERSEC-FINE-D': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Zoals gespecificeerd in gezagsbesluit; doorlopende verplichting indien geactiveerd',
            },
            'CYBERSEC-FINE-C': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Zoals gespecificeerd in het machtigingsverzoek',
            },
            'CYBERSEC-FINE-B': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Doorlopende verplichting; voordat het systeem in werking wordt gesteld, moeten er bedieningselementen aanwezig zijn',
            },
            'CYBERSEC-FINE-A': {
                fine_individual: 'Tot 100 miljoen VND',
                fine_org: 'Tot 200 miljoen VND',
                deadlines: 'Onmiddellijke reactie vereist; rapportage binnen de voorgeschreven tijdlijn',
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: '60 dagen vanaf het begin van de verwerking om het dossier in te dienen bij [[TOK_0]]',
            },
            'PDPL-FINE-B': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                revenue: '3%–5% van de Vietnam-inkomsten van vorig jaar in ernstige gevallen',
                deadlines: '60 dagen vanaf het begin van de verwerking om het dossier in te dienen bij [[TOK_0]]; kennisgeving na de overdracht vereist',
            },
            'PDPL-FINE-C': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: 'Doorlopende verplichting; Voor de verwerking moet toestemming worden verkregen',
            },
            'PDPL-FINE-D': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: '2 werkdagen procedureel antwoord; 10 dagen inzage/correctie; 15 dagen herroeping/beperking/bezwaar; 20 dagen verwijdering',
            },
            'PDPL-FINE-E': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: '2 werkdagen om [[TOK_0]] op de hoogte te stellen nadat een overtreding is ontdekt',
            },
            'PDPL-FINE-F': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: 'Doorlopende verplichting',
            },
            'PDPL-FINE-G': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: 'Doorlopende verplichting; Er moeten controles plaatsvinden voordat gevoelige gegevens worden verwerkt',
            },
            'PDPL-FINE-H': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: 'Doorlopende verplichting; ouderlijke toestemming vereist vóór verwerking',
            },
            'PDPL-FINE-I': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                deadlines: 'Doorlopende verplichting',
            },
            'PDPL-FINE-J': {
                fine_individual: 'Tot 1,5 miljard VND',
                fine_org: 'Tot 3 miljard VND',
                revenue: 'Tot 5% van de Vietnam-inkomsten van vorig jaar voor herhaalde overtredingen',
                deadlines: 'Zoals gespecificeerd in het machtigingsbesluit',
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Voortdurende exploitatie van het platform',
            responsible: {
                '1': 'Platformexploitant / Risico',
                '2': 'Platformoperator / Beveiliging',
                '3': 'Platformexploitant / Risico',
                '4': 'Platformoperator / Beveiliging',
                '5': 'Platformoperator',
                '6': 'Naleving',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P6: {
            trigger: 'Een deelnemer dient een klacht of geschilverzoek in',
            responsible: {
                '1': 'Platformoperator',
                '2': 'Platformoperator',
                '3': 'Platformoperator',
                '4': 'Platformoperator',
                '5': 'Platformexploitant / Juridisch',
                '6': 'Platformoperator',
                '7': 'Naleving',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P5: {
            trigger: 'De levering vindt plaats nadat aan de contract- en betalingsvoorwaarden is voldaan',
            responsible: {
                '1': 'Verkoper / Platformexploitant',
                '2': 'Platformoperator',
                '3': 'Platformoperator',
                '4': 'Platformoperator',
                '5': 'Platformoperator',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P4: {
            trigger: 'Een koper initieert een transactie voor gegevens, producten of diensten',
            responsible: {
                '1': 'Koper',
                '2': 'Koper / Platformexploitant',
                '3': 'Platformoperator',
                '4': 'Koper / Verkoper',
                '5': 'Platformexploitant / Betaling',
                '6': 'Platformoperator',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P3: {
            trigger: 'Een deelnemer wil dataproducten/diensten evalueren in de geïsoleerde omgeving',
            responsible: {
                '1': 'Deelnemer',
                '2': 'Platformexploitant / Deelnemer',
                '3': 'Platformoperator / IT',
                '4': 'Platformoperator / Beveiliging',
                '5': 'Platformoperator',
                '6': 'Platformoperator',
                '7': 'Platformoperator / IT',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P2: {
            trigger: 'Een verkoper wil gegevens, producten of gegevensdiensten aanbieden om te verhandelen',
            responsible: {
                '1': 'Verkoper',
                '2': 'Verkoper / Juridisch',
                '3': 'Verkoper / IT',
                '4': 'Verkoper',
                '5': 'Verkoper',
                '6': 'Platformoperator',
                '7': 'Platformoperator',
                '8': 'Platformoperator',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P1: {
            trigger: 'Een verkoper of koper sluit zich aan bij het dataplatform',
            responsible: {
                '1': 'Platformoperator',
                '2': 'Platformexploitant / Juridisch',
                '3': 'Platformexploitant / Juridisch',
                '4': 'Platformoperator',
                '5': 'Platformoperator',
                '6': 'Platformoperator',
                '7': 'Naleving',
            },
            step_outputs: {},
        },
        PDPL_P1: {
            trigger: 'Aanvang van de verwerking van persoonsgegevens waarvoor een effectbeoordeling vereist is',
            responsible: {
                '1': '[[TOK_0]] / Privacyteam',
                '2': 'Privacy-team',
                '3': 'Juridisch / Naleving',
                '4': '[[TOK_0]] / Privacyteam',
                '5': 'Nalevingsteam',
            },
            step_outputs: {},
        },
        PDPL_P2: {
            trigger: 'Intentie om persoonlijke gegevens buiten Vietnam over te dragen',
            responsible: {
                '1': '[[TOK_0]] / Privacyteam',
                '2': 'Juridisch / Naleving',
                '3': 'Juridisch / Naleving',
                '4': '[[TOK_0]] / Privacyteam',
            },
            step_outputs: {},
        },
        PDPL_P3: {
            trigger: 'Organisatie die gegevensverwerkingsdiensten levert waarvoor certificering vereist is',
            responsible: {
                '1': 'Juridisch / Naleving',
                '2': 'Juridisch / Naleving',
                '3': '[[TOK_0]] / Privacyteam',
                '4': 'Nalevingsteam',
            },
            step_outputs: {},
        },
        PDPL_P4: {
            trigger: 'Ontvangst van een verzoek om rechten van een betrokkene',
            responsible: {
                '1': 'Privacyteam / Klantenservice',
                '2': '[[TOK_0]] / Privacyteam',
                '3': 'Afdelingsleiders/IT',
                '4': '[[TOK_0]] / Privacyteam',
                '5': 'Nalevingsteam',
            },
            step_outputs: {},
        },
        PDPL_P5: {
            trigger: 'Ontdekking van een schending of inbreuk op de bescherming van persoonsgegevens',
            responsible: {
                '1': 'Incidentresponsteam / [[TOK_0]]',
                '2': '[[TOK_0]] / Privacyteam',
                '3': 'Juridisch / Naleving',
                '4': '[[TOK_0]] / Incidentresponsteam',
            },
            step_outputs: {},
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Decreet 13 Art. 24',
        'MoPS Admin Procedures': 'MoPS-beheerprocedures',
        'Annual cycle': 'Jaarlijkse cyclus',
        'Decree 13/2023/NĐ-CP Art. 24': 'Decreet [[TOK_0]]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Decreet [[TOK_0]]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Decreet [[TOK_0]]Đ-CP Art. 5 Cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Decreet [[TOK_0]]Đ-CP Art. 5 Cl. 2–5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Decreet [[TOK_0]]Đ-CP Art. 5 Cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Decreet [[TOK_0]]Đ-CP Art. 5 Cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Decreet [[TOK_0]]Đ-CP Art. 5 Cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Decreet [[TOK_0]]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Ontwerpbesluit Dataplatforms 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Wet [[TOK_0]] Hfdst. III; NĐ 98/2020; NĐ 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Wet [[TOK_0]] Hfdst. IV (Consumentenbescherming)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Wet [[TOK_0]] — Operationele procedure Online.gov.vn',
        'Law 134/2025/QH15 Article 12': 'Wet [[TOK_0]] Artikel 12',
        'Law 134/2025/QH15 Article 21': 'Wet [[TOK_0]] Artikel 21',
        'Law 134/2025/QH15 Article 27': 'Wet [[TOK_0]] Artikel 27',
        'Law 134/2025/QH15 Articles 9–10': 'Wet [[TOK_0]] Artikelen 9–10',
        'Law 24/2023/QH15 — article mapping pending': 'Wet [[TOK_0]] — artikeltoewijzing in behandeling',
        'Law 60/2024/QH15 (internal control target)': 'Wet [[TOK_0]] (doel voor interne controle)',
        'Law 91/2025/QH15 Art. 21': 'Wet [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Wet [[TOK_0]] Art. 23',
        'Policy-defined': 'Beleid gedefinieerd',
        Quarterly: 'Driemaandelijks',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 administratieve procedure',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'doelstelling voor interne controle (Wet [[TOK_0]] Art. 24, lid 2, onder b), 41, lid 5 — exact tijdschema in afwachting van uitvoeringsinstrument)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'internecontroledoelstelling (Wet [[TOK_0]] Artikel 41, lid 3 — exact tijdschema in afwachting van uitvoeringsinstrument)',
        'source verification pending': 'bronverificatie in behandeling',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C) [NL]',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A) [NL]",
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A) [NL]',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A) [NL]',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D) [NL]',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D) [NL]',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D) [NL]',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B) [NL]',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A) [NL]',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN — Internal Audit Governance [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D) [NL]',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN — Management Information System (Layer 4) [NL]',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3) [NL]',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G) [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G) [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN — Outsourcing Controls [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G) [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G) [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G) [NL]',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G) [NL]',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01 [NL]',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5) [NL]',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1) [NL]',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C) [NL]',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A) [NL]',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E) [NL]',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01 [NL]',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A) [NL]',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F) [NL]',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B) [NL]',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2) [NL]',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D) [NL]',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội (Nationale Vergadering)',
        'Ministry of Public Security / A05 Department': 'Ministerie van Openbare Veiligheid / Afdeling A05',
        'Ministry of Public Security': 'Ministerie van Openbare Veiligheid',
        'Ministry of Information and Communications': 'Ministerie van Informatie en Communicatie',
        'Government of Vietnam': 'Regering van Vietnam',
        'European Data Protection Board (EDPB)': 'Europees Comité voor gegevensbescherming (EDPB)',
        'ENISA / National CSIRTs': "ENISA / Nationale CSIRT's",
        'State Bank of Vietnam': 'Staatsbank van Vietnam',
    },
    tour_titles: {
        access_accountability: 'Toegang tot verantwoordingsrondleiding',
        assessments: 'Beoordelingsrondleiding',
        audit_trail: 'Audit Trail-tour',
        classification: 'Classificatie Ronde',
        compliance_forms: 'Rondleiding door nalevingsformulieren',
        connectors: 'Connectoren-rondleiding',
        consent_properties: 'Rondleiding door toestemmingseigenschappen',
        consent: 'Toestemmingsrondleiding',
        dashboard: 'Dashboardrondleiding',
        data_mapping: 'Data Mapping-rondleiding',
        data_subjects: 'Rondleiding door betrokkenen',
        deletion_orchestration: 'Schrapping Orchestration Tour',
        discovery: 'Ontdekkingstocht',
        governance: 'Bestuursrondleiding',
        help_center: 'Rondleiding door het Helpcentrum',
        incident_ops: 'Rondleiding incidentoperaties',
        incidents: 'Incidentenrondleiding',
        localization: 'Lokalisatierondleiding',
        monitoring: 'Bewakingsrondleiding',
        onboarding: 'Onboarding-rondleiding',
        organizations: 'Organisaties Rondleiding',
        partner_workspace: 'Rondleiding door de partnerwerkruimte',
        platform_settings: 'Rondleiding platforminstellingen',
        privacy_scanner: 'Rondleiding door de privacyscanner',
        program_governance: 'Programmabeheerrondleiding',
        rights_requests: 'Rondleiding over rechtenverzoeken',
        task_management: 'Rondleiding voor taakbeheer',
        vendor_risk: 'Leveranciersrisicotour',
    },
    tour_descriptions: {
        access_accountability: 'Als hoofd van de interne audit (P-VN-10) beoordeel je het toegangsbewijs, controleer je het gebruik van toestemmingen en onderzoek je afwijkende patronen om de integriteit en vertrouwelijkheid van artikel 5, lid 1, onder f) aan te tonen.',
        assessments: "Voer als onderneming [[TOK_1]] (P-VN-01) DPIA's uit volgens Decreet 356 Mau so 02a, identificeer lacunes in de naleving en beoordeel de risico's van grensoverschrijdende overdrachten onder [[TOK_0]].",
        audit_trail: 'Als hoofd van de interne audit (P-VN-10) bevraagt u moduleoverschrijdend bewijsmateriaal, stelt u auditpakketten samen en exporteert u fraudebestendige logboeken voor indieningen bij de toezichthouders.',
        classification: 'Als Data Steward (P-VN-05) definieert u taxonomieën voor gegevensclassificatie, wijst u gevoeligheidslabels toe, dwingt u bewaarbeleid af en lost u de dekkingslacunes op die nodig zijn voor [[TOK_0]]-compliance.',
        compliance_forms: 'Blader als de Enterprise [[TOK_0]] (P-VN-01) door officiële Vietnamese regelgevingsformulieren, waaronder Phu luc I, Phu luc II en Mau so-sjablonen voor deponeringen bij de PDP-commissie, en dien deze in.',
        connectors: 'Als IT Systems Lead (P-VN-05) leg je de bedrijfsvereisten voor integraties vast, breng je connectoren in kaart voor compliance-gegevensstromen en verifieer je de POC-gereedheid voordat je live gaat.',
        consent_properties: 'Configureer als Enterprise [[TOK_1]] (P-VN-01) de implementatie van [[TOK_2]]: digitale eigendomsregistratie, gouden sjablonen voor consistente [[TOK_0]] toestemmingsbanners en bindende matrices die eigenschappen koppelen aan verwerkingsactiviteiten.',
        consent: 'Beheer als onderneming [[TOK_1]] (P-VN-01) de levenscyclus van het toestemmingsbeleid: definieer verzameldoeleinden, dwing [[TOK_0]] intrekkingsrechten af en integreer met uw toestemmingsbeheerplatform.',
        dashboard: "Oriënteer u als Enterprise [[TOK_1]] (P-VN-01) rond het compliance-houdingscommandocentrum dat [[TOK_0]]-deadlines naar voren brengt, SLA's overtreedt en KPI's voor auditgereedheid biedt.",
        data_mapping: 'Als Data Steward (P-VN-05) bouwt u uw ROPA-inventaris op, brengt u grensoverschrijdende gegevensstromen in kaart en houdt u het verwerkingsactiviteitenregister bij dat vereist is door [[TOK_0]].',
        data_subjects: 'Beheer als Enterprise DPO of Education Compliance Lead uniforme profielen van betrokkenen die toestemmingsrecords, rechtenverzoeken en tijdlijnactiviteiten op het hele platform koppelen.',
        deletion_orchestration: 'Als [[TOK_1]] (P-VN-01) verifieer je de end-to-end gegevensverwijdering in interne systemen en externe leveranciers, met cryptografisch bewijs voor naleving van het recht op verwijdering van [[TOK_0]] Artikel 17.',
        discovery: 'Voer als Data Steward (P-VN-05) geautomatiseerde scans uit om persoonlijke gegevens op verbonden systemen te ontdekken, gefaseerde bevindingen te bekijken en resultaten in de classificatiemodule in te voeren voor [[TOK_0]]-labeling.',
        governance: "Als Vendor Risk Manager (P-VN-08) houd je het leveranciersregister bij, volg je subprocessorketens, beoordeel je de risico's van grensoverschrijdende overdrachten en handhaaf je governance-playbooks onder [[TOK_0]].",
        help_center: "Voor alle persona's (DPO's, auditors, IT-leads en compliance-managers) vindt u antwoorden, handleidingen en modulespecifieke documentatie ter ondersteuning van uw dagelijkse compliance-workflows.",
        incident_ops: 'Activeer als incidentcommandant (P-VN-09 de reactieplaybooks, houd de naleving van [[TOK_1]] bij aan de hand van het 72-uur durende [[TOK_0]] notificatievenster, beheer escalaties en coördineer de reactie van de leverancier.',
        incidents: 'Als incidentcommandant (P-VN-09) detecteer en rapporteer je datalekken met een meldingsplicht van 72 uur [[TOK_0]] aan het PDP-comité, sorteer je op ernst en stel je incidentdossiers op auditniveau op.',
        localization: 'Beheer als Enterprise [[TOK_1]] (P-VN-01) de levenscyclus van het regelgevingskader: installeer Vietnamese marktpakketten, activeer [[TOK_0]] en Decreet 13 kaders, wijs vereisten toe aan platformmodules en beheer vertalingen.',
        monitoring: "Stel als onderneming [[TOK_1]] (P-VN-01) doorlopende programma's voor nalevingsmonitoring op, volg wijzigingen in de regelgeving, meet KPI's en beheer gevallen van interactie tussen regelgeving onder [[TOK_0]].",
        onboarding: "Geef als Compliance Trainer (P-VN-02) training via rondleidingen, laad realistische voorbeeldgegevens voor praktische oefeningen en voer de installatiewizard uit voor snelstartscenario's.",
        organizations: 'Configureer als [[TOK_0]] (P-VN-01) compliance-structuren voor meerdere organisaties, stel afdelingshiërarchieën in en stuur verzoeken van betrokkenen door uw bedrijfsgroep.',
        partner_workspace: 'Als Partner Account Manager onboard je partnerorganisaties, configureer je serviceniveaus, volg je compliance-resultaten en beheer je de partnermarktplaats.',
        platform_settings: 'Beheer als platformbeheerder alle operationele configuraties (identiteit, beveiliging, integraties en moduletoegang) die ten grondslag liggen aan uw complianceprogramma.',
        privacy_scanner: 'Voer als privacyanalist (P-VN-06) voortdurend monitoringscans uit om schendingen van de toestemming voor cookies, ongeautoriseerde trackers en lacunes in het beleid op te sporen, waardoor bewijs wordt gegenereerd voor ePrivacy en naleving van [TOK_0]].',
        program_governance: 'Navigeer tussen volwassenheidsmodellen, beoordelingen, hiaten in bewijsmateriaal, samenvattingen en meer. Elke submodule draagt ​​bij aan een holistische kijk op de gezondheid van uw interne programma.',
        rights_requests: 'Beheer als onderneming [[TOK_1]] (P-VN-01) de rechtenverzoeken van betrokkenen onder [[TOK_0]] met wettelijke deadlines van 15 dagen, identiteitsverificatie en oplossingen op auditniveau.',
        task_management: "Stuur compliancetaken door verschillende persona's, houd [[TOK_0]] deadlines bij en automatiseer workflows zodat uw team verantwoordelijk blijft.",
        vendor_risk: "Als Vendor Risk Manager (P-VN-08) scoor je risico's van derden, dwing je poortbeoordelingen af en activeer je herbeoordelingen - in tegenstelling tot Program Governance, dat je interne volwassenheid bijhoudt.",
    },
    consolidation: {
        title: 'Consolidatiezaken',
        new_case: 'Consolidatiecase maken',
        case_count: 'case',
        created: 'Consolidatiecase gemaakt',
        create: 'Casus maken',
        creating: 'Creëren...',
        cancel: 'Annuleer',
        no_cases: 'Geen consolidatiegevallen gevonden.',
        all_statuses: 'Alle statussen',
        all_purposes: 'Alle doeleinden',
        filter_status: 'Filter op status',
        filter_purpose: 'Filter op doel',
        col_title: 'Titel',
        col_purpose: 'Doel',
        col_status: 'Status',
        col_progress: 'Vooruitgang',
        col_deadline: 'Deadline',
        col_department: 'Afdeling',
        col_version: 'Versie',
        col_evidence: 'Bewijs',
        sections_accepted: 'accepted',
        prev: 'Vorige',
        next: 'Volgende',
        page: 'Pagina',
        prev_page: 'Vorige pagina',
        next_page: 'Volgende pagina',
        field_title: 'Titel',
        field_purpose: 'Doel',
        field_framework: 'Kadercode',
        field_deadline: 'Deadline',
        field_reviewer: 'Gebruikers-ID van recensent',
        title_placeholder: 'Voer de casetitel in',
        framework_placeholder: 'bijvoorbeeld PDPD-2023',
        reviewer_placeholder: 'Voer de gebruikers-ID van de reviewer in',
        purposes: {
            dpia_filing: '[[TOK_0]] Archivering',
            cross_border_filing: 'Grensoverschrijdende indiening',
            annual_governance_attestation: 'Jaarlijkse bestuursattest',
            breach_package: 'Inbreukpakket',
            audit_inspection_pack: 'Auditinspectiepakket',
        },
        statuses: {
            draft: 'Diepgang',
            collecting: 'Verzamelen',
            consolidating: 'Consolideren',
            review: 'Beoordeling',
            corrections: 'Correcties',
            pending_approval: 'In afwachting van goedkeuring',
            approved: 'Goedgekeurd',
            completed: 'Voltooid',
            closed: 'Gesloten',
            rejected: 'Afgewezen',
        },
        section_statuses: {
            pending: 'In behandeling',
            in_progress: 'In uitvoering',
            submitted: 'Ingezonden',
            accepted: 'Geaccepteerd',
            needs_correction: 'Heeft correctie nodig',
            corrected: 'Gecorrigeerd',
        },
        flag_types: {
            missing_section: 'Ontbrekende sectie',
            conflicting_entry: 'Conflicterende invoer',
            stale_entry: 'Verouderde inzending',
            missing_evidence: 'Ontbrekend bewijs',
            incomplete_data: 'Onvolledige gegevens',
            duplicate_entry: 'Dubbele invoer',
        },
        flag_severities: {
            critical: 'Kritisch',
            warning: 'Waarschuwing',
            info: 'Info',
        },
        sections_title: 'Secties',
        no_sections: 'Nog geen secties toegewezen.',
        flags_title: 'Vlaggen',
        no_flags: 'Geen vlaggen gedetecteerd.',
        open: 'open',
        approval_chain: 'Goedkeuringsketen',
        pending: 'In behandeling',
        audit_trail: 'Audittraject',
        no_audit: 'Geen auditgebeurtenissen.',
        auto_assign: 'Secties automatisch toewijzen',
        start_collection: 'Verzameling starten',
        review_case: 'Beoordeling zaak',
        generate_export: 'Exporteren genereren',
        review_title: 'Consolidatieoverzicht',
        advance_approval: 'Ga door naar goedkeuring',
        back_to_case: 'Terug naar Casus',
        accept: 'Accepteer',
        return_section: 'Keer terug',
        return_comment: 'Reactie retourneren...',
        resolve: 'Oplossen',
        dismiss: 'Negeren',
        resolution_notes: 'Resolutie-opmerkingen...',
        notes: 'Opmerkingen',
        section_accepted: 'Sectie geaccepteerd',
        section_returned: 'Sectie teruggestuurd voor correctie',
        advanced_to_approval: 'De zaak is in behandeling genomen in afwachting van goedkeuring',
        section_data: 'Sectiegegevens',
        save_progress: 'Bewaar vooruitgang',
        submit_section: 'Sectie indienen',
        submitting: 'Verzenden...',
        resubmit: 'Opnieuw indienen',
        progress_saved: 'Vooruitgang opgeslagen',
        section_submitted: 'Sectie ingediend',
        correction_required: 'Correctie vereist',
        evidence_title: 'Bewijs',
        no_evidence: 'Geen bewijsmateriaal bijgevoegd.',
        add_evidence: 'Bewijs toevoegen',
        evidence_added: 'Bewijs toegevoegd',
        evidence_files: 'bewijsbestanden',
        uploaded_by: 'geüpload door',
        comments_title: 'Opmerkingen',
        no_comments: 'Nog geen opmerkingen.',
        comment_placeholder: 'Voeg een reactie toe...',
        add_comment: 'Commentaar toevoegen',
        comment_added: 'Commentaar toegevoegd',
        view_data: 'Bekijk ingediende gegevens',
        export_title: 'Dossier exporteren',
        export_generated: 'Exportpakket gegenereerd',
        regenerate: 'Regenereer',
        regenerating: 'Regenereren...',
        generated_at: 'Gegenereerd op',
        artifacts_title: 'Artefacten exporteren',
        artifact_type: 'Artefact',
        file_name: 'Bestandsnaam',
        file_size: 'Grootte',
        generated: 'Gegenereerd',
        download: 'Downloaden',
        artifacts: {
            master_report: 'Hoofdrapport',
            evidence_bundle: 'Bewijsbundel (ZIP)',
            contributor_lineage: 'Afkomst van de bijdrager',
            conflict_resolution: 'Conflictoplossing',
            approval_history: 'Goedkeuringsgeschiedenis',
        },
        official_forms: 'Officiële formulieren',
        forms_description: 'Uit de geconsolideerde gegevens kunnen de volgende officiële formulieren worden gegenereerd. Officiële formulieren staan ​​los van de interne werkdocumenten.',
        announce_loaded_cases: '[[TOK_1]] consolidatiecases geladen',
        announce_case_detail_loaded: 'Zaakdetail geladen',
        announce_case_transitioned: 'Case overgezet naar [[TOK_1]]',
        announce_flag_resolved: 'Vlag opgelost',
        announce_flag_dismissed: 'Vlag afgewezen',
        case_detail_loaded: 'Zaakdetail geladen',
        sections_auto_assigned: 'Secties worden automatisch toegewezen vanuit de afdelingshiërarchie',
        errors: {
            load_failed: 'Kan gegevens niet laden. Probeer het opnieuw.',
            create_failed: 'Kan casus niet maken. Probeer het opnieuw.',
            required_fields: 'Vul alle verplichte velden in.',
            not_found: 'Niet gevonden.',
            comment_required: 'Bij het retourneren van een onderdeel is commentaar vereist.',
            notes_required: 'Er zijn opmerkingen vereist bij het oplossen of negeren van een vlag.',
        },
    },
    rights_requests: {
        import: {
            title: 'Zaken importeren',
            nav_title: 'Bulkimport',
            description: 'Upload een CSV-bestand om rechtenverzoekcasussen in bulk te importeren.',
            select_file: 'CSV-bestand selecteren',
            file_help: 'CSV met kopteksten die overeenkomen met zaakvelden.',
            file_too_large: 'Bestand te groot. Maximale grootte is 2MB.',
            preview: 'Voorbeeld',
            columns_detected: 'Kolommen gedetecteerd: {count}',
            column_mapping: 'Kolomtoewijzing',
            import_button: 'Importeren',
            import_complete: 'Import voltooid',
            import_error: 'Import mislukt',
            result: 'Importresultaat',
            total: 'Totaal',
            imported: 'Geïmporteerd',
            skipped: 'Overgeslagen',
            failed: 'Mislukt',
            errors: 'Fouten',
            error_row: 'Rij',
            error_field: 'Veld',
            error_message: 'Bericht',
            history: 'Importgeschiedenis',
            no_history: 'Geen importgeschiedenis.',
            history_file: 'Bestandsnaam',
            history_date: 'Datum',
        },
        batch: {
            nav_title: 'Batchproces',
            page_title: 'DSR-batchproces',
            page_subtitle: 'Upload een [[TOK_1]] aan openstaande vraagresponsen. Forseti stelt een bevestigingsantwoord per verzoek op en zet een verificatietaak per rij in de wachtrij. De [[TOK_0]] beoordelingen + accepteren ze allemaal voordat ze worden verzonden.',
            upload_heading: 'Uploaden',
            csv_hint: 'Vereiste kolommen: request_id, requester_email, request_type. Optioneel: deadline (ISO-8601), notities.',
            rows_heading: '[[TOK_1]] rijen geparseerd',
            submit_label: 'Batch uitvoeren',
            submitting: 'Opstellen…',
            col_request_id: 'Aanvraag id',
            col_email: 'E-mailadres van de aanvrager',
            col_type: 'Typ',
            col_status: 'Status',
            col_actions: 'Acties',
            status_queued: 'In de wachtrij',
            status_drafted: 'Opgesteld',
            status_failed: 'Mislukt',
            status_accepted: 'Geaccepteerd',
            status_rejected: 'Afgewezen',
            'status_parsing-error': 'Parseerfout',
            accept: 'Accepteer',
            reject: 'Afwijzen',
            permission_denied: 'U heeft geen toestemming om Forseti-workflows uit te voeren.',
        },
    },
    assessment_triggers: {
        title: 'Beoordelingstriggers',
        subtitle: 'Configureer het automatisch maken van beoordelingen en [[TOK_0]]-meldingen voor privacyworkflows.',
        auto_create_dpia_label: 'Automatisch [[TOK_0]] maken bij het verwerken van activiteit gemarkeerd als [[TOK_1]] vereist',
        auto_notify_new_purpose_label: 'Stel [[TOK_0]] automatisch op de hoogte wanneer er een nieuw doel wordt aangemaakt met gevoelige gegevenscategorieën',
        auto_notify_cross_border_label: 'Stel [[TOK_0]] automatisch op de hoogte wanneer grensoverschrijdende overdracht wordt toegevoegd aan de verwerkingsactiviteit',
        default_dpo_label: 'Standaard [[TOK_0]]',
        default_dpo_placeholder: 'Selecteer standaard [[TOK_0]]...',
        notification_channels_label: 'Meldingskanalen',
        channel_in_app: 'In-app',
        channel_email: 'Email',
        save_success: 'Beoordelingstriggerinstellingen opgeslagen.',
        save_error: 'Kan de triggerinstellingen voor de beoordeling niet opslaan.',
        fetch_error: 'Kan de triggerinstellingen voor de beoordeling niet laden.',
        fetch_users_error: 'Kan gebruikers niet laden.',
        announce_loaded: 'Instellingen voor beoordelingstrigger geladen',
        dpia_status: '[[TOK_0]] Status',
        dpia_linked: '[[TOK_0]] Gekoppeld',
        dpia_required_no_dpia: '[[TOK_0]] Vereist — niet gemaakt',
        create_dpia: 'Maak [[TOK_0]]',
        create_dpia_success: '[[TOK_0]] gemaakt en gekoppeld aan activiteit.',
        create_dpia_error: 'Kan [[TOK_0]] niet maken voor activiteit.',
        view_dpia: 'Bekijk [[TOK_0]]',
    },
    data_subjects: {
        title: 'Profielen van betrokkenen',
        nav_title: 'Betrokkenen',
        nav: {
            profiles: 'Profielen',
        },
        create: 'Profiel aanmaken',
        edit: 'Profiel bewerken',
        delete: 'Profiel verwijderen',
        delete_confirm: 'Weet u zeker dat u dit betrokkenenprofiel wilt verwijderen?',
        display_name: 'Weergavenaam',
        email: 'Email',
        phone: 'Telefoon',
        employee_id: 'Medewerker-ID',
        student_id: 'Student-ID',
        notes: 'Opmerkingen',
        external_refs: 'Externe referenties',
        cases_count: 'Gevallen',
        workflows_count: 'Toestemmingsregistraties',
        last_activity: 'Laatste activiteit',
        timeline: 'Tijdlijn',
        link_case: 'Link Case',
        link_workflow: 'Link Workflow',
        no_profiles: 'Er zijn geen profielen van betrokkenen gevonden.',
        search_placeholder: 'Zoek op naam, e-mailadres, telefoonnummer of ID...',
        create_success: 'Profiel van betrokkene aangemaakt.',
        create_error: 'Kan het profiel van de betrokkene niet maken.',
        update_success: 'Profiel van betrokkene bijgewerkt.',
        update_error: 'Kan het profiel van de betrokkene niet bijwerken.',
        delete_success: 'Profiel van betrokkene verwijderd.',
        delete_error: 'Kan het profiel van de betrokkene niet verwijderen.',
        link_case_success: 'Casus gekoppeld aan profiel.',
        link_case_error: 'Kan case niet aan profiel koppelen.',
        link_workflow_success: 'Workflow gekoppeld aan profiel.',
        link_workflow_error: 'Kan workflow niet aan profiel koppelen.',
        load_error: 'Kan profielen van betrokkenen niet laden.',
        detail_load_error: 'Kan het profiel van de betrokkene niet laden.',
        timeline_load_error: 'Kan de tijdlijn niet laden.',
        tab_cases: 'DSR-gevallen',
        tab_consent: 'Toestemmingsregistraties',
        tab_timeline: 'Tijdlijn',
        tab_consent_workflows: 'Toestemmingsworkflows',
        tab_web_consent: '[[TOK_0]] Toestemming',
        web_consent_empty: 'Er zijn geen [[TOK_0]] toestemmingsrecords gevonden voor dit onderwerp.',
        web_consent_load_error: 'Kan [[TOK_0]] toestemmingsrecords niet laden.',
        col_policy_version: 'Beleidsversie',
        col_versions: 'Versies',
        col_consent_version: 'Toestemming',
        col_cookie_declaration_version: 'Cookieverklaring',
        col_purposes: 'Doeleinden',
        purpose_granted: 'Toegegeven',
        purpose_denied: 'Geweigerd',
        granted_domains: 'Toegegeven',
        denied_domains: 'Geweigerd',
        col_action: 'Actie',
        col_timestamp: 'Tijdstempel',
        col_domain: 'Domein',
        no_cases: 'Geen gekoppelde cases.',
        no_workflows: 'Geen gekoppelde toestemmingsworkflows.',
        no_timeline: 'Geen tijdlijngebeurtenissen.',
        case_id: 'Case-ID',
        case_status: 'Status',
        case_type: 'Verzoektype',
        case_created: 'Gemaakt',
        workflow_id: 'Werkstroom-ID',
        workflow_type: 'Typ',
        workflow_status: 'Status',
        workflow_created: 'Gemaakt',
        timeline_date: 'Datum',
        timeline_event: 'Evenement',
        timeline_details: 'Details',
        timeline_time: 'Tijd',
        timeline_type: 'Typ',
        timeline_summary: 'Samenvatting',
        type_case: 'DSR-zaak',
        type_consent_workflow: 'Toestemmingsworkflow',
        profile_info: 'Profielinformatie',
        announce_loaded: 'Profielen van betrokkenen geladen',
        announce_detail_loaded: 'Profiel van betrokkene geladen',
        select_case: '— Selecteer een zaak —',
        select_workflow: '— Selecteer een werkstroom —',
        no_cases_hint: 'Koppel zaken om ze hier te zien.',
        no_workflows_hint: 'Koppel toestemmingsworkflows om ze hier te zien.',
    },
    flows: {
        map: {
            description_prefix: '{systems} systemen · {flows} stromen · {crossBorder} grensoverschrijdend · {highRisk} hoog/kritiek risico',
            switch_to_list: 'Schakel naar lijstweergave',
            switch_to_list_aria: 'Schakel naar tabelweergave',
            svg_aria: 'Gegevensstroomkaart: {systems} systemen, {flows} stromen, {crossBorder} grensoverschrijdend',
            selected_system: 'Geselecteerd systeem',
            drill_hint: 'Open het tabblad „Lijst" om de gekoppelde stromen, DPIA’s en leverancierstoewijzingen voor dit systeem te bewerken.',
        },
    },
    packages: {
        light: {
            name: 'Licht',
            description: 'Essentiële privacy-compliance-tools voor kleine teams',
        },
        standard: {
            name: 'Standaard',
            description: 'Volledig uitgerust compliance-platform voor groeiende organisaties',
        },
        enterprise_unlimited: {
            name: 'Onderneming onbeperkt',
            description: 'Compliance op enterprise-niveau met multi-org-ondersteuning en toegewijde diensten',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Provider-instellingen',
            subtitle: 'Configureer de Claude-provider voor de Forseti [[TOK_0]] juridisch adviseur.',
            healthHeading: 'Gezondheid van de aanbieder',
            statusLabel: 'Status',
            statusOk: 'Oké',
            statusFailed: 'Niet beschikbaar',
            providerLabel: 'Aanbieder',
            providerClaudeApi: 'Claude [[TOK_0]]',
            providerCliRelay: 'Claude CLI-relais',
            providerAesirManaged: 'Door Aesir beheerde tokens',
            lastCheckedLabel: 'Laatst gecontroleerd',
            reasonLabel: 'Reden',
            refreshButton: 'Vernieuwen',
            apiKeyHeading: 'Claude [[TOK_0]]-toets',
            apiKeyHint: 'Als je een [[TOK_0]]-toets instelt, wordt de Claude-modus [[TOK_1]] geactiveerd. Laat deze instelling uitgeschakeld om de lokale CLI-relay te gebruiken (ontwikkelaar/zelf-hostende modus).',
            apiKeyLabel: '[[TOK_0]]-toets',
            apiKeyMinLength: 'Minimaal 32 tekens. Versleuteld in rust; nooit meer getoond.',
            apiKeyTooShort: 'De sleutel [[TOK_0]] moet minimaal 32 tekens lang zijn.',
            apiKeySaved: '[[TOK_0]] sleutel opgeslagen. Verfrissende gezondheid…',
            apiKeyCleared: '[[TOK_0]]-toets gewist. Forseti maakt nu gebruik van het lokale CLI-relais.',
            setKeyButton: 'Sla de [[TOK_0]]-sleutel op',
            clearKeyButton: 'Wis de [[TOK_0]]-toets (gebruik CLI-relais)',
        },
        usage: {
            title: 'Gebruik',
            subtitle: 'Tokenverbruik en bucketstatus voor deze organisatie.',
            bucketHeading: 'Maandelijkse tokenbucket',
            remainingLabel: 'Resterend',
            consumedLabel: 'Verbruikt',
            totalLabel: 'Totaal',
            unitsLabel: 'factureerbare eenheden',
            lastReconciledLabel: 'Laatst verzoend',
            recentHeading: 'Recente activiteit',
            historyHeading: 'Laatste 12 periodes',
            noActivity: 'Nog geen activiteit deze periode.',
            featureLabel: 'Functie',
            whenLabel: 'Wanneer',
            periodLabel: 'Periode',
            topUpButton: 'Vraag een opwaardeerbundel aan',
            topUpHint: 'Neem contact op met uw accountmanager om een ​​opwaardeerbundel aan te vragen.',
            buyMore: {
                buyButton: 'Meer eenheden kopen',
                purchaseTitle: 'Meer factureringseenheden kopen',
                purchaseSubtitle: 'Kies een bundel. U wordt doorgestuurd naar de beveiligde Stripe-afrekenpagina en uw factuur ontvangt u per e-mail.',
                packageLabel: 'Bundel',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Klein',
                packageMedium: 'Gemiddeld',
                packageLarge: 'Groot',
                checkoutButton: 'Doorgaan naar afrekenen',
                checkoutPending: 'Afrekenen wordt geopend…',
                cancelButton: 'Annuleren',
                purchaseError: 'Kan het afrekenen niet starten. Probeer het zo dadelijk opnieuw.',
                redeemTitle: 'Een factuur inwisselen',
                redeemSubtitle: 'Al betaald? Selecteer de bundel die u hebt gekocht en voer het factuurnummer uit uw e-mail in om de eenheden toe te voegen.',
                invoiceLabel: 'Factuurnummer',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Inwisselen',
                redeemPending: 'Inwisselen…',
                redeemSuccess: 'Eenheden toegevoegd aan uw bucket.',
                redeemAlready: 'Deze factuur is al ingewisseld.',
                errorNotFound: 'Er is geen factuur gevonden met dat nummer. Controleer het factuurnummer en probeer het opnieuw.',
                errorNotPaid: 'Deze factuur is nog niet als betaald gemarkeerd.',
                errorOrgMismatch: 'Deze factuur is niet aan uw organisatie uitgereikt.',
                errorPackageMismatch: 'Deze factuur komt niet overeen met de geselecteerde bundel.',
                errorInvalidInvoice: 'Voer een geldig factuurnummer in.',
                errorGeneric: 'Inwisselen mislukt. Probeer het zo dadelijk opnieuw.',
            },
            byFeatureHeading: 'Deze maand per functie',
            byFeatureEmpty: 'Nog geen feature-activiteit deze periode.',
            featureColumn: 'Functie',
            featureUnitsColumn: 'Eenheden',
            featureRunsColumn: 'Loopt',
            byUserHeading: 'Deze maand per gebruiker (beheerdersweergave)',
            byUserEmpty: 'Er is nog geen activiteit per gebruiker deze periode.',
            userColumn: 'Gebruiker',
            reconciliationLinkLabel: 'Bekijk het afstemmingsafwijkingsrapport',
            reconciliationLinkHint: 'Alleen Aesir-interne beheerder.',
            featureLabels: {
                chat: 'Chatten',
                workflow: 'Workflow uitgevoerd',
                tabular: 'Tabellarische extractie',
                redline: 'Redline-recensie',
                title: 'Titel van het gesprek',
                unknown: 'Anders',
            },
        },
        reconciliation: {
            title: 'Verzoening van Forseti-quota',
            subtitle: 'Wissel tussen de snelle cache van de quotateller en het gezaghebbende factureringsgrootboek. De verzoener wordt elke 5 minuten uitgevoerd; deze pagina toont de laatste run en geschiedenis. Alleen Aesir-interne beheerder.',
            backLink: 'Terug naar Forseti-gebruik',
            stubHeading: 'De geschiedenis van verzoening komt binnenkort',
            stubBody: 'De logboeken van de reconciler-werknemer verlopen via het gestructureerde logboekkanaal. Een backend-leeseindpunt dat de laatste 30 afstemmingsruns blootlegt, wordt in scope gebracht (uitgesteld vanaf Sprint 47.5.9.6 – zie werkbestand). Zodra het eindpunt is geland, toont deze pagina de rungeschiedenistabel + P0-driftbanner.',
            stubBackendOwner: "Uitstel van backend: afstemmingsruns in een nieuwe verzameling voortzetten + route 'GET /llm-relay/quota/reconciliation' toevoegen.",
            permissionDenied: 'Deze pagina is beperkt tot Aesir-interne beheerders. Als u denkt dat u toegang zou moeten hebben, neem dan contact op met uw [[TOK_0]]-vertegenwoordiger.',
        },
        projects: {
            title: 'Projecten',
            subtitle: 'Werkruimten voor documenten, gesprekken, workflows en beoordelingen.',
            modeLabel: 'Bekijk',
            tabMine: 'Mijn projecten',
            tabShared: 'Gedeeld met mij',
            searchLabel: 'Zoek projecten',
            searchPlaceholder: 'Zoek…',
            newButton: 'Nieuw project',
            colName: 'Naam',
            colVisibility: 'Zichtbaarheid',
            colDocs: 'Documenten',
            colMembers: 'Leden',
            colUpdated: 'Bijgewerkt',
            visibilityOwn: 'Alleen eigen',
            visibilityShared: 'Gedeeld',
            emptyMine: 'Nog geen projecten. Maak er een om aan de slag te gaan.',
            emptyShared: 'Er zijn geen projecten met u gedeeld.',
            pageHint: 'Toont [[TOK_2]] van [[TOK_3]].',
            createTitle: 'Nieuw project',
            createSubmit: 'Project aanmaken',
            fieldName: 'Naam',
            fieldDescription: 'Beschrijving (optioneel)',
            fieldCmNumber: 'Zaak-/zaaknummer (optioneel)',
            fieldVisibility: 'Zichtbaarheid',
            errorNameRequired: 'Naam is vereist.',
            errorSelectorRequired: 'Selecteer een gebruiker of organisatiegroep die u wilt toevoegen.',
            renameButton: 'Hernoemen',
            renamePrompt: 'Projectnaam wijzigen',
            deleteButton: 'Verwijderen',
            deleteConfirm: 'Dit project verwijderen? Het wordt 30 dagen bewaard voordat het definitief wordt verwijderd.',
            deleteFolderConfirm: 'Deze map verwijderen? Documenten daarin blijven in het project, maar worden niet opgeslagen.',
            removeMemberConfirm: 'Dit lid verwijderen?',
            foldersHeading: 'Mappen',
            foldersEmpty: 'Nog geen mappen.',
            addFolderButton: 'Nieuwe map',
            addFolderTitle: 'Nieuwe map',
            documentsHeading: 'Documenten',
            documentsEmpty: 'Er zijn nog geen documenten bijgevoegd.',
            colFilename: 'Bestandsnaam',
            colAdded: 'Toegevoegd',
            unattachButton: 'Maak los',
            membersHeading: 'Leden',
            membersEmpty: 'Alleen eigenaar.',
            addMemberButton: 'Lid toevoegen',
            addMemberTitle: 'Lid toevoegen',
            addMemberSubmit: 'Lid toevoegen',
            colMember: 'Lid',
            colRole: 'Rol',
            selectorTypeLabel: 'Voeg toe door',
            selectorUser: 'Gebruikers-ID',
            selectorGroup: 'Organisatiegroep-ID',
            fieldUserId: 'Gebruiker',
            fieldGroupId: 'Org groep',
            fieldRole: 'Rol',
            roleAdmin: 'Beheerder',
            roleEditor: 'Redacteur',
            roleViewer: 'Kijker',
            notFound: 'Project niet gevonden.',
            selectUserPlaceholder: 'Selecteer een gebruiker…',
            selectGroupPlaceholder: 'Selecteer een organisatiegroep…',
            noUsersAvailable: 'Geen gebruikers beschikbaar.',
            noGroupsAvailable: 'Geen organisatiegroepen beschikbaar.',
            loadFailed: 'Kan opties niet laden.',
            deleteProjectTitle: 'Project verwijderen?',
            deleteFolderTitle: 'Map verwijderen?',
            removeMemberTitle: 'Lid verwijderen?',
            removeMemberConfirmGeneric: 'Dit lid uit het project verwijderen?',
            addDocumentButton: 'Document toevoegen',
            addDocumentTitle: 'Document toevoegen aan project',
            fieldDocument: 'Selecteer document',
            selectDocPlaceholder: 'Zoek een document...',
            ownerLabel: 'Systeemeigenaar',
        },
        chat: {
            sidebarLabel: 'Chats',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Uw [[TOK_0]] Juridisch en compliance-adviseur — gebaseerd op uw huurdergegevens en uw geïnstalleerde regelgevingspakketten.',
            personaSelectorLabel: 'Persoon',
            personaHeading: 'Kies een persoonlijkheid',
            startChatButton: 'Start een nieuw chatgesprek',
            startingChat: 'Chat starten…',
            recentHeading: 'Recente chats',
            recentEmpty: 'Nog geen chats: begin er hierboven één.',
            untitledChat: 'Nieuwe chat',
            messageListLabel: 'Gesprek',
            detailSubtitle: 'Persoon: [[TOK_1]]',
            composeHeading: 'Stuur een bericht',
            composeLabel: 'Bericht Forseti',
            composeDisabledPlaceholder: 'De berichtcompositie komt terecht in de volgende sprint (47.5.4b – SSE-streaming + tool-call-lus).',
            composeDisabledHint: 'Alleen-lezen preview verzonden in 47.5.4a. Streaming + tooloproepen komen terecht in 47.5.4b.',
            switchPersonaHeading: 'Persoon',
            presetPersona: 'Vooraf ingestelde persona',
            changePersona: 'Persona wijzigen',
            hidePersonaOptions: 'Personaopties verbergen',
            starterHeading: 'Begin met een van deze acties',
            renameButton: 'Hernoemen',
            renamePrompt: 'Chat hernoemen',
            deleteButton: 'Verwijderen',
            deleteConfirm: 'Deze chat verwijderen? Het wordt 30 dagen bewaard voordat het definitief wordt verwijderd.',
            notFound: 'Chat niet gevonden.',
            emptyChat: 'Nog geen berichten. Zeg hallo om een gesprek te beginnen.',
            roleUser: 'Jij',
            roleAssistant: 'Forseti',
            roleSystem: 'Systeem',
            thinkingLabel: 'Denken',
            toolCallPlaceholder: 'Gereedschapsoproep: ',
            toolResultPlaceholder: 'Toolresultaat verborgen: de volledige gebruikersinterface komt terecht in 47.5.4b.',
            docEditPlaceholder: 'Documentbewerkingen voorgesteld (V[[TOK_1]]).',
            disclaimer: 'Forseti ondersteunt uw oordeel; het vervangt geen bevoegde raadsman.',
            sendButton: 'Verzenden',
            sending: 'Verzenden…',
            composePlaceholder: 'Vraag Forseti…',
            composingPlaceholder: 'Forseti reageert…',
            streamingPlaceholder: 'Forseti is aan het typen…',
            promptInjectionTitle: 'Forseti liet enkele controlefiches vallen.',
            promptInjectionBody: 'Gestripte patronen: [[TOK_1]]. Forseti ziet alleen uw berichttekst.',
            promptInjectionInline: 'Forseti heeft controletokens ([TOK_1]]) uit je bericht verwijderd.',
            rateLimitTitle: 'Je verzendt berichten te snel.',
            rateLimitRetryAfter: 'Probeer het over [[TOK_1]]s opnieuw.',
            counselReviewTitle: 'Forseti is hier onzeker.',
            counselReviewBody: 'Neem contact op met een bevoegde raadsman voordat u op basis van dit antwoord handelt.',
            legalConclusionRefused: 'Forseti weigerde een juridische conclusie te trekken zonder grond. Probeer eerst search_regulatory of escaleer naar een raadsman.',
            toolCallDone: 'Klaar.',
            toolCallArgsLabel: 'Argumenten',
            toolCallResultLabel: 'Resultaat',
            toolResultLogged: 'Toolresultaat vastgelegd in auditlogboek.',
            toolResultAria: 'gereedschap resultaat',
            documentEditAria: 'document bewerken',
            createTaskFromMessage: 'Maak hier een taak van',
            createTaskHeading: 'Maak een taak op basis van dit bericht',
            createTaskTitleLabel: 'Titel',
            createTaskTitleRequired: 'Titel is vereist.',
            createTaskDescriptionLabel: 'Beschrijving',
            createTaskAssigneeLabel: 'Ontvanger',
            createTaskAssigneePlaceholder: 'Selecteer toegewezen…',
            createTaskAssigneeNone: '— niet toegewezen —',
            createTaskDueDateLabel: 'Vervaldatum',
            createTaskWorkflowLabel: 'Gekoppelde workflow (optioneel)',
            createTaskWorkflowPlaceholder: 'Selecteer een werkstroom...',
            createTaskWorkflowNone: '— geen —',
            renameModalSubmit: 'Hernoemen',
            renameModalSaving: 'Opslaan…',
            deleteConfirmTitle: 'Chat verwijderen?',
            createTaskSubmit: 'Taak maken',
            createTaskSubmitting: 'Creëren…',
            cancelButton: 'Annuleer',
            autoRouteHintMessage: 'Deze vraag ligt meer in de stuurhut van [[TOK_1]].',
            autoRouteSwitchButton: 'Schakel over naar [[TOK_1]]',
            autoRouteSwitching: 'Overstappen…',
            handoffSuggestionMessage: 'Of open een nieuwe chat met [[TOK_1]] en stel deze vraag.',
            handoffSuggestionButton: 'Start een nieuwe chat met [[TOK_1]]',
            handoffSuggestionWorking: 'Openen…',
            handoffSuggestionDismiss: 'Niet nu',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Compliance-specialist',
                'forseti-legal': 'Juridisch adviseur',
                'forseti-dpo': 'FG-adviseur',
                'forseti-risk': 'Risicoanalist',
                'forseti-auditor': 'Auditorblik',
            },
            exportButton: 'Exporteren als PDF',
            exportRunning: 'Exporteren…',
            exportSuccess: 'Geëxporteerd: {filename} (open de bestandsbrowser).',
            citation: {
                verifyBadge: '[VERIFIEER]',
                verifyAria: 'citaat kon niet worden geverifieerd - controleer het voordat u erop vertrouwt',
                popoverAria: 'Bron voor [[TOK_1]]',
                openSource: 'Open source-pagina',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: '[[TOK_0]]-gegenereerde gebeurtenis uit het Forseti-audittraject.',
        },
        rowAction: {
            ask: 'Vraag Forseti',
            tooltipOpen: 'Vraag Forseti hierover [[TOK_1]]',
            tooltipLocked: 'Deze [[TOK_1]] is vergrendeld — Forseti kan vragen beantwoorden, maar kan geen wijzigingen aanbrengen.',
        },
        advisorRunPanel: {
            title: 'Forseti — over deze plaat',
            heading: 'Forseti — [[TOK_1]]',
            summaryLabel: 'Samenvatting',
            suggestedPersona: 'Voorgestelde persona',
            askForseti: 'Vraag Forseti',
            runWorkflow: 'Voer een workflow uit',
            viewLineage: 'Bekijk de auditlijn',
            createPdplEvidencePack: 'PDPL-bewijspakket maken',
            prepareBreachDraft: 'Kennisgevingsconcept voorbereiden',
            primaryActions: {
                projectSummary: 'Projectdocument samenvatten',
                supplementSummary: 'Aanvullend verzoek samenvatten',
                authoritySummary: 'Autoriteitsverzoek samenvatten',
                rightsRequestResponse: 'DSR-antwoord opstellen',
                dpiaQuickReview: 'Snelle DPIA-review uitvoeren',
                taskControlWalkthrough: 'Controlebewijs doorlopen',
                vendorRiskNarrative: 'Leveranciersrisico-narratief genereren',
                incidentLetter: 'PDPL-inbreukbrief opstellen',
                ropaSufficiency: 'RoPA-toereikendheidscontrole uitvoeren',
                vendorDpaReview: 'Leveranciers-DPA-review uitvoeren',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'Forseti bereidt alleen conceptinhoud voor het gekoppelde Mẫu số 08 voor. Het beslist niet of melding vereist is en dient of verzendt het formulier niet.',
            breachDraftReady: 'Concept Mẫu số 08 klaar voor beoordeling',
            breachDraftReviewBeforeSelecting: 'Beoordelen vóór selectie',
            workflowHeading: 'Relevante workflows',
            workflowLoading: 'Relevante workflows laden…',
            workflowEmpty: 'Er zijn geen relevante workflows beschikbaar voor dit record.',
            workflowError: 'Kan relevante workflows niet laden.',
            selectWorkflow: '{title} selecteren',
            workflowSelected: 'Workflow geselecteerd. De inline-uitvoerder opent in de volgende stap.',
            workflowRunSelected: 'Geselecteerde workflow uitvoeren',
            workflowStarting: 'Workflow wordt gestart…',
            workflowRunError: 'Deze workflow kon niet worden gestart.',
            workflowQuotaExhausted: 'Uw Forseti-gebruiksquotum is te laag om deze workflow te starten.',
            workflowTopUp: 'Gebruik bekijken en een aanvulling aanvragen',
            workflowCreateGuided: 'Een begeleide workflow voor dit record maken',
            lineageHeading: 'Auditherkomst voor dit record',
            lineageLoading: 'Auditherkomst laden…',
            lineageEmpty: 'Er zijn geen Forseti-herkomstgebeurtenissen vastgelegd voor dit record.',
            lineageError: 'Kan auditherkomst niet laden.',
            retry: 'Opnieuw proberen',
            chatContextLoading: 'Recordcontext laden…',
            chatGuidance: {
                general: 'Forseti kan dit record samenvatten, ontbrekende informatie vaststellen en beoordelingsstappen voorstellen.',
                privacy: 'Forseti kan privacyfeiten beoordelen, verplichtingen uit geïnstalleerde kaders controleren en helpen een concept voor menselijke beoordeling op te stellen.',
                compliance: 'Forseti kan nalevingshiaten vaststellen, vereisten onderbouwen met geïnstalleerde bronnen en verantwoordelijke vervolgstappen voorstellen.',
                legal: 'Forseti kan het record samenvatten, onderbouwd bronmateriaal vinden en helpen een concept voor juridische beoordeling op te stellen.',
                risk: 'Forseti kan vastgelegde risico’s beoordelen, ontbrekende feiten markeren en evenredige beoordelingsstappen voorstellen.',
                audit: 'Forseti kan bewijshiaten onderzoeken, het record aan geïnstalleerde beheersmaatregelen koppelen en auditklare opvolging voorstellen.',
            },
            starterPrompts: {
                identifyGaps: 'Welke informatie of welk bewijs ontbreekt in dit record?',
                reviewFrameworks: 'Welke verplichtingen uit onze geïnstalleerde kaders moet ik voor dit record beoordelen?',
                prepareDraft: 'Help mij een concept op te stellen dat uitsluitend op dit record en onderbouwde geïnstalleerde bronnen is gebaseerd.',
                nextSteps: 'Welke beoordelingsstappen moet ik hierna nemen?',
                summarizeRecord: 'Vat dit record samen en markeer punten die door een mens moeten worden beoordeeld.',
                assessRisk: 'Beoordeel de vastgelegde risico’s, stel ontbrekende feiten vast en stel beoordelingsstappen voor.',
            },
            disclaimer: 'Forseti ondersteunt uw oordeel; het vervangt geen bevoegde raadsman.',
            recordType: {
                project: 'Project',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Dossierarchivering',
                transfer_assessment: 'Grensoverschrijdende overdracht',
                vendor: 'Verkoper',
                vendor_contract: 'Leverancierscontract',
                vendor_acceptance: "Acceptatie van leveranciersrisico's",
                incident: 'Voorval',
                incident_op: 'Incidentoperatie',
                breach_notification: 'Melding van inbreuk',
                authority_request: 'Autoriteitsverzoek',
                supplement_request: 'Aanvraag voor aanvulling',
                rights_request: 'Rechtenverzoek',
                contract: 'Contract',
                task: 'Taak',
                data_mapping_activity: 'RoPA-activiteit',
                compliance_rule: 'Nalevingsregel',
                program: 'Programma',
                governance_document: 'Bestuursdocument',
                remediation_plan: 'Saneringsplan',
                cross_border_filing: 'Grensoverschrijdende indiening',
            },
        },
        autocomplete: {
            button_label: 'Vraag Forseti om dit op te stellen',
            drafting: 'Opstellen…',
            hint_pick_activity: 'Kies een gekoppelde verwerkingsactiviteit om het opstellen van Forseti mogelijk te maken.',
            draft_origin_label: 'Forseti-concept — beoordeling per veld',
            tokens_label: '≈ [[TOK_1]] tokens uit uw maandelijkse bucket',
            accept_selected: 'Accepteer geselecteerd',
            reject_all: 'Concept afwijzen',
            field_checkbox_label: 'Forseti-concept toepassen voor [[TOK_1]]',
            field_labels: {
                description: 'Beschrijving',
                purpose: 'Doel',
                data_subjects: 'Betrokkenen',
                data_types: 'Gegevenstypen',
                necessity_justification: 'Noodzaak & proportionaliteit',
                consultation_notes: 'Aantekeningen bij overleg',
                dpo_opinion: '[[TOK_0]] mening',
                system_ids: 'Gekoppelde systemen',
                vendor_ids: 'Gekoppelde leveranciers',
            },
            error_generic: 'Forseti kon dit [[TOK_0]] niet opstellen. Probeer het opnieuw of verfijn het activiteitenrecord.',
            variant_legend: 'Kaderframe',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'ISO27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Let op: [[TOK_1]] raamwerkoverschrijdende conflicten zijn van toepassing op deze variant. Controleer voordat u deze accepteert.',
        },
        tia: {
            button_label: 'Vraag Forseti om deze TIA op te stellen',
            drafting: 'TIA opstellen…',
            hint_pick_destination: 'Stel het land van bestemming in het overdrachtsrecord in voordat Forseti kan opstellen.',
            draft_origin_label: 'Forseti TIA-concept — beoordeling per veld',
            tokens_label: '≈ [[TOK_1]] tokens uit uw maandelijkse bucket',
            accept_selected: 'Accepteer geselecteerd',
            reject_all: 'Concept afwijzen',
            field_checkbox_label: 'Forseti-concept toepassen voor [[TOK_1]]',
            error_generic: 'Forseti kon deze TIA niet opstellen. Probeer het opnieuw of verfijn het overdrachtsrecord.',
            usage_details: 'AI-gebruiksdetails',
            applied_status: 'Concept geaccepteerd. Controleer de ingevulde velden en selecteer vervolgens Bijwerken.',
            recommended_updates_title: 'Aanbevolen recordupdates',
            mechanism_recommendation: 'Overdrachtsmechanisme: {value}',
            dpo_signoff_recommendation: 'Vereis goedkeuring van de DPO voor deze gevoelige overdracht.',
            review_date_warning: 'Stel een beoordelingstermijn in voordat u deze gevoelige overdracht bijwerkt.',
            processing_activity_warning: 'Koppel ten minste één verwerkingsactiviteit / ROPA-record voordat u de TIA voltooit.',
            go_to_field: 'Ga naar veld',
            adequacy_label: 'Bestemmingsregime',
            adequacy_status_adequacy_decision: 'Adequaatheidsbesluit',
            adequacy_status_non_adequacy_with_sccs: "Niet-adequaatheid — SCC's vereist",
            adequacy_status_derogation: 'Artikel 49 afwijking',
            adequacy_status_transitional: 'Overgangs-/EER-snelkoppeling',
            adequacy_status_unknown: 'Onbekend: stel de bestemming in',
            conflict_banner: 'Let op: [[TOK_1]] Kaderoverschrijdende conflicten zijn van toepassing op dit overdrachtsregime. Controleer voordat u deze accepteert.',
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Ontbrekende vereiste gegevens',
            missing_facts_hint: 'Forseti markeerde gegevens die niet in het record staan. Velden die ervan afhangen, zijn niet vooraf geselecteerd — vul de gegevens aan of accepteer het veld bewust.',
            risk_label: 'Gekalibreerd risico',
            risk_low: 'Laag',
            risk_medium: 'Gemiddeld',
            risk_high: 'Hoog',
            jurisdiction_label: 'Jurisdictietriggers',
            jurisdiction_gdpr: 'AVG',
            jurisdiction_vn_pdpl: 'PDPL (Vietnam)',
            trigger_applicable: 'Van toepassing',
            trigger_not_applicable: 'Niet getriggerd',
            trigger_unknown: 'Onbekend — gegeven ontbreekt',
            recipient_role_label: 'Rol van de ontvanger',
            recipient_role_controller: 'Verwerkingsverantwoordelijke',
            recipient_role_processor: 'Verwerker',
            recipient_role_joint_controller: 'Gezamenlijke verwerkingsverantwoordelijke',
            recipient_role_unknown: 'Onbekend — niet vermeld',
            opt_in_hint: 'Juridische conclusie — selecteer alleen als u deze accepteert met de beschikbare feiten.',
        },
        mcp: {
            pageTitle: 'MCP-connectorsleutels',
            pageSubtitle: 'Geef [[TOK_0]]-sleutels uit zodat externe Claude-clients alleen-lezen Forseti-tools kunnen aanroepen (regelgevend zoeken, document lezen, module zoeken). Fase 1 — alleen-lezen. Schrijftools landen in 48.3.0.',
            issueButton: 'Nieuwe sleutel uitgeven',
            issueModalTitle: 'MCP-sleutel [[TOK_0]] uitgeven',
            labelField: 'Etiket',
            labelHint: 'Een korte beschrijving (bijvoorbeeld "[[TOK_0]] capaciteitslaboratorium — regelgevingsonderzoek").',
            permittedToolsField: 'Toegestane gereedschappen',
            expiresAtField: 'Verloopt (optioneel)',
            expiresAtHint: "Laat dit leeg voor 'verloopt nooit'.",
            submit: 'Sleutel uitgeven',
            cancel: 'Annuleer',
            keyDisplayedOnce: 'Kopieer deze sleutel nu. U kunt deze NIET meer zien. Bewaar het in uw geheime manager (1Password, AWS Secrets Manager, Vault, etc.).',
            keyDisplayedOnceClose: 'Ik heb het gekopieerd - sluit',
            colLabel: 'Etiket',
            colPrefix: 'Voorvoegsel',
            colStatus: 'Status',
            colTools: 'Gereedschap',
            colCreatedAt: 'Gemaakt',
            colLastUsed: 'Laatst gebruikt',
            colCalls: 'Oproepen',
            colActions: 'Acties',
            statusActive: 'Actief',
            statusRevoked: 'Ingetrokken',
            statusExpired: 'Verlopen',
            revokeAction: 'Intrekken',
            rotateAction: 'Draaien',
            confirmRevokeTitle: 'Deze MCP-sleutel intrekken?',
            confirmRevokeBody: 'Externe Claude-klanten die deze sleutel gebruiken, verliezen onmiddellijk de toegang. Dit kan niet ongedaan worden gemaakt.',
            confirmRevoke: 'Sleutel intrekken',
            rotatedTitle: 'Sleutel gedraaid',
            rotatedBody: 'De nieuwe leesbare tekstsleutel staat hieronder. De oude sleutel blijft nog 5 minuten werken, zodat eventuele gesprekken tijdens de vlucht worden beëindigd.',
            emptyState: 'Er zijn nog geen MCP-sleutels uitgegeven.',
            errorIssue: 'Kan de MCP-sleutel niet uitgeven.',
            errorList: 'Kan MCP-sleutels niet laden.',
            errorRevoke: 'Kan de sleutel niet intrekken.',
            errorRotate: 'Kan de sleutel niet draaien.',
            neverUsed: '—',
            neverExpires: 'Nooit',
        },
        memory: {
            pageTitle: 'Forseti-geheugen',
            pageSubtitle: 'Blader door en beheer de organisatiespecifieke context die Forseti heeft verzameld in gesprekken en beslissingen. Gecureerde inzendingen zijn beveiligd tegen nachtelijke retentie en blijven beschikbaar voor elke persona.',
            filterCategory: 'Categorie',
            filterAllCategories: 'Alle categorieën',
            totalCount: '[[TOK_1]] vermeldingen',
            colAnchor: 'Anker',
            colCategory: 'Categorie',
            colSource: 'Bron',
            colContent: 'Inhoud',
            colCreatedAt: 'Gemaakt',
            colActions: 'Acties',
            editButton: 'Bewerken',
            deleteButton: 'Verwijderen',
            promoteButton: 'Promoot tot samengesteld',
            emptyState: 'Nog geen herinneringen: Forseti verzamelt context terwijl je chat.',
            categories: {
                framework_interpretation: 'Kaderinterpretatie',
                process_preference: 'Procesvoorkeur',
                escalation_threshold: 'Escalatiedrempel',
                decision_context: 'Beslissingscontext',
                glossary_term: 'Verklarende term',
                auto_inferred: 'Automatisch afgeleid',
            },
            sources: {
                admin_curated: 'Samengesteld',
                user_explicit: 'Expliciet',
                auto: 'Afgeleid',
            },
            deleteConfirmTitle: 'Deze herinnering verwijderen?',
            deleteConfirmBody: 'Als u verwijdert, wordt dit anker verwijderd uit elke toekomstige Forseti-chatboot. Anker: [[TOK_1]]',
            deleteConfirmLabel: 'Verwijderen',
            deleteCancelLabel: 'Annuleer',
            editModalTitle: 'Geheugen bewerken',
            editAnchorLabel: 'Anker',
            editCategoryLabel: 'Categorie',
            editContentLabel: 'Inhoud',
            editContentCount: '[[TOK_2]]/[[TOK_3]] tekens',
            editEmptyError: 'Inhoud mag niet leeg zijn.',
            editTooLongError: 'Inhoud moet ≤1000 tekens bevatten.',
            editAutoPromoteHint: 'Als u dit automatisch afgeleide geheugen opslaat, wordt het gemarkeerd als door de gebruiker bevestigd en verwijderd uit de retentiecontrole.',
            editCancelButton: 'Annuleer',
            editSaveButton: 'Opslaan',
            editSaving: 'Opslaan…',
        },
        auditLineage: {
            title: 'Audit-afstamming',
            subtitle: 'Traceer elk [[TOK_0]]-gegenereerd artefact dat aan een record is gekoppeld. Chats, tooloproepen, taken, bewijsconcepten en documentversies.',
            filterForm: 'Filters',
            recordType: 'Recordtype',
            recordId: 'Record-ID',
            dateStart: 'Van',
            dateEnd: 'Aan',
            search: 'Zoeken',
            loading: 'Laden…',
            exportPdf: 'Exporteer [[TOK_0]]',
            exportCsv: 'Exporteer [[TOK_0]]',
            nodesHeading: 'Afstammingsknooppunten',
            colType: 'Typ',
            colLabel: 'Etiket',
            colOccurredAt: 'Voorgekomen bij',
            colActor: 'Acteur',
            colId: 'Identiteitskaart',
            noResults: 'Geen adviseuractiviteit voor deze record.',
            draftBadge: '[[TOK_0]] gegenereerd concept',
            prev: 'Vorige',
            next: 'Volgende',
            viewToggleTable: 'Bekijk als tafel',
            viewToggleGraph: 'Bekijk als grafiek',
            graphAriaLabel: 'Afstammingsgrafiek (visueel). Gebruik de tabelweergave voor ondersteunende technologie.',
            graphLegendDraft: 'Concept van [[TOK_0]] bewijsmateriaal',
            graphEmpty: 'Geen knooppunten om te tekenen.',
            paginationAriaLabel: 'Paginering',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_3]]',
            exportErrorTemplate: 'Exporteren mislukt: [[TOK_1]]',
            recordTypes: {
                project: 'Project',
                dpia: '[[TOK_0]]',
                vendor: 'Verkoper',
                incident: 'Voorval',
                incident_op: 'Incidentoperatie',
                rights_request: 'Rechten verzoek',
                contract: 'Contract',
                task: 'Taak',
                data_mapping_activity: 'Activiteit voor het in kaart brengen van gegevens',
                compliance_rule: 'Nalevingsregel',
                program: 'Programma',
            },
            nodeTypes: {
                chat: 'Chatten',
                tool_call: 'Gereedschapsoproep',
                workflow_run: 'Workflow uitgevoerd',
                task: 'Taak',
                evidence: 'Bewijs',
                document_version: 'Documentversie',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: 'Oké',
                drifted: 'Afgedreven',
                hash_mismatch: 'Hasj-mismatch',
                merkle_mismatch: 'Merkle-mismatch',
                source_missing: 'Bron ontbreekt',
                not_found: 'Niet gevonden',
                chain_unreachable: 'Keten onbereikbaar',
                service_unreachable: 'Dienst onbereikbaar',
                pending: 'In afwachting van verankering',
            },
        },
        evidenceDraft: {
            draftBadge: '[[TOK_0]]-gegenereerd DRAFT',
            pendingReviewBadge: 'In afwachting van beoordeling',
            approvedBadge: 'Goedgekeurd',
            rejectedBadge: 'Afgewezen',
            moveToReviewButton: 'Markeer klaar voor beoordeling',
            approveButton: 'Goedkeuren',
            rejectButton: 'Afwijzen',
            rejectReasonLabel: 'Reden van afwijzing',
            humanSignoffBanner: 'Forseti ondersteunt uw oordeel; het vervangt geen bevoegde raadsman. [[TOK_0]]-gegenereerd bewijs vereist menselijke goedkeuring voordat het als formeel bewijs geldt.',
            pageTitle: '[[TOK_0]] bewijsconcepten',
            pageSubtitle: 'Beoordeel, keur goed of wijs [[TOK_0]]-gegenereerd bewijsmateriaal af. Concepten moeten door een mens worden goedgekeurd voordat ze als formeel bewijs gelden.',
            filterAll: 'Allemaal uitvoerbaar',
            filterDrafts: 'Alleen concepten',
            filterPending: 'In afwachting van beoordeling',
            filterApproved: 'Recent goedgekeurd',
            filterRejected: 'Onlangs afgewezen',
            colId: 'Bewijs-ID',
            colStatus: 'Status',
            colSource: 'Bron',
            colCreatedAt: 'Gemaakt',
            colActions: 'Acties',
            empty: 'Geen [[TOK_0]] bewijsconcepten in deze status.',
            confirmApprove: 'Dit door [TOK_0]] gegenereerde bewijsmateriaal als formeel goedkeuren?',
            confirmReject: 'Wijs dit bewijsconcept af. Dit kan niet ongedaan worden gemaakt.',
            reasonRequired: 'Er is een afwijzingsreden vereist.',
            rejectModalTitle: 'Ontwerpbewijsmateriaal afwijzen',
            approveModalTitle: 'Conceptbewijs goedkeuren',
            operationFailed: 'Operatie mislukt. Probeer het opnieuw.',
            moveToReviewSuccess: 'Gemarkeerd als gereed voor beoordeling.',
            approveSuccess: 'Goedgekeurd.',
            rejectSuccess: 'Afgewezen.',
            sourceLabelWorkflowRunTitle: 'Werkstroom: [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Workflowuitvoering [[TOK_1]]',
            sourceLabelChatTitle: 'Chatten: [[TOK_1]]',
            sourceLabelChatId: 'Forseti-chat [[TOK_1]]',
            sourceLabelEmpty: '—',
            filtersAriaLabel: 'Filterstatus',
        },
        workflows: {
            pageTitle: 'AI-workflows',
            pageSubtitle: 'Opgeslagen AI-promptsjablonen die taken en conceptbewijs produceren.',
            newWorkflow: 'Nieuwe workflow',
            newWorkflowHeading: 'Nieuwe AI-workflow',
            tabAll: 'Alle',
            tabBuiltin: 'Ingebouwd pakket',
            tabMine: 'Mijn workflows',
            tabDetail: 'Details',
            tabLinkedTasks: 'Gekoppelde taken',
            builtinBadge: 'Ingebouwd',
            builtinSubtitle: 'Ingebouwde workflow.',
            userSubtitle: 'Aangepaste workflow.',
            emptyHint: 'Nog geen workflows.',
            loadTimeoutError: 'Kon workflows na 10 seconden niet laden. Probeer opnieuw, of controleer het Netwerktabblad van de browser op een vastlopend verzoek.',
            loadError: 'Kon workflows niet laden.',
            hideError: 'Verbergen mislukt.',
            unhideError: 'Tonen mislukt.',
            retry: 'Opnieuw proberen',
            producesTasks: 'Produceert taken',
            producesEvidence: 'Produceert conceptbewijs',
            hideButton: 'Verbergen uit mijn lijst',
            unhideButton: 'Tonen',
            runButton: 'Uitvoeren',
            editButton: 'Bewerken',
            shareButton: 'Delen',
            backToList: 'Terug naar lijst',
            requireTitleAndPrompt: 'Titel en prompt zijn vereist.',
            fieldTitle: 'Titel',
            fieldDescription: 'Beschrijving',
            fieldType: 'Typ',
            fieldPersona: 'Persona-affiniteit',
            fieldPractice: 'Praktijk',
            fieldPrompt: 'Prompt (Markdown)',
            fieldProducesTasks: 'Produceert taken',
            fieldProducesEvidence: 'Produceert conceptbewijs',
            fieldProjectId: 'Project (optioneel)',
            fieldAttachmentIds: 'Bijlagen',
            fieldParentRecord: 'Bovenliggend record (optioneel)',
            fieldPersonaOverride: 'Persona-overschrijving (optioneel)',
            typeAssistant: 'Assistent',
            typeTabular: 'Tabelvormig',
            personaNone: '— geen —',
            parentNone: '— geen —',
            parentIdPlaceholder: 'ID van bovenliggend record',
            selectProjectPlaceholder: 'Selecteer een project…',
            selectProjectFirst: 'Selecteer een project om bijlagen te kiezen.',
            selectAttachmentsPlaceholder: 'Selecteer documenten…',
            noAttachmentsInProject: 'Dit project heeft geen bijgevoegde documenten.',
            selectParentRecordPlaceholder: 'Selecteer een record…',
            selectParentRecordFirst: 'Selecteer eerst een recordtype.',
            noRecordsForType: 'Geen records van dit type beschikbaar.',
            shareUserSelectorLabel: 'Ontvangers (gebruikers)',
            shareGroupSelectorLabel: 'Ontvangers (organisatiegroepen)',
            selectUsersPlaceholder: 'Selecteer gebruikers…',
            selectOrgGroupsPlaceholder: 'Selecteer organisatiegroepen…',
            loadingOptions: 'Laden…',
            loadFailed: 'Kon opties niet laden.',
            parentRecordTypes: {
                dpia: 'DPIA',
                vendor: 'Leverancier',
                incident: 'Voorval',
                rights_request: 'Rechtenverzoek',
                contract: 'Contract',
                data_mapping_activity: 'RoPA-activiteit',
                compliance_rule: 'Compliance-regel',
                program: 'Programma',
            },
            cancelButton: 'Annuleren',
            closeButton: 'Sluiten',
            createButton: 'Aanmaken',
            creating: 'Aanmaken…',
            saveButton: 'Opslaan',
            saving: 'Opslaan…',
            shareWorkflowHeading: 'Workflow delen',
            shareIntro: 'Delen: {title}',
            shareUserIds: "Gebruikers-ID's (gescheiden door spatie of komma)",
            shareGroupIds: "Organisatiegroep-ID's (gescheiden door spatie of komma)",
            shareAllowEdit: 'Ontvangers toestaan te bewerken',
            shareRequireRecipient: 'Geef ten minste één gebruikers-ID of groeps-ID op.',
            shareSuccess: 'Gedeeld.',
            sharing: 'Delen…',
            runWorkflowHeading: 'Uitvoeren: {title}',
            runStarting: 'Starten…',
            runStatusLabel: 'Status: [[TOK_1]]',
            runProducedCounts: 'Taken: {tasks} · Conceptbewijs: {evidence}',
            runPanelHeading: 'Workflowuitvoering',
            runPanelHeadingWithTitle: 'Workflowuitvoering: {title}',
            runViewTasks: 'Gegenereerde taken bekijken',
            runLoadFailed: 'De workflowuitvoering kon niet worden geladen.',
            runStreamFailed: 'De verbinding met de workflowvoortgang is mislukt.',
            runStatusValues: {
                pending: 'In behandeling',
                running: 'Wordt uitgevoerd',
                completed: 'Voltooid',
                succeeded: 'Geslaagd',
                failed: 'Mislukt',
                cancelled: 'Geannuleerd',
            },
            runProgressStatus: 'Status: [[TOK_1]]',
            runProgressTaskCreated: 'Taak aangemaakt.',
            runProgressEvidenceDrafted: 'Conceptbewijs aangemaakt.',
            runProgressAttachmentGenerated: 'Bijlage gegenereerd.',
            guidedWorkflowTitle: 'Begeleide workflow voor {recordType}',
            guidedWorkflowDescription: 'Gemaakt voor records van het type {recordType}. Beoordeel en pas deze workflow aan voordat u hem opslaat.',
            guidedWorkflowPrompt: 'Beoordeel het aangeleverde record van het type {recordType}, stel ontbrekende feiten vast en stel onderbouwde vervolgstappen voor menselijke beoordeling voor.',
            costHint: 'Vooraf-quotumcontrole wordt uitgevoerd bij verzending; uitvoeringen boven het quotum geven 402 terug met een aanvul-CTA.',
            quotaExhausted: 'Token-bucket laag. Vul aan voor opnieuw uitvoeren.',
            promptHeading: 'Prompt',
            editWorkflowHeading: 'Workflow bewerken',
            linkedTasksHint: 'Taken die door deze workflow zijn aangemaakt, verschijnen in de takenlijst gefilterd op deze workflow-ID. Kruisverwijzing arriveert in 47.5.8.',
            notFound: 'Workflow niet gevonden.',
            schedules: {
                tabTitle: "Schema's",
                sectionHeading: 'Geplande uitvoeringen',
                empty: "Nog geen schema's. Maak er een aan om deze workflow automatisch uit te voeren.",
                addButton: 'Schema toevoegen',
                addHeading: 'Workflow plannen',
                editHeading: 'Schema bewerken',
                fieldFrequency: 'Frequentie',
                fieldDayOfWeek: 'Dag van de week',
                fieldDayOfMonth: 'Dag van de maand',
                fieldTime: 'Tijd (UTC)',
                fieldTimezone: 'Tijdzone',
                fieldProject: 'Project (optioneel)',
                fieldAttachments: 'Standaardbijlagen',
                fieldPersonaOverride: 'Persona-overschrijving (optioneel)',
                frequencyDaily: 'Dagelijks',
                frequencyWeekly: 'Wekelijks',
                frequencyMonthly: 'Maandelijks',
                weekdaySun: 'Zondag',
                weekdayMon: 'Maandag',
                weekdayTue: 'Dinsdag',
                weekdayWed: 'Woensdag',
                weekdayThu: 'Donderdag',
                weekdayFri: 'Vrijdag',
                weekdaySat: 'Zaterdag',
                statusActive: 'Actief',
                statusPaused: 'Gepauzeerd',
                nextRunLabel: 'Volgende uitvoering',
                lastRunLabel: 'Laatste uitvoering',
                pauseButton: 'Pauzeren',
                resumeButton: 'Hervatten',
                deleteButton: 'Verwijderen',
                triggerButton: 'Nu uitvoeren',
                savingButton: 'Opslaan…',
                saveButton: 'Opslaan',
                triggered: 'Uitvoering gestart — controleer de uitvoeringsgeschiedenis.',
            },
            branching: {
                helpHeading: 'Voorwaardelijke prompt-syntaxis',
                helpBody: 'Gebruik {% if attachment.framework_code == "vn-pdpl" %}…{% endif %} om de prompt per context te variëren. Toegestane variabelen: attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Geneste {% if %}-blokken worden niet ondersteund.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Conflicten tussen kaders',
            pageSubtitle: 'Samengestelde catalogus van waar uw geïnstalleerde regelgevingspakketten op conflicterende manieren met elkaar omgaan. Forseti-oppervlakken; mensen beslissen.',
            noInstalledPacks: 'Er zijn geen regelgevingspakketten geïnstalleerd voor deze organisatie. Installeer ten minste twee pakketten om cross-framework-conflicten aan het licht te brengen.',
            noConflicts: 'Er zijn geen conflicten die overeenkomen met de huidige filters.',
            allAcknowledged: 'Elk zichtbaar conflict is erkend. Leuk werk.',
            columnSeverity: 'Ernst',
            columnTitle: 'Titel',
            columnFrameworks: 'Kaders',
            columnTopic: 'Onderwerp',
            columnStatus: 'Status',
            filterFrameworkPlaceholder: 'Alle kaders',
            filterTopicPlaceholder: 'Alle onderwerpen',
            filterSeverityPlaceholder: 'Alle ernst',
            filterStatusPlaceholder: 'Alle statussen',
            filterStatusAcknowledged: 'Erkend',
            filterStatusUnacknowledged: 'Niet erkend',
            severityCritical: 'Kritisch',
            severityHigh: 'Hoog',
            severityMedium: 'Middelmatig',
            severityLow: 'Laag',
            statusAcknowledged: 'Erkend',
            statusInReview: 'Wordt beoordeeld',
            statusResolved: 'Opgelost',
            statusWontFix: 'Zal niet oplossen',
            statusUnacknowledged: 'Niet erkend',
            drawerSummaryHeading: 'Samenvatting',
            drawerSideAHeading: 'Kant A',
            drawerSideBHeading: 'Kant B',
            drawerRequirementsLabel: 'Vereisten genoemd',
            drawerSuggestedResolutionHeading: 'Voorgestelde resolutie',
            drawerLegalCounselBadge: 'Beoordeling door een juridisch adviseur vereist',
            drawerAckHeading: 'Erkenning',
            drawerAckStatusLabel: 'Status',
            drawerAckAssigneeLabel: 'Toegewezen aan',
            drawerAckDueDateLabel: 'Vervaldatum',
            drawerAckNotesLabel: 'Opmerkingen',
            drawerAckButtonAcknowledge: 'Erken',
            drawerAckButtonUpdate: 'Bijwerken',
            drawerAckButtonUnacknowledge: 'Bevestiging ongedaan maken',
            searchPlaceholder: 'Titel of samenvatting zoeken…',
            searchButton: 'Zoeken',
            searchButtonAriaLabel: 'Voer een conflictzoekopdracht uit',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]]: [[TOK_1]]',
            exportErrorTemplate: 'Exporteren mislukt: [[TOK_1]]',
            exportAriaLabel: 'Conflicten exporteren',
        },
        tabularReviews: {
            pageTitle: 'Tabellarische beoordelingen',
            pageSubtitle: 'Vergelijk N documenten over M attributen met onderbouwde citaten.',
            newReview: 'Nieuwe beoordeling',
            newReviewHeading: 'Nieuwe tabellarische beoordeling',
            emptyHint: 'Nog geen tabellarische beoordelingen.',
            docsLabel: '{n} documenten',
            colsLabel: '{n} kolommen',
            detailSubtitle: '{docs} documenten · {cols} kolommen',
            addColumn: 'Kolom toevoegen',
            addColumnHeading: 'Kolom toevoegen',
            columnInfo: 'Prompt en formaat tonen',
            columnInfoAria: 'Prompt en formaat voor kolom {name} tonen',
            columnInfoPrompt: 'Prompt',
            columnInfoFormat: 'Retourformaat',
            columnInfoPresets: 'Toegestane waarden',
            columnInfoCitations: 'Citaten',
            columnInfoCitationsRequired: 'Vereist',
            removeColumn: 'Kolom verwijderen',
            removeColumnAria: 'Kolom {name} verwijderen',
            removeColumnConfirm: 'Kolom "{name}" verwijderen? De geëxtraheerde cellen worden verwijderd.',
            deleteReview: 'Verwijderen',
            deleteReviewAria: 'Beoordeling {title} verwijderen',
            deleteReviewConfirm: 'Beoordeling "{title}" verwijderen? Hiermee worden de kolommen, cellen en discussies permanent verwijderd.',
            runAll: 'Alles uitvoeren',
            running: 'Wordt uitgevoerd…',
            cancel: 'Annuleren',
            exportXlsx: 'Excel exporteren',
            exportCsv: 'CSV exporteren',
            exporting: 'Exporteren…',
            backToList: 'Terug naar lijst',
            notFound: 'Tabellarische beoordeling niet gevonden.',
            noDocuments: 'Voeg documenten toe om de beoordeling te starten.',
            noColumns: 'Voeg kolommen toe om te definiëren wat moet worden geëxtraheerd.',
            tableAriaLabel: 'Extractieraster',
            threadsCountAria: '{n} discussiebericht(en)',
            startDiscussionAria: 'Discussie starten',
            docColumn: 'Documenteren',
            statusPending: 'In behandeling',
            statusRunning: 'Wordt uitgevoerd…',
            statusFailed: 'Mislukt: {msg}',
            statusCancelled: 'Geannuleerd',
            citationsCount: '{n} citaat/citaten',
            citationsView: 'Bronpassages bekijken',
            citationPage: 'Pagina {n}',
            titleRequired: 'Titel is vereist.',
            fieldTitle: 'Titel',
            fieldProjectId: 'Project (optioneel)',
            fieldAttachmentIds: 'Bijlagen',
            fieldColumnName: 'Kolomnaam',
            fieldColumnNameHelp: 'Een kort, beschrijvend label voor deze kolom in het extractierooster.',
            columnNamePlaceholder: 'bijv. Startdatum contract',
            fieldExtractionPrompt: 'Extractieprompt',
            fieldExtractionPromptHelp: 'Beschrijf de informatie die u wilt extraheren. Wees specifiek voor betere resultaten.',
            columnPromptPlaceholder: 'Waar moet Forseti in de documenten naar zoeken?',
            fieldReturnFormat: 'Retourformaat',
            fieldReturnFormatHelp: 'Bepaalt hoe de AI het antwoord opmaakt (bijv. als datum of getal).',
            fieldPresets: 'Toegestane waarden (één per regel)',
            fieldPresetsPlaceholder: 'ja\nnee\ngedeeltelijk',
            fieldCitationsRequired: 'Citaat vereist',
            formatShortText: 'Korte tekst',
            formatLongText: 'Lange tekst',
            formatEnum: 'Enum',
            formatNumber: 'Getal',
            formatDate: 'Datum',
            formatList: 'Lijst',
            columnRequireFields: 'Naam en prompt zijn vereist.',
            addColumnError: 'Kolom toevoegen mislukt.',
            cancelButton: 'Annuleren',
            createButton: 'Aanmaken',
            creating: 'Aanmaken…',
            addButton: 'Toevoegen',
            adding: 'Toevoegen…',
            runConfirmHeading: 'Extractie uitvoeren',
            estimateBody: 'Geschat ~{units} factureerbare eenheden ({confidence} vertrouwen).',
            costHint: 'Vooraf-quotumcontrole wordt uitgevoerd bij bevestiging; uitvoeringen boven het quotum geven 402 terug met een aanvul-CTA.',
            quotaExhausted: 'Token-bucket laag. Vul aan voor opnieuw uitvoeren.',
            starting: 'Starten…',
            confirmRun: 'Uitvoering bevestigen',
            charts: {
                title: 'Kolomgrafieken',
                tabsAria: 'Grafiekkolommen',
                enumAria: 'Verdeling van enum-waarden',
                numberAria: 'Histogram van getalverdeling',
                dateAria: 'Datumtijdlijn',
                enumEmpty: 'Geen voltooide cellen.',
                numberEmpty: 'Geen numerieke waarden.',
                numberExcluded: '{n} cel(len) uitgesloten (leeg / niet-numeriek / niet voltooid).',
                dateEmpty: 'Geen datumwaarden.',
                dateExcluded: '{n} cel(len) uitgesloten.',
                unsupportedFormat: 'Niet-ondersteund kolomformaat.',
            },
            threads: {
                drawerTitle: 'Discussie',
                loading: 'Laden…',
                empty: 'Nog geen berichten. Start het gesprek.',
                composerLabel: 'Nieuwe opmerking',
                composerPlaceholder: 'Een opmerking toevoegen…',
                post: 'Plaatsen',
                posting: 'Plaatsen…',
                edit: 'Bewerken',
                editLabel: 'Bericht bewerken',
                delete: 'Verwijderen',
                save: 'Opslaan',
                cancel: 'Annuleren',
                close: 'Sluiten',
                editedBadge: 'bewerkt',
                loadError: 'Kon thread niet laden',
                postError: 'Kon niet plaatsen',
                editError: 'Kon niet bewerken',
                deleteError: 'Kon niet verwijderen',
            },
            compare: {
                pageTitle: 'Beoordelingen vergelijken',
                leftReviewLabel: 'Linker beoordeling',
                rightReviewLabel: 'Rechter beoordeling',
                pickReview: 'Kies een beoordeling om te vergelijken',
                noSharedDocuments: 'Deze beoordelingen delen geen documenten — vergelijking vereist ten minste één gemeenschappelijke bijlage.',
                sharedDocumentsHeading: 'Gedeelde documenten',
                leftOnlyHeading: 'Kolommen alleen in de linker beoordeling',
                rightOnlyHeading: 'Kolommen alleen in de rechter beoordeling',
                differs: 'Verschilt',
                identical: 'Identiek',
                emptyValue: '—',
                compareButton: 'Vergelijken met…',
                documentHeading: 'Documenteren',
                errorMissingIds: "Zowel linker als rechter beoordelings-ID's zijn vereist.",
                errorComparisonFailed: 'Vergelijking mislukt.',
                errorLoadFailed: 'Kon beoordelingen niet laden.',
                pickerLoading: 'Laden…',
                pickerNoOtherReviews: 'Geen andere beoordelingen beschikbaar om mee te vergelijken.',
                pickerCancel: 'Annuleren',
            },
        },
        documentReview: {
            pageTitle: 'Documentbeoordeling',
            pageSubtitle: 'Accepteer of wijs [[TOK_0]] voorgestelde bewerkingen van dit document af.',
            sidePanelLabel: '[[TOK_0]] rode lijnen',
            sidePanelHeading: '[[TOK_0]] rode lijnen',
            noPendingEdits: 'Geen bewerkingen in behandeling.',
            pendingCount: '[[TOK_1]] in behandeling',
            acceptAllButton: 'Accepteer alles',
            rejectAllButton: 'Alles afwijzen',
            acceptAllTitle: 'Alle openstaande bewerkingen accepteren?',
            acceptAllConfirm: 'Hiermee worden [[TOK_1]] openstaande bewerkingen geaccepteerd en een of meer nieuwe versies gemaakt. Doorgaan?',
            editsHeading: 'Bewerkingen',
            editsEmpty: 'Geen bewerkingen om te beoordelen.',
            versionsHeading: 'Versiegeschiedenis',
            versionsEmpty: 'Nog geen versies.',
            editLabel: 'Bewerken',
            editLabelWithId: 'Bewerken #{id}',
            acceptButton: 'Accepteer',
            rejectButton: 'Afwijzen',
            accepting: 'Accepteren…',
            rejecting: 'Afwijzen…',
            diffDeletedAria: 'Verwijderd',
            diffInsertedAria: 'Ingevoegd',
            statusPending: 'In behandeling',
            statusAccepted: 'Geaccepteerd',
            statusRejected: 'Afgewezen',
            versionLabel: 'Versie',
            versionAriaLabel: 'Versie {n}',
            versionAriaLabelCurrent: 'Versie {n} ({current})',
            versionCurrentTag: 'actueel',
            versionSourceLabel: 'Bron',
            versionCreatedLabel: 'Gemaakt',
            versionModelLabel: 'Model',
            sourceUpload: 'Uploaden',
            sourceUserUpload: 'Gebruikersupload',
            sourceAssistantEdit: 'Assistent bewerken',
            sourceUserAccept: 'Gebruiker heeft bewerking geaccepteerd',
            sourceUserReject: 'Gebruiker heeft bewerking afgewezen',
            sourceGenerated: 'Gegenereerd',
        },
        documentReviewIndex: {
            sidebarLabel: 'Documentbeoordeling',
            pageTitle: 'Documentbeoordeling',
            pageSubtitle: 'Documenten in uw organisatie met door AI voorgestelde bewerkingen die wachten op beoordeling, of versies afkomstig van Forseti.',
            colDocument: 'Documenteren',
            colLinkedRecord: 'Gekoppeld record',
            colPendingEdits: 'Openstaande bewerkingen',
            colLastActivity: 'Laatste activiteit',
            colOpen: 'Openen',
            open: 'Openen',
            empty: 'Nog geen documenten onder Forseti-beoordeling. Documenten komen in deze wachtrij wanneer Forseti een bewerking voorstelt tijdens een chat, wanneer een AI-workflow een redline produceert, of wanneer u een document via de bovenstaande knop ter beoordeling stuurt.',
            loading: 'Laden…',
            loadError: 'Kon documenten in beoordeling niet laden.',
            retryButton: 'Opnieuw proberen',
            noLinkedRecord: '—',
            pendingZero: 'Geen',
            sendForReviewButton: 'Een document ter beoordeling sturen',
            sendForReviewTitle: 'Een document ter beoordeling sturen',
            sendForReviewSubtitle: 'Kies een bestaande bijlage uit deze organisatie, of upload een nieuw bestand. Het document wordt aan de beoordelingsrij toegevoegd en Forseti voert er een redline-doorloop op uit.',
            sendForReviewTabPick: 'Bestaande kiezen',
            sendForReviewTabUpload: 'Nieuw uploaden',
            sendForReviewPickerLabel: 'Bijlagen zoeken',
            sendForReviewPickerPlaceholder: 'Typ om te zoeken…',
            sendForReviewPickerEmpty: 'Geen overeenkomende bijlagen. Probeer een andere zoekopdracht.',
            sendForReviewSubmit: 'Ter beoordeling sturen',
            sendForReviewCancel: 'Annuleren',
            sendForReviewSubmitting: 'Versturen…',
            sendForReviewError: 'Kon het document niet ter beoordeling sturen. Probeer het opnieuw.',
            sendForReviewSuccess: 'Document ter beoordeling verzonden.',
            sendForReviewAcceptedExt: 'Geaccepteerd: {ext}.',
            sendForReviewMaxSize: 'Max. grootte {mb} MB.',
        },
        chats: {
            exportError: 'Export mislukt.',
        },
    },
    pdplEvidencePacks: {
        title: 'PDPL-bewijspakketten',
        subtitle: 'Klantgestuurde indiening bij MoPS A05',
        nav: { emailProviders: 'E-mailproviders' },
        providers: {
            pageTitle: 'E-mailproviders',
            pageSubtitle: 'Configureer de uitgaande mailprovider van uw organisatie voor het indienen van PDPL-bewijspakketten bij MoPS A05.',
            architectureRuleHeading: 'Architectuurregel (vergrendeld)',
            architectureRuleBody: 'AesirX is geen afzender van bewijspakket-e-mails. Elke verzending gebruikt een provider die u zelf bezit en beheert. AesirX verzendt nooit namens u.',
            empty: 'Nog geen providers geconfigureerd.',
            createCta: 'Provider aanmaken',
            statusPendingConsent: 'Wacht op toestemming',
            statusPendingConnectionCheck: 'Wacht op verbindingstest',
            statusActive: 'Actief',
            statusConnectionCheckFailed: 'Verbindingstest mislukt',
            statusDisabled: 'Uitgeschakeld',
            acceptConsentCta: 'Toestemming aanvaarden',
            runConnectionCheckCta: 'Verbindingstest uitvoeren',
            disableCta: 'Uitschakelen',
            disableConfirm: 'Door deze provider uit te schakelen stoppen directe verzendingen totdat een nieuwe provider is geconfigureerd en de toestemming opnieuw is bevestigd. Doorgaan?',
            columnDisplayName: 'Naam',
            columnFromAddress: 'Afzenderadres',
            columnStatus: 'Status',
            columnLastCheck: 'Laatste test',
            columnActions: 'Acties',
            createModalTitle: 'Nieuwe SMTP-provider',
            createDisplayNameLabel: 'Weergavenaam',
            createFromAddressLabel: 'Afzenderadres',
            createReplyToLabel: 'Antwoordadres (optioneel)',
            createSmtpHostLabel: 'SMTP-server',
            createSmtpPortLabel: 'SMTP-poort',
            createSmtpUsernameLabel: 'SMTP-gebruikersnaam',
            createSmtpPasswordLabel: 'SMTP-wachtwoord',
            createSmtpEncryptionLabel: 'Versleuteling',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (impliciet)',
            createSmtpEncryptionNone: 'Geen',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Binnenkort beschikbaar',
            createOauthDisabledHint: 'OAuth-providers zijn nog niet ingeschakeld. Gebruik voorlopig SMTP.',
            createSubmitCta: 'Provider aanmaken',
            createCancelCta: 'Annuleren',
            createErrorInvalidFromAddress: 'Het afzenderadres moet een geldige mailbox zijn.',
            createErrorDuplicateFromAddress: 'Er is al een andere provider geconfigureerd voor dit afzenderadres.',
            createErrorGeneric: 'Provider kon niet worden aangemaakt. Controleer het formulier en probeer opnieuw.',
            consentModalTitle: 'Architectuurregel bevestigen',
            consentLocaleToggleEn: 'Engels',
            consentLocaleToggleVi: 'Vietnamees',
            consentAcknowledgeCta: 'Ik bevestig — toestemming aanvaarden',
            consentCancelCta: 'Annuleren',
            consentErrorMismatch: 'De toestemmingstekst is gewijzigd en komt niet meer overeen met de canonieke disclaimer. Open het venster opnieuw en verzend opnieuw.',
            testModalTitle: 'Verbindingstest',
            testRunningCta: 'Verbinding testen…',
            testRunCta: 'Verbindingstest uitvoeren',
            testRetryCta: 'Verbindingstest opnieuw proberen',
            testSuccessHeading: 'Verbinding gelukt',
            testSuccessBody: 'Geverifieerd tegen {host}:{port} in {latencyMs} ms. De provider is klaar voor directe verzendingen.',
            testFailureHeading: 'Verbinding mislukt',
            testFailureBody: 'De test kon niet worden voltooid. Bekijk de reden hieronder en probeer het opnieuw nadat dit is verholpen.',
            testFailureReasonLabel: 'Foutreden',
            testCloseCta: 'Sluiten',
            detailDrawerTitle: 'Providerdetails',
            detailDrawerHistoryHeading: 'Geschiedenis van verbindingstests',
            detailDrawerConsentHeading: 'Toestemmingsbevestiging',
            detailDrawerNoHistory: 'Nog geen verbindingstests vastgelegd.',
            detailDrawerNoConsent: 'Toestemming is nog niet bevestigd.',
            outcomeSuccess: 'Succesvol',
            outcomeFailure: 'Mislukt',
        },
        builder: {
            pageTitle: 'Bewijspakket samenstellen',
            pageSubtitle: 'Upload de 6 deelbestanden, kies het pakkettype en stel de deterministische 8-delige ZIP samen voor indiening.',
            packTypeLabel: 'Pakkettype',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Deel 01 — Begeleidingsbrief (PDF)',
            part02AuthorityForm: 'Deel 02 — Autoriteitsformulier (PDF)',
            part03Supporting: 'Deel 03 — Onderbouwend bewijs (≥1)',
            part04Safeguards: 'Deel 04 — Waarborgen',
            part04SafeguardsRequiredOtia: '(verplicht voor OTIA)',
            part05PriorCorrespondence: 'Deel 05 — Eerdere correspondentie (optioneel)',
            part06Signature: 'Deel 06 — Handtekening- en stempelbewijs (≥1)',
            uploadPickFile: 'Bestand kiezen',
            uploadPickFiles: 'Bestanden kiezen',
            uploadRemoveFile: 'Verwijderen',
            requiredMissing: 'Verplicht onderdeel ontbreekt',
            assembleCta: 'Pakket samenstellen',
            assembling: 'Samenstellen…',
            assembleSuccessHeading: 'Pakket samengesteld',
            assembleSuccessSummary: '{fileCount} bestanden · {bytes} bytes · SHA-256 {shaPrefix}…',
            composeNextCta: 'E-mailconcept opstellen',
            warningsHeading: 'Validatiewaarschuwingen',
            assembleError: 'Pakket kon niet worden samengesteld. Controleer invoer en probeer opnieuw.',
            forsetiAssistHeading: 'Forseti AI-ondersteuning (optioneel)',
            forsetiAssistHint: 'Voer de PDPL Evidence Pack Assembly Advisor uit om ontbrekende onderdelen te belichten, begeleidende brieven op te stellen en beveiligingshiaten te markeren. AesirX is niet de afzender — de AI adviseert alleen; u keurt elk artefact goed.',
            forsetiAssistCta: 'Forseti workflow-bibliotheek openen',
            forsetiAiRunIdLabel: 'Gekoppelde Forseti AI-uitvoering-id (plakken om AI-ondersteuning vast te leggen)',
        },
        draft: {
            pageTitle: 'E-mailconcept',
            pageSubtitle: 'Stel het e-mailconcept op en bewerk het. Direct verzenden komt in een latere release.',
            composeCta: 'Concept opstellen',
            composing: 'Opstellen…',
            noDraftYet: 'Nog geen concept. Stel er een op om te beginnen.',
            localeToggleLabel: 'Taal',
            localeEn: 'Engels',
            localeVi: 'Vietnamees',
            subjectLabel: 'Onderwerp',
            bodyLabel: 'Bericht',
            saveCta: 'Wijzigingen opslaan',
            saving: 'Opslaan…',
            saveError: 'Het concept kon niet worden opgeslagen. Probeer opnieuw.',
            manifestSummaryLabel: 'Manifest-overzicht',
            coverLetterLabel: 'Begeleidingsbrief (PDF)',
            coverLetterDownloadCta: 'PDF downloaden',
            editHistoryHeading: 'Bewerkingsgeschiedenis',
            editHistoryEmpty: 'Nog geen bewerkingen.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 onofficieel-kanaal melding',
            uploadSentProofCta: 'Handmatig verzendbewijs uploaden',
            versionLabel: 'Versie',
            statusDraft: 'Concept',
            statusEdited: 'Bewerkt',
            statusFinalized: 'Afgerond',
        },
        sentProof: {
            modalTitle: 'Handmatig verzendbewijs uploaden',
            architectureLockNote: 'AesirX is niet de afzender. Dit bewijs legt de handmatige verzending vast die u via uw eigen mailprogramma hebt uitgevoerd.',
            fileLabel: 'Bewijsbestand (.eml, .png, .jpg)',
            envelopeFromLabel: 'Van',
            envelopeToLabel: 'Aan',
            envelopeSubjectLabel: 'Onderwerp (bij verzending)',
            envelopeSentAtLabel: 'Verzonden op',
            envelopeAttachmentShaLabel: 'Bijlage SHA-256 (bij verzending)',
            uploadCta: 'Bewijs uploaden',
            uploading: 'Uploaden…',
            uploadSuccess: 'Verzendbewijs geüpload.',
            uploadErrorInvalidMime: 'Bestandstype niet toegestaan. Gebruik .eml, .png, .jpg of .jpeg.',
            uploadErrorGeneric: 'Het bewijs kon niet worden geüpload. Probeer opnieuw.',
            existingProofsHeading: 'Geregistreerde verzendbewijzen',
            existingProofsEmpty: 'Nog geen verzendbewijzen geregistreerd.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Bewijspakket',
            notFoundMessage: 'Pakket niet gevonden — het is mogelijk verwijderd of de link is onjuist.',
            manifestHeading: 'Manifest',
            dossierLabel: 'Dossier',
            packShaLabel: 'Pakket-SHA-256',
            fileCountLabel: 'Bestanden',
            bytesLabel: 'Grootte',
            composeDraftCta: 'Concept opstellen',
            sendComingSoonCta: 'Direct verzenden: binnenkort beschikbaar',
            sendComingSoonHint: 'De direct-verzendfunctie is in actieve ontwikkeling. Gebruik tot die tijd "Handmatig verzendbewijs uploaden" op de conceptpagina.',
            sendCta: 'Verzenden via geconfigureerde provider',
            sendDisabledNoProviderHint: 'Configureer eerst een door de klant beheerde e-mailprovider. AesirX verzendt nooit namens u.',
            timelineHeading: 'Verzendgeschiedenis',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Bewijspakket verzenden',
            providerPickerLabel: 'Geconfigureerde e-mailprovider',
            providerPickerHint: 'AesirX verzendt nooit namens u. Kies hieronder een van uw geconfigureerde providers.',
            providerPickerEmpty: 'Er zijn geen actieve providers geconfigureerd. Configureer er een op de pagina E-mailproviders voordat u verzendt.',
            providerPickerEmptyCta: 'E-mailproviders openen',
            draftPickerLabel: 'E-mailconcept',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: 'Er zijn nog geen concepten opgesteld voor dit pakket. Stel er eerst een op op de conceptpagina.',
            recipientToLabel: 'Aan',
            recipientToHint: "Een of meer e-mailadressen, gescheiden door komma's.",
            recipientCcLabel: "Cc (gescheiden door komma's)",
            recipientCcHint: "Optioneel. Door komma's gescheiden lijst met e-mailadressen.",
            recipientBccLabel: "Bcc (gescheiden door komma's)",
            recipientBccHint: "Optioneel. Door komma's gescheiden lijst met e-mailadressen.",
            consentReaffirmHeading: 'Toestemming van provider opnieuw bevestigen',
            submitCta: 'Nu verzenden',
            sending: 'Bezig met verzenden…',
            cancelCta: 'Annuleren',
            sendSuccess: 'Verzending geregistreerd. Het pakket is verzonden via uw geconfigureerde provider.',
            sendErrorGeneric: 'Het pakket kon niet worden verzonden. Bekijk de fout hieronder en probeer het opnieuw.',
            sendErrorAlreadyFinalized: 'Dit concept is al gebruikt voor een geslaagde verzending. Stel een nieuw concept op voordat u opnieuw verzendt.',
            sendErrorInvalidRecipients: 'Een of meer ontvangeradressen zijn geen geldige e-mailpostbussen.',
            // Timeline
            timelineEmpty: 'Nog geen verzendingen geregistreerd. Gebruik hierboven "Verzenden via geconfigureerde provider" om te versturen via uw door de klant beheerde SMTP-, Microsoft 365- of Google Workspace-provider.',
            timelineProviderLabel: 'Verzonden via uw geconfigureerde provider',
            timelineSentAtLabel: 'Verzonden',
            timelineRecipientLabel: 'Ontvanger',
            timelineOutcomeSent: 'Verzonden',
            timelineOutcomeFailed: 'Mislukt',
            timelineViewDetailsCta: 'Details bekijken',
            // Authority-response chips
            authorityChipNone: 'In afwachting van antwoord',
            authorityChipAcknowledgement: 'Ontvangstbevestiging',
            authorityChipAcceptance: 'Aanvaarding',
            authorityChipRejection: 'Afwijzing',
            authorityChipSupplementRequest: 'Verzoek om aanvulling',
            authorityChipNoResponse: 'Geen antwoord',
            // Hard-copy chips
            hardCopyChipNone: 'Geen papieren opvolging',
            hardCopyChipPending: 'Verstuurd — bezorging in behandeling',
            hardCopyChipDelivered: 'Bezorgd',
            // Drawer
            drawerTitle: 'Verzendrecord',
            drawerEnvelopeHeading: 'Envelop',
            drawerEnvelopeFromLabel: 'Van',
            drawerEnvelopeToLabel: 'Aan',
            drawerEnvelopeCcLabel: 'Cc',
            drawerEnvelopeBccLabel: 'Bcc',
            drawerEnvelopeSubjectLabel: 'Onderwerp',
            drawerEnvelopeMessageIdLabel: 'Bericht-ID',
            drawerOutcomeHeading: 'Resultaat',
            drawerSnapshotHeading: 'Momentopname van bewaringsketen',
            drawerSnapshotPackShaLabel: 'Pakket-SHA-256 bij verzending',
            drawerSnapshotDraftVersionLabel: 'Conceptversie bij verzending',
            drawerSnapshotAttachmentLabel: 'Verzonden ZIP',
            drawerSnapshotAttachmentDownloadCta: 'ZIP downloaden',
            drawerAuthorityResponseHeading: 'Antwoord van autoriteit',
            drawerHardCopyHeading: 'Papieren opvolging',
            drawerSentByLabel: 'Verzonden door',
            drawerSendIdLabel: 'Verzendrecord-ID',
            drawerSmtpResponseLabel: 'SMTP-antwoord',
            drawerFailureReasonLabel: 'Reden van mislukking',
            drawerLatencyLabel: 'Vertraging',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Geaccepteerd',
            drawerRejectedLabel: 'Geweigerd',
            drawerCloseCta: 'Sluiten',
            // Authority-response panel
            authorityRecordCta: 'Antwoord registreren',
            authorityReclassifyCta: 'Herclassificeren',
            authorityClassificationLabel: 'Classificatie',
            authorityReceivedAtLabel: 'Ontvangen op',
            authorityFreeTextLabel: 'Notities (optioneel)',
            authorityEvidenceLabel: 'Bewijsbestand (.eml / .pdf / .png / .jpg — optioneel)',
            authorityReasonLabel: 'Reden voor herclassificatie',
            authorityHistoryHeading: 'Geschiedenis van herclassificaties',
            authorityHistoryEmpty: 'Er zijn geen herclassificaties geregistreerd.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Antwoord opslaan',
            authoritySubmitting: 'Bezig met opslaan…',
            authorityErrorInvalidMime: 'Bestandstype van bewijs niet toegestaan. Gebruik .eml, .pdf, .png of .jpg.',
            authorityErrorGeneric: 'Het antwoord kon niet worden opgeslagen. Probeer het opnieuw.',
            authorityRecordedAtLabel: 'Geregistreerd op',
            authorityRecordedByLabel: 'Geregistreerd door',
            authorityEvidenceFilenameLabel: 'Bewijs',
            authorityEvidenceDownloadCta: 'Bewijs downloaden',
            // Hard-copy panel
            hardCopyRecordCta: 'Papieren opvolging registreren',
            hardCopyConfirmCta: 'Bezorging bevestigen',
            hardCopyEditNotesCta: 'Bezorgingsnotities bewerken',
            hardCopyPostedAtLabel: 'Verstuurd op',
            hardCopyCourierLabel: 'Koerier',
            hardCopyTrackingLabel: 'Trackingnummer',
            hardCopyRecipientLabel: 'Ontvanger op het etiket',
            hardCopyReceiptLabel: 'Ontvangstbewijs (.pdf / .png / .jpg — optioneel)',
            hardCopyReceiptDownloadCta: 'Ontvangstbewijs downloaden',
            hardCopyDeliveredAtLabel: 'Bezorgd op',
            hardCopyDeliveryNotesLabel: 'Bezorgingsnotities (optioneel)',
            hardCopySubmitCta: 'Opvolging opslaan',
            hardCopySubmitting: 'Bezig met opslaan…',
            hardCopyErrorInvalidMime: 'Bestandstype van ontvangstbewijs niet toegestaan. Gebruik .pdf, .png of .jpg.',
            hardCopyErrorGeneric: 'De opvolging kon niet worden opgeslagen. Probeer het opnieuw.',
        },
    },
};
//# sourceMappingURL=nl.js.map